/*! For license information please see main.js.LICENSE.txt */
(function () {
  var __webpack_modules__ = {
      886: function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        'use strict';
        function _asyncIterator(t) {
          var e,
            r,
            n,
            i = 2;
          for ('undefined' != typeof Symbol && ((r = Symbol.asyncIterator), (n = Symbol.iterator)); i--; ) {
            if (r && null != (e = t[r])) return e.call(t);
            if (n && null != (e = t[n])) return new AsyncFromSyncIterator(e.call(t));
            (r = '@@asyncIterator'), (n = '@@iterator');
          }
          throw new TypeError('Object is not async iterable');
        }
        function AsyncFromSyncIterator(t) {
          function e(t) {
            if (Object(t) !== t) return Promise.reject(new TypeError(t + ' is not an object.'));
            var e = t.done;
            return Promise.resolve(t.value).then(function (t) {
              return { value: t, done: e };
            });
          }
          return (
            (AsyncFromSyncIterator = function (t) {
              (this.s = t), (this.n = t.next);
            }),
            (AsyncFromSyncIterator.prototype = {
              s: null,
              n: null,
              next: function () {
                return e(this.n.apply(this.s, arguments));
              },
              return: function (t) {
                var r = this.s.return;
                return void 0 === r ? Promise.resolve({ value: t, done: !0 }) : e(r.apply(this.s, arguments));
              },
              throw: function (t) {
                var r = this.s.return;
                return void 0 === r ? Promise.reject(t) : e(r.apply(this.s, arguments));
              },
            }),
            new AsyncFromSyncIterator(t)
          );
        }
        var REACT_ELEMENT_TYPE;
        function _jsx(t, e, r, n) {
          REACT_ELEMENT_TYPE ||
            (REACT_ELEMENT_TYPE = ('function' == typeof Symbol && Symbol.for && Symbol.for('react.element')) || 60103);
          var i = t && t.defaultProps,
            o = arguments.length - 3;
          if ((e || 0 === o || (e = { children: void 0 }), 1 === o)) e.children = n;
          else if (o > 1) {
            for (var a = new Array(o), s = 0; s < o; s++) a[s] = arguments[s + 3];
            e.children = a;
          }
          if (e && i) for (var l in i) void 0 === e[l] && (e[l] = i[l]);
          else e || (e = i || {});
          return {
            $$typeof: REACT_ELEMENT_TYPE,
            type: t,
            key: void 0 === r ? null : '' + r,
            ref: null,
            props: e,
            _owner: null,
          };
        }
        function ownKeys(t, e) {
          var r = Object.keys(t);
          if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(t);
            e &&
              (n = n.filter(function (e) {
                return Object.getOwnPropertyDescriptor(t, e).enumerable;
              })),
              r.push.apply(r, n);
          }
          return r;
        }
        function _objectSpread2(t) {
          for (var e = 1; e < arguments.length; e++) {
            var r = null != arguments[e] ? arguments[e] : {};
            e % 2
              ? ownKeys(Object(r), !0).forEach(function (e) {
                  _defineProperty(t, e, r[e]);
                })
              : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r))
              : ownKeys(Object(r)).forEach(function (e) {
                  Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
                });
          }
          return t;
        }
        function _typeof(t) {
          return (
            (_typeof =
              'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
                ? function (t) {
                    return typeof t;
                  }
                : function (t) {
                    return t && 'function' == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype
                      ? 'symbol'
                      : typeof t;
                  }),
            _typeof(t)
          );
        }
        function _wrapRegExp() {
          _wrapRegExp = function (t, e) {
            return new r(t, void 0, e);
          };
          var t = RegExp.prototype,
            e = new WeakMap();
          function r(t, n, i) {
            var o = new RegExp(t, n);
            return e.set(o, i || e.get(t)), _setPrototypeOf(o, r.prototype);
          }
          function n(t, r) {
            var n = e.get(r);
            return Object.keys(n).reduce(function (e, r) {
              return (e[r] = t[n[r]]), e;
            }, Object.create(null));
          }
          return (
            _inherits(r, RegExp),
            (r.prototype.exec = function (e) {
              var r = t.exec.call(this, e);
              return r && (r.groups = n(r, this)), r;
            }),
            (r.prototype[Symbol.replace] = function (r, i) {
              if ('string' == typeof i) {
                var o = e.get(this);
                return t[Symbol.replace].call(
                  this,
                  r,
                  i.replace(/\$<([^>]+)>/g, function (t, e) {
                    return '$' + o[e];
                  }),
                );
              }
              if ('function' == typeof i) {
                var a = this;
                return t[Symbol.replace].call(this, r, function () {
                  var t = arguments;
                  return 'object' != typeof t[t.length - 1] && (t = [].slice.call(t)).push(n(t, a)), i.apply(this, t);
                });
              }
              return t[Symbol.replace].call(this, r, i);
            }),
            _wrapRegExp.apply(this, arguments)
          );
        }
        function _AwaitValue(t) {
          this.wrapped = t;
        }
        function _AsyncGenerator(t) {
          var e, r;
          function n(e, r) {
            try {
              var o = t[e](r),
                a = o.value,
                s = a instanceof _AwaitValue;
              Promise.resolve(s ? a.wrapped : a).then(
                function (t) {
                  s ? n('return' === e ? 'return' : 'next', t) : i(o.done ? 'return' : 'normal', t);
                },
                function (t) {
                  n('throw', t);
                },
              );
            } catch (t) {
              i('throw', t);
            }
          }
          function i(t, i) {
            switch (t) {
              case 'return':
                e.resolve({ value: i, done: !0 });
                break;
              case 'throw':
                e.reject(i);
                break;
              default:
                e.resolve({ value: i, done: !1 });
            }
            (e = e.next) ? n(e.key, e.arg) : (r = null);
          }
          (this._invoke = function (t, i) {
            return new Promise(function (o, a) {
              var s = { key: t, arg: i, resolve: o, reject: a, next: null };
              r ? (r = r.next = s) : ((e = r = s), n(t, i));
            });
          }),
            'function' != typeof t.return && (this.return = void 0);
        }
        function _wrapAsyncGenerator(t) {
          return function () {
            return new _AsyncGenerator(t.apply(this, arguments));
          };
        }
        function _awaitAsyncGenerator(t) {
          return new _AwaitValue(t);
        }
        function _asyncGeneratorDelegate(t, e) {
          var r = {},
            n = !1;
          function i(r, i) {
            return (
              (n = !0),
              (i = new Promise(function (e) {
                e(t[r](i));
              })),
              { done: !1, value: e(i) }
            );
          }
          return (
            (r[('undefined' != typeof Symbol && Symbol.iterator) || '@@iterator'] = function () {
              return this;
            }),
            (r.next = function (t) {
              return n ? ((n = !1), t) : i('next', t);
            }),
            'function' == typeof t.throw &&
              (r.throw = function (t) {
                if (n) throw ((n = !1), t);
                return i('throw', t);
              }),
            'function' == typeof t.return &&
              (r.return = function (t) {
                return n ? ((n = !1), t) : i('return', t);
              }),
            r
          );
        }
        function asyncGeneratorStep(t, e, r, n, i, o, a) {
          try {
            var s = t[o](a),
              l = s.value;
          } catch (t) {
            return void r(t);
          }
          s.done ? e(l) : Promise.resolve(l).then(n, i);
        }
        function _asyncToGenerator(t) {
          return function () {
            var e = this,
              r = arguments;
            return new Promise(function (n, i) {
              var o = t.apply(e, r);
              function a(t) {
                asyncGeneratorStep(o, n, i, a, s, 'next', t);
              }
              function s(t) {
                asyncGeneratorStep(o, n, i, a, s, 'throw', t);
              }
              a(void 0);
            });
          };
        }
        function _classCallCheck(t, e) {
          if (!(t instanceof e)) throw new TypeError('Cannot call a class as a function');
        }
        function _defineProperties(t, e) {
          for (var r = 0; r < e.length; r++) {
            var n = e[r];
            (n.enumerable = n.enumerable || !1),
              (n.configurable = !0),
              'value' in n && (n.writable = !0),
              Object.defineProperty(t, n.key, n);
          }
        }
        function _createClass(t, e, r) {
          return (
            e && _defineProperties(t.prototype, e),
            r && _defineProperties(t, r),
            Object.defineProperty(t, 'prototype', { writable: !1 }),
            t
          );
        }
        function _defineEnumerableProperties(t, e) {
          for (var r in e)
            ((o = e[r]).configurable = o.enumerable = !0),
              'value' in o && (o.writable = !0),
              Object.defineProperty(t, r, o);
          if (Object.getOwnPropertySymbols)
            for (var n = Object.getOwnPropertySymbols(e), i = 0; i < n.length; i++) {
              var o,
                a = n[i];
              ((o = e[a]).configurable = o.enumerable = !0),
                'value' in o && (o.writable = !0),
                Object.defineProperty(t, a, o);
            }
          return t;
        }
        function _defaults(t, e) {
          for (var r = Object.getOwnPropertyNames(e), n = 0; n < r.length; n++) {
            var i = r[n],
              o = Object.getOwnPropertyDescriptor(e, i);
            o && o.configurable && void 0 === t[i] && Object.defineProperty(t, i, o);
          }
          return t;
        }
        function _defineProperty(t, e, r) {
          return (
            e in t
              ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 })
              : (t[e] = r),
            t
          );
        }
        function _extends() {
          return (
            (_extends =
              Object.assign ||
              function (t) {
                for (var e = 1; e < arguments.length; e++) {
                  var r = arguments[e];
                  for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
                }
                return t;
              }),
            _extends.apply(this, arguments)
          );
        }
        function _objectSpread(t) {
          for (var e = 1; e < arguments.length; e++) {
            var r = null != arguments[e] ? Object(arguments[e]) : {},
              n = Object.keys(r);
            'function' == typeof Object.getOwnPropertySymbols &&
              n.push.apply(
                n,
                Object.getOwnPropertySymbols(r).filter(function (t) {
                  return Object.getOwnPropertyDescriptor(r, t).enumerable;
                }),
              ),
              n.forEach(function (e) {
                _defineProperty(t, e, r[e]);
              });
          }
          return t;
        }
        function _inherits(t, e) {
          if ('function' != typeof e && null !== e)
            throw new TypeError('Super expression must either be null or a function');
          (t.prototype = Object.create(e && e.prototype, {
            constructor: { value: t, writable: !0, configurable: !0 },
          })),
            Object.defineProperty(t, 'prototype', { writable: !1 }),
            e && _setPrototypeOf(t, e);
        }
        function _inheritsLoose(t, e) {
          (t.prototype = Object.create(e.prototype)), (t.prototype.constructor = t), _setPrototypeOf(t, e);
        }
        function _getPrototypeOf(t) {
          return (
            (_getPrototypeOf = Object.setPrototypeOf
              ? Object.getPrototypeOf
              : function (t) {
                  return t.__proto__ || Object.getPrototypeOf(t);
                }),
            _getPrototypeOf(t)
          );
        }
        function _setPrototypeOf(t, e) {
          return (
            (_setPrototypeOf =
              Object.setPrototypeOf ||
              function (t, e) {
                return (t.__proto__ = e), t;
              }),
            _setPrototypeOf(t, e)
          );
        }
        function _isNativeReflectConstruct() {
          if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ('function' == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }
        function _construct(t, e, r) {
          return (
            (_construct = _isNativeReflectConstruct()
              ? Reflect.construct
              : function (t, e, r) {
                  var n = [null];
                  n.push.apply(n, e);
                  var i = new (Function.bind.apply(t, n))();
                  return r && _setPrototypeOf(i, r.prototype), i;
                }),
            _construct.apply(null, arguments)
          );
        }
        function _isNativeFunction(t) {
          return -1 !== Function.toString.call(t).indexOf('[native code]');
        }
        function _wrapNativeSuper(t) {
          var e = 'function' == typeof Map ? new Map() : void 0;
          return (
            (_wrapNativeSuper = function (t) {
              if (null === t || !_isNativeFunction(t)) return t;
              if ('function' != typeof t) throw new TypeError('Super expression must either be null or a function');
              if (void 0 !== e) {
                if (e.has(t)) return e.get(t);
                e.set(t, r);
              }
              function r() {
                return _construct(t, arguments, _getPrototypeOf(this).constructor);
              }
              return (
                (r.prototype = Object.create(t.prototype, {
                  constructor: { value: r, enumerable: !1, writable: !0, configurable: !0 },
                })),
                _setPrototypeOf(r, t)
              );
            }),
            _wrapNativeSuper(t)
          );
        }
        function _instanceof(t, e) {
          return null != e && 'undefined' != typeof Symbol && e[Symbol.hasInstance]
            ? !!e[Symbol.hasInstance](t)
            : t instanceof e;
        }
        function _interopRequireDefault(t) {
          return t && t.__esModule ? t : { default: t };
        }
        function _getRequireWildcardCache(t) {
          if ('function' != typeof WeakMap) return null;
          var e = new WeakMap(),
            r = new WeakMap();
          return (_getRequireWildcardCache = function (t) {
            return t ? r : e;
          })(t);
        }
        function _interopRequireWildcard(t, e) {
          if (!e && t && t.__esModule) return t;
          if (null === t || ('object' != typeof t && 'function' != typeof t)) return { default: t };
          var r = _getRequireWildcardCache(e);
          if (r && r.has(t)) return r.get(t);
          var n = {},
            i = Object.defineProperty && Object.getOwnPropertyDescriptor;
          for (var o in t)
            if ('default' !== o && Object.prototype.hasOwnProperty.call(t, o)) {
              var a = i ? Object.getOwnPropertyDescriptor(t, o) : null;
              a && (a.get || a.set) ? Object.defineProperty(n, o, a) : (n[o] = t[o]);
            }
          return (n.default = t), r && r.set(t, n), n;
        }
        function _newArrowCheck(t, e) {
          if (t !== e) throw new TypeError('Cannot instantiate an arrow function');
        }
        function _objectDestructuringEmpty(t) {
          if (null == t) throw new TypeError('Cannot destructure undefined');
        }
        function _objectWithoutPropertiesLoose(t, e) {
          if (null == t) return {};
          var r,
            n,
            i = {},
            o = Object.keys(t);
          for (n = 0; n < o.length; n++) (r = o[n]), e.indexOf(r) >= 0 || (i[r] = t[r]);
          return i;
        }
        function _objectWithoutProperties(t, e) {
          if (null == t) return {};
          var r,
            n,
            i = _objectWithoutPropertiesLoose(t, e);
          if (Object.getOwnPropertySymbols) {
            var o = Object.getOwnPropertySymbols(t);
            for (n = 0; n < o.length; n++)
              (r = o[n]), e.indexOf(r) >= 0 || (Object.prototype.propertyIsEnumerable.call(t, r) && (i[r] = t[r]));
          }
          return i;
        }
        function _assertThisInitialized(t) {
          if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return t;
        }
        function _possibleConstructorReturn(t, e) {
          if (e && ('object' == typeof e || 'function' == typeof e)) return e;
          if (void 0 !== e) throw new TypeError('Derived constructors may only return object or undefined');
          return _assertThisInitialized(t);
        }
        function _createSuper(t) {
          var e = _isNativeReflectConstruct();
          return function () {
            var r,
              n = _getPrototypeOf(t);
            if (e) {
              var i = _getPrototypeOf(this).constructor;
              r = Reflect.construct(n, arguments, i);
            } else r = n.apply(this, arguments);
            return _possibleConstructorReturn(this, r);
          };
        }
        function _superPropBase(t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = _getPrototypeOf(t)); );
          return t;
        }
        function _get() {
          return (
            (_get =
              'undefined' != typeof Reflect && Reflect.get
                ? Reflect.get
                : function (t, e, r) {
                    var n = _superPropBase(t, e);
                    if (n) {
                      var i = Object.getOwnPropertyDescriptor(n, e);
                      return i.get ? i.get.call(arguments.length < 3 ? t : r) : i.value;
                    }
                  }),
            _get.apply(this, arguments)
          );
        }
        function set(t, e, r, n) {
          return (
            (set =
              'undefined' != typeof Reflect && Reflect.set
                ? Reflect.set
                : function (t, e, r, n) {
                    var i,
                      o = _superPropBase(t, e);
                    if (o) {
                      if ((i = Object.getOwnPropertyDescriptor(o, e)).set) return i.set.call(n, r), !0;
                      if (!i.writable) return !1;
                    }
                    if ((i = Object.getOwnPropertyDescriptor(n, e))) {
                      if (!i.writable) return !1;
                      (i.value = r), Object.defineProperty(n, e, i);
                    } else _defineProperty(n, e, r);
                    return !0;
                  }),
            set(t, e, r, n)
          );
        }
        function _set(t, e, r, n, i) {
          if (!set(t, e, r, n || t) && i) throw new Error('failed to set property');
          return r;
        }
        function _taggedTemplateLiteral(t, e) {
          return e || (e = t.slice(0)), Object.freeze(Object.defineProperties(t, { raw: { value: Object.freeze(e) } }));
        }
        function _taggedTemplateLiteralLoose(t, e) {
          return e || (e = t.slice(0)), (t.raw = e), t;
        }
        function _readOnlyError(t) {
          throw new TypeError('"' + t + '" is read-only');
        }
        function _writeOnlyError(t) {
          throw new TypeError('"' + t + '" is write-only');
        }
        function _classNameTDZError(t) {
          throw new Error('Class "' + t + '" cannot be referenced in computed property keys.');
        }
        function _temporalUndefined() {}
        function _tdz(t) {
          throw new ReferenceError(t + ' is not defined - temporal dead zone');
        }
        function _temporalRef(t, e) {
          return t === _temporalUndefined ? _tdz(e) : t;
        }
        function _slicedToArray(t, e) {
          return (
            _arrayWithHoles(t) || _iterableToArrayLimit(t, e) || _unsupportedIterableToArray(t, e) || _nonIterableRest()
          );
        }
        function _slicedToArrayLoose(t, e) {
          return (
            _arrayWithHoles(t) ||
            _iterableToArrayLimitLoose(t, e) ||
            _unsupportedIterableToArray(t, e) ||
            _nonIterableRest()
          );
        }
        function _toArray(t) {
          return _arrayWithHoles(t) || _iterableToArray(t) || _unsupportedIterableToArray(t) || _nonIterableRest();
        }
        function _toConsumableArray(t) {
          return _arrayWithoutHoles(t) || _iterableToArray(t) || _unsupportedIterableToArray(t) || _nonIterableSpread();
        }
        function _arrayWithoutHoles(t) {
          if (Array.isArray(t)) return _arrayLikeToArray(t);
        }
        function _arrayWithHoles(t) {
          if (Array.isArray(t)) return t;
        }
        function _maybeArrayLike(t, e, r) {
          if (e && !Array.isArray(e) && 'number' == typeof e.length) {
            var n = e.length;
            return _arrayLikeToArray(e, void 0 !== r && r < n ? r : n);
          }
          return t(e, r);
        }
        function _iterableToArray(t) {
          if (('undefined' != typeof Symbol && null != t[Symbol.iterator]) || null != t['@@iterator'])
            return Array.from(t);
        }
        function _iterableToArrayLimit(t, e) {
          var r = null == t ? null : ('undefined' != typeof Symbol && t[Symbol.iterator]) || t['@@iterator'];
          if (null != r) {
            var n,
              i,
              o = [],
              a = !0,
              s = !1;
            try {
              for (r = r.call(t); !(a = (n = r.next()).done) && (o.push(n.value), !e || o.length !== e); a = !0);
            } catch (t) {
              (s = !0), (i = t);
            } finally {
              try {
                a || null == r.return || r.return();
              } finally {
                if (s) throw i;
              }
            }
            return o;
          }
        }
        function _iterableToArrayLimitLoose(t, e) {
          var r = t && (('undefined' != typeof Symbol && t[Symbol.iterator]) || t['@@iterator']);
          if (null != r) {
            var n = [];
            for (r = r.call(t), _step; !(_step = r.next()).done && (n.push(_step.value), !e || n.length !== e); );
            return n;
          }
        }
        function _unsupportedIterableToArray(t, e) {
          if (t) {
            if ('string' == typeof t) return _arrayLikeToArray(t, e);
            var r = Object.prototype.toString.call(t).slice(8, -1);
            return (
              'Object' === r && t.constructor && (r = t.constructor.name),
              'Map' === r || 'Set' === r
                ? Array.from(t)
                : 'Arguments' === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)
                ? _arrayLikeToArray(t, e)
                : void 0
            );
          }
        }
        function _arrayLikeToArray(t, e) {
          (null == e || e > t.length) && (e = t.length);
          for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
          return n;
        }
        function _nonIterableSpread() {
          throw new TypeError(
            'Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
          );
        }
        function _nonIterableRest() {
          throw new TypeError(
            'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
          );
        }
        function _createForOfIteratorHelper(t, e) {
          var r = ('undefined' != typeof Symbol && t[Symbol.iterator]) || t['@@iterator'];
          if (!r) {
            if (Array.isArray(t) || (r = _unsupportedIterableToArray(t)) || (e && t && 'number' == typeof t.length)) {
              r && (t = r);
              var n = 0,
                i = function () {};
              return {
                s: i,
                n: function () {
                  return n >= t.length ? { done: !0 } : { done: !1, value: t[n++] };
                },
                e: function (t) {
                  throw t;
                },
                f: i,
              };
            }
            throw new TypeError(
              'Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
            );
          }
          var o,
            a = !0,
            s = !1;
          return {
            s: function () {
              r = r.call(t);
            },
            n: function () {
              var t = r.next();
              return (a = t.done), t;
            },
            e: function (t) {
              (s = !0), (o = t);
            },
            f: function () {
              try {
                a || null == r.return || r.return();
              } finally {
                if (s) throw o;
              }
            },
          };
        }
        function _createForOfIteratorHelperLoose(t, e) {
          var r = ('undefined' != typeof Symbol && t[Symbol.iterator]) || t['@@iterator'];
          if (r) return (r = r.call(t)).next.bind(r);
          if (Array.isArray(t) || (r = _unsupportedIterableToArray(t)) || (e && t && 'number' == typeof t.length)) {
            r && (t = r);
            var n = 0;
            return function () {
              return n >= t.length ? { done: !0 } : { done: !1, value: t[n++] };
            };
          }
          throw new TypeError(
            'Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
          );
        }
        function _skipFirstGeneratorNext(t) {
          return function () {
            var e = t.apply(this, arguments);
            return e.next(), e;
          };
        }
        function _toPrimitive(t, e) {
          if ('object' != typeof t || null === t) return t;
          var r = t[Symbol.toPrimitive];
          if (void 0 !== r) {
            var n = r.call(t, e || 'default');
            if ('object' != typeof n) return n;
            throw new TypeError('@@toPrimitive must return a primitive value.');
          }
          return ('string' === e ? String : Number)(t);
        }
        function _toPropertyKey(t) {
          var e = _toPrimitive(t, 'string');
          return 'symbol' == typeof e ? e : String(e);
        }
        function _initializerWarningHelper(t, e) {
          throw new Error(
            'Decorating class property failed. Please ensure that proposal-class-properties is enabled and runs after the decorators transform.',
          );
        }
        function _initializerDefineProperty(t, e, r, n) {
          r &&
            Object.defineProperty(t, e, {
              enumerable: r.enumerable,
              configurable: r.configurable,
              writable: r.writable,
              value: r.initializer ? r.initializer.call(n) : void 0,
            });
        }
        function _applyDecoratedDescriptor(t, e, r, n, i) {
          var o = {};
          return (
            Object.keys(n).forEach(function (t) {
              o[t] = n[t];
            }),
            (o.enumerable = !!o.enumerable),
            (o.configurable = !!o.configurable),
            ('value' in o || o.initializer) && (o.writable = !0),
            (o = r
              .slice()
              .reverse()
              .reduce(function (r, n) {
                return n(t, e, r) || r;
              }, o)),
            i &&
              void 0 !== o.initializer &&
              ((o.value = o.initializer ? o.initializer.call(i) : void 0), (o.initializer = void 0)),
            void 0 === o.initializer && (Object.defineProperty(t, e, o), (o = null)),
            o
          );
        }
        (_AsyncGenerator.prototype[('function' == typeof Symbol && Symbol.asyncIterator) || '@@asyncIterator'] =
          function () {
            return this;
          }),
          (_AsyncGenerator.prototype.next = function (t) {
            return this._invoke('next', t);
          }),
          (_AsyncGenerator.prototype.throw = function (t) {
            return this._invoke('throw', t);
          }),
          (_AsyncGenerator.prototype.return = function (t) {
            return this._invoke('return', t);
          });
        var id = 0;
        function _classPrivateFieldLooseKey(t) {
          return '__private_' + id++ + '_' + t;
        }
        function _classPrivateFieldLooseBase(t, e) {
          if (!Object.prototype.hasOwnProperty.call(t, e))
            throw new TypeError('attempted to use private field on non-instance');
          return t;
        }
        function _classPrivateFieldGet(t, e) {
          return _classApplyDescriptorGet(t, _classExtractFieldDescriptor(t, e, 'get'));
        }
        function _classPrivateFieldSet(t, e, r) {
          return _classApplyDescriptorSet(t, _classExtractFieldDescriptor(t, e, 'set'), r), r;
        }
        function _classPrivateFieldDestructureSet(t, e) {
          return _classApplyDescriptorDestructureSet(t, _classExtractFieldDescriptor(t, e, 'set'));
        }
        function _classExtractFieldDescriptor(t, e, r) {
          if (!e.has(t)) throw new TypeError('attempted to ' + r + ' private field on non-instance');
          return e.get(t);
        }
        function _classStaticPrivateFieldSpecGet(t, e, r) {
          return (
            _classCheckPrivateStaticAccess(t, e),
            _classCheckPrivateStaticFieldDescriptor(r, 'get'),
            _classApplyDescriptorGet(t, r)
          );
        }
        function _classStaticPrivateFieldSpecSet(t, e, r, n) {
          return (
            _classCheckPrivateStaticAccess(t, e),
            _classCheckPrivateStaticFieldDescriptor(r, 'set'),
            _classApplyDescriptorSet(t, r, n),
            n
          );
        }
        function _classStaticPrivateMethodGet(t, e, r) {
          return _classCheckPrivateStaticAccess(t, e), r;
        }
        function _classStaticPrivateMethodSet() {
          throw new TypeError('attempted to set read only static private field');
        }
        function _classApplyDescriptorGet(t, e) {
          return e.get ? e.get.call(t) : e.value;
        }
        function _classApplyDescriptorSet(t, e, r) {
          if (e.set) e.set.call(t, r);
          else {
            if (!e.writable) throw new TypeError('attempted to set read only private field');
            e.value = r;
          }
        }
        function _classApplyDescriptorDestructureSet(t, e) {
          if (e.set)
            return (
              '__destrObj' in e ||
                (e.__destrObj = {
                  set value(r) {
                    e.set.call(t, r);
                  },
                }),
              e.__destrObj
            );
          if (!e.writable) throw new TypeError('attempted to set read only private field');
          return e;
        }
        function _classStaticPrivateFieldDestructureSet(t, e, r) {
          return (
            _classCheckPrivateStaticAccess(t, e),
            _classCheckPrivateStaticFieldDescriptor(r, 'set'),
            _classApplyDescriptorDestructureSet(t, r)
          );
        }
        function _classCheckPrivateStaticAccess(t, e) {
          if (t !== e) throw new TypeError('Private static access of wrong provenance');
        }
        function _classCheckPrivateStaticFieldDescriptor(t, e) {
          if (void 0 === t) throw new TypeError('attempted to ' + e + ' private static field before its declaration');
        }
        function _decorate(t, e, r, n) {
          var i = _getDecoratorsApi();
          if (n) for (var o = 0; o < n.length; o++) i = n[o](i);
          var a = e(function (t) {
              i.initializeInstanceElements(t, s.elements);
            }, r),
            s = i.decorateClass(_coalesceClassElements(a.d.map(_createElementDescriptor)), t);
          return i.initializeClassElements(a.F, s.elements), i.runClassFinishers(a.F, s.finishers);
        }
        function _getDecoratorsApi() {
          _getDecoratorsApi = function () {
            return t;
          };
          var t = {
            elementsDefinitionOrder: [['method'], ['field']],
            initializeInstanceElements: function (t, e) {
              ['method', 'field'].forEach(function (r) {
                e.forEach(function (e) {
                  e.kind === r && 'own' === e.placement && this.defineClassElement(t, e);
                }, this);
              }, this);
            },
            initializeClassElements: function (t, e) {
              var r = t.prototype;
              ['method', 'field'].forEach(function (n) {
                e.forEach(function (e) {
                  var i = e.placement;
                  if (e.kind === n && ('static' === i || 'prototype' === i)) {
                    var o = 'static' === i ? t : r;
                    this.defineClassElement(o, e);
                  }
                }, this);
              }, this);
            },
            defineClassElement: function (t, e) {
              var r = e.descriptor;
              if ('field' === e.kind) {
                var n = e.initializer;
                r = {
                  enumerable: r.enumerable,
                  writable: r.writable,
                  configurable: r.configurable,
                  value: void 0 === n ? void 0 : n.call(t),
                };
              }
              Object.defineProperty(t, e.key, r);
            },
            decorateClass: function (t, e) {
              var r = [],
                n = [],
                i = { static: [], prototype: [], own: [] };
              if (
                (t.forEach(function (t) {
                  this.addElementPlacement(t, i);
                }, this),
                t.forEach(function (t) {
                  if (!_hasDecorators(t)) return r.push(t);
                  var e = this.decorateElement(t, i);
                  r.push(e.element), r.push.apply(r, e.extras), n.push.apply(n, e.finishers);
                }, this),
                !e)
              )
                return { elements: r, finishers: n };
              var o = this.decorateConstructor(r, e);
              return n.push.apply(n, o.finishers), (o.finishers = n), o;
            },
            addElementPlacement: function (t, e, r) {
              var n = e[t.placement];
              if (!r && -1 !== n.indexOf(t.key)) throw new TypeError('Duplicated element (' + t.key + ')');
              n.push(t.key);
            },
            decorateElement: function (t, e) {
              for (var r = [], n = [], i = t.decorators, o = i.length - 1; o >= 0; o--) {
                var a = e[t.placement];
                a.splice(a.indexOf(t.key), 1);
                var s = this.fromElementDescriptor(t),
                  l = this.toElementFinisherExtras((0, i[o])(s) || s);
                (t = l.element), this.addElementPlacement(t, e), l.finisher && n.push(l.finisher);
                var c = l.extras;
                if (c) {
                  for (var h = 0; h < c.length; h++) this.addElementPlacement(c[h], e);
                  r.push.apply(r, c);
                }
              }
              return { element: t, finishers: n, extras: r };
            },
            decorateConstructor: function (t, e) {
              for (var r = [], n = e.length - 1; n >= 0; n--) {
                var i = this.fromClassDescriptor(t),
                  o = this.toClassDescriptor((0, e[n])(i) || i);
                if ((void 0 !== o.finisher && r.push(o.finisher), void 0 !== o.elements)) {
                  t = o.elements;
                  for (var a = 0; a < t.length - 1; a++)
                    for (var s = a + 1; s < t.length; s++)
                      if (t[a].key === t[s].key && t[a].placement === t[s].placement)
                        throw new TypeError('Duplicated element (' + t[a].key + ')');
                }
              }
              return { elements: t, finishers: r };
            },
            fromElementDescriptor: function (t) {
              var e = { kind: t.kind, key: t.key, placement: t.placement, descriptor: t.descriptor };
              return (
                Object.defineProperty(e, Symbol.toStringTag, { value: 'Descriptor', configurable: !0 }),
                'field' === t.kind && (e.initializer = t.initializer),
                e
              );
            },
            toElementDescriptors: function (t) {
              if (void 0 !== t)
                return _toArray(t).map(function (t) {
                  var e = this.toElementDescriptor(t);
                  return (
                    this.disallowProperty(t, 'finisher', 'An element descriptor'),
                    this.disallowProperty(t, 'extras', 'An element descriptor'),
                    e
                  );
                }, this);
            },
            toElementDescriptor: function (t) {
              var e = String(t.kind);
              if ('method' !== e && 'field' !== e)
                throw new TypeError(
                  'An element descriptor\'s .kind property must be either "method" or "field", but a decorator created an element descriptor with .kind "' +
                    e +
                    '"',
                );
              var r = _toPropertyKey(t.key),
                n = String(t.placement);
              if ('static' !== n && 'prototype' !== n && 'own' !== n)
                throw new TypeError(
                  'An element descriptor\'s .placement property must be one of "static", "prototype" or "own", but a decorator created an element descriptor with .placement "' +
                    n +
                    '"',
                );
              var i = t.descriptor;
              this.disallowProperty(t, 'elements', 'An element descriptor');
              var o = { kind: e, key: r, placement: n, descriptor: Object.assign({}, i) };
              return (
                'field' !== e
                  ? this.disallowProperty(t, 'initializer', 'A method descriptor')
                  : (this.disallowProperty(i, 'get', 'The property descriptor of a field descriptor'),
                    this.disallowProperty(i, 'set', 'The property descriptor of a field descriptor'),
                    this.disallowProperty(i, 'value', 'The property descriptor of a field descriptor'),
                    (o.initializer = t.initializer)),
                o
              );
            },
            toElementFinisherExtras: function (t) {
              return {
                element: this.toElementDescriptor(t),
                finisher: _optionalCallableProperty(t, 'finisher'),
                extras: this.toElementDescriptors(t.extras),
              };
            },
            fromClassDescriptor: function (t) {
              var e = { kind: 'class', elements: t.map(this.fromElementDescriptor, this) };
              return Object.defineProperty(e, Symbol.toStringTag, { value: 'Descriptor', configurable: !0 }), e;
            },
            toClassDescriptor: function (t) {
              var e = String(t.kind);
              if ('class' !== e)
                throw new TypeError(
                  'A class descriptor\'s .kind property must be "class", but a decorator created a class descriptor with .kind "' +
                    e +
                    '"',
                );
              this.disallowProperty(t, 'key', 'A class descriptor'),
                this.disallowProperty(t, 'placement', 'A class descriptor'),
                this.disallowProperty(t, 'descriptor', 'A class descriptor'),
                this.disallowProperty(t, 'initializer', 'A class descriptor'),
                this.disallowProperty(t, 'extras', 'A class descriptor');
              var r = _optionalCallableProperty(t, 'finisher');
              return { elements: this.toElementDescriptors(t.elements), finisher: r };
            },
            runClassFinishers: function (t, e) {
              for (var r = 0; r < e.length; r++) {
                var n = (0, e[r])(t);
                if (void 0 !== n) {
                  if ('function' != typeof n) throw new TypeError('Finishers must return a constructor.');
                  t = n;
                }
              }
              return t;
            },
            disallowProperty: function (t, e, r) {
              if (void 0 !== t[e]) throw new TypeError(r + " can't have a ." + e + ' property.');
            },
          };
          return t;
        }
        function _createElementDescriptor(t) {
          var e,
            r = _toPropertyKey(t.key);
          'method' === t.kind
            ? (e = { value: t.value, writable: !0, configurable: !0, enumerable: !1 })
            : 'get' === t.kind
            ? (e = { get: t.value, configurable: !0, enumerable: !1 })
            : 'set' === t.kind
            ? (e = { set: t.value, configurable: !0, enumerable: !1 })
            : 'field' === t.kind && (e = { configurable: !0, writable: !0, enumerable: !0 });
          var n = {
            kind: 'field' === t.kind ? 'field' : 'method',
            key: r,
            placement: t.static ? 'static' : 'field' === t.kind ? 'own' : 'prototype',
            descriptor: e,
          };
          return t.decorators && (n.decorators = t.decorators), 'field' === t.kind && (n.initializer = t.value), n;
        }
        function _coalesceGetterSetter(t, e) {
          void 0 !== t.descriptor.get ? (e.descriptor.get = t.descriptor.get) : (e.descriptor.set = t.descriptor.set);
        }
        function _coalesceClassElements(t) {
          for (
            var e = [],
              r = function (t) {
                return 'method' === t.kind && t.key === o.key && t.placement === o.placement;
              },
              n = 0;
            n < t.length;
            n++
          ) {
            var i,
              o = t[n];
            if ('method' === o.kind && (i = e.find(r)))
              if (_isDataDescriptor(o.descriptor) || _isDataDescriptor(i.descriptor)) {
                if (_hasDecorators(o) || _hasDecorators(i))
                  throw new ReferenceError('Duplicated methods (' + o.key + ") can't be decorated.");
                i.descriptor = o.descriptor;
              } else {
                if (_hasDecorators(o)) {
                  if (_hasDecorators(i))
                    throw new ReferenceError(
                      "Decorators can't be placed on different accessors with for the same property (" + o.key + ').',
                    );
                  i.decorators = o.decorators;
                }
                _coalesceGetterSetter(o, i);
              }
            else e.push(o);
          }
          return e;
        }
        function _hasDecorators(t) {
          return t.decorators && t.decorators.length;
        }
        function _isDataDescriptor(t) {
          return void 0 !== t && !(void 0 === t.value && void 0 === t.writable);
        }
        function _optionalCallableProperty(t, e) {
          var r = t[e];
          if (void 0 !== r && 'function' != typeof r) throw new TypeError("Expected '" + e + "' to be a function");
          return r;
        }
        function _classPrivateMethodGet(t, e, r) {
          if (!e.has(t)) throw new TypeError('attempted to get private field on non-instance');
          return r;
        }
        function _checkPrivateRedeclaration(t, e) {
          if (e.has(t)) throw new TypeError('Cannot initialize the same private elements twice on an object');
        }
        function _classPrivateFieldInitSpec(t, e, r) {
          _checkPrivateRedeclaration(t, e), e.set(t, r);
        }
        function _classPrivateMethodInitSpec(t, e) {
          _checkPrivateRedeclaration(t, e), e.add(t);
        }
        function _classPrivateMethodSet() {
          throw new TypeError('attempted to reassign private method');
        }
        var _extendStatics = function (t, e) {
          return (
            (_extendStatics =
              Object.setPrototypeOf ||
              ({ __proto__: [] } instanceof Array &&
                function (t, e) {
                  t.__proto__ = e;
                }) ||
              function (t, e) {
                for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
              }),
            _extendStatics(t, e)
          );
        };
        function __extends(t, e) {
          if ('function' != typeof e && null !== e)
            throw new TypeError('Class extends value ' + String(e) + ' is not a constructor or null');
          function r() {
            this.constructor = t;
          }
          _extendStatics(t, e), (t.prototype = null === e ? Object.create(e) : ((r.prototype = e.prototype), new r()));
        }
        var _assign = function () {
          return (
            (_assign =
              Object.assign ||
              function (t) {
                for (var e, r = 1, n = arguments.length; r < n; r++)
                  for (var i in (e = arguments[r])) Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
                return t;
              }),
            _assign.apply(this, arguments)
          );
        };
        function __rest(t, e) {
          var r = {};
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && e.indexOf(n) < 0 && (r[n] = t[n]);
          if (null != t && 'function' == typeof Object.getOwnPropertySymbols) {
            var i = 0;
            for (n = Object.getOwnPropertySymbols(t); i < n.length; i++)
              e.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, n[i]) && (r[n[i]] = t[n[i]]);
          }
          return r;
        }
        function __decorate(t, e, r, n) {
          var i,
            o = arguments.length,
            a = o < 3 ? e : null === n ? (n = Object.getOwnPropertyDescriptor(e, r)) : n;
          if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate) a = Reflect.decorate(t, e, r, n);
          else
            for (var s = t.length - 1; s >= 0; s--)
              (i = t[s]) && (a = (o < 3 ? i(a) : o > 3 ? i(e, r, a) : i(e, r)) || a);
          return o > 3 && a && Object.defineProperty(e, r, a), a;
        }
        function __param(t, e) {
          return function (r, n) {
            e(r, n, t);
          };
        }
        function __metadata(t, e) {
          if ('object' == typeof Reflect && 'function' == typeof Reflect.metadata) return Reflect.metadata(t, e);
        }
        function __awaiter(t, e, r, n) {
          return new (r || (r = Promise))(function (i, o) {
            function a(t) {
              try {
                l(n.next(t));
              } catch (t) {
                o(t);
              }
            }
            function s(t) {
              try {
                l(n.throw(t));
              } catch (t) {
                o(t);
              }
            }
            function l(t) {
              var e;
              t.done
                ? i(t.value)
                : ((e = t.value),
                  e instanceof r
                    ? e
                    : new r(function (t) {
                        t(e);
                      })).then(a, s);
            }
            l((n = n.apply(t, e || [])).next());
          });
        }
        function __generator(t, e) {
          var r,
            n,
            i,
            o,
            a = {
              label: 0,
              sent: function () {
                if (1 & i[0]) throw i[1];
                return i[1];
              },
              trys: [],
              ops: [],
            };
          return (
            (o = { next: s(0), throw: s(1), return: s(2) }),
            'function' == typeof Symbol &&
              (o[Symbol.iterator] = function () {
                return this;
              }),
            o
          );
          function s(o) {
            return function (s) {
              return (function (o) {
                if (r) throw new TypeError('Generator is already executing.');
                for (; a; )
                  try {
                    if (
                      ((r = 1),
                      n &&
                        (i = 2 & o[0] ? n.return : o[0] ? n.throw || ((i = n.return) && i.call(n), 0) : n.next) &&
                        !(i = i.call(n, o[1])).done)
                    )
                      return i;
                    switch (((n = 0), i && (o = [2 & o[0], i.value]), o[0])) {
                      case 0:
                      case 1:
                        i = o;
                        break;
                      case 4:
                        return a.label++, { value: o[1], done: !1 };
                      case 5:
                        a.label++, (n = o[1]), (o = [0]);
                        continue;
                      case 7:
                        (o = a.ops.pop()), a.trys.pop();
                        continue;
                      default:
                        if (!((i = (i = a.trys).length > 0 && i[i.length - 1]) || (6 !== o[0] && 2 !== o[0]))) {
                          a = 0;
                          continue;
                        }
                        if (3 === o[0] && (!i || (o[1] > i[0] && o[1] < i[3]))) {
                          a.label = o[1];
                          break;
                        }
                        if (6 === o[0] && a.label < i[1]) {
                          (a.label = i[1]), (i = o);
                          break;
                        }
                        if (i && a.label < i[2]) {
                          (a.label = i[2]), a.ops.push(o);
                          break;
                        }
                        i[2] && a.ops.pop(), a.trys.pop();
                        continue;
                    }
                    o = e.call(t, a);
                  } catch (t) {
                    (o = [6, t]), (n = 0);
                  } finally {
                    r = i = 0;
                  }
                if (5 & o[0]) throw o[1];
                return { value: o[0] ? o[1] : void 0, done: !0 };
              })([o, s]);
            };
          }
        }
        var __createBinding = Object.create
          ? function (t, e, r, n) {
              void 0 === n && (n = r),
                Object.defineProperty(t, n, {
                  enumerable: !0,
                  get: function () {
                    return e[r];
                  },
                });
            }
          : function (t, e, r, n) {
              void 0 === n && (n = r), (t[n] = e[r]);
            };
        function __exportStar(t, e) {
          for (var r in t) 'default' === r || Object.prototype.hasOwnProperty.call(e, r) || __createBinding(e, t, r);
        }
        function __values(t) {
          var e = 'function' == typeof Symbol && Symbol.iterator,
            r = e && t[e],
            n = 0;
          if (r) return r.call(t);
          if (t && 'number' == typeof t.length)
            return {
              next: function () {
                return t && n >= t.length && (t = void 0), { value: t && t[n++], done: !t };
              },
            };
          throw new TypeError(e ? 'Object is not iterable.' : 'Symbol.iterator is not defined.');
        }
        function __read(t, e) {
          var r = 'function' == typeof Symbol && t[Symbol.iterator];
          if (!r) return t;
          var n,
            i,
            o = r.call(t),
            a = [];
          try {
            for (; (void 0 === e || e-- > 0) && !(n = o.next()).done; ) a.push(n.value);
          } catch (t) {
            i = { error: t };
          } finally {
            try {
              n && !n.done && (r = o.return) && r.call(o);
            } finally {
              if (i) throw i.error;
            }
          }
          return a;
        }
        function __spread() {
          for (var t = [], e = 0; e < arguments.length; e++) t = t.concat(__read(arguments[e]));
          return t;
        }
        function __spreadArrays() {
          for (var t = 0, e = 0, r = arguments.length; e < r; e++) t += arguments[e].length;
          var n = Array(t),
            i = 0;
          for (e = 0; e < r; e++) for (var o = arguments[e], a = 0, s = o.length; a < s; a++, i++) n[i] = o[a];
          return n;
        }
        function __spreadArray(t, e, r) {
          if (r || 2 === arguments.length)
            for (var n, i = 0, o = e.length; i < o; i++)
              (!n && i in e) || (n || (n = Array.prototype.slice.call(e, 0, i)), (n[i] = e[i]));
          return t.concat(n || Array.prototype.slice.call(e));
        }
        function __await(t) {
          return this instanceof __await ? ((this.v = t), this) : new __await(t);
        }
        function __asyncGenerator(t, e, r) {
          if (!Symbol.asyncIterator) throw new TypeError('Symbol.asyncIterator is not defined.');
          var n,
            i = r.apply(t, e || []),
            o = [];
          return (
            (n = {}),
            a('next'),
            a('throw'),
            a('return'),
            (n[Symbol.asyncIterator] = function () {
              return this;
            }),
            n
          );
          function a(t) {
            i[t] &&
              (n[t] = function (e) {
                return new Promise(function (r, n) {
                  o.push([t, e, r, n]) > 1 || s(t, e);
                });
              });
          }
          function s(t, e) {
            try {
              !(function (t) {
                t.value instanceof __await ? Promise.resolve(t.value.v).then(l, c) : h(o[0][2], t);
              })(i[t](e));
            } catch (t) {
              h(o[0][3], t);
            }
          }
          function l(t) {
            s('next', t);
          }
          function c(t) {
            s('throw', t);
          }
          function h(t, e) {
            t(e), o.shift(), o.length && s(o[0][0], o[0][1]);
          }
        }
        function __asyncDelegator(t) {
          var e, r;
          return (
            (e = {}),
            n('next'),
            n('throw', function (t) {
              throw t;
            }),
            n('return'),
            (e[Symbol.iterator] = function () {
              return this;
            }),
            e
          );
          function n(n, i) {
            e[n] = t[n]
              ? function (e) {
                  return (r = !r) ? { value: __await(t[n](e)), done: 'return' === n } : i ? i(e) : e;
                }
              : i;
          }
        }
        function __asyncValues(t) {
          if (!Symbol.asyncIterator) throw new TypeError('Symbol.asyncIterator is not defined.');
          var e,
            r = t[Symbol.asyncIterator];
          return r
            ? r.call(t)
            : ((t = 'function' == typeof __values ? __values(t) : t[Symbol.iterator]()),
              (e = {}),
              n('next'),
              n('throw'),
              n('return'),
              (e[Symbol.asyncIterator] = function () {
                return this;
              }),
              e);
          function n(r) {
            e[r] =
              t[r] &&
              function (e) {
                return new Promise(function (n, i) {
                  !(function (t, e, r, n) {
                    Promise.resolve(n).then(function (e) {
                      t({ value: e, done: r });
                    }, e);
                  })(n, i, (e = t[r](e)).done, e.value);
                });
              };
          }
        }
        function __makeTemplateObject(t, e) {
          return Object.defineProperty ? Object.defineProperty(t, 'raw', { value: e }) : (t.raw = e), t;
        }
        var __setModuleDefault = Object.create
          ? function (t, e) {
              Object.defineProperty(t, 'default', { enumerable: !0, value: e });
            }
          : function (t, e) {
              t.default = e;
            };
        function __importStar(t) {
          if (t && t.__esModule) return t;
          var e = {};
          if (null != t)
            for (var r in t) 'default' !== r && Object.prototype.hasOwnProperty.call(t, r) && __createBinding(e, t, r);
          return __setModuleDefault(e, t), e;
        }
        function __importDefault(t) {
          return t && t.__esModule ? t : { default: t };
        }
        function __classPrivateFieldGet(t, e, r, n) {
          if ('a' === r && !n) throw new TypeError('Private accessor was defined without a getter');
          if ('function' == typeof e ? t !== e || !n : !e.has(t))
            throw new TypeError('Cannot read private member from an object whose class did not declare it');
          return 'm' === r ? n : 'a' === r ? n.call(t) : n ? n.value : e.get(t);
        }
        function __classPrivateFieldSet(t, e, r, n, i) {
          if ('m' === n) throw new TypeError('Private method is not writable');
          if ('a' === n && !i) throw new TypeError('Private accessor was defined without a setter');
          if ('function' == typeof e ? t !== e || !i : !e.has(t))
            throw new TypeError('Cannot write private member to an object whose class did not declare it');
          return 'a' === n ? i.call(t, r) : i ? (i.value = r) : e.set(t, r), r;
        }
        var t$3 =
            window.ShadowRoot &&
            (void 0 === window.ShadyCSS || window.ShadyCSS.nativeShadow) &&
            'adoptedStyleSheets' in Document.prototype &&
            'replace' in CSSStyleSheet.prototype,
          e$8 = Symbol(),
          n$5 = new Map();
        class s$3 {
          constructor(t, e) {
            if (((this._$cssResult$ = !0), e !== e$8))
              throw Error('CSSResult is not constructable. Use `unsafeCSS` or `css` instead.');
            this.cssText = t;
          }
          get styleSheet() {
            var t = n$5.get(this.cssText);
            return (
              t$3 && void 0 === t && (n$5.set(this.cssText, (t = new CSSStyleSheet())), t.replaceSync(this.cssText)), t
            );
          }
          toString() {
            return this.cssText;
          }
        }
        var o$5 = (t) => new s$3('string' == typeof t ? t : t + '', e$8),
          r$3 = function (t) {
            for (var e = arguments.length, r = new Array(e > 1 ? e - 1 : 0), n = 1; n < e; n++) r[n - 1] = arguments[n];
            var i =
              1 === t.length
                ? t[0]
                : r.reduce(
                    (e, r, n) =>
                      e +
                      ((t) => {
                        if (!0 === t._$cssResult$) return t.cssText;
                        if ('number' == typeof t) return t;
                        throw Error(
                          "Value passed to 'css' function must be a 'css' function result: " +
                            t +
                            ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.",
                        );
                      })(r) +
                      t[n + 1],
                    t[0],
                  );
            return new s$3(i, e$8);
          },
          i$3 = (t, e) => {
            t$3
              ? (t.adoptedStyleSheets = e.map((t) => (t instanceof CSSStyleSheet ? t : t.styleSheet)))
              : e.forEach((e) => {
                  var r = document.createElement('style'),
                    n = window.litNonce;
                  void 0 !== n && r.setAttribute('nonce', n), (r.textContent = e.cssText), t.appendChild(r);
                });
          },
          S$1 = t$3
            ? (t) => t
            : (t) =>
                t instanceof CSSStyleSheet
                  ? ((t) => {
                      var e = '';
                      for (var r of t.cssRules) e += r.cssText;
                      return o$5(e);
                    })(t)
                  : t,
          s$2,
          e$7 = window.trustedTypes,
          r$2 = e$7 ? e$7.emptyScript : '',
          h$2 = window.reactiveElementPolyfillSupport,
          o$4 = {
            toAttribute(t, e) {
              switch (e) {
                case Boolean:
                  t = t ? r$2 : null;
                  break;
                case Object:
                case Array:
                  t = null == t ? t : JSON.stringify(t);
              }
              return t;
            },
            fromAttribute(t, e) {
              var r = t;
              switch (e) {
                case Boolean:
                  r = null !== t;
                  break;
                case Number:
                  r = null === t ? null : Number(t);
                  break;
                case Object:
                case Array:
                  try {
                    r = JSON.parse(t);
                  } catch (t) {
                    r = null;
                  }
              }
              return r;
            },
          },
          n$4 = (t, e) => e !== t && (e == e || t == t),
          l$3 = { attribute: !0, type: String, converter: o$4, reflect: !1, hasChanged: n$4 },
          t$2;
        class a$1 extends HTMLElement {
          constructor() {
            super(),
              (this._$Et = new Map()),
              (this.isUpdatePending = !1),
              (this.hasUpdated = !1),
              (this._$Ei = null),
              this.o();
          }
          static addInitializer(t) {
            var e;
            (null !== (e = this.l) && void 0 !== e) || (this.l = []), this.l.push(t);
          }
          static get observedAttributes() {
            this.finalize();
            var t = [];
            return (
              this.elementProperties.forEach((e, r) => {
                var n = this._$Eh(r, e);
                void 0 !== n && (this._$Eu.set(n, r), t.push(n));
              }),
              t
            );
          }
          static createProperty(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : l$3;
            if (
              (e.state && (e.attribute = !1),
              this.finalize(),
              this.elementProperties.set(t, e),
              !e.noAccessor && !this.prototype.hasOwnProperty(t))
            ) {
              var r = 'symbol' == typeof t ? Symbol() : '__' + t,
                n = this.getPropertyDescriptor(t, r, e);
              void 0 !== n && Object.defineProperty(this.prototype, t, n);
            }
          }
          static getPropertyDescriptor(t, e, r) {
            return {
              get() {
                return this[e];
              },
              set(n) {
                var i = this[t];
                (this[e] = n), this.requestUpdate(t, i, r);
              },
              configurable: !0,
              enumerable: !0,
            };
          }
          static getPropertyOptions(t) {
            return this.elementProperties.get(t) || l$3;
          }
          static finalize() {
            if (this.hasOwnProperty('finalized')) return !1;
            this.finalized = !0;
            var t = Object.getPrototypeOf(this);
            if (
              (t.finalize(),
              (this.elementProperties = new Map(t.elementProperties)),
              (this._$Eu = new Map()),
              this.hasOwnProperty('properties'))
            ) {
              var e = this.properties,
                r = [...Object.getOwnPropertyNames(e), ...Object.getOwnPropertySymbols(e)];
              for (var n of r) this.createProperty(n, e[n]);
            }
            return (this.elementStyles = this.finalizeStyles(this.styles)), !0;
          }
          static finalizeStyles(t) {
            var e = [];
            if (Array.isArray(t)) {
              var r = new Set(t.flat(1 / 0).reverse());
              for (var n of r) e.unshift(S$1(n));
            } else void 0 !== t && e.push(S$1(t));
            return e;
          }
          static _$Eh(t, e) {
            var r = e.attribute;
            return !1 === r ? void 0 : 'string' == typeof r ? r : 'string' == typeof t ? t.toLowerCase() : void 0;
          }
          o() {
            var t;
            (this._$Ep = new Promise((t) => (this.enableUpdating = t))),
              (this._$AL = new Map()),
              this._$Em(),
              this.requestUpdate(),
              null === (t = this.constructor.l) || void 0 === t || t.forEach((t) => t(this));
          }
          addController(t) {
            var e, r;
            (null !== (e = this._$Eg) && void 0 !== e ? e : (this._$Eg = [])).push(t),
              void 0 !== this.renderRoot &&
                this.isConnected &&
                (null === (r = t.hostConnected) || void 0 === r || r.call(t));
          }
          removeController(t) {
            var e;
            null === (e = this._$Eg) || void 0 === e || e.splice(this._$Eg.indexOf(t) >>> 0, 1);
          }
          _$Em() {
            this.constructor.elementProperties.forEach((t, e) => {
              this.hasOwnProperty(e) && (this._$Et.set(e, this[e]), delete this[e]);
            });
          }
          createRenderRoot() {
            var t,
              e =
                null !== (t = this.shadowRoot) && void 0 !== t
                  ? t
                  : this.attachShadow(this.constructor.shadowRootOptions);
            return i$3(e, this.constructor.elementStyles), e;
          }
          connectedCallback() {
            var t;
            void 0 === this.renderRoot && (this.renderRoot = this.createRenderRoot()),
              this.enableUpdating(!0),
              null === (t = this._$Eg) ||
                void 0 === t ||
                t.forEach((t) => {
                  var e;
                  return null === (e = t.hostConnected) || void 0 === e ? void 0 : e.call(t);
                });
          }
          enableUpdating(t) {}
          disconnectedCallback() {
            var t;
            null === (t = this._$Eg) ||
              void 0 === t ||
              t.forEach((t) => {
                var e;
                return null === (e = t.hostDisconnected) || void 0 === e ? void 0 : e.call(t);
              });
          }
          attributeChangedCallback(t, e, r) {
            this._$AK(t, r);
          }
          _$ES(t, e) {
            var r,
              n,
              i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : l$3,
              o = this.constructor._$Eh(t, i);
            if (void 0 !== o && !0 === i.reflect) {
              var a = (
                null !== (n = null === (r = i.converter) || void 0 === r ? void 0 : r.toAttribute) && void 0 !== n
                  ? n
                  : o$4.toAttribute
              )(e, i.type);
              (this._$Ei = t), null == a ? this.removeAttribute(o) : this.setAttribute(o, a), (this._$Ei = null);
            }
          }
          _$AK(t, e) {
            var r,
              n,
              i,
              o = this.constructor,
              a = o._$Eu.get(t);
            if (void 0 !== a && this._$Ei !== a) {
              var s = o.getPropertyOptions(a),
                l = s.converter,
                c =
                  null !==
                    (i =
                      null !== (n = null === (r = l) || void 0 === r ? void 0 : r.fromAttribute) && void 0 !== n
                        ? n
                        : 'function' == typeof l
                        ? l
                        : null) && void 0 !== i
                    ? i
                    : o$4.fromAttribute;
              (this._$Ei = a), (this[a] = c(e, s.type)), (this._$Ei = null);
            }
          }
          requestUpdate(t, e, r) {
            var n = !0;
            void 0 !== t &&
              (((r = r || this.constructor.getPropertyOptions(t)).hasChanged || n$4)(this[t], e)
                ? (this._$AL.has(t) || this._$AL.set(t, e),
                  !0 === r.reflect &&
                    this._$Ei !== t &&
                    (void 0 === this._$E_ && (this._$E_ = new Map()), this._$E_.set(t, r)))
                : (n = !1)),
              !this.isUpdatePending && n && (this._$Ep = this._$EC());
          }
          _$EC() {
            var t = this;
            return _asyncToGenerator(function* () {
              t.isUpdatePending = !0;
              try {
                yield t._$Ep;
              } catch (e) {
                Promise.reject(e);
              }
              var e = t.scheduleUpdate();
              return null != e && (yield e), !t.isUpdatePending;
            })();
          }
          scheduleUpdate() {
            return this.performUpdate();
          }
          performUpdate() {
            var t;
            if (this.isUpdatePending) {
              this.hasUpdated, this._$Et && (this._$Et.forEach((t, e) => (this[e] = t)), (this._$Et = void 0));
              var e = !1,
                r = this._$AL;
              try {
                (e = this.shouldUpdate(r))
                  ? (this.willUpdate(r),
                    null === (t = this._$Eg) ||
                      void 0 === t ||
                      t.forEach((t) => {
                        var e;
                        return null === (e = t.hostUpdate) || void 0 === e ? void 0 : e.call(t);
                      }),
                    this.update(r))
                  : this._$EU();
              } catch (t) {
                throw ((e = !1), this._$EU(), t);
              }
              e && this._$AE(r);
            }
          }
          willUpdate(t) {}
          _$AE(t) {
            var e;
            null === (e = this._$Eg) ||
              void 0 === e ||
              e.forEach((t) => {
                var e;
                return null === (e = t.hostUpdated) || void 0 === e ? void 0 : e.call(t);
              }),
              this.hasUpdated || ((this.hasUpdated = !0), this.firstUpdated(t)),
              this.updated(t);
          }
          _$EU() {
            (this._$AL = new Map()), (this.isUpdatePending = !1);
          }
          get updateComplete() {
            return this.getUpdateComplete();
          }
          getUpdateComplete() {
            return this._$Ep;
          }
          shouldUpdate(t) {
            return !0;
          }
          update(t) {
            void 0 !== this._$E_ && (this._$E_.forEach((t, e) => this._$ES(e, this[e], t)), (this._$E_ = void 0)),
              this._$EU();
          }
          updated(t) {}
          firstUpdated(t) {}
        }
        (a$1.finalized = !0),
          (a$1.elementProperties = new Map()),
          (a$1.elementStyles = []),
          (a$1.shadowRootOptions = { mode: 'open' }),
          null == h$2 || h$2({ ReactiveElement: a$1 }),
          (null !== (s$2 = globalThis.reactiveElementVersions) && void 0 !== s$2
            ? s$2
            : (globalThis.reactiveElementVersions = [])
          ).push('1.2.1');
        var i$2 = globalThis.trustedTypes,
          s$1 = i$2 ? i$2.createPolicy('lit-html', { createHTML: (t) => t }) : void 0,
          e$6 = 'lit$'.concat((Math.random() + '').slice(9), '$'),
          o$3 = '?' + e$6,
          n$3 = '<'.concat(o$3, '>'),
          l$2 = document,
          h$1 = function () {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : '';
            return l$2.createComment(t);
          },
          r$1 = (t) => null === t || ('object' != typeof t && 'function' != typeof t),
          d = Array.isArray,
          u = (t) => {
            var e;
            return d(t) || 'function' == typeof (null === (e = t) || void 0 === e ? void 0 : e[Symbol.iterator]);
          },
          c = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g,
          v = /-->/g,
          a = />/g,
          f = />|[ 	\n\r](?:([^\s"'>=/]+)([ 	\n\r]*=[ 	\n\r]*(?:[^ 	\n\r"'`<>=]|("|')|))|$)/g,
          _ = /'/g,
          m = /"/g,
          g = /^(?:script|style|textarea)$/i,
          p = (t) =>
            function (e) {
              for (var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), i = 1; i < r; i++)
                n[i - 1] = arguments[i];
              return { _$litType$: t, strings: e, values: n };
            },
          $ = p(1),
          y = p(2),
          b = Symbol.for('lit-noChange'),
          w = Symbol.for('lit-nothing'),
          T = new WeakMap(),
          x = (t, e, r) => {
            var n,
              i,
              o = null !== (n = null == r ? void 0 : r.renderBefore) && void 0 !== n ? n : e,
              a = o._$litPart$;
            if (void 0 === a) {
              var s = null !== (i = null == r ? void 0 : r.renderBefore) && void 0 !== i ? i : null;
              o._$litPart$ = a = new N(e.insertBefore(h$1(), s), s, void 0, null != r ? r : {});
            }
            return a._$AI(t), a;
          },
          A = l$2.createTreeWalker(l$2, 129, null, !1),
          C = (t, e) => {
            for (var r, n = t.length - 1, i = [], o = 2 === e ? '<svg>' : '', s = c, l = 0; l < n; l++) {
              for (
                var h = t[l], u = void 0, p = void 0, d = -1, y = 0;
                y < h.length && ((s.lastIndex = y), null !== (p = s.exec(h)));

              )
                (y = s.lastIndex),
                  s === c
                    ? '!--' === p[1]
                      ? (s = v)
                      : void 0 !== p[1]
                      ? (s = a)
                      : void 0 !== p[2]
                      ? (g.test(p[2]) && (r = RegExp('</' + p[2], 'g')), (s = f))
                      : void 0 !== p[3] && (s = f)
                    : s === f
                    ? '>' === p[0]
                      ? ((s = null != r ? r : c), (d = -1))
                      : void 0 === p[1]
                      ? (d = -2)
                      : ((d = s.lastIndex - p[2].length), (u = p[1]), (s = void 0 === p[3] ? f : '"' === p[3] ? m : _))
                    : s === m || s === _
                    ? (s = f)
                    : s === v || s === a
                    ? (s = c)
                    : ((s = f), (r = void 0));
              var b = s === f && t[l + 1].startsWith('/>') ? ' ' : '';
              o +=
                s === c
                  ? h + n$3
                  : d >= 0
                  ? (i.push(u), h.slice(0, d) + '$lit$' + h.slice(d) + e$6 + b)
                  : h + e$6 + (-2 === d ? (i.push(void 0), l) : b);
            }
            var x = o + (t[n] || '<?>') + (2 === e ? '</svg>' : '');
            if (!Array.isArray(t) || !t.hasOwnProperty('raw')) throw Error('invalid template strings array');
            return [void 0 !== s$1 ? s$1.createHTML(x) : x, i];
          };
        class E {
          constructor(t, e) {
            var r,
              { strings: n, _$litType$: i } = t;
            this.parts = [];
            var o = 0,
              a = 0,
              s = n.length - 1,
              l = this.parts,
              [c, h] = C(n, i);
            if (((this.el = E.createElement(c, e)), (A.currentNode = this.el.content), 2 === i)) {
              var u = this.el.content,
                p = u.firstChild;
              p.remove(), u.append(...p.childNodes);
            }
            for (; null !== (r = A.nextNode()) && l.length < s; ) {
              if (1 === r.nodeType) {
                if (r.hasAttributes()) {
                  var f = [];
                  for (var d of r.getAttributeNames())
                    if (d.endsWith('$lit$') || d.startsWith(e$6)) {
                      var m = h[a++];
                      if ((f.push(d), void 0 !== m)) {
                        var y = r.getAttribute(m.toLowerCase() + '$lit$').split(e$6),
                          v = /([.?@])?(.*)/.exec(m);
                        l.push({
                          type: 1,
                          index: o,
                          name: v[2],
                          strings: y,
                          ctor: '.' === v[1] ? M : '?' === v[1] ? H : '@' === v[1] ? I : S,
                        });
                      } else l.push({ type: 6, index: o });
                    }
                  for (var b of f) r.removeAttribute(b);
                }
                if (g.test(r.tagName)) {
                  var x = r.textContent.split(e$6),
                    w = x.length - 1;
                  if (w > 0) {
                    r.textContent = i$2 ? i$2.emptyScript : '';
                    for (var _ = 0; _ < w; _++) r.append(x[_], h$1()), A.nextNode(), l.push({ type: 2, index: ++o });
                    r.append(x[w], h$1());
                  }
                }
              } else if (8 === r.nodeType)
                if (r.data === o$3) l.push({ type: 2, index: o });
                else
                  for (var P = -1; -1 !== (P = r.data.indexOf(e$6, P + 1)); )
                    l.push({ type: 7, index: o }), (P += e$6.length - 1);
              o++;
            }
          }
          static createElement(t, e) {
            var r = l$2.createElement('template');
            return (r.innerHTML = t), r;
          }
        }
        function P(t, e) {
          var r,
            n,
            i,
            o,
            a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : t,
            s = arguments.length > 3 ? arguments[3] : void 0;
          if (e === b) return e;
          var l = void 0 !== s ? (null === (r = a._$Cl) || void 0 === r ? void 0 : r[s]) : a._$Cu,
            c = r$1(e) ? void 0 : e._$litDirective$;
          return (
            (null == l ? void 0 : l.constructor) !== c &&
              (null === (n = null == l ? void 0 : l._$AO) || void 0 === n || n.call(l, !1),
              void 0 === c ? (l = void 0) : (l = new c(t))._$AT(t, a, s),
              void 0 !== s ? ((null !== (i = (o = a)._$Cl) && void 0 !== i ? i : (o._$Cl = []))[s] = l) : (a._$Cu = l)),
            void 0 !== l && (e = P(t, l._$AS(t, e.values), l, s)),
            e
          );
        }
        class V {
          constructor(t, e) {
            (this.v = []), (this._$AN = void 0), (this._$AD = t), (this._$AM = e);
          }
          get parentNode() {
            return this._$AM.parentNode;
          }
          get _$AU() {
            return this._$AM._$AU;
          }
          p(t) {
            var e,
              {
                el: { content: r },
                parts: n,
              } = this._$AD,
              i = (null !== (e = null == t ? void 0 : t.creationScope) && void 0 !== e ? e : l$2).importNode(r, !0);
            A.currentNode = i;
            for (var o = A.nextNode(), a = 0, s = 0, l = n[0]; void 0 !== l; ) {
              if (a === l.index) {
                var c = void 0;
                2 === l.type
                  ? (c = new N(o, o.nextSibling, this, t))
                  : 1 === l.type
                  ? (c = new l.ctor(o, l.name, l.strings, this, t))
                  : 6 === l.type && (c = new L(o, this, t)),
                  this.v.push(c),
                  (l = n[++s]);
              }
              a !== (null == l ? void 0 : l.index) && ((o = A.nextNode()), a++);
            }
            return i;
          }
          m(t) {
            var e = 0;
            for (var r of this.v)
              void 0 !== r && (void 0 !== r.strings ? (r._$AI(t, r, e), (e += r.strings.length - 2)) : r._$AI(t[e])),
                e++;
          }
        }
        class N {
          constructor(t, e, r, n) {
            var i;
            (this.type = 2),
              (this._$AH = w),
              (this._$AN = void 0),
              (this._$AA = t),
              (this._$AB = e),
              (this._$AM = r),
              (this.options = n),
              (this._$Cg = null === (i = null == n ? void 0 : n.isConnected) || void 0 === i || i);
          }
          get _$AU() {
            var t, e;
            return null !== (e = null === (t = this._$AM) || void 0 === t ? void 0 : t._$AU) && void 0 !== e
              ? e
              : this._$Cg;
          }
          get parentNode() {
            var t = this._$AA.parentNode,
              e = this._$AM;
            return void 0 !== e && 11 === t.nodeType && (t = e.parentNode), t;
          }
          get startNode() {
            return this._$AA;
          }
          get endNode() {
            return this._$AB;
          }
          _$AI(t) {
            (t = P(this, t, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this)),
              r$1(t)
                ? t === w || null == t || '' === t
                  ? (this._$AH !== w && this._$AR(), (this._$AH = w))
                  : t !== this._$AH && t !== b && this.$(t)
                : void 0 !== t._$litType$
                ? this.T(t)
                : void 0 !== t.nodeType
                ? this.S(t)
                : u(t)
                ? this.A(t)
                : this.$(t);
          }
          M(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this._$AB;
            return this._$AA.parentNode.insertBefore(t, e);
          }
          S(t) {
            this._$AH !== t && (this._$AR(), (this._$AH = this.M(t)));
          }
          $(t) {
            this._$AH !== w && r$1(this._$AH) ? (this._$AA.nextSibling.data = t) : this.S(l$2.createTextNode(t)),
              (this._$AH = t);
          }
          T(t) {
            var e,
              { values: r, _$litType$: n } = t,
              i =
                'number' == typeof n
                  ? this._$AC(t)
                  : (void 0 === n.el && (n.el = E.createElement(n.h, this.options)), n);
            if ((null === (e = this._$AH) || void 0 === e ? void 0 : e._$AD) === i) this._$AH.m(r);
            else {
              var o = new V(i, this),
                a = o.p(this.options);
              o.m(r), this.S(a), (this._$AH = o);
            }
          }
          _$AC(t) {
            var e = T.get(t.strings);
            return void 0 === e && T.set(t.strings, (e = new E(t))), e;
          }
          A(t) {
            d(this._$AH) || ((this._$AH = []), this._$AR());
            var e,
              r = this._$AH,
              n = 0;
            for (var i of t)
              n === r.length ? r.push((e = new N(this.M(h$1()), this.M(h$1()), this, this.options))) : (e = r[n]),
                e._$AI(i),
                n++;
            n < r.length && (this._$AR(e && e._$AB.nextSibling, n), (r.length = n));
          }
          _$AR() {
            var t,
              e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this._$AA.nextSibling,
              r = arguments.length > 1 ? arguments[1] : void 0;
            for (null === (t = this._$AP) || void 0 === t || t.call(this, !1, !0, r); e && e !== this._$AB; ) {
              var n = e.nextSibling;
              e.remove(), (e = n);
            }
          }
          setConnected(t) {
            var e;
            void 0 === this._$AM && ((this._$Cg = t), null === (e = this._$AP) || void 0 === e || e.call(this, t));
          }
        }
        class S {
          constructor(t, e, r, n, i) {
            (this.type = 1),
              (this._$AH = w),
              (this._$AN = void 0),
              (this.element = t),
              (this.name = e),
              (this._$AM = n),
              (this.options = i),
              r.length > 2 || '' !== r[0] || '' !== r[1]
                ? ((this._$AH = Array(r.length - 1).fill(new String())), (this.strings = r))
                : (this._$AH = w);
          }
          get tagName() {
            return this.element.tagName;
          }
          get _$AU() {
            return this._$AM._$AU;
          }
          _$AI(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this,
              r = arguments.length > 2 ? arguments[2] : void 0,
              n = arguments.length > 3 ? arguments[3] : void 0,
              i = this.strings,
              o = !1;
            if (void 0 === i) (t = P(this, t, e, 0)), (o = !r$1(t) || (t !== this._$AH && t !== b)) && (this._$AH = t);
            else {
              var a,
                s,
                l = t;
              for (t = i[0], a = 0; a < i.length - 1; a++)
                (s = P(this, l[r + a], e, a)) === b && (s = this._$AH[a]),
                  o || (o = !r$1(s) || s !== this._$AH[a]),
                  s === w ? (t = w) : t !== w && (t += (null != s ? s : '') + i[a + 1]),
                  (this._$AH[a] = s);
            }
            o && !n && this.k(t);
          }
          k(t) {
            t === w
              ? this.element.removeAttribute(this.name)
              : this.element.setAttribute(this.name, null != t ? t : '');
          }
        }
        class M extends S {
          constructor() {
            super(...arguments), (this.type = 3);
          }
          k(t) {
            this.element[this.name] = t === w ? void 0 : t;
          }
        }
        var k = i$2 ? i$2.emptyScript : '';
        class H extends S {
          constructor() {
            super(...arguments), (this.type = 4);
          }
          k(t) {
            t && t !== w ? this.element.setAttribute(this.name, k) : this.element.removeAttribute(this.name);
          }
        }
        class I extends S {
          constructor(t, e, r, n, i) {
            super(t, e, r, n, i), (this.type = 5);
          }
          _$AI(t) {
            var e;
            if (
              (t =
                null !== (e = P(this, t, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this, 0)) &&
                void 0 !== e
                  ? e
                  : w) !== b
            ) {
              var r = this._$AH,
                n = (t === w && r !== w) || t.capture !== r.capture || t.once !== r.once || t.passive !== r.passive,
                i = t !== w && (r === w || n);
              n && this.element.removeEventListener(this.name, this, r),
                i && this.element.addEventListener(this.name, this, t),
                (this._$AH = t);
            }
          }
          handleEvent(t) {
            var e, r;
            'function' == typeof this._$AH
              ? this._$AH.call(
                  null !== (r = null === (e = this.options) || void 0 === e ? void 0 : e.host) && void 0 !== r
                    ? r
                    : this.element,
                  t,
                )
              : this._$AH.handleEvent(t);
          }
        }
        class L {
          constructor(t, e, r) {
            (this.element = t), (this.type = 6), (this._$AN = void 0), (this._$AM = e), (this.options = r);
          }
          get _$AU() {
            return this._$AM._$AU;
          }
          _$AI(t) {
            P(this, t);
          }
        }
        var R = { P: '$lit$', V: e$6, L: o$3, I: 1, N: C, R: V, D: u, j: P, H: N, O: S, F: H, B: I, W: M, Z: L },
          z = window.litHtmlPolyfillSupport,
          l$1,
          o$2;
        null == z || z(E, N),
          (null !== (t$2 = globalThis.litHtmlVersions) && void 0 !== t$2
            ? t$2
            : (globalThis.litHtmlVersions = [])
          ).push('2.1.2');
        var r = a$1;
        class s extends a$1 {
          constructor() {
            super(...arguments), (this.renderOptions = { host: this }), (this._$Dt = void 0);
          }
          createRenderRoot() {
            var t,
              e,
              r = super.createRenderRoot();
            return (
              (null !== (t = (e = this.renderOptions).renderBefore) && void 0 !== t) || (e.renderBefore = r.firstChild),
              r
            );
          }
          update(t) {
            var e = this.render();
            this.hasUpdated || (this.renderOptions.isConnected = this.isConnected),
              super.update(t),
              (this._$Dt = x(e, this.renderRoot, this.renderOptions));
          }
          connectedCallback() {
            var t;
            super.connectedCallback(), null === (t = this._$Dt) || void 0 === t || t.setConnected(!0);
          }
          disconnectedCallback() {
            var t;
            super.disconnectedCallback(), null === (t = this._$Dt) || void 0 === t || t.setConnected(!1);
          }
          render() {
            return b;
          }
        }
        (s.finalized = !0),
          (s._$litElement$ = !0),
          null === (l$1 = globalThis.litElementHydrateSupport) ||
            void 0 === l$1 ||
            l$1.call(globalThis, { LitElement: s });
        var n$2 = globalThis.litElementPolyfillSupport;
        null == n$2 || n$2({ LitElement: s });
        var h = {
          _$AK: (t, e, r) => {
            t._$AK(e, r);
          },
          _$AL: (t) => t._$AL,
        };
        (null !== (o$2 = globalThis.litElementVersions) && void 0 !== o$2
          ? o$2
          : (globalThis.litElementVersions = [])
        ).push('3.1.2');
        var n$1 = (t) => (e) =>
            'function' == typeof e
              ? ((t, e) => (window.customElements.define(t, e), e))(t, e)
              : ((t, e) => {
                  var { kind: r, elements: n } = e;
                  return {
                    kind: r,
                    elements: n,
                    finisher(e) {
                      window.customElements.define(t, e);
                    },
                  };
                })(t, e),
          i$1 = (t, e) =>
            'method' === e.kind && e.descriptor && !('value' in e.descriptor)
              ? _objectSpread2(
                  _objectSpread2({}, e),
                  {},
                  {
                    finisher(r) {
                      r.createProperty(e.key, t);
                    },
                  },
                )
              : {
                  kind: 'field',
                  key: Symbol(),
                  placement: 'own',
                  descriptor: {},
                  originalKey: e.key,
                  initializer() {
                    'function' == typeof e.initializer && (this[e.key] = e.initializer.call(this));
                  },
                  finisher(r) {
                    r.createProperty(e.key, t);
                  },
                };
        function e$5(t) {
          return (e, r) =>
            void 0 !== r
              ? ((t, e, r) => {
                  e.constructor.createProperty(r, t);
                })(t, e, r)
              : i$1(t, e);
        }
        function t$1(t) {
          return e$5(_objectSpread2(_objectSpread2({}, t), {}, { state: !0 }));
        }
        var e$4 = (t, e, r) => {
            Object.defineProperty(e, r, t);
          },
          t = (t, e) => ({ kind: 'method', placement: 'prototype', key: e.key, descriptor: t }),
          o$1 = (t) => {
            var { finisher: e, descriptor: r } = t;
            return (t, n) => {
              var i;
              if (void 0 === n) {
                var o = null !== (i = t.originalKey) && void 0 !== i ? i : t.key,
                  a =
                    null != r
                      ? { kind: 'method', placement: 'prototype', key: o, descriptor: r(t.key) }
                      : _objectSpread2(_objectSpread2({}, t), {}, { key: o });
                return (
                  null != e &&
                    (a.finisher = function (t) {
                      e(t, o);
                    }),
                  a
                );
              }
              var s = t.constructor;
              void 0 !== r && Object.defineProperty(t, n, r(n)), null == e || e(s, n);
            };
          },
          n;
        function e$3(t) {
          return o$1({
            finisher: (e, r) => {
              Object.assign(e.prototype[r], t);
            },
          });
        }
        function i(t, e) {
          return o$1({
            descriptor: (r) => {
              var n = {
                get() {
                  var e, r;
                  return null !== (r = null === (e = this.renderRoot) || void 0 === e ? void 0 : e.querySelector(t)) &&
                    void 0 !== r
                    ? r
                    : null;
                },
                enumerable: !0,
                configurable: !0,
              };
              if (e) {
                var i = 'symbol' == typeof r ? Symbol() : '__' + r;
                n.get = function () {
                  var e, r;
                  return (
                    void 0 === this[i] &&
                      (this[i] =
                        null !== (r = null === (e = this.renderRoot) || void 0 === e ? void 0 : e.querySelector(t)) &&
                        void 0 !== r
                          ? r
                          : null),
                    this[i]
                  );
                };
              }
              return n;
            },
          });
        }
        function e$2(t) {
          return o$1({
            descriptor: (e) => ({
              get() {
                var e, r;
                return null !== (r = null === (e = this.renderRoot) || void 0 === e ? void 0 : e.querySelectorAll(t)) &&
                  void 0 !== r
                  ? r
                  : [];
              },
              enumerable: !0,
              configurable: !0,
            }),
          });
        }
        function e$1(t) {
          return o$1({
            descriptor: (e) => ({
              get() {
                var e = this;
                return _asyncToGenerator(function* () {
                  var r;
                  return (
                    yield e.updateComplete, null === (r = e.renderRoot) || void 0 === r ? void 0 : r.querySelector(t)
                  );
                })();
              },
              enumerable: !0,
              configurable: !0,
            }),
          });
        }
        var e =
          null != (null === (n = window.HTMLSlotElement) || void 0 === n ? void 0 : n.prototype.assignedElements)
            ? (t, e) => t.assignedElements(e)
            : (t, e) => t.assignedNodes(e).filter((t) => t.nodeType === Node.ELEMENT_NODE);
        function l(t) {
          var { slot: r, selector: n } = null != t ? t : {};
          return o$1({
            descriptor: (i) => ({
              get() {
                var i,
                  o = 'slot' + (r ? '[name='.concat(r, ']') : ':not([name])'),
                  a = null === (i = this.renderRoot) || void 0 === i ? void 0 : i.querySelector(o),
                  s = null != a ? e(a, t) : [];
                return n ? s.filter((t) => t.matches(n)) : s;
              },
              enumerable: !0,
              configurable: !0,
            }),
          });
        }
        function o(t, e, r) {
          var n,
            i = t;
          return (
            'object' == typeof t ? ((i = t.slot), (n = t)) : (n = { flatten: e }),
            r
              ? l({ slot: i, flatten: e, selector: r })
              : o$1({
                  descriptor: (t) => ({
                    get() {
                      var t,
                        e,
                        r = 'slot' + (i ? '[name='.concat(i, ']') : ':not([name])'),
                        o = null === (t = this.renderRoot) || void 0 === t ? void 0 : t.querySelector(r);
                      return null !== (e = null == o ? void 0 : o.assignedNodes(n)) && void 0 !== e ? e : [];
                    },
                    enumerable: !0,
                    configurable: !0,
                  }),
                })
          );
        }
        var commonjsGlobal =
          'undefined' != typeof globalThis
            ? globalThis
            : 'undefined' != typeof window
            ? window
            : void 0 !== __webpack_require__.g
            ? __webpack_require__.g
            : 'undefined' != typeof self
            ? self
            : {};
        function getDefaultExportFromCjs(t) {
          return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, 'default') ? t.default : t;
        }
        function getDefaultExportFromNamespaceIfPresent(t) {
          return t && Object.prototype.hasOwnProperty.call(t, 'default') ? t.default : t;
        }
        function getDefaultExportFromNamespaceIfNotNamed(t) {
          return t && Object.prototype.hasOwnProperty.call(t, 'default') && 1 === Object.keys(t).length ? t.default : t;
        }
        function getAugmentedNamespace(t) {
          if (t.__esModule) return t;
          var e = Object.defineProperty({}, '__esModule', { value: !0 });
          return (
            Object.keys(t).forEach(function (r) {
              var n = Object.getOwnPropertyDescriptor(t, r);
              Object.defineProperty(
                e,
                r,
                n.get
                  ? n
                  : {
                      enumerable: !0,
                      get: function () {
                        return t[r];
                      },
                    },
              );
            }),
            e
          );
        }
        function commonjsRequire(t) {
          throw new Error(
            'Could not dynamically require "' +
              t +
              '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.',
          );
        }
        var lottie$1 = { exports: {} };
        (function (module, exports) {
          var factory;
          'undefined' != typeof navigator &&
            ((factory = function () {
              var svgNS = 'http://www.w3.org/2000/svg',
                locationHref = '',
                _useWebWorker = !1,
                initialDefaultFrame = -999999,
                setWebWorker = function (t) {
                  _useWebWorker = !!t;
                },
                getWebWorker = function () {
                  return _useWebWorker;
                },
                setLocationHref = function (t) {
                  locationHref = t;
                },
                getLocationHref = function () {
                  return locationHref;
                };
              function createTag(t) {
                return document.createElement(t);
              }
              function extendPrototype(t, e) {
                var r,
                  n,
                  i = t.length;
                for (r = 0; r < i; r += 1)
                  for (var o in (n = t[r].prototype))
                    Object.prototype.hasOwnProperty.call(n, o) && (e.prototype[o] = n[o]);
              }
              function getDescriptor(t, e) {
                return Object.getOwnPropertyDescriptor(t, e);
              }
              function createProxyFunction(t) {
                function e() {}
                return (e.prototype = t), e;
              }
              var audioControllerFactory = (function () {
                  function t(t) {
                    (this.audios = []), (this.audioFactory = t), (this._volume = 1), (this._isMuted = !1);
                  }
                  return (
                    (t.prototype = {
                      addAudio: function (t) {
                        this.audios.push(t);
                      },
                      pause: function () {
                        var t,
                          e = this.audios.length;
                        for (t = 0; t < e; t += 1) this.audios[t].pause();
                      },
                      resume: function () {
                        var t,
                          e = this.audios.length;
                        for (t = 0; t < e; t += 1) this.audios[t].resume();
                      },
                      setRate: function (t) {
                        var e,
                          r = this.audios.length;
                        for (e = 0; e < r; e += 1) this.audios[e].setRate(t);
                      },
                      createAudio: function (t) {
                        return this.audioFactory
                          ? this.audioFactory(t)
                          : window.Howl
                          ? new window.Howl({ src: [t] })
                          : {
                              isPlaying: !1,
                              play: function () {
                                this.isPlaying = !0;
                              },
                              seek: function () {
                                this.isPlaying = !1;
                              },
                              playing: function () {},
                              rate: function () {},
                              setVolume: function () {},
                            };
                      },
                      setAudioFactory: function (t) {
                        this.audioFactory = t;
                      },
                      setVolume: function (t) {
                        (this._volume = t), this._updateVolume();
                      },
                      mute: function () {
                        (this._isMuted = !0), this._updateVolume();
                      },
                      unmute: function () {
                        (this._isMuted = !1), this._updateVolume();
                      },
                      getVolume: function () {
                        return this._volume;
                      },
                      _updateVolume: function () {
                        var t,
                          e = this.audios.length;
                        for (t = 0; t < e; t += 1) this.audios[t].volume(this._volume * (this._isMuted ? 0 : 1));
                      },
                    }),
                    function () {
                      return new t();
                    }
                  );
                })(),
                createTypedArray = (function () {
                  function t(t, e) {
                    var r,
                      n = 0,
                      i = [];
                    switch (t) {
                      case 'int16':
                      case 'uint8c':
                        r = 1;
                        break;
                      default:
                        r = 1.1;
                    }
                    for (n = 0; n < e; n += 1) i.push(r);
                    return i;
                  }
                  return 'function' == typeof Uint8ClampedArray && 'function' == typeof Float32Array
                    ? function (e, r) {
                        return 'float32' === e
                          ? new Float32Array(r)
                          : 'int16' === e
                          ? new Int16Array(r)
                          : 'uint8c' === e
                          ? new Uint8ClampedArray(r)
                          : t(e, r);
                      }
                    : t;
                })();
              function createSizedArray(t) {
                return Array.apply(null, { length: t });
              }
              function _typeof$6(t) {
                return (
                  (_typeof$6 =
                    'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
                      ? function (t) {
                          return typeof t;
                        }
                      : function (t) {
                          return t && 'function' == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype
                            ? 'symbol'
                            : typeof t;
                        }),
                  _typeof$6(t)
                );
              }
              var subframeEnabled = !0,
                expressionsPlugin = null,
                expressionsInterfaces = null,
                idPrefix$1 = '',
                isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent),
                _shouldRoundValues = !1,
                bmPow = Math.pow,
                bmSqrt = Math.sqrt,
                bmFloor = Math.floor,
                bmMax = Math.max,
                bmMin = Math.min,
                BMMath = {};
              function ProjectInterface$1() {
                return {};
              }
              !(function () {
                var t,
                  e = [
                    'abs',
                    'acos',
                    'acosh',
                    'asin',
                    'asinh',
                    'atan',
                    'atanh',
                    'atan2',
                    'ceil',
                    'cbrt',
                    'expm1',
                    'clz32',
                    'cos',
                    'cosh',
                    'exp',
                    'floor',
                    'fround',
                    'hypot',
                    'imul',
                    'log',
                    'log1p',
                    'log2',
                    'log10',
                    'max',
                    'min',
                    'pow',
                    'random',
                    'round',
                    'sign',
                    'sin',
                    'sinh',
                    'sqrt',
                    'tan',
                    'tanh',
                    'trunc',
                    'E',
                    'LN10',
                    'LN2',
                    'LOG10E',
                    'LOG2E',
                    'PI',
                    'SQRT1_2',
                    'SQRT2',
                  ],
                  r = e.length;
                for (t = 0; t < r; t += 1) BMMath[e[t]] = Math[e[t]];
              })(),
                (BMMath.random = Math.random),
                (BMMath.abs = function (t) {
                  if ('object' === _typeof$6(t) && t.length) {
                    var e,
                      r = createSizedArray(t.length),
                      n = t.length;
                    for (e = 0; e < n; e += 1) r[e] = Math.abs(t[e]);
                    return r;
                  }
                  return Math.abs(t);
                });
              var defaultCurveSegments = 150,
                degToRads = Math.PI / 180,
                roundCorner = 0.5519;
              function roundValues(t) {
                _shouldRoundValues = !!t;
              }
              function bmRnd(t) {
                return _shouldRoundValues ? Math.round(t) : t;
              }
              function styleDiv(t) {
                (t.style.position = 'absolute'),
                  (t.style.top = 0),
                  (t.style.left = 0),
                  (t.style.display = 'block'),
                  (t.style.transformOrigin = '0 0'),
                  (t.style.webkitTransformOrigin = '0 0'),
                  (t.style.backfaceVisibility = 'visible'),
                  (t.style.webkitBackfaceVisibility = 'visible'),
                  (t.style.transformStyle = 'preserve-3d'),
                  (t.style.webkitTransformStyle = 'preserve-3d'),
                  (t.style.mozTransformStyle = 'preserve-3d');
              }
              function BMEnterFrameEvent(t, e, r, n) {
                (this.type = t), (this.currentTime = e), (this.totalTime = r), (this.direction = n < 0 ? -1 : 1);
              }
              function BMCompleteEvent(t, e) {
                (this.type = t), (this.direction = e < 0 ? -1 : 1);
              }
              function BMCompleteLoopEvent(t, e, r, n) {
                (this.type = t), (this.currentLoop = r), (this.totalLoops = e), (this.direction = n < 0 ? -1 : 1);
              }
              function BMSegmentStartEvent(t, e, r) {
                (this.type = t), (this.firstFrame = e), (this.totalFrames = r);
              }
              function BMDestroyEvent(t, e) {
                (this.type = t), (this.target = e);
              }
              function BMRenderFrameErrorEvent(t, e) {
                (this.type = 'renderFrameError'), (this.nativeError = t), (this.currentTime = e);
              }
              function BMConfigErrorEvent(t) {
                (this.type = 'configError'), (this.nativeError = t);
              }
              function BMAnimationConfigErrorEvent(t, e) {
                (this.type = t), (this.nativeError = e);
              }
              var createElementID =
                  ((_count = 0),
                  function () {
                    return idPrefix$1 + '__lottie_element_' + (_count += 1);
                  }),
                _count;
              function HSVtoRGB(t, e, r) {
                var n, i, o, a, s, l, c, h;
                switch (
                  ((l = r * (1 - e)),
                  (c = r * (1 - (s = 6 * t - (a = Math.floor(6 * t))) * e)),
                  (h = r * (1 - (1 - s) * e)),
                  a % 6)
                ) {
                  case 0:
                    (n = r), (i = h), (o = l);
                    break;
                  case 1:
                    (n = c), (i = r), (o = l);
                    break;
                  case 2:
                    (n = l), (i = r), (o = h);
                    break;
                  case 3:
                    (n = l), (i = c), (o = r);
                    break;
                  case 4:
                    (n = h), (i = l), (o = r);
                    break;
                  case 5:
                    (n = r), (i = l), (o = c);
                }
                return [n, i, o];
              }
              function RGBtoHSV(t, e, r) {
                var n,
                  i = Math.max(t, e, r),
                  o = Math.min(t, e, r),
                  a = i - o,
                  s = 0 === i ? 0 : a / i,
                  l = i / 255;
                switch (i) {
                  case o:
                    n = 0;
                    break;
                  case t:
                    (n = e - r + a * (e < r ? 6 : 0)), (n /= 6 * a);
                    break;
                  case e:
                    (n = r - t + 2 * a), (n /= 6 * a);
                    break;
                  case r:
                    (n = t - e + 4 * a), (n /= 6 * a);
                }
                return [n, s, l];
              }
              function addSaturationToRGB(t, e) {
                var r = RGBtoHSV(255 * t[0], 255 * t[1], 255 * t[2]);
                return (r[1] += e), r[1] > 1 ? (r[1] = 1) : r[1] <= 0 && (r[1] = 0), HSVtoRGB(r[0], r[1], r[2]);
              }
              function addBrightnessToRGB(t, e) {
                var r = RGBtoHSV(255 * t[0], 255 * t[1], 255 * t[2]);
                return (r[2] += e), r[2] > 1 ? (r[2] = 1) : r[2] < 0 && (r[2] = 0), HSVtoRGB(r[0], r[1], r[2]);
              }
              function addHueToRGB(t, e) {
                var r = RGBtoHSV(255 * t[0], 255 * t[1], 255 * t[2]);
                return (r[0] += e / 360), r[0] > 1 ? (r[0] -= 1) : r[0] < 0 && (r[0] += 1), HSVtoRGB(r[0], r[1], r[2]);
              }
              var rgbToHex = (function () {
                  var t,
                    e,
                    r = [];
                  for (t = 0; t < 256; t += 1) (e = t.toString(16)), (r[t] = 1 === e.length ? '0' + e : e);
                  return function (t, e, n) {
                    return t < 0 && (t = 0), e < 0 && (e = 0), n < 0 && (n = 0), '#' + r[t] + r[e] + r[n];
                  };
                })(),
                setSubframeEnabled = function (t) {
                  subframeEnabled = !!t;
                },
                getSubframeEnabled = function () {
                  return subframeEnabled;
                },
                setExpressionsPlugin = function (t) {
                  expressionsPlugin = t;
                },
                getExpressionsPlugin = function () {
                  return expressionsPlugin;
                },
                setExpressionInterfaces = function (t) {
                  expressionsInterfaces = t;
                },
                getExpressionInterfaces = function () {
                  return expressionsInterfaces;
                },
                setDefaultCurveSegments = function (t) {
                  defaultCurveSegments = t;
                },
                getDefaultCurveSegments = function () {
                  return defaultCurveSegments;
                },
                setIdPrefix = function (t) {
                  idPrefix$1 = t;
                },
                getIdPrefix = function () {
                  return idPrefix$1;
                };
              function createNS(t) {
                return document.createElementNS(svgNS, t);
              }
              function _typeof$5(t) {
                return (
                  (_typeof$5 =
                    'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
                      ? function (t) {
                          return typeof t;
                        }
                      : function (t) {
                          return t && 'function' == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype
                            ? 'symbol'
                            : typeof t;
                        }),
                  _typeof$5(t)
                );
              }
              var dataManager = (function () {
                  var t,
                    e,
                    r = 1,
                    n = [],
                    i = {
                      onmessage: function () {},
                      postMessage: function (e) {
                        t({ data: e });
                      },
                    },
                    o = {
                      postMessage: function (t) {
                        i.onmessage({ data: t });
                      },
                    };
                  function a() {
                    e ||
                      ((e = (function (e) {
                        if (window.Worker && window.Blob && getWebWorker()) {
                          var r = new Blob(['var _workerSelf = self; self.onmessage = ', e.toString()], {
                              type: 'text/javascript',
                            }),
                            n = URL.createObjectURL(r);
                          return new Worker(n);
                        }
                        return (t = e), i;
                      })(function (t) {
                        if (
                          (o.dataManager ||
                            (o.dataManager = (function () {
                              function t(i, o) {
                                var a,
                                  s,
                                  l,
                                  c,
                                  h,
                                  p,
                                  f = i.length;
                                for (s = 0; s < f; s += 1)
                                  if ('ks' in (a = i[s]) && !a.completed) {
                                    if (((a.completed = !0), a.hasMask)) {
                                      var d = a.masksProperties;
                                      for (c = d.length, l = 0; l < c; l += 1)
                                        if (d[l].pt.k.i) n(d[l].pt.k);
                                        else
                                          for (p = d[l].pt.k.length, h = 0; h < p; h += 1)
                                            d[l].pt.k[h].s && n(d[l].pt.k[h].s[0]),
                                              d[l].pt.k[h].e && n(d[l].pt.k[h].e[0]);
                                    }
                                    0 === a.ty
                                      ? ((a.layers = e(a.refId, o)), t(a.layers, o))
                                      : 4 === a.ty
                                      ? r(a.shapes)
                                      : 5 === a.ty && u(a);
                                  }
                              }
                              function e(t, e) {
                                var r = (function (t, e) {
                                  for (var r = 0, n = e.length; r < n; ) {
                                    if (e[r].id === t) return e[r];
                                    r += 1;
                                  }
                                  return null;
                                })(t, e);
                                return r
                                  ? r.layers.__used
                                    ? JSON.parse(JSON.stringify(r.layers))
                                    : ((r.layers.__used = !0), r.layers)
                                  : null;
                              }
                              function r(t) {
                                var e, i, o;
                                for (e = t.length - 1; e >= 0; e -= 1)
                                  if ('sh' === t[e].ty)
                                    if (t[e].ks.k.i) n(t[e].ks.k);
                                    else
                                      for (o = t[e].ks.k.length, i = 0; i < o; i += 1)
                                        t[e].ks.k[i].s && n(t[e].ks.k[i].s[0]), t[e].ks.k[i].e && n(t[e].ks.k[i].e[0]);
                                  else 'gr' === t[e].ty && r(t[e].it);
                              }
                              function n(t) {
                                var e,
                                  r = t.i.length;
                                for (e = 0; e < r; e += 1)
                                  (t.i[e][0] += t.v[e][0]),
                                    (t.i[e][1] += t.v[e][1]),
                                    (t.o[e][0] += t.v[e][0]),
                                    (t.o[e][1] += t.v[e][1]);
                              }
                              function i(t, e) {
                                var r = e ? e.split('.') : [100, 100, 100];
                                return (
                                  t[0] > r[0] ||
                                  (!(r[0] > t[0]) &&
                                    (t[1] > r[1] || (!(r[1] > t[1]) && (t[2] > r[2] || (!(r[2] > t[2]) && null)))))
                                );
                              }
                              var o,
                                a = (function () {
                                  var t = [4, 4, 14];
                                  function e(t) {
                                    var e,
                                      r,
                                      n,
                                      i = t.length;
                                    for (e = 0; e < i; e += 1)
                                      5 === t[e].ty && ((n = (r = t[e]).t.d), (r.t.d = { k: [{ s: n, t: 0 }] }));
                                  }
                                  return function (r) {
                                    if (i(t, r.v) && (e(r.layers), r.assets)) {
                                      var n,
                                        o = r.assets.length;
                                      for (n = 0; n < o; n += 1) r.assets[n].layers && e(r.assets[n].layers);
                                    }
                                  };
                                })(),
                                s =
                                  ((o = [4, 7, 99]),
                                  function (t) {
                                    if (t.chars && !i(o, t.v)) {
                                      var e,
                                        n = t.chars.length;
                                      for (e = 0; e < n; e += 1) {
                                        var a = t.chars[e];
                                        a.data &&
                                          a.data.shapes &&
                                          (r(a.data.shapes),
                                          (a.data.ip = 0),
                                          (a.data.op = 99999),
                                          (a.data.st = 0),
                                          (a.data.sr = 1),
                                          (a.data.ks = {
                                            p: { k: [0, 0], a: 0 },
                                            s: { k: [100, 100], a: 0 },
                                            a: { k: [0, 0], a: 0 },
                                            r: { k: 0, a: 0 },
                                            o: { k: 100, a: 0 },
                                          }),
                                          t.chars[e].t ||
                                            (a.data.shapes.push({ ty: 'no' }),
                                            a.data.shapes[0].it.push({
                                              p: { k: [0, 0], a: 0 },
                                              s: { k: [100, 100], a: 0 },
                                              a: { k: [0, 0], a: 0 },
                                              r: { k: 0, a: 0 },
                                              o: { k: 100, a: 0 },
                                              sk: { k: 0, a: 0 },
                                              sa: { k: 0, a: 0 },
                                              ty: 'tr',
                                            })));
                                      }
                                    }
                                  }),
                                l = (function () {
                                  var t = [5, 7, 15];
                                  function e(t) {
                                    var e,
                                      r,
                                      n = t.length;
                                    for (e = 0; e < n; e += 1)
                                      5 === t[e].ty &&
                                        ((r = void 0),
                                        'number' == typeof (r = t[e].t.p).a && (r.a = { a: 0, k: r.a }),
                                        'number' == typeof r.p && (r.p = { a: 0, k: r.p }),
                                        'number' == typeof r.r && (r.r = { a: 0, k: r.r }));
                                  }
                                  return function (r) {
                                    if (i(t, r.v) && (e(r.layers), r.assets)) {
                                      var n,
                                        o = r.assets.length;
                                      for (n = 0; n < o; n += 1) r.assets[n].layers && e(r.assets[n].layers);
                                    }
                                  };
                                })(),
                                c = (function () {
                                  var t = [4, 1, 9];
                                  function e(t) {
                                    var r,
                                      n,
                                      i,
                                      o = t.length;
                                    for (r = 0; r < o; r += 1)
                                      if ('gr' === t[r].ty) e(t[r].it);
                                      else if ('fl' === t[r].ty || 'st' === t[r].ty)
                                        if (t[r].c.k && t[r].c.k[0].i)
                                          for (i = t[r].c.k.length, n = 0; n < i; n += 1)
                                            t[r].c.k[n].s &&
                                              ((t[r].c.k[n].s[0] /= 255),
                                              (t[r].c.k[n].s[1] /= 255),
                                              (t[r].c.k[n].s[2] /= 255),
                                              (t[r].c.k[n].s[3] /= 255)),
                                              t[r].c.k[n].e &&
                                                ((t[r].c.k[n].e[0] /= 255),
                                                (t[r].c.k[n].e[1] /= 255),
                                                (t[r].c.k[n].e[2] /= 255),
                                                (t[r].c.k[n].e[3] /= 255));
                                        else
                                          (t[r].c.k[0] /= 255),
                                            (t[r].c.k[1] /= 255),
                                            (t[r].c.k[2] /= 255),
                                            (t[r].c.k[3] /= 255);
                                  }
                                  function r(t) {
                                    var r,
                                      n = t.length;
                                    for (r = 0; r < n; r += 1) 4 === t[r].ty && e(t[r].shapes);
                                  }
                                  return function (e) {
                                    if (i(t, e.v) && (r(e.layers), e.assets)) {
                                      var n,
                                        o = e.assets.length;
                                      for (n = 0; n < o; n += 1) e.assets[n].layers && r(e.assets[n].layers);
                                    }
                                  };
                                })(),
                                h = (function () {
                                  var t = [4, 4, 18];
                                  function e(t) {
                                    var r, n, i;
                                    for (r = t.length - 1; r >= 0; r -= 1)
                                      if ('sh' === t[r].ty)
                                        if (t[r].ks.k.i) t[r].ks.k.c = t[r].closed;
                                        else
                                          for (i = t[r].ks.k.length, n = 0; n < i; n += 1)
                                            t[r].ks.k[n].s && (t[r].ks.k[n].s[0].c = t[r].closed),
                                              t[r].ks.k[n].e && (t[r].ks.k[n].e[0].c = t[r].closed);
                                      else 'gr' === t[r].ty && e(t[r].it);
                                  }
                                  function r(t) {
                                    var r,
                                      n,
                                      i,
                                      o,
                                      a,
                                      s,
                                      l = t.length;
                                    for (n = 0; n < l; n += 1) {
                                      if ((r = t[n]).hasMask) {
                                        var c = r.masksProperties;
                                        for (o = c.length, i = 0; i < o; i += 1)
                                          if (c[i].pt.k.i) c[i].pt.k.c = c[i].cl;
                                          else
                                            for (s = c[i].pt.k.length, a = 0; a < s; a += 1)
                                              c[i].pt.k[a].s && (c[i].pt.k[a].s[0].c = c[i].cl),
                                                c[i].pt.k[a].e && (c[i].pt.k[a].e[0].c = c[i].cl);
                                      }
                                      4 === r.ty && e(r.shapes);
                                    }
                                  }
                                  return function (e) {
                                    if (i(t, e.v) && (r(e.layers), e.assets)) {
                                      var n,
                                        o = e.assets.length;
                                      for (n = 0; n < o; n += 1) e.assets[n].layers && r(e.assets[n].layers);
                                    }
                                  };
                                })();
                              function u(t) {
                                0 === t.t.a.length && t.t.p;
                              }
                              var p = {
                                completeData: function (r) {
                                  r.__complete ||
                                    (c(r),
                                    a(r),
                                    s(r),
                                    l(r),
                                    h(r),
                                    t(r.layers, r.assets),
                                    (function (r, n) {
                                      if (r) {
                                        var i = 0,
                                          o = r.length;
                                        for (i = 0; i < o; i += 1)
                                          1 === r[i].t &&
                                            ((r[i].data.layers = e(r[i].data.refId, n)), t(r[i].data.layers, n));
                                      }
                                    })(r.chars, r.assets),
                                    (r.__complete = !0));
                                },
                              };
                              return (
                                (p.checkColors = c),
                                (p.checkChars = s),
                                (p.checkPathProperties = l),
                                (p.checkShapes = h),
                                (p.completeLayers = t),
                                p
                              );
                            })()),
                          o.assetLoader ||
                            (o.assetLoader = (function () {
                              function t(t) {
                                var e = t.getResponseHeader('content-type');
                                return (e && 'json' === t.responseType && -1 !== e.indexOf('json')) ||
                                  (t.response && 'object' === _typeof$5(t.response))
                                  ? t.response
                                  : t.response && 'string' == typeof t.response
                                  ? JSON.parse(t.response)
                                  : t.responseText
                                  ? JSON.parse(t.responseText)
                                  : null;
                              }
                              return {
                                load: function (e, r, n, i) {
                                  var o,
                                    a = new XMLHttpRequest();
                                  try {
                                    a.responseType = 'json';
                                  } catch (t) {}
                                  a.onreadystatechange = function () {
                                    if (4 === a.readyState)
                                      if (200 === a.status) (o = t(a)), n(o);
                                      else
                                        try {
                                          (o = t(a)), n(o);
                                        } catch (t) {
                                          i && i(t);
                                        }
                                  };
                                  try {
                                    a.open(['G', 'E', 'T'].join(''), e, !0);
                                  } catch (t) {
                                    a.open(['G', 'E', 'T'].join(''), r + '/' + e, !0);
                                  }
                                  a.send();
                                },
                              };
                            })()),
                          'loadAnimation' === t.data.type)
                        )
                          o.assetLoader.load(
                            t.data.path,
                            t.data.fullPath,
                            function (e) {
                              o.dataManager.completeData(e),
                                o.postMessage({ id: t.data.id, payload: e, status: 'success' });
                            },
                            function () {
                              o.postMessage({ id: t.data.id, status: 'error' });
                            },
                          );
                        else if ('complete' === t.data.type) {
                          var e = t.data.animation;
                          o.dataManager.completeData(e),
                            o.postMessage({ id: t.data.id, payload: e, status: 'success' });
                        } else
                          'loadData' === t.data.type &&
                            o.assetLoader.load(
                              t.data.path,
                              t.data.fullPath,
                              function (e) {
                                o.postMessage({ id: t.data.id, payload: e, status: 'success' });
                              },
                              function () {
                                o.postMessage({ id: t.data.id, status: 'error' });
                              },
                            );
                      })),
                      (e.onmessage = function (t) {
                        var e = t.data,
                          r = e.id,
                          i = n[r];
                        (n[r] = null), 'success' === e.status ? i.onComplete(e.payload) : i.onError && i.onError();
                      }));
                  }
                  function s(t, e) {
                    var i = 'processId_' + (r += 1);
                    return (n[i] = { onComplete: t, onError: e }), i;
                  }
                  return {
                    loadAnimation: function (t, r, n) {
                      a();
                      var i = s(r, n);
                      e.postMessage({
                        type: 'loadAnimation',
                        path: t,
                        fullPath: window.location.origin + window.location.pathname,
                        id: i,
                      });
                    },
                    loadData: function (t, r, n) {
                      a();
                      var i = s(r, n);
                      e.postMessage({
                        type: 'loadData',
                        path: t,
                        fullPath: window.location.origin + window.location.pathname,
                        id: i,
                      });
                    },
                    completeAnimation: function (t, r, n) {
                      a();
                      var i = s(r, n);
                      e.postMessage({ type: 'complete', animation: t, id: i });
                    },
                  };
                })(),
                ImagePreloader = (function () {
                  var t = (function () {
                    var t = createTag('canvas');
                    (t.width = 1), (t.height = 1);
                    var e = t.getContext('2d');
                    return (e.fillStyle = 'rgba(0,0,0,0)'), e.fillRect(0, 0, 1, 1), t;
                  })();
                  function e() {
                    (this.loadedAssets += 1),
                      this.loadedAssets === this.totalImages &&
                        this.loadedFootagesCount === this.totalFootages &&
                        this.imagesLoadedCb &&
                        this.imagesLoadedCb(null);
                  }
                  function r() {
                    (this.loadedFootagesCount += 1),
                      this.loadedAssets === this.totalImages &&
                        this.loadedFootagesCount === this.totalFootages &&
                        this.imagesLoadedCb &&
                        this.imagesLoadedCb(null);
                  }
                  function n(t, e, r) {
                    var n = '';
                    if (t.e) n = t.p;
                    else if (e) {
                      var i = t.p;
                      -1 !== i.indexOf('images/') && (i = i.split('/')[1]), (n = e + i);
                    } else (n = r), (n += t.u ? t.u : ''), (n += t.p);
                    return n;
                  }
                  function i(t) {
                    var e = 0,
                      r = setInterval(
                        function () {
                          (t.getBBox().width || e > 500) && (this._imageLoaded(), clearInterval(r)), (e += 1);
                        }.bind(this),
                        50,
                      );
                  }
                  function o(t) {
                    var e = { assetData: t },
                      r = n(t, this.assetsPath, this.path);
                    return (
                      dataManager.loadData(
                        r,
                        function (t) {
                          (e.img = t), this._footageLoaded();
                        }.bind(this),
                        function () {
                          (e.img = {}), this._footageLoaded();
                        }.bind(this),
                      ),
                      e
                    );
                  }
                  function a() {
                    (this._imageLoaded = e.bind(this)),
                      (this._footageLoaded = r.bind(this)),
                      (this.testImageLoaded = i.bind(this)),
                      (this.createFootageData = o.bind(this)),
                      (this.assetsPath = ''),
                      (this.path = ''),
                      (this.totalImages = 0),
                      (this.totalFootages = 0),
                      (this.loadedAssets = 0),
                      (this.loadedFootagesCount = 0),
                      (this.imagesLoadedCb = null),
                      (this.images = []);
                  }
                  return (
                    (a.prototype = {
                      loadAssets: function (t, e) {
                        var r;
                        this.imagesLoadedCb = e;
                        var n = t.length;
                        for (r = 0; r < n; r += 1)
                          t[r].layers ||
                            (t[r].t && 'seq' !== t[r].t
                              ? 3 === t[r].t &&
                                ((this.totalFootages += 1), this.images.push(this.createFootageData(t[r])))
                              : ((this.totalImages += 1), this.images.push(this._createImageData(t[r]))));
                      },
                      setAssetsPath: function (t) {
                        this.assetsPath = t || '';
                      },
                      setPath: function (t) {
                        this.path = t || '';
                      },
                      loadedImages: function () {
                        return this.totalImages === this.loadedAssets;
                      },
                      loadedFootages: function () {
                        return this.totalFootages === this.loadedFootagesCount;
                      },
                      destroy: function () {
                        (this.imagesLoadedCb = null), (this.images.length = 0);
                      },
                      getAsset: function (t) {
                        for (var e = 0, r = this.images.length; e < r; ) {
                          if (this.images[e].assetData === t) return this.images[e].img;
                          e += 1;
                        }
                        return null;
                      },
                      createImgData: function (e) {
                        var r = n(e, this.assetsPath, this.path),
                          i = createTag('img');
                        (i.crossOrigin = 'anonymous'),
                          i.addEventListener('load', this._imageLoaded, !1),
                          i.addEventListener(
                            'error',
                            function () {
                              (o.img = t), this._imageLoaded();
                            }.bind(this),
                            !1,
                          ),
                          (i.src = r);
                        var o = { img: i, assetData: e };
                        return o;
                      },
                      createImageData: function (e) {
                        var r = n(e, this.assetsPath, this.path),
                          i = createNS('image');
                        isSafari ? this.testImageLoaded(i) : i.addEventListener('load', this._imageLoaded, !1),
                          i.addEventListener(
                            'error',
                            function () {
                              (o.img = t), this._imageLoaded();
                            }.bind(this),
                            !1,
                          ),
                          i.setAttributeNS('http://www.w3.org/1999/xlink', 'href', r),
                          this._elementHelper.append
                            ? this._elementHelper.append(i)
                            : this._elementHelper.appendChild(i);
                        var o = { img: i, assetData: e };
                        return o;
                      },
                      imageLoaded: e,
                      footageLoaded: r,
                      setCacheType: function (t, e) {
                        'svg' === t
                          ? ((this._elementHelper = e), (this._createImageData = this.createImageData.bind(this)))
                          : (this._createImageData = this.createImgData.bind(this));
                      },
                    }),
                    a
                  );
                })();
              function BaseEvent() {}
              BaseEvent.prototype = {
                triggerEvent: function (t, e) {
                  if (this._cbs[t]) for (var r = this._cbs[t], n = 0; n < r.length; n += 1) r[n](e);
                },
                addEventListener: function (t, e) {
                  return (
                    this._cbs[t] || (this._cbs[t] = []),
                    this._cbs[t].push(e),
                    function () {
                      this.removeEventListener(t, e);
                    }.bind(this)
                  );
                },
                removeEventListener: function (t, e) {
                  if (e) {
                    if (this._cbs[t]) {
                      for (var r = 0, n = this._cbs[t].length; r < n; )
                        this._cbs[t][r] === e && (this._cbs[t].splice(r, 1), (r -= 1), (n -= 1)), (r += 1);
                      this._cbs[t].length || (this._cbs[t] = null);
                    }
                  } else this._cbs[t] = null;
                },
              };
              var markerParser = (function () {
                  function t(t) {
                    for (var e, r = t.split('\r\n'), n = {}, i = 0, o = 0; o < r.length; o += 1)
                      2 === (e = r[o].split(':')).length && ((n[e[0]] = e[1].trim()), (i += 1));
                    if (0 === i) throw new Error();
                    return n;
                  }
                  return function (e) {
                    for (var r = [], n = 0; n < e.length; n += 1) {
                      var i = e[n],
                        o = { time: i.tm, duration: i.dr };
                      try {
                        o.payload = JSON.parse(e[n].cm);
                      } catch (r) {
                        try {
                          o.payload = t(e[n].cm);
                        } catch (t) {
                          o.payload = { name: e[n].cm };
                        }
                      }
                      r.push(o);
                    }
                    return r;
                  };
                })(),
                ProjectInterface = (function () {
                  function t(t) {
                    this.compositions.push(t);
                  }
                  return function () {
                    function e(t) {
                      for (var e = 0, r = this.compositions.length; e < r; ) {
                        if (this.compositions[e].data && this.compositions[e].data.nm === t)
                          return (
                            this.compositions[e].prepareFrame &&
                              this.compositions[e].data.xt &&
                              this.compositions[e].prepareFrame(this.currentFrame),
                            this.compositions[e].compInterface
                          );
                        e += 1;
                      }
                      return null;
                    }
                    return (e.compositions = []), (e.currentFrame = 0), (e.registerComposition = t), e;
                  };
                })(),
                renderers = {},
                registerRenderer = function (t, e) {
                  renderers[t] = e;
                };
              function getRenderer(t) {
                return renderers[t];
              }
              function _typeof$4(t) {
                return (
                  (_typeof$4 =
                    'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
                      ? function (t) {
                          return typeof t;
                        }
                      : function (t) {
                          return t && 'function' == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype
                            ? 'symbol'
                            : typeof t;
                        }),
                  _typeof$4(t)
                );
              }
              var AnimationItem = function () {
                (this._cbs = []),
                  (this.name = ''),
                  (this.path = ''),
                  (this.isLoaded = !1),
                  (this.currentFrame = 0),
                  (this.currentRawFrame = 0),
                  (this.firstFrame = 0),
                  (this.totalFrames = 0),
                  (this.frameRate = 0),
                  (this.frameMult = 0),
                  (this.playSpeed = 1),
                  (this.playDirection = 1),
                  (this.playCount = 0),
                  (this.animationData = {}),
                  (this.assets = []),
                  (this.isPaused = !0),
                  (this.autoplay = !1),
                  (this.loop = !0),
                  (this.renderer = null),
                  (this.animationID = createElementID()),
                  (this.assetsPath = ''),
                  (this.timeCompleted = 0),
                  (this.segmentPos = 0),
                  (this.isSubframeEnabled = getSubframeEnabled()),
                  (this.segments = []),
                  (this._idle = !0),
                  (this._completedLoop = !1),
                  (this.projectInterface = ProjectInterface()),
                  (this.imagePreloader = new ImagePreloader()),
                  (this.audioController = audioControllerFactory()),
                  (this.markers = []),
                  (this.configAnimation = this.configAnimation.bind(this)),
                  (this.onSetupError = this.onSetupError.bind(this)),
                  (this.onSegmentComplete = this.onSegmentComplete.bind(this)),
                  (this.drawnFrameEvent = new BMEnterFrameEvent('drawnFrame', 0, 0, 0));
              };
              extendPrototype([BaseEvent], AnimationItem),
                (AnimationItem.prototype.setParams = function (t) {
                  (t.wrapper || t.container) && (this.wrapper = t.wrapper || t.container);
                  var e = 'svg';
                  t.animType ? (e = t.animType) : t.renderer && (e = t.renderer);
                  var r = getRenderer(e);
                  (this.renderer = new r(this, t.rendererSettings)),
                    this.imagePreloader.setCacheType(e, this.renderer.globalData.defs),
                    this.renderer.setProjectInterface(this.projectInterface),
                    (this.animType = e),
                    '' === t.loop || null === t.loop || void 0 === t.loop || !0 === t.loop
                      ? (this.loop = !0)
                      : !1 === t.loop
                      ? (this.loop = !1)
                      : (this.loop = parseInt(t.loop, 10)),
                    (this.autoplay = !('autoplay' in t) || t.autoplay),
                    (this.name = t.name ? t.name : ''),
                    (this.autoloadSegments =
                      !Object.prototype.hasOwnProperty.call(t, 'autoloadSegments') || t.autoloadSegments),
                    (this.assetsPath = t.assetsPath),
                    (this.initialSegment = t.initialSegment),
                    t.audioFactory && this.audioController.setAudioFactory(t.audioFactory),
                    t.animationData
                      ? this.setupAnimation(t.animationData)
                      : t.path &&
                        (-1 !== t.path.lastIndexOf('\\')
                          ? (this.path = t.path.substr(0, t.path.lastIndexOf('\\') + 1))
                          : (this.path = t.path.substr(0, t.path.lastIndexOf('/') + 1)),
                        (this.fileName = t.path.substr(t.path.lastIndexOf('/') + 1)),
                        (this.fileName = this.fileName.substr(0, this.fileName.lastIndexOf('.json'))),
                        dataManager.loadAnimation(t.path, this.configAnimation, this.onSetupError));
                }),
                (AnimationItem.prototype.onSetupError = function () {
                  this.trigger('data_failed');
                }),
                (AnimationItem.prototype.setupAnimation = function (t) {
                  dataManager.completeAnimation(t, this.configAnimation);
                }),
                (AnimationItem.prototype.setData = function (t, e) {
                  e && 'object' !== _typeof$4(e) && (e = JSON.parse(e));
                  var r = { wrapper: t, animationData: e },
                    n = t.attributes;
                  (r.path = n.getNamedItem('data-animation-path')
                    ? n.getNamedItem('data-animation-path').value
                    : n.getNamedItem('data-bm-path')
                    ? n.getNamedItem('data-bm-path').value
                    : n.getNamedItem('bm-path')
                    ? n.getNamedItem('bm-path').value
                    : ''),
                    (r.animType = n.getNamedItem('data-anim-type')
                      ? n.getNamedItem('data-anim-type').value
                      : n.getNamedItem('data-bm-type')
                      ? n.getNamedItem('data-bm-type').value
                      : n.getNamedItem('bm-type')
                      ? n.getNamedItem('bm-type').value
                      : n.getNamedItem('data-bm-renderer')
                      ? n.getNamedItem('data-bm-renderer').value
                      : n.getNamedItem('bm-renderer')
                      ? n.getNamedItem('bm-renderer').value
                      : 'canvas');
                  var i = n.getNamedItem('data-anim-loop')
                    ? n.getNamedItem('data-anim-loop').value
                    : n.getNamedItem('data-bm-loop')
                    ? n.getNamedItem('data-bm-loop').value
                    : n.getNamedItem('bm-loop')
                    ? n.getNamedItem('bm-loop').value
                    : '';
                  'false' === i ? (r.loop = !1) : 'true' === i ? (r.loop = !0) : '' !== i && (r.loop = parseInt(i, 10));
                  var o = n.getNamedItem('data-anim-autoplay')
                    ? n.getNamedItem('data-anim-autoplay').value
                    : n.getNamedItem('data-bm-autoplay')
                    ? n.getNamedItem('data-bm-autoplay').value
                    : !n.getNamedItem('bm-autoplay') || n.getNamedItem('bm-autoplay').value;
                  (r.autoplay = 'false' !== o),
                    (r.name = n.getNamedItem('data-name')
                      ? n.getNamedItem('data-name').value
                      : n.getNamedItem('data-bm-name')
                      ? n.getNamedItem('data-bm-name').value
                      : n.getNamedItem('bm-name')
                      ? n.getNamedItem('bm-name').value
                      : ''),
                    'false' ===
                      (n.getNamedItem('data-anim-prerender')
                        ? n.getNamedItem('data-anim-prerender').value
                        : n.getNamedItem('data-bm-prerender')
                        ? n.getNamedItem('data-bm-prerender').value
                        : n.getNamedItem('bm-prerender')
                        ? n.getNamedItem('bm-prerender').value
                        : '') && (r.prerender = !1),
                    this.setParams(r);
                }),
                (AnimationItem.prototype.includeLayers = function (t) {
                  t.op > this.animationData.op &&
                    ((this.animationData.op = t.op), (this.totalFrames = Math.floor(t.op - this.animationData.ip)));
                  var e,
                    r,
                    n = this.animationData.layers,
                    i = n.length,
                    o = t.layers,
                    a = o.length;
                  for (r = 0; r < a; r += 1)
                    for (e = 0; e < i; ) {
                      if (n[e].id === o[r].id) {
                        n[e] = o[r];
                        break;
                      }
                      e += 1;
                    }
                  if (
                    ((t.chars || t.fonts) &&
                      (this.renderer.globalData.fontManager.addChars(t.chars),
                      this.renderer.globalData.fontManager.addFonts(t.fonts, this.renderer.globalData.defs)),
                    t.assets)
                  )
                    for (i = t.assets.length, e = 0; e < i; e += 1) this.animationData.assets.push(t.assets[e]);
                  (this.animationData.__complete = !1),
                    dataManager.completeAnimation(this.animationData, this.onSegmentComplete);
                }),
                (AnimationItem.prototype.onSegmentComplete = function (t) {
                  this.animationData = t;
                  var e = getExpressionsPlugin();
                  e && e.initExpressions(this), this.loadNextSegment();
                }),
                (AnimationItem.prototype.loadNextSegment = function () {
                  var t = this.animationData.segments;
                  if (!t || 0 === t.length || !this.autoloadSegments)
                    return this.trigger('data_ready'), void (this.timeCompleted = this.totalFrames);
                  var e = t.shift();
                  this.timeCompleted = e.time * this.frameRate;
                  var r = this.path + this.fileName + '_' + this.segmentPos + '.json';
                  (this.segmentPos += 1),
                    dataManager.loadData(
                      r,
                      this.includeLayers.bind(this),
                      function () {
                        this.trigger('data_failed');
                      }.bind(this),
                    );
                }),
                (AnimationItem.prototype.loadSegments = function () {
                  this.animationData.segments || (this.timeCompleted = this.totalFrames), this.loadNextSegment();
                }),
                (AnimationItem.prototype.imagesLoaded = function () {
                  this.trigger('loaded_images'), this.checkLoaded();
                }),
                (AnimationItem.prototype.preloadImages = function () {
                  this.imagePreloader.setAssetsPath(this.assetsPath),
                    this.imagePreloader.setPath(this.path),
                    this.imagePreloader.loadAssets(this.animationData.assets, this.imagesLoaded.bind(this));
                }),
                (AnimationItem.prototype.configAnimation = function (t) {
                  if (this.renderer)
                    try {
                      (this.animationData = t),
                        this.initialSegment
                          ? ((this.totalFrames = Math.floor(this.initialSegment[1] - this.initialSegment[0])),
                            (this.firstFrame = Math.round(this.initialSegment[0])))
                          : ((this.totalFrames = Math.floor(this.animationData.op - this.animationData.ip)),
                            (this.firstFrame = Math.round(this.animationData.ip))),
                        this.renderer.configAnimation(t),
                        t.assets || (t.assets = []),
                        (this.assets = this.animationData.assets),
                        (this.frameRate = this.animationData.fr),
                        (this.frameMult = this.animationData.fr / 1e3),
                        this.renderer.searchExtraCompositions(t.assets),
                        (this.markers = markerParser(t.markers || [])),
                        this.trigger('config_ready'),
                        this.preloadImages(),
                        this.loadSegments(),
                        this.updaFrameModifier(),
                        this.waitForFontsLoaded(),
                        this.isPaused && this.audioController.pause();
                    } catch (t) {
                      this.triggerConfigError(t);
                    }
                }),
                (AnimationItem.prototype.waitForFontsLoaded = function () {
                  this.renderer &&
                    (this.renderer.globalData.fontManager.isLoaded
                      ? this.checkLoaded()
                      : setTimeout(this.waitForFontsLoaded.bind(this), 20));
                }),
                (AnimationItem.prototype.checkLoaded = function () {
                  if (
                    !this.isLoaded &&
                    this.renderer.globalData.fontManager.isLoaded &&
                    (this.imagePreloader.loadedImages() || 'canvas' !== this.renderer.rendererType) &&
                    this.imagePreloader.loadedFootages()
                  ) {
                    this.isLoaded = !0;
                    var t = getExpressionsPlugin();
                    t && t.initExpressions(this),
                      this.renderer.initItems(),
                      setTimeout(
                        function () {
                          this.trigger('DOMLoaded');
                        }.bind(this),
                        0,
                      ),
                      this.gotoFrame(),
                      this.autoplay && this.play();
                  }
                }),
                (AnimationItem.prototype.resize = function (t, e) {
                  var r = 'number' == typeof t ? t : void 0,
                    n = 'number' == typeof e ? e : void 0;
                  this.renderer.updateContainerSize(r, n);
                }),
                (AnimationItem.prototype.setSubframe = function (t) {
                  this.isSubframeEnabled = !!t;
                }),
                (AnimationItem.prototype.gotoFrame = function () {
                  (this.currentFrame = this.isSubframeEnabled ? this.currentRawFrame : ~~this.currentRawFrame),
                    this.timeCompleted !== this.totalFrames &&
                      this.currentFrame > this.timeCompleted &&
                      (this.currentFrame = this.timeCompleted),
                    this.trigger('enterFrame'),
                    this.renderFrame(),
                    this.trigger('drawnFrame');
                }),
                (AnimationItem.prototype.renderFrame = function () {
                  if (!1 !== this.isLoaded && this.renderer)
                    try {
                      this.renderer.renderFrame(this.currentFrame + this.firstFrame);
                    } catch (t) {
                      this.triggerRenderFrameError(t);
                    }
                }),
                (AnimationItem.prototype.play = function (t) {
                  (t && this.name !== t) ||
                    (!0 === this.isPaused &&
                      ((this.isPaused = !1),
                      this.trigger('_pause'),
                      this.audioController.resume(),
                      this._idle && ((this._idle = !1), this.trigger('_active'))));
                }),
                (AnimationItem.prototype.pause = function (t) {
                  (t && this.name !== t) ||
                    (!1 === this.isPaused &&
                      ((this.isPaused = !0),
                      this.trigger('_play'),
                      (this._idle = !0),
                      this.trigger('_idle'),
                      this.audioController.pause()));
                }),
                (AnimationItem.prototype.togglePause = function (t) {
                  (t && this.name !== t) || (!0 === this.isPaused ? this.play() : this.pause());
                }),
                (AnimationItem.prototype.stop = function (t) {
                  (t && this.name !== t) ||
                    (this.pause(), (this.playCount = 0), (this._completedLoop = !1), this.setCurrentRawFrameValue(0));
                }),
                (AnimationItem.prototype.getMarkerData = function (t) {
                  for (var e, r = 0; r < this.markers.length; r += 1)
                    if ((e = this.markers[r]).payload && e.payload.name === t) return e;
                  return null;
                }),
                (AnimationItem.prototype.goToAndStop = function (t, e, r) {
                  if (!r || this.name === r) {
                    var n = Number(t);
                    if (isNaN(n)) {
                      var i = this.getMarkerData(t);
                      i && this.goToAndStop(i.time, !0);
                    } else e ? this.setCurrentRawFrameValue(t) : this.setCurrentRawFrameValue(t * this.frameModifier);
                    this.pause();
                  }
                }),
                (AnimationItem.prototype.goToAndPlay = function (t, e, r) {
                  if (!r || this.name === r) {
                    var n = Number(t);
                    if (isNaN(n)) {
                      var i = this.getMarkerData(t);
                      i &&
                        (i.duration
                          ? this.playSegments([i.time, i.time + i.duration], !0)
                          : this.goToAndStop(i.time, !0));
                    } else this.goToAndStop(n, e, r);
                    this.play();
                  }
                }),
                (AnimationItem.prototype.advanceTime = function (t) {
                  if (!0 !== this.isPaused && !1 !== this.isLoaded) {
                    var e = this.currentRawFrame + t * this.frameModifier,
                      r = !1;
                    e >= this.totalFrames - 1 && this.frameModifier > 0
                      ? this.loop && this.playCount !== this.loop
                        ? e >= this.totalFrames
                          ? ((this.playCount += 1),
                            this.checkSegments(e % this.totalFrames) ||
                              (this.setCurrentRawFrameValue(e % this.totalFrames),
                              (this._completedLoop = !0),
                              this.trigger('loopComplete')))
                          : this.setCurrentRawFrameValue(e)
                        : this.checkSegments(e > this.totalFrames ? e % this.totalFrames : 0) ||
                          ((r = !0), (e = this.totalFrames - 1))
                      : e < 0
                      ? this.checkSegments(e % this.totalFrames) ||
                        (!this.loop || (this.playCount-- <= 0 && !0 !== this.loop)
                          ? ((r = !0), (e = 0))
                          : (this.setCurrentRawFrameValue(this.totalFrames + (e % this.totalFrames)),
                            this._completedLoop ? this.trigger('loopComplete') : (this._completedLoop = !0)))
                      : this.setCurrentRawFrameValue(e),
                      r && (this.setCurrentRawFrameValue(e), this.pause(), this.trigger('complete'));
                  }
                }),
                (AnimationItem.prototype.adjustSegment = function (t, e) {
                  (this.playCount = 0),
                    t[1] < t[0]
                      ? (this.frameModifier > 0 &&
                          (this.playSpeed < 0 ? this.setSpeed(-this.playSpeed) : this.setDirection(-1)),
                        (this.totalFrames = t[0] - t[1]),
                        (this.timeCompleted = this.totalFrames),
                        (this.firstFrame = t[1]),
                        this.setCurrentRawFrameValue(this.totalFrames - 0.001 - e))
                      : t[1] > t[0] &&
                        (this.frameModifier < 0 &&
                          (this.playSpeed < 0 ? this.setSpeed(-this.playSpeed) : this.setDirection(1)),
                        (this.totalFrames = t[1] - t[0]),
                        (this.timeCompleted = this.totalFrames),
                        (this.firstFrame = t[0]),
                        this.setCurrentRawFrameValue(0.001 + e)),
                    this.trigger('segmentStart');
                }),
                (AnimationItem.prototype.setSegment = function (t, e) {
                  var r = -1;
                  this.isPaused &&
                    (this.currentRawFrame + this.firstFrame < t
                      ? (r = t)
                      : this.currentRawFrame + this.firstFrame > e && (r = e - t)),
                    (this.firstFrame = t),
                    (this.totalFrames = e - t),
                    (this.timeCompleted = this.totalFrames),
                    -1 !== r && this.goToAndStop(r, !0);
                }),
                (AnimationItem.prototype.playSegments = function (t, e) {
                  if ((e && (this.segments.length = 0), 'object' === _typeof$4(t[0]))) {
                    var r,
                      n = t.length;
                    for (r = 0; r < n; r += 1) this.segments.push(t[r]);
                  } else this.segments.push(t);
                  this.segments.length && e && this.adjustSegment(this.segments.shift(), 0),
                    this.isPaused && this.play();
                }),
                (AnimationItem.prototype.resetSegments = function (t) {
                  (this.segments.length = 0),
                    this.segments.push([this.animationData.ip, this.animationData.op]),
                    t && this.checkSegments(0);
                }),
                (AnimationItem.prototype.checkSegments = function (t) {
                  return !!this.segments.length && (this.adjustSegment(this.segments.shift(), t), !0);
                }),
                (AnimationItem.prototype.destroy = function (t) {
                  (t && this.name !== t) ||
                    !this.renderer ||
                    (this.renderer.destroy(),
                    this.imagePreloader.destroy(),
                    this.trigger('destroy'),
                    (this._cbs = null),
                    (this.onEnterFrame = null),
                    (this.onLoopComplete = null),
                    (this.onComplete = null),
                    (this.onSegmentStart = null),
                    (this.onDestroy = null),
                    (this.renderer = null),
                    (this.renderer = null),
                    (this.imagePreloader = null),
                    (this.projectInterface = null));
                }),
                (AnimationItem.prototype.setCurrentRawFrameValue = function (t) {
                  (this.currentRawFrame = t), this.gotoFrame();
                }),
                (AnimationItem.prototype.setSpeed = function (t) {
                  (this.playSpeed = t), this.updaFrameModifier();
                }),
                (AnimationItem.prototype.setDirection = function (t) {
                  (this.playDirection = t < 0 ? -1 : 1), this.updaFrameModifier();
                }),
                (AnimationItem.prototype.setVolume = function (t, e) {
                  (e && this.name !== e) || this.audioController.setVolume(t);
                }),
                (AnimationItem.prototype.getVolume = function () {
                  return this.audioController.getVolume();
                }),
                (AnimationItem.prototype.mute = function (t) {
                  (t && this.name !== t) || this.audioController.mute();
                }),
                (AnimationItem.prototype.unmute = function (t) {
                  (t && this.name !== t) || this.audioController.unmute();
                }),
                (AnimationItem.prototype.updaFrameModifier = function () {
                  (this.frameModifier = this.frameMult * this.playSpeed * this.playDirection),
                    this.audioController.setRate(this.playSpeed * this.playDirection);
                }),
                (AnimationItem.prototype.getPath = function () {
                  return this.path;
                }),
                (AnimationItem.prototype.getAssetsPath = function (t) {
                  var e = '';
                  if (t.e) e = t.p;
                  else if (this.assetsPath) {
                    var r = t.p;
                    -1 !== r.indexOf('images/') && (r = r.split('/')[1]), (e = this.assetsPath + r);
                  } else (e = this.path), (e += t.u ? t.u : ''), (e += t.p);
                  return e;
                }),
                (AnimationItem.prototype.getAssetData = function (t) {
                  for (var e = 0, r = this.assets.length; e < r; ) {
                    if (t === this.assets[e].id) return this.assets[e];
                    e += 1;
                  }
                  return null;
                }),
                (AnimationItem.prototype.hide = function () {
                  this.renderer.hide();
                }),
                (AnimationItem.prototype.show = function () {
                  this.renderer.show();
                }),
                (AnimationItem.prototype.getDuration = function (t) {
                  return t ? this.totalFrames : this.totalFrames / this.frameRate;
                }),
                (AnimationItem.prototype.updateDocumentData = function (t, e, r) {
                  try {
                    this.renderer.getElementByPath(t).updateDocumentData(e, r);
                  } catch (t) {}
                }),
                (AnimationItem.prototype.trigger = function (t) {
                  if (this._cbs && this._cbs[t])
                    switch (t) {
                      case 'enterFrame':
                        this.triggerEvent(
                          t,
                          new BMEnterFrameEvent(t, this.currentFrame, this.totalFrames, this.frameModifier),
                        );
                        break;
                      case 'drawnFrame':
                        (this.drawnFrameEvent.currentTime = this.currentFrame),
                          (this.drawnFrameEvent.totalTime = this.totalFrames),
                          (this.drawnFrameEvent.direction = this.frameModifier),
                          this.triggerEvent(t, this.drawnFrameEvent);
                        break;
                      case 'loopComplete':
                        this.triggerEvent(t, new BMCompleteLoopEvent(t, this.loop, this.playCount, this.frameMult));
                        break;
                      case 'complete':
                        this.triggerEvent(t, new BMCompleteEvent(t, this.frameMult));
                        break;
                      case 'segmentStart':
                        this.triggerEvent(t, new BMSegmentStartEvent(t, this.firstFrame, this.totalFrames));
                        break;
                      case 'destroy':
                        this.triggerEvent(t, new BMDestroyEvent(t, this));
                        break;
                      default:
                        this.triggerEvent(t);
                    }
                  'enterFrame' === t &&
                    this.onEnterFrame &&
                    this.onEnterFrame.call(
                      this,
                      new BMEnterFrameEvent(t, this.currentFrame, this.totalFrames, this.frameMult),
                    ),
                    'loopComplete' === t &&
                      this.onLoopComplete &&
                      this.onLoopComplete.call(
                        this,
                        new BMCompleteLoopEvent(t, this.loop, this.playCount, this.frameMult),
                      ),
                    'complete' === t &&
                      this.onComplete &&
                      this.onComplete.call(this, new BMCompleteEvent(t, this.frameMult)),
                    'segmentStart' === t &&
                      this.onSegmentStart &&
                      this.onSegmentStart.call(this, new BMSegmentStartEvent(t, this.firstFrame, this.totalFrames)),
                    'destroy' === t && this.onDestroy && this.onDestroy.call(this, new BMDestroyEvent(t, this));
                }),
                (AnimationItem.prototype.triggerRenderFrameError = function (t) {
                  var e = new BMRenderFrameErrorEvent(t, this.currentFrame);
                  this.triggerEvent('error', e), this.onError && this.onError.call(this, e);
                }),
                (AnimationItem.prototype.triggerConfigError = function (t) {
                  var e = new BMConfigErrorEvent(t, this.currentFrame);
                  this.triggerEvent('error', e), this.onError && this.onError.call(this, e);
                });
              var animationManager = (function () {
                  var t = {},
                    e = [],
                    r = 0,
                    n = 0,
                    i = 0,
                    o = !0,
                    a = !1;
                  function s(t) {
                    for (var r = 0, i = t.target; r < n; )
                      e[r].animation === i && (e.splice(r, 1), (r -= 1), (n -= 1), i.isPaused || h()), (r += 1);
                  }
                  function l(t, r) {
                    if (!t) return null;
                    for (var i = 0; i < n; ) {
                      if (e[i].elem === t && null !== e[i].elem) return e[i].animation;
                      i += 1;
                    }
                    var o = new AnimationItem();
                    return u(o, t), o.setData(t, r), o;
                  }
                  function c() {
                    (i += 1), d();
                  }
                  function h() {
                    i -= 1;
                  }
                  function u(t, r) {
                    t.addEventListener('destroy', s),
                      t.addEventListener('_active', c),
                      t.addEventListener('_idle', h),
                      e.push({ elem: r, animation: t }),
                      (n += 1);
                  }
                  function p(t) {
                    var s,
                      l = t - r;
                    for (s = 0; s < n; s += 1) e[s].animation.advanceTime(l);
                    (r = t), i && !a ? window.requestAnimationFrame(p) : (o = !0);
                  }
                  function f(t) {
                    (r = t), window.requestAnimationFrame(p);
                  }
                  function d() {
                    !a && i && o && (window.requestAnimationFrame(f), (o = !1));
                  }
                  return (
                    (t.registerAnimation = l),
                    (t.loadAnimation = function (t) {
                      var e = new AnimationItem();
                      return u(e, null), e.setParams(t), e;
                    }),
                    (t.setSpeed = function (t, r) {
                      var i;
                      for (i = 0; i < n; i += 1) e[i].animation.setSpeed(t, r);
                    }),
                    (t.setDirection = function (t, r) {
                      var i;
                      for (i = 0; i < n; i += 1) e[i].animation.setDirection(t, r);
                    }),
                    (t.play = function (t) {
                      var r;
                      for (r = 0; r < n; r += 1) e[r].animation.play(t);
                    }),
                    (t.pause = function (t) {
                      var r;
                      for (r = 0; r < n; r += 1) e[r].animation.pause(t);
                    }),
                    (t.stop = function (t) {
                      var r;
                      for (r = 0; r < n; r += 1) e[r].animation.stop(t);
                    }),
                    (t.togglePause = function (t) {
                      var r;
                      for (r = 0; r < n; r += 1) e[r].animation.togglePause(t);
                    }),
                    (t.searchAnimations = function (t, e, r) {
                      var n,
                        i = [].concat(
                          [].slice.call(document.getElementsByClassName('lottie')),
                          [].slice.call(document.getElementsByClassName('bodymovin')),
                        ),
                        o = i.length;
                      for (n = 0; n < o; n += 1) r && i[n].setAttribute('data-bm-type', r), l(i[n], t);
                      if (e && 0 === o) {
                        r || (r = 'svg');
                        var a = document.getElementsByTagName('body')[0];
                        a.innerText = '';
                        var s = createTag('div');
                        (s.style.width = '100%'),
                          (s.style.height = '100%'),
                          s.setAttribute('data-bm-type', r),
                          a.appendChild(s),
                          l(s, t);
                      }
                    }),
                    (t.resize = function () {
                      var t;
                      for (t = 0; t < n; t += 1) e[t].animation.resize();
                    }),
                    (t.goToAndStop = function (t, r, i) {
                      var o;
                      for (o = 0; o < n; o += 1) e[o].animation.goToAndStop(t, r, i);
                    }),
                    (t.destroy = function (t) {
                      var r;
                      for (r = n - 1; r >= 0; r -= 1) e[r].animation.destroy(t);
                    }),
                    (t.freeze = function () {
                      a = !0;
                    }),
                    (t.unfreeze = function () {
                      (a = !1), d();
                    }),
                    (t.setVolume = function (t, r) {
                      var i;
                      for (i = 0; i < n; i += 1) e[i].animation.setVolume(t, r);
                    }),
                    (t.mute = function (t) {
                      var r;
                      for (r = 0; r < n; r += 1) e[r].animation.mute(t);
                    }),
                    (t.unmute = function (t) {
                      var r;
                      for (r = 0; r < n; r += 1) e[r].animation.unmute(t);
                    }),
                    (t.getRegisteredAnimations = function () {
                      var t,
                        r = e.length,
                        n = [];
                      for (t = 0; t < r; t += 1) n.push(e[t].animation);
                      return n;
                    }),
                    t
                  );
                })(),
                BezierFactory = (function () {
                  var t = {
                      getBezierEasing: function (t, r, n, i, o) {
                        var a = o || ('bez_' + t + '_' + r + '_' + n + '_' + i).replace(/\./g, 'p');
                        if (e[a]) return e[a];
                        var s = new c([t, r, n, i]);
                        return (e[a] = s), s;
                      },
                    },
                    e = {},
                    r = 0.1,
                    n = 'function' == typeof Float32Array;
                  function i(t, e) {
                    return 1 - 3 * e + 3 * t;
                  }
                  function o(t, e) {
                    return 3 * e - 6 * t;
                  }
                  function a(t) {
                    return 3 * t;
                  }
                  function s(t, e, r) {
                    return ((i(e, r) * t + o(e, r)) * t + a(e)) * t;
                  }
                  function l(t, e, r) {
                    return 3 * i(e, r) * t * t + 2 * o(e, r) * t + a(e);
                  }
                  function c(t) {
                    (this._p = t),
                      (this._mSampleValues = n ? new Float32Array(11) : new Array(11)),
                      (this._precomputed = !1),
                      (this.get = this.get.bind(this));
                  }
                  return (
                    (c.prototype = {
                      get: function (t) {
                        var e = this._p[0],
                          r = this._p[1],
                          n = this._p[2],
                          i = this._p[3];
                        return (
                          this._precomputed || this._precompute(),
                          e === r && n === i ? t : 0 === t ? 0 : 1 === t ? 1 : s(this._getTForX(t), r, i)
                        );
                      },
                      _precompute: function () {
                        var t = this._p[0],
                          e = this._p[1],
                          r = this._p[2],
                          n = this._p[3];
                        (this._precomputed = !0), (t === e && r === n) || this._calcSampleValues();
                      },
                      _calcSampleValues: function () {
                        for (var t = this._p[0], e = this._p[2], n = 0; n < 11; ++n)
                          this._mSampleValues[n] = s(n * r, t, e);
                      },
                      _getTForX: function (t) {
                        for (
                          var e = this._p[0], n = this._p[2], i = this._mSampleValues, o = 0, a = 1;
                          10 !== a && i[a] <= t;
                          ++a
                        )
                          o += r;
                        var c = o + ((t - i[--a]) / (i[a + 1] - i[a])) * r,
                          h = l(c, e, n);
                        return h >= 0.001
                          ? (function (t, e, r, n) {
                              for (var i = 0; i < 4; ++i) {
                                var o = l(e, r, n);
                                if (0 === o) return e;
                                e -= (s(e, r, n) - t) / o;
                              }
                              return e;
                            })(t, c, e, n)
                          : 0 === h
                          ? c
                          : (function (t, e, r, n, i) {
                              var o,
                                a,
                                l = 0;
                              do {
                                (o = s((a = e + (r - e) / 2), n, i) - t) > 0 ? (r = a) : (e = a);
                              } while (Math.abs(o) > 1e-7 && ++l < 10);
                              return a;
                            })(t, o, o + r, e, n);
                      },
                    }),
                    t
                  );
                })(),
                pooling = {
                  double: function (t) {
                    return t.concat(createSizedArray(t.length));
                  },
                },
                poolFactory = function (t, e, r) {
                  var n = 0,
                    i = t,
                    o = createSizedArray(i);
                  return {
                    newElement: function () {
                      return n ? o[(n -= 1)] : e();
                    },
                    release: function (t) {
                      n === i && ((o = pooling.double(o)), (i *= 2)), r && r(t), (o[n] = t), (n += 1);
                    },
                  };
                },
                bezierLengthPool = poolFactory(8, function () {
                  return {
                    addedLength: 0,
                    percents: createTypedArray('float32', getDefaultCurveSegments()),
                    lengths: createTypedArray('float32', getDefaultCurveSegments()),
                  };
                }),
                segmentsLengthPool = poolFactory(
                  8,
                  function () {
                    return { lengths: [], totalLength: 0 };
                  },
                  function (t) {
                    var e,
                      r = t.lengths.length;
                    for (e = 0; e < r; e += 1) bezierLengthPool.release(t.lengths[e]);
                    t.lengths.length = 0;
                  },
                );
              function bezFunction() {
                var t = Math;
                function e(t, e, r, n, i, o) {
                  var a = t * n + e * i + r * o - i * n - o * t - r * e;
                  return a > -0.001 && a < 0.001;
                }
                var r = function (t, e, r, n) {
                  var i,
                    o,
                    a,
                    s,
                    l,
                    c,
                    h = getDefaultCurveSegments(),
                    u = 0,
                    p = [],
                    f = [],
                    d = bezierLengthPool.newElement();
                  for (a = r.length, i = 0; i < h; i += 1) {
                    for (l = i / (h - 1), c = 0, o = 0; o < a; o += 1)
                      (s =
                        bmPow(1 - l, 3) * t[o] +
                        3 * bmPow(1 - l, 2) * l * r[o] +
                        3 * (1 - l) * bmPow(l, 2) * n[o] +
                        bmPow(l, 3) * e[o]),
                        (p[o] = s),
                        null !== f[o] && (c += bmPow(p[o] - f[o], 2)),
                        (f[o] = p[o]);
                    c && (u += c = bmSqrt(c)), (d.percents[i] = l), (d.lengths[i] = u);
                  }
                  return (d.addedLength = u), d;
                };
                function n(t) {
                  (this.segmentLength = 0), (this.points = new Array(t));
                }
                function i(t, e) {
                  (this.partialLength = t), (this.point = e);
                }
                var o,
                  a =
                    ((o = {}),
                    function (t, r, a, s) {
                      var l = (
                        t[0] +
                        '_' +
                        t[1] +
                        '_' +
                        r[0] +
                        '_' +
                        r[1] +
                        '_' +
                        a[0] +
                        '_' +
                        a[1] +
                        '_' +
                        s[0] +
                        '_' +
                        s[1]
                      ).replace(/\./g, 'p');
                      if (!o[l]) {
                        var c,
                          h,
                          u,
                          p,
                          f,
                          d,
                          m,
                          y = getDefaultCurveSegments(),
                          g = 0,
                          v = null;
                        2 === t.length &&
                          (t[0] !== r[0] || t[1] !== r[1]) &&
                          e(t[0], t[1], r[0], r[1], t[0] + a[0], t[1] + a[1]) &&
                          e(t[0], t[1], r[0], r[1], r[0] + s[0], r[1] + s[1]) &&
                          (y = 2);
                        var b = new n(y);
                        for (u = a.length, c = 0; c < y; c += 1) {
                          for (m = createSizedArray(u), f = c / (y - 1), d = 0, h = 0; h < u; h += 1)
                            (p =
                              bmPow(1 - f, 3) * t[h] +
                              3 * bmPow(1 - f, 2) * f * (t[h] + a[h]) +
                              3 * (1 - f) * bmPow(f, 2) * (r[h] + s[h]) +
                              bmPow(f, 3) * r[h]),
                              (m[h] = p),
                              null !== v && (d += bmPow(m[h] - v[h], 2));
                          (g += d = bmSqrt(d)), (b.points[c] = new i(d, m)), (v = m);
                        }
                        (b.segmentLength = g), (o[l] = b);
                      }
                      return o[l];
                    });
                function s(t, e) {
                  var r = e.percents,
                    n = e.lengths,
                    i = r.length,
                    o = bmFloor((i - 1) * t),
                    a = t * e.addedLength,
                    s = 0;
                  if (o === i - 1 || 0 === o || a === n[o]) return r[o];
                  for (var l = n[o] > a ? -1 : 1, c = !0; c; )
                    if (
                      (n[o] <= a && n[o + 1] > a ? ((s = (a - n[o]) / (n[o + 1] - n[o])), (c = !1)) : (o += l),
                      o < 0 || o >= i - 1)
                    ) {
                      if (o === i - 1) return r[o];
                      c = !1;
                    }
                  return r[o] + (r[o + 1] - r[o]) * s;
                }
                var l = createTypedArray('float32', 8);
                return {
                  getSegmentsLength: function (t) {
                    var e,
                      n = segmentsLengthPool.newElement(),
                      i = t.c,
                      o = t.v,
                      a = t.o,
                      s = t.i,
                      l = t._length,
                      c = n.lengths,
                      h = 0;
                    for (e = 0; e < l - 1; e += 1) (c[e] = r(o[e], o[e + 1], a[e], s[e + 1])), (h += c[e].addedLength);
                    return (
                      i && l && ((c[e] = r(o[e], o[0], a[e], s[0])), (h += c[e].addedLength)), (n.totalLength = h), n
                    );
                  },
                  getNewSegment: function (e, r, n, i, o, a, c) {
                    o < 0 ? (o = 0) : o > 1 && (o = 1);
                    var h,
                      u = s(o, c),
                      p = s((a = a > 1 ? 1 : a), c),
                      f = e.length,
                      d = 1 - u,
                      m = 1 - p,
                      y = d * d * d,
                      g = u * d * d * 3,
                      v = u * u * d * 3,
                      b = u * u * u,
                      x = d * d * m,
                      E = u * d * m + d * u * m + d * d * p,
                      w = u * u * m + d * u * p + u * d * p,
                      _ = u * u * p,
                      S = d * m * m,
                      P = u * m * m + d * p * m + d * m * p,
                      A = u * p * m + d * p * p + u * m * p,
                      C = u * p * p,
                      T = m * m * m,
                      k = p * m * m + m * p * m + m * m * p,
                      D = p * p * m + m * p * p + p * m * p,
                      M = p * p * p;
                    for (h = 0; h < f; h += 1)
                      (l[4 * h] = t.round(1e3 * (y * e[h] + g * n[h] + v * i[h] + b * r[h])) / 1e3),
                        (l[4 * h + 1] = t.round(1e3 * (x * e[h] + E * n[h] + w * i[h] + _ * r[h])) / 1e3),
                        (l[4 * h + 2] = t.round(1e3 * (S * e[h] + P * n[h] + A * i[h] + C * r[h])) / 1e3),
                        (l[4 * h + 3] = t.round(1e3 * (T * e[h] + k * n[h] + D * i[h] + M * r[h])) / 1e3);
                    return l;
                  },
                  getPointInSegment: function (e, r, n, i, o, a) {
                    var l = s(o, a),
                      c = 1 - l;
                    return [
                      t.round(
                        1e3 *
                          (c * c * c * e[0] +
                            (l * c * c + c * l * c + c * c * l) * n[0] +
                            (l * l * c + c * l * l + l * c * l) * i[0] +
                            l * l * l * r[0]),
                      ) / 1e3,
                      t.round(
                        1e3 *
                          (c * c * c * e[1] +
                            (l * c * c + c * l * c + c * c * l) * n[1] +
                            (l * l * c + c * l * l + l * c * l) * i[1] +
                            l * l * l * r[1]),
                      ) / 1e3,
                    ];
                  },
                  buildBezierData: a,
                  pointOnLine2D: e,
                  pointOnLine3D: function (r, n, i, o, a, s, l, c, h) {
                    if (0 === i && 0 === s && 0 === h) return e(r, n, o, a, l, c);
                    var u,
                      p = t.sqrt(t.pow(o - r, 2) + t.pow(a - n, 2) + t.pow(s - i, 2)),
                      f = t.sqrt(t.pow(l - r, 2) + t.pow(c - n, 2) + t.pow(h - i, 2)),
                      d = t.sqrt(t.pow(l - o, 2) + t.pow(c - a, 2) + t.pow(h - s, 2));
                    return (
                      (u = p > f ? (p > d ? p - f - d : d - f - p) : d > f ? d - f - p : f - p - d) > -1e-4 && u < 1e-4
                    );
                  },
                };
              }
              var bez = bezFunction(),
                PropertyFactory = (function () {
                  var t = initialDefaultFrame,
                    e = Math.abs;
                  function r(t, e) {
                    var r,
                      i = this.offsetTime;
                    'multidimensional' === this.propType && (r = createTypedArray('float32', this.pv.length));
                    for (
                      var o, a, s, l, c, h, u, p, f, d = e.lastIndex, m = d, y = this.keyframes.length - 1, g = !0;
                      g;

                    ) {
                      if (((o = this.keyframes[m]), (a = this.keyframes[m + 1]), m === y - 1 && t >= a.t - i)) {
                        o.h && (o = a), (d = 0);
                        break;
                      }
                      if (a.t - i > t) {
                        d = m;
                        break;
                      }
                      m < y - 1 ? (m += 1) : ((d = 0), (g = !1));
                    }
                    s = this.keyframesMetadata[m] || {};
                    var v,
                      b,
                      x,
                      E,
                      w,
                      _,
                      S,
                      P,
                      A,
                      C,
                      T = a.t - i,
                      k = o.t - i;
                    if (o.to) {
                      s.bezierData || (s.bezierData = bez.buildBezierData(o.s, a.s || o.e, o.to, o.ti));
                      var D = s.bezierData;
                      if (t >= T || t < k) {
                        var M = t >= T ? D.points.length - 1 : 0;
                        for (c = D.points[M].point.length, l = 0; l < c; l += 1) r[l] = D.points[M].point[l];
                      } else {
                        s.__fnct
                          ? (f = s.__fnct)
                          : ((f = BezierFactory.getBezierEasing(o.o.x, o.o.y, o.i.x, o.i.y, o.n).get), (s.__fnct = f)),
                          (h = f((t - k) / (T - k)));
                        var I,
                          F = D.segmentLength * h,
                          L = e.lastFrame < t && e._lastKeyframeIndex === m ? e._lastAddedLength : 0;
                        for (
                          p = e.lastFrame < t && e._lastKeyframeIndex === m ? e._lastPoint : 0,
                            g = !0,
                            u = D.points.length;
                          g;

                        ) {
                          if (((L += D.points[p].partialLength), 0 === F || 0 === h || p === D.points.length - 1)) {
                            for (c = D.points[p].point.length, l = 0; l < c; l += 1) r[l] = D.points[p].point[l];
                            break;
                          }
                          if (F >= L && F < L + D.points[p + 1].partialLength) {
                            for (
                              I = (F - L) / D.points[p + 1].partialLength, c = D.points[p].point.length, l = 0;
                              l < c;
                              l += 1
                            )
                              r[l] = D.points[p].point[l] + (D.points[p + 1].point[l] - D.points[p].point[l]) * I;
                            break;
                          }
                          p < u - 1 ? (p += 1) : (g = !1);
                        }
                        (e._lastPoint = p),
                          (e._lastAddedLength = L - D.points[p].partialLength),
                          (e._lastKeyframeIndex = m);
                      }
                    } else {
                      var R, O, B, j, N;
                      if (((y = o.s.length), (v = a.s || o.e), this.sh && 1 !== o.h))
                        t >= T
                          ? ((r[0] = v[0]), (r[1] = v[1]), (r[2] = v[2]))
                          : t <= k
                          ? ((r[0] = o.s[0]), (r[1] = o.s[1]), (r[2] = o.s[2]))
                          : ((b = r),
                            (x = (function (t, e, r) {
                              var n,
                                i,
                                o,
                                a,
                                s,
                                l = [],
                                c = t[0],
                                h = t[1],
                                u = t[2],
                                p = t[3],
                                f = e[0],
                                d = e[1],
                                m = e[2],
                                y = e[3];
                              return (
                                (i = c * f + h * d + u * m + p * y) < 0 &&
                                  ((i = -i), (f = -f), (d = -d), (m = -m), (y = -y)),
                                1 - i > 1e-6
                                  ? ((n = Math.acos(i)),
                                    (o = Math.sin(n)),
                                    (a = Math.sin((1 - r) * n) / o),
                                    (s = Math.sin(r * n) / o))
                                  : ((a = 1 - r), (s = r)),
                                (l[0] = a * c + s * f),
                                (l[1] = a * h + s * d),
                                (l[2] = a * u + s * m),
                                (l[3] = a * p + s * y),
                                l
                              );
                            })(n(o.s), n(v), (t - k) / (T - k))),
                            (E = x[0]),
                            (w = x[1]),
                            (_ = x[2]),
                            (S = x[3]),
                            (P = Math.atan2(2 * w * S - 2 * E * _, 1 - 2 * w * w - 2 * _ * _)),
                            (A = Math.asin(2 * E * w + 2 * _ * S)),
                            (C = Math.atan2(2 * E * S - 2 * w * _, 1 - 2 * E * E - 2 * _ * _)),
                            (b[0] = P / degToRads),
                            (b[1] = A / degToRads),
                            (b[2] = C / degToRads));
                      else
                        for (m = 0; m < y; m += 1)
                          1 !== o.h &&
                            (t >= T
                              ? (h = 1)
                              : t < k
                              ? (h = 0)
                              : (o.o.x.constructor === Array
                                  ? (s.__fnct || (s.__fnct = []),
                                    s.__fnct[m]
                                      ? (f = s.__fnct[m])
                                      : ((R = void 0 === o.o.x[m] ? o.o.x[0] : o.o.x[m]),
                                        (O = void 0 === o.o.y[m] ? o.o.y[0] : o.o.y[m]),
                                        (B = void 0 === o.i.x[m] ? o.i.x[0] : o.i.x[m]),
                                        (j = void 0 === o.i.y[m] ? o.i.y[0] : o.i.y[m]),
                                        (f = BezierFactory.getBezierEasing(R, O, B, j).get),
                                        (s.__fnct[m] = f)))
                                  : s.__fnct
                                  ? (f = s.__fnct)
                                  : ((R = o.o.x),
                                    (O = o.o.y),
                                    (B = o.i.x),
                                    (j = o.i.y),
                                    (f = BezierFactory.getBezierEasing(R, O, B, j).get),
                                    (o.keyframeMetadata = f)),
                                (h = f((t - k) / (T - k))))),
                            (v = a.s || o.e),
                            (N = 1 === o.h ? o.s[m] : o.s[m] + (v[m] - o.s[m]) * h),
                            'multidimensional' === this.propType ? (r[m] = N) : (r = N);
                    }
                    return (e.lastIndex = d), r;
                  }
                  function n(t) {
                    var e = t[0] * degToRads,
                      r = t[1] * degToRads,
                      n = t[2] * degToRads,
                      i = Math.cos(e / 2),
                      o = Math.cos(r / 2),
                      a = Math.cos(n / 2),
                      s = Math.sin(e / 2),
                      l = Math.sin(r / 2),
                      c = Math.sin(n / 2);
                    return [s * l * a + i * o * c, s * o * a + i * l * c, i * l * a - s * o * c, i * o * a - s * l * c];
                  }
                  function i() {
                    var e = this.comp.renderedFrame - this.offsetTime,
                      r = this.keyframes[0].t - this.offsetTime,
                      n = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
                    if (
                      !(
                        e === this._caching.lastFrame ||
                        (this._caching.lastFrame !== t &&
                          ((this._caching.lastFrame >= n && e >= n) || (this._caching.lastFrame < r && e < r)))
                      )
                    ) {
                      this._caching.lastFrame >= e &&
                        ((this._caching._lastKeyframeIndex = -1), (this._caching.lastIndex = 0));
                      var i = this.interpolateValue(e, this._caching);
                      this.pv = i;
                    }
                    return (this._caching.lastFrame = e), this.pv;
                  }
                  function o(t) {
                    var r;
                    if ('unidimensional' === this.propType)
                      (r = t * this.mult), e(this.v - r) > 1e-5 && ((this.v = r), (this._mdf = !0));
                    else
                      for (var n = 0, i = this.v.length; n < i; )
                        (r = t[n] * this.mult),
                          e(this.v[n] - r) > 1e-5 && ((this.v[n] = r), (this._mdf = !0)),
                          (n += 1);
                  }
                  function a() {
                    if (this.elem.globalData.frameId !== this.frameId && this.effectsSequence.length)
                      if (this.lock) this.setVValue(this.pv);
                      else {
                        var t;
                        (this.lock = !0), (this._mdf = this._isFirstFrame);
                        var e = this.effectsSequence.length,
                          r = this.kf ? this.pv : this.data.k;
                        for (t = 0; t < e; t += 1) r = this.effectsSequence[t](r);
                        this.setVValue(r),
                          (this._isFirstFrame = !1),
                          (this.lock = !1),
                          (this.frameId = this.elem.globalData.frameId);
                      }
                  }
                  function s(t) {
                    this.effectsSequence.push(t), this.container.addDynamicProperty(this);
                  }
                  function l(t, e, r, n) {
                    (this.propType = 'unidimensional'),
                      (this.mult = r || 1),
                      (this.data = e),
                      (this.v = r ? e.k * r : e.k),
                      (this.pv = e.k),
                      (this._mdf = !1),
                      (this.elem = t),
                      (this.container = n),
                      (this.comp = t.comp),
                      (this.k = !1),
                      (this.kf = !1),
                      (this.vel = 0),
                      (this.effectsSequence = []),
                      (this._isFirstFrame = !0),
                      (this.getValue = a),
                      (this.setVValue = o),
                      (this.addEffect = s);
                  }
                  function c(t, e, r, n) {
                    var i;
                    (this.propType = 'multidimensional'),
                      (this.mult = r || 1),
                      (this.data = e),
                      (this._mdf = !1),
                      (this.elem = t),
                      (this.container = n),
                      (this.comp = t.comp),
                      (this.k = !1),
                      (this.kf = !1),
                      (this.frameId = -1);
                    var l = e.k.length;
                    for (
                      this.v = createTypedArray('float32', l),
                        this.pv = createTypedArray('float32', l),
                        this.vel = createTypedArray('float32', l),
                        i = 0;
                      i < l;
                      i += 1
                    )
                      (this.v[i] = e.k[i] * this.mult), (this.pv[i] = e.k[i]);
                    (this._isFirstFrame = !0),
                      (this.effectsSequence = []),
                      (this.getValue = a),
                      (this.setVValue = o),
                      (this.addEffect = s);
                  }
                  function h(e, n, l, c) {
                    (this.propType = 'unidimensional'),
                      (this.keyframes = n.k),
                      (this.keyframesMetadata = []),
                      (this.offsetTime = e.data.st),
                      (this.frameId = -1),
                      (this._caching = { lastFrame: t, lastIndex: 0, value: 0, _lastKeyframeIndex: -1 }),
                      (this.k = !0),
                      (this.kf = !0),
                      (this.data = n),
                      (this.mult = l || 1),
                      (this.elem = e),
                      (this.container = c),
                      (this.comp = e.comp),
                      (this.v = t),
                      (this.pv = t),
                      (this._isFirstFrame = !0),
                      (this.getValue = a),
                      (this.setVValue = o),
                      (this.interpolateValue = r),
                      (this.effectsSequence = [i.bind(this)]),
                      (this.addEffect = s);
                  }
                  function u(e, n, l, c) {
                    var h;
                    this.propType = 'multidimensional';
                    var u,
                      p,
                      f,
                      d,
                      m = n.k.length;
                    for (h = 0; h < m - 1; h += 1)
                      n.k[h].to &&
                        n.k[h].s &&
                        n.k[h + 1] &&
                        n.k[h + 1].s &&
                        ((u = n.k[h].s),
                        (p = n.k[h + 1].s),
                        (f = n.k[h].to),
                        (d = n.k[h].ti),
                        ((2 === u.length &&
                          (u[0] !== p[0] || u[1] !== p[1]) &&
                          bez.pointOnLine2D(u[0], u[1], p[0], p[1], u[0] + f[0], u[1] + f[1]) &&
                          bez.pointOnLine2D(u[0], u[1], p[0], p[1], p[0] + d[0], p[1] + d[1])) ||
                          (3 === u.length &&
                            (u[0] !== p[0] || u[1] !== p[1] || u[2] !== p[2]) &&
                            bez.pointOnLine3D(
                              u[0],
                              u[1],
                              u[2],
                              p[0],
                              p[1],
                              p[2],
                              u[0] + f[0],
                              u[1] + f[1],
                              u[2] + f[2],
                            ) &&
                            bez.pointOnLine3D(
                              u[0],
                              u[1],
                              u[2],
                              p[0],
                              p[1],
                              p[2],
                              p[0] + d[0],
                              p[1] + d[1],
                              p[2] + d[2],
                            ))) &&
                          ((n.k[h].to = null), (n.k[h].ti = null)),
                        u[0] === p[0] &&
                          u[1] === p[1] &&
                          0 === f[0] &&
                          0 === f[1] &&
                          0 === d[0] &&
                          0 === d[1] &&
                          (2 === u.length || (u[2] === p[2] && 0 === f[2] && 0 === d[2])) &&
                          ((n.k[h].to = null), (n.k[h].ti = null)));
                    (this.effectsSequence = [i.bind(this)]),
                      (this.data = n),
                      (this.keyframes = n.k),
                      (this.keyframesMetadata = []),
                      (this.offsetTime = e.data.st),
                      (this.k = !0),
                      (this.kf = !0),
                      (this._isFirstFrame = !0),
                      (this.mult = l || 1),
                      (this.elem = e),
                      (this.container = c),
                      (this.comp = e.comp),
                      (this.getValue = a),
                      (this.setVValue = o),
                      (this.interpolateValue = r),
                      (this.frameId = -1);
                    var y = n.k[0].s.length;
                    for (
                      this.v = createTypedArray('float32', y), this.pv = createTypedArray('float32', y), h = 0;
                      h < y;
                      h += 1
                    )
                      (this.v[h] = t), (this.pv[h] = t);
                    (this._caching = { lastFrame: t, lastIndex: 0, value: createTypedArray('float32', y) }),
                      (this.addEffect = s);
                  }
                  var p = {
                    getProp: function (t, e, r, n, i) {
                      var o;
                      if (e.k.length)
                        if ('number' == typeof e.k[0]) o = new c(t, e, n, i);
                        else
                          switch (r) {
                            case 0:
                              o = new h(t, e, n, i);
                              break;
                            case 1:
                              o = new u(t, e, n, i);
                          }
                      else o = new l(t, e, n, i);
                      return o.effectsSequence.length && i.addDynamicProperty(o), o;
                    },
                  };
                  return p;
                })();
              function DynamicPropertyContainer() {}
              DynamicPropertyContainer.prototype = {
                addDynamicProperty: function (t) {
                  -1 === this.dynamicProperties.indexOf(t) &&
                    (this.dynamicProperties.push(t), this.container.addDynamicProperty(this), (this._isAnimated = !0));
                },
                iterateDynamicProperties: function () {
                  var t;
                  this._mdf = !1;
                  var e = this.dynamicProperties.length;
                  for (t = 0; t < e; t += 1)
                    this.dynamicProperties[t].getValue(), this.dynamicProperties[t]._mdf && (this._mdf = !0);
                },
                initDynamicPropertyContainer: function (t) {
                  (this.container = t), (this.dynamicProperties = []), (this._mdf = !1), (this._isAnimated = !1);
                },
              };
              var pointPool = poolFactory(8, function () {
                return createTypedArray('float32', 2);
              });
              function ShapePath() {
                (this.c = !1),
                  (this._length = 0),
                  (this._maxLength = 8),
                  (this.v = createSizedArray(this._maxLength)),
                  (this.o = createSizedArray(this._maxLength)),
                  (this.i = createSizedArray(this._maxLength));
              }
              (ShapePath.prototype.setPathData = function (t, e) {
                (this.c = t), this.setLength(e);
                for (var r = 0; r < e; )
                  (this.v[r] = pointPool.newElement()),
                    (this.o[r] = pointPool.newElement()),
                    (this.i[r] = pointPool.newElement()),
                    (r += 1);
              }),
                (ShapePath.prototype.setLength = function (t) {
                  for (; this._maxLength < t; ) this.doubleArrayLength();
                  this._length = t;
                }),
                (ShapePath.prototype.doubleArrayLength = function () {
                  (this.v = this.v.concat(createSizedArray(this._maxLength))),
                    (this.i = this.i.concat(createSizedArray(this._maxLength))),
                    (this.o = this.o.concat(createSizedArray(this._maxLength))),
                    (this._maxLength *= 2);
                }),
                (ShapePath.prototype.setXYAt = function (t, e, r, n, i) {
                  var o;
                  switch (
                    ((this._length = Math.max(this._length, n + 1)),
                    this._length >= this._maxLength && this.doubleArrayLength(),
                    r)
                  ) {
                    case 'v':
                      o = this.v;
                      break;
                    case 'i':
                      o = this.i;
                      break;
                    case 'o':
                      o = this.o;
                      break;
                    default:
                      o = [];
                  }
                  (!o[n] || (o[n] && !i)) && (o[n] = pointPool.newElement()), (o[n][0] = t), (o[n][1] = e);
                }),
                (ShapePath.prototype.setTripleAt = function (t, e, r, n, i, o, a, s) {
                  this.setXYAt(t, e, 'v', a, s), this.setXYAt(r, n, 'o', a, s), this.setXYAt(i, o, 'i', a, s);
                }),
                (ShapePath.prototype.reverse = function () {
                  var t = new ShapePath();
                  t.setPathData(this.c, this._length);
                  var e = this.v,
                    r = this.o,
                    n = this.i,
                    i = 0;
                  this.c && (t.setTripleAt(e[0][0], e[0][1], n[0][0], n[0][1], r[0][0], r[0][1], 0, !1), (i = 1));
                  var o,
                    a = this._length - 1,
                    s = this._length;
                  for (o = i; o < s; o += 1)
                    t.setTripleAt(e[a][0], e[a][1], n[a][0], n[a][1], r[a][0], r[a][1], o, !1), (a -= 1);
                  return t;
                }),
                (ShapePath.prototype.length = function () {
                  return this._length;
                });
              var shapePool =
                  ((factory = poolFactory(
                    4,
                    function () {
                      return new ShapePath();
                    },
                    function (t) {
                      var e,
                        r = t._length;
                      for (e = 0; e < r; e += 1)
                        pointPool.release(t.v[e]),
                          pointPool.release(t.i[e]),
                          pointPool.release(t.o[e]),
                          (t.v[e] = null),
                          (t.i[e] = null),
                          (t.o[e] = null);
                      (t._length = 0), (t.c = !1);
                    },
                  )),
                  (factory.clone = function (t) {
                    var e,
                      r = factory.newElement(),
                      n = void 0 === t._length ? t.v.length : t._length;
                    for (r.setLength(n), r.c = t.c, e = 0; e < n; e += 1)
                      r.setTripleAt(t.v[e][0], t.v[e][1], t.o[e][0], t.o[e][1], t.i[e][0], t.i[e][1], e);
                    return r;
                  }),
                  factory),
                factory;
              function ShapeCollection() {
                (this._length = 0), (this._maxLength = 4), (this.shapes = createSizedArray(this._maxLength));
              }
              (ShapeCollection.prototype.addShape = function (t) {
                this._length === this._maxLength &&
                  ((this.shapes = this.shapes.concat(createSizedArray(this._maxLength))), (this._maxLength *= 2)),
                  (this.shapes[this._length] = t),
                  (this._length += 1);
              }),
                (ShapeCollection.prototype.releaseShapes = function () {
                  var t;
                  for (t = 0; t < this._length; t += 1) shapePool.release(this.shapes[t]);
                  this._length = 0;
                });
              var shapeCollectionPool =
                  ((ob = {
                    newShapeCollection: function () {
                      return _length ? pool[(_length -= 1)] : new ShapeCollection();
                    },
                    release: function (t) {
                      var e,
                        r = t._length;
                      for (e = 0; e < r; e += 1) shapePool.release(t.shapes[e]);
                      (t._length = 0),
                        _length === _maxLength && ((pool = pooling.double(pool)), (_maxLength *= 2)),
                        (pool[_length] = t),
                        (_length += 1);
                    },
                  }),
                  (_length = 0),
                  (_maxLength = 4),
                  (pool = createSizedArray(_maxLength)),
                  ob),
                ob,
                _length,
                _maxLength,
                pool,
                ShapePropertyFactory = (function () {
                  var t = -999999;
                  function e(t, e, r) {
                    var n,
                      i,
                      o,
                      a,
                      s,
                      l,
                      c,
                      h,
                      u,
                      p = r.lastIndex,
                      f = this.keyframes;
                    if (t < f[0].t - this.offsetTime) (n = f[0].s[0]), (o = !0), (p = 0);
                    else if (t >= f[f.length - 1].t - this.offsetTime)
                      (n = f[f.length - 1].s ? f[f.length - 1].s[0] : f[f.length - 2].e[0]), (o = !0);
                    else {
                      for (
                        var d, m, y, g = p, v = f.length - 1, b = !0;
                        b && ((d = f[g]), !((m = f[g + 1]).t - this.offsetTime > t));

                      )
                        g < v - 1 ? (g += 1) : (b = !1);
                      if (((y = this.keyframesMetadata[g] || {}), (p = g), !(o = 1 === d.h))) {
                        if (t >= m.t - this.offsetTime) h = 1;
                        else if (t < d.t - this.offsetTime) h = 0;
                        else {
                          var x;
                          y.__fnct
                            ? (x = y.__fnct)
                            : ((x = BezierFactory.getBezierEasing(d.o.x, d.o.y, d.i.x, d.i.y).get), (y.__fnct = x)),
                            (h = x((t - (d.t - this.offsetTime)) / (m.t - this.offsetTime - (d.t - this.offsetTime))));
                        }
                        i = m.s ? m.s[0] : d.e[0];
                      }
                      n = d.s[0];
                    }
                    for (l = e._length, c = n.i[0].length, r.lastIndex = p, a = 0; a < l; a += 1)
                      for (s = 0; s < c; s += 1)
                        (u = o ? n.i[a][s] : n.i[a][s] + (i.i[a][s] - n.i[a][s]) * h),
                          (e.i[a][s] = u),
                          (u = o ? n.o[a][s] : n.o[a][s] + (i.o[a][s] - n.o[a][s]) * h),
                          (e.o[a][s] = u),
                          (u = o ? n.v[a][s] : n.v[a][s] + (i.v[a][s] - n.v[a][s]) * h),
                          (e.v[a][s] = u);
                  }
                  function r() {
                    var e = this.comp.renderedFrame - this.offsetTime,
                      r = this.keyframes[0].t - this.offsetTime,
                      n = this.keyframes[this.keyframes.length - 1].t - this.offsetTime,
                      i = this._caching.lastFrame;
                    return (
                      (i !== t && ((i < r && e < r) || (i > n && e > n))) ||
                        ((this._caching.lastIndex = i < e ? this._caching.lastIndex : 0),
                        this.interpolateShape(e, this.pv, this._caching)),
                      (this._caching.lastFrame = e),
                      this.pv
                    );
                  }
                  function n() {
                    this.paths = this.localShapeCollection;
                  }
                  function i(t) {
                    (function (t, e) {
                      if (t._length !== e._length || t.c !== e.c) return !1;
                      var r,
                        n = t._length;
                      for (r = 0; r < n; r += 1)
                        if (
                          t.v[r][0] !== e.v[r][0] ||
                          t.v[r][1] !== e.v[r][1] ||
                          t.o[r][0] !== e.o[r][0] ||
                          t.o[r][1] !== e.o[r][1] ||
                          t.i[r][0] !== e.i[r][0] ||
                          t.i[r][1] !== e.i[r][1]
                        )
                          return !1;
                      return !0;
                    })(this.v, t) ||
                      ((this.v = shapePool.clone(t)),
                      this.localShapeCollection.releaseShapes(),
                      this.localShapeCollection.addShape(this.v),
                      (this._mdf = !0),
                      (this.paths = this.localShapeCollection));
                  }
                  function o() {
                    if (this.elem.globalData.frameId !== this.frameId)
                      if (this.effectsSequence.length)
                        if (this.lock) this.setVValue(this.pv);
                        else {
                          var t, e;
                          (this.lock = !0),
                            (this._mdf = !1),
                            (t = this.kf ? this.pv : this.data.ks ? this.data.ks.k : this.data.pt.k);
                          var r = this.effectsSequence.length;
                          for (e = 0; e < r; e += 1) t = this.effectsSequence[e](t);
                          this.setVValue(t), (this.lock = !1), (this.frameId = this.elem.globalData.frameId);
                        }
                      else this._mdf = !1;
                  }
                  function a(t, e, r) {
                    (this.propType = 'shape'),
                      (this.comp = t.comp),
                      (this.container = t),
                      (this.elem = t),
                      (this.data = e),
                      (this.k = !1),
                      (this.kf = !1),
                      (this._mdf = !1);
                    var i = 3 === r ? e.pt.k : e.ks.k;
                    (this.v = shapePool.clone(i)),
                      (this.pv = shapePool.clone(this.v)),
                      (this.localShapeCollection = shapeCollectionPool.newShapeCollection()),
                      (this.paths = this.localShapeCollection),
                      this.paths.addShape(this.v),
                      (this.reset = n),
                      (this.effectsSequence = []);
                  }
                  function s(t) {
                    this.effectsSequence.push(t), this.container.addDynamicProperty(this);
                  }
                  function l(e, i, o) {
                    (this.propType = 'shape'),
                      (this.comp = e.comp),
                      (this.elem = e),
                      (this.container = e),
                      (this.offsetTime = e.data.st),
                      (this.keyframes = 3 === o ? i.pt.k : i.ks.k),
                      (this.keyframesMetadata = []),
                      (this.k = !0),
                      (this.kf = !0);
                    var a = this.keyframes[0].s[0].i.length;
                    (this.v = shapePool.newElement()),
                      this.v.setPathData(this.keyframes[0].s[0].c, a),
                      (this.pv = shapePool.clone(this.v)),
                      (this.localShapeCollection = shapeCollectionPool.newShapeCollection()),
                      (this.paths = this.localShapeCollection),
                      this.paths.addShape(this.v),
                      (this.lastFrame = t),
                      (this.reset = n),
                      (this._caching = { lastFrame: t, lastIndex: 0 }),
                      (this.effectsSequence = [r.bind(this)]);
                  }
                  (a.prototype.interpolateShape = e),
                    (a.prototype.getValue = o),
                    (a.prototype.setVValue = i),
                    (a.prototype.addEffect = s),
                    (l.prototype.getValue = o),
                    (l.prototype.interpolateShape = e),
                    (l.prototype.setVValue = i),
                    (l.prototype.addEffect = s);
                  var c = (function () {
                      var t = roundCorner;
                      function e(t, e) {
                        (this.v = shapePool.newElement()),
                          this.v.setPathData(!0, 4),
                          (this.localShapeCollection = shapeCollectionPool.newShapeCollection()),
                          (this.paths = this.localShapeCollection),
                          this.localShapeCollection.addShape(this.v),
                          (this.d = e.d),
                          (this.elem = t),
                          (this.comp = t.comp),
                          (this.frameId = -1),
                          this.initDynamicPropertyContainer(t),
                          (this.p = PropertyFactory.getProp(t, e.p, 1, 0, this)),
                          (this.s = PropertyFactory.getProp(t, e.s, 1, 0, this)),
                          this.dynamicProperties.length ? (this.k = !0) : ((this.k = !1), this.convertEllToPath());
                      }
                      return (
                        (e.prototype = {
                          reset: n,
                          getValue: function () {
                            this.elem.globalData.frameId !== this.frameId &&
                              ((this.frameId = this.elem.globalData.frameId),
                              this.iterateDynamicProperties(),
                              this._mdf && this.convertEllToPath());
                          },
                          convertEllToPath: function () {
                            var e = this.p.v[0],
                              r = this.p.v[1],
                              n = this.s.v[0] / 2,
                              i = this.s.v[1] / 2,
                              o = 3 !== this.d,
                              a = this.v;
                            (a.v[0][0] = e),
                              (a.v[0][1] = r - i),
                              (a.v[1][0] = o ? e + n : e - n),
                              (a.v[1][1] = r),
                              (a.v[2][0] = e),
                              (a.v[2][1] = r + i),
                              (a.v[3][0] = o ? e - n : e + n),
                              (a.v[3][1] = r),
                              (a.i[0][0] = o ? e - n * t : e + n * t),
                              (a.i[0][1] = r - i),
                              (a.i[1][0] = o ? e + n : e - n),
                              (a.i[1][1] = r - i * t),
                              (a.i[2][0] = o ? e + n * t : e - n * t),
                              (a.i[2][1] = r + i),
                              (a.i[3][0] = o ? e - n : e + n),
                              (a.i[3][1] = r + i * t),
                              (a.o[0][0] = o ? e + n * t : e - n * t),
                              (a.o[0][1] = r - i),
                              (a.o[1][0] = o ? e + n : e - n),
                              (a.o[1][1] = r + i * t),
                              (a.o[2][0] = o ? e - n * t : e + n * t),
                              (a.o[2][1] = r + i),
                              (a.o[3][0] = o ? e - n : e + n),
                              (a.o[3][1] = r - i * t);
                          },
                        }),
                        extendPrototype([DynamicPropertyContainer], e),
                        e
                      );
                    })(),
                    h = (function () {
                      function t(t, e) {
                        (this.v = shapePool.newElement()),
                          this.v.setPathData(!0, 0),
                          (this.elem = t),
                          (this.comp = t.comp),
                          (this.data = e),
                          (this.frameId = -1),
                          (this.d = e.d),
                          this.initDynamicPropertyContainer(t),
                          1 === e.sy
                            ? ((this.ir = PropertyFactory.getProp(t, e.ir, 0, 0, this)),
                              (this.is = PropertyFactory.getProp(t, e.is, 0, 0.01, this)),
                              (this.convertToPath = this.convertStarToPath))
                            : (this.convertToPath = this.convertPolygonToPath),
                          (this.pt = PropertyFactory.getProp(t, e.pt, 0, 0, this)),
                          (this.p = PropertyFactory.getProp(t, e.p, 1, 0, this)),
                          (this.r = PropertyFactory.getProp(t, e.r, 0, degToRads, this)),
                          (this.or = PropertyFactory.getProp(t, e.or, 0, 0, this)),
                          (this.os = PropertyFactory.getProp(t, e.os, 0, 0.01, this)),
                          (this.localShapeCollection = shapeCollectionPool.newShapeCollection()),
                          this.localShapeCollection.addShape(this.v),
                          (this.paths = this.localShapeCollection),
                          this.dynamicProperties.length ? (this.k = !0) : ((this.k = !1), this.convertToPath());
                      }
                      return (
                        (t.prototype = {
                          reset: n,
                          getValue: function () {
                            this.elem.globalData.frameId !== this.frameId &&
                              ((this.frameId = this.elem.globalData.frameId),
                              this.iterateDynamicProperties(),
                              this._mdf && this.convertToPath());
                          },
                          convertStarToPath: function () {
                            var t,
                              e,
                              r,
                              n,
                              i = 2 * Math.floor(this.pt.v),
                              o = (2 * Math.PI) / i,
                              a = !0,
                              s = this.or.v,
                              l = this.ir.v,
                              c = this.os.v,
                              h = this.is.v,
                              u = (2 * Math.PI * s) / (2 * i),
                              p = (2 * Math.PI * l) / (2 * i),
                              f = -Math.PI / 2;
                            f += this.r.v;
                            var d = 3 === this.data.d ? -1 : 1;
                            for (this.v._length = 0, t = 0; t < i; t += 1) {
                              (r = a ? c : h), (n = a ? u : p);
                              var m = (e = a ? s : l) * Math.cos(f),
                                y = e * Math.sin(f),
                                g = 0 === m && 0 === y ? 0 : y / Math.sqrt(m * m + y * y),
                                v = 0 === m && 0 === y ? 0 : -m / Math.sqrt(m * m + y * y);
                              (m += +this.p.v[0]),
                                (y += +this.p.v[1]),
                                this.v.setTripleAt(
                                  m,
                                  y,
                                  m - g * n * r * d,
                                  y - v * n * r * d,
                                  m + g * n * r * d,
                                  y + v * n * r * d,
                                  t,
                                  !0,
                                ),
                                (a = !a),
                                (f += o * d);
                            }
                          },
                          convertPolygonToPath: function () {
                            var t,
                              e = Math.floor(this.pt.v),
                              r = (2 * Math.PI) / e,
                              n = this.or.v,
                              i = this.os.v,
                              o = (2 * Math.PI * n) / (4 * e),
                              a = 0.5 * -Math.PI,
                              s = 3 === this.data.d ? -1 : 1;
                            for (a += this.r.v, this.v._length = 0, t = 0; t < e; t += 1) {
                              var l = n * Math.cos(a),
                                c = n * Math.sin(a),
                                h = 0 === l && 0 === c ? 0 : c / Math.sqrt(l * l + c * c),
                                u = 0 === l && 0 === c ? 0 : -l / Math.sqrt(l * l + c * c);
                              (l += +this.p.v[0]),
                                (c += +this.p.v[1]),
                                this.v.setTripleAt(
                                  l,
                                  c,
                                  l - h * o * i * s,
                                  c - u * o * i * s,
                                  l + h * o * i * s,
                                  c + u * o * i * s,
                                  t,
                                  !0,
                                ),
                                (a += r * s);
                            }
                            (this.paths.length = 0), (this.paths[0] = this.v);
                          },
                        }),
                        extendPrototype([DynamicPropertyContainer], t),
                        t
                      );
                    })(),
                    u = (function () {
                      function t(t, e) {
                        (this.v = shapePool.newElement()),
                          (this.v.c = !0),
                          (this.localShapeCollection = shapeCollectionPool.newShapeCollection()),
                          this.localShapeCollection.addShape(this.v),
                          (this.paths = this.localShapeCollection),
                          (this.elem = t),
                          (this.comp = t.comp),
                          (this.frameId = -1),
                          (this.d = e.d),
                          this.initDynamicPropertyContainer(t),
                          (this.p = PropertyFactory.getProp(t, e.p, 1, 0, this)),
                          (this.s = PropertyFactory.getProp(t, e.s, 1, 0, this)),
                          (this.r = PropertyFactory.getProp(t, e.r, 0, 0, this)),
                          this.dynamicProperties.length ? (this.k = !0) : ((this.k = !1), this.convertRectToPath());
                      }
                      return (
                        (t.prototype = {
                          convertRectToPath: function () {
                            var t = this.p.v[0],
                              e = this.p.v[1],
                              r = this.s.v[0] / 2,
                              n = this.s.v[1] / 2,
                              i = bmMin(r, n, this.r.v),
                              o = i * (1 - roundCorner);
                            (this.v._length = 0),
                              2 === this.d || 1 === this.d
                                ? (this.v.setTripleAt(t + r, e - n + i, t + r, e - n + i, t + r, e - n + o, 0, !0),
                                  this.v.setTripleAt(t + r, e + n - i, t + r, e + n - o, t + r, e + n - i, 1, !0),
                                  0 !== i
                                    ? (this.v.setTripleAt(t + r - i, e + n, t + r - i, e + n, t + r - o, e + n, 2, !0),
                                      this.v.setTripleAt(t - r + i, e + n, t - r + o, e + n, t - r + i, e + n, 3, !0),
                                      this.v.setTripleAt(t - r, e + n - i, t - r, e + n - i, t - r, e + n - o, 4, !0),
                                      this.v.setTripleAt(t - r, e - n + i, t - r, e - n + o, t - r, e - n + i, 5, !0),
                                      this.v.setTripleAt(t - r + i, e - n, t - r + i, e - n, t - r + o, e - n, 6, !0),
                                      this.v.setTripleAt(t + r - i, e - n, t + r - o, e - n, t + r - i, e - n, 7, !0))
                                    : (this.v.setTripleAt(t - r, e + n, t - r + o, e + n, t - r, e + n, 2),
                                      this.v.setTripleAt(t - r, e - n, t - r, e - n + o, t - r, e - n, 3)))
                                : (this.v.setTripleAt(t + r, e - n + i, t + r, e - n + o, t + r, e - n + i, 0, !0),
                                  0 !== i
                                    ? (this.v.setTripleAt(t + r - i, e - n, t + r - i, e - n, t + r - o, e - n, 1, !0),
                                      this.v.setTripleAt(t - r + i, e - n, t - r + o, e - n, t - r + i, e - n, 2, !0),
                                      this.v.setTripleAt(t - r, e - n + i, t - r, e - n + i, t - r, e - n + o, 3, !0),
                                      this.v.setTripleAt(t - r, e + n - i, t - r, e + n - o, t - r, e + n - i, 4, !0),
                                      this.v.setTripleAt(t - r + i, e + n, t - r + i, e + n, t - r + o, e + n, 5, !0),
                                      this.v.setTripleAt(t + r - i, e + n, t + r - o, e + n, t + r - i, e + n, 6, !0),
                                      this.v.setTripleAt(t + r, e + n - i, t + r, e + n - i, t + r, e + n - o, 7, !0))
                                    : (this.v.setTripleAt(t - r, e - n, t - r + o, e - n, t - r, e - n, 1, !0),
                                      this.v.setTripleAt(t - r, e + n, t - r, e + n - o, t - r, e + n, 2, !0),
                                      this.v.setTripleAt(t + r, e + n, t + r - o, e + n, t + r, e + n, 3, !0)));
                          },
                          getValue: function () {
                            this.elem.globalData.frameId !== this.frameId &&
                              ((this.frameId = this.elem.globalData.frameId),
                              this.iterateDynamicProperties(),
                              this._mdf && this.convertRectToPath());
                          },
                          reset: n,
                        }),
                        extendPrototype([DynamicPropertyContainer], t),
                        t
                      );
                    })(),
                    p = {
                      getShapeProp: function (t, e, r) {
                        var n;
                        return (
                          3 === r || 4 === r
                            ? (n = (3 === r ? e.pt : e.ks).k.length ? new l(t, e, r) : new a(t, e, r))
                            : 5 === r
                            ? (n = new u(t, e))
                            : 6 === r
                            ? (n = new c(t, e))
                            : 7 === r && (n = new h(t, e)),
                          n.k && t.addDynamicProperty(n),
                          n
                        );
                      },
                      getConstructorFunction: function () {
                        return a;
                      },
                      getKeyframedConstructorFunction: function () {
                        return l;
                      },
                    };
                  return p;
                })(),
                Matrix = (function () {
                  var t = Math.cos,
                    e = Math.sin,
                    r = Math.tan,
                    n = Math.round;
                  function i() {
                    return (
                      (this.props[0] = 1),
                      (this.props[1] = 0),
                      (this.props[2] = 0),
                      (this.props[3] = 0),
                      (this.props[4] = 0),
                      (this.props[5] = 1),
                      (this.props[6] = 0),
                      (this.props[7] = 0),
                      (this.props[8] = 0),
                      (this.props[9] = 0),
                      (this.props[10] = 1),
                      (this.props[11] = 0),
                      (this.props[12] = 0),
                      (this.props[13] = 0),
                      (this.props[14] = 0),
                      (this.props[15] = 1),
                      this
                    );
                  }
                  function o(r) {
                    if (0 === r) return this;
                    var n = t(r),
                      i = e(r);
                    return this._t(n, -i, 0, 0, i, n, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
                  }
                  function a(r) {
                    if (0 === r) return this;
                    var n = t(r),
                      i = e(r);
                    return this._t(1, 0, 0, 0, 0, n, -i, 0, 0, i, n, 0, 0, 0, 0, 1);
                  }
                  function s(r) {
                    if (0 === r) return this;
                    var n = t(r),
                      i = e(r);
                    return this._t(n, 0, i, 0, 0, 1, 0, 0, -i, 0, n, 0, 0, 0, 0, 1);
                  }
                  function l(r) {
                    if (0 === r) return this;
                    var n = t(r),
                      i = e(r);
                    return this._t(n, -i, 0, 0, i, n, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
                  }
                  function c(t, e) {
                    return this._t(1, e, t, 1, 0, 0);
                  }
                  function h(t, e) {
                    return this.shear(r(t), r(e));
                  }
                  function u(n, i) {
                    var o = t(i),
                      a = e(i);
                    return this._t(o, a, 0, 0, -a, o, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)
                      ._t(1, 0, 0, 0, r(n), 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)
                      ._t(o, -a, 0, 0, a, o, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
                  }
                  function p(t, e, r) {
                    return (
                      r || 0 === r || (r = 1),
                      1 === t && 1 === e && 1 === r ? this : this._t(t, 0, 0, 0, 0, e, 0, 0, 0, 0, r, 0, 0, 0, 0, 1)
                    );
                  }
                  function f(t, e, r, n, i, o, a, s, l, c, h, u, p, f, d, m) {
                    return (
                      (this.props[0] = t),
                      (this.props[1] = e),
                      (this.props[2] = r),
                      (this.props[3] = n),
                      (this.props[4] = i),
                      (this.props[5] = o),
                      (this.props[6] = a),
                      (this.props[7] = s),
                      (this.props[8] = l),
                      (this.props[9] = c),
                      (this.props[10] = h),
                      (this.props[11] = u),
                      (this.props[12] = p),
                      (this.props[13] = f),
                      (this.props[14] = d),
                      (this.props[15] = m),
                      this
                    );
                  }
                  function d(t, e, r) {
                    return (
                      (r = r || 0),
                      0 !== t || 0 !== e || 0 !== r ? this._t(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, t, e, r, 1) : this
                    );
                  }
                  function m(t, e, r, n, i, o, a, s, l, c, h, u, p, f, d, m) {
                    var y = this.props;
                    if (
                      1 === t &&
                      0 === e &&
                      0 === r &&
                      0 === n &&
                      0 === i &&
                      1 === o &&
                      0 === a &&
                      0 === s &&
                      0 === l &&
                      0 === c &&
                      1 === h &&
                      0 === u
                    )
                      return (
                        (y[12] = y[12] * t + y[15] * p),
                        (y[13] = y[13] * o + y[15] * f),
                        (y[14] = y[14] * h + y[15] * d),
                        (y[15] *= m),
                        (this._identityCalculated = !1),
                        this
                      );
                    var g = y[0],
                      v = y[1],
                      b = y[2],
                      x = y[3],
                      E = y[4],
                      w = y[5],
                      _ = y[6],
                      S = y[7],
                      P = y[8],
                      A = y[9],
                      C = y[10],
                      T = y[11],
                      k = y[12],
                      D = y[13],
                      M = y[14],
                      I = y[15];
                    return (
                      (y[0] = g * t + v * i + b * l + x * p),
                      (y[1] = g * e + v * o + b * c + x * f),
                      (y[2] = g * r + v * a + b * h + x * d),
                      (y[3] = g * n + v * s + b * u + x * m),
                      (y[4] = E * t + w * i + _ * l + S * p),
                      (y[5] = E * e + w * o + _ * c + S * f),
                      (y[6] = E * r + w * a + _ * h + S * d),
                      (y[7] = E * n + w * s + _ * u + S * m),
                      (y[8] = P * t + A * i + C * l + T * p),
                      (y[9] = P * e + A * o + C * c + T * f),
                      (y[10] = P * r + A * a + C * h + T * d),
                      (y[11] = P * n + A * s + C * u + T * m),
                      (y[12] = k * t + D * i + M * l + I * p),
                      (y[13] = k * e + D * o + M * c + I * f),
                      (y[14] = k * r + D * a + M * h + I * d),
                      (y[15] = k * n + D * s + M * u + I * m),
                      (this._identityCalculated = !1),
                      this
                    );
                  }
                  function y() {
                    return (
                      this._identityCalculated ||
                        ((this._identity = !(
                          1 !== this.props[0] ||
                          0 !== this.props[1] ||
                          0 !== this.props[2] ||
                          0 !== this.props[3] ||
                          0 !== this.props[4] ||
                          1 !== this.props[5] ||
                          0 !== this.props[6] ||
                          0 !== this.props[7] ||
                          0 !== this.props[8] ||
                          0 !== this.props[9] ||
                          1 !== this.props[10] ||
                          0 !== this.props[11] ||
                          0 !== this.props[12] ||
                          0 !== this.props[13] ||
                          0 !== this.props[14] ||
                          1 !== this.props[15]
                        )),
                        (this._identityCalculated = !0)),
                      this._identity
                    );
                  }
                  function g(t) {
                    for (var e = 0; e < 16; ) {
                      if (t.props[e] !== this.props[e]) return !1;
                      e += 1;
                    }
                    return !0;
                  }
                  function v(t) {
                    var e;
                    for (e = 0; e < 16; e += 1) t.props[e] = this.props[e];
                    return t;
                  }
                  function b(t) {
                    var e;
                    for (e = 0; e < 16; e += 1) this.props[e] = t[e];
                  }
                  function x(t, e, r) {
                    return {
                      x: t * this.props[0] + e * this.props[4] + r * this.props[8] + this.props[12],
                      y: t * this.props[1] + e * this.props[5] + r * this.props[9] + this.props[13],
                      z: t * this.props[2] + e * this.props[6] + r * this.props[10] + this.props[14],
                    };
                  }
                  function E(t, e, r) {
                    return t * this.props[0] + e * this.props[4] + r * this.props[8] + this.props[12];
                  }
                  function w(t, e, r) {
                    return t * this.props[1] + e * this.props[5] + r * this.props[9] + this.props[13];
                  }
                  function _(t, e, r) {
                    return t * this.props[2] + e * this.props[6] + r * this.props[10] + this.props[14];
                  }
                  function S() {
                    var t = this.props[0] * this.props[5] - this.props[1] * this.props[4],
                      e = this.props[5] / t,
                      r = -this.props[1] / t,
                      n = -this.props[4] / t,
                      i = this.props[0] / t,
                      o = (this.props[4] * this.props[13] - this.props[5] * this.props[12]) / t,
                      a = -(this.props[0] * this.props[13] - this.props[1] * this.props[12]) / t,
                      s = new Matrix();
                    return (
                      (s.props[0] = e),
                      (s.props[1] = r),
                      (s.props[4] = n),
                      (s.props[5] = i),
                      (s.props[12] = o),
                      (s.props[13] = a),
                      s
                    );
                  }
                  function P(t) {
                    return this.getInverseMatrix().applyToPointArray(t[0], t[1], t[2] || 0);
                  }
                  function A(t) {
                    var e,
                      r = t.length,
                      n = [];
                    for (e = 0; e < r; e += 1) n[e] = P(t[e]);
                    return n;
                  }
                  function C(t, e, r) {
                    var n = createTypedArray('float32', 6);
                    if (this.isIdentity())
                      (n[0] = t[0]), (n[1] = t[1]), (n[2] = e[0]), (n[3] = e[1]), (n[4] = r[0]), (n[5] = r[1]);
                    else {
                      var i = this.props[0],
                        o = this.props[1],
                        a = this.props[4],
                        s = this.props[5],
                        l = this.props[12],
                        c = this.props[13];
                      (n[0] = t[0] * i + t[1] * a + l),
                        (n[1] = t[0] * o + t[1] * s + c),
                        (n[2] = e[0] * i + e[1] * a + l),
                        (n[3] = e[0] * o + e[1] * s + c),
                        (n[4] = r[0] * i + r[1] * a + l),
                        (n[5] = r[0] * o + r[1] * s + c);
                    }
                    return n;
                  }
                  function T(t, e, r) {
                    return this.isIdentity()
                      ? [t, e, r]
                      : [
                          t * this.props[0] + e * this.props[4] + r * this.props[8] + this.props[12],
                          t * this.props[1] + e * this.props[5] + r * this.props[9] + this.props[13],
                          t * this.props[2] + e * this.props[6] + r * this.props[10] + this.props[14],
                        ];
                  }
                  function k(t, e) {
                    if (this.isIdentity()) return t + ',' + e;
                    var r = this.props;
                    return (
                      Math.round(100 * (t * r[0] + e * r[4] + r[12])) / 100 +
                      ',' +
                      Math.round(100 * (t * r[1] + e * r[5] + r[13])) / 100
                    );
                  }
                  function D() {
                    for (var t = 0, e = this.props, r = 'matrix3d('; t < 16; )
                      (r += n(1e4 * e[t]) / 1e4), (r += 15 === t ? ')' : ','), (t += 1);
                    return r;
                  }
                  function M(t) {
                    return (t < 1e-6 && t > 0) || (t > -1e-6 && t < 0) ? n(1e4 * t) / 1e4 : t;
                  }
                  function I() {
                    var t = this.props;
                    return (
                      'matrix(' +
                      M(t[0]) +
                      ',' +
                      M(t[1]) +
                      ',' +
                      M(t[4]) +
                      ',' +
                      M(t[5]) +
                      ',' +
                      M(t[12]) +
                      ',' +
                      M(t[13]) +
                      ')'
                    );
                  }
                  return function () {
                    (this.reset = i),
                      (this.rotate = o),
                      (this.rotateX = a),
                      (this.rotateY = s),
                      (this.rotateZ = l),
                      (this.skew = h),
                      (this.skewFromAxis = u),
                      (this.shear = c),
                      (this.scale = p),
                      (this.setTransform = f),
                      (this.translate = d),
                      (this.transform = m),
                      (this.applyToPoint = x),
                      (this.applyToX = E),
                      (this.applyToY = w),
                      (this.applyToZ = _),
                      (this.applyToPointArray = T),
                      (this.applyToTriplePoints = C),
                      (this.applyToPointStringified = k),
                      (this.toCSS = D),
                      (this.to2dCSS = I),
                      (this.clone = v),
                      (this.cloneFromProps = b),
                      (this.equals = g),
                      (this.inversePoints = A),
                      (this.inversePoint = P),
                      (this.getInverseMatrix = S),
                      (this._t = this.transform),
                      (this.isIdentity = y),
                      (this._identity = !0),
                      (this._identityCalculated = !1),
                      (this.props = createTypedArray('float32', 16)),
                      this.reset();
                  };
                })();
              function _typeof$3(t) {
                return (
                  (_typeof$3 =
                    'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
                      ? function (t) {
                          return typeof t;
                        }
                      : function (t) {
                          return t && 'function' == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype
                            ? 'symbol'
                            : typeof t;
                        }),
                  _typeof$3(t)
                );
              }
              var lottie = {},
                standalone = '__[STANDALONE]__',
                animationData = '__[ANIMATIONDATA]__',
                renderer = '';
              function setLocation(t) {
                setLocationHref(t);
              }
              function searchAnimations() {
                !0 === standalone
                  ? animationManager.searchAnimations(animationData, standalone, renderer)
                  : animationManager.searchAnimations();
              }
              function setSubframeRendering(t) {
                setSubframeEnabled(t);
              }
              function setPrefix(t) {
                setIdPrefix(t);
              }
              function loadAnimation(t) {
                return (
                  !0 === standalone && (t.animationData = JSON.parse(animationData)), animationManager.loadAnimation(t)
                );
              }
              function setQuality(t) {
                if ('string' == typeof t)
                  switch (t) {
                    case 'high':
                      setDefaultCurveSegments(200);
                      break;
                    default:
                    case 'medium':
                      setDefaultCurveSegments(50);
                      break;
                    case 'low':
                      setDefaultCurveSegments(10);
                  }
                else !isNaN(t) && t > 1 && setDefaultCurveSegments(t);
                getDefaultCurveSegments() >= 50 ? roundValues(!1) : roundValues(!0);
              }
              function inBrowser() {
                return 'undefined' != typeof navigator;
              }
              function installPlugin(t, e) {
                'expressions' === t && setExpressionsPlugin(e);
              }
              function getFactory(t) {
                switch (t) {
                  case 'propertyFactory':
                    return PropertyFactory;
                  case 'shapePropertyFactory':
                    return ShapePropertyFactory;
                  case 'matrix':
                    return Matrix;
                  default:
                    return null;
                }
              }
              function checkReady() {
                'complete' === document.readyState && (clearInterval(readyStateCheckInterval), searchAnimations());
              }
              function getQueryVariable(t) {
                for (var e = queryString.split('&'), r = 0; r < e.length; r += 1) {
                  var n = e[r].split('=');
                  if (decodeURIComponent(n[0]) == t) return decodeURIComponent(n[1]);
                }
                return null;
              }
              (lottie.play = animationManager.play),
                (lottie.pause = animationManager.pause),
                (lottie.setLocationHref = setLocation),
                (lottie.togglePause = animationManager.togglePause),
                (lottie.setSpeed = animationManager.setSpeed),
                (lottie.setDirection = animationManager.setDirection),
                (lottie.stop = animationManager.stop),
                (lottie.searchAnimations = searchAnimations),
                (lottie.registerAnimation = animationManager.registerAnimation),
                (lottie.loadAnimation = loadAnimation),
                (lottie.setSubframeRendering = setSubframeRendering),
                (lottie.resize = animationManager.resize),
                (lottie.goToAndStop = animationManager.goToAndStop),
                (lottie.destroy = animationManager.destroy),
                (lottie.setQuality = setQuality),
                (lottie.inBrowser = inBrowser),
                (lottie.installPlugin = installPlugin),
                (lottie.freeze = animationManager.freeze),
                (lottie.unfreeze = animationManager.unfreeze),
                (lottie.setVolume = animationManager.setVolume),
                (lottie.mute = animationManager.mute),
                (lottie.unmute = animationManager.unmute),
                (lottie.getRegisteredAnimations = animationManager.getRegisteredAnimations),
                (lottie.useWebWorker = setWebWorker),
                (lottie.setIDPrefix = setPrefix),
                (lottie.__getFactory = getFactory),
                (lottie.version = '5.10.0');
              var queryString = '';
              if (standalone) {
                var scripts = document.getElementsByTagName('script'),
                  index = scripts.length - 1,
                  myScript = scripts[index] || { src: '' };
                (queryString = myScript.src ? myScript.src.replace(/^[^\?]+\??/, '') : ''),
                  (renderer = getQueryVariable('renderer'));
              }
              var readyStateCheckInterval = setInterval(checkReady, 100);
              try {
                'object' !== _typeof$3(exports) && (window.bodymovin = lottie);
              } catch (t) {}
              var ShapeModifiers = (function () {
                var t = {},
                  e = {};
                return (
                  (t.registerModifier = function (t, r) {
                    e[t] || (e[t] = r);
                  }),
                  (t.getModifier = function (t, r, n) {
                    return new e[t](r, n);
                  }),
                  t
                );
              })();
              function ShapeModifier() {}
              function TrimModifier() {}
              function PuckerAndBloatModifier() {}
              (ShapeModifier.prototype.initModifierProperties = function () {}),
                (ShapeModifier.prototype.addShapeToModifier = function () {}),
                (ShapeModifier.prototype.addShape = function (t) {
                  if (!this.closed) {
                    t.sh.container.addDynamicProperty(t.sh);
                    var e = { shape: t.sh, data: t, localShapeCollection: shapeCollectionPool.newShapeCollection() };
                    this.shapes.push(e), this.addShapeToModifier(e), this._isAnimated && t.setAsAnimated();
                  }
                }),
                (ShapeModifier.prototype.init = function (t, e) {
                  (this.shapes = []),
                    (this.elem = t),
                    this.initDynamicPropertyContainer(t),
                    this.initModifierProperties(t, e),
                    (this.frameId = initialDefaultFrame),
                    (this.closed = !1),
                    (this.k = !1),
                    this.dynamicProperties.length ? (this.k = !0) : this.getValue(!0);
                }),
                (ShapeModifier.prototype.processKeys = function () {
                  this.elem.globalData.frameId !== this.frameId &&
                    ((this.frameId = this.elem.globalData.frameId), this.iterateDynamicProperties());
                }),
                extendPrototype([DynamicPropertyContainer], ShapeModifier),
                extendPrototype([ShapeModifier], TrimModifier),
                (TrimModifier.prototype.initModifierProperties = function (t, e) {
                  (this.s = PropertyFactory.getProp(t, e.s, 0, 0.01, this)),
                    (this.e = PropertyFactory.getProp(t, e.e, 0, 0.01, this)),
                    (this.o = PropertyFactory.getProp(t, e.o, 0, 0, this)),
                    (this.sValue = 0),
                    (this.eValue = 0),
                    (this.getValue = this.processKeys),
                    (this.m = e.m),
                    (this._isAnimated =
                      !!this.s.effectsSequence.length ||
                      !!this.e.effectsSequence.length ||
                      !!this.o.effectsSequence.length);
                }),
                (TrimModifier.prototype.addShapeToModifier = function (t) {
                  t.pathsData = [];
                }),
                (TrimModifier.prototype.calculateShapeEdges = function (t, e, r, n, i) {
                  var o = [];
                  e <= 1
                    ? o.push({ s: t, e: e })
                    : t >= 1
                    ? o.push({ s: t - 1, e: e - 1 })
                    : (o.push({ s: t, e: 1 }), o.push({ s: 0, e: e - 1 }));
                  var a,
                    s,
                    l = [],
                    c = o.length;
                  for (a = 0; a < c; a += 1) {
                    var h, u;
                    (s = o[a]).e * i < n ||
                      s.s * i > n + r ||
                      ((h = s.s * i <= n ? 0 : (s.s * i - n) / r),
                      (u = s.e * i >= n + r ? 1 : (s.e * i - n) / r),
                      l.push([h, u]));
                  }
                  return l.length || l.push([0, 0]), l;
                }),
                (TrimModifier.prototype.releasePathsData = function (t) {
                  var e,
                    r = t.length;
                  for (e = 0; e < r; e += 1) segmentsLengthPool.release(t[e]);
                  return (t.length = 0), t;
                }),
                (TrimModifier.prototype.processShapes = function (t) {
                  var e, r, n, i;
                  if (this._mdf || t) {
                    var o = (this.o.v % 360) / 360;
                    if (
                      (o < 0 && (o += 1),
                      (e = this.s.v > 1 ? 1 + o : this.s.v < 0 ? 0 + o : this.s.v + o) >
                        (r = this.e.v > 1 ? 1 + o : this.e.v < 0 ? 0 + o : this.e.v + o))
                    ) {
                      var a = e;
                      (e = r), (r = a);
                    }
                    (e = 1e-4 * Math.round(1e4 * e)),
                      (r = 1e-4 * Math.round(1e4 * r)),
                      (this.sValue = e),
                      (this.eValue = r);
                  } else (e = this.sValue), (r = this.eValue);
                  var s,
                    l,
                    c,
                    h,
                    u,
                    p = this.shapes.length,
                    f = 0;
                  if (r === e)
                    for (i = 0; i < p; i += 1)
                      this.shapes[i].localShapeCollection.releaseShapes(),
                        (this.shapes[i].shape._mdf = !0),
                        (this.shapes[i].shape.paths = this.shapes[i].localShapeCollection),
                        this._mdf && (this.shapes[i].pathsData.length = 0);
                  else if ((1 === r && 0 === e) || (0 === r && 1 === e)) {
                    if (this._mdf)
                      for (i = 0; i < p; i += 1)
                        (this.shapes[i].pathsData.length = 0), (this.shapes[i].shape._mdf = !0);
                  } else {
                    var d,
                      m,
                      y = [];
                    for (i = 0; i < p; i += 1)
                      if ((d = this.shapes[i]).shape._mdf || this._mdf || t || 2 === this.m) {
                        if (((l = (n = d.shape.paths)._length), (u = 0), !d.shape._mdf && d.pathsData.length))
                          u = d.totalShapeLength;
                        else {
                          for (c = this.releasePathsData(d.pathsData), s = 0; s < l; s += 1)
                            (h = bez.getSegmentsLength(n.shapes[s])), c.push(h), (u += h.totalLength);
                          (d.totalShapeLength = u), (d.pathsData = c);
                        }
                        (f += u), (d.shape._mdf = !0);
                      } else d.shape.paths = d.localShapeCollection;
                    var g,
                      v = e,
                      b = r,
                      x = 0;
                    for (i = p - 1; i >= 0; i -= 1)
                      if ((d = this.shapes[i]).shape._mdf) {
                        for (
                          (m = d.localShapeCollection).releaseShapes(),
                            2 === this.m && p > 1
                              ? ((g = this.calculateShapeEdges(e, r, d.totalShapeLength, x, f)),
                                (x += d.totalShapeLength))
                              : (g = [[v, b]]),
                            l = g.length,
                            s = 0;
                          s < l;
                          s += 1
                        ) {
                          (v = g[s][0]),
                            (b = g[s][1]),
                            (y.length = 0),
                            b <= 1
                              ? y.push({ s: d.totalShapeLength * v, e: d.totalShapeLength * b })
                              : v >= 1
                              ? y.push({ s: d.totalShapeLength * (v - 1), e: d.totalShapeLength * (b - 1) })
                              : (y.push({ s: d.totalShapeLength * v, e: d.totalShapeLength }),
                                y.push({ s: 0, e: d.totalShapeLength * (b - 1) }));
                          var E = this.addShapes(d, y[0]);
                          if (y[0].s !== y[0].e) {
                            if (y.length > 1)
                              if (d.shape.paths.shapes[d.shape.paths._length - 1].c) {
                                var w = E.pop();
                                this.addPaths(E, m), (E = this.addShapes(d, y[1], w));
                              } else this.addPaths(E, m), (E = this.addShapes(d, y[1]));
                            this.addPaths(E, m);
                          }
                        }
                        d.shape.paths = m;
                      }
                  }
                }),
                (TrimModifier.prototype.addPaths = function (t, e) {
                  var r,
                    n = t.length;
                  for (r = 0; r < n; r += 1) e.addShape(t[r]);
                }),
                (TrimModifier.prototype.addSegment = function (t, e, r, n, i, o, a) {
                  i.setXYAt(e[0], e[1], 'o', o),
                    i.setXYAt(r[0], r[1], 'i', o + 1),
                    a && i.setXYAt(t[0], t[1], 'v', o),
                    i.setXYAt(n[0], n[1], 'v', o + 1);
                }),
                (TrimModifier.prototype.addSegmentFromArray = function (t, e, r, n) {
                  e.setXYAt(t[1], t[5], 'o', r),
                    e.setXYAt(t[2], t[6], 'i', r + 1),
                    n && e.setXYAt(t[0], t[4], 'v', r),
                    e.setXYAt(t[3], t[7], 'v', r + 1);
                }),
                (TrimModifier.prototype.addShapes = function (t, e, r) {
                  var n,
                    i,
                    o,
                    a,
                    s,
                    l,
                    c,
                    h,
                    u = t.pathsData,
                    p = t.shape.paths.shapes,
                    f = t.shape.paths._length,
                    d = 0,
                    m = [],
                    y = !0;
                  for (
                    r ? ((s = r._length), (h = r._length)) : ((r = shapePool.newElement()), (s = 0), (h = 0)),
                      m.push(r),
                      n = 0;
                    n < f;
                    n += 1
                  ) {
                    for (l = u[n].lengths, r.c = p[n].c, o = p[n].c ? l.length : l.length + 1, i = 1; i < o; i += 1)
                      if (d + (a = l[i - 1]).addedLength < e.s) (d += a.addedLength), (r.c = !1);
                      else {
                        if (d > e.e) {
                          r.c = !1;
                          break;
                        }
                        e.s <= d && e.e >= d + a.addedLength
                          ? (this.addSegment(p[n].v[i - 1], p[n].o[i - 1], p[n].i[i], p[n].v[i], r, s, y), (y = !1))
                          : ((c = bez.getNewSegment(
                              p[n].v[i - 1],
                              p[n].v[i],
                              p[n].o[i - 1],
                              p[n].i[i],
                              (e.s - d) / a.addedLength,
                              (e.e - d) / a.addedLength,
                              l[i - 1],
                            )),
                            this.addSegmentFromArray(c, r, s, y),
                            (y = !1),
                            (r.c = !1)),
                          (d += a.addedLength),
                          (s += 1);
                      }
                    if (p[n].c && l.length) {
                      if (((a = l[i - 1]), d <= e.e)) {
                        var g = l[i - 1].addedLength;
                        e.s <= d && e.e >= d + g
                          ? (this.addSegment(p[n].v[i - 1], p[n].o[i - 1], p[n].i[0], p[n].v[0], r, s, y), (y = !1))
                          : ((c = bez.getNewSegment(
                              p[n].v[i - 1],
                              p[n].v[0],
                              p[n].o[i - 1],
                              p[n].i[0],
                              (e.s - d) / g,
                              (e.e - d) / g,
                              l[i - 1],
                            )),
                            this.addSegmentFromArray(c, r, s, y),
                            (y = !1),
                            (r.c = !1));
                      } else r.c = !1;
                      (d += a.addedLength), (s += 1);
                    }
                    if (
                      (r._length &&
                        (r.setXYAt(r.v[h][0], r.v[h][1], 'i', h),
                        r.setXYAt(r.v[r._length - 1][0], r.v[r._length - 1][1], 'o', r._length - 1)),
                      d > e.e)
                    )
                      break;
                    n < f - 1 && ((r = shapePool.newElement()), (y = !0), m.push(r), (s = 0));
                  }
                  return m;
                }),
                extendPrototype([ShapeModifier], PuckerAndBloatModifier),
                (PuckerAndBloatModifier.prototype.initModifierProperties = function (t, e) {
                  (this.getValue = this.processKeys),
                    (this.amount = PropertyFactory.getProp(t, e.a, 0, null, this)),
                    (this._isAnimated = !!this.amount.effectsSequence.length);
                }),
                (PuckerAndBloatModifier.prototype.processPath = function (t, e) {
                  var r = e / 100,
                    n = [0, 0],
                    i = t._length,
                    o = 0;
                  for (o = 0; o < i; o += 1) (n[0] += t.v[o][0]), (n[1] += t.v[o][1]);
                  (n[0] /= i), (n[1] /= i);
                  var a,
                    s,
                    l,
                    c,
                    h,
                    u,
                    p = shapePool.newElement();
                  for (p.c = t.c, o = 0; o < i; o += 1)
                    (a = t.v[o][0] + (n[0] - t.v[o][0]) * r),
                      (s = t.v[o][1] + (n[1] - t.v[o][1]) * r),
                      (l = t.o[o][0] + (n[0] - t.o[o][0]) * -r),
                      (c = t.o[o][1] + (n[1] - t.o[o][1]) * -r),
                      (h = t.i[o][0] + (n[0] - t.i[o][0]) * -r),
                      (u = t.i[o][1] + (n[1] - t.i[o][1]) * -r),
                      p.setTripleAt(a, s, l, c, h, u, o);
                  return p;
                }),
                (PuckerAndBloatModifier.prototype.processShapes = function (t) {
                  var e,
                    r,
                    n,
                    i,
                    o,
                    a,
                    s = this.shapes.length,
                    l = this.amount.v;
                  if (0 !== l)
                    for (r = 0; r < s; r += 1) {
                      if (((a = (o = this.shapes[r]).localShapeCollection), o.shape._mdf || this._mdf || t))
                        for (
                          a.releaseShapes(),
                            o.shape._mdf = !0,
                            e = o.shape.paths.shapes,
                            i = o.shape.paths._length,
                            n = 0;
                          n < i;
                          n += 1
                        )
                          a.addShape(this.processPath(e[n], l));
                      o.shape.paths = o.localShapeCollection;
                    }
                  this.dynamicProperties.length || (this._mdf = !1);
                });
              var TransformPropertyFactory = (function () {
                var t = [0, 0];
                function e(t, e, r) {
                  if (
                    ((this.elem = t),
                    (this.frameId = -1),
                    (this.propType = 'transform'),
                    (this.data = e),
                    (this.v = new Matrix()),
                    (this.pre = new Matrix()),
                    (this.appliedTransformations = 0),
                    this.initDynamicPropertyContainer(r || t),
                    e.p && e.p.s
                      ? ((this.px = PropertyFactory.getProp(t, e.p.x, 0, 0, this)),
                        (this.py = PropertyFactory.getProp(t, e.p.y, 0, 0, this)),
                        e.p.z && (this.pz = PropertyFactory.getProp(t, e.p.z, 0, 0, this)))
                      : (this.p = PropertyFactory.getProp(t, e.p || { k: [0, 0, 0] }, 1, 0, this)),
                    e.rx)
                  ) {
                    if (
                      ((this.rx = PropertyFactory.getProp(t, e.rx, 0, degToRads, this)),
                      (this.ry = PropertyFactory.getProp(t, e.ry, 0, degToRads, this)),
                      (this.rz = PropertyFactory.getProp(t, e.rz, 0, degToRads, this)),
                      e.or.k[0].ti)
                    ) {
                      var n,
                        i = e.or.k.length;
                      for (n = 0; n < i; n += 1) (e.or.k[n].to = null), (e.or.k[n].ti = null);
                    }
                    (this.or = PropertyFactory.getProp(t, e.or, 1, degToRads, this)), (this.or.sh = !0);
                  } else this.r = PropertyFactory.getProp(t, e.r || { k: 0 }, 0, degToRads, this);
                  e.sk &&
                    ((this.sk = PropertyFactory.getProp(t, e.sk, 0, degToRads, this)),
                    (this.sa = PropertyFactory.getProp(t, e.sa, 0, degToRads, this))),
                    (this.a = PropertyFactory.getProp(t, e.a || { k: [0, 0, 0] }, 1, 0, this)),
                    (this.s = PropertyFactory.getProp(t, e.s || { k: [100, 100, 100] }, 1, 0.01, this)),
                    e.o ? (this.o = PropertyFactory.getProp(t, e.o, 0, 0.01, t)) : (this.o = { _mdf: !1, v: 1 }),
                    (this._isDirty = !0),
                    this.dynamicProperties.length || this.getValue(!0);
                }
                return (
                  (e.prototype = {
                    applyToMatrix: function (t) {
                      var e = this._mdf;
                      this.iterateDynamicProperties(),
                        (this._mdf = this._mdf || e),
                        this.a && t.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]),
                        this.s && t.scale(this.s.v[0], this.s.v[1], this.s.v[2]),
                        this.sk && t.skewFromAxis(-this.sk.v, this.sa.v),
                        this.r
                          ? t.rotate(-this.r.v)
                          : t
                              .rotateZ(-this.rz.v)
                              .rotateY(this.ry.v)
                              .rotateX(this.rx.v)
                              .rotateZ(-this.or.v[2])
                              .rotateY(this.or.v[1])
                              .rotateX(this.or.v[0]),
                        this.data.p.s
                          ? this.data.p.z
                            ? t.translate(this.px.v, this.py.v, -this.pz.v)
                            : t.translate(this.px.v, this.py.v, 0)
                          : t.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
                    },
                    getValue: function (e) {
                      if (this.elem.globalData.frameId !== this.frameId) {
                        if (
                          (this._isDirty && (this.precalculateMatrix(), (this._isDirty = !1)),
                          this.iterateDynamicProperties(),
                          this._mdf || e)
                        ) {
                          var r;
                          if (
                            (this.v.cloneFromProps(this.pre.props),
                            this.appliedTransformations < 1 &&
                              this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]),
                            this.appliedTransformations < 2 && this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]),
                            this.sk && this.appliedTransformations < 3 && this.v.skewFromAxis(-this.sk.v, this.sa.v),
                            this.r && this.appliedTransformations < 4
                              ? this.v.rotate(-this.r.v)
                              : !this.r &&
                                this.appliedTransformations < 4 &&
                                this.v
                                  .rotateZ(-this.rz.v)
                                  .rotateY(this.ry.v)
                                  .rotateX(this.rx.v)
                                  .rotateZ(-this.or.v[2])
                                  .rotateY(this.or.v[1])
                                  .rotateX(this.or.v[0]),
                            this.autoOriented)
                          ) {
                            var n, i;
                            if (
                              ((r = this.elem.globalData.frameRate),
                              this.p && this.p.keyframes && this.p.getValueAtTime)
                            )
                              this.p._caching.lastFrame + this.p.offsetTime <= this.p.keyframes[0].t
                                ? ((n = this.p.getValueAtTime((this.p.keyframes[0].t + 0.01) / r, 0)),
                                  (i = this.p.getValueAtTime(this.p.keyframes[0].t / r, 0)))
                                : this.p._caching.lastFrame + this.p.offsetTime >=
                                  this.p.keyframes[this.p.keyframes.length - 1].t
                                ? ((n = this.p.getValueAtTime(this.p.keyframes[this.p.keyframes.length - 1].t / r, 0)),
                                  (i = this.p.getValueAtTime(
                                    (this.p.keyframes[this.p.keyframes.length - 1].t - 0.05) / r,
                                    0,
                                  )))
                                : ((n = this.p.pv),
                                  (i = this.p.getValueAtTime(
                                    (this.p._caching.lastFrame + this.p.offsetTime - 0.01) / r,
                                    this.p.offsetTime,
                                  )));
                            else if (
                              this.px &&
                              this.px.keyframes &&
                              this.py.keyframes &&
                              this.px.getValueAtTime &&
                              this.py.getValueAtTime
                            ) {
                              (n = []), (i = []);
                              var o = this.px,
                                a = this.py;
                              o._caching.lastFrame + o.offsetTime <= o.keyframes[0].t
                                ? ((n[0] = o.getValueAtTime((o.keyframes[0].t + 0.01) / r, 0)),
                                  (n[1] = a.getValueAtTime((a.keyframes[0].t + 0.01) / r, 0)),
                                  (i[0] = o.getValueAtTime(o.keyframes[0].t / r, 0)),
                                  (i[1] = a.getValueAtTime(a.keyframes[0].t / r, 0)))
                                : o._caching.lastFrame + o.offsetTime >= o.keyframes[o.keyframes.length - 1].t
                                ? ((n[0] = o.getValueAtTime(o.keyframes[o.keyframes.length - 1].t / r, 0)),
                                  (n[1] = a.getValueAtTime(a.keyframes[a.keyframes.length - 1].t / r, 0)),
                                  (i[0] = o.getValueAtTime((o.keyframes[o.keyframes.length - 1].t - 0.01) / r, 0)),
                                  (i[1] = a.getValueAtTime((a.keyframes[a.keyframes.length - 1].t - 0.01) / r, 0)))
                                : ((n = [o.pv, a.pv]),
                                  (i[0] = o.getValueAtTime(
                                    (o._caching.lastFrame + o.offsetTime - 0.01) / r,
                                    o.offsetTime,
                                  )),
                                  (i[1] = a.getValueAtTime(
                                    (a._caching.lastFrame + a.offsetTime - 0.01) / r,
                                    a.offsetTime,
                                  )));
                            } else n = i = t;
                            this.v.rotate(-Math.atan2(n[1] - i[1], n[0] - i[0]));
                          }
                          this.data.p && this.data.p.s
                            ? this.data.p.z
                              ? this.v.translate(this.px.v, this.py.v, -this.pz.v)
                              : this.v.translate(this.px.v, this.py.v, 0)
                            : this.v.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
                        }
                        this.frameId = this.elem.globalData.frameId;
                      }
                    },
                    precalculateMatrix: function () {
                      if (
                        !this.a.k &&
                        (this.pre.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]),
                        (this.appliedTransformations = 1),
                        !this.s.effectsSequence.length)
                      ) {
                        if (
                          (this.pre.scale(this.s.v[0], this.s.v[1], this.s.v[2]),
                          (this.appliedTransformations = 2),
                          this.sk)
                        ) {
                          if (this.sk.effectsSequence.length || this.sa.effectsSequence.length) return;
                          this.pre.skewFromAxis(-this.sk.v, this.sa.v), (this.appliedTransformations = 3);
                        }
                        this.r
                          ? this.r.effectsSequence.length ||
                            (this.pre.rotate(-this.r.v), (this.appliedTransformations = 4))
                          : this.rz.effectsSequence.length ||
                            this.ry.effectsSequence.length ||
                            this.rx.effectsSequence.length ||
                            this.or.effectsSequence.length ||
                            (this.pre
                              .rotateZ(-this.rz.v)
                              .rotateY(this.ry.v)
                              .rotateX(this.rx.v)
                              .rotateZ(-this.or.v[2])
                              .rotateY(this.or.v[1])
                              .rotateX(this.or.v[0]),
                            (this.appliedTransformations = 4));
                      }
                    },
                    autoOrient: function () {},
                  }),
                  extendPrototype([DynamicPropertyContainer], e),
                  (e.prototype.addDynamicProperty = function (t) {
                    this._addDynamicProperty(t), this.elem.addDynamicProperty(t), (this._isDirty = !0);
                  }),
                  (e.prototype._addDynamicProperty = DynamicPropertyContainer.prototype.addDynamicProperty),
                  {
                    getTransformProperty: function (t, r, n) {
                      return new e(t, r, n);
                    },
                  }
                );
              })();
              function RepeaterModifier() {}
              function RoundCornersModifier() {}
              function floatEqual(t, e) {
                return 1e5 * Math.abs(t - e) <= Math.min(Math.abs(t), Math.abs(e));
              }
              function floatZero(t) {
                return Math.abs(t) <= 1e-5;
              }
              function lerp(t, e, r) {
                return t * (1 - r) + e * r;
              }
              function lerpPoint(t, e, r) {
                return [lerp(t[0], e[0], r), lerp(t[1], e[1], r)];
              }
              function quadRoots(t, e, r) {
                if (0 === t) return [];
                var n = e * e - 4 * t * r;
                if (n < 0) return [];
                var i = -e / (2 * t);
                if (0 === n) return [i];
                var o = Math.sqrt(n) / (2 * t);
                return [i - o, i + o];
              }
              function polynomialCoefficients(t, e, r, n) {
                return [3 * e - t - 3 * r + n, 3 * t - 6 * e + 3 * r, -3 * t + 3 * e, t];
              }
              function singlePoint(t) {
                return new PolynomialBezier(t, t, t, t, !1);
              }
              function PolynomialBezier(t, e, r, n, i) {
                i && pointEqual(t, e) && (e = lerpPoint(t, n, 1 / 3)),
                  i && pointEqual(r, n) && (r = lerpPoint(t, n, 2 / 3));
                var o = polynomialCoefficients(t[0], e[0], r[0], n[0]),
                  a = polynomialCoefficients(t[1], e[1], r[1], n[1]);
                (this.a = [o[0], a[0]]),
                  (this.b = [o[1], a[1]]),
                  (this.c = [o[2], a[2]]),
                  (this.d = [o[3], a[3]]),
                  (this.points = [t, e, r, n]);
              }
              function extrema(t, e) {
                var r = t.points[0][e],
                  n = t.points[t.points.length - 1][e];
                if (r > n) {
                  var i = n;
                  (n = r), (r = i);
                }
                for (var o = quadRoots(3 * t.a[e], 2 * t.b[e], t.c[e]), a = 0; a < o.length; a += 1)
                  if (o[a] > 0 && o[a] < 1) {
                    var s = t.point(o[a])[e];
                    s < r ? (r = s) : s > n && (n = s);
                  }
                return { min: r, max: n };
              }
              function intersectData(t, e, r) {
                var n = t.boundingBox();
                return { cx: n.cx, cy: n.cy, width: n.width, height: n.height, bez: t, t: (e + r) / 2, t1: e, t2: r };
              }
              function splitData(t) {
                var e = t.bez.split(0.5);
                return [intersectData(e[0], t.t1, t.t), intersectData(e[1], t.t, t.t2)];
              }
              function boxIntersect(t, e) {
                return 2 * Math.abs(t.cx - e.cx) < t.width + e.width && 2 * Math.abs(t.cy - e.cy) < t.height + e.height;
              }
              function intersectsImpl(t, e, r, n, i, o) {
                if (boxIntersect(t, e))
                  if (r >= o || (t.width <= n && t.height <= n && e.width <= n && e.height <= n)) i.push([t.t, e.t]);
                  else {
                    var a = splitData(t),
                      s = splitData(e);
                    intersectsImpl(a[0], s[0], r + 1, n, i, o),
                      intersectsImpl(a[0], s[1], r + 1, n, i, o),
                      intersectsImpl(a[1], s[0], r + 1, n, i, o),
                      intersectsImpl(a[1], s[1], r + 1, n, i, o);
                  }
              }
              function crossProduct(t, e) {
                return [t[1] * e[2] - t[2] * e[1], t[2] * e[0] - t[0] * e[2], t[0] * e[1] - t[1] * e[0]];
              }
              function lineIntersection(t, e, r, n) {
                var i = [t[0], t[1], 1],
                  o = [e[0], e[1], 1],
                  a = [r[0], r[1], 1],
                  s = [n[0], n[1], 1],
                  l = crossProduct(crossProduct(i, o), crossProduct(a, s));
                return floatZero(l[2]) ? null : [l[0] / l[2], l[1] / l[2]];
              }
              function polarOffset(t, e, r) {
                return [t[0] + Math.cos(e) * r, t[1] - Math.sin(e) * r];
              }
              function pointDistance(t, e) {
                return Math.hypot(t[0] - e[0], t[1] - e[1]);
              }
              function pointEqual(t, e) {
                return floatEqual(t[0], e[0]) && floatEqual(t[1], e[1]);
              }
              function ZigZagModifier() {}
              function setPoint(t, e, r, n, i, o, a) {
                var s = r - Math.PI / 2,
                  l = r + Math.PI / 2,
                  c = e[0] + Math.cos(r) * n * i,
                  h = e[1] - Math.sin(r) * n * i;
                t.setTripleAt(
                  c,
                  h,
                  c + Math.cos(s) * o,
                  h - Math.sin(s) * o,
                  c + Math.cos(l) * a,
                  h - Math.sin(l) * a,
                  t.length(),
                );
              }
              function getPerpendicularVector(t, e) {
                var r = [e[0] - t[0], e[1] - t[1]],
                  n = 0.5 * -Math.PI;
                return [Math.cos(n) * r[0] - Math.sin(n) * r[1], Math.sin(n) * r[0] + Math.cos(n) * r[1]];
              }
              function getProjectingAngle(t, e) {
                var r = 0 === e ? t.length() - 1 : e - 1,
                  n = (e + 1) % t.length(),
                  i = getPerpendicularVector(t.v[r], t.v[n]);
                return Math.atan2(0, 1) - Math.atan2(i[1], i[0]);
              }
              function zigZagCorner(t, e, r, n, i, o, a) {
                var s = getProjectingAngle(e, r),
                  l = e.v[r % e._length],
                  c = e.v[0 === r ? e._length - 1 : r - 1],
                  h = e.v[(r + 1) % e._length],
                  u = 2 === o ? Math.sqrt(Math.pow(l[0] - c[0], 2) + Math.pow(l[1] - c[1], 2)) : 0,
                  p = 2 === o ? Math.sqrt(Math.pow(l[0] - h[0], 2) + Math.pow(l[1] - h[1], 2)) : 0;
                setPoint(t, e.v[r % e._length], s, a, n, p / (2 * (i + 1)), u / (2 * (i + 1)), o);
              }
              function zigZagSegment(t, e, r, n, i, o) {
                for (var a = 0; a < n; a += 1) {
                  var s = (a + 1) / (n + 1),
                    l =
                      2 === i
                        ? Math.sqrt(
                            Math.pow(e.points[3][0] - e.points[0][0], 2) + Math.pow(e.points[3][1] - e.points[0][1], 2),
                          )
                        : 0,
                    c = e.normalAngle(s);
                  setPoint(t, e.point(s), c, o, r, l / (2 * (n + 1)), l / (2 * (n + 1)), i), (o = -o);
                }
                return o;
              }
              function linearOffset(t, e, r) {
                var n = Math.atan2(e[0] - t[0], e[1] - t[1]);
                return [polarOffset(t, n, r), polarOffset(e, n, r)];
              }
              function offsetSegment(t, e) {
                var r, n, i, o, a, s, l;
                (r = (l = linearOffset(t.points[0], t.points[1], e))[0]),
                  (n = l[1]),
                  (i = (l = linearOffset(t.points[1], t.points[2], e))[0]),
                  (o = l[1]),
                  (a = (l = linearOffset(t.points[2], t.points[3], e))[0]),
                  (s = l[1]);
                var c = lineIntersection(r, n, i, o);
                null === c && (c = n);
                var h = lineIntersection(a, s, i, o);
                return null === h && (h = a), new PolynomialBezier(r, c, h, s);
              }
              function joinLines(t, e, r, n, i) {
                var o = e.points[3],
                  a = r.points[0];
                if (3 === n) return o;
                if (pointEqual(o, a)) return o;
                if (2 === n) {
                  var s = -e.tangentAngle(1),
                    l = -r.tangentAngle(0) + Math.PI,
                    c = lineIntersection(
                      o,
                      polarOffset(o, s + Math.PI / 2, 100),
                      a,
                      polarOffset(a, s + Math.PI / 2, 100),
                    ),
                    h = c ? pointDistance(c, o) : pointDistance(o, a) / 2,
                    u = polarOffset(o, s, 2 * h * roundCorner);
                  return (
                    t.setXYAt(u[0], u[1], 'o', t.length() - 1),
                    (u = polarOffset(a, l, 2 * h * roundCorner)),
                    t.setTripleAt(a[0], a[1], a[0], a[1], u[0], u[1], t.length()),
                    a
                  );
                }
                var p = lineIntersection(
                  pointEqual(o, e.points[2]) ? e.points[0] : e.points[2],
                  o,
                  a,
                  pointEqual(a, r.points[1]) ? r.points[3] : r.points[1],
                );
                return p && pointDistance(p, o) < i
                  ? (t.setTripleAt(p[0], p[1], p[0], p[1], p[0], p[1], t.length()), p)
                  : o;
              }
              function getIntersection(t, e) {
                var r = t.intersections(e);
                return r.length && floatEqual(r[0][0], 1) && r.shift(), r.length ? r[0] : null;
              }
              function pruneSegmentIntersection(t, e) {
                var r = t.slice(),
                  n = e.slice(),
                  i = getIntersection(t[t.length - 1], e[0]);
                return (
                  i && ((r[t.length - 1] = t[t.length - 1].split(i[0])[0]), (n[0] = e[0].split(i[1])[1])),
                  t.length > 1 && e.length > 1 && (i = getIntersection(t[0], e[e.length - 1]))
                    ? [[t[0].split(i[0])[0]], [e[e.length - 1].split(i[1])[1]]]
                    : [r, n]
                );
              }
              function pruneIntersections(t) {
                for (var e, r = 1; r < t.length; r += 1)
                  (e = pruneSegmentIntersection(t[r - 1], t[r])), (t[r - 1] = e[0]), (t[r] = e[1]);
                return (
                  t.length > 1 &&
                    ((e = pruneSegmentIntersection(t[t.length - 1], t[0])), (t[t.length - 1] = e[0]), (t[0] = e[1])),
                  t
                );
              }
              function offsetSegmentSplit(t, e) {
                var r,
                  n,
                  i,
                  o,
                  a = t.inflectionPoints();
                if (0 === a.length) return [offsetSegment(t, e)];
                if (1 === a.length || floatEqual(a[1], 1))
                  return (r = (i = t.split(a[0]))[0]), (n = i[1]), [offsetSegment(r, e), offsetSegment(n, e)];
                r = (i = t.split(a[0]))[0];
                var s = (a[1] - a[0]) / (1 - a[0]);
                return (
                  (o = (i = i[1].split(s))[0]),
                  (n = i[1]),
                  [offsetSegment(r, e), offsetSegment(o, e), offsetSegment(n, e)]
                );
              }
              function OffsetPathModifier() {}
              function getFontProperties(t) {
                for (
                  var e = t.fStyle ? t.fStyle.split(' ') : [], r = 'normal', n = 'normal', i = e.length, o = 0;
                  o < i;
                  o += 1
                )
                  switch (e[o].toLowerCase()) {
                    case 'italic':
                      n = 'italic';
                      break;
                    case 'bold':
                      r = '700';
                      break;
                    case 'black':
                      r = '900';
                      break;
                    case 'medium':
                      r = '500';
                      break;
                    case 'regular':
                    case 'normal':
                      r = '400';
                      break;
                    case 'light':
                    case 'thin':
                      r = '200';
                  }
                return { style: n, weight: t.fWeight || r };
              }
              extendPrototype([ShapeModifier], RepeaterModifier),
                (RepeaterModifier.prototype.initModifierProperties = function (t, e) {
                  (this.getValue = this.processKeys),
                    (this.c = PropertyFactory.getProp(t, e.c, 0, null, this)),
                    (this.o = PropertyFactory.getProp(t, e.o, 0, null, this)),
                    (this.tr = TransformPropertyFactory.getTransformProperty(t, e.tr, this)),
                    (this.so = PropertyFactory.getProp(t, e.tr.so, 0, 0.01, this)),
                    (this.eo = PropertyFactory.getProp(t, e.tr.eo, 0, 0.01, this)),
                    (this.data = e),
                    this.dynamicProperties.length || this.getValue(!0),
                    (this._isAnimated = !!this.dynamicProperties.length),
                    (this.pMatrix = new Matrix()),
                    (this.rMatrix = new Matrix()),
                    (this.sMatrix = new Matrix()),
                    (this.tMatrix = new Matrix()),
                    (this.matrix = new Matrix());
                }),
                (RepeaterModifier.prototype.applyTransforms = function (t, e, r, n, i, o) {
                  var a = o ? -1 : 1,
                    s = n.s.v[0] + (1 - n.s.v[0]) * (1 - i),
                    l = n.s.v[1] + (1 - n.s.v[1]) * (1 - i);
                  t.translate(n.p.v[0] * a * i, n.p.v[1] * a * i, n.p.v[2]),
                    e.translate(-n.a.v[0], -n.a.v[1], n.a.v[2]),
                    e.rotate(-n.r.v * a * i),
                    e.translate(n.a.v[0], n.a.v[1], n.a.v[2]),
                    r.translate(-n.a.v[0], -n.a.v[1], n.a.v[2]),
                    r.scale(o ? 1 / s : s, o ? 1 / l : l),
                    r.translate(n.a.v[0], n.a.v[1], n.a.v[2]);
                }),
                (RepeaterModifier.prototype.init = function (t, e, r, n) {
                  for (
                    this.elem = t,
                      this.arr = e,
                      this.pos = r,
                      this.elemsData = n,
                      this._currentCopies = 0,
                      this._elements = [],
                      this._groups = [],
                      this.frameId = -1,
                      this.initDynamicPropertyContainer(t),
                      this.initModifierProperties(t, e[r]);
                    r > 0;

                  )
                    (r -= 1), this._elements.unshift(e[r]);
                  this.dynamicProperties.length ? (this.k = !0) : this.getValue(!0);
                }),
                (RepeaterModifier.prototype.resetElements = function (t) {
                  var e,
                    r = t.length;
                  for (e = 0; e < r; e += 1) (t[e]._processed = !1), 'gr' === t[e].ty && this.resetElements(t[e].it);
                }),
                (RepeaterModifier.prototype.cloneElements = function (t) {
                  var e = JSON.parse(JSON.stringify(t));
                  return this.resetElements(e), e;
                }),
                (RepeaterModifier.prototype.changeGroupRender = function (t, e) {
                  var r,
                    n = t.length;
                  for (r = 0; r < n; r += 1) (t[r]._render = e), 'gr' === t[r].ty && this.changeGroupRender(t[r].it, e);
                }),
                (RepeaterModifier.prototype.processShapes = function (t) {
                  var e,
                    r,
                    n,
                    i,
                    o,
                    a = !1;
                  if (this._mdf || t) {
                    var s,
                      l = Math.ceil(this.c.v);
                    if (this._groups.length < l) {
                      for (; this._groups.length < l; ) {
                        var c = { it: this.cloneElements(this._elements), ty: 'gr' };
                        c.it.push({
                          a: { a: 0, ix: 1, k: [0, 0] },
                          nm: 'Transform',
                          o: { a: 0, ix: 7, k: 100 },
                          p: { a: 0, ix: 2, k: [0, 0] },
                          r: {
                            a: 1,
                            ix: 6,
                            k: [
                              { s: 0, e: 0, t: 0 },
                              { s: 0, e: 0, t: 1 },
                            ],
                          },
                          s: { a: 0, ix: 3, k: [100, 100] },
                          sa: { a: 0, ix: 5, k: 0 },
                          sk: { a: 0, ix: 4, k: 0 },
                          ty: 'tr',
                        }),
                          this.arr.splice(0, 0, c),
                          this._groups.splice(0, 0, c),
                          (this._currentCopies += 1);
                      }
                      this.elem.reloadShapes(), (a = !0);
                    }
                    for (o = 0, n = 0; n <= this._groups.length - 1; n += 1) {
                      if (
                        ((s = o < l), (this._groups[n]._render = s), this.changeGroupRender(this._groups[n].it, s), !s)
                      ) {
                        var h = this.elemsData[n].it,
                          u = h[h.length - 1];
                        0 !== u.transform.op.v
                          ? ((u.transform.op._mdf = !0), (u.transform.op.v = 0))
                          : (u.transform.op._mdf = !1);
                      }
                      o += 1;
                    }
                    this._currentCopies = l;
                    var p = this.o.v,
                      f = p % 1,
                      d = p > 0 ? Math.floor(p) : Math.ceil(p),
                      m = this.pMatrix.props,
                      y = this.rMatrix.props,
                      g = this.sMatrix.props;
                    this.pMatrix.reset(),
                      this.rMatrix.reset(),
                      this.sMatrix.reset(),
                      this.tMatrix.reset(),
                      this.matrix.reset();
                    var v,
                      b,
                      x = 0;
                    if (p > 0) {
                      for (; x < d; )
                        this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !1), (x += 1);
                      f && (this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, f, !1), (x += f));
                    } else if (p < 0) {
                      for (; x > d; )
                        this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !0), (x -= 1);
                      f && (this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, -f, !0), (x -= f));
                    }
                    for (
                      n = 1 === this.data.m ? 0 : this._currentCopies - 1,
                        i = 1 === this.data.m ? 1 : -1,
                        o = this._currentCopies;
                      o;

                    ) {
                      if (
                        ((b = (r = (e = this.elemsData[n].it)[e.length - 1].transform.mProps.v.props).length),
                        (e[e.length - 1].transform.mProps._mdf = !0),
                        (e[e.length - 1].transform.op._mdf = !0),
                        (e[e.length - 1].transform.op.v =
                          1 === this._currentCopies
                            ? this.so.v
                            : this.so.v + (this.eo.v - this.so.v) * (n / (this._currentCopies - 1))),
                        0 !== x)
                      ) {
                        for (
                          ((0 !== n && 1 === i) || (n !== this._currentCopies - 1 && -1 === i)) &&
                            this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !1),
                            this.matrix.transform(
                              y[0],
                              y[1],
                              y[2],
                              y[3],
                              y[4],
                              y[5],
                              y[6],
                              y[7],
                              y[8],
                              y[9],
                              y[10],
                              y[11],
                              y[12],
                              y[13],
                              y[14],
                              y[15],
                            ),
                            this.matrix.transform(
                              g[0],
                              g[1],
                              g[2],
                              g[3],
                              g[4],
                              g[5],
                              g[6],
                              g[7],
                              g[8],
                              g[9],
                              g[10],
                              g[11],
                              g[12],
                              g[13],
                              g[14],
                              g[15],
                            ),
                            this.matrix.transform(
                              m[0],
                              m[1],
                              m[2],
                              m[3],
                              m[4],
                              m[5],
                              m[6],
                              m[7],
                              m[8],
                              m[9],
                              m[10],
                              m[11],
                              m[12],
                              m[13],
                              m[14],
                              m[15],
                            ),
                            v = 0;
                          v < b;
                          v += 1
                        )
                          r[v] = this.matrix.props[v];
                        this.matrix.reset();
                      } else for (this.matrix.reset(), v = 0; v < b; v += 1) r[v] = this.matrix.props[v];
                      (x += 1), (o -= 1), (n += i);
                    }
                  } else
                    for (o = this._currentCopies, n = 0, i = 1; o; )
                      (r = (e = this.elemsData[n].it)[e.length - 1].transform.mProps.v.props),
                        (e[e.length - 1].transform.mProps._mdf = !1),
                        (e[e.length - 1].transform.op._mdf = !1),
                        (o -= 1),
                        (n += i);
                  return a;
                }),
                (RepeaterModifier.prototype.addShape = function () {}),
                extendPrototype([ShapeModifier], RoundCornersModifier),
                (RoundCornersModifier.prototype.initModifierProperties = function (t, e) {
                  (this.getValue = this.processKeys),
                    (this.rd = PropertyFactory.getProp(t, e.r, 0, null, this)),
                    (this._isAnimated = !!this.rd.effectsSequence.length);
                }),
                (RoundCornersModifier.prototype.processPath = function (t, e) {
                  var r,
                    n = shapePool.newElement();
                  n.c = t.c;
                  var i,
                    o,
                    a,
                    s,
                    l,
                    c,
                    h,
                    u,
                    p,
                    f,
                    d,
                    m,
                    y = t._length,
                    g = 0;
                  for (r = 0; r < y; r += 1)
                    (i = t.v[r]),
                      (a = t.o[r]),
                      (o = t.i[r]),
                      i[0] === a[0] && i[1] === a[1] && i[0] === o[0] && i[1] === o[1]
                        ? (0 !== r && r !== y - 1) || t.c
                          ? ((s = 0 === r ? t.v[y - 1] : t.v[r - 1]),
                            (c = (l = Math.sqrt(Math.pow(i[0] - s[0], 2) + Math.pow(i[1] - s[1], 2)))
                              ? Math.min(l / 2, e) / l
                              : 0),
                            (h = d = i[0] + (s[0] - i[0]) * c),
                            (u = m = i[1] - (i[1] - s[1]) * c),
                            (p = h - (h - i[0]) * roundCorner),
                            (f = u - (u - i[1]) * roundCorner),
                            n.setTripleAt(h, u, p, f, d, m, g),
                            (g += 1),
                            (s = r === y - 1 ? t.v[0] : t.v[r + 1]),
                            (c = (l = Math.sqrt(Math.pow(i[0] - s[0], 2) + Math.pow(i[1] - s[1], 2)))
                              ? Math.min(l / 2, e) / l
                              : 0),
                            (h = p = i[0] + (s[0] - i[0]) * c),
                            (u = f = i[1] + (s[1] - i[1]) * c),
                            (d = h - (h - i[0]) * roundCorner),
                            (m = u - (u - i[1]) * roundCorner),
                            n.setTripleAt(h, u, p, f, d, m, g),
                            (g += 1))
                          : (n.setTripleAt(i[0], i[1], a[0], a[1], o[0], o[1], g), (g += 1))
                        : (n.setTripleAt(t.v[r][0], t.v[r][1], t.o[r][0], t.o[r][1], t.i[r][0], t.i[r][1], g),
                          (g += 1));
                  return n;
                }),
                (RoundCornersModifier.prototype.processShapes = function (t) {
                  var e,
                    r,
                    n,
                    i,
                    o,
                    a,
                    s = this.shapes.length,
                    l = this.rd.v;
                  if (0 !== l)
                    for (r = 0; r < s; r += 1) {
                      if (((a = (o = this.shapes[r]).localShapeCollection), o.shape._mdf || this._mdf || t))
                        for (
                          a.releaseShapes(),
                            o.shape._mdf = !0,
                            e = o.shape.paths.shapes,
                            i = o.shape.paths._length,
                            n = 0;
                          n < i;
                          n += 1
                        )
                          a.addShape(this.processPath(e[n], l));
                      o.shape.paths = o.localShapeCollection;
                    }
                  this.dynamicProperties.length || (this._mdf = !1);
                }),
                (PolynomialBezier.prototype.point = function (t) {
                  return [
                    ((this.a[0] * t + this.b[0]) * t + this.c[0]) * t + this.d[0],
                    ((this.a[1] * t + this.b[1]) * t + this.c[1]) * t + this.d[1],
                  ];
                }),
                (PolynomialBezier.prototype.derivative = function (t) {
                  return [
                    (3 * t * this.a[0] + 2 * this.b[0]) * t + this.c[0],
                    (3 * t * this.a[1] + 2 * this.b[1]) * t + this.c[1],
                  ];
                }),
                (PolynomialBezier.prototype.tangentAngle = function (t) {
                  var e = this.derivative(t);
                  return Math.atan2(e[1], e[0]);
                }),
                (PolynomialBezier.prototype.normalAngle = function (t) {
                  var e = this.derivative(t);
                  return Math.atan2(e[0], e[1]);
                }),
                (PolynomialBezier.prototype.inflectionPoints = function () {
                  var t = this.a[1] * this.b[0] - this.a[0] * this.b[1];
                  if (floatZero(t)) return [];
                  var e = (-0.5 * (this.a[1] * this.c[0] - this.a[0] * this.c[1])) / t,
                    r = e * e - ((1 / 3) * (this.b[1] * this.c[0] - this.b[0] * this.c[1])) / t;
                  if (r < 0) return [];
                  var n = Math.sqrt(r);
                  return floatZero(n)
                    ? n > 0 && n < 1
                      ? [e]
                      : []
                    : [e - n, e + n].filter(function (t) {
                        return t > 0 && t < 1;
                      });
                }),
                (PolynomialBezier.prototype.split = function (t) {
                  if (t <= 0) return [singlePoint(this.points[0]), this];
                  if (t >= 1) return [this, singlePoint(this.points[this.points.length - 1])];
                  var e = lerpPoint(this.points[0], this.points[1], t),
                    r = lerpPoint(this.points[1], this.points[2], t),
                    n = lerpPoint(this.points[2], this.points[3], t),
                    i = lerpPoint(e, r, t),
                    o = lerpPoint(r, n, t),
                    a = lerpPoint(i, o, t);
                  return [
                    new PolynomialBezier(this.points[0], e, i, a, !0),
                    new PolynomialBezier(a, o, n, this.points[3], !0),
                  ];
                }),
                (PolynomialBezier.prototype.bounds = function () {
                  return { x: extrema(this, 0), y: extrema(this, 1) };
                }),
                (PolynomialBezier.prototype.boundingBox = function () {
                  var t = this.bounds();
                  return {
                    left: t.x.min,
                    right: t.x.max,
                    top: t.y.min,
                    bottom: t.y.max,
                    width: t.x.max - t.x.min,
                    height: t.y.max - t.y.min,
                    cx: (t.x.max + t.x.min) / 2,
                    cy: (t.y.max + t.y.min) / 2,
                  };
                }),
                (PolynomialBezier.prototype.intersections = function (t, e, r) {
                  void 0 === e && (e = 2), void 0 === r && (r = 7);
                  var n = [];
                  return intersectsImpl(intersectData(this, 0, 1), intersectData(t, 0, 1), 0, e, n, r), n;
                }),
                (PolynomialBezier.shapeSegment = function (t, e) {
                  var r = (e + 1) % t.length();
                  return new PolynomialBezier(t.v[e], t.o[e], t.i[r], t.v[r], !0);
                }),
                (PolynomialBezier.shapeSegmentInverted = function (t, e) {
                  var r = (e + 1) % t.length();
                  return new PolynomialBezier(t.v[r], t.i[r], t.o[e], t.v[e], !0);
                }),
                extendPrototype([ShapeModifier], ZigZagModifier),
                (ZigZagModifier.prototype.initModifierProperties = function (t, e) {
                  (this.getValue = this.processKeys),
                    (this.amplitude = PropertyFactory.getProp(t, e.s, 0, null, this)),
                    (this.frequency = PropertyFactory.getProp(t, e.r, 0, null, this)),
                    (this.pointsType = PropertyFactory.getProp(t, e.pt, 0, null, this)),
                    (this._isAnimated =
                      0 !== this.amplitude.effectsSequence.length ||
                      0 !== this.frequency.effectsSequence.length ||
                      0 !== this.pointsType.effectsSequence.length);
                }),
                (ZigZagModifier.prototype.processPath = function (t, e, r, n) {
                  var i = t._length,
                    o = shapePool.newElement();
                  if (((o.c = t.c), t.c || (i -= 1), 0 === i)) return o;
                  var a = -1,
                    s = PolynomialBezier.shapeSegment(t, 0);
                  zigZagCorner(o, t, 0, e, r, n, a);
                  for (var l = 0; l < i; l += 1)
                    (a = zigZagSegment(o, s, e, r, n, -a)),
                      (s = l !== i - 1 || t.c ? PolynomialBezier.shapeSegment(t, (l + 1) % i) : null),
                      zigZagCorner(o, t, l + 1, e, r, n, a);
                  return o;
                }),
                (ZigZagModifier.prototype.processShapes = function (t) {
                  var e,
                    r,
                    n,
                    i,
                    o,
                    a,
                    s = this.shapes.length,
                    l = this.amplitude.v,
                    c = Math.max(0, Math.round(this.frequency.v)),
                    h = this.pointsType.v;
                  if (0 !== l)
                    for (r = 0; r < s; r += 1) {
                      if (((a = (o = this.shapes[r]).localShapeCollection), o.shape._mdf || this._mdf || t))
                        for (
                          a.releaseShapes(),
                            o.shape._mdf = !0,
                            e = o.shape.paths.shapes,
                            i = o.shape.paths._length,
                            n = 0;
                          n < i;
                          n += 1
                        )
                          a.addShape(this.processPath(e[n], l, c, h));
                      o.shape.paths = o.localShapeCollection;
                    }
                  this.dynamicProperties.length || (this._mdf = !1);
                }),
                extendPrototype([ShapeModifier], OffsetPathModifier),
                (OffsetPathModifier.prototype.initModifierProperties = function (t, e) {
                  (this.getValue = this.processKeys),
                    (this.amount = PropertyFactory.getProp(t, e.a, 0, null, this)),
                    (this.miterLimit = PropertyFactory.getProp(t, e.ml, 0, null, this)),
                    (this.lineJoin = e.lj),
                    (this._isAnimated = 0 !== this.amount.effectsSequence.length);
                }),
                (OffsetPathModifier.prototype.processPath = function (t, e, r, n) {
                  var i = shapePool.newElement();
                  i.c = t.c;
                  var o,
                    a,
                    s,
                    l = t.length();
                  t.c || (l -= 1);
                  var c = [];
                  for (o = 0; o < l; o += 1)
                    (s = PolynomialBezier.shapeSegment(t, o)), c.push(offsetSegmentSplit(s, e));
                  if (!t.c)
                    for (o = l - 1; o >= 0; o -= 1)
                      (s = PolynomialBezier.shapeSegmentInverted(t, o)), c.push(offsetSegmentSplit(s, e));
                  c = pruneIntersections(c);
                  var h = null,
                    u = null;
                  for (o = 0; o < c.length; o += 1) {
                    var p = c[o];
                    for (u && (h = joinLines(i, u, p[0], r, n)), u = p[p.length - 1], a = 0; a < p.length; a += 1)
                      (s = p[a]),
                        h && pointEqual(s.points[0], h)
                          ? i.setXYAt(s.points[1][0], s.points[1][1], 'o', i.length() - 1)
                          : i.setTripleAt(
                              s.points[0][0],
                              s.points[0][1],
                              s.points[1][0],
                              s.points[1][1],
                              s.points[0][0],
                              s.points[0][1],
                              i.length(),
                            ),
                        i.setTripleAt(
                          s.points[3][0],
                          s.points[3][1],
                          s.points[3][0],
                          s.points[3][1],
                          s.points[2][0],
                          s.points[2][1],
                          i.length(),
                        ),
                        (h = s.points[3]);
                  }
                  return c.length && joinLines(i, u, c[0][0], r, n), i;
                }),
                (OffsetPathModifier.prototype.processShapes = function (t) {
                  var e,
                    r,
                    n,
                    i,
                    o,
                    a,
                    s = this.shapes.length,
                    l = this.amount.v,
                    c = this.miterLimit.v,
                    h = this.lineJoin;
                  if (0 !== l)
                    for (r = 0; r < s; r += 1) {
                      if (((a = (o = this.shapes[r]).localShapeCollection), o.shape._mdf || this._mdf || t))
                        for (
                          a.releaseShapes(),
                            o.shape._mdf = !0,
                            e = o.shape.paths.shapes,
                            i = o.shape.paths._length,
                            n = 0;
                          n < i;
                          n += 1
                        )
                          a.addShape(this.processPath(e[n], l, h, c));
                      o.shape.paths = o.localShapeCollection;
                    }
                  this.dynamicProperties.length || (this._mdf = !1);
                });
              var FontManager = (function () {
                var t = { w: 0, size: 0, shapes: [], data: { shapes: [] } },
                  e = [];
                e = e.concat([
                  2304, 2305, 2306, 2307, 2362, 2363, 2364, 2364, 2366, 2367, 2368, 2369, 2370, 2371, 2372, 2373, 2374,
                  2375, 2376, 2377, 2378, 2379, 2380, 2381, 2382, 2383, 2387, 2388, 2389, 2390, 2391, 2402, 2403,
                ]);
                var r = ['d83cdffb', 'd83cdffc', 'd83cdffd', 'd83cdffe', 'd83cdfff'],
                  n = [65039, 8205];
                function i(t, e) {
                  var r = createTag('span');
                  r.setAttribute('aria-hidden', !0), (r.style.fontFamily = e);
                  var n = createTag('span');
                  (n.innerText = 'giItT1WQy@!-/#'),
                    (r.style.position = 'absolute'),
                    (r.style.left = '-10000px'),
                    (r.style.top = '-10000px'),
                    (r.style.fontSize = '300px'),
                    (r.style.fontVariant = 'normal'),
                    (r.style.fontStyle = 'normal'),
                    (r.style.fontWeight = 'normal'),
                    (r.style.letterSpacing = '0'),
                    r.appendChild(n),
                    document.body.appendChild(r);
                  var i = n.offsetWidth;
                  return (
                    (n.style.fontFamily =
                      (function (t) {
                        var e,
                          r = t.split(','),
                          n = r.length,
                          i = [];
                        for (e = 0; e < n; e += 1) 'sans-serif' !== r[e] && 'monospace' !== r[e] && i.push(r[e]);
                        return i.join(',');
                      })(t) +
                      ', ' +
                      e),
                    { node: n, w: i, parent: r }
                  );
                }
                function o(t, e) {
                  var r,
                    n = document.body && e ? 'svg' : 'canvas',
                    i = getFontProperties(t);
                  if ('svg' === n) {
                    var o = createNS('text');
                    (o.style.fontSize = '100px'),
                      o.setAttribute('font-family', t.fFamily),
                      o.setAttribute('font-style', i.style),
                      o.setAttribute('font-weight', i.weight),
                      (o.textContent = '1'),
                      t.fClass
                        ? ((o.style.fontFamily = 'inherit'), o.setAttribute('class', t.fClass))
                        : (o.style.fontFamily = t.fFamily),
                      e.appendChild(o),
                      (r = o);
                  } else {
                    var a = new OffscreenCanvas(500, 500).getContext('2d');
                    (a.font = i.style + ' ' + i.weight + ' 100px ' + t.fFamily), (r = a);
                  }
                  return {
                    measureText: function (t) {
                      return 'svg' === n ? ((r.textContent = t), r.getComputedTextLength()) : r.measureText(t).width;
                    },
                  };
                }
                var a = function () {
                  (this.fonts = []),
                    (this.chars = null),
                    (this.typekitLoaded = 0),
                    (this.isLoaded = !1),
                    (this._warned = !1),
                    (this.initTime = Date.now()),
                    (this.setIsLoadedBinded = this.setIsLoaded.bind(this)),
                    (this.checkLoadedFontsBinded = this.checkLoadedFonts.bind(this));
                };
                (a.isModifier = function (t, e) {
                  var n = t.toString(16) + e.toString(16);
                  return -1 !== r.indexOf(n);
                }),
                  (a.isZeroWidthJoiner = function (t, e) {
                    return e ? t === n[0] && e === n[1] : t === n[1];
                  }),
                  (a.isCombinedCharacter = function (t) {
                    return -1 !== e.indexOf(t);
                  });
                var s = {
                  addChars: function (t) {
                    if (t) {
                      var e;
                      this.chars || (this.chars = []);
                      var r,
                        n,
                        i = t.length,
                        o = this.chars.length;
                      for (e = 0; e < i; e += 1) {
                        for (r = 0, n = !1; r < o; )
                          this.chars[r].style === t[e].style &&
                            this.chars[r].fFamily === t[e].fFamily &&
                            this.chars[r].ch === t[e].ch &&
                            (n = !0),
                            (r += 1);
                        n || (this.chars.push(t[e]), (o += 1));
                      }
                    }
                  },
                  addFonts: function (t, e) {
                    if (t) {
                      if (this.chars) return (this.isLoaded = !0), void (this.fonts = t.list);
                      if (!document.body)
                        return (
                          (this.isLoaded = !0),
                          t.list.forEach(function (t) {
                            (t.helper = o(t)), (t.cache = {});
                          }),
                          void (this.fonts = t.list)
                        );
                      var r,
                        n = t.list,
                        a = n.length,
                        s = a;
                      for (r = 0; r < a; r += 1) {
                        var l,
                          c,
                          h = !0;
                        if (
                          ((n[r].loaded = !1),
                          (n[r].monoCase = i(n[r].fFamily, 'monospace')),
                          (n[r].sansCase = i(n[r].fFamily, 'sans-serif')),
                          n[r].fPath)
                        ) {
                          if ('p' === n[r].fOrigin || 3 === n[r].origin) {
                            if (
                              ((l = document.querySelectorAll(
                                'style[f-forigin="p"][f-family="' +
                                  n[r].fFamily +
                                  '"], style[f-origin="3"][f-family="' +
                                  n[r].fFamily +
                                  '"]',
                              )).length > 0 && (h = !1),
                              h)
                            ) {
                              var u = createTag('style');
                              u.setAttribute('f-forigin', n[r].fOrigin),
                                u.setAttribute('f-origin', n[r].origin),
                                u.setAttribute('f-family', n[r].fFamily),
                                (u.type = 'text/css'),
                                (u.innerText =
                                  '@font-face {font-family: ' +
                                  n[r].fFamily +
                                  "; font-style: normal; src: url('" +
                                  n[r].fPath +
                                  "');}"),
                                e.appendChild(u);
                            }
                          } else if ('g' === n[r].fOrigin || 1 === n[r].origin) {
                            for (
                              l = document.querySelectorAll('link[f-forigin="g"], link[f-origin="1"]'), c = 0;
                              c < l.length;
                              c += 1
                            )
                              -1 !== l[c].href.indexOf(n[r].fPath) && (h = !1);
                            if (h) {
                              var p = createTag('link');
                              p.setAttribute('f-forigin', n[r].fOrigin),
                                p.setAttribute('f-origin', n[r].origin),
                                (p.type = 'text/css'),
                                (p.rel = 'stylesheet'),
                                (p.href = n[r].fPath),
                                document.body.appendChild(p);
                            }
                          } else if ('t' === n[r].fOrigin || 2 === n[r].origin) {
                            for (
                              l = document.querySelectorAll('script[f-forigin="t"], script[f-origin="2"]'), c = 0;
                              c < l.length;
                              c += 1
                            )
                              n[r].fPath === l[c].src && (h = !1);
                            if (h) {
                              var f = createTag('link');
                              f.setAttribute('f-forigin', n[r].fOrigin),
                                f.setAttribute('f-origin', n[r].origin),
                                f.setAttribute('rel', 'stylesheet'),
                                f.setAttribute('href', n[r].fPath),
                                e.appendChild(f);
                            }
                          }
                        } else (n[r].loaded = !0), (s -= 1);
                        (n[r].helper = o(n[r], e)), (n[r].cache = {}), this.fonts.push(n[r]);
                      }
                      0 === s ? (this.isLoaded = !0) : setTimeout(this.checkLoadedFonts.bind(this), 100);
                    } else this.isLoaded = !0;
                  },
                  getCharData: function (e, r, n) {
                    for (var i = 0, o = this.chars.length; i < o; ) {
                      if (this.chars[i].ch === e && this.chars[i].style === r && this.chars[i].fFamily === n)
                        return this.chars[i];
                      i += 1;
                    }
                    return (
                      (('string' == typeof e && 13 !== e.charCodeAt(0)) || !e) &&
                        console &&
                        console.warn &&
                        !this._warned &&
                        ((this._warned = !0),
                        console.warn('Missing character from exported characters list: ', e, r, n)),
                      t
                    );
                  },
                  getFontByName: function (t) {
                    for (var e = 0, r = this.fonts.length; e < r; ) {
                      if (this.fonts[e].fName === t) return this.fonts[e];
                      e += 1;
                    }
                    return this.fonts[0];
                  },
                  measureText: function (t, e, r) {
                    var n = this.getFontByName(e),
                      i = t.charCodeAt(0);
                    if (!n.cache[i + 1]) {
                      var o = n.helper;
                      if (' ' === t) {
                        var a = o.measureText('|' + t + '|'),
                          s = o.measureText('||');
                        n.cache[i + 1] = (a - s) / 100;
                      } else n.cache[i + 1] = o.measureText(t) / 100;
                    }
                    return n.cache[i + 1] * r;
                  },
                  checkLoadedFonts: function () {
                    var t,
                      e,
                      r,
                      n = this.fonts.length,
                      i = n;
                    for (t = 0; t < n; t += 1)
                      this.fonts[t].loaded
                        ? (i -= 1)
                        : 'n' === this.fonts[t].fOrigin || 0 === this.fonts[t].origin
                        ? (this.fonts[t].loaded = !0)
                        : ((e = this.fonts[t].monoCase.node),
                          (r = this.fonts[t].monoCase.w),
                          e.offsetWidth !== r
                            ? ((i -= 1), (this.fonts[t].loaded = !0))
                            : ((e = this.fonts[t].sansCase.node),
                              (r = this.fonts[t].sansCase.w),
                              e.offsetWidth !== r && ((i -= 1), (this.fonts[t].loaded = !0))),
                          this.fonts[t].loaded &&
                            (this.fonts[t].sansCase.parent.parentNode.removeChild(this.fonts[t].sansCase.parent),
                            this.fonts[t].monoCase.parent.parentNode.removeChild(this.fonts[t].monoCase.parent)));
                    0 !== i && Date.now() - this.initTime < 5e3
                      ? setTimeout(this.checkLoadedFontsBinded, 20)
                      : setTimeout(this.setIsLoadedBinded, 10);
                  },
                  setIsLoaded: function () {
                    this.isLoaded = !0;
                  },
                };
                return (a.prototype = s), a;
              })();
              function RenderableElement() {}
              RenderableElement.prototype = {
                initRenderable: function () {
                  (this.isInRange = !1),
                    (this.hidden = !1),
                    (this.isTransparent = !1),
                    (this.renderableComponents = []);
                },
                addRenderableComponent: function (t) {
                  -1 === this.renderableComponents.indexOf(t) && this.renderableComponents.push(t);
                },
                removeRenderableComponent: function (t) {
                  -1 !== this.renderableComponents.indexOf(t) &&
                    this.renderableComponents.splice(this.renderableComponents.indexOf(t), 1);
                },
                prepareRenderableFrame: function (t) {
                  this.checkLayerLimits(t);
                },
                checkTransparency: function () {
                  this.finalTransform.mProp.o.v <= 0
                    ? !this.isTransparent &&
                      this.globalData.renderConfig.hideOnTransparent &&
                      ((this.isTransparent = !0), this.hide())
                    : this.isTransparent && ((this.isTransparent = !1), this.show());
                },
                checkLayerLimits: function (t) {
                  this.data.ip - this.data.st <= t && this.data.op - this.data.st > t
                    ? !0 !== this.isInRange &&
                      ((this.globalData._mdf = !0), (this._mdf = !0), (this.isInRange = !0), this.show())
                    : !1 !== this.isInRange && ((this.globalData._mdf = !0), (this.isInRange = !1), this.hide());
                },
                renderRenderable: function () {
                  var t,
                    e = this.renderableComponents.length;
                  for (t = 0; t < e; t += 1) this.renderableComponents[t].renderFrame(this._isFirstFrame);
                },
                sourceRectAtTime: function () {
                  return { top: 0, left: 0, width: 100, height: 100 };
                },
                getLayerSize: function () {
                  return 5 === this.data.ty
                    ? { w: this.data.textData.width, h: this.data.textData.height }
                    : { w: this.data.width, h: this.data.height };
                },
              };
              var getBlendMode =
                  ((blendModeEnums = {
                    0: 'source-over',
                    1: 'multiply',
                    2: 'screen',
                    3: 'overlay',
                    4: 'darken',
                    5: 'lighten',
                    6: 'color-dodge',
                    7: 'color-burn',
                    8: 'hard-light',
                    9: 'soft-light',
                    10: 'difference',
                    11: 'exclusion',
                    12: 'hue',
                    13: 'saturation',
                    14: 'color',
                    15: 'luminosity',
                  }),
                  function (t) {
                    return blendModeEnums[t] || '';
                  }),
                blendModeEnums;
              function SliderEffect(t, e, r) {
                this.p = PropertyFactory.getProp(e, t.v, 0, 0, r);
              }
              function AngleEffect(t, e, r) {
                this.p = PropertyFactory.getProp(e, t.v, 0, 0, r);
              }
              function ColorEffect(t, e, r) {
                this.p = PropertyFactory.getProp(e, t.v, 1, 0, r);
              }
              function PointEffect(t, e, r) {
                this.p = PropertyFactory.getProp(e, t.v, 1, 0, r);
              }
              function LayerIndexEffect(t, e, r) {
                this.p = PropertyFactory.getProp(e, t.v, 0, 0, r);
              }
              function MaskIndexEffect(t, e, r) {
                this.p = PropertyFactory.getProp(e, t.v, 0, 0, r);
              }
              function CheckboxEffect(t, e, r) {
                this.p = PropertyFactory.getProp(e, t.v, 0, 0, r);
              }
              function NoValueEffect() {
                this.p = {};
              }
              function EffectsManager(t, e) {
                var r,
                  n = t.ef || [];
                this.effectElements = [];
                var i,
                  o = n.length;
                for (r = 0; r < o; r += 1) (i = new GroupEffect(n[r], e)), this.effectElements.push(i);
              }
              function GroupEffect(t, e) {
                this.init(t, e);
              }
              function BaseElement() {}
              function FrameElement() {}
              function FootageElement(t, e, r) {
                this.initFrame(),
                  this.initRenderable(),
                  (this.assetData = e.getAssetData(t.refId)),
                  (this.footageData = e.imageLoader.getAsset(this.assetData)),
                  this.initBaseData(t, e, r);
              }
              function AudioElement(t, e, r) {
                this.initFrame(),
                  this.initRenderable(),
                  (this.assetData = e.getAssetData(t.refId)),
                  this.initBaseData(t, e, r),
                  (this._isPlaying = !1),
                  (this._canPlay = !1);
                var n = this.globalData.getAssetsPath(this.assetData);
                (this.audio = this.globalData.audioController.createAudio(n)),
                  (this._currentTime = 0),
                  this.globalData.audioController.addAudio(this),
                  (this._volumeMultiplier = 1),
                  (this._volume = 1),
                  (this._previousVolume = null),
                  (this.tm = t.tm ? PropertyFactory.getProp(this, t.tm, 0, e.frameRate, this) : { _placeholder: !0 }),
                  (this.lv = PropertyFactory.getProp(this, t.au && t.au.lv ? t.au.lv : { k: [100] }, 1, 0.01, this));
              }
              function BaseRenderer() {}
              function TransformElement() {}
              function MaskElement(t, e, r) {
                (this.data = t),
                  (this.element = e),
                  (this.globalData = r),
                  (this.storedData = []),
                  (this.masksProperties = this.data.masksProperties || []),
                  (this.maskElement = null);
                var n,
                  i,
                  o = this.globalData.defs,
                  a = this.masksProperties ? this.masksProperties.length : 0;
                (this.viewData = createSizedArray(a)), (this.solidPath = '');
                var s,
                  l,
                  c,
                  h,
                  u,
                  p,
                  f = this.masksProperties,
                  d = 0,
                  m = [],
                  y = createElementID(),
                  g = 'clipPath',
                  v = 'clip-path';
                for (n = 0; n < a; n += 1)
                  if (
                    ((('a' !== f[n].mode && 'n' !== f[n].mode) || f[n].inv || 100 !== f[n].o.k || f[n].o.x) &&
                      ((g = 'mask'), (v = 'mask')),
                    ('s' !== f[n].mode && 'i' !== f[n].mode) || 0 !== d
                      ? (c = null)
                      : ((c = createNS('rect')).setAttribute('fill', '#ffffff'),
                        c.setAttribute('width', this.element.comp.data.w || 0),
                        c.setAttribute('height', this.element.comp.data.h || 0),
                        m.push(c)),
                    (i = createNS('path')),
                    'n' === f[n].mode)
                  )
                    (this.viewData[n] = {
                      op: PropertyFactory.getProp(this.element, f[n].o, 0, 0.01, this.element),
                      prop: ShapePropertyFactory.getShapeProp(this.element, f[n], 3),
                      elem: i,
                      lastPath: '',
                    }),
                      o.appendChild(i);
                  else {
                    var b;
                    if (
                      ((d += 1),
                      i.setAttribute('fill', 's' === f[n].mode ? '#000000' : '#ffffff'),
                      i.setAttribute('clip-rule', 'nonzero'),
                      0 !== f[n].x.k
                        ? ((g = 'mask'),
                          (v = 'mask'),
                          (p = PropertyFactory.getProp(this.element, f[n].x, 0, null, this.element)),
                          (b = createElementID()),
                          (h = createNS('filter')).setAttribute('id', b),
                          (u = createNS('feMorphology')).setAttribute('operator', 'erode'),
                          u.setAttribute('in', 'SourceGraphic'),
                          u.setAttribute('radius', '0'),
                          h.appendChild(u),
                          o.appendChild(h),
                          i.setAttribute('stroke', 's' === f[n].mode ? '#000000' : '#ffffff'))
                        : ((u = null), (p = null)),
                      (this.storedData[n] = {
                        elem: i,
                        x: p,
                        expan: u,
                        lastPath: '',
                        lastOperator: '',
                        filterId: b,
                        lastRadius: 0,
                      }),
                      'i' === f[n].mode)
                    ) {
                      l = m.length;
                      var x = createNS('g');
                      for (s = 0; s < l; s += 1) x.appendChild(m[s]);
                      var E = createNS('mask');
                      E.setAttribute('mask-type', 'alpha'),
                        E.setAttribute('id', y + '_' + d),
                        E.appendChild(i),
                        o.appendChild(E),
                        x.setAttribute('mask', 'url(' + getLocationHref() + '#' + y + '_' + d + ')'),
                        (m.length = 0),
                        m.push(x);
                    } else m.push(i);
                    f[n].inv && !this.solidPath && (this.solidPath = this.createLayerSolidPath()),
                      (this.viewData[n] = {
                        elem: i,
                        lastPath: '',
                        op: PropertyFactory.getProp(this.element, f[n].o, 0, 0.01, this.element),
                        prop: ShapePropertyFactory.getShapeProp(this.element, f[n], 3),
                        invRect: c,
                      }),
                      this.viewData[n].prop.k || this.drawPath(f[n], this.viewData[n].prop.v, this.viewData[n]);
                  }
                for (this.maskElement = createNS(g), a = m.length, n = 0; n < a; n += 1)
                  this.maskElement.appendChild(m[n]);
                d > 0 &&
                  (this.maskElement.setAttribute('id', y),
                  this.element.maskedElement.setAttribute(v, 'url(' + getLocationHref() + '#' + y + ')'),
                  o.appendChild(this.maskElement)),
                  this.viewData.length && this.element.addRenderableComponent(this);
              }
              extendPrototype([DynamicPropertyContainer], GroupEffect),
                (GroupEffect.prototype.getValue = GroupEffect.prototype.iterateDynamicProperties),
                (GroupEffect.prototype.init = function (t, e) {
                  var r;
                  (this.data = t), (this.effectElements = []), this.initDynamicPropertyContainer(e);
                  var n,
                    i = this.data.ef.length,
                    o = this.data.ef;
                  for (r = 0; r < i; r += 1) {
                    switch (((n = null), o[r].ty)) {
                      case 0:
                        n = new SliderEffect(o[r], e, this);
                        break;
                      case 1:
                        n = new AngleEffect(o[r], e, this);
                        break;
                      case 2:
                        n = new ColorEffect(o[r], e, this);
                        break;
                      case 3:
                        n = new PointEffect(o[r], e, this);
                        break;
                      case 4:
                      case 7:
                        n = new CheckboxEffect(o[r], e, this);
                        break;
                      case 10:
                        n = new LayerIndexEffect(o[r], e, this);
                        break;
                      case 11:
                        n = new MaskIndexEffect(o[r], e, this);
                        break;
                      case 5:
                        n = new EffectsManager(o[r], e, this);
                        break;
                      default:
                        n = new NoValueEffect(o[r], e, this);
                    }
                    n && this.effectElements.push(n);
                  }
                }),
                (BaseElement.prototype = {
                  checkMasks: function () {
                    if (!this.data.hasMask) return !1;
                    for (var t = 0, e = this.data.masksProperties.length; t < e; ) {
                      if ('n' !== this.data.masksProperties[t].mode && !1 !== this.data.masksProperties[t].cl)
                        return !0;
                      t += 1;
                    }
                    return !1;
                  },
                  initExpressions: function () {
                    var t = getExpressionInterfaces();
                    if (t) {
                      var e = t('layer'),
                        r = t('effects'),
                        n = t('shape'),
                        i = t('text'),
                        o = t('comp');
                      (this.layerInterface = e(this)),
                        this.data.hasMask &&
                          this.maskManager &&
                          this.layerInterface.registerMaskInterface(this.maskManager);
                      var a = r.createEffectsInterface(this, this.layerInterface);
                      this.layerInterface.registerEffectsInterface(a),
                        0 === this.data.ty || this.data.xt
                          ? (this.compInterface = o(this))
                          : 4 === this.data.ty
                          ? ((this.layerInterface.shapeInterface = n(
                              this.shapesData,
                              this.itemsData,
                              this.layerInterface,
                            )),
                            (this.layerInterface.content = this.layerInterface.shapeInterface))
                          : 5 === this.data.ty &&
                            ((this.layerInterface.textInterface = i(this)),
                            (this.layerInterface.text = this.layerInterface.textInterface));
                    }
                  },
                  setBlendMode: function () {
                    var t = getBlendMode(this.data.bm);
                    (this.baseElement || this.layerElement).style['mix-blend-mode'] = t;
                  },
                  initBaseData: function (t, e, r) {
                    (this.globalData = e),
                      (this.comp = r),
                      (this.data = t),
                      (this.layerId = createElementID()),
                      this.data.sr || (this.data.sr = 1),
                      (this.effectsManager = new EffectsManager(this.data, this, this.dynamicProperties));
                  },
                  getType: function () {
                    return this.type;
                  },
                  sourceRectAtTime: function () {},
                }),
                (FrameElement.prototype = {
                  initFrame: function () {
                    (this._isFirstFrame = !1), (this.dynamicProperties = []), (this._mdf = !1);
                  },
                  prepareProperties: function (t, e) {
                    var r,
                      n = this.dynamicProperties.length;
                    for (r = 0; r < n; r += 1)
                      (e || (this._isParent && 'transform' === this.dynamicProperties[r].propType)) &&
                        (this.dynamicProperties[r].getValue(),
                        this.dynamicProperties[r]._mdf && ((this.globalData._mdf = !0), (this._mdf = !0)));
                  },
                  addDynamicProperty: function (t) {
                    -1 === this.dynamicProperties.indexOf(t) && this.dynamicProperties.push(t);
                  },
                }),
                (FootageElement.prototype.prepareFrame = function () {}),
                extendPrototype([RenderableElement, BaseElement, FrameElement], FootageElement),
                (FootageElement.prototype.getBaseElement = function () {
                  return null;
                }),
                (FootageElement.prototype.renderFrame = function () {}),
                (FootageElement.prototype.destroy = function () {}),
                (FootageElement.prototype.initExpressions = function () {
                  var t = getExpressionInterfaces();
                  if (t) {
                    var e = t('footage');
                    this.layerInterface = e(this);
                  }
                }),
                (FootageElement.prototype.getFootageData = function () {
                  return this.footageData;
                }),
                (AudioElement.prototype.prepareFrame = function (t) {
                  if ((this.prepareRenderableFrame(t, !0), this.prepareProperties(t, !0), this.tm._placeholder))
                    this._currentTime = t / this.data.sr;
                  else {
                    var e = this.tm.v;
                    this._currentTime = e;
                  }
                  this._volume = this.lv.v[0];
                  var r = this._volume * this._volumeMultiplier;
                  this._previousVolume !== r && ((this._previousVolume = r), this.audio.volume(r));
                }),
                extendPrototype([RenderableElement, BaseElement, FrameElement], AudioElement),
                (AudioElement.prototype.renderFrame = function () {
                  this.isInRange &&
                    this._canPlay &&
                    (this._isPlaying
                      ? (!this.audio.playing() ||
                          Math.abs(this._currentTime / this.globalData.frameRate - this.audio.seek()) > 0.1) &&
                        this.audio.seek(this._currentTime / this.globalData.frameRate)
                      : (this.audio.play(),
                        this.audio.seek(this._currentTime / this.globalData.frameRate),
                        (this._isPlaying = !0)));
                }),
                (AudioElement.prototype.show = function () {}),
                (AudioElement.prototype.hide = function () {
                  this.audio.pause(), (this._isPlaying = !1);
                }),
                (AudioElement.prototype.pause = function () {
                  this.audio.pause(), (this._isPlaying = !1), (this._canPlay = !1);
                }),
                (AudioElement.prototype.resume = function () {
                  this._canPlay = !0;
                }),
                (AudioElement.prototype.setRate = function (t) {
                  this.audio.rate(t);
                }),
                (AudioElement.prototype.volume = function (t) {
                  (this._volumeMultiplier = t),
                    (this._previousVolume = t * this._volume),
                    this.audio.volume(this._previousVolume);
                }),
                (AudioElement.prototype.getBaseElement = function () {
                  return null;
                }),
                (AudioElement.prototype.destroy = function () {}),
                (AudioElement.prototype.sourceRectAtTime = function () {}),
                (AudioElement.prototype.initExpressions = function () {}),
                (BaseRenderer.prototype.checkLayers = function (t) {
                  var e,
                    r,
                    n = this.layers.length;
                  for (this.completeLayers = !0, e = n - 1; e >= 0; e -= 1)
                    this.elements[e] ||
                      ((r = this.layers[e]).ip - r.st <= t - this.layers[e].st &&
                        r.op - r.st > t - this.layers[e].st &&
                        this.buildItem(e)),
                      (this.completeLayers = !!this.elements[e] && this.completeLayers);
                  this.checkPendingElements();
                }),
                (BaseRenderer.prototype.createItem = function (t) {
                  switch (t.ty) {
                    case 2:
                      return this.createImage(t);
                    case 0:
                      return this.createComp(t);
                    case 1:
                      return this.createSolid(t);
                    case 3:
                    default:
                      return this.createNull(t);
                    case 4:
                      return this.createShape(t);
                    case 5:
                      return this.createText(t);
                    case 6:
                      return this.createAudio(t);
                    case 13:
                      return this.createCamera(t);
                    case 15:
                      return this.createFootage(t);
                  }
                }),
                (BaseRenderer.prototype.createCamera = function () {
                  throw new Error("You're using a 3d camera. Try the html renderer.");
                }),
                (BaseRenderer.prototype.createAudio = function (t) {
                  return new AudioElement(t, this.globalData, this);
                }),
                (BaseRenderer.prototype.createFootage = function (t) {
                  return new FootageElement(t, this.globalData, this);
                }),
                (BaseRenderer.prototype.buildAllItems = function () {
                  var t,
                    e = this.layers.length;
                  for (t = 0; t < e; t += 1) this.buildItem(t);
                  this.checkPendingElements();
                }),
                (BaseRenderer.prototype.includeLayers = function (t) {
                  var e;
                  this.completeLayers = !1;
                  var r,
                    n = t.length,
                    i = this.layers.length;
                  for (e = 0; e < n; e += 1)
                    for (r = 0; r < i; ) {
                      if (this.layers[r].id === t[e].id) {
                        this.layers[r] = t[e];
                        break;
                      }
                      r += 1;
                    }
                }),
                (BaseRenderer.prototype.setProjectInterface = function (t) {
                  this.globalData.projectInterface = t;
                }),
                (BaseRenderer.prototype.initItems = function () {
                  this.globalData.progressiveLoad || this.buildAllItems();
                }),
                (BaseRenderer.prototype.buildElementParenting = function (t, e, r) {
                  for (var n = this.elements, i = this.layers, o = 0, a = i.length; o < a; )
                    i[o].ind == e &&
                      (n[o] && !0 !== n[o]
                        ? (r.push(n[o]),
                          n[o].setAsParent(),
                          void 0 !== i[o].parent ? this.buildElementParenting(t, i[o].parent, r) : t.setHierarchy(r))
                        : (this.buildItem(o), this.addPendingElement(t))),
                      (o += 1);
                }),
                (BaseRenderer.prototype.addPendingElement = function (t) {
                  this.pendingElements.push(t);
                }),
                (BaseRenderer.prototype.searchExtraCompositions = function (t) {
                  var e,
                    r = t.length;
                  for (e = 0; e < r; e += 1)
                    if (t[e].xt) {
                      var n = this.createComp(t[e]);
                      n.initExpressions(), this.globalData.projectInterface.registerComposition(n);
                    }
                }),
                (BaseRenderer.prototype.getElementByPath = function (t) {
                  var e,
                    r = t.shift();
                  if ('number' == typeof r) e = this.elements[r];
                  else {
                    var n,
                      i = this.elements.length;
                    for (n = 0; n < i; n += 1)
                      if (this.elements[n].data.nm === r) {
                        e = this.elements[n];
                        break;
                      }
                  }
                  return 0 === t.length ? e : e.getElementByPath(t);
                }),
                (BaseRenderer.prototype.setupGlobalData = function (t, e) {
                  (this.globalData.fontManager = new FontManager()),
                    this.globalData.fontManager.addChars(t.chars),
                    this.globalData.fontManager.addFonts(t.fonts, e),
                    (this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem)),
                    (this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem)),
                    (this.globalData.imageLoader = this.animationItem.imagePreloader),
                    (this.globalData.audioController = this.animationItem.audioController),
                    (this.globalData.frameId = 0),
                    (this.globalData.frameRate = t.fr),
                    (this.globalData.nm = t.nm),
                    (this.globalData.compSize = { w: t.w, h: t.h });
                }),
                (TransformElement.prototype = {
                  initTransform: function () {
                    (this.finalTransform = {
                      mProp: this.data.ks
                        ? TransformPropertyFactory.getTransformProperty(this, this.data.ks, this)
                        : { o: 0 },
                      _matMdf: !1,
                      _opMdf: !1,
                      mat: new Matrix(),
                    }),
                      this.data.ao && (this.finalTransform.mProp.autoOriented = !0),
                      this.data.ty;
                  },
                  renderTransform: function () {
                    if (
                      ((this.finalTransform._opMdf = this.finalTransform.mProp.o._mdf || this._isFirstFrame),
                      (this.finalTransform._matMdf = this.finalTransform.mProp._mdf || this._isFirstFrame),
                      this.hierarchy)
                    ) {
                      var t,
                        e = this.finalTransform.mat,
                        r = 0,
                        n = this.hierarchy.length;
                      if (!this.finalTransform._matMdf)
                        for (; r < n; ) {
                          if (this.hierarchy[r].finalTransform.mProp._mdf) {
                            this.finalTransform._matMdf = !0;
                            break;
                          }
                          r += 1;
                        }
                      if (this.finalTransform._matMdf)
                        for (t = this.finalTransform.mProp.v.props, e.cloneFromProps(t), r = 0; r < n; r += 1)
                          (t = this.hierarchy[r].finalTransform.mProp.v.props),
                            e.transform(
                              t[0],
                              t[1],
                              t[2],
                              t[3],
                              t[4],
                              t[5],
                              t[6],
                              t[7],
                              t[8],
                              t[9],
                              t[10],
                              t[11],
                              t[12],
                              t[13],
                              t[14],
                              t[15],
                            );
                    }
                  },
                  globalToLocal: function (t) {
                    var e = [];
                    e.push(this.finalTransform);
                    for (var r, n = !0, i = this.comp; n; )
                      i.finalTransform ? (i.data.hasMask && e.splice(0, 0, i.finalTransform), (i = i.comp)) : (n = !1);
                    var o,
                      a = e.length;
                    for (r = 0; r < a; r += 1)
                      (o = e[r].mat.applyToPointArray(0, 0, 0)), (t = [t[0] - o[0], t[1] - o[1], 0]);
                    return t;
                  },
                  mHelper: new Matrix(),
                }),
                (MaskElement.prototype.getMaskProperty = function (t) {
                  return this.viewData[t].prop;
                }),
                (MaskElement.prototype.renderFrame = function (t) {
                  var e,
                    r = this.element.finalTransform.mat,
                    n = this.masksProperties.length;
                  for (e = 0; e < n; e += 1)
                    if (
                      ((this.viewData[e].prop._mdf || t) &&
                        this.drawPath(this.masksProperties[e], this.viewData[e].prop.v, this.viewData[e]),
                      (this.viewData[e].op._mdf || t) &&
                        this.viewData[e].elem.setAttribute('fill-opacity', this.viewData[e].op.v),
                      'n' !== this.masksProperties[e].mode &&
                        (this.viewData[e].invRect &&
                          (this.element.finalTransform.mProp._mdf || t) &&
                          this.viewData[e].invRect.setAttribute('transform', r.getInverseMatrix().to2dCSS()),
                        this.storedData[e].x && (this.storedData[e].x._mdf || t)))
                    ) {
                      var i = this.storedData[e].expan;
                      this.storedData[e].x.v < 0
                        ? ('erode' !== this.storedData[e].lastOperator &&
                            ((this.storedData[e].lastOperator = 'erode'),
                            this.storedData[e].elem.setAttribute(
                              'filter',
                              'url(' + getLocationHref() + '#' + this.storedData[e].filterId + ')',
                            )),
                          i.setAttribute('radius', -this.storedData[e].x.v))
                        : ('dilate' !== this.storedData[e].lastOperator &&
                            ((this.storedData[e].lastOperator = 'dilate'),
                            this.storedData[e].elem.setAttribute('filter', null)),
                          this.storedData[e].elem.setAttribute('stroke-width', 2 * this.storedData[e].x.v));
                    }
                }),
                (MaskElement.prototype.getMaskelement = function () {
                  return this.maskElement;
                }),
                (MaskElement.prototype.createLayerSolidPath = function () {
                  var t = 'M0,0 ';
                  return (
                    (t += ' h' + this.globalData.compSize.w),
                    (t += ' v' + this.globalData.compSize.h),
                    (t += ' h-' + this.globalData.compSize.w) + ' v-' + this.globalData.compSize.h + ' '
                  );
                }),
                (MaskElement.prototype.drawPath = function (t, e, r) {
                  var n,
                    i,
                    o = ' M' + e.v[0][0] + ',' + e.v[0][1];
                  for (i = e._length, n = 1; n < i; n += 1)
                    o +=
                      ' C' +
                      e.o[n - 1][0] +
                      ',' +
                      e.o[n - 1][1] +
                      ' ' +
                      e.i[n][0] +
                      ',' +
                      e.i[n][1] +
                      ' ' +
                      e.v[n][0] +
                      ',' +
                      e.v[n][1];
                  if (
                    (e.c &&
                      i > 1 &&
                      (o +=
                        ' C' +
                        e.o[n - 1][0] +
                        ',' +
                        e.o[n - 1][1] +
                        ' ' +
                        e.i[0][0] +
                        ',' +
                        e.i[0][1] +
                        ' ' +
                        e.v[0][0] +
                        ',' +
                        e.v[0][1]),
                    r.lastPath !== o)
                  ) {
                    var a = '';
                    r.elem && (e.c && (a = t.inv ? this.solidPath + o : o), r.elem.setAttribute('d', a)),
                      (r.lastPath = o);
                  }
                }),
                (MaskElement.prototype.destroy = function () {
                  (this.element = null),
                    (this.globalData = null),
                    (this.maskElement = null),
                    (this.data = null),
                    (this.masksProperties = null);
                });
              var filtersFactory = (function () {
                  var t = {
                    createFilter: function (t, e) {
                      var r = createNS('filter');
                      return (
                        r.setAttribute('id', t),
                        !0 !== e &&
                          (r.setAttribute('filterUnits', 'objectBoundingBox'),
                          r.setAttribute('x', '0%'),
                          r.setAttribute('y', '0%'),
                          r.setAttribute('width', '100%'),
                          r.setAttribute('height', '100%')),
                        r
                      );
                    },
                    createAlphaToLuminanceFilter: function () {
                      var t = createNS('feColorMatrix');
                      return (
                        t.setAttribute('type', 'matrix'),
                        t.setAttribute('color-interpolation-filters', 'sRGB'),
                        t.setAttribute('values', '0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1'),
                        t
                      );
                    },
                  };
                  return t;
                })(),
                featureSupport = (function () {
                  var t = { maskType: !0 };
                  return (
                    (/MSIE 10/i.test(navigator.userAgent) ||
                      /MSIE 9/i.test(navigator.userAgent) ||
                      /rv:11.0/i.test(navigator.userAgent) ||
                      /Edge\/\d./i.test(navigator.userAgent)) &&
                      (t.maskType = !1),
                    t
                  );
                })(),
                registeredEffects = {},
                idPrefix = 'filter_result_';
              function SVGEffects(t) {
                var e,
                  r,
                  n = 'SourceGraphic',
                  i = t.data.ef ? t.data.ef.length : 0,
                  o = createElementID(),
                  a = filtersFactory.createFilter(o, !0),
                  s = 0;
                for (this.filters = [], e = 0; e < i; e += 1) {
                  r = null;
                  var l = t.data.ef[e].ty;
                  registeredEffects[l] &&
                    ((r = new (0, registeredEffects[l].effect)(
                      a,
                      t.effectsManager.effectElements[e],
                      t,
                      idPrefix + s,
                      n,
                    )),
                    (n = idPrefix + s),
                    registeredEffects[l].countsAsEffect && (s += 1)),
                    r && this.filters.push(r);
                }
                s &&
                  (t.globalData.defs.appendChild(a),
                  t.layerElement.setAttribute('filter', 'url(' + getLocationHref() + '#' + o + ')')),
                  this.filters.length && t.addRenderableComponent(this);
              }
              function registerEffect(t, e, r) {
                registeredEffects[t] = { effect: e, countsAsEffect: r };
              }
              function SVGBaseElement() {}
              function HierarchyElement() {}
              function RenderableDOMElement() {}
              function IImageElement(t, e, r) {
                (this.assetData = e.getAssetData(t.refId)),
                  this.initElement(t, e, r),
                  (this.sourceRect = { top: 0, left: 0, width: this.assetData.w, height: this.assetData.h });
              }
              function ProcessedElement(t, e) {
                (this.elem = t), (this.pos = e);
              }
              function IShapeElement() {}
              (SVGEffects.prototype.renderFrame = function (t) {
                var e,
                  r = this.filters.length;
                for (e = 0; e < r; e += 1) this.filters[e].renderFrame(t);
              }),
                (SVGBaseElement.prototype = {
                  initRendererElement: function () {
                    this.layerElement = createNS('g');
                  },
                  createContainerElements: function () {
                    (this.matteElement = createNS('g')),
                      (this.transformedElement = this.layerElement),
                      (this.maskedElement = this.layerElement),
                      (this._sizeChanged = !1);
                    var t = null;
                    if (this.data.td) {
                      this.matteMasks = {};
                      var e = createNS('symbol');
                      e.setAttribute('id', this.layerId);
                      var r = createNS('g');
                      r.appendChild(this.layerElement), e.appendChild(r), (t = r), this.globalData.defs.appendChild(e);
                    } else
                      this.data.tt
                        ? (this.matteElement.appendChild(this.layerElement),
                          (t = this.matteElement),
                          (this.baseElement = this.matteElement))
                        : (this.baseElement = this.layerElement);
                    if (
                      (this.data.ln && this.layerElement.setAttribute('id', this.data.ln),
                      this.data.cl && this.layerElement.setAttribute('class', this.data.cl),
                      0 === this.data.ty && !this.data.hd)
                    ) {
                      var n = createNS('clipPath'),
                        i = createNS('path');
                      i.setAttribute(
                        'd',
                        'M0,0 L' + this.data.w + ',0 L' + this.data.w + ',' + this.data.h + ' L0,' + this.data.h + 'z',
                      );
                      var o = createElementID();
                      if (
                        (n.setAttribute('id', o),
                        n.appendChild(i),
                        this.globalData.defs.appendChild(n),
                        this.checkMasks())
                      ) {
                        var a = createNS('g');
                        a.setAttribute('clip-path', 'url(' + getLocationHref() + '#' + o + ')'),
                          a.appendChild(this.layerElement),
                          (this.transformedElement = a),
                          t ? t.appendChild(this.transformedElement) : (this.baseElement = this.transformedElement);
                      } else this.layerElement.setAttribute('clip-path', 'url(' + getLocationHref() + '#' + o + ')');
                    }
                    0 !== this.data.bm && this.setBlendMode();
                  },
                  renderElement: function () {
                    this.finalTransform._matMdf &&
                      this.transformedElement.setAttribute('transform', this.finalTransform.mat.to2dCSS()),
                      this.finalTransform._opMdf &&
                        this.transformedElement.setAttribute('opacity', this.finalTransform.mProp.o.v);
                  },
                  destroyBaseElement: function () {
                    (this.layerElement = null), (this.matteElement = null), this.maskManager.destroy();
                  },
                  getBaseElement: function () {
                    return this.data.hd ? null : this.baseElement;
                  },
                  createRenderableComponents: function () {
                    (this.maskManager = new MaskElement(this.data, this, this.globalData)),
                      (this.renderableEffectsManager = new SVGEffects(this));
                  },
                  getMatte: function (t) {
                    if (!this.matteMasks[t]) {
                      var e,
                        r,
                        n,
                        i,
                        o = this.layerId + '_' + t;
                      if (1 === t || 3 === t) {
                        var a = createNS('mask');
                        a.setAttribute('id', o),
                          a.setAttribute('mask-type', 3 === t ? 'luminance' : 'alpha'),
                          (n = createNS('use')).setAttributeNS(
                            'http://www.w3.org/1999/xlink',
                            'href',
                            '#' + this.layerId,
                          ),
                          a.appendChild(n),
                          this.globalData.defs.appendChild(a),
                          featureSupport.maskType ||
                            1 !== t ||
                            (a.setAttribute('mask-type', 'luminance'),
                            (e = createElementID()),
                            (r = filtersFactory.createFilter(e)),
                            this.globalData.defs.appendChild(r),
                            r.appendChild(filtersFactory.createAlphaToLuminanceFilter()),
                            (i = createNS('g')).appendChild(n),
                            a.appendChild(i),
                            i.setAttribute('filter', 'url(' + getLocationHref() + '#' + e + ')'));
                      } else if (2 === t) {
                        var s = createNS('mask');
                        s.setAttribute('id', o), s.setAttribute('mask-type', 'alpha');
                        var l = createNS('g');
                        s.appendChild(l), (e = createElementID()), (r = filtersFactory.createFilter(e));
                        var c = createNS('feComponentTransfer');
                        c.setAttribute('in', 'SourceGraphic'), r.appendChild(c);
                        var h = createNS('feFuncA');
                        h.setAttribute('type', 'table'),
                          h.setAttribute('tableValues', '1.0 0.0'),
                          c.appendChild(h),
                          this.globalData.defs.appendChild(r);
                        var u = createNS('rect');
                        u.setAttribute('width', this.comp.data.w),
                          u.setAttribute('height', this.comp.data.h),
                          u.setAttribute('x', '0'),
                          u.setAttribute('y', '0'),
                          u.setAttribute('fill', '#ffffff'),
                          u.setAttribute('opacity', '0'),
                          l.setAttribute('filter', 'url(' + getLocationHref() + '#' + e + ')'),
                          l.appendChild(u),
                          (n = createNS('use')).setAttributeNS(
                            'http://www.w3.org/1999/xlink',
                            'href',
                            '#' + this.layerId,
                          ),
                          l.appendChild(n),
                          featureSupport.maskType ||
                            (s.setAttribute('mask-type', 'luminance'),
                            r.appendChild(filtersFactory.createAlphaToLuminanceFilter()),
                            (i = createNS('g')),
                            l.appendChild(u),
                            i.appendChild(this.layerElement),
                            l.appendChild(i)),
                          this.globalData.defs.appendChild(s);
                      }
                      this.matteMasks[t] = o;
                    }
                    return this.matteMasks[t];
                  },
                  setMatte: function (t) {
                    this.matteElement &&
                      this.matteElement.setAttribute('mask', 'url(' + getLocationHref() + '#' + t + ')');
                  },
                }),
                (HierarchyElement.prototype = {
                  initHierarchy: function () {
                    (this.hierarchy = []), (this._isParent = !1), this.checkParenting();
                  },
                  setHierarchy: function (t) {
                    this.hierarchy = t;
                  },
                  setAsParent: function () {
                    this._isParent = !0;
                  },
                  checkParenting: function () {
                    void 0 !== this.data.parent && this.comp.buildElementParenting(this, this.data.parent, []);
                  },
                }),
                extendPrototype(
                  [
                    RenderableElement,
                    createProxyFunction({
                      initElement: function (t, e, r) {
                        this.initFrame(),
                          this.initBaseData(t, e, r),
                          this.initTransform(t, e, r),
                          this.initHierarchy(),
                          this.initRenderable(),
                          this.initRendererElement(),
                          this.createContainerElements(),
                          this.createRenderableComponents(),
                          this.createContent(),
                          this.hide();
                      },
                      hide: function () {
                        this.hidden ||
                          (this.isInRange && !this.isTransparent) ||
                          (((this.baseElement || this.layerElement).style.display = 'none'), (this.hidden = !0));
                      },
                      show: function () {
                        this.isInRange &&
                          !this.isTransparent &&
                          (this.data.hd || ((this.baseElement || this.layerElement).style.display = 'block'),
                          (this.hidden = !1),
                          (this._isFirstFrame = !0));
                      },
                      renderFrame: function () {
                        this.data.hd ||
                          this.hidden ||
                          (this.renderTransform(),
                          this.renderRenderable(),
                          this.renderElement(),
                          this.renderInnerContent(),
                          this._isFirstFrame && (this._isFirstFrame = !1));
                      },
                      renderInnerContent: function () {},
                      prepareFrame: function (t) {
                        (this._mdf = !1),
                          this.prepareRenderableFrame(t),
                          this.prepareProperties(t, this.isInRange),
                          this.checkTransparency();
                      },
                      destroy: function () {
                        (this.innerElem = null), this.destroyBaseElement();
                      },
                    }),
                  ],
                  RenderableDOMElement,
                ),
                extendPrototype(
                  [BaseElement, TransformElement, SVGBaseElement, HierarchyElement, FrameElement, RenderableDOMElement],
                  IImageElement,
                ),
                (IImageElement.prototype.createContent = function () {
                  var t = this.globalData.getAssetsPath(this.assetData);
                  (this.innerElem = createNS('image')),
                    this.innerElem.setAttribute('width', this.assetData.w + 'px'),
                    this.innerElem.setAttribute('height', this.assetData.h + 'px'),
                    this.innerElem.setAttribute(
                      'preserveAspectRatio',
                      this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio,
                    ),
                    this.innerElem.setAttributeNS('http://www.w3.org/1999/xlink', 'href', t),
                    this.layerElement.appendChild(this.innerElem);
                }),
                (IImageElement.prototype.sourceRectAtTime = function () {
                  return this.sourceRect;
                }),
                (IShapeElement.prototype = {
                  addShapeToModifiers: function (t) {
                    var e,
                      r = this.shapeModifiers.length;
                    for (e = 0; e < r; e += 1) this.shapeModifiers[e].addShape(t);
                  },
                  isShapeInAnimatedModifiers: function (t) {
                    for (var e = this.shapeModifiers.length; 0 < e; )
                      if (this.shapeModifiers[0].isAnimatedWithShape(t)) return !0;
                    return !1;
                  },
                  renderModifiers: function () {
                    if (this.shapeModifiers.length) {
                      var t,
                        e = this.shapes.length;
                      for (t = 0; t < e; t += 1) this.shapes[t].sh.reset();
                      for (
                        t = (e = this.shapeModifiers.length) - 1;
                        t >= 0 && !this.shapeModifiers[t].processShapes(this._isFirstFrame);
                        t -= 1
                      );
                    }
                  },
                  searchProcessedElement: function (t) {
                    for (var e = this.processedElements, r = 0, n = e.length; r < n; ) {
                      if (e[r].elem === t) return e[r].pos;
                      r += 1;
                    }
                    return 0;
                  },
                  addProcessedElement: function (t, e) {
                    for (var r = this.processedElements, n = r.length; n; )
                      if (r[(n -= 1)].elem === t) return void (r[n].pos = e);
                    r.push(new ProcessedElement(t, e));
                  },
                  prepareFrame: function (t) {
                    this.prepareRenderableFrame(t), this.prepareProperties(t, this.isInRange);
                  },
                });
              var lineCapEnum = { 1: 'butt', 2: 'round', 3: 'square' },
                lineJoinEnum = { 1: 'miter', 2: 'round', 3: 'bevel' };
              function SVGShapeData(t, e, r) {
                (this.caches = []),
                  (this.styles = []),
                  (this.transformers = t),
                  (this.lStr = ''),
                  (this.sh = r),
                  (this.lvl = e),
                  (this._isAnimated = !!r.k);
                for (var n = 0, i = t.length; n < i; ) {
                  if (t[n].mProps.dynamicProperties.length) {
                    this._isAnimated = !0;
                    break;
                  }
                  n += 1;
                }
              }
              function SVGStyleData(t, e) {
                (this.data = t),
                  (this.type = t.ty),
                  (this.d = ''),
                  (this.lvl = e),
                  (this._mdf = !1),
                  (this.closed = !0 === t.hd),
                  (this.pElem = createNS('path')),
                  (this.msElem = null);
              }
              function DashProperty(t, e, r, n) {
                var i;
                (this.elem = t),
                  (this.frameId = -1),
                  (this.dataProps = createSizedArray(e.length)),
                  (this.renderer = r),
                  (this.k = !1),
                  (this.dashStr = ''),
                  (this.dashArray = createTypedArray('float32', e.length ? e.length - 1 : 0)),
                  (this.dashoffset = createTypedArray('float32', 1)),
                  this.initDynamicPropertyContainer(n);
                var o,
                  a = e.length || 0;
                for (i = 0; i < a; i += 1)
                  (o = PropertyFactory.getProp(t, e[i].v, 0, 0, this)),
                    (this.k = o.k || this.k),
                    (this.dataProps[i] = { n: e[i].n, p: o });
                this.k || this.getValue(!0), (this._isAnimated = this.k);
              }
              function SVGStrokeStyleData(t, e, r) {
                this.initDynamicPropertyContainer(t),
                  (this.getValue = this.iterateDynamicProperties),
                  (this.o = PropertyFactory.getProp(t, e.o, 0, 0.01, this)),
                  (this.w = PropertyFactory.getProp(t, e.w, 0, null, this)),
                  (this.d = new DashProperty(t, e.d || {}, 'svg', this)),
                  (this.c = PropertyFactory.getProp(t, e.c, 1, 255, this)),
                  (this.style = r),
                  (this._isAnimated = !!this._isAnimated);
              }
              function SVGFillStyleData(t, e, r) {
                this.initDynamicPropertyContainer(t),
                  (this.getValue = this.iterateDynamicProperties),
                  (this.o = PropertyFactory.getProp(t, e.o, 0, 0.01, this)),
                  (this.c = PropertyFactory.getProp(t, e.c, 1, 255, this)),
                  (this.style = r);
              }
              function SVGNoStyleData(t, e, r) {
                this.initDynamicPropertyContainer(t), (this.getValue = this.iterateDynamicProperties), (this.style = r);
              }
              function GradientProperty(t, e, r) {
                (this.data = e), (this.c = createTypedArray('uint8c', 4 * e.p));
                var n = e.k.k[0].s ? e.k.k[0].s.length - 4 * e.p : e.k.k.length - 4 * e.p;
                (this.o = createTypedArray('float32', n)),
                  (this._cmdf = !1),
                  (this._omdf = !1),
                  (this._collapsable = this.checkCollapsable()),
                  (this._hasOpacity = n),
                  this.initDynamicPropertyContainer(r),
                  (this.prop = PropertyFactory.getProp(t, e.k, 1, null, this)),
                  (this.k = this.prop.k),
                  this.getValue(!0);
              }
              function SVGGradientFillStyleData(t, e, r) {
                this.initDynamicPropertyContainer(t),
                  (this.getValue = this.iterateDynamicProperties),
                  this.initGradientData(t, e, r);
              }
              function SVGGradientStrokeStyleData(t, e, r) {
                this.initDynamicPropertyContainer(t),
                  (this.getValue = this.iterateDynamicProperties),
                  (this.w = PropertyFactory.getProp(t, e.w, 0, null, this)),
                  (this.d = new DashProperty(t, e.d || {}, 'svg', this)),
                  this.initGradientData(t, e, r),
                  (this._isAnimated = !!this._isAnimated);
              }
              function ShapeGroupData() {
                (this.it = []), (this.prevViewData = []), (this.gr = createNS('g'));
              }
              function SVGTransformData(t, e, r) {
                (this.transform = { mProps: t, op: e, container: r }),
                  (this.elements = []),
                  (this._isAnimated =
                    this.transform.mProps.dynamicProperties.length || this.transform.op.effectsSequence.length);
              }
              (SVGShapeData.prototype.setAsAnimated = function () {
                this._isAnimated = !0;
              }),
                (SVGStyleData.prototype.reset = function () {
                  (this.d = ''), (this._mdf = !1);
                }),
                (DashProperty.prototype.getValue = function (t) {
                  if (
                    (this.elem.globalData.frameId !== this.frameId || t) &&
                    ((this.frameId = this.elem.globalData.frameId),
                    this.iterateDynamicProperties(),
                    (this._mdf = this._mdf || t),
                    this._mdf)
                  ) {
                    var e = 0,
                      r = this.dataProps.length;
                    for ('svg' === this.renderer && (this.dashStr = ''), e = 0; e < r; e += 1)
                      'o' !== this.dataProps[e].n
                        ? 'svg' === this.renderer
                          ? (this.dashStr += ' ' + this.dataProps[e].p.v)
                          : (this.dashArray[e] = this.dataProps[e].p.v)
                        : (this.dashoffset[0] = this.dataProps[e].p.v);
                  }
                }),
                extendPrototype([DynamicPropertyContainer], DashProperty),
                extendPrototype([DynamicPropertyContainer], SVGStrokeStyleData),
                extendPrototype([DynamicPropertyContainer], SVGFillStyleData),
                extendPrototype([DynamicPropertyContainer], SVGNoStyleData),
                (GradientProperty.prototype.comparePoints = function (t, e) {
                  for (var r = 0, n = this.o.length / 2; r < n; ) {
                    if (Math.abs(t[4 * r] - t[4 * e + 2 * r]) > 0.01) return !1;
                    r += 1;
                  }
                  return !0;
                }),
                (GradientProperty.prototype.checkCollapsable = function () {
                  if (this.o.length / 2 != this.c.length / 4) return !1;
                  if (this.data.k.k[0].s)
                    for (var t = 0, e = this.data.k.k.length; t < e; ) {
                      if (!this.comparePoints(this.data.k.k[t].s, this.data.p)) return !1;
                      t += 1;
                    }
                  else if (!this.comparePoints(this.data.k.k, this.data.p)) return !1;
                  return !0;
                }),
                (GradientProperty.prototype.getValue = function (t) {
                  if (
                    (this.prop.getValue(), (this._mdf = !1), (this._cmdf = !1), (this._omdf = !1), this.prop._mdf || t)
                  ) {
                    var e,
                      r,
                      n,
                      i = 4 * this.data.p;
                    for (e = 0; e < i; e += 1)
                      (r = e % 4 == 0 ? 100 : 255),
                        (n = Math.round(this.prop.v[e] * r)),
                        this.c[e] !== n && ((this.c[e] = n), (this._cmdf = !t));
                    if (this.o.length)
                      for (i = this.prop.v.length, e = 4 * this.data.p; e < i; e += 1)
                        (r = e % 2 == 0 ? 100 : 1),
                          (n = e % 2 == 0 ? Math.round(100 * this.prop.v[e]) : this.prop.v[e]),
                          this.o[e - 4 * this.data.p] !== n && ((this.o[e - 4 * this.data.p] = n), (this._omdf = !t));
                    this._mdf = !t;
                  }
                }),
                extendPrototype([DynamicPropertyContainer], GradientProperty),
                (SVGGradientFillStyleData.prototype.initGradientData = function (t, e, r) {
                  (this.o = PropertyFactory.getProp(t, e.o, 0, 0.01, this)),
                    (this.s = PropertyFactory.getProp(t, e.s, 1, null, this)),
                    (this.e = PropertyFactory.getProp(t, e.e, 1, null, this)),
                    (this.h = PropertyFactory.getProp(t, e.h || { k: 0 }, 0, 0.01, this)),
                    (this.a = PropertyFactory.getProp(t, e.a || { k: 0 }, 0, degToRads, this)),
                    (this.g = new GradientProperty(t, e.g, this)),
                    (this.style = r),
                    (this.stops = []),
                    this.setGradientData(r.pElem, e),
                    this.setGradientOpacity(e, r),
                    (this._isAnimated = !!this._isAnimated);
                }),
                (SVGGradientFillStyleData.prototype.setGradientData = function (t, e) {
                  var r = createElementID(),
                    n = createNS(1 === e.t ? 'linearGradient' : 'radialGradient');
                  n.setAttribute('id', r),
                    n.setAttribute('spreadMethod', 'pad'),
                    n.setAttribute('gradientUnits', 'userSpaceOnUse');
                  var i,
                    o,
                    a,
                    s = [];
                  for (a = 4 * e.g.p, o = 0; o < a; o += 4) (i = createNS('stop')), n.appendChild(i), s.push(i);
                  t.setAttribute('gf' === e.ty ? 'fill' : 'stroke', 'url(' + getLocationHref() + '#' + r + ')'),
                    (this.gf = n),
                    (this.cst = s);
                }),
                (SVGGradientFillStyleData.prototype.setGradientOpacity = function (t, e) {
                  if (this.g._hasOpacity && !this.g._collapsable) {
                    var r,
                      n,
                      i,
                      o = createNS('mask'),
                      a = createNS('path');
                    o.appendChild(a);
                    var s = createElementID(),
                      l = createElementID();
                    o.setAttribute('id', l);
                    var c = createNS(1 === t.t ? 'linearGradient' : 'radialGradient');
                    c.setAttribute('id', s),
                      c.setAttribute('spreadMethod', 'pad'),
                      c.setAttribute('gradientUnits', 'userSpaceOnUse'),
                      (i = t.g.k.k[0].s ? t.g.k.k[0].s.length : t.g.k.k.length);
                    var h = this.stops;
                    for (n = 4 * t.g.p; n < i; n += 2)
                      (r = createNS('stop')).setAttribute('stop-color', 'rgb(255,255,255)'),
                        c.appendChild(r),
                        h.push(r);
                    a.setAttribute('gf' === t.ty ? 'fill' : 'stroke', 'url(' + getLocationHref() + '#' + s + ')'),
                      'gs' === t.ty &&
                        (a.setAttribute('stroke-linecap', lineCapEnum[t.lc || 2]),
                        a.setAttribute('stroke-linejoin', lineJoinEnum[t.lj || 2]),
                        1 === t.lj && a.setAttribute('stroke-miterlimit', t.ml)),
                      (this.of = c),
                      (this.ms = o),
                      (this.ost = h),
                      (this.maskId = l),
                      (e.msElem = a);
                  }
                }),
                extendPrototype([DynamicPropertyContainer], SVGGradientFillStyleData),
                extendPrototype([SVGGradientFillStyleData, DynamicPropertyContainer], SVGGradientStrokeStyleData);
              var buildShapeString = function (t, e, r, n) {
                  if (0 === e) return '';
                  var i,
                    o = t.o,
                    a = t.i,
                    s = t.v,
                    l = ' M' + n.applyToPointStringified(s[0][0], s[0][1]);
                  for (i = 1; i < e; i += 1)
                    l +=
                      ' C' +
                      n.applyToPointStringified(o[i - 1][0], o[i - 1][1]) +
                      ' ' +
                      n.applyToPointStringified(a[i][0], a[i][1]) +
                      ' ' +
                      n.applyToPointStringified(s[i][0], s[i][1]);
                  return (
                    r &&
                      e &&
                      ((l +=
                        ' C' +
                        n.applyToPointStringified(o[i - 1][0], o[i - 1][1]) +
                        ' ' +
                        n.applyToPointStringified(a[0][0], a[0][1]) +
                        ' ' +
                        n.applyToPointStringified(s[0][0], s[0][1])),
                      (l += 'z')),
                    l
                  );
                },
                SVGElementsRenderer = (function () {
                  var t = new Matrix(),
                    e = new Matrix();
                  function r(t, e, r) {
                    (r || e.transform.op._mdf) && e.transform.container.setAttribute('opacity', e.transform.op.v),
                      (r || e.transform.mProps._mdf) &&
                        e.transform.container.setAttribute('transform', e.transform.mProps.v.to2dCSS());
                  }
                  function n() {}
                  function i(r, n, i) {
                    var o,
                      a,
                      s,
                      l,
                      c,
                      h,
                      u,
                      p,
                      f,
                      d,
                      m,
                      y = n.styles.length,
                      g = n.lvl;
                    for (h = 0; h < y; h += 1) {
                      if (((l = n.sh._mdf || i), n.styles[h].lvl < g)) {
                        for (p = e.reset(), d = g - n.styles[h].lvl, m = n.transformers.length - 1; !l && d > 0; )
                          (l = n.transformers[m].mProps._mdf || l), (d -= 1), (m -= 1);
                        if (l)
                          for (d = g - n.styles[h].lvl, m = n.transformers.length - 1; d > 0; )
                            (f = n.transformers[m].mProps.v.props),
                              p.transform(
                                f[0],
                                f[1],
                                f[2],
                                f[3],
                                f[4],
                                f[5],
                                f[6],
                                f[7],
                                f[8],
                                f[9],
                                f[10],
                                f[11],
                                f[12],
                                f[13],
                                f[14],
                                f[15],
                              ),
                              (d -= 1),
                              (m -= 1);
                      } else p = t;
                      if (((a = (u = n.sh.paths)._length), l)) {
                        for (s = '', o = 0; o < a; o += 1)
                          (c = u.shapes[o]) && c._length && (s += buildShapeString(c, c._length, c.c, p));
                        n.caches[h] = s;
                      } else s = n.caches[h];
                      (n.styles[h].d += !0 === r.hd ? '' : s), (n.styles[h]._mdf = l || n.styles[h]._mdf);
                    }
                  }
                  function o(t, e, r) {
                    var n = e.style;
                    (e.c._mdf || r) &&
                      n.pElem.setAttribute(
                        'fill',
                        'rgb(' + bmFloor(e.c.v[0]) + ',' + bmFloor(e.c.v[1]) + ',' + bmFloor(e.c.v[2]) + ')',
                      ),
                      (e.o._mdf || r) && n.pElem.setAttribute('fill-opacity', e.o.v);
                  }
                  function a(t, e, r) {
                    s(t, e, r), l(0, e, r);
                  }
                  function s(t, e, r) {
                    var n,
                      i,
                      o,
                      a,
                      s,
                      l = e.gf,
                      c = e.g._hasOpacity,
                      h = e.s.v,
                      u = e.e.v;
                    if (e.o._mdf || r) {
                      var p = 'gf' === t.ty ? 'fill-opacity' : 'stroke-opacity';
                      e.style.pElem.setAttribute(p, e.o.v);
                    }
                    if (e.s._mdf || r) {
                      var f = 1 === t.t ? 'x1' : 'cx',
                        d = 'x1' === f ? 'y1' : 'cy';
                      l.setAttribute(f, h[0]),
                        l.setAttribute(d, h[1]),
                        c && !e.g._collapsable && (e.of.setAttribute(f, h[0]), e.of.setAttribute(d, h[1]));
                    }
                    if (e.g._cmdf || r) {
                      n = e.cst;
                      var m = e.g.c;
                      for (o = n.length, i = 0; i < o; i += 1)
                        (a = n[i]).setAttribute('offset', m[4 * i] + '%'),
                          a.setAttribute(
                            'stop-color',
                            'rgb(' + m[4 * i + 1] + ',' + m[4 * i + 2] + ',' + m[4 * i + 3] + ')',
                          );
                    }
                    if (c && (e.g._omdf || r)) {
                      var y = e.g.o;
                      for (o = (n = e.g._collapsable ? e.cst : e.ost).length, i = 0; i < o; i += 1)
                        (a = n[i]),
                          e.g._collapsable || a.setAttribute('offset', y[2 * i] + '%'),
                          a.setAttribute('stop-opacity', y[2 * i + 1]);
                    }
                    if (1 === t.t)
                      (e.e._mdf || r) &&
                        (l.setAttribute('x2', u[0]),
                        l.setAttribute('y2', u[1]),
                        c && !e.g._collapsable && (e.of.setAttribute('x2', u[0]), e.of.setAttribute('y2', u[1])));
                    else if (
                      ((e.s._mdf || e.e._mdf || r) &&
                        ((s = Math.sqrt(Math.pow(h[0] - u[0], 2) + Math.pow(h[1] - u[1], 2))),
                        l.setAttribute('r', s),
                        c && !e.g._collapsable && e.of.setAttribute('r', s)),
                      e.e._mdf || e.h._mdf || e.a._mdf || r)
                    ) {
                      s || (s = Math.sqrt(Math.pow(h[0] - u[0], 2) + Math.pow(h[1] - u[1], 2)));
                      var g = Math.atan2(u[1] - h[1], u[0] - h[0]),
                        v = e.h.v;
                      v >= 1 ? (v = 0.99) : v <= -1 && (v = -0.99);
                      var b = s * v,
                        x = Math.cos(g + e.a.v) * b + h[0],
                        E = Math.sin(g + e.a.v) * b + h[1];
                      l.setAttribute('fx', x),
                        l.setAttribute('fy', E),
                        c && !e.g._collapsable && (e.of.setAttribute('fx', x), e.of.setAttribute('fy', E));
                    }
                  }
                  function l(t, e, r) {
                    var n = e.style,
                      i = e.d;
                    i &&
                      (i._mdf || r) &&
                      i.dashStr &&
                      (n.pElem.setAttribute('stroke-dasharray', i.dashStr),
                      n.pElem.setAttribute('stroke-dashoffset', i.dashoffset[0])),
                      e.c &&
                        (e.c._mdf || r) &&
                        n.pElem.setAttribute(
                          'stroke',
                          'rgb(' + bmFloor(e.c.v[0]) + ',' + bmFloor(e.c.v[1]) + ',' + bmFloor(e.c.v[2]) + ')',
                        ),
                      (e.o._mdf || r) && n.pElem.setAttribute('stroke-opacity', e.o.v),
                      (e.w._mdf || r) &&
                        (n.pElem.setAttribute('stroke-width', e.w.v),
                        n.msElem && n.msElem.setAttribute('stroke-width', e.w.v));
                  }
                  return {
                    createRenderFunction: function (t) {
                      switch (t.ty) {
                        case 'fl':
                          return o;
                        case 'gf':
                          return s;
                        case 'gs':
                          return a;
                        case 'st':
                          return l;
                        case 'sh':
                        case 'el':
                        case 'rc':
                        case 'sr':
                          return i;
                        case 'tr':
                          return r;
                        case 'no':
                          return n;
                        default:
                          return null;
                      }
                    },
                  };
                })();
              function SVGShapeElement(t, e, r) {
                (this.shapes = []),
                  (this.shapesData = t.shapes),
                  (this.stylesList = []),
                  (this.shapeModifiers = []),
                  (this.itemsData = []),
                  (this.processedElements = []),
                  (this.animatedContents = []),
                  this.initElement(t, e, r),
                  (this.prevViewData = []);
              }
              function LetterProps(t, e, r, n, i, o) {
                (this.o = t),
                  (this.sw = e),
                  (this.sc = r),
                  (this.fc = n),
                  (this.m = i),
                  (this.p = o),
                  (this._mdf = { o: !0, sw: !!e, sc: !!r, fc: !!n, m: !0, p: !0 });
              }
              function TextProperty(t, e) {
                (this._frameId = initialDefaultFrame),
                  (this.pv = ''),
                  (this.v = ''),
                  (this.kf = !1),
                  (this._isFirstFrame = !0),
                  (this._mdf = !1),
                  (this.data = e),
                  (this.elem = t),
                  (this.comp = this.elem.comp),
                  (this.keysIndex = 0),
                  (this.canResize = !1),
                  (this.minimumFontSize = 1),
                  (this.effectsSequence = []),
                  (this.currentData = {
                    ascent: 0,
                    boxWidth: this.defaultBoxWidth,
                    f: '',
                    fStyle: '',
                    fWeight: '',
                    fc: '',
                    j: '',
                    justifyOffset: '',
                    l: [],
                    lh: 0,
                    lineWidths: [],
                    ls: '',
                    of: '',
                    s: '',
                    sc: '',
                    sw: 0,
                    t: 0,
                    tr: 0,
                    sz: 0,
                    ps: null,
                    fillColorAnim: !1,
                    strokeColorAnim: !1,
                    strokeWidthAnim: !1,
                    yOffset: 0,
                    finalSize: 0,
                    finalText: [],
                    finalLineHeight: 0,
                    __complete: !1,
                  }),
                  this.copyData(this.currentData, this.data.d.k[0].s),
                  this.searchProperty() || this.completeTextData(this.currentData);
              }
              extendPrototype(
                [
                  BaseElement,
                  TransformElement,
                  SVGBaseElement,
                  IShapeElement,
                  HierarchyElement,
                  FrameElement,
                  RenderableDOMElement,
                ],
                SVGShapeElement,
              ),
                (SVGShapeElement.prototype.initSecondaryElement = function () {}),
                (SVGShapeElement.prototype.identityMatrix = new Matrix()),
                (SVGShapeElement.prototype.buildExpressionInterface = function () {}),
                (SVGShapeElement.prototype.createContent = function () {
                  this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], !0),
                    this.filterUniqueShapes();
                }),
                (SVGShapeElement.prototype.filterUniqueShapes = function () {
                  var t,
                    e,
                    r,
                    n,
                    i = this.shapes.length,
                    o = this.stylesList.length,
                    a = [],
                    s = !1;
                  for (r = 0; r < o; r += 1) {
                    for (n = this.stylesList[r], s = !1, a.length = 0, t = 0; t < i; t += 1)
                      -1 !== (e = this.shapes[t]).styles.indexOf(n) && (a.push(e), (s = e._isAnimated || s));
                    a.length > 1 && s && this.setShapesAsAnimated(a);
                  }
                }),
                (SVGShapeElement.prototype.setShapesAsAnimated = function (t) {
                  var e,
                    r = t.length;
                  for (e = 0; e < r; e += 1) t[e].setAsAnimated();
                }),
                (SVGShapeElement.prototype.createStyleElement = function (t, e) {
                  var r,
                    n = new SVGStyleData(t, e),
                    i = n.pElem;
                  return (
                    'st' === t.ty
                      ? (r = new SVGStrokeStyleData(this, t, n))
                      : 'fl' === t.ty
                      ? (r = new SVGFillStyleData(this, t, n))
                      : 'gf' === t.ty || 'gs' === t.ty
                      ? ((r = new ('gf' === t.ty ? SVGGradientFillStyleData : SVGGradientStrokeStyleData)(this, t, n)),
                        this.globalData.defs.appendChild(r.gf),
                        r.maskId &&
                          (this.globalData.defs.appendChild(r.ms),
                          this.globalData.defs.appendChild(r.of),
                          i.setAttribute('mask', 'url(' + getLocationHref() + '#' + r.maskId + ')')))
                      : 'no' === t.ty && (r = new SVGNoStyleData(this, t, n)),
                    ('st' !== t.ty && 'gs' !== t.ty) ||
                      (i.setAttribute('stroke-linecap', lineCapEnum[t.lc || 2]),
                      i.setAttribute('stroke-linejoin', lineJoinEnum[t.lj || 2]),
                      i.setAttribute('fill-opacity', '0'),
                      1 === t.lj && i.setAttribute('stroke-miterlimit', t.ml)),
                    2 === t.r && i.setAttribute('fill-rule', 'evenodd'),
                    t.ln && i.setAttribute('id', t.ln),
                    t.cl && i.setAttribute('class', t.cl),
                    t.bm && (i.style['mix-blend-mode'] = getBlendMode(t.bm)),
                    this.stylesList.push(n),
                    this.addToAnimatedContents(t, r),
                    r
                  );
                }),
                (SVGShapeElement.prototype.createGroupElement = function (t) {
                  var e = new ShapeGroupData();
                  return (
                    t.ln && e.gr.setAttribute('id', t.ln),
                    t.cl && e.gr.setAttribute('class', t.cl),
                    t.bm && (e.gr.style['mix-blend-mode'] = getBlendMode(t.bm)),
                    e
                  );
                }),
                (SVGShapeElement.prototype.createTransformElement = function (t, e) {
                  var r = TransformPropertyFactory.getTransformProperty(this, t, this),
                    n = new SVGTransformData(r, r.o, e);
                  return this.addToAnimatedContents(t, n), n;
                }),
                (SVGShapeElement.prototype.createShapeElement = function (t, e, r) {
                  var n = 4;
                  'rc' === t.ty ? (n = 5) : 'el' === t.ty ? (n = 6) : 'sr' === t.ty && (n = 7);
                  var i = new SVGShapeData(e, r, ShapePropertyFactory.getShapeProp(this, t, n, this));
                  return this.shapes.push(i), this.addShapeToModifiers(i), this.addToAnimatedContents(t, i), i;
                }),
                (SVGShapeElement.prototype.addToAnimatedContents = function (t, e) {
                  for (var r = 0, n = this.animatedContents.length; r < n; ) {
                    if (this.animatedContents[r].element === e) return;
                    r += 1;
                  }
                  this.animatedContents.push({ fn: SVGElementsRenderer.createRenderFunction(t), element: e, data: t });
                }),
                (SVGShapeElement.prototype.setElementStyles = function (t) {
                  var e,
                    r = t.styles,
                    n = this.stylesList.length;
                  for (e = 0; e < n; e += 1) this.stylesList[e].closed || r.push(this.stylesList[e]);
                }),
                (SVGShapeElement.prototype.reloadShapes = function () {
                  var t;
                  this._isFirstFrame = !0;
                  var e = this.itemsData.length;
                  for (t = 0; t < e; t += 1) this.prevViewData[t] = this.itemsData[t];
                  for (
                    this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], !0),
                      this.filterUniqueShapes(),
                      e = this.dynamicProperties.length,
                      t = 0;
                    t < e;
                    t += 1
                  )
                    this.dynamicProperties[t].getValue();
                  this.renderModifiers();
                }),
                (SVGShapeElement.prototype.searchShapes = function (t, e, r, n, i, o, a) {
                  var s,
                    l,
                    c,
                    h,
                    u,
                    p,
                    f = [].concat(o),
                    d = t.length - 1,
                    m = [],
                    y = [];
                  for (s = d; s >= 0; s -= 1) {
                    if (
                      ((p = this.searchProcessedElement(t[s])) ? (e[s] = r[p - 1]) : (t[s]._render = a),
                      'fl' === t[s].ty || 'st' === t[s].ty || 'gf' === t[s].ty || 'gs' === t[s].ty || 'no' === t[s].ty)
                    )
                      p ? (e[s].style.closed = !1) : (e[s] = this.createStyleElement(t[s], i)),
                        t[s]._render && e[s].style.pElem.parentNode !== n && n.appendChild(e[s].style.pElem),
                        m.push(e[s].style);
                    else if ('gr' === t[s].ty) {
                      if (p) for (c = e[s].it.length, l = 0; l < c; l += 1) e[s].prevViewData[l] = e[s].it[l];
                      else e[s] = this.createGroupElement(t[s]);
                      this.searchShapes(t[s].it, e[s].it, e[s].prevViewData, e[s].gr, i + 1, f, a),
                        t[s]._render && e[s].gr.parentNode !== n && n.appendChild(e[s].gr);
                    } else
                      'tr' === t[s].ty
                        ? (p || (e[s] = this.createTransformElement(t[s], n)), (h = e[s].transform), f.push(h))
                        : 'sh' === t[s].ty || 'rc' === t[s].ty || 'el' === t[s].ty || 'sr' === t[s].ty
                        ? (p || (e[s] = this.createShapeElement(t[s], f, i)), this.setElementStyles(e[s]))
                        : 'tm' === t[s].ty ||
                          'rd' === t[s].ty ||
                          'ms' === t[s].ty ||
                          'pb' === t[s].ty ||
                          'zz' === t[s].ty ||
                          'op' === t[s].ty
                        ? (p
                            ? ((u = e[s]).closed = !1)
                            : ((u = ShapeModifiers.getModifier(t[s].ty)).init(this, t[s]),
                              (e[s] = u),
                              this.shapeModifiers.push(u)),
                          y.push(u))
                        : 'rp' === t[s].ty &&
                          (p
                            ? ((u = e[s]).closed = !0)
                            : ((u = ShapeModifiers.getModifier(t[s].ty)),
                              (e[s] = u),
                              u.init(this, t, s, e),
                              this.shapeModifiers.push(u),
                              (a = !1)),
                          y.push(u));
                    this.addProcessedElement(t[s], s + 1);
                  }
                  for (d = m.length, s = 0; s < d; s += 1) m[s].closed = !0;
                  for (d = y.length, s = 0; s < d; s += 1) y[s].closed = !0;
                }),
                (SVGShapeElement.prototype.renderInnerContent = function () {
                  var t;
                  this.renderModifiers();
                  var e = this.stylesList.length;
                  for (t = 0; t < e; t += 1) this.stylesList[t].reset();
                  for (this.renderShape(), t = 0; t < e; t += 1)
                    (this.stylesList[t]._mdf || this._isFirstFrame) &&
                      (this.stylesList[t].msElem &&
                        (this.stylesList[t].msElem.setAttribute('d', this.stylesList[t].d),
                        (this.stylesList[t].d = 'M0 0' + this.stylesList[t].d)),
                      this.stylesList[t].pElem.setAttribute('d', this.stylesList[t].d || 'M0 0'));
                }),
                (SVGShapeElement.prototype.renderShape = function () {
                  var t,
                    e,
                    r = this.animatedContents.length;
                  for (t = 0; t < r; t += 1)
                    (e = this.animatedContents[t]),
                      (this._isFirstFrame || e.element._isAnimated) &&
                        !0 !== e.data &&
                        e.fn(e.data, e.element, this._isFirstFrame);
                }),
                (SVGShapeElement.prototype.destroy = function () {
                  this.destroyBaseElement(), (this.shapesData = null), (this.itemsData = null);
                }),
                (LetterProps.prototype.update = function (t, e, r, n, i, o) {
                  (this._mdf.o = !1),
                    (this._mdf.sw = !1),
                    (this._mdf.sc = !1),
                    (this._mdf.fc = !1),
                    (this._mdf.m = !1),
                    (this._mdf.p = !1);
                  var a = !1;
                  return (
                    this.o !== t && ((this.o = t), (this._mdf.o = !0), (a = !0)),
                    this.sw !== e && ((this.sw = e), (this._mdf.sw = !0), (a = !0)),
                    this.sc !== r && ((this.sc = r), (this._mdf.sc = !0), (a = !0)),
                    this.fc !== n && ((this.fc = n), (this._mdf.fc = !0), (a = !0)),
                    this.m !== i && ((this.m = i), (this._mdf.m = !0), (a = !0)),
                    !o.length ||
                      (this.p[0] === o[0] &&
                        this.p[1] === o[1] &&
                        this.p[4] === o[4] &&
                        this.p[5] === o[5] &&
                        this.p[12] === o[12] &&
                        this.p[13] === o[13]) ||
                      ((this.p = o), (this._mdf.p = !0), (a = !0)),
                    a
                  );
                }),
                (TextProperty.prototype.defaultBoxWidth = [0, 0]),
                (TextProperty.prototype.copyData = function (t, e) {
                  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
                  return t;
                }),
                (TextProperty.prototype.setCurrentData = function (t) {
                  t.__complete || this.completeTextData(t),
                    (this.currentData = t),
                    (this.currentData.boxWidth = this.currentData.boxWidth || this.defaultBoxWidth),
                    (this._mdf = !0);
                }),
                (TextProperty.prototype.searchProperty = function () {
                  return this.searchKeyframes();
                }),
                (TextProperty.prototype.searchKeyframes = function () {
                  return (
                    (this.kf = this.data.d.k.length > 1),
                    this.kf && this.addEffect(this.getKeyframeValue.bind(this)),
                    this.kf
                  );
                }),
                (TextProperty.prototype.addEffect = function (t) {
                  this.effectsSequence.push(t), this.elem.addDynamicProperty(this);
                }),
                (TextProperty.prototype.getValue = function (t) {
                  if ((this.elem.globalData.frameId !== this.frameId && this.effectsSequence.length) || t) {
                    this.currentData.t = this.data.d.k[this.keysIndex].s.t;
                    var e = this.currentData,
                      r = this.keysIndex;
                    if (this.lock) this.setCurrentData(this.currentData);
                    else {
                      var n;
                      (this.lock = !0), (this._mdf = !1);
                      var i = this.effectsSequence.length,
                        o = t || this.data.d.k[this.keysIndex].s;
                      for (n = 0; n < i; n += 1)
                        o =
                          r !== this.keysIndex
                            ? this.effectsSequence[n](o, o.t)
                            : this.effectsSequence[n](this.currentData, o.t);
                      e !== o && this.setCurrentData(o),
                        (this.v = this.currentData),
                        (this.pv = this.v),
                        (this.lock = !1),
                        (this.frameId = this.elem.globalData.frameId);
                    }
                  }
                }),
                (TextProperty.prototype.getKeyframeValue = function () {
                  for (
                    var t = this.data.d.k, e = this.elem.comp.renderedFrame, r = 0, n = t.length;
                    r <= n - 1 && !(r === n - 1 || t[r + 1].t > e);

                  )
                    r += 1;
                  return this.keysIndex !== r && (this.keysIndex = r), this.data.d.k[this.keysIndex].s;
                }),
                (TextProperty.prototype.buildFinalText = function (t) {
                  for (var e, r, n = [], i = 0, o = t.length, a = !1; i < o; )
                    (e = t.charCodeAt(i)),
                      FontManager.isCombinedCharacter(e)
                        ? (n[n.length - 1] += t.charAt(i))
                        : e >= 55296 && e <= 56319
                        ? (r = t.charCodeAt(i + 1)) >= 56320 && r <= 57343
                          ? (a || FontManager.isModifier(e, r)
                              ? ((n[n.length - 1] += t.substr(i, 2)), (a = !1))
                              : n.push(t.substr(i, 2)),
                            (i += 1))
                          : n.push(t.charAt(i))
                        : e > 56319
                        ? ((r = t.charCodeAt(i + 1)),
                          FontManager.isZeroWidthJoiner(e, r)
                            ? ((a = !0), (n[n.length - 1] += t.substr(i, 2)), (i += 1))
                            : n.push(t.charAt(i)))
                        : FontManager.isZeroWidthJoiner(e)
                        ? ((n[n.length - 1] += t.charAt(i)), (a = !0))
                        : n.push(t.charAt(i)),
                      (i += 1);
                  return n;
                }),
                (TextProperty.prototype.completeTextData = function (t) {
                  t.__complete = !0;
                  var e,
                    r,
                    n,
                    i,
                    o,
                    a,
                    s,
                    l = this.elem.globalData.fontManager,
                    c = this.data,
                    h = [],
                    u = 0,
                    p = c.m.g,
                    f = 0,
                    d = 0,
                    m = 0,
                    y = [],
                    g = 0,
                    v = 0,
                    b = l.getFontByName(t.f),
                    x = 0,
                    E = getFontProperties(b);
                  (t.fWeight = E.weight),
                    (t.fStyle = E.style),
                    (t.finalSize = t.s),
                    (t.finalText = this.buildFinalText(t.t)),
                    (r = t.finalText.length),
                    (t.finalLineHeight = t.lh);
                  var w,
                    _ = (t.tr / 1e3) * t.finalSize;
                  if (t.sz)
                    for (var S, P, A = !0, C = t.sz[0], T = t.sz[1]; A; ) {
                      (S = 0), (g = 0), (r = (P = this.buildFinalText(t.t)).length), (_ = (t.tr / 1e3) * t.finalSize);
                      var k = -1;
                      for (e = 0; e < r; e += 1)
                        (w = P[e].charCodeAt(0)),
                          (n = !1),
                          ' ' === P[e]
                            ? (k = e)
                            : (13 !== w && 3 !== w) ||
                              ((g = 0), (n = !0), (S += t.finalLineHeight || 1.2 * t.finalSize)),
                          l.chars
                            ? ((s = l.getCharData(P[e], b.fStyle, b.fFamily)), (x = n ? 0 : (s.w * t.finalSize) / 100))
                            : (x = l.measureText(P[e], t.f, t.finalSize)),
                          g + x > C && ' ' !== P[e]
                            ? (-1 === k ? (r += 1) : (e = k),
                              (S += t.finalLineHeight || 1.2 * t.finalSize),
                              P.splice(e, k === e ? 1 : 0, '\r'),
                              (k = -1),
                              (g = 0))
                            : ((g += x), (g += _));
                      (S += (b.ascent * t.finalSize) / 100),
                        this.canResize && t.finalSize > this.minimumFontSize && T < S
                          ? ((t.finalSize -= 1), (t.finalLineHeight = (t.finalSize * t.lh) / t.s))
                          : ((t.finalText = P), (r = t.finalText.length), (A = !1));
                    }
                  (g = -_), (x = 0);
                  var D,
                    M = 0;
                  for (e = 0; e < r; e += 1)
                    if (
                      ((n = !1),
                      13 === (w = (D = t.finalText[e]).charCodeAt(0)) || 3 === w
                        ? ((M = 0), y.push(g), (v = g > v ? g : v), (g = -2 * _), (i = ''), (n = !0), (m += 1))
                        : (i = D),
                      l.chars
                        ? ((s = l.getCharData(D, b.fStyle, l.getFontByName(t.f).fFamily)),
                          (x = n ? 0 : (s.w * t.finalSize) / 100))
                        : (x = l.measureText(i, t.f, t.finalSize)),
                      ' ' === D ? (M += x + _) : ((g += x + _ + M), (M = 0)),
                      h.push({ l: x, an: x, add: f, n: n, anIndexes: [], val: i, line: m, animatorJustifyOffset: 0 }),
                      2 == p)
                    ) {
                      if (((f += x), '' === i || ' ' === i || e === r - 1)) {
                        for (('' !== i && ' ' !== i) || (f -= x); d <= e; )
                          (h[d].an = f), (h[d].ind = u), (h[d].extra = x), (d += 1);
                        (u += 1), (f = 0);
                      }
                    } else if (3 == p) {
                      if (((f += x), '' === i || e === r - 1)) {
                        for ('' === i && (f -= x); d <= e; ) (h[d].an = f), (h[d].ind = u), (h[d].extra = x), (d += 1);
                        (f = 0), (u += 1);
                      }
                    } else (h[u].ind = u), (h[u].extra = 0), (u += 1);
                  if (((t.l = h), (v = g > v ? g : v), y.push(g), t.sz)) (t.boxWidth = t.sz[0]), (t.justifyOffset = 0);
                  else
                    switch (((t.boxWidth = v), t.j)) {
                      case 1:
                        t.justifyOffset = -t.boxWidth;
                        break;
                      case 2:
                        t.justifyOffset = -t.boxWidth / 2;
                        break;
                      default:
                        t.justifyOffset = 0;
                    }
                  t.lineWidths = y;
                  var I,
                    F,
                    L,
                    R,
                    O = c.a;
                  a = O.length;
                  var B = [];
                  for (o = 0; o < a; o += 1) {
                    for (
                      (I = O[o]).a.sc && (t.strokeColorAnim = !0),
                        I.a.sw && (t.strokeWidthAnim = !0),
                        (I.a.fc || I.a.fh || I.a.fs || I.a.fb) && (t.fillColorAnim = !0),
                        R = 0,
                        L = I.s.b,
                        e = 0;
                      e < r;
                      e += 1
                    )
                      ((F = h[e]).anIndexes[o] = R),
                        ((1 == L && '' !== F.val) ||
                          (2 == L && '' !== F.val && ' ' !== F.val) ||
                          (3 == L && (F.n || ' ' == F.val || e == r - 1)) ||
                          (4 == L && (F.n || e == r - 1))) &&
                          (1 === I.s.rn && B.push(R), (R += 1));
                    c.a[o].s.totalChars = R;
                    var j,
                      N = -1;
                    if (1 === I.s.rn)
                      for (e = 0; e < r; e += 1)
                        N != (F = h[e]).anIndexes[o] &&
                          ((N = F.anIndexes[o]), (j = B.splice(Math.floor(Math.random() * B.length), 1)[0])),
                          (F.anIndexes[o] = j);
                  }
                  (t.yOffset = t.finalLineHeight || 1.2 * t.finalSize),
                    (t.ls = t.ls || 0),
                    (t.ascent = (b.ascent * t.finalSize) / 100);
                }),
                (TextProperty.prototype.updateDocumentData = function (t, e) {
                  e = void 0 === e ? this.keysIndex : e;
                  var r = this.copyData({}, this.data.d.k[e].s);
                  (r = this.copyData(r, t)),
                    (this.data.d.k[e].s = r),
                    this.recalculate(e),
                    this.elem.addDynamicProperty(this);
                }),
                (TextProperty.prototype.recalculate = function (t) {
                  var e = this.data.d.k[t].s;
                  (e.__complete = !1), (this.keysIndex = 0), (this._isFirstFrame = !0), this.getValue(e);
                }),
                (TextProperty.prototype.canResizeFont = function (t) {
                  (this.canResize = t), this.recalculate(this.keysIndex), this.elem.addDynamicProperty(this);
                }),
                (TextProperty.prototype.setMinimumFontSize = function (t) {
                  (this.minimumFontSize = Math.floor(t) || 1),
                    this.recalculate(this.keysIndex),
                    this.elem.addDynamicProperty(this);
                });
              var TextSelectorProp = (function () {
                var t = Math.max,
                  e = Math.min,
                  r = Math.floor;
                function n(t, e) {
                  (this._currentTextLength = -1),
                    (this.k = !1),
                    (this.data = e),
                    (this.elem = t),
                    (this.comp = t.comp),
                    (this.finalS = 0),
                    (this.finalE = 0),
                    this.initDynamicPropertyContainer(t),
                    (this.s = PropertyFactory.getProp(t, e.s || { k: 0 }, 0, 0, this)),
                    (this.e = 'e' in e ? PropertyFactory.getProp(t, e.e, 0, 0, this) : { v: 100 }),
                    (this.o = PropertyFactory.getProp(t, e.o || { k: 0 }, 0, 0, this)),
                    (this.xe = PropertyFactory.getProp(t, e.xe || { k: 0 }, 0, 0, this)),
                    (this.ne = PropertyFactory.getProp(t, e.ne || { k: 0 }, 0, 0, this)),
                    (this.sm = PropertyFactory.getProp(t, e.sm || { k: 100 }, 0, 0, this)),
                    (this.a = PropertyFactory.getProp(t, e.a, 0, 0.01, this)),
                    this.dynamicProperties.length || this.getValue();
                }
                return (
                  (n.prototype = {
                    getMult: function (n) {
                      this._currentTextLength !== this.elem.textProperty.currentData.l.length && this.getValue();
                      var i = 0,
                        o = 0,
                        a = 1,
                        s = 1;
                      this.ne.v > 0 ? (i = this.ne.v / 100) : (o = -this.ne.v / 100),
                        this.xe.v > 0 ? (a = 1 - this.xe.v / 100) : (s = 1 + this.xe.v / 100);
                      var l = BezierFactory.getBezierEasing(i, o, a, s).get,
                        c = 0,
                        h = this.finalS,
                        u = this.finalE,
                        p = this.data.sh;
                      if (2 === p)
                        c = l((c = u === h ? (n >= u ? 1 : 0) : t(0, e(0.5 / (u - h) + (n - h) / (u - h), 1))));
                      else if (3 === p)
                        c = l((c = u === h ? (n >= u ? 0 : 1) : 1 - t(0, e(0.5 / (u - h) + (n - h) / (u - h), 1))));
                      else if (4 === p)
                        u === h
                          ? (c = 0)
                          : (c = t(0, e(0.5 / (u - h) + (n - h) / (u - h), 1))) < 0.5
                          ? (c *= 2)
                          : (c = 1 - 2 * (c - 0.5)),
                          (c = l(c));
                      else if (5 === p) {
                        if (u === h) c = 0;
                        else {
                          var f = u - h,
                            d = -f / 2 + (n = e(t(0, n + 0.5 - h), u - h)),
                            m = f / 2;
                          c = Math.sqrt(1 - (d * d) / (m * m));
                        }
                        c = l(c);
                      } else
                        6 === p
                          ? (u === h
                              ? (c = 0)
                              : ((n = e(t(0, n + 0.5 - h), u - h)),
                                (c = (1 + Math.cos(Math.PI + (2 * Math.PI * n) / (u - h))) / 2)),
                            (c = l(c)))
                          : (n >= r(h) && (c = t(0, e(n - h < 0 ? e(u, 1) - (h - n) : u - n, 1))), (c = l(c)));
                      if (100 !== this.sm.v) {
                        var y = 0.01 * this.sm.v;
                        0 === y && (y = 1e-8);
                        var g = 0.5 - 0.5 * y;
                        c < g ? (c = 0) : (c = (c - g) / y) > 1 && (c = 1);
                      }
                      return c * this.a.v;
                    },
                    getValue: function (t) {
                      this.iterateDynamicProperties(),
                        (this._mdf = t || this._mdf),
                        (this._currentTextLength = this.elem.textProperty.currentData.l.length || 0),
                        t && 2 === this.data.r && (this.e.v = this._currentTextLength);
                      var e = 2 === this.data.r ? 1 : 100 / this.data.totalChars,
                        r = this.o.v / e,
                        n = this.s.v / e + r,
                        i = this.e.v / e + r;
                      if (n > i) {
                        var o = n;
                        (n = i), (i = o);
                      }
                      (this.finalS = n), (this.finalE = i);
                    },
                  }),
                  extendPrototype([DynamicPropertyContainer], n),
                  {
                    getTextSelectorProp: function (t, e, r) {
                      return new n(t, e, r);
                    },
                  }
                );
              })();
              function TextAnimatorDataProperty(t, e, r) {
                var n = { propType: !1 },
                  i = PropertyFactory.getProp,
                  o = e.a;
                (this.a = {
                  r: o.r ? i(t, o.r, 0, degToRads, r) : n,
                  rx: o.rx ? i(t, o.rx, 0, degToRads, r) : n,
                  ry: o.ry ? i(t, o.ry, 0, degToRads, r) : n,
                  sk: o.sk ? i(t, o.sk, 0, degToRads, r) : n,
                  sa: o.sa ? i(t, o.sa, 0, degToRads, r) : n,
                  s: o.s ? i(t, o.s, 1, 0.01, r) : n,
                  a: o.a ? i(t, o.a, 1, 0, r) : n,
                  o: o.o ? i(t, o.o, 0, 0.01, r) : n,
                  p: o.p ? i(t, o.p, 1, 0, r) : n,
                  sw: o.sw ? i(t, o.sw, 0, 0, r) : n,
                  sc: o.sc ? i(t, o.sc, 1, 0, r) : n,
                  fc: o.fc ? i(t, o.fc, 1, 0, r) : n,
                  fh: o.fh ? i(t, o.fh, 0, 0, r) : n,
                  fs: o.fs ? i(t, o.fs, 0, 0.01, r) : n,
                  fb: o.fb ? i(t, o.fb, 0, 0.01, r) : n,
                  t: o.t ? i(t, o.t, 0, 0, r) : n,
                }),
                  (this.s = TextSelectorProp.getTextSelectorProp(t, e.s, r)),
                  (this.s.t = e.s.t);
              }
              function TextAnimatorProperty(t, e, r) {
                (this._isFirstFrame = !0),
                  (this._hasMaskedPath = !1),
                  (this._frameId = -1),
                  (this._textData = t),
                  (this._renderType = e),
                  (this._elem = r),
                  (this._animatorsData = createSizedArray(this._textData.a.length)),
                  (this._pathData = {}),
                  (this._moreOptions = { alignment: {} }),
                  (this.renderedLetters = []),
                  (this.lettersChangedFlag = !1),
                  this.initDynamicPropertyContainer(r);
              }
              function ITextElement() {}
              (TextAnimatorProperty.prototype.searchProperties = function () {
                var t,
                  e,
                  r = this._textData.a.length,
                  n = PropertyFactory.getProp;
                for (t = 0; t < r; t += 1)
                  (e = this._textData.a[t]),
                    (this._animatorsData[t] = new TextAnimatorDataProperty(this._elem, e, this));
                this._textData.p && 'm' in this._textData.p
                  ? ((this._pathData = {
                      a: n(this._elem, this._textData.p.a, 0, 0, this),
                      f: n(this._elem, this._textData.p.f, 0, 0, this),
                      l: n(this._elem, this._textData.p.l, 0, 0, this),
                      r: n(this._elem, this._textData.p.r, 0, 0, this),
                      p: n(this._elem, this._textData.p.p, 0, 0, this),
                      m: this._elem.maskManager.getMaskProperty(this._textData.p.m),
                    }),
                    (this._hasMaskedPath = !0))
                  : (this._hasMaskedPath = !1),
                  (this._moreOptions.alignment = n(this._elem, this._textData.m.a, 1, 0, this));
              }),
                (TextAnimatorProperty.prototype.getMeasures = function (t, e) {
                  if (
                    ((this.lettersChangedFlag = e),
                    this._mdf || this._isFirstFrame || e || (this._hasMaskedPath && this._pathData.m._mdf))
                  ) {
                    this._isFirstFrame = !1;
                    var r,
                      n,
                      i,
                      o,
                      a,
                      s,
                      l,
                      c,
                      h,
                      u,
                      p,
                      f,
                      d,
                      m,
                      y,
                      g,
                      v,
                      b,
                      x,
                      E = this._moreOptions.alignment.v,
                      w = this._animatorsData,
                      _ = this._textData,
                      S = this.mHelper,
                      P = this._renderType,
                      A = this.renderedLetters.length,
                      C = t.l;
                    if (this._hasMaskedPath) {
                      if (((x = this._pathData.m), !this._pathData.n || this._pathData._mdf)) {
                        var T,
                          k = x.v;
                        for (
                          this._pathData.r.v && (k = k.reverse()),
                            a = { tLength: 0, segments: [] },
                            o = k._length - 1,
                            g = 0,
                            i = 0;
                          i < o;
                          i += 1
                        )
                          (T = bez.buildBezierData(
                            k.v[i],
                            k.v[i + 1],
                            [k.o[i][0] - k.v[i][0], k.o[i][1] - k.v[i][1]],
                            [k.i[i + 1][0] - k.v[i + 1][0], k.i[i + 1][1] - k.v[i + 1][1]],
                          )),
                            (a.tLength += T.segmentLength),
                            a.segments.push(T),
                            (g += T.segmentLength);
                        (i = o),
                          x.v.c &&
                            ((T = bez.buildBezierData(
                              k.v[i],
                              k.v[0],
                              [k.o[i][0] - k.v[i][0], k.o[i][1] - k.v[i][1]],
                              [k.i[0][0] - k.v[0][0], k.i[0][1] - k.v[0][1]],
                            )),
                            (a.tLength += T.segmentLength),
                            a.segments.push(T),
                            (g += T.segmentLength)),
                          (this._pathData.pi = a);
                      }
                      if (
                        ((a = this._pathData.pi),
                        (s = this._pathData.f.v),
                        (p = 0),
                        (u = 1),
                        (c = 0),
                        (h = !0),
                        (m = a.segments),
                        s < 0 && x.v.c)
                      )
                        for (
                          a.tLength < Math.abs(s) && (s = -Math.abs(s) % a.tLength),
                            u = (d = m[(p = m.length - 1)].points).length - 1;
                          s < 0;

                        )
                          (s += d[u].partialLength), (u -= 1) < 0 && (u = (d = m[(p -= 1)].points).length - 1);
                      (f = (d = m[p].points)[u - 1]), (y = (l = d[u]).partialLength);
                    }
                    (o = C.length), (r = 0), (n = 0);
                    var D,
                      M,
                      I,
                      F,
                      L,
                      R = 1.2 * t.finalSize * 0.714,
                      O = !0;
                    I = w.length;
                    var B,
                      j,
                      N,
                      V,
                      z,
                      $,
                      q,
                      H,
                      G,
                      W,
                      U,
                      X,
                      Y = -1,
                      K = s,
                      Z = p,
                      J = u,
                      Q = -1,
                      tt = '',
                      et = this.defaultPropsArray;
                    if (2 === t.j || 1 === t.j) {
                      var rt = 0,
                        nt = 0,
                        it = 2 === t.j ? -0.5 : -1,
                        ot = 0,
                        at = !0;
                      for (i = 0; i < o; i += 1)
                        if (C[i].n) {
                          for (rt && (rt += nt); ot < i; ) (C[ot].animatorJustifyOffset = rt), (ot += 1);
                          (rt = 0), (at = !0);
                        } else {
                          for (M = 0; M < I; M += 1)
                            (D = w[M].a).t.propType &&
                              (at && 2 === t.j && (nt += D.t.v * it),
                              (L = w[M].s.getMult(C[i].anIndexes[M], _.a[M].s.totalChars)).length
                                ? (rt += D.t.v * L[0] * it)
                                : (rt += D.t.v * L * it));
                          at = !1;
                        }
                      for (rt && (rt += nt); ot < i; ) (C[ot].animatorJustifyOffset = rt), (ot += 1);
                    }
                    for (i = 0; i < o; i += 1) {
                      if ((S.reset(), (V = 1), C[i].n))
                        (r = 0),
                          (n += t.yOffset),
                          (n += O ? 1 : 0),
                          (s = K),
                          (O = !1),
                          this._hasMaskedPath &&
                            ((u = J), (f = (d = m[(p = Z)].points)[u - 1]), (y = (l = d[u]).partialLength), (c = 0)),
                          (tt = ''),
                          (U = ''),
                          (G = ''),
                          (X = ''),
                          (et = this.defaultPropsArray);
                      else {
                        if (this._hasMaskedPath) {
                          if (Q !== C[i].line) {
                            switch (t.j) {
                              case 1:
                                s += g - t.lineWidths[C[i].line];
                                break;
                              case 2:
                                s += (g - t.lineWidths[C[i].line]) / 2;
                            }
                            Q = C[i].line;
                          }
                          Y !== C[i].ind && (C[Y] && (s += C[Y].extra), (s += C[i].an / 2), (Y = C[i].ind)),
                            (s += E[0] * C[i].an * 0.005);
                          var st = 0;
                          for (M = 0; M < I; M += 1)
                            (D = w[M].a).p.propType &&
                              ((L = w[M].s.getMult(C[i].anIndexes[M], _.a[M].s.totalChars)).length
                                ? (st += D.p.v[0] * L[0])
                                : (st += D.p.v[0] * L)),
                              D.a.propType &&
                                ((L = w[M].s.getMult(C[i].anIndexes[M], _.a[M].s.totalChars)).length
                                  ? (st += D.a.v[0] * L[0])
                                  : (st += D.a.v[0] * L));
                          for (
                            h = !0,
                              this._pathData.a.v &&
                                ((s =
                                  0.5 * C[0].an +
                                  ((g - this._pathData.f.v - 0.5 * C[0].an - 0.5 * C[C.length - 1].an) * Y) / (o - 1)),
                                (s += this._pathData.f.v));
                            h;

                          )
                            c + y >= s + st || !d
                              ? ((v = (s + st - c) / l.partialLength),
                                (j = f.point[0] + (l.point[0] - f.point[0]) * v),
                                (N = f.point[1] + (l.point[1] - f.point[1]) * v),
                                S.translate(-E[0] * C[i].an * 0.005, -E[1] * R * 0.01),
                                (h = !1))
                              : d &&
                                ((c += l.partialLength),
                                (u += 1) >= d.length &&
                                  ((u = 0),
                                  m[(p += 1)]
                                    ? (d = m[p].points)
                                    : x.v.c
                                    ? ((u = 0), (d = m[(p = 0)].points))
                                    : ((c -= l.partialLength), (d = null))),
                                d && ((f = l), (y = (l = d[u]).partialLength)));
                          (B = C[i].an / 2 - C[i].add), S.translate(-B, 0, 0);
                        } else
                          (B = C[i].an / 2 - C[i].add),
                            S.translate(-B, 0, 0),
                            S.translate(-E[0] * C[i].an * 0.005, -E[1] * R * 0.01, 0);
                        for (M = 0; M < I; M += 1)
                          (D = w[M].a).t.propType &&
                            ((L = w[M].s.getMult(C[i].anIndexes[M], _.a[M].s.totalChars)),
                            (0 === r && 0 === t.j) ||
                              (this._hasMaskedPath
                                ? L.length
                                  ? (s += D.t.v * L[0])
                                  : (s += D.t.v * L)
                                : L.length
                                ? (r += D.t.v * L[0])
                                : (r += D.t.v * L)));
                        for (
                          t.strokeWidthAnim && ($ = t.sw || 0),
                            t.strokeColorAnim && (z = t.sc ? [t.sc[0], t.sc[1], t.sc[2]] : [0, 0, 0]),
                            t.fillColorAnim && t.fc && (q = [t.fc[0], t.fc[1], t.fc[2]]),
                            M = 0;
                          M < I;
                          M += 1
                        )
                          (D = w[M].a).a.propType &&
                            ((L = w[M].s.getMult(C[i].anIndexes[M], _.a[M].s.totalChars)).length
                              ? S.translate(-D.a.v[0] * L[0], -D.a.v[1] * L[1], D.a.v[2] * L[2])
                              : S.translate(-D.a.v[0] * L, -D.a.v[1] * L, D.a.v[2] * L));
                        for (M = 0; M < I; M += 1)
                          (D = w[M].a).s.propType &&
                            ((L = w[M].s.getMult(C[i].anIndexes[M], _.a[M].s.totalChars)).length
                              ? S.scale(1 + (D.s.v[0] - 1) * L[0], 1 + (D.s.v[1] - 1) * L[1], 1)
                              : S.scale(1 + (D.s.v[0] - 1) * L, 1 + (D.s.v[1] - 1) * L, 1));
                        for (M = 0; M < I; M += 1) {
                          if (
                            ((D = w[M].a),
                            (L = w[M].s.getMult(C[i].anIndexes[M], _.a[M].s.totalChars)),
                            D.sk.propType &&
                              (L.length
                                ? S.skewFromAxis(-D.sk.v * L[0], D.sa.v * L[1])
                                : S.skewFromAxis(-D.sk.v * L, D.sa.v * L)),
                            D.r.propType && (L.length ? S.rotateZ(-D.r.v * L[2]) : S.rotateZ(-D.r.v * L)),
                            D.ry.propType && (L.length ? S.rotateY(D.ry.v * L[1]) : S.rotateY(D.ry.v * L)),
                            D.rx.propType && (L.length ? S.rotateX(D.rx.v * L[0]) : S.rotateX(D.rx.v * L)),
                            D.o.propType && (L.length ? (V += (D.o.v * L[0] - V) * L[0]) : (V += (D.o.v * L - V) * L)),
                            t.strokeWidthAnim && D.sw.propType && (L.length ? ($ += D.sw.v * L[0]) : ($ += D.sw.v * L)),
                            t.strokeColorAnim && D.sc.propType)
                          )
                            for (H = 0; H < 3; H += 1)
                              L.length ? (z[H] += (D.sc.v[H] - z[H]) * L[0]) : (z[H] += (D.sc.v[H] - z[H]) * L);
                          if (t.fillColorAnim && t.fc) {
                            if (D.fc.propType)
                              for (H = 0; H < 3; H += 1)
                                L.length ? (q[H] += (D.fc.v[H] - q[H]) * L[0]) : (q[H] += (D.fc.v[H] - q[H]) * L);
                            D.fh.propType &&
                              (q = L.length ? addHueToRGB(q, D.fh.v * L[0]) : addHueToRGB(q, D.fh.v * L)),
                              D.fs.propType &&
                                (q = L.length
                                  ? addSaturationToRGB(q, D.fs.v * L[0])
                                  : addSaturationToRGB(q, D.fs.v * L)),
                              D.fb.propType &&
                                (q = L.length
                                  ? addBrightnessToRGB(q, D.fb.v * L[0])
                                  : addBrightnessToRGB(q, D.fb.v * L));
                          }
                        }
                        for (M = 0; M < I; M += 1)
                          (D = w[M].a).p.propType &&
                            ((L = w[M].s.getMult(C[i].anIndexes[M], _.a[M].s.totalChars)),
                            this._hasMaskedPath
                              ? L.length
                                ? S.translate(0, D.p.v[1] * L[0], -D.p.v[2] * L[1])
                                : S.translate(0, D.p.v[1] * L, -D.p.v[2] * L)
                              : L.length
                              ? S.translate(D.p.v[0] * L[0], D.p.v[1] * L[1], -D.p.v[2] * L[2])
                              : S.translate(D.p.v[0] * L, D.p.v[1] * L, -D.p.v[2] * L));
                        if (
                          (t.strokeWidthAnim && (G = $ < 0 ? 0 : $),
                          t.strokeColorAnim &&
                            (W =
                              'rgb(' +
                              Math.round(255 * z[0]) +
                              ',' +
                              Math.round(255 * z[1]) +
                              ',' +
                              Math.round(255 * z[2]) +
                              ')'),
                          t.fillColorAnim &&
                            t.fc &&
                            (U =
                              'rgb(' +
                              Math.round(255 * q[0]) +
                              ',' +
                              Math.round(255 * q[1]) +
                              ',' +
                              Math.round(255 * q[2]) +
                              ')'),
                          this._hasMaskedPath)
                        ) {
                          if ((S.translate(0, -t.ls), S.translate(0, E[1] * R * 0.01 + n, 0), this._pathData.p.v)) {
                            b = (l.point[1] - f.point[1]) / (l.point[0] - f.point[0]);
                            var lt = (180 * Math.atan(b)) / Math.PI;
                            l.point[0] < f.point[0] && (lt += 180), S.rotate((-lt * Math.PI) / 180);
                          }
                          S.translate(j, N, 0),
                            (s -= E[0] * C[i].an * 0.005),
                            C[i + 1] && Y !== C[i + 1].ind && ((s += C[i].an / 2), (s += 0.001 * t.tr * t.finalSize));
                        } else {
                          switch ((S.translate(r, n, 0), t.ps && S.translate(t.ps[0], t.ps[1] + t.ascent, 0), t.j)) {
                            case 1:
                              S.translate(
                                C[i].animatorJustifyOffset + t.justifyOffset + (t.boxWidth - t.lineWidths[C[i].line]),
                                0,
                                0,
                              );
                              break;
                            case 2:
                              S.translate(
                                C[i].animatorJustifyOffset +
                                  t.justifyOffset +
                                  (t.boxWidth - t.lineWidths[C[i].line]) / 2,
                                0,
                                0,
                              );
                          }
                          S.translate(0, -t.ls),
                            S.translate(B, 0, 0),
                            S.translate(E[0] * C[i].an * 0.005, E[1] * R * 0.01, 0),
                            (r += C[i].l + 0.001 * t.tr * t.finalSize);
                        }
                        'html' === P
                          ? (tt = S.toCSS())
                          : 'svg' === P
                          ? (tt = S.to2dCSS())
                          : (et = [
                              S.props[0],
                              S.props[1],
                              S.props[2],
                              S.props[3],
                              S.props[4],
                              S.props[5],
                              S.props[6],
                              S.props[7],
                              S.props[8],
                              S.props[9],
                              S.props[10],
                              S.props[11],
                              S.props[12],
                              S.props[13],
                              S.props[14],
                              S.props[15],
                            ]),
                          (X = V);
                      }
                      A <= i
                        ? ((F = new LetterProps(X, G, W, U, tt, et)),
                          this.renderedLetters.push(F),
                          (A += 1),
                          (this.lettersChangedFlag = !0))
                        : ((F = this.renderedLetters[i]),
                          (this.lettersChangedFlag = F.update(X, G, W, U, tt, et) || this.lettersChangedFlag));
                    }
                  }
                }),
                (TextAnimatorProperty.prototype.getValue = function () {
                  this._elem.globalData.frameId !== this._frameId &&
                    ((this._frameId = this._elem.globalData.frameId), this.iterateDynamicProperties());
                }),
                (TextAnimatorProperty.prototype.mHelper = new Matrix()),
                (TextAnimatorProperty.prototype.defaultPropsArray = []),
                extendPrototype([DynamicPropertyContainer], TextAnimatorProperty),
                (ITextElement.prototype.initElement = function (t, e, r) {
                  (this.lettersChangedFlag = !0),
                    this.initFrame(),
                    this.initBaseData(t, e, r),
                    (this.textProperty = new TextProperty(this, t.t, this.dynamicProperties)),
                    (this.textAnimator = new TextAnimatorProperty(t.t, this.renderType, this)),
                    this.initTransform(t, e, r),
                    this.initHierarchy(),
                    this.initRenderable(),
                    this.initRendererElement(),
                    this.createContainerElements(),
                    this.createRenderableComponents(),
                    this.createContent(),
                    this.hide(),
                    this.textAnimator.searchProperties(this.dynamicProperties);
                }),
                (ITextElement.prototype.prepareFrame = function (t) {
                  (this._mdf = !1),
                    this.prepareRenderableFrame(t),
                    this.prepareProperties(t, this.isInRange),
                    (this.textProperty._mdf || this.textProperty._isFirstFrame) &&
                      (this.buildNewText(), (this.textProperty._isFirstFrame = !1), (this.textProperty._mdf = !1));
                }),
                (ITextElement.prototype.createPathShape = function (t, e) {
                  var r,
                    n,
                    i = e.length,
                    o = '';
                  for (r = 0; r < i; r += 1)
                    'sh' === e[r].ty && ((n = e[r].ks.k), (o += buildShapeString(n, n.i.length, !0, t)));
                  return o;
                }),
                (ITextElement.prototype.updateDocumentData = function (t, e) {
                  this.textProperty.updateDocumentData(t, e);
                }),
                (ITextElement.prototype.canResizeFont = function (t) {
                  this.textProperty.canResizeFont(t);
                }),
                (ITextElement.prototype.setMinimumFontSize = function (t) {
                  this.textProperty.setMinimumFontSize(t);
                }),
                (ITextElement.prototype.applyTextPropertiesToMatrix = function (t, e, r, n, i) {
                  switch ((t.ps && e.translate(t.ps[0], t.ps[1] + t.ascent, 0), e.translate(0, -t.ls, 0), t.j)) {
                    case 1:
                      e.translate(t.justifyOffset + (t.boxWidth - t.lineWidths[r]), 0, 0);
                      break;
                    case 2:
                      e.translate(t.justifyOffset + (t.boxWidth - t.lineWidths[r]) / 2, 0, 0);
                  }
                  e.translate(n, i, 0);
                }),
                (ITextElement.prototype.buildColor = function (t) {
                  return (
                    'rgb(' + Math.round(255 * t[0]) + ',' + Math.round(255 * t[1]) + ',' + Math.round(255 * t[2]) + ')'
                  );
                }),
                (ITextElement.prototype.emptyProp = new LetterProps()),
                (ITextElement.prototype.destroy = function () {});
              var emptyShapeData = { shapes: [] };
              function SVGTextLottieElement(t, e, r) {
                (this.textSpans = []), (this.renderType = 'svg'), this.initElement(t, e, r);
              }
              function ISolidElement(t, e, r) {
                this.initElement(t, e, r);
              }
              function NullElement(t, e, r) {
                this.initFrame(),
                  this.initBaseData(t, e, r),
                  this.initFrame(),
                  this.initTransform(t, e, r),
                  this.initHierarchy();
              }
              function SVGRendererBase() {}
              function ICompElement() {}
              function SVGCompElement(t, e, r) {
                (this.layers = t.layers),
                  (this.supports3d = !0),
                  (this.completeLayers = !1),
                  (this.pendingElements = []),
                  (this.elements = this.layers ? createSizedArray(this.layers.length) : []),
                  this.initElement(t, e, r),
                  (this.tm = t.tm ? PropertyFactory.getProp(this, t.tm, 0, e.frameRate, this) : { _placeholder: !0 });
              }
              function SVGRenderer(t, e) {
                (this.animationItem = t),
                  (this.layers = null),
                  (this.renderedFrame = -1),
                  (this.svgElement = createNS('svg'));
                var r = '';
                if (e && e.title) {
                  var n = createNS('title'),
                    i = createElementID();
                  n.setAttribute('id', i), (n.textContent = e.title), this.svgElement.appendChild(n), (r += i);
                }
                if (e && e.description) {
                  var o = createNS('desc'),
                    a = createElementID();
                  o.setAttribute('id', a),
                    (o.textContent = e.description),
                    this.svgElement.appendChild(o),
                    (r += ' ' + a);
                }
                r && this.svgElement.setAttribute('aria-labelledby', r);
                var s = createNS('defs');
                this.svgElement.appendChild(s);
                var l = createNS('g');
                this.svgElement.appendChild(l),
                  (this.layerElement = l),
                  (this.renderConfig = {
                    preserveAspectRatio: (e && e.preserveAspectRatio) || 'xMidYMid meet',
                    imagePreserveAspectRatio: (e && e.imagePreserveAspectRatio) || 'xMidYMid slice',
                    contentVisibility: (e && e.contentVisibility) || 'visible',
                    progressiveLoad: (e && e.progressiveLoad) || !1,
                    hideOnTransparent: !(e && !1 === e.hideOnTransparent),
                    viewBoxOnly: (e && e.viewBoxOnly) || !1,
                    viewBoxSize: (e && e.viewBoxSize) || !1,
                    className: (e && e.className) || '',
                    id: (e && e.id) || '',
                    focusable: e && e.focusable,
                    filterSize: {
                      width: (e && e.filterSize && e.filterSize.width) || '100%',
                      height: (e && e.filterSize && e.filterSize.height) || '100%',
                      x: (e && e.filterSize && e.filterSize.x) || '0%',
                      y: (e && e.filterSize && e.filterSize.y) || '0%',
                    },
                    width: e && e.width,
                    height: e && e.height,
                    runExpressions: !e || void 0 === e.runExpressions || e.runExpressions,
                  }),
                  (this.globalData = { _mdf: !1, frameNum: -1, defs: s, renderConfig: this.renderConfig }),
                  (this.elements = []),
                  (this.pendingElements = []),
                  (this.destroyed = !1),
                  (this.rendererType = 'svg');
              }
              function CVContextData() {
                var t;
                for (
                  this.saved = [],
                    this.cArrPos = 0,
                    this.cTr = new Matrix(),
                    this.cO = 1,
                    this.savedOp = createTypedArray('float32', 15),
                    t = 0;
                  t < 15;
                  t += 1
                )
                  this.saved[t] = createTypedArray('float32', 16);
                this._length = 15;
              }
              function ShapeTransformManager() {
                (this.sequences = {}), (this.sequenceList = []), (this.transform_key_count = 0);
              }
              function CVEffects() {}
              function CVMaskElement(t, e) {
                var r;
                (this.data = t),
                  (this.element = e),
                  (this.masksProperties = this.data.masksProperties || []),
                  (this.viewData = createSizedArray(this.masksProperties.length));
                var n = this.masksProperties.length,
                  i = !1;
                for (r = 0; r < n; r += 1)
                  'n' !== this.masksProperties[r].mode && (i = !0),
                    (this.viewData[r] = ShapePropertyFactory.getShapeProp(this.element, this.masksProperties[r], 3));
                (this.hasMasks = i), i && this.element.addRenderableComponent(this);
              }
              function CVBaseElement() {}
              function CVShapeData(t, e, r, n) {
                (this.styledShapes = []), (this.tr = [0, 0, 0, 0, 0, 0]);
                var i,
                  o = 4;
                'rc' === e.ty ? (o = 5) : 'el' === e.ty ? (o = 6) : 'sr' === e.ty && (o = 7),
                  (this.sh = ShapePropertyFactory.getShapeProp(t, e, o, t));
                var a,
                  s = r.length;
                for (i = 0; i < s; i += 1)
                  r[i].closed ||
                    ((a = { transforms: n.addTransformSequence(r[i].transforms), trNodes: [] }),
                    this.styledShapes.push(a),
                    r[i].elements.push(a));
              }
              function CVShapeElement(t, e, r) {
                (this.shapes = []),
                  (this.shapesData = t.shapes),
                  (this.stylesList = []),
                  (this.itemsData = []),
                  (this.prevViewData = []),
                  (this.shapeModifiers = []),
                  (this.processedElements = []),
                  (this.transformsManager = new ShapeTransformManager()),
                  this.initElement(t, e, r);
              }
              function CVTextElement(t, e, r) {
                (this.textSpans = []),
                  (this.yOffset = 0),
                  (this.fillColorAnim = !1),
                  (this.strokeColorAnim = !1),
                  (this.strokeWidthAnim = !1),
                  (this.stroke = !1),
                  (this.fill = !1),
                  (this.justifyOffset = 0),
                  (this.currentRender = null),
                  (this.renderType = 'canvas'),
                  (this.values = { fill: 'rgba(0,0,0,0)', stroke: 'rgba(0,0,0,0)', sWidth: 0, fValue: '' }),
                  this.initElement(t, e, r);
              }
              function CVImageElement(t, e, r) {
                (this.assetData = e.getAssetData(t.refId)),
                  (this.img = e.imageLoader.getAsset(this.assetData)),
                  this.initElement(t, e, r);
              }
              function CVSolidElement(t, e, r) {
                this.initElement(t, e, r);
              }
              function CanvasRendererBase(t, e) {
                (this.animationItem = t),
                  (this.renderConfig = {
                    clearCanvas: !e || void 0 === e.clearCanvas || e.clearCanvas,
                    context: (e && e.context) || null,
                    progressiveLoad: (e && e.progressiveLoad) || !1,
                    preserveAspectRatio: (e && e.preserveAspectRatio) || 'xMidYMid meet',
                    imagePreserveAspectRatio: (e && e.imagePreserveAspectRatio) || 'xMidYMid slice',
                    contentVisibility: (e && e.contentVisibility) || 'visible',
                    className: (e && e.className) || '',
                    id: (e && e.id) || '',
                  }),
                  (this.renderConfig.dpr = (e && e.dpr) || 1),
                  this.animationItem.wrapper && (this.renderConfig.dpr = (e && e.dpr) || window.devicePixelRatio || 1),
                  (this.renderedFrame = -1),
                  (this.globalData = {
                    frameNum: -1,
                    _mdf: !1,
                    renderConfig: this.renderConfig,
                    currentGlobalAlpha: -1,
                  }),
                  (this.contextData = new CVContextData()),
                  (this.elements = []),
                  (this.pendingElements = []),
                  (this.transformMat = new Matrix()),
                  (this.completeLayers = !1),
                  (this.rendererType = 'canvas');
              }
              function CVCompElement(t, e, r) {
                (this.completeLayers = !1),
                  (this.layers = t.layers),
                  (this.pendingElements = []),
                  (this.elements = createSizedArray(this.layers.length)),
                  this.initElement(t, e, r),
                  (this.tm = t.tm ? PropertyFactory.getProp(this, t.tm, 0, e.frameRate, this) : { _placeholder: !0 });
              }
              function CanvasRenderer(t, e) {
                (this.animationItem = t),
                  (this.renderConfig = {
                    clearCanvas: !e || void 0 === e.clearCanvas || e.clearCanvas,
                    context: (e && e.context) || null,
                    progressiveLoad: (e && e.progressiveLoad) || !1,
                    preserveAspectRatio: (e && e.preserveAspectRatio) || 'xMidYMid meet',
                    imagePreserveAspectRatio: (e && e.imagePreserveAspectRatio) || 'xMidYMid slice',
                    contentVisibility: (e && e.contentVisibility) || 'visible',
                    className: (e && e.className) || '',
                    id: (e && e.id) || '',
                    runExpressions: !e || void 0 === e.runExpressions || e.runExpressions,
                  }),
                  (this.renderConfig.dpr = (e && e.dpr) || 1),
                  this.animationItem.wrapper && (this.renderConfig.dpr = (e && e.dpr) || window.devicePixelRatio || 1),
                  (this.renderedFrame = -1),
                  (this.globalData = {
                    frameNum: -1,
                    _mdf: !1,
                    renderConfig: this.renderConfig,
                    currentGlobalAlpha: -1,
                  }),
                  (this.contextData = new CVContextData()),
                  (this.elements = []),
                  (this.pendingElements = []),
                  (this.transformMat = new Matrix()),
                  (this.completeLayers = !1),
                  (this.rendererType = 'canvas');
              }
              function HBaseElement() {}
              function HSolidElement(t, e, r) {
                this.initElement(t, e, r);
              }
              function HShapeElement(t, e, r) {
                (this.shapes = []),
                  (this.shapesData = t.shapes),
                  (this.stylesList = []),
                  (this.shapeModifiers = []),
                  (this.itemsData = []),
                  (this.processedElements = []),
                  (this.animatedContents = []),
                  (this.shapesContainer = createNS('g')),
                  this.initElement(t, e, r),
                  (this.prevViewData = []),
                  (this.currentBBox = { x: 999999, y: -999999, h: 0, w: 0 });
              }
              function HTextElement(t, e, r) {
                (this.textSpans = []),
                  (this.textPaths = []),
                  (this.currentBBox = { x: 999999, y: -999999, h: 0, w: 0 }),
                  (this.renderType = 'svg'),
                  (this.isMasked = !1),
                  this.initElement(t, e, r);
              }
              function HCameraElement(t, e, r) {
                this.initFrame(), this.initBaseData(t, e, r), this.initHierarchy();
                var n = PropertyFactory.getProp;
                if (
                  ((this.pe = n(this, t.pe, 0, 0, this)),
                  t.ks.p.s
                    ? ((this.px = n(this, t.ks.p.x, 1, 0, this)),
                      (this.py = n(this, t.ks.p.y, 1, 0, this)),
                      (this.pz = n(this, t.ks.p.z, 1, 0, this)))
                    : (this.p = n(this, t.ks.p, 1, 0, this)),
                  t.ks.a && (this.a = n(this, t.ks.a, 1, 0, this)),
                  t.ks.or.k.length && t.ks.or.k[0].to)
                ) {
                  var i,
                    o = t.ks.or.k.length;
                  for (i = 0; i < o; i += 1) (t.ks.or.k[i].to = null), (t.ks.or.k[i].ti = null);
                }
                (this.or = n(this, t.ks.or, 1, degToRads, this)),
                  (this.or.sh = !0),
                  (this.rx = n(this, t.ks.rx, 0, degToRads, this)),
                  (this.ry = n(this, t.ks.ry, 0, degToRads, this)),
                  (this.rz = n(this, t.ks.rz, 0, degToRads, this)),
                  (this.mat = new Matrix()),
                  (this._prevMat = new Matrix()),
                  (this._isFirstFrame = !0),
                  (this.finalTransform = { mProp: this });
              }
              function HImageElement(t, e, r) {
                (this.assetData = e.getAssetData(t.refId)), this.initElement(t, e, r);
              }
              function HybridRendererBase(t, e) {
                (this.animationItem = t),
                  (this.layers = null),
                  (this.renderedFrame = -1),
                  (this.renderConfig = {
                    className: (e && e.className) || '',
                    imagePreserveAspectRatio: (e && e.imagePreserveAspectRatio) || 'xMidYMid slice',
                    hideOnTransparent: !(e && !1 === e.hideOnTransparent),
                    filterSize: {
                      width: (e && e.filterSize && e.filterSize.width) || '400%',
                      height: (e && e.filterSize && e.filterSize.height) || '400%',
                      x: (e && e.filterSize && e.filterSize.x) || '-100%',
                      y: (e && e.filterSize && e.filterSize.y) || '-100%',
                    },
                  }),
                  (this.globalData = { _mdf: !1, frameNum: -1, renderConfig: this.renderConfig }),
                  (this.pendingElements = []),
                  (this.elements = []),
                  (this.threeDElements = []),
                  (this.destroyed = !1),
                  (this.camera = null),
                  (this.supports3d = !0),
                  (this.rendererType = 'html');
              }
              function HCompElement(t, e, r) {
                (this.layers = t.layers),
                  (this.supports3d = !t.hasMask),
                  (this.completeLayers = !1),
                  (this.pendingElements = []),
                  (this.elements = this.layers ? createSizedArray(this.layers.length) : []),
                  this.initElement(t, e, r),
                  (this.tm = t.tm ? PropertyFactory.getProp(this, t.tm, 0, e.frameRate, this) : { _placeholder: !0 });
              }
              function HybridRenderer(t, e) {
                (this.animationItem = t),
                  (this.layers = null),
                  (this.renderedFrame = -1),
                  (this.renderConfig = {
                    className: (e && e.className) || '',
                    imagePreserveAspectRatio: (e && e.imagePreserveAspectRatio) || 'xMidYMid slice',
                    hideOnTransparent: !(e && !1 === e.hideOnTransparent),
                    filterSize: {
                      width: (e && e.filterSize && e.filterSize.width) || '400%',
                      height: (e && e.filterSize && e.filterSize.height) || '400%',
                      x: (e && e.filterSize && e.filterSize.x) || '-100%',
                      y: (e && e.filterSize && e.filterSize.y) || '-100%',
                    },
                    runExpressions: !e || void 0 === e.runExpressions || e.runExpressions,
                  }),
                  (this.globalData = { _mdf: !1, frameNum: -1, renderConfig: this.renderConfig }),
                  (this.pendingElements = []),
                  (this.elements = []),
                  (this.threeDElements = []),
                  (this.destroyed = !1),
                  (this.camera = null),
                  (this.supports3d = !0),
                  (this.rendererType = 'html');
              }
              extendPrototype(
                [
                  BaseElement,
                  TransformElement,
                  SVGBaseElement,
                  HierarchyElement,
                  FrameElement,
                  RenderableDOMElement,
                  ITextElement,
                ],
                SVGTextLottieElement,
              ),
                (SVGTextLottieElement.prototype.createContent = function () {
                  this.data.singleShape &&
                    !this.globalData.fontManager.chars &&
                    (this.textContainer = createNS('text'));
                }),
                (SVGTextLottieElement.prototype.buildTextContents = function (t) {
                  for (var e = 0, r = t.length, n = [], i = ''; e < r; )
                    t[e] === String.fromCharCode(13) || t[e] === String.fromCharCode(3)
                      ? (n.push(i), (i = ''))
                      : (i += t[e]),
                      (e += 1);
                  return n.push(i), n;
                }),
                (SVGTextLottieElement.prototype.buildShapeData = function (t, e) {
                  if (t.shapes && t.shapes.length) {
                    var r = t.shapes[0];
                    if (r.it) {
                      var n = r.it[r.it.length - 1];
                      n.s && ((n.s.k[0] = e), (n.s.k[1] = e));
                    }
                  }
                  return t;
                }),
                (SVGTextLottieElement.prototype.buildNewText = function () {
                  var t, e;
                  this.addDynamicProperty(this);
                  var r = this.textProperty.currentData;
                  (this.renderedLetters = createSizedArray(r ? r.l.length : 0)),
                    r.fc
                      ? this.layerElement.setAttribute('fill', this.buildColor(r.fc))
                      : this.layerElement.setAttribute('fill', 'rgba(0,0,0,0)'),
                    r.sc &&
                      (this.layerElement.setAttribute('stroke', this.buildColor(r.sc)),
                      this.layerElement.setAttribute('stroke-width', r.sw)),
                    this.layerElement.setAttribute('font-size', r.finalSize);
                  var n = this.globalData.fontManager.getFontByName(r.f);
                  if (n.fClass) this.layerElement.setAttribute('class', n.fClass);
                  else {
                    this.layerElement.setAttribute('font-family', n.fFamily);
                    var i = r.fWeight,
                      o = r.fStyle;
                    this.layerElement.setAttribute('font-style', o), this.layerElement.setAttribute('font-weight', i);
                  }
                  this.layerElement.setAttribute('aria-label', r.t);
                  var a,
                    s = r.l || [],
                    l = !!this.globalData.fontManager.chars;
                  e = s.length;
                  var c = this.mHelper,
                    h = this.data.singleShape,
                    u = 0,
                    p = 0,
                    f = !0,
                    d = 0.001 * r.tr * r.finalSize;
                  if (!h || l || r.sz) {
                    var m,
                      y = this.textSpans.length;
                    for (t = 0; t < e; t += 1) {
                      if (
                        (this.textSpans[t] || (this.textSpans[t] = { span: null, childSpan: null, glyph: null }),
                        !l || !h || 0 === t)
                      ) {
                        if (((a = y > t ? this.textSpans[t].span : createNS(l ? 'g' : 'text')), y <= t)) {
                          if (
                            (a.setAttribute('stroke-linecap', 'butt'),
                            a.setAttribute('stroke-linejoin', 'round'),
                            a.setAttribute('stroke-miterlimit', '4'),
                            (this.textSpans[t].span = a),
                            l)
                          ) {
                            var g = createNS('g');
                            a.appendChild(g), (this.textSpans[t].childSpan = g);
                          }
                          (this.textSpans[t].span = a), this.layerElement.appendChild(a);
                        }
                        a.style.display = 'inherit';
                      }
                      if (
                        (c.reset(),
                        h &&
                          (s[t].n && ((u = -d), (p += r.yOffset), (p += f ? 1 : 0), (f = !1)),
                          this.applyTextPropertiesToMatrix(r, c, s[t].line, u, p),
                          (u += s[t].l || 0),
                          (u += d)),
                        l)
                      ) {
                        var v;
                        if (
                          1 ===
                          (m = this.globalData.fontManager.getCharData(
                            r.finalText[t],
                            n.fStyle,
                            this.globalData.fontManager.getFontByName(r.f).fFamily,
                          )).t
                        )
                          v = new SVGCompElement(m.data, this.globalData, this);
                        else {
                          var b = emptyShapeData;
                          m.data && m.data.shapes && (b = this.buildShapeData(m.data, r.finalSize)),
                            (v = new SVGShapeElement(b, this.globalData, this));
                        }
                        if (this.textSpans[t].glyph) {
                          var x = this.textSpans[t].glyph;
                          this.textSpans[t].childSpan.removeChild(x.layerElement), x.destroy();
                        }
                        (this.textSpans[t].glyph = v),
                          (v._debug = !0),
                          v.prepareFrame(0),
                          v.renderFrame(),
                          this.textSpans[t].childSpan.appendChild(v.layerElement),
                          1 === m.t &&
                            this.textSpans[t].childSpan.setAttribute(
                              'transform',
                              'scale(' + r.finalSize / 100 + ',' + r.finalSize / 100 + ')',
                            );
                      } else
                        h && a.setAttribute('transform', 'translate(' + c.props[12] + ',' + c.props[13] + ')'),
                          (a.textContent = s[t].val),
                          a.setAttributeNS('http://www.w3.org/XML/1998/namespace', 'xml:space', 'preserve');
                    }
                    h && a && a.setAttribute('d', '');
                  } else {
                    var E = this.textContainer,
                      w = 'start';
                    switch (r.j) {
                      case 1:
                        w = 'end';
                        break;
                      case 2:
                        w = 'middle';
                        break;
                      default:
                        w = 'start';
                    }
                    E.setAttribute('text-anchor', w), E.setAttribute('letter-spacing', d);
                    var _ = this.buildTextContents(r.finalText);
                    for (e = _.length, p = r.ps ? r.ps[1] + r.ascent : 0, t = 0; t < e; t += 1)
                      ((a = this.textSpans[t].span || createNS('tspan')).textContent = _[t]),
                        a.setAttribute('x', 0),
                        a.setAttribute('y', p),
                        (a.style.display = 'inherit'),
                        E.appendChild(a),
                        this.textSpans[t] || (this.textSpans[t] = { span: null, glyph: null }),
                        (this.textSpans[t].span = a),
                        (p += r.finalLineHeight);
                    this.layerElement.appendChild(E);
                  }
                  for (; t < this.textSpans.length; ) (this.textSpans[t].span.style.display = 'none'), (t += 1);
                  this._sizeChanged = !0;
                }),
                (SVGTextLottieElement.prototype.sourceRectAtTime = function () {
                  if (
                    (this.prepareFrame(this.comp.renderedFrame - this.data.st),
                    this.renderInnerContent(),
                    this._sizeChanged)
                  ) {
                    this._sizeChanged = !1;
                    var t = this.layerElement.getBBox();
                    this.bbox = { top: t.y, left: t.x, width: t.width, height: t.height };
                  }
                  return this.bbox;
                }),
                (SVGTextLottieElement.prototype.getValue = function () {
                  var t,
                    e,
                    r = this.textSpans.length;
                  for (this.renderedFrame = this.comp.renderedFrame, t = 0; t < r; t += 1)
                    (e = this.textSpans[t].glyph) &&
                      (e.prepareFrame(this.comp.renderedFrame - this.data.st), e._mdf && (this._mdf = !0));
                }),
                (SVGTextLottieElement.prototype.renderInnerContent = function () {
                  if (
                    (!this.data.singleShape || this._mdf) &&
                    (this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag),
                    this.lettersChangedFlag || this.textAnimator.lettersChangedFlag)
                  ) {
                    var t, e;
                    this._sizeChanged = !0;
                    var r,
                      n,
                      i,
                      o = this.textAnimator.renderedLetters,
                      a = this.textProperty.currentData.l;
                    for (e = a.length, t = 0; t < e; t += 1)
                      a[t].n ||
                        ((r = o[t]),
                        (n = this.textSpans[t].span),
                        (i = this.textSpans[t].glyph) && i.renderFrame(),
                        r._mdf.m && n.setAttribute('transform', r.m),
                        r._mdf.o && n.setAttribute('opacity', r.o),
                        r._mdf.sw && n.setAttribute('stroke-width', r.sw),
                        r._mdf.sc && n.setAttribute('stroke', r.sc),
                        r._mdf.fc && n.setAttribute('fill', r.fc));
                  }
                }),
                extendPrototype([IImageElement], ISolidElement),
                (ISolidElement.prototype.createContent = function () {
                  var t = createNS('rect');
                  t.setAttribute('width', this.data.sw),
                    t.setAttribute('height', this.data.sh),
                    t.setAttribute('fill', this.data.sc),
                    this.layerElement.appendChild(t);
                }),
                (NullElement.prototype.prepareFrame = function (t) {
                  this.prepareProperties(t, !0);
                }),
                (NullElement.prototype.renderFrame = function () {}),
                (NullElement.prototype.getBaseElement = function () {
                  return null;
                }),
                (NullElement.prototype.destroy = function () {}),
                (NullElement.prototype.sourceRectAtTime = function () {}),
                (NullElement.prototype.hide = function () {}),
                extendPrototype([BaseElement, TransformElement, HierarchyElement, FrameElement], NullElement),
                extendPrototype([BaseRenderer], SVGRendererBase),
                (SVGRendererBase.prototype.createNull = function (t) {
                  return new NullElement(t, this.globalData, this);
                }),
                (SVGRendererBase.prototype.createShape = function (t) {
                  return new SVGShapeElement(t, this.globalData, this);
                }),
                (SVGRendererBase.prototype.createText = function (t) {
                  return new SVGTextLottieElement(t, this.globalData, this);
                }),
                (SVGRendererBase.prototype.createImage = function (t) {
                  return new IImageElement(t, this.globalData, this);
                }),
                (SVGRendererBase.prototype.createSolid = function (t) {
                  return new ISolidElement(t, this.globalData, this);
                }),
                (SVGRendererBase.prototype.configAnimation = function (t) {
                  this.svgElement.setAttribute('xmlns', 'http://www.w3.org/2000/svg'),
                    this.svgElement.setAttribute('xmlns:xlink', 'http://www.w3.org/1999/xlink'),
                    this.renderConfig.viewBoxSize
                      ? this.svgElement.setAttribute('viewBox', this.renderConfig.viewBoxSize)
                      : this.svgElement.setAttribute('viewBox', '0 0 ' + t.w + ' ' + t.h),
                    this.renderConfig.viewBoxOnly ||
                      (this.svgElement.setAttribute('width', t.w),
                      this.svgElement.setAttribute('height', t.h),
                      (this.svgElement.style.width = '100%'),
                      (this.svgElement.style.height = '100%'),
                      (this.svgElement.style.transform = 'translate3d(0,0,0)'),
                      (this.svgElement.style.contentVisibility = this.renderConfig.contentVisibility)),
                    this.renderConfig.width && this.svgElement.setAttribute('width', this.renderConfig.width),
                    this.renderConfig.height && this.svgElement.setAttribute('height', this.renderConfig.height),
                    this.renderConfig.className && this.svgElement.setAttribute('class', this.renderConfig.className),
                    this.renderConfig.id && this.svgElement.setAttribute('id', this.renderConfig.id),
                    void 0 !== this.renderConfig.focusable &&
                      this.svgElement.setAttribute('focusable', this.renderConfig.focusable),
                    this.svgElement.setAttribute('preserveAspectRatio', this.renderConfig.preserveAspectRatio),
                    this.animationItem.wrapper.appendChild(this.svgElement);
                  var e = this.globalData.defs;
                  this.setupGlobalData(t, e),
                    (this.globalData.progressiveLoad = this.renderConfig.progressiveLoad),
                    (this.data = t);
                  var r = createNS('clipPath'),
                    n = createNS('rect');
                  n.setAttribute('width', t.w),
                    n.setAttribute('height', t.h),
                    n.setAttribute('x', 0),
                    n.setAttribute('y', 0);
                  var i = createElementID();
                  r.setAttribute('id', i),
                    r.appendChild(n),
                    this.layerElement.setAttribute('clip-path', 'url(' + getLocationHref() + '#' + i + ')'),
                    e.appendChild(r),
                    (this.layers = t.layers),
                    (this.elements = createSizedArray(t.layers.length));
                }),
                (SVGRendererBase.prototype.destroy = function () {
                  var t;
                  this.animationItem.wrapper && (this.animationItem.wrapper.innerText = ''),
                    (this.layerElement = null),
                    (this.globalData.defs = null);
                  var e = this.layers ? this.layers.length : 0;
                  for (t = 0; t < e; t += 1) this.elements[t] && this.elements[t].destroy();
                  (this.elements.length = 0), (this.destroyed = !0), (this.animationItem = null);
                }),
                (SVGRendererBase.prototype.updateContainerSize = function () {}),
                (SVGRendererBase.prototype.findIndexByInd = function (t) {
                  var e = 0,
                    r = this.layers.length;
                  for (e = 0; e < r; e += 1) if (this.layers[e].ind === t) return e;
                  return -1;
                }),
                (SVGRendererBase.prototype.buildItem = function (t) {
                  var e = this.elements;
                  if (!e[t] && 99 !== this.layers[t].ty) {
                    e[t] = !0;
                    var r = this.createItem(this.layers[t]);
                    if (
                      ((e[t] = r),
                      getExpressionsPlugin() &&
                        (0 === this.layers[t].ty && this.globalData.projectInterface.registerComposition(r),
                        r.initExpressions()),
                      this.appendElementInPos(r, t),
                      this.layers[t].tt)
                    ) {
                      var n = 'tp' in this.layers[t] ? this.findIndexByInd(this.layers[t].tp) : t - 1;
                      if (-1 === n) return;
                      if (this.elements[n] && !0 !== this.elements[n]) {
                        var i = e[n].getMatte(this.layers[t].tt);
                        r.setMatte(i);
                      } else this.buildItem(n), this.addPendingElement(r);
                    }
                  }
                }),
                (SVGRendererBase.prototype.checkPendingElements = function () {
                  for (; this.pendingElements.length; ) {
                    var t = this.pendingElements.pop();
                    if ((t.checkParenting(), t.data.tt))
                      for (var e = 0, r = this.elements.length; e < r; ) {
                        if (this.elements[e] === t) {
                          var n = 'tp' in t.data ? this.findIndexByInd(t.data.tp) : e - 1,
                            i = this.elements[n].getMatte(this.layers[e].tt);
                          t.setMatte(i);
                          break;
                        }
                        e += 1;
                      }
                  }
                }),
                (SVGRendererBase.prototype.renderFrame = function (t) {
                  if (this.renderedFrame !== t && !this.destroyed) {
                    var e;
                    null === t ? (t = this.renderedFrame) : (this.renderedFrame = t),
                      (this.globalData.frameNum = t),
                      (this.globalData.frameId += 1),
                      (this.globalData.projectInterface.currentFrame = t),
                      (this.globalData._mdf = !1);
                    var r = this.layers.length;
                    for (this.completeLayers || this.checkLayers(t), e = r - 1; e >= 0; e -= 1)
                      (this.completeLayers || this.elements[e]) && this.elements[e].prepareFrame(t - this.layers[e].st);
                    if (this.globalData._mdf)
                      for (e = 0; e < r; e += 1)
                        (this.completeLayers || this.elements[e]) && this.elements[e].renderFrame();
                  }
                }),
                (SVGRendererBase.prototype.appendElementInPos = function (t, e) {
                  var r = t.getBaseElement();
                  if (r) {
                    for (var n, i = 0; i < e; )
                      this.elements[i] &&
                        !0 !== this.elements[i] &&
                        this.elements[i].getBaseElement() &&
                        (n = this.elements[i].getBaseElement()),
                        (i += 1);
                    n ? this.layerElement.insertBefore(r, n) : this.layerElement.appendChild(r);
                  }
                }),
                (SVGRendererBase.prototype.hide = function () {
                  this.layerElement.style.display = 'none';
                }),
                (SVGRendererBase.prototype.show = function () {
                  this.layerElement.style.display = 'block';
                }),
                extendPrototype(
                  [BaseElement, TransformElement, HierarchyElement, FrameElement, RenderableDOMElement],
                  ICompElement,
                ),
                (ICompElement.prototype.initElement = function (t, e, r) {
                  this.initFrame(),
                    this.initBaseData(t, e, r),
                    this.initTransform(t, e, r),
                    this.initRenderable(),
                    this.initHierarchy(),
                    this.initRendererElement(),
                    this.createContainerElements(),
                    this.createRenderableComponents(),
                    (!this.data.xt && e.progressiveLoad) || this.buildAllItems(),
                    this.hide();
                }),
                (ICompElement.prototype.prepareFrame = function (t) {
                  if (
                    ((this._mdf = !1),
                    this.prepareRenderableFrame(t),
                    this.prepareProperties(t, this.isInRange),
                    this.isInRange || this.data.xt)
                  ) {
                    if (this.tm._placeholder) this.renderedFrame = t / this.data.sr;
                    else {
                      var e = this.tm.v;
                      e === this.data.op && (e = this.data.op - 1), (this.renderedFrame = e);
                    }
                    var r,
                      n = this.elements.length;
                    for (this.completeLayers || this.checkLayers(this.renderedFrame), r = n - 1; r >= 0; r -= 1)
                      (this.completeLayers || this.elements[r]) &&
                        (this.elements[r].prepareFrame(this.renderedFrame - this.layers[r].st),
                        this.elements[r]._mdf && (this._mdf = !0));
                  }
                }),
                (ICompElement.prototype.renderInnerContent = function () {
                  var t,
                    e = this.layers.length;
                  for (t = 0; t < e; t += 1)
                    (this.completeLayers || this.elements[t]) && this.elements[t].renderFrame();
                }),
                (ICompElement.prototype.setElements = function (t) {
                  this.elements = t;
                }),
                (ICompElement.prototype.getElements = function () {
                  return this.elements;
                }),
                (ICompElement.prototype.destroyElements = function () {
                  var t,
                    e = this.layers.length;
                  for (t = 0; t < e; t += 1) this.elements[t] && this.elements[t].destroy();
                }),
                (ICompElement.prototype.destroy = function () {
                  this.destroyElements(), this.destroyBaseElement();
                }),
                extendPrototype([SVGRendererBase, ICompElement, SVGBaseElement], SVGCompElement),
                (SVGCompElement.prototype.createComp = function (t) {
                  return new SVGCompElement(t, this.globalData, this);
                }),
                extendPrototype([SVGRendererBase], SVGRenderer),
                (SVGRenderer.prototype.createComp = function (t) {
                  return new SVGCompElement(t, this.globalData, this);
                }),
                (CVContextData.prototype.duplicate = function () {
                  var t = 2 * this._length,
                    e = this.savedOp;
                  (this.savedOp = createTypedArray('float32', t)), this.savedOp.set(e);
                  var r = 0;
                  for (r = this._length; r < t; r += 1) this.saved[r] = createTypedArray('float32', 16);
                  this._length = t;
                }),
                (CVContextData.prototype.reset = function () {
                  (this.cArrPos = 0), this.cTr.reset(), (this.cO = 1);
                }),
                (ShapeTransformManager.prototype = {
                  addTransformSequence: function (t) {
                    var e,
                      r = t.length,
                      n = '_';
                    for (e = 0; e < r; e += 1) n += t[e].transform.key + '_';
                    var i = this.sequences[n];
                    return (
                      i ||
                        ((i = { transforms: [].concat(t), finalTransform: new Matrix(), _mdf: !1 }),
                        (this.sequences[n] = i),
                        this.sequenceList.push(i)),
                      i
                    );
                  },
                  processSequence: function (t, e) {
                    for (var r, n = 0, i = t.transforms.length, o = e; n < i && !e; ) {
                      if (t.transforms[n].transform.mProps._mdf) {
                        o = !0;
                        break;
                      }
                      n += 1;
                    }
                    if (o)
                      for (t.finalTransform.reset(), n = i - 1; n >= 0; n -= 1)
                        (r = t.transforms[n].transform.mProps.v.props),
                          t.finalTransform.transform(
                            r[0],
                            r[1],
                            r[2],
                            r[3],
                            r[4],
                            r[5],
                            r[6],
                            r[7],
                            r[8],
                            r[9],
                            r[10],
                            r[11],
                            r[12],
                            r[13],
                            r[14],
                            r[15],
                          );
                    t._mdf = o;
                  },
                  processSequences: function (t) {
                    var e,
                      r = this.sequenceList.length;
                    for (e = 0; e < r; e += 1) this.processSequence(this.sequenceList[e], t);
                  },
                  getNewKey: function () {
                    return (this.transform_key_count += 1), '_' + this.transform_key_count;
                  },
                }),
                (CVEffects.prototype.renderFrame = function () {}),
                (CVMaskElement.prototype.renderFrame = function () {
                  if (this.hasMasks) {
                    var t,
                      e,
                      r,
                      n,
                      i = this.element.finalTransform.mat,
                      o = this.element.canvasContext,
                      a = this.masksProperties.length;
                    for (o.beginPath(), t = 0; t < a; t += 1)
                      if ('n' !== this.masksProperties[t].mode) {
                        var s;
                        this.masksProperties[t].inv &&
                          (o.moveTo(0, 0),
                          o.lineTo(this.element.globalData.compSize.w, 0),
                          o.lineTo(this.element.globalData.compSize.w, this.element.globalData.compSize.h),
                          o.lineTo(0, this.element.globalData.compSize.h),
                          o.lineTo(0, 0)),
                          (n = this.viewData[t].v),
                          (e = i.applyToPointArray(n.v[0][0], n.v[0][1], 0)),
                          o.moveTo(e[0], e[1]);
                        var l = n._length;
                        for (s = 1; s < l; s += 1)
                          (r = i.applyToTriplePoints(n.o[s - 1], n.i[s], n.v[s])),
                            o.bezierCurveTo(r[0], r[1], r[2], r[3], r[4], r[5]);
                        (r = i.applyToTriplePoints(n.o[s - 1], n.i[0], n.v[0])),
                          o.bezierCurveTo(r[0], r[1], r[2], r[3], r[4], r[5]);
                      }
                    this.element.globalData.renderer.save(!0), o.clip();
                  }
                }),
                (CVMaskElement.prototype.getMaskProperty = MaskElement.prototype.getMaskProperty),
                (CVMaskElement.prototype.destroy = function () {
                  this.element = null;
                }),
                (CVBaseElement.prototype = {
                  createElements: function () {},
                  initRendererElement: function () {},
                  createContainerElements: function () {
                    (this.canvasContext = this.globalData.canvasContext),
                      (this.renderableEffectsManager = new CVEffects(this));
                  },
                  createContent: function () {},
                  setBlendMode: function () {
                    var t = this.globalData;
                    if (t.blendMode !== this.data.bm) {
                      t.blendMode = this.data.bm;
                      var e = getBlendMode(this.data.bm);
                      t.canvasContext.globalCompositeOperation = e;
                    }
                  },
                  createRenderableComponents: function () {
                    this.maskManager = new CVMaskElement(this.data, this);
                  },
                  hideElement: function () {
                    this.hidden || (this.isInRange && !this.isTransparent) || (this.hidden = !0);
                  },
                  showElement: function () {
                    this.isInRange &&
                      !this.isTransparent &&
                      ((this.hidden = !1), (this._isFirstFrame = !0), (this.maskManager._isFirstFrame = !0));
                  },
                  renderFrame: function () {
                    if (!this.hidden && !this.data.hd) {
                      this.renderTransform(), this.renderRenderable(), this.setBlendMode();
                      var t = 0 === this.data.ty;
                      this.globalData.renderer.save(t),
                        this.globalData.renderer.ctxTransform(this.finalTransform.mat.props),
                        this.globalData.renderer.ctxOpacity(this.finalTransform.mProp.o.v),
                        this.renderInnerContent(),
                        this.globalData.renderer.restore(t),
                        this.maskManager.hasMasks && this.globalData.renderer.restore(!0),
                        this._isFirstFrame && (this._isFirstFrame = !1);
                    }
                  },
                  destroy: function () {
                    (this.canvasContext = null),
                      (this.data = null),
                      (this.globalData = null),
                      this.maskManager.destroy();
                  },
                  mHelper: new Matrix(),
                }),
                (CVBaseElement.prototype.hide = CVBaseElement.prototype.hideElement),
                (CVBaseElement.prototype.show = CVBaseElement.prototype.showElement),
                (CVShapeData.prototype.setAsAnimated = SVGShapeData.prototype.setAsAnimated),
                extendPrototype(
                  [
                    BaseElement,
                    TransformElement,
                    CVBaseElement,
                    IShapeElement,
                    HierarchyElement,
                    FrameElement,
                    RenderableElement,
                  ],
                  CVShapeElement,
                ),
                (CVShapeElement.prototype.initElement = RenderableDOMElement.prototype.initElement),
                (CVShapeElement.prototype.transformHelper = { opacity: 1, _opMdf: !1 }),
                (CVShapeElement.prototype.dashResetter = []),
                (CVShapeElement.prototype.createContent = function () {
                  this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, !0, []);
                }),
                (CVShapeElement.prototype.createStyleElement = function (t, e) {
                  var r = {
                      data: t,
                      type: t.ty,
                      preTransforms: this.transformsManager.addTransformSequence(e),
                      transforms: [],
                      elements: [],
                      closed: !0 === t.hd,
                    },
                    n = {};
                  if (
                    ('fl' === t.ty || 'st' === t.ty
                      ? ((n.c = PropertyFactory.getProp(this, t.c, 1, 255, this)),
                        n.c.k ||
                          (r.co = 'rgb(' + bmFloor(n.c.v[0]) + ',' + bmFloor(n.c.v[1]) + ',' + bmFloor(n.c.v[2]) + ')'))
                      : ('gf' !== t.ty && 'gs' !== t.ty) ||
                        ((n.s = PropertyFactory.getProp(this, t.s, 1, null, this)),
                        (n.e = PropertyFactory.getProp(this, t.e, 1, null, this)),
                        (n.h = PropertyFactory.getProp(this, t.h || { k: 0 }, 0, 0.01, this)),
                        (n.a = PropertyFactory.getProp(this, t.a || { k: 0 }, 0, degToRads, this)),
                        (n.g = new GradientProperty(this, t.g, this))),
                    (n.o = PropertyFactory.getProp(this, t.o, 0, 0.01, this)),
                    'st' === t.ty || 'gs' === t.ty)
                  ) {
                    if (
                      ((r.lc = lineCapEnum[t.lc || 2]),
                      (r.lj = lineJoinEnum[t.lj || 2]),
                      1 == t.lj && (r.ml = t.ml),
                      (n.w = PropertyFactory.getProp(this, t.w, 0, null, this)),
                      n.w.k || (r.wi = n.w.v),
                      t.d)
                    ) {
                      var i = new DashProperty(this, t.d, 'canvas', this);
                      (n.d = i), n.d.k || ((r.da = n.d.dashArray), (r.do = n.d.dashoffset[0]));
                    }
                  } else r.r = 2 === t.r ? 'evenodd' : 'nonzero';
                  return this.stylesList.push(r), (n.style = r), n;
                }),
                (CVShapeElement.prototype.createGroupElement = function () {
                  return { it: [], prevViewData: [] };
                }),
                (CVShapeElement.prototype.createTransformElement = function (t) {
                  return {
                    transform: {
                      opacity: 1,
                      _opMdf: !1,
                      key: this.transformsManager.getNewKey(),
                      op: PropertyFactory.getProp(this, t.o, 0, 0.01, this),
                      mProps: TransformPropertyFactory.getTransformProperty(this, t, this),
                    },
                  };
                }),
                (CVShapeElement.prototype.createShapeElement = function (t) {
                  var e = new CVShapeData(this, t, this.stylesList, this.transformsManager);
                  return this.shapes.push(e), this.addShapeToModifiers(e), e;
                }),
                (CVShapeElement.prototype.reloadShapes = function () {
                  var t;
                  this._isFirstFrame = !0;
                  var e = this.itemsData.length;
                  for (t = 0; t < e; t += 1) this.prevViewData[t] = this.itemsData[t];
                  for (
                    this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, !0, []),
                      e = this.dynamicProperties.length,
                      t = 0;
                    t < e;
                    t += 1
                  )
                    this.dynamicProperties[t].getValue();
                  this.renderModifiers(), this.transformsManager.processSequences(this._isFirstFrame);
                }),
                (CVShapeElement.prototype.addTransformToStyleList = function (t) {
                  var e,
                    r = this.stylesList.length;
                  for (e = 0; e < r; e += 1) this.stylesList[e].closed || this.stylesList[e].transforms.push(t);
                }),
                (CVShapeElement.prototype.removeTransformFromStyleList = function () {
                  var t,
                    e = this.stylesList.length;
                  for (t = 0; t < e; t += 1) this.stylesList[t].closed || this.stylesList[t].transforms.pop();
                }),
                (CVShapeElement.prototype.closeStyles = function (t) {
                  var e,
                    r = t.length;
                  for (e = 0; e < r; e += 1) t[e].closed = !0;
                }),
                (CVShapeElement.prototype.searchShapes = function (t, e, r, n, i) {
                  var o,
                    a,
                    s,
                    l,
                    c,
                    h,
                    u = t.length - 1,
                    p = [],
                    f = [],
                    d = [].concat(i);
                  for (o = u; o >= 0; o -= 1) {
                    if (
                      ((l = this.searchProcessedElement(t[o])) ? (e[o] = r[l - 1]) : (t[o]._shouldRender = n),
                      'fl' === t[o].ty || 'st' === t[o].ty || 'gf' === t[o].ty || 'gs' === t[o].ty)
                    )
                      l ? (e[o].style.closed = !1) : (e[o] = this.createStyleElement(t[o], d)), p.push(e[o].style);
                    else if ('gr' === t[o].ty) {
                      if (l) for (s = e[o].it.length, a = 0; a < s; a += 1) e[o].prevViewData[a] = e[o].it[a];
                      else e[o] = this.createGroupElement(t[o]);
                      this.searchShapes(t[o].it, e[o].it, e[o].prevViewData, n, d);
                    } else
                      'tr' === t[o].ty
                        ? (l || ((h = this.createTransformElement(t[o])), (e[o] = h)),
                          d.push(e[o]),
                          this.addTransformToStyleList(e[o]))
                        : 'sh' === t[o].ty || 'rc' === t[o].ty || 'el' === t[o].ty || 'sr' === t[o].ty
                        ? l || (e[o] = this.createShapeElement(t[o]))
                        : 'tm' === t[o].ty ||
                          'rd' === t[o].ty ||
                          'pb' === t[o].ty ||
                          'zz' === t[o].ty ||
                          'op' === t[o].ty
                        ? (l
                            ? ((c = e[o]).closed = !1)
                            : ((c = ShapeModifiers.getModifier(t[o].ty)).init(this, t[o]),
                              (e[o] = c),
                              this.shapeModifiers.push(c)),
                          f.push(c))
                        : 'rp' === t[o].ty &&
                          (l
                            ? ((c = e[o]).closed = !0)
                            : ((c = ShapeModifiers.getModifier(t[o].ty)),
                              (e[o] = c),
                              c.init(this, t, o, e),
                              this.shapeModifiers.push(c),
                              (n = !1)),
                          f.push(c));
                    this.addProcessedElement(t[o], o + 1);
                  }
                  for (this.removeTransformFromStyleList(), this.closeStyles(p), u = f.length, o = 0; o < u; o += 1)
                    f[o].closed = !0;
                }),
                (CVShapeElement.prototype.renderInnerContent = function () {
                  (this.transformHelper.opacity = 1),
                    (this.transformHelper._opMdf = !1),
                    this.renderModifiers(),
                    this.transformsManager.processSequences(this._isFirstFrame),
                    this.renderShape(this.transformHelper, this.shapesData, this.itemsData, !0);
                }),
                (CVShapeElement.prototype.renderShapeTransform = function (t, e) {
                  (t._opMdf || e.op._mdf || this._isFirstFrame) &&
                    ((e.opacity = t.opacity), (e.opacity *= e.op.v), (e._opMdf = !0));
                }),
                (CVShapeElement.prototype.drawLayer = function () {
                  var t,
                    e,
                    r,
                    n,
                    i,
                    o,
                    a,
                    s,
                    l,
                    c = this.stylesList.length,
                    h = this.globalData.renderer,
                    u = this.globalData.canvasContext;
                  for (t = 0; t < c; t += 1)
                    if (
                      (('st' !== (s = (l = this.stylesList[t]).type) && 'gs' !== s) || 0 !== l.wi) &&
                      l.data._shouldRender &&
                      0 !== l.coOp &&
                      0 !== this.globalData.currentGlobalAlpha
                    ) {
                      for (
                        h.save(),
                          o = l.elements,
                          'st' === s || 'gs' === s
                            ? ((u.strokeStyle = 'st' === s ? l.co : l.grd),
                              (u.lineWidth = l.wi),
                              (u.lineCap = l.lc),
                              (u.lineJoin = l.lj),
                              (u.miterLimit = l.ml || 0))
                            : (u.fillStyle = 'fl' === s ? l.co : l.grd),
                          h.ctxOpacity(l.coOp),
                          'st' !== s && 'gs' !== s && u.beginPath(),
                          h.ctxTransform(l.preTransforms.finalTransform.props),
                          r = o.length,
                          e = 0;
                        e < r;
                        e += 1
                      ) {
                        for (
                          ('st' !== s && 'gs' !== s) ||
                            (u.beginPath(), l.da && (u.setLineDash(l.da), (u.lineDashOffset = l.do))),
                            i = (a = o[e].trNodes).length,
                            n = 0;
                          n < i;
                          n += 1
                        )
                          'm' === a[n].t
                            ? u.moveTo(a[n].p[0], a[n].p[1])
                            : 'c' === a[n].t
                            ? u.bezierCurveTo(
                                a[n].pts[0],
                                a[n].pts[1],
                                a[n].pts[2],
                                a[n].pts[3],
                                a[n].pts[4],
                                a[n].pts[5],
                              )
                            : u.closePath();
                        ('st' !== s && 'gs' !== s) || (u.stroke(), l.da && u.setLineDash(this.dashResetter));
                      }
                      'st' !== s && 'gs' !== s && u.fill(l.r), h.restore();
                    }
                }),
                (CVShapeElement.prototype.renderShape = function (t, e, r, n) {
                  var i, o;
                  for (o = t, i = e.length - 1; i >= 0; i -= 1)
                    'tr' === e[i].ty
                      ? ((o = r[i].transform), this.renderShapeTransform(t, o))
                      : 'sh' === e[i].ty || 'el' === e[i].ty || 'rc' === e[i].ty || 'sr' === e[i].ty
                      ? this.renderPath(e[i], r[i])
                      : 'fl' === e[i].ty
                      ? this.renderFill(e[i], r[i], o)
                      : 'st' === e[i].ty
                      ? this.renderStroke(e[i], r[i], o)
                      : 'gf' === e[i].ty || 'gs' === e[i].ty
                      ? this.renderGradientFill(e[i], r[i], o)
                      : 'gr' === e[i].ty
                      ? this.renderShape(o, e[i].it, r[i].it)
                      : e[i].ty;
                  n && this.drawLayer();
                }),
                (CVShapeElement.prototype.renderStyledShape = function (t, e) {
                  if (this._isFirstFrame || e._mdf || t.transforms._mdf) {
                    var r,
                      n,
                      i,
                      o = t.trNodes,
                      a = e.paths,
                      s = a._length;
                    o.length = 0;
                    var l = t.transforms.finalTransform;
                    for (i = 0; i < s; i += 1) {
                      var c = a.shapes[i];
                      if (c && c.v) {
                        for (n = c._length, r = 1; r < n; r += 1)
                          1 === r && o.push({ t: 'm', p: l.applyToPointArray(c.v[0][0], c.v[0][1], 0) }),
                            o.push({ t: 'c', pts: l.applyToTriplePoints(c.o[r - 1], c.i[r], c.v[r]) });
                        1 === n && o.push({ t: 'm', p: l.applyToPointArray(c.v[0][0], c.v[0][1], 0) }),
                          c.c &&
                            n &&
                            (o.push({ t: 'c', pts: l.applyToTriplePoints(c.o[r - 1], c.i[0], c.v[0]) }),
                            o.push({ t: 'z' }));
                      }
                    }
                    t.trNodes = o;
                  }
                }),
                (CVShapeElement.prototype.renderPath = function (t, e) {
                  if (!0 !== t.hd && t._shouldRender) {
                    var r,
                      n = e.styledShapes.length;
                    for (r = 0; r < n; r += 1) this.renderStyledShape(e.styledShapes[r], e.sh);
                  }
                }),
                (CVShapeElement.prototype.renderFill = function (t, e, r) {
                  var n = e.style;
                  (e.c._mdf || this._isFirstFrame) &&
                    (n.co = 'rgb(' + bmFloor(e.c.v[0]) + ',' + bmFloor(e.c.v[1]) + ',' + bmFloor(e.c.v[2]) + ')'),
                    (e.o._mdf || r._opMdf || this._isFirstFrame) && (n.coOp = e.o.v * r.opacity);
                }),
                (CVShapeElement.prototype.renderGradientFill = function (t, e, r) {
                  var n,
                    i = e.style;
                  if (!i.grd || e.g._mdf || e.s._mdf || e.e._mdf || (1 !== t.t && (e.h._mdf || e.a._mdf))) {
                    var o,
                      a = this.globalData.canvasContext,
                      s = e.s.v,
                      l = e.e.v;
                    if (1 === t.t) n = a.createLinearGradient(s[0], s[1], l[0], l[1]);
                    else {
                      var c = Math.sqrt(Math.pow(s[0] - l[0], 2) + Math.pow(s[1] - l[1], 2)),
                        h = Math.atan2(l[1] - s[1], l[0] - s[0]),
                        u = e.h.v;
                      u >= 1 ? (u = 0.99) : u <= -1 && (u = -0.99);
                      var p = c * u,
                        f = Math.cos(h + e.a.v) * p + s[0],
                        d = Math.sin(h + e.a.v) * p + s[1];
                      n = a.createRadialGradient(f, d, 0, s[0], s[1], c);
                    }
                    var m = t.g.p,
                      y = e.g.c,
                      g = 1;
                    for (o = 0; o < m; o += 1)
                      e.g._hasOpacity && e.g._collapsable && (g = e.g.o[2 * o + 1]),
                        n.addColorStop(
                          y[4 * o] / 100,
                          'rgba(' + y[4 * o + 1] + ',' + y[4 * o + 2] + ',' + y[4 * o + 3] + ',' + g + ')',
                        );
                    i.grd = n;
                  }
                  i.coOp = e.o.v * r.opacity;
                }),
                (CVShapeElement.prototype.renderStroke = function (t, e, r) {
                  var n = e.style,
                    i = e.d;
                  i && (i._mdf || this._isFirstFrame) && ((n.da = i.dashArray), (n.do = i.dashoffset[0])),
                    (e.c._mdf || this._isFirstFrame) &&
                      (n.co = 'rgb(' + bmFloor(e.c.v[0]) + ',' + bmFloor(e.c.v[1]) + ',' + bmFloor(e.c.v[2]) + ')'),
                    (e.o._mdf || r._opMdf || this._isFirstFrame) && (n.coOp = e.o.v * r.opacity),
                    (e.w._mdf || this._isFirstFrame) && (n.wi = e.w.v);
                }),
                (CVShapeElement.prototype.destroy = function () {
                  (this.shapesData = null),
                    (this.globalData = null),
                    (this.canvasContext = null),
                    (this.stylesList.length = 0),
                    (this.itemsData.length = 0);
                }),
                extendPrototype(
                  [
                    BaseElement,
                    TransformElement,
                    CVBaseElement,
                    HierarchyElement,
                    FrameElement,
                    RenderableElement,
                    ITextElement,
                  ],
                  CVTextElement,
                ),
                (CVTextElement.prototype.tHelper = createTag('canvas').getContext('2d')),
                (CVTextElement.prototype.buildNewText = function () {
                  var t = this.textProperty.currentData;
                  this.renderedLetters = createSizedArray(t.l ? t.l.length : 0);
                  var e = !1;
                  t.fc ? ((e = !0), (this.values.fill = this.buildColor(t.fc))) : (this.values.fill = 'rgba(0,0,0,0)'),
                    (this.fill = e);
                  var r = !1;
                  t.sc && ((r = !0), (this.values.stroke = this.buildColor(t.sc)), (this.values.sWidth = t.sw));
                  var n,
                    i,
                    o,
                    a,
                    s,
                    l,
                    c,
                    h,
                    u,
                    p,
                    f,
                    d,
                    m = this.globalData.fontManager.getFontByName(t.f),
                    y = t.l,
                    g = this.mHelper;
                  (this.stroke = r),
                    (this.values.fValue = t.finalSize + 'px ' + this.globalData.fontManager.getFontByName(t.f).fFamily),
                    (i = t.finalText.length);
                  var v = this.data.singleShape,
                    b = 0.001 * t.tr * t.finalSize,
                    x = 0,
                    E = 0,
                    w = !0,
                    _ = 0;
                  for (n = 0; n < i; n += 1) {
                    (a =
                      ((o = this.globalData.fontManager.getCharData(
                        t.finalText[n],
                        m.fStyle,
                        this.globalData.fontManager.getFontByName(t.f).fFamily,
                      )) &&
                        o.data) ||
                      {}),
                      g.reset(),
                      v && y[n].n && ((x = -b), (E += t.yOffset), (E += w ? 1 : 0), (w = !1)),
                      (u = (c = a.shapes ? a.shapes[0].it : []).length),
                      g.scale(t.finalSize / 100, t.finalSize / 100),
                      v && this.applyTextPropertiesToMatrix(t, g, y[n].line, x, E),
                      (f = createSizedArray(u - 1));
                    var S = 0;
                    for (h = 0; h < u; h += 1)
                      if ('sh' === c[h].ty) {
                        for (l = c[h].ks.k.i.length, p = c[h].ks.k, d = [], s = 1; s < l; s += 1)
                          1 === s && d.push(g.applyToX(p.v[0][0], p.v[0][1], 0), g.applyToY(p.v[0][0], p.v[0][1], 0)),
                            d.push(
                              g.applyToX(p.o[s - 1][0], p.o[s - 1][1], 0),
                              g.applyToY(p.o[s - 1][0], p.o[s - 1][1], 0),
                              g.applyToX(p.i[s][0], p.i[s][1], 0),
                              g.applyToY(p.i[s][0], p.i[s][1], 0),
                              g.applyToX(p.v[s][0], p.v[s][1], 0),
                              g.applyToY(p.v[s][0], p.v[s][1], 0),
                            );
                        d.push(
                          g.applyToX(p.o[s - 1][0], p.o[s - 1][1], 0),
                          g.applyToY(p.o[s - 1][0], p.o[s - 1][1], 0),
                          g.applyToX(p.i[0][0], p.i[0][1], 0),
                          g.applyToY(p.i[0][0], p.i[0][1], 0),
                          g.applyToX(p.v[0][0], p.v[0][1], 0),
                          g.applyToY(p.v[0][0], p.v[0][1], 0),
                        ),
                          (f[S] = d),
                          (S += 1);
                      }
                    v && ((x += y[n].l), (x += b)),
                      this.textSpans[_] ? (this.textSpans[_].elem = f) : (this.textSpans[_] = { elem: f }),
                      (_ += 1);
                  }
                }),
                (CVTextElement.prototype.renderInnerContent = function () {
                  var t,
                    e,
                    r,
                    n,
                    i,
                    o,
                    a = this.canvasContext;
                  (a.font = this.values.fValue),
                    (a.lineCap = 'butt'),
                    (a.lineJoin = 'miter'),
                    (a.miterLimit = 4),
                    this.data.singleShape ||
                      this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
                  var s,
                    l = this.textAnimator.renderedLetters,
                    c = this.textProperty.currentData.l;
                  e = c.length;
                  var h,
                    u,
                    p = null,
                    f = null,
                    d = null;
                  for (t = 0; t < e; t += 1)
                    if (!c[t].n) {
                      if (
                        ((s = l[t]) &&
                          (this.globalData.renderer.save(),
                          this.globalData.renderer.ctxTransform(s.p),
                          this.globalData.renderer.ctxOpacity(s.o)),
                        this.fill)
                      ) {
                        for (
                          s && s.fc
                            ? p !== s.fc && ((p = s.fc), (a.fillStyle = s.fc))
                            : p !== this.values.fill && ((p = this.values.fill), (a.fillStyle = this.values.fill)),
                            n = (h = this.textSpans[t].elem).length,
                            this.globalData.canvasContext.beginPath(),
                            r = 0;
                          r < n;
                          r += 1
                        )
                          for (
                            o = (u = h[r]).length, this.globalData.canvasContext.moveTo(u[0], u[1]), i = 2;
                            i < o;
                            i += 6
                          )
                            this.globalData.canvasContext.bezierCurveTo(
                              u[i],
                              u[i + 1],
                              u[i + 2],
                              u[i + 3],
                              u[i + 4],
                              u[i + 5],
                            );
                        this.globalData.canvasContext.closePath(), this.globalData.canvasContext.fill();
                      }
                      if (this.stroke) {
                        for (
                          s && s.sw
                            ? d !== s.sw && ((d = s.sw), (a.lineWidth = s.sw))
                            : d !== this.values.sWidth &&
                              ((d = this.values.sWidth), (a.lineWidth = this.values.sWidth)),
                            s && s.sc
                              ? f !== s.sc && ((f = s.sc), (a.strokeStyle = s.sc))
                              : f !== this.values.stroke &&
                                ((f = this.values.stroke), (a.strokeStyle = this.values.stroke)),
                            n = (h = this.textSpans[t].elem).length,
                            this.globalData.canvasContext.beginPath(),
                            r = 0;
                          r < n;
                          r += 1
                        )
                          for (
                            o = (u = h[r]).length, this.globalData.canvasContext.moveTo(u[0], u[1]), i = 2;
                            i < o;
                            i += 6
                          )
                            this.globalData.canvasContext.bezierCurveTo(
                              u[i],
                              u[i + 1],
                              u[i + 2],
                              u[i + 3],
                              u[i + 4],
                              u[i + 5],
                            );
                        this.globalData.canvasContext.closePath(), this.globalData.canvasContext.stroke();
                      }
                      s && this.globalData.renderer.restore();
                    }
                }),
                extendPrototype(
                  [BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement],
                  CVImageElement,
                ),
                (CVImageElement.prototype.initElement = SVGShapeElement.prototype.initElement),
                (CVImageElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame),
                (CVImageElement.prototype.createContent = function () {
                  if (this.img.width && (this.assetData.w !== this.img.width || this.assetData.h !== this.img.height)) {
                    var t = createTag('canvas');
                    (t.width = this.assetData.w), (t.height = this.assetData.h);
                    var e,
                      r,
                      n = t.getContext('2d'),
                      i = this.img.width,
                      o = this.img.height,
                      a = i / o,
                      s = this.assetData.w / this.assetData.h,
                      l = this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio;
                    (a > s && 'xMidYMid slice' === l) || (a < s && 'xMidYMid slice' !== l)
                      ? (e = (r = o) * s)
                      : (r = (e = i) / s),
                      n.drawImage(this.img, (i - e) / 2, (o - r) / 2, e, r, 0, 0, this.assetData.w, this.assetData.h),
                      (this.img = t);
                  }
                }),
                (CVImageElement.prototype.renderInnerContent = function () {
                  this.canvasContext.drawImage(this.img, 0, 0);
                }),
                (CVImageElement.prototype.destroy = function () {
                  this.img = null;
                }),
                extendPrototype(
                  [BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement],
                  CVSolidElement,
                ),
                (CVSolidElement.prototype.initElement = SVGShapeElement.prototype.initElement),
                (CVSolidElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame),
                (CVSolidElement.prototype.renderInnerContent = function () {
                  var t = this.canvasContext;
                  (t.fillStyle = this.data.sc), t.fillRect(0, 0, this.data.sw, this.data.sh);
                }),
                extendPrototype([BaseRenderer], CanvasRendererBase),
                (CanvasRendererBase.prototype.createShape = function (t) {
                  return new CVShapeElement(t, this.globalData, this);
                }),
                (CanvasRendererBase.prototype.createText = function (t) {
                  return new CVTextElement(t, this.globalData, this);
                }),
                (CanvasRendererBase.prototype.createImage = function (t) {
                  return new CVImageElement(t, this.globalData, this);
                }),
                (CanvasRendererBase.prototype.createSolid = function (t) {
                  return new CVSolidElement(t, this.globalData, this);
                }),
                (CanvasRendererBase.prototype.createNull = SVGRenderer.prototype.createNull),
                (CanvasRendererBase.prototype.ctxTransform = function (t) {
                  if (1 !== t[0] || 0 !== t[1] || 0 !== t[4] || 1 !== t[5] || 0 !== t[12] || 0 !== t[13])
                    if (this.renderConfig.clearCanvas) {
                      this.transformMat.cloneFromProps(t);
                      var e = this.contextData.cTr.props;
                      this.transformMat.transform(
                        e[0],
                        e[1],
                        e[2],
                        e[3],
                        e[4],
                        e[5],
                        e[6],
                        e[7],
                        e[8],
                        e[9],
                        e[10],
                        e[11],
                        e[12],
                        e[13],
                        e[14],
                        e[15],
                      ),
                        this.contextData.cTr.cloneFromProps(this.transformMat.props);
                      var r = this.contextData.cTr.props;
                      this.canvasContext.setTransform(r[0], r[1], r[4], r[5], r[12], r[13]);
                    } else this.canvasContext.transform(t[0], t[1], t[4], t[5], t[12], t[13]);
                }),
                (CanvasRendererBase.prototype.ctxOpacity = function (t) {
                  if (!this.renderConfig.clearCanvas)
                    return (
                      (this.canvasContext.globalAlpha *= t < 0 ? 0 : t),
                      void (this.globalData.currentGlobalAlpha = this.contextData.cO)
                    );
                  (this.contextData.cO *= t < 0 ? 0 : t),
                    this.globalData.currentGlobalAlpha !== this.contextData.cO &&
                      ((this.canvasContext.globalAlpha = this.contextData.cO),
                      (this.globalData.currentGlobalAlpha = this.contextData.cO));
                }),
                (CanvasRendererBase.prototype.reset = function () {
                  this.renderConfig.clearCanvas ? this.contextData.reset() : this.canvasContext.restore();
                }),
                (CanvasRendererBase.prototype.save = function (t) {
                  if (this.renderConfig.clearCanvas) {
                    t && this.canvasContext.save();
                    var e,
                      r = this.contextData.cTr.props;
                    this.contextData._length <= this.contextData.cArrPos && this.contextData.duplicate();
                    var n = this.contextData.saved[this.contextData.cArrPos];
                    for (e = 0; e < 16; e += 1) n[e] = r[e];
                    (this.contextData.savedOp[this.contextData.cArrPos] = this.contextData.cO),
                      (this.contextData.cArrPos += 1);
                  } else this.canvasContext.save();
                }),
                (CanvasRendererBase.prototype.restore = function (t) {
                  if (this.renderConfig.clearCanvas) {
                    t && (this.canvasContext.restore(), (this.globalData.blendMode = 'source-over')),
                      (this.contextData.cArrPos -= 1);
                    var e,
                      r = this.contextData.saved[this.contextData.cArrPos],
                      n = this.contextData.cTr.props;
                    for (e = 0; e < 16; e += 1) n[e] = r[e];
                    this.canvasContext.setTransform(r[0], r[1], r[4], r[5], r[12], r[13]),
                      (r = this.contextData.savedOp[this.contextData.cArrPos]),
                      (this.contextData.cO = r),
                      this.globalData.currentGlobalAlpha !== r &&
                        ((this.canvasContext.globalAlpha = r), (this.globalData.currentGlobalAlpha = r));
                  } else this.canvasContext.restore();
                }),
                (CanvasRendererBase.prototype.configAnimation = function (t) {
                  if (this.animationItem.wrapper) {
                    this.animationItem.container = createTag('canvas');
                    var e = this.animationItem.container.style;
                    (e.width = '100%'), (e.height = '100%');
                    var r = '0px 0px 0px';
                    (e.transformOrigin = r),
                      (e.mozTransformOrigin = r),
                      (e.webkitTransformOrigin = r),
                      (e['-webkit-transform'] = r),
                      (e.contentVisibility = this.renderConfig.contentVisibility),
                      this.animationItem.wrapper.appendChild(this.animationItem.container),
                      (this.canvasContext = this.animationItem.container.getContext('2d')),
                      this.renderConfig.className &&
                        this.animationItem.container.setAttribute('class', this.renderConfig.className),
                      this.renderConfig.id && this.animationItem.container.setAttribute('id', this.renderConfig.id);
                  } else this.canvasContext = this.renderConfig.context;
                  (this.data = t),
                    (this.layers = t.layers),
                    (this.transformCanvas = { w: t.w, h: t.h, sx: 0, sy: 0, tx: 0, ty: 0 }),
                    this.setupGlobalData(t, document.body),
                    (this.globalData.canvasContext = this.canvasContext),
                    (this.globalData.renderer = this),
                    (this.globalData.isDashed = !1),
                    (this.globalData.progressiveLoad = this.renderConfig.progressiveLoad),
                    (this.globalData.transformCanvas = this.transformCanvas),
                    (this.elements = createSizedArray(t.layers.length)),
                    this.updateContainerSize();
                }),
                (CanvasRendererBase.prototype.updateContainerSize = function (t, e) {
                  var r, n, i, o;
                  if (
                    (this.reset(),
                    t
                      ? ((r = t),
                        (n = e),
                        (this.canvasContext.canvas.width = r),
                        (this.canvasContext.canvas.height = n))
                      : (this.animationItem.wrapper && this.animationItem.container
                          ? ((r = this.animationItem.wrapper.offsetWidth),
                            (n = this.animationItem.wrapper.offsetHeight))
                          : ((r = this.canvasContext.canvas.width), (n = this.canvasContext.canvas.height)),
                        (this.canvasContext.canvas.width = r * this.renderConfig.dpr),
                        (this.canvasContext.canvas.height = n * this.renderConfig.dpr)),
                    -1 !== this.renderConfig.preserveAspectRatio.indexOf('meet') ||
                      -1 !== this.renderConfig.preserveAspectRatio.indexOf('slice'))
                  ) {
                    var a = this.renderConfig.preserveAspectRatio.split(' '),
                      s = a[1] || 'meet',
                      l = a[0] || 'xMidYMid',
                      c = l.substr(0, 4),
                      h = l.substr(4);
                    (i = r / n),
                      ((o = this.transformCanvas.w / this.transformCanvas.h) > i && 'meet' === s) ||
                      (o < i && 'slice' === s)
                        ? ((this.transformCanvas.sx = r / (this.transformCanvas.w / this.renderConfig.dpr)),
                          (this.transformCanvas.sy = r / (this.transformCanvas.w / this.renderConfig.dpr)))
                        : ((this.transformCanvas.sx = n / (this.transformCanvas.h / this.renderConfig.dpr)),
                          (this.transformCanvas.sy = n / (this.transformCanvas.h / this.renderConfig.dpr))),
                      (this.transformCanvas.tx =
                        'xMid' === c && ((o < i && 'meet' === s) || (o > i && 'slice' === s))
                          ? ((r - this.transformCanvas.w * (n / this.transformCanvas.h)) / 2) * this.renderConfig.dpr
                          : 'xMax' === c && ((o < i && 'meet' === s) || (o > i && 'slice' === s))
                          ? (r - this.transformCanvas.w * (n / this.transformCanvas.h)) * this.renderConfig.dpr
                          : 0),
                      (this.transformCanvas.ty =
                        'YMid' === h && ((o > i && 'meet' === s) || (o < i && 'slice' === s))
                          ? ((n - this.transformCanvas.h * (r / this.transformCanvas.w)) / 2) * this.renderConfig.dpr
                          : 'YMax' === h && ((o > i && 'meet' === s) || (o < i && 'slice' === s))
                          ? (n - this.transformCanvas.h * (r / this.transformCanvas.w)) * this.renderConfig.dpr
                          : 0);
                  } else
                    'none' === this.renderConfig.preserveAspectRatio
                      ? ((this.transformCanvas.sx = r / (this.transformCanvas.w / this.renderConfig.dpr)),
                        (this.transformCanvas.sy = n / (this.transformCanvas.h / this.renderConfig.dpr)),
                        (this.transformCanvas.tx = 0),
                        (this.transformCanvas.ty = 0))
                      : ((this.transformCanvas.sx = this.renderConfig.dpr),
                        (this.transformCanvas.sy = this.renderConfig.dpr),
                        (this.transformCanvas.tx = 0),
                        (this.transformCanvas.ty = 0));
                  (this.transformCanvas.props = [
                    this.transformCanvas.sx,
                    0,
                    0,
                    0,
                    0,
                    this.transformCanvas.sy,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    this.transformCanvas.tx,
                    this.transformCanvas.ty,
                    0,
                    1,
                  ]),
                    this.ctxTransform(this.transformCanvas.props),
                    this.canvasContext.beginPath(),
                    this.canvasContext.rect(0, 0, this.transformCanvas.w, this.transformCanvas.h),
                    this.canvasContext.closePath(),
                    this.canvasContext.clip(),
                    this.renderFrame(this.renderedFrame, !0);
                }),
                (CanvasRendererBase.prototype.destroy = function () {
                  var t;
                  for (
                    this.renderConfig.clearCanvas &&
                      this.animationItem.wrapper &&
                      (this.animationItem.wrapper.innerText = ''),
                      t = (this.layers ? this.layers.length : 0) - 1;
                    t >= 0;
                    t -= 1
                  )
                    this.elements[t] && this.elements[t].destroy();
                  (this.elements.length = 0),
                    (this.globalData.canvasContext = null),
                    (this.animationItem.container = null),
                    (this.destroyed = !0);
                }),
                (CanvasRendererBase.prototype.renderFrame = function (t, e) {
                  if (
                    (this.renderedFrame !== t || !0 !== this.renderConfig.clearCanvas || e) &&
                    !this.destroyed &&
                    -1 !== t
                  ) {
                    var r;
                    (this.renderedFrame = t),
                      (this.globalData.frameNum = t - this.animationItem._isFirstFrame),
                      (this.globalData.frameId += 1),
                      (this.globalData._mdf = !this.renderConfig.clearCanvas || e),
                      (this.globalData.projectInterface.currentFrame = t);
                    var n = this.layers.length;
                    for (this.completeLayers || this.checkLayers(t), r = 0; r < n; r += 1)
                      (this.completeLayers || this.elements[r]) && this.elements[r].prepareFrame(t - this.layers[r].st);
                    if (this.globalData._mdf) {
                      for (
                        !0 === this.renderConfig.clearCanvas
                          ? this.canvasContext.clearRect(0, 0, this.transformCanvas.w, this.transformCanvas.h)
                          : this.save(),
                          r = n - 1;
                        r >= 0;
                        r -= 1
                      )
                        (this.completeLayers || this.elements[r]) && this.elements[r].renderFrame();
                      !0 !== this.renderConfig.clearCanvas && this.restore();
                    }
                  }
                }),
                (CanvasRendererBase.prototype.buildItem = function (t) {
                  var e = this.elements;
                  if (!e[t] && 99 !== this.layers[t].ty) {
                    var r = this.createItem(this.layers[t], this, this.globalData);
                    (e[t] = r), r.initExpressions();
                  }
                }),
                (CanvasRendererBase.prototype.checkPendingElements = function () {
                  for (; this.pendingElements.length; ) this.pendingElements.pop().checkParenting();
                }),
                (CanvasRendererBase.prototype.hide = function () {
                  this.animationItem.container.style.display = 'none';
                }),
                (CanvasRendererBase.prototype.show = function () {
                  this.animationItem.container.style.display = 'block';
                }),
                extendPrototype([CanvasRendererBase, ICompElement, CVBaseElement], CVCompElement),
                (CVCompElement.prototype.renderInnerContent = function () {
                  var t,
                    e = this.canvasContext;
                  for (
                    e.beginPath(),
                      e.moveTo(0, 0),
                      e.lineTo(this.data.w, 0),
                      e.lineTo(this.data.w, this.data.h),
                      e.lineTo(0, this.data.h),
                      e.lineTo(0, 0),
                      e.clip(),
                      t = this.layers.length - 1;
                    t >= 0;
                    t -= 1
                  )
                    (this.completeLayers || this.elements[t]) && this.elements[t].renderFrame();
                }),
                (CVCompElement.prototype.destroy = function () {
                  var t;
                  for (t = this.layers.length - 1; t >= 0; t -= 1) this.elements[t] && this.elements[t].destroy();
                  (this.layers = null), (this.elements = null);
                }),
                (CVCompElement.prototype.createComp = function (t) {
                  return new CVCompElement(t, this.globalData, this);
                }),
                extendPrototype([CanvasRendererBase], CanvasRenderer),
                (CanvasRenderer.prototype.createComp = function (t) {
                  return new CVCompElement(t, this.globalData, this);
                }),
                (HBaseElement.prototype = {
                  checkBlendMode: function () {},
                  initRendererElement: function () {
                    (this.baseElement = createTag(this.data.tg || 'div')),
                      this.data.hasMask
                        ? ((this.svgElement = createNS('svg')),
                          (this.layerElement = createNS('g')),
                          (this.maskedElement = this.layerElement),
                          this.svgElement.appendChild(this.layerElement),
                          this.baseElement.appendChild(this.svgElement))
                        : (this.layerElement = this.baseElement),
                      styleDiv(this.baseElement);
                  },
                  createContainerElements: function () {
                    (this.renderableEffectsManager = new CVEffects(this)),
                      (this.transformedElement = this.baseElement),
                      (this.maskedElement = this.layerElement),
                      this.data.ln && this.layerElement.setAttribute('id', this.data.ln),
                      this.data.cl && this.layerElement.setAttribute('class', this.data.cl),
                      0 !== this.data.bm && this.setBlendMode();
                  },
                  renderElement: function () {
                    var t = this.transformedElement ? this.transformedElement.style : {};
                    if (this.finalTransform._matMdf) {
                      var e = this.finalTransform.mat.toCSS();
                      (t.transform = e), (t.webkitTransform = e);
                    }
                    this.finalTransform._opMdf && (t.opacity = this.finalTransform.mProp.o.v);
                  },
                  renderFrame: function () {
                    this.data.hd ||
                      this.hidden ||
                      (this.renderTransform(),
                      this.renderRenderable(),
                      this.renderElement(),
                      this.renderInnerContent(),
                      this._isFirstFrame && (this._isFirstFrame = !1));
                  },
                  destroy: function () {
                    (this.layerElement = null),
                      (this.transformedElement = null),
                      this.matteElement && (this.matteElement = null),
                      this.maskManager && (this.maskManager.destroy(), (this.maskManager = null));
                  },
                  createRenderableComponents: function () {
                    this.maskManager = new MaskElement(this.data, this, this.globalData);
                  },
                  addEffects: function () {},
                  setMatte: function () {},
                }),
                (HBaseElement.prototype.getBaseElement = SVGBaseElement.prototype.getBaseElement),
                (HBaseElement.prototype.destroyBaseElement = HBaseElement.prototype.destroy),
                (HBaseElement.prototype.buildElementParenting = BaseRenderer.prototype.buildElementParenting),
                extendPrototype(
                  [BaseElement, TransformElement, HBaseElement, HierarchyElement, FrameElement, RenderableDOMElement],
                  HSolidElement,
                ),
                (HSolidElement.prototype.createContent = function () {
                  var t;
                  this.data.hasMask
                    ? ((t = createNS('rect')).setAttribute('width', this.data.sw),
                      t.setAttribute('height', this.data.sh),
                      t.setAttribute('fill', this.data.sc),
                      this.svgElement.setAttribute('width', this.data.sw),
                      this.svgElement.setAttribute('height', this.data.sh))
                    : (((t = createTag('div')).style.width = this.data.sw + 'px'),
                      (t.style.height = this.data.sh + 'px'),
                      (t.style.backgroundColor = this.data.sc)),
                    this.layerElement.appendChild(t);
                }),
                extendPrototype(
                  [
                    BaseElement,
                    TransformElement,
                    HSolidElement,
                    SVGShapeElement,
                    HBaseElement,
                    HierarchyElement,
                    FrameElement,
                    RenderableElement,
                  ],
                  HShapeElement,
                ),
                (HShapeElement.prototype._renderShapeFrame = HShapeElement.prototype.renderInnerContent),
                (HShapeElement.prototype.createContent = function () {
                  var t;
                  if (((this.baseElement.style.fontSize = 0), this.data.hasMask))
                    this.layerElement.appendChild(this.shapesContainer), (t = this.svgElement);
                  else {
                    t = createNS('svg');
                    var e = this.comp.data ? this.comp.data : this.globalData.compSize;
                    t.setAttribute('width', e.w),
                      t.setAttribute('height', e.h),
                      t.appendChild(this.shapesContainer),
                      this.layerElement.appendChild(t);
                  }
                  this.searchShapes(
                    this.shapesData,
                    this.itemsData,
                    this.prevViewData,
                    this.shapesContainer,
                    0,
                    [],
                    !0,
                  ),
                    this.filterUniqueShapes(),
                    (this.shapeCont = t);
                }),
                (HShapeElement.prototype.getTransformedPoint = function (t, e) {
                  var r,
                    n = t.length;
                  for (r = 0; r < n; r += 1) e = t[r].mProps.v.applyToPointArray(e[0], e[1], 0);
                  return e;
                }),
                (HShapeElement.prototype.calculateShapeBoundingBox = function (t, e) {
                  var r,
                    n,
                    i,
                    o,
                    a,
                    s = t.sh.v,
                    l = t.transformers,
                    c = s._length;
                  if (!(c <= 1)) {
                    for (r = 0; r < c - 1; r += 1)
                      (n = this.getTransformedPoint(l, s.v[r])),
                        (i = this.getTransformedPoint(l, s.o[r])),
                        (o = this.getTransformedPoint(l, s.i[r + 1])),
                        (a = this.getTransformedPoint(l, s.v[r + 1])),
                        this.checkBounds(n, i, o, a, e);
                    s.c &&
                      ((n = this.getTransformedPoint(l, s.v[r])),
                      (i = this.getTransformedPoint(l, s.o[r])),
                      (o = this.getTransformedPoint(l, s.i[0])),
                      (a = this.getTransformedPoint(l, s.v[0])),
                      this.checkBounds(n, i, o, a, e));
                  }
                }),
                (HShapeElement.prototype.checkBounds = function (t, e, r, n, i) {
                  this.getBoundsOfCurve(t, e, r, n);
                  var o = this.shapeBoundingBox;
                  (i.x = bmMin(o.left, i.x)),
                    (i.xMax = bmMax(o.right, i.xMax)),
                    (i.y = bmMin(o.top, i.y)),
                    (i.yMax = bmMax(o.bottom, i.yMax));
                }),
                (HShapeElement.prototype.shapeBoundingBox = { left: 0, right: 0, top: 0, bottom: 0 }),
                (HShapeElement.prototype.tempBoundingBox = { x: 0, xMax: 0, y: 0, yMax: 0, width: 0, height: 0 }),
                (HShapeElement.prototype.getBoundsOfCurve = function (t, e, r, n) {
                  for (
                    var i,
                      o,
                      a,
                      s,
                      l,
                      c,
                      h,
                      u = [
                        [t[0], n[0]],
                        [t[1], n[1]],
                      ],
                      p = 0;
                    p < 2;
                    ++p
                  )
                    (o = 6 * t[p] - 12 * e[p] + 6 * r[p]),
                      (i = -3 * t[p] + 9 * e[p] - 9 * r[p] + 3 * n[p]),
                      (a = 3 * e[p] - 3 * t[p]),
                      (o |= 0),
                      (a |= 0),
                      (0 == (i |= 0) && 0 === o) ||
                        (0 === i
                          ? (s = -a / o) > 0 && s < 1 && u[p].push(this.calculateF(s, t, e, r, n, p))
                          : (l = o * o - 4 * a * i) >= 0 &&
                            ((c = (-o + bmSqrt(l)) / (2 * i)) > 0 &&
                              c < 1 &&
                              u[p].push(this.calculateF(c, t, e, r, n, p)),
                            (h = (-o - bmSqrt(l)) / (2 * i)) > 0 &&
                              h < 1 &&
                              u[p].push(this.calculateF(h, t, e, r, n, p))));
                  (this.shapeBoundingBox.left = bmMin.apply(null, u[0])),
                    (this.shapeBoundingBox.top = bmMin.apply(null, u[1])),
                    (this.shapeBoundingBox.right = bmMax.apply(null, u[0])),
                    (this.shapeBoundingBox.bottom = bmMax.apply(null, u[1]));
                }),
                (HShapeElement.prototype.calculateF = function (t, e, r, n, i, o) {
                  return (
                    bmPow(1 - t, 3) * e[o] +
                    3 * bmPow(1 - t, 2) * t * r[o] +
                    3 * (1 - t) * bmPow(t, 2) * n[o] +
                    bmPow(t, 3) * i[o]
                  );
                }),
                (HShapeElement.prototype.calculateBoundingBox = function (t, e) {
                  var r,
                    n = t.length;
                  for (r = 0; r < n; r += 1)
                    t[r] && t[r].sh
                      ? this.calculateShapeBoundingBox(t[r], e)
                      : t[r] && t[r].it
                      ? this.calculateBoundingBox(t[r].it, e)
                      : t[r] && t[r].style && t[r].w && this.expandStrokeBoundingBox(t[r].w, e);
                }),
                (HShapeElement.prototype.expandStrokeBoundingBox = function (t, e) {
                  var r = 0;
                  if (t.keyframes) {
                    for (var n = 0; n < t.keyframes.length; n += 1) {
                      var i = t.keyframes[n].s;
                      i > r && (r = i);
                    }
                    r *= t.mult;
                  } else r = t.v * t.mult;
                  (e.x -= r), (e.xMax += r), (e.y -= r), (e.yMax += r);
                }),
                (HShapeElement.prototype.currentBoxContains = function (t) {
                  return (
                    this.currentBBox.x <= t.x &&
                    this.currentBBox.y <= t.y &&
                    this.currentBBox.width + this.currentBBox.x >= t.x + t.width &&
                    this.currentBBox.height + this.currentBBox.y >= t.y + t.height
                  );
                }),
                (HShapeElement.prototype.renderInnerContent = function () {
                  if ((this._renderShapeFrame(), !this.hidden && (this._isFirstFrame || this._mdf))) {
                    var t = this.tempBoundingBox,
                      e = 999999;
                    if (
                      ((t.x = e),
                      (t.xMax = -e),
                      (t.y = e),
                      (t.yMax = -e),
                      this.calculateBoundingBox(this.itemsData, t),
                      (t.width = t.xMax < t.x ? 0 : t.xMax - t.x),
                      (t.height = t.yMax < t.y ? 0 : t.yMax - t.y),
                      this.currentBoxContains(t))
                    )
                      return;
                    var r = !1;
                    if (
                      (this.currentBBox.w !== t.width &&
                        ((this.currentBBox.w = t.width), this.shapeCont.setAttribute('width', t.width), (r = !0)),
                      this.currentBBox.h !== t.height &&
                        ((this.currentBBox.h = t.height), this.shapeCont.setAttribute('height', t.height), (r = !0)),
                      r || this.currentBBox.x !== t.x || this.currentBBox.y !== t.y)
                    ) {
                      (this.currentBBox.w = t.width),
                        (this.currentBBox.h = t.height),
                        (this.currentBBox.x = t.x),
                        (this.currentBBox.y = t.y),
                        this.shapeCont.setAttribute(
                          'viewBox',
                          this.currentBBox.x +
                            ' ' +
                            this.currentBBox.y +
                            ' ' +
                            this.currentBBox.w +
                            ' ' +
                            this.currentBBox.h,
                        );
                      var n = this.shapeCont.style,
                        i = 'translate(' + this.currentBBox.x + 'px,' + this.currentBBox.y + 'px)';
                      (n.transform = i), (n.webkitTransform = i);
                    }
                  }
                }),
                extendPrototype(
                  [
                    BaseElement,
                    TransformElement,
                    HBaseElement,
                    HierarchyElement,
                    FrameElement,
                    RenderableDOMElement,
                    ITextElement,
                  ],
                  HTextElement,
                ),
                (HTextElement.prototype.createContent = function () {
                  if (((this.isMasked = this.checkMasks()), this.isMasked)) {
                    (this.renderType = 'svg'),
                      (this.compW = this.comp.data.w),
                      (this.compH = this.comp.data.h),
                      this.svgElement.setAttribute('width', this.compW),
                      this.svgElement.setAttribute('height', this.compH);
                    var t = createNS('g');
                    this.maskedElement.appendChild(t), (this.innerElem = t);
                  } else (this.renderType = 'html'), (this.innerElem = this.layerElement);
                  this.checkParenting();
                }),
                (HTextElement.prototype.buildNewText = function () {
                  var t = this.textProperty.currentData;
                  this.renderedLetters = createSizedArray(t.l ? t.l.length : 0);
                  var e = this.innerElem.style,
                    r = t.fc ? this.buildColor(t.fc) : 'rgba(0,0,0,0)';
                  (e.fill = r),
                    (e.color = r),
                    t.sc && ((e.stroke = this.buildColor(t.sc)), (e.strokeWidth = t.sw + 'px'));
                  var n,
                    i,
                    o = this.globalData.fontManager.getFontByName(t.f);
                  if (!this.globalData.fontManager.chars)
                    if (((e.fontSize = t.finalSize + 'px'), (e.lineHeight = t.finalSize + 'px'), o.fClass))
                      this.innerElem.className = o.fClass;
                    else {
                      e.fontFamily = o.fFamily;
                      var a = t.fWeight,
                        s = t.fStyle;
                      (e.fontStyle = s), (e.fontWeight = a);
                    }
                  var l,
                    c,
                    h,
                    u = t.l;
                  i = u.length;
                  var p,
                    f = this.mHelper,
                    d = '',
                    m = 0;
                  for (n = 0; n < i; n += 1) {
                    if (
                      (this.globalData.fontManager.chars
                        ? (this.textPaths[m]
                            ? (l = this.textPaths[m])
                            : ((l = createNS('path')).setAttribute('stroke-linecap', lineCapEnum[1]),
                              l.setAttribute('stroke-linejoin', lineJoinEnum[2]),
                              l.setAttribute('stroke-miterlimit', '4')),
                          this.isMasked ||
                            (this.textSpans[m]
                              ? (h = (c = this.textSpans[m]).children[0])
                              : (((c = createTag('div')).style.lineHeight = 0),
                                (h = createNS('svg')).appendChild(l),
                                styleDiv(c))))
                        : this.isMasked
                        ? (l = this.textPaths[m] ? this.textPaths[m] : createNS('text'))
                        : this.textSpans[m]
                        ? ((c = this.textSpans[m]), (l = this.textPaths[m]))
                        : (styleDiv((c = createTag('span'))), styleDiv((l = createTag('span'))), c.appendChild(l)),
                      this.globalData.fontManager.chars)
                    ) {
                      var y,
                        g = this.globalData.fontManager.getCharData(
                          t.finalText[n],
                          o.fStyle,
                          this.globalData.fontManager.getFontByName(t.f).fFamily,
                        );
                      if (
                        ((y = g ? g.data : null),
                        f.reset(),
                        y &&
                          y.shapes &&
                          y.shapes.length &&
                          ((p = y.shapes[0].it),
                          f.scale(t.finalSize / 100, t.finalSize / 100),
                          (d = this.createPathShape(f, p)),
                          l.setAttribute('d', d)),
                        this.isMasked)
                      )
                        this.innerElem.appendChild(l);
                      else {
                        if ((this.innerElem.appendChild(c), y && y.shapes)) {
                          document.body.appendChild(h);
                          var v = h.getBBox();
                          h.setAttribute('width', v.width + 2),
                            h.setAttribute('height', v.height + 2),
                            h.setAttribute(
                              'viewBox',
                              v.x - 1 + ' ' + (v.y - 1) + ' ' + (v.width + 2) + ' ' + (v.height + 2),
                            );
                          var b = h.style,
                            x = 'translate(' + (v.x - 1) + 'px,' + (v.y - 1) + 'px)';
                          (b.transform = x), (b.webkitTransform = x), (u[n].yOffset = v.y - 1);
                        } else h.setAttribute('width', 1), h.setAttribute('height', 1);
                        c.appendChild(h);
                      }
                    } else if (
                      ((l.textContent = u[n].val),
                      l.setAttributeNS('http://www.w3.org/XML/1998/namespace', 'xml:space', 'preserve'),
                      this.isMasked)
                    )
                      this.innerElem.appendChild(l);
                    else {
                      this.innerElem.appendChild(c);
                      var E = l.style,
                        w = 'translate3d(0,' + -t.finalSize / 1.2 + 'px,0)';
                      (E.transform = w), (E.webkitTransform = w);
                    }
                    this.isMasked ? (this.textSpans[m] = l) : (this.textSpans[m] = c),
                      (this.textSpans[m].style.display = 'block'),
                      (this.textPaths[m] = l),
                      (m += 1);
                  }
                  for (; m < this.textSpans.length; ) (this.textSpans[m].style.display = 'none'), (m += 1);
                }),
                (HTextElement.prototype.renderInnerContent = function () {
                  var t;
                  if (this.data.singleShape) {
                    if (!this._isFirstFrame && !this.lettersChangedFlag) return;
                    if (this.isMasked && this.finalTransform._matMdf) {
                      this.svgElement.setAttribute(
                        'viewBox',
                        -this.finalTransform.mProp.p.v[0] +
                          ' ' +
                          -this.finalTransform.mProp.p.v[1] +
                          ' ' +
                          this.compW +
                          ' ' +
                          this.compH,
                      ),
                        (t = this.svgElement.style);
                      var e =
                        'translate(' +
                        -this.finalTransform.mProp.p.v[0] +
                        'px,' +
                        -this.finalTransform.mProp.p.v[1] +
                        'px)';
                      (t.transform = e), (t.webkitTransform = e);
                    }
                  }
                  if (
                    (this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag),
                    this.lettersChangedFlag || this.textAnimator.lettersChangedFlag)
                  ) {
                    var r,
                      n,
                      i,
                      o,
                      a,
                      s = 0,
                      l = this.textAnimator.renderedLetters,
                      c = this.textProperty.currentData.l;
                    for (n = c.length, r = 0; r < n; r += 1)
                      c[r].n
                        ? (s += 1)
                        : ((o = this.textSpans[r]),
                          (a = this.textPaths[r]),
                          (i = l[s]),
                          (s += 1),
                          i._mdf.m &&
                            (this.isMasked
                              ? o.setAttribute('transform', i.m)
                              : ((o.style.webkitTransform = i.m), (o.style.transform = i.m))),
                          (o.style.opacity = i.o),
                          i.sw && i._mdf.sw && a.setAttribute('stroke-width', i.sw),
                          i.sc && i._mdf.sc && a.setAttribute('stroke', i.sc),
                          i.fc && i._mdf.fc && (a.setAttribute('fill', i.fc), (a.style.color = i.fc)));
                    if (this.innerElem.getBBox && !this.hidden && (this._isFirstFrame || this._mdf)) {
                      var h = this.innerElem.getBBox();
                      if (
                        (this.currentBBox.w !== h.width &&
                          ((this.currentBBox.w = h.width), this.svgElement.setAttribute('width', h.width)),
                        this.currentBBox.h !== h.height &&
                          ((this.currentBBox.h = h.height), this.svgElement.setAttribute('height', h.height)),
                        this.currentBBox.w !== h.width + 2 ||
                          this.currentBBox.h !== h.height + 2 ||
                          this.currentBBox.x !== h.x - 1 ||
                          this.currentBBox.y !== h.y - 1)
                      ) {
                        (this.currentBBox.w = h.width + 2),
                          (this.currentBBox.h = h.height + 2),
                          (this.currentBBox.x = h.x - 1),
                          (this.currentBBox.y = h.y - 1),
                          this.svgElement.setAttribute(
                            'viewBox',
                            this.currentBBox.x +
                              ' ' +
                              this.currentBBox.y +
                              ' ' +
                              this.currentBBox.w +
                              ' ' +
                              this.currentBBox.h,
                          ),
                          (t = this.svgElement.style);
                        var u = 'translate(' + this.currentBBox.x + 'px,' + this.currentBBox.y + 'px)';
                        (t.transform = u), (t.webkitTransform = u);
                      }
                    }
                  }
                }),
                extendPrototype([BaseElement, FrameElement, HierarchyElement], HCameraElement),
                (HCameraElement.prototype.setup = function () {
                  var t,
                    e,
                    r,
                    n,
                    i = this.comp.threeDElements.length;
                  for (t = 0; t < i; t += 1)
                    if ('3d' === (e = this.comp.threeDElements[t]).type) {
                      (r = e.perspectiveElem.style), (n = e.container.style);
                      var o = this.pe.v + 'px',
                        a = '0px 0px 0px',
                        s = 'matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)';
                      (r.perspective = o),
                        (r.webkitPerspective = o),
                        (n.transformOrigin = a),
                        (n.mozTransformOrigin = a),
                        (n.webkitTransformOrigin = a),
                        (r.transform = s),
                        (r.webkitTransform = s);
                    }
                }),
                (HCameraElement.prototype.createElements = function () {}),
                (HCameraElement.prototype.hide = function () {}),
                (HCameraElement.prototype.renderFrame = function () {
                  var t,
                    e,
                    r = this._isFirstFrame;
                  if (this.hierarchy)
                    for (e = this.hierarchy.length, t = 0; t < e; t += 1)
                      r = this.hierarchy[t].finalTransform.mProp._mdf || r;
                  if (
                    r ||
                    this.pe._mdf ||
                    (this.p && this.p._mdf) ||
                    (this.px && (this.px._mdf || this.py._mdf || this.pz._mdf)) ||
                    this.rx._mdf ||
                    this.ry._mdf ||
                    this.rz._mdf ||
                    this.or._mdf ||
                    (this.a && this.a._mdf)
                  ) {
                    if ((this.mat.reset(), this.hierarchy))
                      for (t = e = this.hierarchy.length - 1; t >= 0; t -= 1) {
                        var n = this.hierarchy[t].finalTransform.mProp;
                        this.mat.translate(-n.p.v[0], -n.p.v[1], n.p.v[2]),
                          this.mat.rotateX(-n.or.v[0]).rotateY(-n.or.v[1]).rotateZ(n.or.v[2]),
                          this.mat.rotateX(-n.rx.v).rotateY(-n.ry.v).rotateZ(n.rz.v),
                          this.mat.scale(1 / n.s.v[0], 1 / n.s.v[1], 1 / n.s.v[2]),
                          this.mat.translate(n.a.v[0], n.a.v[1], n.a.v[2]);
                      }
                    if (
                      (this.p
                        ? this.mat.translate(-this.p.v[0], -this.p.v[1], this.p.v[2])
                        : this.mat.translate(-this.px.v, -this.py.v, this.pz.v),
                      this.a)
                    ) {
                      var i;
                      i = this.p
                        ? [this.p.v[0] - this.a.v[0], this.p.v[1] - this.a.v[1], this.p.v[2] - this.a.v[2]]
                        : [this.px.v - this.a.v[0], this.py.v - this.a.v[1], this.pz.v - this.a.v[2]];
                      var o = Math.sqrt(Math.pow(i[0], 2) + Math.pow(i[1], 2) + Math.pow(i[2], 2)),
                        a = [i[0] / o, i[1] / o, i[2] / o],
                        s = Math.sqrt(a[2] * a[2] + a[0] * a[0]),
                        l = Math.atan2(a[1], s),
                        c = Math.atan2(a[0], -a[2]);
                      this.mat.rotateY(c).rotateX(-l);
                    }
                    this.mat.rotateX(-this.rx.v).rotateY(-this.ry.v).rotateZ(this.rz.v),
                      this.mat.rotateX(-this.or.v[0]).rotateY(-this.or.v[1]).rotateZ(this.or.v[2]),
                      this.mat.translate(this.globalData.compSize.w / 2, this.globalData.compSize.h / 2, 0),
                      this.mat.translate(0, 0, this.pe.v);
                    var h = !this._prevMat.equals(this.mat);
                    if ((h || this.pe._mdf) && this.comp.threeDElements) {
                      var u, p, f;
                      for (e = this.comp.threeDElements.length, t = 0; t < e; t += 1)
                        if ('3d' === (u = this.comp.threeDElements[t]).type) {
                          if (h) {
                            var d = this.mat.toCSS();
                            ((f = u.container.style).transform = d), (f.webkitTransform = d);
                          }
                          this.pe._mdf &&
                            (((p = u.perspectiveElem.style).perspective = this.pe.v + 'px'),
                            (p.webkitPerspective = this.pe.v + 'px'));
                        }
                      this.mat.clone(this._prevMat);
                    }
                  }
                  this._isFirstFrame = !1;
                }),
                (HCameraElement.prototype.prepareFrame = function (t) {
                  this.prepareProperties(t, !0);
                }),
                (HCameraElement.prototype.destroy = function () {}),
                (HCameraElement.prototype.getBaseElement = function () {
                  return null;
                }),
                extendPrototype(
                  [
                    BaseElement,
                    TransformElement,
                    HBaseElement,
                    HSolidElement,
                    HierarchyElement,
                    FrameElement,
                    RenderableElement,
                  ],
                  HImageElement,
                ),
                (HImageElement.prototype.createContent = function () {
                  var t = this.globalData.getAssetsPath(this.assetData),
                    e = new Image();
                  this.data.hasMask
                    ? ((this.imageElem = createNS('image')),
                      this.imageElem.setAttribute('width', this.assetData.w + 'px'),
                      this.imageElem.setAttribute('height', this.assetData.h + 'px'),
                      this.imageElem.setAttributeNS('http://www.w3.org/1999/xlink', 'href', t),
                      this.layerElement.appendChild(this.imageElem),
                      this.baseElement.setAttribute('width', this.assetData.w),
                      this.baseElement.setAttribute('height', this.assetData.h))
                    : this.layerElement.appendChild(e),
                    (e.crossOrigin = 'anonymous'),
                    (e.src = t),
                    this.data.ln && this.baseElement.setAttribute('id', this.data.ln);
                }),
                extendPrototype([BaseRenderer], HybridRendererBase),
                (HybridRendererBase.prototype.buildItem = SVGRenderer.prototype.buildItem),
                (HybridRendererBase.prototype.checkPendingElements = function () {
                  for (; this.pendingElements.length; ) this.pendingElements.pop().checkParenting();
                }),
                (HybridRendererBase.prototype.appendElementInPos = function (t, e) {
                  var r = t.getBaseElement();
                  if (r) {
                    var n = this.layers[e];
                    if (n.ddd && this.supports3d) this.addTo3dContainer(r, e);
                    else if (this.threeDElements) this.addTo3dContainer(r, e);
                    else {
                      for (var i, o, a = 0; a < e; )
                        this.elements[a] &&
                          !0 !== this.elements[a] &&
                          this.elements[a].getBaseElement &&
                          ((o = this.elements[a]),
                          (i = (this.layers[a].ddd ? this.getThreeDContainerByPos(a) : o.getBaseElement()) || i)),
                          (a += 1);
                      i
                        ? (n.ddd && this.supports3d) || this.layerElement.insertBefore(r, i)
                        : (n.ddd && this.supports3d) || this.layerElement.appendChild(r);
                    }
                  }
                }),
                (HybridRendererBase.prototype.createShape = function (t) {
                  return this.supports3d
                    ? new HShapeElement(t, this.globalData, this)
                    : new SVGShapeElement(t, this.globalData, this);
                }),
                (HybridRendererBase.prototype.createText = function (t) {
                  return this.supports3d
                    ? new HTextElement(t, this.globalData, this)
                    : new SVGTextLottieElement(t, this.globalData, this);
                }),
                (HybridRendererBase.prototype.createCamera = function (t) {
                  return (this.camera = new HCameraElement(t, this.globalData, this)), this.camera;
                }),
                (HybridRendererBase.prototype.createImage = function (t) {
                  return this.supports3d
                    ? new HImageElement(t, this.globalData, this)
                    : new IImageElement(t, this.globalData, this);
                }),
                (HybridRendererBase.prototype.createSolid = function (t) {
                  return this.supports3d
                    ? new HSolidElement(t, this.globalData, this)
                    : new ISolidElement(t, this.globalData, this);
                }),
                (HybridRendererBase.prototype.createNull = SVGRenderer.prototype.createNull),
                (HybridRendererBase.prototype.getThreeDContainerByPos = function (t) {
                  for (var e = 0, r = this.threeDElements.length; e < r; ) {
                    if (this.threeDElements[e].startPos <= t && this.threeDElements[e].endPos >= t)
                      return this.threeDElements[e].perspectiveElem;
                    e += 1;
                  }
                  return null;
                }),
                (HybridRendererBase.prototype.createThreeDContainer = function (t, e) {
                  var r,
                    n,
                    i = createTag('div');
                  styleDiv(i);
                  var o = createTag('div');
                  if ((styleDiv(o), '3d' === e)) {
                    ((r = i.style).width = this.globalData.compSize.w + 'px'),
                      (r.height = this.globalData.compSize.h + 'px');
                    var a = '50% 50%';
                    (r.webkitTransformOrigin = a), (r.mozTransformOrigin = a), (r.transformOrigin = a);
                    var s = 'matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)';
                    ((n = o.style).transform = s), (n.webkitTransform = s);
                  }
                  i.appendChild(o);
                  var l = { container: o, perspectiveElem: i, startPos: t, endPos: t, type: e };
                  return this.threeDElements.push(l), l;
                }),
                (HybridRendererBase.prototype.build3dContainers = function () {
                  var t,
                    e,
                    r = this.layers.length,
                    n = '';
                  for (t = 0; t < r; t += 1)
                    this.layers[t].ddd && 3 !== this.layers[t].ty
                      ? ('3d' !== n && ((n = '3d'), (e = this.createThreeDContainer(t, '3d'))),
                        (e.endPos = Math.max(e.endPos, t)))
                      : ('2d' !== n && ((n = '2d'), (e = this.createThreeDContainer(t, '2d'))),
                        (e.endPos = Math.max(e.endPos, t)));
                  for (t = (r = this.threeDElements.length) - 1; t >= 0; t -= 1)
                    this.resizerElem.appendChild(this.threeDElements[t].perspectiveElem);
                }),
                (HybridRendererBase.prototype.addTo3dContainer = function (t, e) {
                  for (var r = 0, n = this.threeDElements.length; r < n; ) {
                    if (e <= this.threeDElements[r].endPos) {
                      for (var i, o = this.threeDElements[r].startPos; o < e; )
                        this.elements[o] && this.elements[o].getBaseElement && (i = this.elements[o].getBaseElement()),
                          (o += 1);
                      i
                        ? this.threeDElements[r].container.insertBefore(t, i)
                        : this.threeDElements[r].container.appendChild(t);
                      break;
                    }
                    r += 1;
                  }
                }),
                (HybridRendererBase.prototype.configAnimation = function (t) {
                  var e = createTag('div'),
                    r = this.animationItem.wrapper,
                    n = e.style;
                  (n.width = t.w + 'px'),
                    (n.height = t.h + 'px'),
                    (this.resizerElem = e),
                    styleDiv(e),
                    (n.transformStyle = 'flat'),
                    (n.mozTransformStyle = 'flat'),
                    (n.webkitTransformStyle = 'flat'),
                    this.renderConfig.className && e.setAttribute('class', this.renderConfig.className),
                    r.appendChild(e),
                    (n.overflow = 'hidden');
                  var i = createNS('svg');
                  i.setAttribute('width', '1'),
                    i.setAttribute('height', '1'),
                    styleDiv(i),
                    this.resizerElem.appendChild(i);
                  var o = createNS('defs');
                  i.appendChild(o),
                    (this.data = t),
                    this.setupGlobalData(t, i),
                    (this.globalData.defs = o),
                    (this.layers = t.layers),
                    (this.layerElement = this.resizerElem),
                    this.build3dContainers(),
                    this.updateContainerSize();
                }),
                (HybridRendererBase.prototype.destroy = function () {
                  var t;
                  this.animationItem.wrapper && (this.animationItem.wrapper.innerText = ''),
                    (this.animationItem.container = null),
                    (this.globalData.defs = null);
                  var e = this.layers ? this.layers.length : 0;
                  for (t = 0; t < e; t += 1) this.elements[t].destroy();
                  (this.elements.length = 0), (this.destroyed = !0), (this.animationItem = null);
                }),
                (HybridRendererBase.prototype.updateContainerSize = function () {
                  var t,
                    e,
                    r,
                    n,
                    i = this.animationItem.wrapper.offsetWidth,
                    o = this.animationItem.wrapper.offsetHeight,
                    a = i / o;
                  this.globalData.compSize.w / this.globalData.compSize.h > a
                    ? ((t = i / this.globalData.compSize.w),
                      (e = i / this.globalData.compSize.w),
                      (r = 0),
                      (n = (o - this.globalData.compSize.h * (i / this.globalData.compSize.w)) / 2))
                    : ((t = o / this.globalData.compSize.h),
                      (e = o / this.globalData.compSize.h),
                      (r = (i - this.globalData.compSize.w * (o / this.globalData.compSize.h)) / 2),
                      (n = 0));
                  var s = this.resizerElem.style;
                  (s.webkitTransform = 'matrix3d(' + t + ',0,0,0,0,' + e + ',0,0,0,0,1,0,' + r + ',' + n + ',0,1)'),
                    (s.transform = s.webkitTransform);
                }),
                (HybridRendererBase.prototype.renderFrame = SVGRenderer.prototype.renderFrame),
                (HybridRendererBase.prototype.hide = function () {
                  this.resizerElem.style.display = 'none';
                }),
                (HybridRendererBase.prototype.show = function () {
                  this.resizerElem.style.display = 'block';
                }),
                (HybridRendererBase.prototype.initItems = function () {
                  if ((this.buildAllItems(), this.camera)) this.camera.setup();
                  else {
                    var t,
                      e = this.globalData.compSize.w,
                      r = this.globalData.compSize.h,
                      n = this.threeDElements.length;
                    for (t = 0; t < n; t += 1) {
                      var i = this.threeDElements[t].perspectiveElem.style;
                      (i.webkitPerspective = Math.sqrt(Math.pow(e, 2) + Math.pow(r, 2)) + 'px'),
                        (i.perspective = i.webkitPerspective);
                    }
                  }
                }),
                (HybridRendererBase.prototype.searchExtraCompositions = function (t) {
                  var e,
                    r = t.length,
                    n = createTag('div');
                  for (e = 0; e < r; e += 1)
                    if (t[e].xt) {
                      var i = this.createComp(t[e], n, this.globalData.comp, null);
                      i.initExpressions(), this.globalData.projectInterface.registerComposition(i);
                    }
                }),
                extendPrototype([HybridRendererBase, ICompElement, HBaseElement], HCompElement),
                (HCompElement.prototype._createBaseContainerElements = HCompElement.prototype.createContainerElements),
                (HCompElement.prototype.createContainerElements = function () {
                  this._createBaseContainerElements(),
                    this.data.hasMask
                      ? (this.svgElement.setAttribute('width', this.data.w),
                        this.svgElement.setAttribute('height', this.data.h),
                        (this.transformedElement = this.baseElement))
                      : (this.transformedElement = this.layerElement);
                }),
                (HCompElement.prototype.addTo3dContainer = function (t, e) {
                  for (var r, n = 0; n < e; )
                    this.elements[n] && this.elements[n].getBaseElement && (r = this.elements[n].getBaseElement()),
                      (n += 1);
                  r ? this.layerElement.insertBefore(t, r) : this.layerElement.appendChild(t);
                }),
                (HCompElement.prototype.createComp = function (t) {
                  return this.supports3d
                    ? new HCompElement(t, this.globalData, this)
                    : new SVGCompElement(t, this.globalData, this);
                }),
                extendPrototype([HybridRendererBase], HybridRenderer),
                (HybridRenderer.prototype.createComp = function (t) {
                  return this.supports3d
                    ? new HCompElement(t, this.globalData, this)
                    : new SVGCompElement(t, this.globalData, this);
                });
              var CompExpressionInterface = function (t) {
                  function e(e) {
                    for (var r = 0, n = t.layers.length; r < n; ) {
                      if (t.layers[r].nm === e || t.layers[r].ind === e) return t.elements[r].layerInterface;
                      r += 1;
                    }
                    return null;
                  }
                  return (
                    Object.defineProperty(e, '_name', { value: t.data.nm }),
                    (e.layer = e),
                    (e.pixelAspect = 1),
                    (e.height = t.data.h || t.globalData.compSize.h),
                    (e.width = t.data.w || t.globalData.compSize.w),
                    (e.pixelAspect = 1),
                    (e.frameDuration = 1 / t.globalData.frameRate),
                    (e.displayStartTime = 0),
                    (e.numLayers = t.layers.length),
                    e
                  );
                },
                Expressions = (function () {
                  var t = {
                    initExpressions: function (t) {
                      var e = 0,
                        r = [];
                      (t.renderer.compInterface = CompExpressionInterface(t.renderer)),
                        t.renderer.globalData.projectInterface.registerComposition(t.renderer),
                        (t.renderer.globalData.pushExpression = function () {
                          e += 1;
                        }),
                        (t.renderer.globalData.popExpression = function () {
                          0 == (e -= 1) &&
                            (function () {
                              var t,
                                e = r.length;
                              for (t = 0; t < e; t += 1) r[t].release();
                              r.length = 0;
                            })();
                        }),
                        (t.renderer.globalData.registerExpressionProperty = function (t) {
                          -1 === r.indexOf(t) && r.push(t);
                        });
                    },
                  };
                  return t;
                })(),
                MaskManagerInterface = (function () {
                  function t(t, e) {
                    (this._mask = t), (this._data = e);
                  }
                  return (
                    Object.defineProperty(t.prototype, 'maskPath', {
                      get: function () {
                        return this._mask.prop.k && this._mask.prop.getValue(), this._mask.prop;
                      },
                    }),
                    Object.defineProperty(t.prototype, 'maskOpacity', {
                      get: function () {
                        return this._mask.op.k && this._mask.op.getValue(), 100 * this._mask.op.v;
                      },
                    }),
                    function (e) {
                      var r,
                        n = createSizedArray(e.viewData.length),
                        i = e.viewData.length;
                      for (r = 0; r < i; r += 1) n[r] = new t(e.viewData[r], e.masksProperties[r]);
                      return function (t) {
                        for (r = 0; r < i; ) {
                          if (e.masksProperties[r].nm === t) return n[r];
                          r += 1;
                        }
                        return null;
                      };
                    }
                  );
                })(),
                ExpressionPropertyInterface = (function () {
                  var t = { pv: 0, v: 0, mult: 1 },
                    e = { pv: [0, 0, 0], v: [0, 0, 0], mult: 1 };
                  function r(t, e, r) {
                    Object.defineProperty(t, 'velocity', {
                      get: function () {
                        return e.getVelocityAtTime(e.comp.currentFrame);
                      },
                    }),
                      (t.numKeys = e.keyframes ? e.keyframes.length : 0),
                      (t.key = function (n) {
                        if (!t.numKeys) return 0;
                        var i;
                        i =
                          's' in e.keyframes[n - 1]
                            ? e.keyframes[n - 1].s
                            : 'e' in e.keyframes[n - 2]
                            ? e.keyframes[n - 2].e
                            : e.keyframes[n - 2].s;
                        var o = 'unidimensional' === r ? new Number(i) : Object.assign({}, i);
                        return (
                          (o.time = e.keyframes[n - 1].t / e.elem.comp.globalData.frameRate),
                          (o.value = 'unidimensional' === r ? i[0] : i),
                          o
                        );
                      }),
                      (t.valueAtTime = e.getValueAtTime),
                      (t.speedAtTime = e.getSpeedAtTime),
                      (t.velocityAtTime = e.getVelocityAtTime),
                      (t.propertyGroup = e.propertyGroup);
                  }
                  function n() {
                    return t;
                  }
                  return function (i) {
                    return i
                      ? 'unidimensional' === i.propType
                        ? (function (e) {
                            (e && 'pv' in e) || (e = t);
                            var n = 1 / e.mult,
                              i = e.pv * n,
                              o = new Number(i);
                            return (
                              (o.value = i),
                              r(o, e, 'unidimensional'),
                              function () {
                                return (
                                  e.k && e.getValue(),
                                  (i = e.v * n),
                                  o.value !== i && (((o = new Number(i)).value = i), r(o, e, 'unidimensional')),
                                  o
                                );
                              }
                            );
                          })(i)
                        : (function (t) {
                            (t && 'pv' in t) || (t = e);
                            var n = 1 / t.mult,
                              i = (t.data && t.data.l) || t.pv.length,
                              o = createTypedArray('float32', i),
                              a = createTypedArray('float32', i);
                            return (
                              (o.value = a),
                              r(o, t, 'multidimensional'),
                              function () {
                                t.k && t.getValue();
                                for (var e = 0; e < i; e += 1) (a[e] = t.v[e] * n), (o[e] = a[e]);
                                return o;
                              }
                            );
                          })(i)
                      : n;
                  };
                })(),
                TransformExpressionInterface = function (t) {
                  function e(t) {
                    switch (t) {
                      case 'scale':
                      case 'Scale':
                      case 'ADBE Scale':
                      case 6:
                        return e.scale;
                      case 'rotation':
                      case 'Rotation':
                      case 'ADBE Rotation':
                      case 'ADBE Rotate Z':
                      case 10:
                        return e.rotation;
                      case 'ADBE Rotate X':
                        return e.xRotation;
                      case 'ADBE Rotate Y':
                        return e.yRotation;
                      case 'position':
                      case 'Position':
                      case 'ADBE Position':
                      case 2:
                        return e.position;
                      case 'ADBE Position_0':
                        return e.xPosition;
                      case 'ADBE Position_1':
                        return e.yPosition;
                      case 'ADBE Position_2':
                        return e.zPosition;
                      case 'anchorPoint':
                      case 'AnchorPoint':
                      case 'Anchor Point':
                      case 'ADBE AnchorPoint':
                      case 1:
                        return e.anchorPoint;
                      case 'opacity':
                      case 'Opacity':
                      case 11:
                        return e.opacity;
                      default:
                        return null;
                    }
                  }
                  var r, n, i, o;
                  return (
                    Object.defineProperty(e, 'rotation', { get: ExpressionPropertyInterface(t.r || t.rz) }),
                    Object.defineProperty(e, 'zRotation', { get: ExpressionPropertyInterface(t.rz || t.r) }),
                    Object.defineProperty(e, 'xRotation', { get: ExpressionPropertyInterface(t.rx) }),
                    Object.defineProperty(e, 'yRotation', { get: ExpressionPropertyInterface(t.ry) }),
                    Object.defineProperty(e, 'scale', { get: ExpressionPropertyInterface(t.s) }),
                    t.p
                      ? (o = ExpressionPropertyInterface(t.p))
                      : ((r = ExpressionPropertyInterface(t.px)),
                        (n = ExpressionPropertyInterface(t.py)),
                        t.pz && (i = ExpressionPropertyInterface(t.pz))),
                    Object.defineProperty(e, 'position', {
                      get: function () {
                        return t.p ? o() : [r(), n(), i ? i() : 0];
                      },
                    }),
                    Object.defineProperty(e, 'xPosition', { get: ExpressionPropertyInterface(t.px) }),
                    Object.defineProperty(e, 'yPosition', { get: ExpressionPropertyInterface(t.py) }),
                    Object.defineProperty(e, 'zPosition', { get: ExpressionPropertyInterface(t.pz) }),
                    Object.defineProperty(e, 'anchorPoint', { get: ExpressionPropertyInterface(t.a) }),
                    Object.defineProperty(e, 'opacity', { get: ExpressionPropertyInterface(t.o) }),
                    Object.defineProperty(e, 'skew', { get: ExpressionPropertyInterface(t.sk) }),
                    Object.defineProperty(e, 'skewAxis', { get: ExpressionPropertyInterface(t.sa) }),
                    Object.defineProperty(e, 'orientation', { get: ExpressionPropertyInterface(t.or) }),
                    e
                  );
                },
                LayerExpressionInterface = (function () {
                  function t(t) {
                    var e = new Matrix();
                    return (
                      void 0 !== t
                        ? this._elem.finalTransform.mProp.getValueAtTime(t).clone(e)
                        : this._elem.finalTransform.mProp.applyToMatrix(e),
                      e
                    );
                  }
                  function e(t, e) {
                    var r = this.getMatrix(e);
                    return (r.props[12] = 0), (r.props[13] = 0), (r.props[14] = 0), this.applyPoint(r, t);
                  }
                  function r(t, e) {
                    var r = this.getMatrix(e);
                    return this.applyPoint(r, t);
                  }
                  function n(t, e) {
                    var r = this.getMatrix(e);
                    return (r.props[12] = 0), (r.props[13] = 0), (r.props[14] = 0), this.invertPoint(r, t);
                  }
                  function i(t, e) {
                    var r = this.getMatrix(e);
                    return this.invertPoint(r, t);
                  }
                  function o(t, e) {
                    if (this._elem.hierarchy && this._elem.hierarchy.length) {
                      var r,
                        n = this._elem.hierarchy.length;
                      for (r = 0; r < n; r += 1) this._elem.hierarchy[r].finalTransform.mProp.applyToMatrix(t);
                    }
                    return t.applyToPointArray(e[0], e[1], e[2] || 0);
                  }
                  function a(t, e) {
                    if (this._elem.hierarchy && this._elem.hierarchy.length) {
                      var r,
                        n = this._elem.hierarchy.length;
                      for (r = 0; r < n; r += 1) this._elem.hierarchy[r].finalTransform.mProp.applyToMatrix(t);
                    }
                    return t.inversePoint(e);
                  }
                  function s(t) {
                    var e = new Matrix();
                    if (
                      (e.reset(),
                      this._elem.finalTransform.mProp.applyToMatrix(e),
                      this._elem.hierarchy && this._elem.hierarchy.length)
                    ) {
                      var r,
                        n = this._elem.hierarchy.length;
                      for (r = 0; r < n; r += 1) this._elem.hierarchy[r].finalTransform.mProp.applyToMatrix(e);
                      return e.inversePoint(t);
                    }
                    return e.inversePoint(t);
                  }
                  function l() {
                    return [1, 1, 1, 1];
                  }
                  return function (c) {
                    var h;
                    function u(t) {
                      switch (t) {
                        case 'ADBE Root Vectors Group':
                        case 'Contents':
                        case 2:
                          return u.shapeInterface;
                        case 1:
                        case 6:
                        case 'Transform':
                        case 'transform':
                        case 'ADBE Transform Group':
                          return h;
                        case 4:
                        case 'ADBE Effect Parade':
                        case 'effects':
                        case 'Effects':
                          return u.effect;
                        case 'ADBE Text Properties':
                          return u.textInterface;
                        default:
                          return null;
                      }
                    }
                    (u.getMatrix = t),
                      (u.invertPoint = a),
                      (u.applyPoint = o),
                      (u.toWorld = r),
                      (u.toWorldVec = e),
                      (u.fromWorld = i),
                      (u.fromWorldVec = n),
                      (u.toComp = r),
                      (u.fromComp = s),
                      (u.sampleImage = l),
                      (u.sourceRectAtTime = c.sourceRectAtTime.bind(c)),
                      (u._elem = c);
                    var p = getDescriptor((h = TransformExpressionInterface(c.finalTransform.mProp)), 'anchorPoint');
                    return (
                      Object.defineProperties(u, {
                        hasParent: {
                          get: function () {
                            return c.hierarchy.length;
                          },
                        },
                        parent: {
                          get: function () {
                            return c.hierarchy[0].layerInterface;
                          },
                        },
                        rotation: getDescriptor(h, 'rotation'),
                        scale: getDescriptor(h, 'scale'),
                        position: getDescriptor(h, 'position'),
                        opacity: getDescriptor(h, 'opacity'),
                        anchorPoint: p,
                        anchor_point: p,
                        transform: {
                          get: function () {
                            return h;
                          },
                        },
                        active: {
                          get: function () {
                            return c.isInRange;
                          },
                        },
                      }),
                      (u.startTime = c.data.st),
                      (u.index = c.data.ind),
                      (u.source = c.data.refId),
                      (u.height = 0 === c.data.ty ? c.data.h : 100),
                      (u.width = 0 === c.data.ty ? c.data.w : 100),
                      (u.inPoint = c.data.ip / c.comp.globalData.frameRate),
                      (u.outPoint = c.data.op / c.comp.globalData.frameRate),
                      (u._name = c.data.nm),
                      (u.registerMaskInterface = function (t) {
                        u.mask = new MaskManagerInterface(t, c);
                      }),
                      (u.registerEffectsInterface = function (t) {
                        u.effect = t;
                      }),
                      u
                    );
                  };
                })(),
                propertyGroupFactory = function (t, e) {
                  return function (r) {
                    return (r = void 0 === r ? 1 : r) <= 0 ? t : e(r - 1);
                  };
                },
                PropertyInterface = function (t, e) {
                  var r = { _name: t };
                  return function (t) {
                    return (t = void 0 === t ? 1 : t) <= 0 ? r : e(t - 1);
                  };
                },
                EffectsExpressionInterface = (function () {
                  var t = {
                    createEffectsInterface: function (t, r) {
                      if (t.effectsManager) {
                        var n,
                          i = [],
                          o = t.data.ef,
                          a = t.effectsManager.effectElements.length;
                        for (n = 0; n < a; n += 1) i.push(e(o[n], t.effectsManager.effectElements[n], r, t));
                        var s = t.data.ef || [],
                          l = function (t) {
                            for (n = 0, a = s.length; n < a; ) {
                              if (t === s[n].nm || t === s[n].mn || t === s[n].ix) return i[n];
                              n += 1;
                            }
                            return null;
                          };
                        return (
                          Object.defineProperty(l, 'numProperties', {
                            get: function () {
                              return s.length;
                            },
                          }),
                          l
                        );
                      }
                      return null;
                    },
                  };
                  function e(t, n, i, o) {
                    function a(e) {
                      for (var r = t.ef, n = 0, i = r.length; n < i; ) {
                        if (e === r[n].nm || e === r[n].mn || e === r[n].ix) return 5 === r[n].ty ? c[n] : c[n]();
                        n += 1;
                      }
                      throw new Error();
                    }
                    var s,
                      l = propertyGroupFactory(a, i),
                      c = [],
                      h = t.ef.length;
                    for (s = 0; s < h; s += 1)
                      5 === t.ef[s].ty
                        ? c.push(e(t.ef[s], n.effectElements[s], n.effectElements[s].propertyGroup, o))
                        : c.push(r(n.effectElements[s], t.ef[s].ty, o, l));
                    return (
                      'ADBE Color Control' === t.mn &&
                        Object.defineProperty(a, 'color', {
                          get: function () {
                            return c[0]();
                          },
                        }),
                      Object.defineProperties(a, {
                        numProperties: {
                          get: function () {
                            return t.np;
                          },
                        },
                        _name: { value: t.nm },
                        propertyGroup: { value: l },
                      }),
                      (a.enabled = 0 !== t.en),
                      (a.active = a.enabled),
                      a
                    );
                  }
                  function r(t, e, r, n) {
                    var i = ExpressionPropertyInterface(t.p);
                    return (
                      t.p.setGroupProperty && t.p.setGroupProperty(PropertyInterface('', n)),
                      function () {
                        return 10 === e ? r.comp.compInterface(t.p.v) : i();
                      }
                    );
                  }
                  return t;
                })(),
                ShapePathInterface = function (t, e, r) {
                  var n = e.sh;
                  function i(t) {
                    return 'Shape' === t ||
                      'shape' === t ||
                      'Path' === t ||
                      'path' === t ||
                      'ADBE Vector Shape' === t ||
                      2 === t
                      ? i.path
                      : null;
                  }
                  var o = propertyGroupFactory(i, r);
                  return (
                    n.setGroupProperty(PropertyInterface('Path', o)),
                    Object.defineProperties(i, {
                      path: {
                        get: function () {
                          return n.k && n.getValue(), n;
                        },
                      },
                      shape: {
                        get: function () {
                          return n.k && n.getValue(), n;
                        },
                      },
                      _name: { value: t.nm },
                      ix: { value: t.ix },
                      propertyIndex: { value: t.ix },
                      mn: { value: t.mn },
                      propertyGroup: { value: r },
                    }),
                    i
                  );
                },
                ShapeExpressionInterface = (function () {
                  function t(t, a, p) {
                    var f,
                      d = [],
                      m = t ? t.length : 0;
                    for (f = 0; f < m; f += 1)
                      'gr' === t[f].ty
                        ? d.push(e(t[f], a[f], p))
                        : 'fl' === t[f].ty
                        ? d.push(r(t[f], a[f], p))
                        : 'st' === t[f].ty
                        ? d.push(i(t[f], a[f], p))
                        : 'tm' === t[f].ty
                        ? d.push(o(t[f], a[f], p))
                        : 'tr' === t[f].ty ||
                          ('el' === t[f].ty
                            ? d.push(s(t[f], a[f], p))
                            : 'sr' === t[f].ty
                            ? d.push(l(t[f], a[f], p))
                            : 'sh' === t[f].ty
                            ? d.push(ShapePathInterface(t[f], a[f], p))
                            : 'rc' === t[f].ty
                            ? d.push(c(t[f], a[f], p))
                            : 'rd' === t[f].ty
                            ? d.push(h(t[f], a[f], p))
                            : 'rp' === t[f].ty
                            ? d.push(u(t[f], a[f], p))
                            : 'gf' === t[f].ty
                            ? d.push(n(t[f], a[f], p))
                            : d.push(
                                (t[f],
                                a[f],
                                function () {
                                  return null;
                                }),
                              ));
                    return d;
                  }
                  function e(e, r, n) {
                    var i = function (t) {
                      switch (t) {
                        case 'ADBE Vectors Group':
                        case 'Contents':
                        case 2:
                          return i.content;
                        default:
                          return i.transform;
                      }
                    };
                    i.propertyGroup = propertyGroupFactory(i, n);
                    var o = (function (e, r, n) {
                        var i,
                          o = function (t) {
                            for (var e = 0, r = i.length; e < r; ) {
                              if (
                                i[e]._name === t ||
                                i[e].mn === t ||
                                i[e].propertyIndex === t ||
                                i[e].ix === t ||
                                i[e].ind === t
                              )
                                return i[e];
                              e += 1;
                            }
                            return 'number' == typeof t ? i[t - 1] : null;
                          };
                        (o.propertyGroup = propertyGroupFactory(o, n)),
                          (i = t(e.it, r.it, o.propertyGroup)),
                          (o.numProperties = i.length);
                        var s = a(e.it[e.it.length - 1], r.it[r.it.length - 1], o.propertyGroup);
                        return (o.transform = s), (o.propertyIndex = e.cix), (o._name = e.nm), o;
                      })(e, r, i.propertyGroup),
                      s = a(e.it[e.it.length - 1], r.it[r.it.length - 1], i.propertyGroup);
                    return (
                      (i.content = o),
                      (i.transform = s),
                      Object.defineProperty(i, '_name', {
                        get: function () {
                          return e.nm;
                        },
                      }),
                      (i.numProperties = e.np),
                      (i.propertyIndex = e.ix),
                      (i.nm = e.nm),
                      (i.mn = e.mn),
                      i
                    );
                  }
                  function r(t, e, r) {
                    function n(t) {
                      return 'Color' === t || 'color' === t
                        ? n.color
                        : 'Opacity' === t || 'opacity' === t
                        ? n.opacity
                        : null;
                    }
                    return (
                      Object.defineProperties(n, {
                        color: { get: ExpressionPropertyInterface(e.c) },
                        opacity: { get: ExpressionPropertyInterface(e.o) },
                        _name: { value: t.nm },
                        mn: { value: t.mn },
                      }),
                      e.c.setGroupProperty(PropertyInterface('Color', r)),
                      e.o.setGroupProperty(PropertyInterface('Opacity', r)),
                      n
                    );
                  }
                  function n(t, e, r) {
                    function n(t) {
                      return 'Start Point' === t || 'start point' === t
                        ? n.startPoint
                        : 'End Point' === t || 'end point' === t
                        ? n.endPoint
                        : 'Opacity' === t || 'opacity' === t
                        ? n.opacity
                        : null;
                    }
                    return (
                      Object.defineProperties(n, {
                        startPoint: { get: ExpressionPropertyInterface(e.s) },
                        endPoint: { get: ExpressionPropertyInterface(e.e) },
                        opacity: { get: ExpressionPropertyInterface(e.o) },
                        type: {
                          get: function () {
                            return 'a';
                          },
                        },
                        _name: { value: t.nm },
                        mn: { value: t.mn },
                      }),
                      e.s.setGroupProperty(PropertyInterface('Start Point', r)),
                      e.e.setGroupProperty(PropertyInterface('End Point', r)),
                      e.o.setGroupProperty(PropertyInterface('Opacity', r)),
                      n
                    );
                  }
                  function i(t, e, r) {
                    var n,
                      i = propertyGroupFactory(c, r),
                      o = propertyGroupFactory(l, i);
                    function a(r) {
                      Object.defineProperty(l, t.d[r].nm, { get: ExpressionPropertyInterface(e.d.dataProps[r].p) });
                    }
                    var s = t.d ? t.d.length : 0,
                      l = {};
                    for (n = 0; n < s; n += 1) a(n), e.d.dataProps[n].p.setGroupProperty(o);
                    function c(t) {
                      return 'Color' === t || 'color' === t
                        ? c.color
                        : 'Opacity' === t || 'opacity' === t
                        ? c.opacity
                        : 'Stroke Width' === t || 'stroke width' === t
                        ? c.strokeWidth
                        : null;
                    }
                    return (
                      Object.defineProperties(c, {
                        color: { get: ExpressionPropertyInterface(e.c) },
                        opacity: { get: ExpressionPropertyInterface(e.o) },
                        strokeWidth: { get: ExpressionPropertyInterface(e.w) },
                        dash: {
                          get: function () {
                            return l;
                          },
                        },
                        _name: { value: t.nm },
                        mn: { value: t.mn },
                      }),
                      e.c.setGroupProperty(PropertyInterface('Color', i)),
                      e.o.setGroupProperty(PropertyInterface('Opacity', i)),
                      e.w.setGroupProperty(PropertyInterface('Stroke Width', i)),
                      c
                    );
                  }
                  function o(t, e, r) {
                    function n(e) {
                      return e === t.e.ix || 'End' === e || 'end' === e
                        ? n.end
                        : e === t.s.ix
                        ? n.start
                        : e === t.o.ix
                        ? n.offset
                        : null;
                    }
                    var i = propertyGroupFactory(n, r);
                    return (
                      (n.propertyIndex = t.ix),
                      e.s.setGroupProperty(PropertyInterface('Start', i)),
                      e.e.setGroupProperty(PropertyInterface('End', i)),
                      e.o.setGroupProperty(PropertyInterface('Offset', i)),
                      (n.propertyIndex = t.ix),
                      (n.propertyGroup = r),
                      Object.defineProperties(n, {
                        start: { get: ExpressionPropertyInterface(e.s) },
                        end: { get: ExpressionPropertyInterface(e.e) },
                        offset: { get: ExpressionPropertyInterface(e.o) },
                        _name: { value: t.nm },
                      }),
                      (n.mn = t.mn),
                      n
                    );
                  }
                  function a(t, e, r) {
                    function n(e) {
                      return t.a.ix === e || 'Anchor Point' === e
                        ? n.anchorPoint
                        : t.o.ix === e || 'Opacity' === e
                        ? n.opacity
                        : t.p.ix === e || 'Position' === e
                        ? n.position
                        : t.r.ix === e || 'Rotation' === e || 'ADBE Vector Rotation' === e
                        ? n.rotation
                        : t.s.ix === e || 'Scale' === e
                        ? n.scale
                        : (t.sk && t.sk.ix === e) || 'Skew' === e
                        ? n.skew
                        : (t.sa && t.sa.ix === e) || 'Skew Axis' === e
                        ? n.skewAxis
                        : null;
                    }
                    var i = propertyGroupFactory(n, r);
                    return (
                      e.transform.mProps.o.setGroupProperty(PropertyInterface('Opacity', i)),
                      e.transform.mProps.p.setGroupProperty(PropertyInterface('Position', i)),
                      e.transform.mProps.a.setGroupProperty(PropertyInterface('Anchor Point', i)),
                      e.transform.mProps.s.setGroupProperty(PropertyInterface('Scale', i)),
                      e.transform.mProps.r.setGroupProperty(PropertyInterface('Rotation', i)),
                      e.transform.mProps.sk &&
                        (e.transform.mProps.sk.setGroupProperty(PropertyInterface('Skew', i)),
                        e.transform.mProps.sa.setGroupProperty(PropertyInterface('Skew Angle', i))),
                      e.transform.op.setGroupProperty(PropertyInterface('Opacity', i)),
                      Object.defineProperties(n, {
                        opacity: { get: ExpressionPropertyInterface(e.transform.mProps.o) },
                        position: { get: ExpressionPropertyInterface(e.transform.mProps.p) },
                        anchorPoint: { get: ExpressionPropertyInterface(e.transform.mProps.a) },
                        scale: { get: ExpressionPropertyInterface(e.transform.mProps.s) },
                        rotation: { get: ExpressionPropertyInterface(e.transform.mProps.r) },
                        skew: { get: ExpressionPropertyInterface(e.transform.mProps.sk) },
                        skewAxis: { get: ExpressionPropertyInterface(e.transform.mProps.sa) },
                        _name: { value: t.nm },
                      }),
                      (n.ty = 'tr'),
                      (n.mn = t.mn),
                      (n.propertyGroup = r),
                      n
                    );
                  }
                  function s(t, e, r) {
                    function n(e) {
                      return t.p.ix === e ? n.position : t.s.ix === e ? n.size : null;
                    }
                    var i = propertyGroupFactory(n, r);
                    n.propertyIndex = t.ix;
                    var o = 'tm' === e.sh.ty ? e.sh.prop : e.sh;
                    return (
                      o.s.setGroupProperty(PropertyInterface('Size', i)),
                      o.p.setGroupProperty(PropertyInterface('Position', i)),
                      Object.defineProperties(n, {
                        size: { get: ExpressionPropertyInterface(o.s) },
                        position: { get: ExpressionPropertyInterface(o.p) },
                        _name: { value: t.nm },
                      }),
                      (n.mn = t.mn),
                      n
                    );
                  }
                  function l(t, e, r) {
                    function n(e) {
                      return t.p.ix === e
                        ? n.position
                        : t.r.ix === e
                        ? n.rotation
                        : t.pt.ix === e
                        ? n.points
                        : t.or.ix === e || 'ADBE Vector Star Outer Radius' === e
                        ? n.outerRadius
                        : t.os.ix === e
                        ? n.outerRoundness
                        : !t.ir || (t.ir.ix !== e && 'ADBE Vector Star Inner Radius' !== e)
                        ? t.is && t.is.ix === e
                          ? n.innerRoundness
                          : null
                        : n.innerRadius;
                    }
                    var i = propertyGroupFactory(n, r),
                      o = 'tm' === e.sh.ty ? e.sh.prop : e.sh;
                    return (
                      (n.propertyIndex = t.ix),
                      o.or.setGroupProperty(PropertyInterface('Outer Radius', i)),
                      o.os.setGroupProperty(PropertyInterface('Outer Roundness', i)),
                      o.pt.setGroupProperty(PropertyInterface('Points', i)),
                      o.p.setGroupProperty(PropertyInterface('Position', i)),
                      o.r.setGroupProperty(PropertyInterface('Rotation', i)),
                      t.ir &&
                        (o.ir.setGroupProperty(PropertyInterface('Inner Radius', i)),
                        o.is.setGroupProperty(PropertyInterface('Inner Roundness', i))),
                      Object.defineProperties(n, {
                        position: { get: ExpressionPropertyInterface(o.p) },
                        rotation: { get: ExpressionPropertyInterface(o.r) },
                        points: { get: ExpressionPropertyInterface(o.pt) },
                        outerRadius: { get: ExpressionPropertyInterface(o.or) },
                        outerRoundness: { get: ExpressionPropertyInterface(o.os) },
                        innerRadius: { get: ExpressionPropertyInterface(o.ir) },
                        innerRoundness: { get: ExpressionPropertyInterface(o.is) },
                        _name: { value: t.nm },
                      }),
                      (n.mn = t.mn),
                      n
                    );
                  }
                  function c(t, e, r) {
                    function n(e) {
                      return t.p.ix === e
                        ? n.position
                        : t.r.ix === e
                        ? n.roundness
                        : t.s.ix === e || 'Size' === e || 'ADBE Vector Rect Size' === e
                        ? n.size
                        : null;
                    }
                    var i = propertyGroupFactory(n, r),
                      o = 'tm' === e.sh.ty ? e.sh.prop : e.sh;
                    return (
                      (n.propertyIndex = t.ix),
                      o.p.setGroupProperty(PropertyInterface('Position', i)),
                      o.s.setGroupProperty(PropertyInterface('Size', i)),
                      o.r.setGroupProperty(PropertyInterface('Rotation', i)),
                      Object.defineProperties(n, {
                        position: { get: ExpressionPropertyInterface(o.p) },
                        roundness: { get: ExpressionPropertyInterface(o.r) },
                        size: { get: ExpressionPropertyInterface(o.s) },
                        _name: { value: t.nm },
                      }),
                      (n.mn = t.mn),
                      n
                    );
                  }
                  function h(t, e, r) {
                    function n(e) {
                      return t.r.ix === e || 'Round Corners 1' === e ? n.radius : null;
                    }
                    var i = propertyGroupFactory(n, r),
                      o = e;
                    return (
                      (n.propertyIndex = t.ix),
                      o.rd.setGroupProperty(PropertyInterface('Radius', i)),
                      Object.defineProperties(n, {
                        radius: { get: ExpressionPropertyInterface(o.rd) },
                        _name: { value: t.nm },
                      }),
                      (n.mn = t.mn),
                      n
                    );
                  }
                  function u(t, e, r) {
                    function n(e) {
                      return t.c.ix === e || 'Copies' === e
                        ? n.copies
                        : t.o.ix === e || 'Offset' === e
                        ? n.offset
                        : null;
                    }
                    var i = propertyGroupFactory(n, r),
                      o = e;
                    return (
                      (n.propertyIndex = t.ix),
                      o.c.setGroupProperty(PropertyInterface('Copies', i)),
                      o.o.setGroupProperty(PropertyInterface('Offset', i)),
                      Object.defineProperties(n, {
                        copies: { get: ExpressionPropertyInterface(o.c) },
                        offset: { get: ExpressionPropertyInterface(o.o) },
                        _name: { value: t.nm },
                      }),
                      (n.mn = t.mn),
                      n
                    );
                  }
                  return function (e, r, n) {
                    var i;
                    function o(t) {
                      if ('number' == typeof t) return 0 === (t = void 0 === t ? 1 : t) ? n : i[t - 1];
                      for (var e = 0, r = i.length; e < r; ) {
                        if (i[e]._name === t) return i[e];
                        e += 1;
                      }
                      return null;
                    }
                    return (
                      (o.propertyGroup = propertyGroupFactory(o, function () {
                        return n;
                      })),
                      (i = t(e, r, o.propertyGroup)),
                      (o.numProperties = i.length),
                      (o._name = 'Contents'),
                      o
                    );
                  };
                })(),
                TextExpressionInterface = function (t) {
                  var e, r;
                  function n(t) {
                    return 'ADBE Text Document' === t ? n.sourceText : null;
                  }
                  return (
                    Object.defineProperty(n, 'sourceText', {
                      get: function () {
                        t.textProperty.getValue();
                        var n = t.textProperty.currentData.t;
                        return (
                          n !== e &&
                            ((t.textProperty.currentData.t = e), ((r = new String(n)).value = n || new String(n))),
                          r
                        );
                      },
                    }),
                    n
                  );
                };
              function _typeof$2(t) {
                return (
                  (_typeof$2 =
                    'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
                      ? function (t) {
                          return typeof t;
                        }
                      : function (t) {
                          return t && 'function' == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype
                            ? 'symbol'
                            : typeof t;
                        }),
                  _typeof$2(t)
                );
              }
              var FootageInterface =
                  ((dataInterfaceFactory = function (t) {
                    function e(t) {
                      return 'Outline' === t ? e.outlineInterface() : null;
                    }
                    return (
                      (e._name = 'Outline'),
                      (e.outlineInterface = (function (t) {
                        var e = '',
                          r = t.getFootageData();
                        function n(t) {
                          if (r[t]) return (e = t), 'object' === _typeof$2((r = r[t])) ? n : r;
                          var i = t.indexOf(e);
                          if (-1 !== i) {
                            var o = parseInt(t.substr(i + e.length), 10);
                            return 'object' === _typeof$2((r = r[o])) ? n : r;
                          }
                          return '';
                        }
                        return function () {
                          return (e = ''), (r = t.getFootageData()), n;
                        };
                      })(t)),
                      e
                    );
                  }),
                  function (t) {
                    function e(t) {
                      return 'Data' === t ? e.dataInterface : null;
                    }
                    return (e._name = 'Data'), (e.dataInterface = dataInterfaceFactory(t)), e;
                  }),
                dataInterfaceFactory,
                interfaces = {
                  layer: LayerExpressionInterface,
                  effects: EffectsExpressionInterface,
                  comp: CompExpressionInterface,
                  shape: ShapeExpressionInterface,
                  text: TextExpressionInterface,
                  footage: FootageInterface,
                };
              function getInterface(t) {
                return interfaces[t] || null;
              }
              function _typeof$1(t) {
                return (
                  (_typeof$1 =
                    'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
                      ? function (t) {
                          return typeof t;
                        }
                      : function (t) {
                          return t && 'function' == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype
                            ? 'symbol'
                            : typeof t;
                        }),
                  _typeof$1(t)
                );
              }
              function seedRandom(t, e) {
                var r = this,
                  n = 256,
                  i = e.pow(n, 6),
                  o = e.pow(2, 52),
                  a = 2 * o,
                  s = 255;
                function l(t) {
                  var e,
                    r = t.length,
                    i = this,
                    o = 0,
                    a = (i.i = i.j = 0),
                    l = (i.S = []);
                  for (r || (t = [r++]); o < n; ) l[o] = o++;
                  for (o = 0; o < n; o++) (l[o] = l[(a = s & (a + t[o % r] + (e = l[o])))]), (l[a] = e);
                  i.g = function (t) {
                    for (var e, r = 0, o = i.i, a = i.j, l = i.S; t--; )
                      (e = l[(o = s & (o + 1))]), (r = r * n + l[s & ((l[o] = l[(a = s & (a + e))]) + (l[a] = e))]);
                    return (i.i = o), (i.j = a), r;
                  };
                }
                function c(t, e) {
                  return (e.i = t.i), (e.j = t.j), (e.S = t.S.slice()), e;
                }
                function h(t, e) {
                  var r,
                    n = [],
                    i = _typeof$1(t);
                  if (e && 'object' == i)
                    for (r in t)
                      try {
                        n.push(h(t[r], e - 1));
                      } catch (t) {}
                  return n.length ? n : 'string' == i ? t : t + '\0';
                }
                function u(t, e) {
                  for (var r, n = t + '', i = 0; i < n.length; )
                    e[s & i] = s & ((r ^= 19 * e[s & i]) + n.charCodeAt(i++));
                  return p(e);
                }
                function p(t) {
                  return String.fromCharCode.apply(0, t);
                }
                (e.seedrandom = function (s, f, d) {
                  var m = [],
                    y = u(
                      h(
                        (f = !0 === f ? { entropy: !0 } : f || {}).entropy
                          ? [s, p(t)]
                          : null === s
                          ? (function () {
                              try {
                                var e = new Uint8Array(n);
                                return (r.crypto || r.msCrypto).getRandomValues(e), p(e);
                              } catch (e) {
                                var i = r.navigator,
                                  o = i && i.plugins;
                                return [+new Date(), r, o, r.screen, p(t)];
                              }
                            })()
                          : s,
                        3,
                      ),
                      m,
                    ),
                    g = new l(m),
                    v = function () {
                      for (var t = g.g(6), e = i, r = 0; t < o; ) (t = (t + r) * n), (e *= n), (r = g.g(1));
                      for (; t >= a; ) (t /= 2), (e /= 2), (r >>>= 1);
                      return (t + r) / e;
                    };
                  return (
                    (v.int32 = function () {
                      return 0 | g.g(4);
                    }),
                    (v.quick = function () {
                      return g.g(4) / 4294967296;
                    }),
                    (v.double = v),
                    u(p(g.S), t),
                    (
                      f.pass ||
                      d ||
                      function (t, r, n, i) {
                        return (
                          i &&
                            (i.S && c(i, g),
                            (t.state = function () {
                              return c(g, {});
                            })),
                          n ? ((e.random = t), r) : t
                        );
                      }
                    )(v, y, 'global' in f ? f.global : this == e, f.state)
                  );
                }),
                  u(e.random(), t);
              }
              function initialize$2(t) {
                seedRandom([], t);
              }
              var propTypes = { SHAPE: 'shape' };
              function _typeof(t) {
                return (
                  (_typeof =
                    'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
                      ? function (t) {
                          return typeof t;
                        }
                      : function (t) {
                          return t && 'function' == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype
                            ? 'symbol'
                            : typeof t;
                        }),
                  _typeof(t)
                );
              }
              var ExpressionManager = (function () {
                  var ob = {},
                    Math = BMMath,
                    window = null,
                    document = null,
                    XMLHttpRequest = null,
                    fetch = null,
                    frames = null;
                  function $bm_isInstanceOfArray(t) {
                    return t.constructor === Array || t.constructor === Float32Array;
                  }
                  function isNumerable(t, e) {
                    return 'number' === t || 'boolean' === t || 'string' === t || e instanceof Number;
                  }
                  function $bm_neg(t) {
                    var e = _typeof(t);
                    if ('number' === e || 'boolean' === e || t instanceof Number) return -t;
                    if ($bm_isInstanceOfArray(t)) {
                      var r,
                        n = t.length,
                        i = [];
                      for (r = 0; r < n; r += 1) i[r] = -t[r];
                      return i;
                    }
                    return t.propType ? t.v : -t;
                  }
                  initialize$2(BMMath);
                  var easeInBez = BezierFactory.getBezierEasing(0.333, 0, 0.833, 0.833, 'easeIn').get,
                    easeOutBez = BezierFactory.getBezierEasing(0.167, 0.167, 0.667, 1, 'easeOut').get,
                    easeInOutBez = BezierFactory.getBezierEasing(0.33, 0, 0.667, 1, 'easeInOut').get;
                  function sum(t, e) {
                    var r = _typeof(t),
                      n = _typeof(e);
                    if ('string' === r || 'string' === n) return t + e;
                    if (isNumerable(r, t) && isNumerable(n, e)) return t + e;
                    if ($bm_isInstanceOfArray(t) && isNumerable(n, e)) return ((t = t.slice(0))[0] += e), t;
                    if (isNumerable(r, t) && $bm_isInstanceOfArray(e)) return ((e = e.slice(0))[0] = t + e[0]), e;
                    if ($bm_isInstanceOfArray(t) && $bm_isInstanceOfArray(e)) {
                      for (var i = 0, o = t.length, a = e.length, s = []; i < o || i < a; )
                        ('number' == typeof t[i] || t[i] instanceof Number) &&
                        ('number' == typeof e[i] || e[i] instanceof Number)
                          ? (s[i] = t[i] + e[i])
                          : (s[i] = void 0 === e[i] ? t[i] : t[i] || e[i]),
                          (i += 1);
                      return s;
                    }
                    return 0;
                  }
                  var add = sum;
                  function sub(t, e) {
                    var r = _typeof(t),
                      n = _typeof(e);
                    if (isNumerable(r, t) && isNumerable(n, e))
                      return 'string' === r && (t = parseInt(t, 10)), 'string' === n && (e = parseInt(e, 10)), t - e;
                    if ($bm_isInstanceOfArray(t) && isNumerable(n, e)) return ((t = t.slice(0))[0] -= e), t;
                    if (isNumerable(r, t) && $bm_isInstanceOfArray(e)) return ((e = e.slice(0))[0] = t - e[0]), e;
                    if ($bm_isInstanceOfArray(t) && $bm_isInstanceOfArray(e)) {
                      for (var i = 0, o = t.length, a = e.length, s = []; i < o || i < a; )
                        ('number' == typeof t[i] || t[i] instanceof Number) &&
                        ('number' == typeof e[i] || e[i] instanceof Number)
                          ? (s[i] = t[i] - e[i])
                          : (s[i] = void 0 === e[i] ? t[i] : t[i] || e[i]),
                          (i += 1);
                      return s;
                    }
                    return 0;
                  }
                  function mul(t, e) {
                    var r,
                      n,
                      i,
                      o = _typeof(t),
                      a = _typeof(e);
                    if (isNumerable(o, t) && isNumerable(a, e)) return t * e;
                    if ($bm_isInstanceOfArray(t) && isNumerable(a, e)) {
                      for (i = t.length, r = createTypedArray('float32', i), n = 0; n < i; n += 1) r[n] = t[n] * e;
                      return r;
                    }
                    if (isNumerable(o, t) && $bm_isInstanceOfArray(e)) {
                      for (i = e.length, r = createTypedArray('float32', i), n = 0; n < i; n += 1) r[n] = t * e[n];
                      return r;
                    }
                    return 0;
                  }
                  function div(t, e) {
                    var r,
                      n,
                      i,
                      o = _typeof(t),
                      a = _typeof(e);
                    if (isNumerable(o, t) && isNumerable(a, e)) return t / e;
                    if ($bm_isInstanceOfArray(t) && isNumerable(a, e)) {
                      for (i = t.length, r = createTypedArray('float32', i), n = 0; n < i; n += 1) r[n] = t[n] / e;
                      return r;
                    }
                    if (isNumerable(o, t) && $bm_isInstanceOfArray(e)) {
                      for (i = e.length, r = createTypedArray('float32', i), n = 0; n < i; n += 1) r[n] = t / e[n];
                      return r;
                    }
                    return 0;
                  }
                  function mod(t, e) {
                    return (
                      'string' == typeof t && (t = parseInt(t, 10)),
                      'string' == typeof e && (e = parseInt(e, 10)),
                      t % e
                    );
                  }
                  var $bm_sum = sum,
                    $bm_sub = sub,
                    $bm_mul = mul,
                    $bm_div = div,
                    $bm_mod = mod;
                  function clamp(t, e, r) {
                    if (e > r) {
                      var n = r;
                      (r = e), (e = n);
                    }
                    return Math.min(Math.max(t, e), r);
                  }
                  function radiansToDegrees(t) {
                    return t / degToRads;
                  }
                  var radians_to_degrees = radiansToDegrees;
                  function degreesToRadians(t) {
                    return t * degToRads;
                  }
                  var degrees_to_radians = radiansToDegrees,
                    helperLengthArray = [0, 0, 0, 0, 0, 0];
                  function length(t, e) {
                    if ('number' == typeof t || t instanceof Number) return (e = e || 0), Math.abs(t - e);
                    var r;
                    e || (e = helperLengthArray);
                    var n = Math.min(t.length, e.length),
                      i = 0;
                    for (r = 0; r < n; r += 1) i += Math.pow(e[r] - t[r], 2);
                    return Math.sqrt(i);
                  }
                  function normalize(t) {
                    return div(t, length(t));
                  }
                  function rgbToHsl(t) {
                    var e,
                      r,
                      n = t[0],
                      i = t[1],
                      o = t[2],
                      a = Math.max(n, i, o),
                      s = Math.min(n, i, o),
                      l = (a + s) / 2;
                    if (a === s) (e = 0), (r = 0);
                    else {
                      var c = a - s;
                      switch (((r = l > 0.5 ? c / (2 - a - s) : c / (a + s)), a)) {
                        case n:
                          e = (i - o) / c + (i < o ? 6 : 0);
                          break;
                        case i:
                          e = (o - n) / c + 2;
                          break;
                        case o:
                          e = (n - i) / c + 4;
                      }
                      e /= 6;
                    }
                    return [e, r, l, t[3]];
                  }
                  function hue2rgb(t, e, r) {
                    return (
                      r < 0 && (r += 1),
                      r > 1 && (r -= 1),
                      r < 1 / 6 ? t + 6 * (e - t) * r : r < 0.5 ? e : r < 2 / 3 ? t + (e - t) * (2 / 3 - r) * 6 : t
                    );
                  }
                  function hslToRgb(t) {
                    var e,
                      r,
                      n,
                      i = t[0],
                      o = t[1],
                      a = t[2];
                    if (0 === o) (e = a), (n = a), (r = a);
                    else {
                      var s = a < 0.5 ? a * (1 + o) : a + o - a * o,
                        l = 2 * a - s;
                      (e = hue2rgb(l, s, i + 1 / 3)), (r = hue2rgb(l, s, i)), (n = hue2rgb(l, s, i - 1 / 3));
                    }
                    return [e, r, n, t[3]];
                  }
                  function linear(t, e, r, n, i) {
                    if (((void 0 !== n && void 0 !== i) || ((n = e), (i = r), (e = 0), (r = 1)), r < e)) {
                      var o = r;
                      (r = e), (e = o);
                    }
                    if (t <= e) return n;
                    if (t >= r) return i;
                    var a,
                      s = r === e ? 0 : (t - e) / (r - e);
                    if (!n.length) return n + (i - n) * s;
                    var l = n.length,
                      c = createTypedArray('float32', l);
                    for (a = 0; a < l; a += 1) c[a] = n[a] + (i[a] - n[a]) * s;
                    return c;
                  }
                  function random(t, e) {
                    if ((void 0 === e && (void 0 === t ? ((t = 0), (e = 1)) : ((e = t), (t = void 0))), e.length)) {
                      var r,
                        n = e.length;
                      t || (t = createTypedArray('float32', n));
                      var i = createTypedArray('float32', n),
                        o = BMMath.random();
                      for (r = 0; r < n; r += 1) i[r] = t[r] + o * (e[r] - t[r]);
                      return i;
                    }
                    return void 0 === t && (t = 0), t + BMMath.random() * (e - t);
                  }
                  function createPath(t, e, r, n) {
                    var i,
                      o = t.length,
                      a = shapePool.newElement();
                    a.setPathData(!!n, o);
                    var s,
                      l,
                      c = [0, 0];
                    for (i = 0; i < o; i += 1)
                      (s = e && e[i] ? e[i] : c),
                        (l = r && r[i] ? r[i] : c),
                        a.setTripleAt(
                          t[i][0],
                          t[i][1],
                          l[0] + t[i][0],
                          l[1] + t[i][1],
                          s[0] + t[i][0],
                          s[1] + t[i][1],
                          i,
                          !0,
                        );
                    return a;
                  }
                  function initiateExpression(elem, data, property) {
                    function noOp(t) {
                      return t;
                    }
                    if (!elem.globalData.renderConfig.runExpressions) return noOp;
                    var val = data.x,
                      needsVelocity = /velocity(?![\w\d])/.test(val),
                      _needsRandom = -1 !== val.indexOf('random'),
                      elemType = elem.data.ty,
                      transform,
                      $bm_transform,
                      content,
                      effect,
                      thisProperty = property;
                    (thisProperty.valueAtTime = thisProperty.getValueAtTime),
                      Object.defineProperty(thisProperty, 'value', {
                        get: function () {
                          return thisProperty.v;
                        },
                      }),
                      (elem.comp.frameDuration = 1 / elem.comp.globalData.frameRate),
                      (elem.comp.displayStartTime = 0);
                    var inPoint = elem.data.ip / elem.comp.globalData.frameRate,
                      outPoint = elem.data.op / elem.comp.globalData.frameRate,
                      width = elem.data.sw ? elem.data.sw : 0,
                      height = elem.data.sh ? elem.data.sh : 0,
                      name = elem.data.nm,
                      loopIn,
                      loop_in,
                      loopOut,
                      loop_out,
                      smooth,
                      toWorld,
                      fromWorld,
                      fromComp,
                      toComp,
                      fromCompToSurface,
                      position,
                      rotation,
                      anchorPoint,
                      scale,
                      thisLayer,
                      thisComp,
                      mask,
                      valueAtTime,
                      velocityAtTime,
                      scoped_bm_rt,
                      expression_function = eval(
                        '[function _expression_function(){' + val + ';scoped_bm_rt=$bm_rt}]',
                      )[0],
                      numKeys = property.kf ? data.k.length : 0,
                      active = !this.data || !0 !== this.data.hd,
                      wiggle = function (t, e) {
                        var r,
                          n,
                          i = this.pv.length ? this.pv.length : 1,
                          o = createTypedArray('float32', i),
                          a = Math.floor(5 * time);
                        for (r = 0, n = 0; r < a; ) {
                          for (n = 0; n < i; n += 1) o[n] += -e + 2 * e * BMMath.random();
                          r += 1;
                        }
                        var s = 5 * time,
                          l = s - Math.floor(s),
                          c = createTypedArray('float32', i);
                        if (i > 1) {
                          for (n = 0; n < i; n += 1) c[n] = this.pv[n] + o[n] + (-e + 2 * e * BMMath.random()) * l;
                          return c;
                        }
                        return this.pv + o[0] + (-e + 2 * e * BMMath.random()) * l;
                      }.bind(this);
                    function loopInDuration(t, e) {
                      return loopIn(t, e, !0);
                    }
                    function loopOutDuration(t, e) {
                      return loopOut(t, e, !0);
                    }
                    thisProperty.loopIn && ((loopIn = thisProperty.loopIn.bind(thisProperty)), (loop_in = loopIn)),
                      thisProperty.loopOut &&
                        ((loopOut = thisProperty.loopOut.bind(thisProperty)), (loop_out = loopOut)),
                      thisProperty.smooth && (smooth = thisProperty.smooth.bind(thisProperty)),
                      this.getValueAtTime && (valueAtTime = this.getValueAtTime.bind(this)),
                      this.getVelocityAtTime && (velocityAtTime = this.getVelocityAtTime.bind(this));
                    var comp = elem.comp.globalData.projectInterface.bind(elem.comp.globalData.projectInterface),
                      time,
                      velocity,
                      value,
                      text,
                      textIndex,
                      textTotal,
                      selectorValue;
                    function lookAt(t, e) {
                      var r = [e[0] - t[0], e[1] - t[1], e[2] - t[2]],
                        n = Math.atan2(r[0], Math.sqrt(r[1] * r[1] + r[2] * r[2])) / degToRads;
                      return [-Math.atan2(r[1], r[2]) / degToRads, n, 0];
                    }
                    function easeOut(t, e, r, n, i) {
                      return applyEase(easeOutBez, t, e, r, n, i);
                    }
                    function easeIn(t, e, r, n, i) {
                      return applyEase(easeInBez, t, e, r, n, i);
                    }
                    function ease(t, e, r, n, i) {
                      return applyEase(easeInOutBez, t, e, r, n, i);
                    }
                    function applyEase(t, e, r, n, i, o) {
                      void 0 === i ? ((i = r), (o = n)) : (e = (e - r) / (n - r)), e > 1 ? (e = 1) : e < 0 && (e = 0);
                      var a = t(e);
                      if ($bm_isInstanceOfArray(i)) {
                        var s,
                          l = i.length,
                          c = createTypedArray('float32', l);
                        for (s = 0; s < l; s += 1) c[s] = (o[s] - i[s]) * a + i[s];
                        return c;
                      }
                      return (o - i) * a + i;
                    }
                    function nearestKey(t) {
                      var e,
                        r,
                        n,
                        i = data.k.length;
                      if (data.k.length && 'number' != typeof data.k[0])
                        if (((r = -1), (t *= elem.comp.globalData.frameRate) < data.k[0].t)) (r = 1), (n = data.k[0].t);
                        else {
                          for (e = 0; e < i - 1; e += 1) {
                            if (t === data.k[e].t) {
                              (r = e + 1), (n = data.k[e].t);
                              break;
                            }
                            if (t > data.k[e].t && t < data.k[e + 1].t) {
                              t - data.k[e].t > data.k[e + 1].t - t
                                ? ((r = e + 2), (n = data.k[e + 1].t))
                                : ((r = e + 1), (n = data.k[e].t));
                              break;
                            }
                          }
                          -1 === r && ((r = e + 1), (n = data.k[e].t));
                        }
                      else (r = 0), (n = 0);
                      var o = {};
                      return (o.index = r), (o.time = n / elem.comp.globalData.frameRate), o;
                    }
                    function key(t) {
                      var e, r, n;
                      if (!data.k.length || 'number' == typeof data.k[0])
                        throw new Error('The property has no keyframe at index ' + t);
                      (t -= 1), (e = { time: data.k[t].t / elem.comp.globalData.frameRate, value: [] });
                      var i = Object.prototype.hasOwnProperty.call(data.k[t], 's') ? data.k[t].s : data.k[t - 1].e;
                      for (n = i.length, r = 0; r < n; r += 1) (e[r] = i[r]), (e.value[r] = i[r]);
                      return e;
                    }
                    function framesToTime(t, e) {
                      return e || (e = elem.comp.globalData.frameRate), t / e;
                    }
                    function timeToFrames(t, e) {
                      return t || 0 === t || (t = time), e || (e = elem.comp.globalData.frameRate), t * e;
                    }
                    function seedRandom(t) {
                      BMMath.seedrandom(randSeed + t);
                    }
                    function sourceRectAtTime() {
                      return elem.sourceRectAtTime();
                    }
                    function substring(t, e) {
                      return 'string' == typeof value
                        ? void 0 === e
                          ? value.substring(t)
                          : value.substring(t, e)
                        : '';
                    }
                    function substr(t, e) {
                      return 'string' == typeof value ? (void 0 === e ? value.substr(t) : value.substr(t, e)) : '';
                    }
                    function posterizeTime(t) {
                      (time = 0 === t ? 0 : Math.floor(time * t) / t), (value = valueAtTime(time));
                    }
                    var index = elem.data.ind,
                      hasParent = !(!elem.hierarchy || !elem.hierarchy.length),
                      parent,
                      randSeed = Math.floor(1e6 * Math.random()),
                      globalData = elem.globalData;
                    function executeExpression(t) {
                      return (
                        (value = t),
                        this.frameExpressionId === elem.globalData.frameId && 'textSelector' !== this.propType
                          ? value
                          : ('textSelector' === this.propType &&
                              ((textIndex = this.textIndex),
                              (textTotal = this.textTotal),
                              (selectorValue = this.selectorValue)),
                            thisLayer ||
                              ((text = elem.layerInterface.text),
                              (thisLayer = elem.layerInterface),
                              (thisComp = elem.comp.compInterface),
                              (toWorld = thisLayer.toWorld.bind(thisLayer)),
                              (fromWorld = thisLayer.fromWorld.bind(thisLayer)),
                              (fromComp = thisLayer.fromComp.bind(thisLayer)),
                              (toComp = thisLayer.toComp.bind(thisLayer)),
                              (mask = thisLayer.mask ? thisLayer.mask.bind(thisLayer) : null),
                              (fromCompToSurface = fromComp)),
                            transform ||
                              ((transform = elem.layerInterface('ADBE Transform Group')),
                              ($bm_transform = transform),
                              transform && (anchorPoint = transform.anchorPoint)),
                            4 !== elemType || content || (content = thisLayer('ADBE Root Vectors Group')),
                            effect || (effect = thisLayer(4)),
                            (hasParent = !(!elem.hierarchy || !elem.hierarchy.length)) &&
                              !parent &&
                              (parent = elem.hierarchy[0].layerInterface),
                            (time = this.comp.renderedFrame / this.comp.globalData.frameRate),
                            _needsRandom && seedRandom(randSeed + time),
                            needsVelocity && (velocity = velocityAtTime(time)),
                            expression_function(),
                            (this.frameExpressionId = elem.globalData.frameId),
                            (scoped_bm_rt = scoped_bm_rt.propType === propTypes.SHAPE ? scoped_bm_rt.v : scoped_bm_rt))
                      );
                    }
                    return (
                      (executeExpression.__preventDeadCodeRemoval = [
                        $bm_transform,
                        anchorPoint,
                        time,
                        velocity,
                        inPoint,
                        outPoint,
                        width,
                        height,
                        name,
                        loop_in,
                        loop_out,
                        smooth,
                        toComp,
                        fromCompToSurface,
                        toWorld,
                        fromWorld,
                        mask,
                        position,
                        rotation,
                        scale,
                        thisComp,
                        numKeys,
                        active,
                        wiggle,
                        loopInDuration,
                        loopOutDuration,
                        comp,
                        lookAt,
                        easeOut,
                        easeIn,
                        ease,
                        nearestKey,
                        key,
                        text,
                        textIndex,
                        textTotal,
                        selectorValue,
                        framesToTime,
                        timeToFrames,
                        sourceRectAtTime,
                        substring,
                        substr,
                        posterizeTime,
                        index,
                        globalData,
                      ]),
                      executeExpression
                    );
                  }
                  return (
                    (ob.initiateExpression = initiateExpression),
                    (ob.__preventDeadCodeRemoval = [
                      window,
                      document,
                      XMLHttpRequest,
                      fetch,
                      frames,
                      $bm_neg,
                      add,
                      $bm_sum,
                      $bm_sub,
                      $bm_mul,
                      $bm_div,
                      $bm_mod,
                      clamp,
                      radians_to_degrees,
                      degreesToRadians,
                      degrees_to_radians,
                      normalize,
                      rgbToHsl,
                      hslToRgb,
                      linear,
                      random,
                      createPath,
                    ]),
                    ob
                  );
                })(),
                expressionHelpers = {
                  searchExpressions: function (t, e, r) {
                    e.x &&
                      ((r.k = !0),
                      (r.x = !0),
                      (r.initiateExpression = ExpressionManager.initiateExpression),
                      r.effectsSequence.push(r.initiateExpression(t, e, r).bind(r)));
                  },
                  getSpeedAtTime: function (t) {
                    var e = this.getValueAtTime(t),
                      r = this.getValueAtTime(t + -0.01),
                      n = 0;
                    if (e.length) {
                      var i;
                      for (i = 0; i < e.length; i += 1) n += Math.pow(r[i] - e[i], 2);
                      n = 100 * Math.sqrt(n);
                    } else n = 0;
                    return n;
                  },
                  getVelocityAtTime: function (t) {
                    if (void 0 !== this.vel) return this.vel;
                    var e,
                      r,
                      n = -0.001,
                      i = this.getValueAtTime(t),
                      o = this.getValueAtTime(t + n);
                    if (i.length)
                      for (e = createTypedArray('float32', i.length), r = 0; r < i.length; r += 1)
                        e[r] = (o[r] - i[r]) / n;
                    else e = (o - i) / n;
                    return e;
                  },
                  getValueAtTime: function (t) {
                    return (
                      (t *= this.elem.globalData.frameRate),
                      (t -= this.offsetTime) !== this._cachingAtTime.lastFrame &&
                        ((this._cachingAtTime.lastIndex =
                          this._cachingAtTime.lastFrame < t ? this._cachingAtTime.lastIndex : 0),
                        (this._cachingAtTime.value = this.interpolateValue(t, this._cachingAtTime)),
                        (this._cachingAtTime.lastFrame = t)),
                      this._cachingAtTime.value
                    );
                  },
                  getStaticValueAtTime: function () {
                    return this.pv;
                  },
                  setGroupProperty: function (t) {
                    this.propertyGroup = t;
                  },
                };
              function addPropertyDecorator() {
                function t(t, e, r) {
                  if (!this.k || !this.keyframes) return this.pv;
                  t = t ? t.toLowerCase() : '';
                  var n,
                    i,
                    o,
                    a,
                    s,
                    l = this.comp.renderedFrame,
                    c = this.keyframes,
                    h = c[c.length - 1].t;
                  if (l <= h) return this.pv;
                  if (
                    (r
                      ? (i =
                          h -
                          (n = e
                            ? Math.abs(h - this.elem.comp.globalData.frameRate * e)
                            : Math.max(0, h - this.elem.data.ip)))
                      : ((!e || e > c.length - 1) && (e = c.length - 1), (n = h - (i = c[c.length - 1 - e].t))),
                    'pingpong' === t)
                  ) {
                    if (Math.floor((l - i) / n) % 2 != 0)
                      return this.getValueAtTime((n - ((l - i) % n) + i) / this.comp.globalData.frameRate, 0);
                  } else {
                    if ('offset' === t) {
                      var u = this.getValueAtTime(i / this.comp.globalData.frameRate, 0),
                        p = this.getValueAtTime(h / this.comp.globalData.frameRate, 0),
                        f = this.getValueAtTime((((l - i) % n) + i) / this.comp.globalData.frameRate, 0),
                        d = Math.floor((l - i) / n);
                      if (this.pv.length) {
                        for (a = (s = new Array(u.length)).length, o = 0; o < a; o += 1)
                          s[o] = (p[o] - u[o]) * d + f[o];
                        return s;
                      }
                      return (p - u) * d + f;
                    }
                    if ('continue' === t) {
                      var m = this.getValueAtTime(h / this.comp.globalData.frameRate, 0),
                        y = this.getValueAtTime((h - 0.001) / this.comp.globalData.frameRate, 0);
                      if (this.pv.length) {
                        for (a = (s = new Array(m.length)).length, o = 0; o < a; o += 1)
                          s[o] = m[o] + ((m[o] - y[o]) * ((l - h) / this.comp.globalData.frameRate)) / 5e-4;
                        return s;
                      }
                      return m + ((l - h) / 0.001) * (m - y);
                    }
                  }
                  return this.getValueAtTime((((l - i) % n) + i) / this.comp.globalData.frameRate, 0);
                }
                function e(t, e, r) {
                  if (!this.k) return this.pv;
                  t = t ? t.toLowerCase() : '';
                  var n,
                    i,
                    o,
                    a,
                    s,
                    l = this.comp.renderedFrame,
                    c = this.keyframes,
                    h = c[0].t;
                  if (l >= h) return this.pv;
                  if (
                    (r
                      ? (i =
                          h +
                          (n = e
                            ? Math.abs(this.elem.comp.globalData.frameRate * e)
                            : Math.max(0, this.elem.data.op - h)))
                      : ((!e || e > c.length - 1) && (e = c.length - 1), (n = (i = c[e].t) - h)),
                    'pingpong' === t)
                  ) {
                    if (Math.floor((h - l) / n) % 2 == 0)
                      return this.getValueAtTime((((h - l) % n) + h) / this.comp.globalData.frameRate, 0);
                  } else {
                    if ('offset' === t) {
                      var u = this.getValueAtTime(h / this.comp.globalData.frameRate, 0),
                        p = this.getValueAtTime(i / this.comp.globalData.frameRate, 0),
                        f = this.getValueAtTime((n - ((h - l) % n) + h) / this.comp.globalData.frameRate, 0),
                        d = Math.floor((h - l) / n) + 1;
                      if (this.pv.length) {
                        for (a = (s = new Array(u.length)).length, o = 0; o < a; o += 1)
                          s[o] = f[o] - (p[o] - u[o]) * d;
                        return s;
                      }
                      return f - (p - u) * d;
                    }
                    if ('continue' === t) {
                      var m = this.getValueAtTime(h / this.comp.globalData.frameRate, 0),
                        y = this.getValueAtTime((h + 0.001) / this.comp.globalData.frameRate, 0);
                      if (this.pv.length) {
                        for (a = (s = new Array(m.length)).length, o = 0; o < a; o += 1)
                          s[o] = m[o] + ((m[o] - y[o]) * (h - l)) / 0.001;
                        return s;
                      }
                      return m + ((m - y) * (h - l)) / 0.001;
                    }
                  }
                  return this.getValueAtTime((n - (((h - l) % n) + h)) / this.comp.globalData.frameRate, 0);
                }
                function r(t, e) {
                  if (!this.k) return this.pv;
                  if (((t = 0.5 * (t || 0.4)), (e = Math.floor(e || 5)) <= 1)) return this.pv;
                  var r,
                    n,
                    i = this.comp.renderedFrame / this.comp.globalData.frameRate,
                    o = i - t,
                    a = e > 1 ? (i + t - o) / (e - 1) : 1,
                    s = 0,
                    l = 0;
                  for (r = this.pv.length ? createTypedArray('float32', this.pv.length) : 0; s < e; ) {
                    if (((n = this.getValueAtTime(o + s * a)), this.pv.length))
                      for (l = 0; l < this.pv.length; l += 1) r[l] += n[l];
                    else r += n;
                    s += 1;
                  }
                  if (this.pv.length) for (l = 0; l < this.pv.length; l += 1) r[l] /= e;
                  else r /= e;
                  return r;
                }
                function n(t) {
                  this._transformCachingAtTime || (this._transformCachingAtTime = { v: new Matrix() });
                  var e = this._transformCachingAtTime.v;
                  if ((e.cloneFromProps(this.pre.props), this.appliedTransformations < 1)) {
                    var r = this.a.getValueAtTime(t);
                    e.translate(-r[0] * this.a.mult, -r[1] * this.a.mult, r[2] * this.a.mult);
                  }
                  if (this.appliedTransformations < 2) {
                    var n = this.s.getValueAtTime(t);
                    e.scale(n[0] * this.s.mult, n[1] * this.s.mult, n[2] * this.s.mult);
                  }
                  if (this.sk && this.appliedTransformations < 3) {
                    var i = this.sk.getValueAtTime(t),
                      o = this.sa.getValueAtTime(t);
                    e.skewFromAxis(-i * this.sk.mult, o * this.sa.mult);
                  }
                  if (this.r && this.appliedTransformations < 4) {
                    var a = this.r.getValueAtTime(t);
                    e.rotate(-a * this.r.mult);
                  } else if (!this.r && this.appliedTransformations < 4) {
                    var s = this.rz.getValueAtTime(t),
                      l = this.ry.getValueAtTime(t),
                      c = this.rx.getValueAtTime(t),
                      h = this.or.getValueAtTime(t);
                    e.rotateZ(-s * this.rz.mult)
                      .rotateY(l * this.ry.mult)
                      .rotateX(c * this.rx.mult)
                      .rotateZ(-h[2] * this.or.mult)
                      .rotateY(h[1] * this.or.mult)
                      .rotateX(h[0] * this.or.mult);
                  }
                  if (this.data.p && this.data.p.s) {
                    var u = this.px.getValueAtTime(t),
                      p = this.py.getValueAtTime(t);
                    if (this.data.p.z) {
                      var f = this.pz.getValueAtTime(t);
                      e.translate(u * this.px.mult, p * this.py.mult, -f * this.pz.mult);
                    } else e.translate(u * this.px.mult, p * this.py.mult, 0);
                  } else {
                    var d = this.p.getValueAtTime(t);
                    e.translate(d[0] * this.p.mult, d[1] * this.p.mult, -d[2] * this.p.mult);
                  }
                  return e;
                }
                function i() {
                  return this.v.clone(new Matrix());
                }
                var o = TransformPropertyFactory.getTransformProperty;
                TransformPropertyFactory.getTransformProperty = function (t, e, r) {
                  var a = o(t, e, r);
                  return (
                    a.dynamicProperties.length ? (a.getValueAtTime = n.bind(a)) : (a.getValueAtTime = i.bind(a)),
                    (a.setGroupProperty = expressionHelpers.setGroupProperty),
                    a
                  );
                };
                var a = PropertyFactory.getProp;
                PropertyFactory.getProp = function (n, i, o, s, l) {
                  var c = a(n, i, o, s, l);
                  c.kf
                    ? (c.getValueAtTime = expressionHelpers.getValueAtTime.bind(c))
                    : (c.getValueAtTime = expressionHelpers.getStaticValueAtTime.bind(c)),
                    (c.setGroupProperty = expressionHelpers.setGroupProperty),
                    (c.loopOut = t),
                    (c.loopIn = e),
                    (c.smooth = r),
                    (c.getVelocityAtTime = expressionHelpers.getVelocityAtTime.bind(c)),
                    (c.getSpeedAtTime = expressionHelpers.getSpeedAtTime.bind(c)),
                    (c.numKeys = 1 === i.a ? i.k.length : 0),
                    (c.propertyIndex = i.ix);
                  var h = 0;
                  return (
                    0 !== o && (h = createTypedArray('float32', 1 === i.a ? i.k[0].s.length : i.k.length)),
                    (c._cachingAtTime = { lastFrame: initialDefaultFrame, lastIndex: 0, value: h }),
                    expressionHelpers.searchExpressions(n, i, c),
                    c.k && l.addDynamicProperty(c),
                    c
                  );
                };
                var s = ShapePropertyFactory.getConstructorFunction(),
                  l = ShapePropertyFactory.getKeyframedConstructorFunction();
                function c() {}
                (c.prototype = {
                  vertices: function (t, e) {
                    this.k && this.getValue();
                    var r,
                      n = this.v;
                    void 0 !== e && (n = this.getValueAtTime(e, 0));
                    var i = n._length,
                      o = n[t],
                      a = n.v,
                      s = createSizedArray(i);
                    for (r = 0; r < i; r += 1)
                      s[r] = 'i' === t || 'o' === t ? [o[r][0] - a[r][0], o[r][1] - a[r][1]] : [o[r][0], o[r][1]];
                    return s;
                  },
                  points: function (t) {
                    return this.vertices('v', t);
                  },
                  inTangents: function (t) {
                    return this.vertices('i', t);
                  },
                  outTangents: function (t) {
                    return this.vertices('o', t);
                  },
                  isClosed: function () {
                    return this.v.c;
                  },
                  pointOnPath: function (t, e) {
                    var r = this.v;
                    void 0 !== e && (r = this.getValueAtTime(e, 0)),
                      this._segmentsLength || (this._segmentsLength = bez.getSegmentsLength(r));
                    for (
                      var n, i = this._segmentsLength, o = i.lengths, a = i.totalLength * t, s = 0, l = o.length, c = 0;
                      s < l;

                    ) {
                      if (c + o[s].addedLength > a) {
                        var h = s,
                          u = r.c && s === l - 1 ? 0 : s + 1,
                          p = (a - c) / o[s].addedLength;
                        n = bez.getPointInSegment(r.v[h], r.v[u], r.o[h], r.i[u], p, o[s]);
                        break;
                      }
                      (c += o[s].addedLength), (s += 1);
                    }
                    return n || (n = r.c ? [r.v[0][0], r.v[0][1]] : [r.v[r._length - 1][0], r.v[r._length - 1][1]]), n;
                  },
                  vectorOnPath: function (t, e, r) {
                    1 == t ? (t = this.v.c) : 0 == t && (t = 0.999);
                    var n = this.pointOnPath(t, e),
                      i = this.pointOnPath(t + 0.001, e),
                      o = i[0] - n[0],
                      a = i[1] - n[1],
                      s = Math.sqrt(Math.pow(o, 2) + Math.pow(a, 2));
                    return 0 === s ? [0, 0] : 'tangent' === r ? [o / s, a / s] : [-a / s, o / s];
                  },
                  tangentOnPath: function (t, e) {
                    return this.vectorOnPath(t, e, 'tangent');
                  },
                  normalOnPath: function (t, e) {
                    return this.vectorOnPath(t, e, 'normal');
                  },
                  setGroupProperty: expressionHelpers.setGroupProperty,
                  getValueAtTime: expressionHelpers.getStaticValueAtTime,
                }),
                  extendPrototype([c], s),
                  extendPrototype([c], l),
                  (l.prototype.getValueAtTime = function (t) {
                    return (
                      this._cachingAtTime ||
                        (this._cachingAtTime = {
                          shapeValue: shapePool.clone(this.pv),
                          lastIndex: 0,
                          lastTime: initialDefaultFrame,
                        }),
                      (t *= this.elem.globalData.frameRate),
                      (t -= this.offsetTime) !== this._cachingAtTime.lastTime &&
                        ((this._cachingAtTime.lastIndex =
                          this._cachingAtTime.lastTime < t ? this._caching.lastIndex : 0),
                        (this._cachingAtTime.lastTime = t),
                        this.interpolateShape(t, this._cachingAtTime.shapeValue, this._cachingAtTime)),
                      this._cachingAtTime.shapeValue
                    );
                  }),
                  (l.prototype.initiateExpression = ExpressionManager.initiateExpression);
                var h = ShapePropertyFactory.getShapeProp;
                ShapePropertyFactory.getShapeProp = function (t, e, r, n, i) {
                  var o = h(t, e, r, n, i);
                  return (
                    (o.propertyIndex = e.ix),
                    (o.lock = !1),
                    3 === r
                      ? expressionHelpers.searchExpressions(t, e.pt, o)
                      : 4 === r && expressionHelpers.searchExpressions(t, e.ks, o),
                    o.k && t.addDynamicProperty(o),
                    o
                  );
                };
              }
              function initialize$1() {
                addPropertyDecorator();
              }
              function addDecorator() {
                (TextProperty.prototype.getExpressionValue = function (t, e) {
                  var r = this.calculateExpression(e);
                  if (t.t !== r) {
                    var n = {};
                    return this.copyData(n, t), (n.t = r.toString()), (n.__complete = !1), n;
                  }
                  return t;
                }),
                  (TextProperty.prototype.searchProperty = function () {
                    var t = this.searchKeyframes(),
                      e = this.searchExpressions();
                    return (this.kf = t || e), this.kf;
                  }),
                  (TextProperty.prototype.searchExpressions = function () {
                    return this.data.d.x
                      ? ((this.calculateExpression = ExpressionManager.initiateExpression.bind(this)(
                          this.elem,
                          this.data.d,
                          this,
                        )),
                        this.addEffect(this.getExpressionValue.bind(this)),
                        !0)
                      : null;
                  });
              }
              function initialize() {
                addDecorator();
              }
              function SVGComposableEffect() {}
              function SVGTintFilter(t, e, r, n, i) {
                this.filterManager = e;
                var o = createNS('feColorMatrix');
                o.setAttribute('type', 'matrix'),
                  o.setAttribute('color-interpolation-filters', 'linearRGB'),
                  o.setAttribute(
                    'values',
                    '0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0',
                  ),
                  o.setAttribute('result', n + '_tint_1'),
                  t.appendChild(o),
                  (o = createNS('feColorMatrix')).setAttribute('type', 'matrix'),
                  o.setAttribute('color-interpolation-filters', 'sRGB'),
                  o.setAttribute('values', '1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0'),
                  o.setAttribute('result', n + '_tint_2'),
                  t.appendChild(o),
                  (this.matrixFilter = o);
                var a = this.createMergeNode(n, [i, n + '_tint_1', n + '_tint_2']);
                t.appendChild(a);
              }
              function SVGFillFilter(t, e, r, n) {
                this.filterManager = e;
                var i = createNS('feColorMatrix');
                i.setAttribute('type', 'matrix'),
                  i.setAttribute('color-interpolation-filters', 'sRGB'),
                  i.setAttribute('values', '1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0'),
                  i.setAttribute('result', n),
                  t.appendChild(i),
                  (this.matrixFilter = i);
              }
              function SVGStrokeEffect(t, e, r) {
                (this.initialized = !1), (this.filterManager = e), (this.elem = r), (this.paths = []);
              }
              function SVGTritoneFilter(t, e, r, n) {
                this.filterManager = e;
                var i = createNS('feColorMatrix');
                i.setAttribute('type', 'matrix'),
                  i.setAttribute('color-interpolation-filters', 'linearRGB'),
                  i.setAttribute(
                    'values',
                    '0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0',
                  ),
                  t.appendChild(i);
                var o = createNS('feComponentTransfer');
                o.setAttribute('color-interpolation-filters', 'sRGB'),
                  o.setAttribute('result', n),
                  (this.matrixFilter = o);
                var a = createNS('feFuncR');
                a.setAttribute('type', 'table'), o.appendChild(a), (this.feFuncR = a);
                var s = createNS('feFuncG');
                s.setAttribute('type', 'table'), o.appendChild(s), (this.feFuncG = s);
                var l = createNS('feFuncB');
                l.setAttribute('type', 'table'), o.appendChild(l), (this.feFuncB = l), t.appendChild(o);
              }
              function SVGProLevelsFilter(t, e, r, n) {
                this.filterManager = e;
                var i = this.filterManager.effectElements,
                  o = createNS('feComponentTransfer');
                (i[10].p.k ||
                  0 !== i[10].p.v ||
                  i[11].p.k ||
                  1 !== i[11].p.v ||
                  i[12].p.k ||
                  1 !== i[12].p.v ||
                  i[13].p.k ||
                  0 !== i[13].p.v ||
                  i[14].p.k ||
                  1 !== i[14].p.v) &&
                  (this.feFuncR = this.createFeFunc('feFuncR', o)),
                  (i[17].p.k ||
                    0 !== i[17].p.v ||
                    i[18].p.k ||
                    1 !== i[18].p.v ||
                    i[19].p.k ||
                    1 !== i[19].p.v ||
                    i[20].p.k ||
                    0 !== i[20].p.v ||
                    i[21].p.k ||
                    1 !== i[21].p.v) &&
                    (this.feFuncG = this.createFeFunc('feFuncG', o)),
                  (i[24].p.k ||
                    0 !== i[24].p.v ||
                    i[25].p.k ||
                    1 !== i[25].p.v ||
                    i[26].p.k ||
                    1 !== i[26].p.v ||
                    i[27].p.k ||
                    0 !== i[27].p.v ||
                    i[28].p.k ||
                    1 !== i[28].p.v) &&
                    (this.feFuncB = this.createFeFunc('feFuncB', o)),
                  (i[31].p.k ||
                    0 !== i[31].p.v ||
                    i[32].p.k ||
                    1 !== i[32].p.v ||
                    i[33].p.k ||
                    1 !== i[33].p.v ||
                    i[34].p.k ||
                    0 !== i[34].p.v ||
                    i[35].p.k ||
                    1 !== i[35].p.v) &&
                    (this.feFuncA = this.createFeFunc('feFuncA', o)),
                  (this.feFuncR || this.feFuncG || this.feFuncB || this.feFuncA) &&
                    (o.setAttribute('color-interpolation-filters', 'sRGB'), t.appendChild(o)),
                  (i[3].p.k ||
                    0 !== i[3].p.v ||
                    i[4].p.k ||
                    1 !== i[4].p.v ||
                    i[5].p.k ||
                    1 !== i[5].p.v ||
                    i[6].p.k ||
                    0 !== i[6].p.v ||
                    i[7].p.k ||
                    1 !== i[7].p.v) &&
                    ((o = createNS('feComponentTransfer')).setAttribute('color-interpolation-filters', 'sRGB'),
                    o.setAttribute('result', n),
                    t.appendChild(o),
                    (this.feFuncRComposed = this.createFeFunc('feFuncR', o)),
                    (this.feFuncGComposed = this.createFeFunc('feFuncG', o)),
                    (this.feFuncBComposed = this.createFeFunc('feFuncB', o)));
              }
              function SVGDropShadowEffect(t, e, r, n, i) {
                var o = e.container.globalData.renderConfig.filterSize,
                  a = e.data.fs || o;
                t.setAttribute('x', a.x || o.x),
                  t.setAttribute('y', a.y || o.y),
                  t.setAttribute('width', a.width || o.width),
                  t.setAttribute('height', a.height || o.height),
                  (this.filterManager = e);
                var s = createNS('feGaussianBlur');
                s.setAttribute('in', 'SourceAlpha'),
                  s.setAttribute('result', n + '_drop_shadow_1'),
                  s.setAttribute('stdDeviation', '0'),
                  (this.feGaussianBlur = s),
                  t.appendChild(s);
                var l = createNS('feOffset');
                l.setAttribute('dx', '25'),
                  l.setAttribute('dy', '0'),
                  l.setAttribute('in', n + '_drop_shadow_1'),
                  l.setAttribute('result', n + '_drop_shadow_2'),
                  (this.feOffset = l),
                  t.appendChild(l);
                var c = createNS('feFlood');
                c.setAttribute('flood-color', '#00ff00'),
                  c.setAttribute('flood-opacity', '1'),
                  c.setAttribute('result', n + '_drop_shadow_3'),
                  (this.feFlood = c),
                  t.appendChild(c);
                var h = createNS('feComposite');
                h.setAttribute('in', n + '_drop_shadow_3'),
                  h.setAttribute('in2', n + '_drop_shadow_2'),
                  h.setAttribute('operator', 'in'),
                  h.setAttribute('result', n + '_drop_shadow_4'),
                  t.appendChild(h);
                var u = this.createMergeNode(n, [n + '_drop_shadow_4', i]);
                t.appendChild(u);
              }
              (SVGComposableEffect.prototype = {
                createMergeNode: function (t, e) {
                  var r,
                    n,
                    i = createNS('feMerge');
                  for (i.setAttribute('result', t), n = 0; n < e.length; n += 1)
                    (r = createNS('feMergeNode')).setAttribute('in', e[n]), i.appendChild(r), i.appendChild(r);
                  return i;
                },
              }),
                extendPrototype([SVGComposableEffect], SVGTintFilter),
                (SVGTintFilter.prototype.renderFrame = function (t) {
                  if (t || this.filterManager._mdf) {
                    var e = this.filterManager.effectElements[0].p.v,
                      r = this.filterManager.effectElements[1].p.v,
                      n = this.filterManager.effectElements[2].p.v / 100;
                    this.matrixFilter.setAttribute(
                      'values',
                      r[0] -
                        e[0] +
                        ' 0 0 0 ' +
                        e[0] +
                        ' ' +
                        (r[1] - e[1]) +
                        ' 0 0 0 ' +
                        e[1] +
                        ' ' +
                        (r[2] - e[2]) +
                        ' 0 0 0 ' +
                        e[2] +
                        ' 0 0 0 ' +
                        n +
                        ' 0',
                    );
                  }
                }),
                (SVGFillFilter.prototype.renderFrame = function (t) {
                  if (t || this.filterManager._mdf) {
                    var e = this.filterManager.effectElements[2].p.v,
                      r = this.filterManager.effectElements[6].p.v;
                    this.matrixFilter.setAttribute(
                      'values',
                      '0 0 0 0 ' + e[0] + ' 0 0 0 0 ' + e[1] + ' 0 0 0 0 ' + e[2] + ' 0 0 0 ' + r + ' 0',
                    );
                  }
                }),
                (SVGStrokeEffect.prototype.initialize = function () {
                  var t,
                    e,
                    r,
                    n,
                    i = this.elem.layerElement.children || this.elem.layerElement.childNodes;
                  for (
                    1 === this.filterManager.effectElements[1].p.v
                      ? ((n = this.elem.maskManager.masksProperties.length), (r = 0))
                      : (n = 1 + (r = this.filterManager.effectElements[0].p.v - 1)),
                      (e = createNS('g')).setAttribute('fill', 'none'),
                      e.setAttribute('stroke-linecap', 'round'),
                      e.setAttribute('stroke-dashoffset', 1);
                    r < n;
                    r += 1
                  )
                    (t = createNS('path')), e.appendChild(t), this.paths.push({ p: t, m: r });
                  if (3 === this.filterManager.effectElements[10].p.v) {
                    var o = createNS('mask'),
                      a = createElementID();
                    o.setAttribute('id', a),
                      o.setAttribute('mask-type', 'alpha'),
                      o.appendChild(e),
                      this.elem.globalData.defs.appendChild(o);
                    var s = createNS('g');
                    for (s.setAttribute('mask', 'url(' + getLocationHref() + '#' + a + ')'); i[0]; )
                      s.appendChild(i[0]);
                    this.elem.layerElement.appendChild(s), (this.masker = o), e.setAttribute('stroke', '#fff');
                  } else if (
                    1 === this.filterManager.effectElements[10].p.v ||
                    2 === this.filterManager.effectElements[10].p.v
                  ) {
                    if (2 === this.filterManager.effectElements[10].p.v)
                      for (i = this.elem.layerElement.children || this.elem.layerElement.childNodes; i.length; )
                        this.elem.layerElement.removeChild(i[0]);
                    this.elem.layerElement.appendChild(e),
                      this.elem.layerElement.removeAttribute('mask'),
                      e.setAttribute('stroke', '#fff');
                  }
                  (this.initialized = !0), (this.pathMasker = e);
                }),
                (SVGStrokeEffect.prototype.renderFrame = function (t) {
                  var e;
                  this.initialized || this.initialize();
                  var r,
                    n,
                    i = this.paths.length;
                  for (e = 0; e < i; e += 1)
                    if (
                      -1 !== this.paths[e].m &&
                      ((r = this.elem.maskManager.viewData[this.paths[e].m]),
                      (n = this.paths[e].p),
                      (t || this.filterManager._mdf || r.prop._mdf) && n.setAttribute('d', r.lastPath),
                      t ||
                        this.filterManager.effectElements[9].p._mdf ||
                        this.filterManager.effectElements[4].p._mdf ||
                        this.filterManager.effectElements[7].p._mdf ||
                        this.filterManager.effectElements[8].p._mdf ||
                        r.prop._mdf)
                    ) {
                      var o;
                      if (
                        0 !== this.filterManager.effectElements[7].p.v ||
                        100 !== this.filterManager.effectElements[8].p.v
                      ) {
                        var a =
                            0.01 *
                            Math.min(
                              this.filterManager.effectElements[7].p.v,
                              this.filterManager.effectElements[8].p.v,
                            ),
                          s =
                            0.01 *
                            Math.max(
                              this.filterManager.effectElements[7].p.v,
                              this.filterManager.effectElements[8].p.v,
                            ),
                          l = n.getTotalLength();
                        o = '0 0 0 ' + l * a + ' ';
                        var c,
                          h = l * (s - a),
                          u =
                            1 +
                            2 *
                              this.filterManager.effectElements[4].p.v *
                              this.filterManager.effectElements[9].p.v *
                              0.01,
                          p = Math.floor(h / u);
                        for (c = 0; c < p; c += 1)
                          o +=
                            '1 ' +
                            2 *
                              this.filterManager.effectElements[4].p.v *
                              this.filterManager.effectElements[9].p.v *
                              0.01 +
                            ' ';
                        o += '0 ' + 10 * l + ' 0 0';
                      } else
                        o =
                          '1 ' +
                          2 *
                            this.filterManager.effectElements[4].p.v *
                            this.filterManager.effectElements[9].p.v *
                            0.01;
                      n.setAttribute('stroke-dasharray', o);
                    }
                  if (
                    ((t || this.filterManager.effectElements[4].p._mdf) &&
                      this.pathMasker.setAttribute('stroke-width', 2 * this.filterManager.effectElements[4].p.v),
                    (t || this.filterManager.effectElements[6].p._mdf) &&
                      this.pathMasker.setAttribute('opacity', this.filterManager.effectElements[6].p.v),
                    (1 === this.filterManager.effectElements[10].p.v ||
                      2 === this.filterManager.effectElements[10].p.v) &&
                      (t || this.filterManager.effectElements[3].p._mdf))
                  ) {
                    var f = this.filterManager.effectElements[3].p.v;
                    this.pathMasker.setAttribute(
                      'stroke',
                      'rgb(' + bmFloor(255 * f[0]) + ',' + bmFloor(255 * f[1]) + ',' + bmFloor(255 * f[2]) + ')',
                    );
                  }
                }),
                (SVGTritoneFilter.prototype.renderFrame = function (t) {
                  if (t || this.filterManager._mdf) {
                    var e = this.filterManager.effectElements[0].p.v,
                      r = this.filterManager.effectElements[1].p.v,
                      n = this.filterManager.effectElements[2].p.v,
                      i = n[0] + ' ' + r[0] + ' ' + e[0],
                      o = n[1] + ' ' + r[1] + ' ' + e[1],
                      a = n[2] + ' ' + r[2] + ' ' + e[2];
                    this.feFuncR.setAttribute('tableValues', i),
                      this.feFuncG.setAttribute('tableValues', o),
                      this.feFuncB.setAttribute('tableValues', a);
                  }
                }),
                (SVGProLevelsFilter.prototype.createFeFunc = function (t, e) {
                  var r = createNS(t);
                  return r.setAttribute('type', 'table'), e.appendChild(r), r;
                }),
                (SVGProLevelsFilter.prototype.getTableValue = function (t, e, r, n, i) {
                  for (
                    var o,
                      a,
                      s = 0,
                      l = Math.min(t, e),
                      c = Math.max(t, e),
                      h = Array.call(null, { length: 256 }),
                      u = 0,
                      p = i - n,
                      f = e - t;
                    s <= 256;

                  )
                    (a =
                      (o = s / 256) <= l
                        ? f < 0
                          ? i
                          : n
                        : o >= c
                        ? f < 0
                          ? n
                          : i
                        : n + p * Math.pow((o - t) / f, 1 / r)),
                      (h[u] = a),
                      (u += 1),
                      (s += 256 / 255);
                  return h.join(' ');
                }),
                (SVGProLevelsFilter.prototype.renderFrame = function (t) {
                  if (t || this.filterManager._mdf) {
                    var e,
                      r = this.filterManager.effectElements;
                    this.feFuncRComposed &&
                      (t || r[3].p._mdf || r[4].p._mdf || r[5].p._mdf || r[6].p._mdf || r[7].p._mdf) &&
                      ((e = this.getTableValue(r[3].p.v, r[4].p.v, r[5].p.v, r[6].p.v, r[7].p.v)),
                      this.feFuncRComposed.setAttribute('tableValues', e),
                      this.feFuncGComposed.setAttribute('tableValues', e),
                      this.feFuncBComposed.setAttribute('tableValues', e)),
                      this.feFuncR &&
                        (t || r[10].p._mdf || r[11].p._mdf || r[12].p._mdf || r[13].p._mdf || r[14].p._mdf) &&
                        ((e = this.getTableValue(r[10].p.v, r[11].p.v, r[12].p.v, r[13].p.v, r[14].p.v)),
                        this.feFuncR.setAttribute('tableValues', e)),
                      this.feFuncG &&
                        (t || r[17].p._mdf || r[18].p._mdf || r[19].p._mdf || r[20].p._mdf || r[21].p._mdf) &&
                        ((e = this.getTableValue(r[17].p.v, r[18].p.v, r[19].p.v, r[20].p.v, r[21].p.v)),
                        this.feFuncG.setAttribute('tableValues', e)),
                      this.feFuncB &&
                        (t || r[24].p._mdf || r[25].p._mdf || r[26].p._mdf || r[27].p._mdf || r[28].p._mdf) &&
                        ((e = this.getTableValue(r[24].p.v, r[25].p.v, r[26].p.v, r[27].p.v, r[28].p.v)),
                        this.feFuncB.setAttribute('tableValues', e)),
                      this.feFuncA &&
                        (t || r[31].p._mdf || r[32].p._mdf || r[33].p._mdf || r[34].p._mdf || r[35].p._mdf) &&
                        ((e = this.getTableValue(r[31].p.v, r[32].p.v, r[33].p.v, r[34].p.v, r[35].p.v)),
                        this.feFuncA.setAttribute('tableValues', e));
                  }
                }),
                extendPrototype([SVGComposableEffect], SVGDropShadowEffect),
                (SVGDropShadowEffect.prototype.renderFrame = function (t) {
                  if (t || this.filterManager._mdf) {
                    if (
                      ((t || this.filterManager.effectElements[4].p._mdf) &&
                        this.feGaussianBlur.setAttribute('stdDeviation', this.filterManager.effectElements[4].p.v / 4),
                      t || this.filterManager.effectElements[0].p._mdf)
                    ) {
                      var e = this.filterManager.effectElements[0].p.v;
                      this.feFlood.setAttribute(
                        'flood-color',
                        rgbToHex(Math.round(255 * e[0]), Math.round(255 * e[1]), Math.round(255 * e[2])),
                      );
                    }
                    if (
                      ((t || this.filterManager.effectElements[1].p._mdf) &&
                        this.feFlood.setAttribute('flood-opacity', this.filterManager.effectElements[1].p.v / 255),
                      t || this.filterManager.effectElements[2].p._mdf || this.filterManager.effectElements[3].p._mdf)
                    ) {
                      var r = this.filterManager.effectElements[3].p.v,
                        n = (this.filterManager.effectElements[2].p.v - 90) * degToRads,
                        i = r * Math.cos(n),
                        o = r * Math.sin(n);
                      this.feOffset.setAttribute('dx', i), this.feOffset.setAttribute('dy', o);
                    }
                  }
                });
              var _svgMatteSymbols = [];
              function SVGMatte3Effect(t, e, r) {
                (this.initialized = !1),
                  (this.filterManager = e),
                  (this.filterElem = t),
                  (this.elem = r),
                  (r.matteElement = createNS('g')),
                  r.matteElement.appendChild(r.layerElement),
                  r.matteElement.appendChild(r.transformedElement),
                  (r.baseElement = r.matteElement);
              }
              function SVGGaussianBlurEffect(t, e, r, n) {
                t.setAttribute('x', '-100%'),
                  t.setAttribute('y', '-100%'),
                  t.setAttribute('width', '300%'),
                  t.setAttribute('height', '300%'),
                  (this.filterManager = e);
                var i = createNS('feGaussianBlur');
                i.setAttribute('result', n), t.appendChild(i), (this.feGaussianBlur = i);
              }
              return (
                (SVGMatte3Effect.prototype.findSymbol = function (t) {
                  for (var e = 0, r = _svgMatteSymbols.length; e < r; ) {
                    if (_svgMatteSymbols[e] === t) return _svgMatteSymbols[e];
                    e += 1;
                  }
                  return null;
                }),
                (SVGMatte3Effect.prototype.replaceInParent = function (t, e) {
                  var r = t.layerElement.parentNode;
                  if (r) {
                    for (var n, i = r.children, o = 0, a = i.length; o < a && i[o] !== t.layerElement; ) o += 1;
                    o <= a - 2 && (n = i[o + 1]);
                    var s = createNS('use');
                    s.setAttribute('href', '#' + e), n ? r.insertBefore(s, n) : r.appendChild(s);
                  }
                }),
                (SVGMatte3Effect.prototype.setElementAsMask = function (t, e) {
                  if (!this.findSymbol(e)) {
                    var r = createElementID(),
                      n = createNS('mask');
                    n.setAttribute('id', e.layerId), n.setAttribute('mask-type', 'alpha'), _svgMatteSymbols.push(e);
                    var i = t.globalData.defs;
                    i.appendChild(n);
                    var o = createNS('symbol');
                    o.setAttribute('id', r),
                      this.replaceInParent(e, r),
                      o.appendChild(e.layerElement),
                      i.appendChild(o);
                    var a = createNS('use');
                    a.setAttribute('href', '#' + r), n.appendChild(a), (e.data.hd = !1), e.show();
                  }
                  t.setMatte(e.layerId);
                }),
                (SVGMatte3Effect.prototype.initialize = function () {
                  for (
                    var t = this.filterManager.effectElements[0].p.v, e = this.elem.comp.elements, r = 0, n = e.length;
                    r < n;

                  )
                    e[r] && e[r].data.ind === t && this.setElementAsMask(this.elem, e[r]), (r += 1);
                  this.initialized = !0;
                }),
                (SVGMatte3Effect.prototype.renderFrame = function () {
                  this.initialized || this.initialize();
                }),
                (SVGGaussianBlurEffect.prototype.renderFrame = function (t) {
                  if (t || this.filterManager._mdf) {
                    var e = 0.3 * this.filterManager.effectElements[0].p.v,
                      r = this.filterManager.effectElements[1].p.v,
                      n = 3 == r ? 0 : e,
                      i = 2 == r ? 0 : e;
                    this.feGaussianBlur.setAttribute('stdDeviation', n + ' ' + i);
                    var o = 1 == this.filterManager.effectElements[2].p.v ? 'wrap' : 'duplicate';
                    this.feGaussianBlur.setAttribute('edgeMode', o);
                  }
                }),
                registerRenderer('canvas', CanvasRenderer),
                registerRenderer('html', HybridRenderer),
                registerRenderer('svg', SVGRenderer),
                ShapeModifiers.registerModifier('tm', TrimModifier),
                ShapeModifiers.registerModifier('pb', PuckerAndBloatModifier),
                ShapeModifiers.registerModifier('rp', RepeaterModifier),
                ShapeModifiers.registerModifier('rd', RoundCornersModifier),
                ShapeModifiers.registerModifier('zz', ZigZagModifier),
                ShapeModifiers.registerModifier('op', OffsetPathModifier),
                setExpressionsPlugin(Expressions),
                setExpressionInterfaces(getInterface),
                initialize$1(),
                initialize(),
                registerEffect(20, SVGTintFilter, !0),
                registerEffect(21, SVGFillFilter, !0),
                registerEffect(22, SVGStrokeEffect, !1),
                registerEffect(23, SVGTritoneFilter, !0),
                registerEffect(24, SVGProLevelsFilter, !0),
                registerEffect(25, SVGDropShadowEffect, !0),
                registerEffect(28, SVGMatte3Effect, !1),
                registerEffect(29, SVGGaussianBlurEffect, !0),
                lottie
              );
            }),
            (module.exports = factory()));
        })(lottie$1, lottie$1.exports);
        var lottie = lottie$1.exports,
          _templateObject$1,
          styles = r$3(
            _templateObject$1 ||
              (_templateObject$1 = _taggedTemplateLiteral([
                '\n  * {\n    box-sizing: border-box;\n  }\n\n  :host {\n    --lottie-player-toolbar-height: 35px;\n    --lottie-player-toolbar-background-color: transparent;\n    --lottie-player-toolbar-icon-color: #999;\n    --lottie-player-toolbar-icon-hover-color: #222;\n    --lottie-player-toolbar-icon-active-color: #555;\n    --lottie-player-seeker-track-color: #ccc;\n    --lottie-player-seeker-thumb-color: rgba(0, 107, 120, 0.8);\n    --lottie-player-seeker-display: block;\n\n    display: block;\n    width: 100%;\n    height: 100%;\n  }\n\n  .main {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    width: 100%;\n  }\n\n  .animation {\n    width: 100%;\n    height: 100%;\n    display: flex;\n  }\n  .animation.controls {\n    height: calc(100% - 35px);\n  }\n\n  .toolbar {\n    display: flex;\n    align-items: center;\n    justify-items: center;\n    background-color: var(--lottie-player-toolbar-background-color);\n    margin: 0 5px;\n    height: 35px;\n  }\n\n  .toolbar button {\n    cursor: pointer;\n    fill: var(--lottie-player-toolbar-icon-color);\n    display: flex;\n    background: none;\n    border: 0;\n    padding: 0;\n    outline: none;\n    height: 100%;\n  }\n\n  .toolbar button:hover {\n    fill: var(--lottie-player-toolbar-icon-hover-color);\n  }\n\n  .toolbar button.active {\n    fill: var(--lottie-player-toolbar-icon-active-color);\n  }\n\n  .toolbar button.active:hover {\n    fill: var(--lottie-player-toolbar-icon-hover-color);\n  }\n\n  .toolbar button:focus {\n    outline: 1px dotted var(--lottie-player-toolbar-icon-active-color);\n  }\n\n  .toolbar button svg {\n  }\n\n  .toolbar button.disabled svg {\n    display: none;\n  }\n\n  .seeker {\n    -webkit-appearance: none;\n    width: 95%;\n    outline: none;\n    background-color: var(--lottie-player-toolbar-background-color);\n    display: var(--lottie-player-seeker-display);\n  }\n\n  .seeker::-webkit-slider-runnable-track {\n    width: 100%;\n    height: 5px;\n    cursor: pointer;\n    background: var(--lottie-player-seeker-track-color);\n    border-radius: 3px;\n  }\n  .seeker::-webkit-slider-thumb {\n    height: 15px;\n    width: 15px;\n    border-radius: 50%;\n    background: var(--lottie-player-seeker-thumb-color);\n    cursor: pointer;\n    -webkit-appearance: none;\n    margin-top: -5px;\n  }\n  .seeker:focus::-webkit-slider-runnable-track {\n    background: #999;\n  }\n  .seeker::-moz-range-track {\n    width: 100%;\n    height: 5px;\n    cursor: pointer;\n    background: var(--lottie-player-seeker-track-color);\n    border-radius: 3px;\n  }\n  .seeker::-moz-range-thumb {\n    height: 15px;\n    width: 15px;\n    border-radius: 50%;\n    background: var(--lottie-player-seeker-thumb-color);\n    cursor: pointer;\n  }\n  .seeker::-ms-track {\n    width: 100%;\n    height: 5px;\n    cursor: pointer;\n    background: transparent;\n    border-color: transparent;\n    color: transparent;\n  }\n  .seeker::-ms-fill-lower {\n    background: var(--lottie-player-seeker-track-color);\n    border-radius: 3px;\n  }\n  .seeker::-ms-fill-upper {\n    background: var(--lottie-player-seeker-track-color);\n    border-radius: 3px;\n  }\n  .seeker::-ms-thumb {\n    border: 0;\n    height: 15px;\n    width: 15px;\n    border-radius: 50%;\n    background: var(--lottie-player-seeker-thumb-color);\n    cursor: pointer;\n  }\n  .seeker:focus::-ms-fill-lower {\n    background: var(--lottie-player-seeker-track-color);\n  }\n  .seeker:focus::-ms-fill-upper {\n    background: var(--lottie-player-seeker-track-color);\n  }\n\n  .error {\n    display: flex;\n    justify-content: center;\n    height: 100%;\n    align-items: center;\n  }\n',
              ])),
          ),
          LOTTIE_PLAYER_VERSION = '2.0.2',
          LOTTIE_WEB_VERSION = '^5.10.0',
          _templateObject,
          _templateObject2,
          _templateObject3,
          _templateObject4,
          _templateObject5,
          PlayerState,
          PlayMode,
          PlayerEvents;
        function parseSrc(t) {
          if ('object' == typeof t) return t;
          try {
            return JSON.parse(t);
          } catch (e) {
            return new URL(t, window.location.href).toString();
          }
        }
        function isLottie(t) {
          return ['v', 'ip', 'op', 'layers', 'fr', 'w', 'h'].every((e) => Object.prototype.hasOwnProperty.call(t, e));
        }
        function fromURL(t) {
          return _fromURL.apply(this, arguments);
        }
        function _fromURL() {
          return (_fromURL = _asyncToGenerator(function* (t) {
            if ('string' != typeof t) throw new Error('The url value must be a string');
            var e;
            try {
              var r = new URL(t),
                n = yield fetch(r.toString());
              e = yield n.json();
            } catch (t) {
              throw new Error('An error occurred while trying to load the Lottie file from URL');
            }
            return e;
          })).apply(this, arguments);
        }
        !(function (t) {
          (t.Destroyed = 'destroyed'),
            (t.Error = 'error'),
            (t.Frozen = 'frozen'),
            (t.Loading = 'loading'),
            (t.Paused = 'paused'),
            (t.Playing = 'playing'),
            (t.Stopped = 'stopped');
        })(PlayerState || (PlayerState = {})),
          (function (t) {
            (t.Bounce = 'bounce'), (t.Normal = 'normal');
          })(PlayMode || (PlayMode = {})),
          (function (t) {
            (t.Complete = 'complete'),
              (t.Destroyed = 'destroyed'),
              (t.Error = 'error'),
              (t.Frame = 'frame'),
              (t.Freeze = 'freeze'),
              (t.Load = 'load'),
              (t.Loop = 'loop'),
              (t.Pause = 'pause'),
              (t.Play = 'play'),
              (t.Ready = 'ready'),
              (t.Rendered = 'rendered'),
              (t.Stop = 'stop');
          })(PlayerEvents || (PlayerEvents = {}));
        var LottiePlayer = class extends s {
          constructor() {
            super(...arguments),
              (this.autoplay = !1),
              (this.background = 'transparent'),
              (this.controls = !1),
              (this.currentState = PlayerState.Loading),
              (this.description = 'Lottie animation'),
              (this.direction = 1),
              (this.disableCheck = !1),
              (this.disableShadowDOM = !1),
              (this.hover = !1),
              (this.intermission = 1),
              (this.loop = !1),
              (this.mode = PlayMode.Normal),
              (this.preserveAspectRatio = 'xMidYMid meet'),
              (this.renderer = 'svg'),
              (this.speed = 1),
              (this._io = void 0),
              (this._counter = 1);
          }
          load(t) {
            var e = this;
            return _asyncToGenerator(function* () {
              var r = {
                container: e.container,
                loop: !1,
                autoplay: !1,
                renderer: e.renderer,
                rendererSettings: Object.assign(
                  {
                    preserveAspectRatio: e.preserveAspectRatio,
                    clearCanvas: !1,
                    progressiveLoad: !0,
                    hideOnTransparent: !0,
                  },
                  e.viewBoxSize && { viewBoxSize: e.viewBoxSize },
                ),
              };
              try {
                var n = parseSrc(t),
                  i = {},
                  o = 'string' == typeof n ? 'path' : 'animationData';
                e._lottie && e._lottie.destroy(),
                  e.webworkers && lottie$1.exports.useWebWorker(!0),
                  (e._lottie = lottie$1.exports.loadAnimation(Object.assign(Object.assign({}, r), { [o]: n }))),
                  e._attachEventListeners(),
                  e.disableCheck ||
                    ('path' === o ? ((i = yield fromURL(n)), (o = 'animationData')) : (i = n),
                    isLottie(i) ||
                      ((e.currentState = PlayerState.Error), e.dispatchEvent(new CustomEvent(PlayerEvents.Error))));
              } catch (t) {
                (e.currentState = PlayerState.Error), e.dispatchEvent(new CustomEvent(PlayerEvents.Error));
              }
            })();
          }
          getLottie() {
            return this._lottie;
          }
          getVersions() {
            return { lottieWebVersion: LOTTIE_WEB_VERSION, lottiePlayerVersion: LOTTIE_PLAYER_VERSION };
          }
          play() {
            this._lottie &&
              (this._lottie.play(),
              (this.currentState = PlayerState.Playing),
              this.dispatchEvent(new CustomEvent(PlayerEvents.Play)));
          }
          pause() {
            this._lottie &&
              (this._lottie.pause(),
              (this.currentState = PlayerState.Paused),
              this.dispatchEvent(new CustomEvent(PlayerEvents.Pause)));
          }
          stop() {
            this._lottie &&
              ((this._counter = 1),
              this._lottie.stop(),
              (this.currentState = PlayerState.Stopped),
              this.dispatchEvent(new CustomEvent(PlayerEvents.Stop)));
          }
          destroy() {
            this._lottie &&
              (this._lottie.destroy(),
              (this._lottie = null),
              (this.currentState = PlayerState.Destroyed),
              this.dispatchEvent(new CustomEvent(PlayerEvents.Destroyed)),
              this.remove());
          }
          seek(t) {
            if (this._lottie) {
              var e = /^(\d+)(%?)$/.exec(t.toString());
              if (e) {
                var r = '%' === e[2] ? (this._lottie.totalFrames * Number(e[1])) / 100 : Number(e[1]);
                (this.seeker = r),
                  this.currentState === PlayerState.Playing
                    ? this._lottie.goToAndPlay(r, !0)
                    : (this._lottie.goToAndStop(r, !0), this._lottie.pause());
              }
            }
          }
          snapshot() {
            var t = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
            if (this.shadowRoot) {
              var e = this.shadowRoot.querySelector('.animation svg'),
                r = new XMLSerializer().serializeToString(e);
              if (t) {
                var n = document.createElement('a');
                (n.href = 'data:image/svg+xml;charset=utf-8,'.concat(encodeURIComponent(r))),
                  (n.download = 'download_'.concat(this.seeker, '.svg')),
                  document.body.appendChild(n),
                  n.click(),
                  document.body.removeChild(n);
              }
              return r;
            }
          }
          setSpeed() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1;
            this._lottie && this._lottie.setSpeed(t);
          }
          setDirection(t) {
            this._lottie && this._lottie.setDirection(t);
          }
          setLooping(t) {
            this._lottie && ((this.loop = t), (this._lottie.loop = t));
          }
          togglePlay() {
            return this.currentState === PlayerState.Playing ? this.pause() : this.play();
          }
          toggleLooping() {
            this.setLooping(!this.loop);
          }
          resize() {
            this._lottie && this._lottie.resize();
          }
          static get styles() {
            return styles;
          }
          disconnectedCallback() {
            this.isConnected ||
              (this._io && (this._io.disconnect(), (this._io = void 0)),
              document.removeEventListener('visibilitychange', () => this._onVisibilityChange()),
              this.destroy());
          }
          render() {
            var t = this.controls ? 'main controls' : 'main',
              e = this.controls ? 'animation controls' : 'animation';
            return $(
              _templateObject ||
                (_templateObject = _taggedTemplateLiteral([
                  ' <div\n      id="animation-container"\n      class=',
                  '\n      lang="en"\n      aria-label=',
                  '\n      role="img"\n    >\n      <div\n        id="animation"\n        class=',
                  '\n        style="background:',
                  ';"\n      >\n        ',
                  '\n      </div>\n      ',
                  '\n    </div>',
                ])),
              t,
              this.description,
              e,
              this.background,
              this.currentState === PlayerState.Error
                ? $(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(['<div class="error">⚠️</div>'])))
                : void 0,
              this.controls && !this.disableShadowDOM ? this.renderControls() : void 0,
            );
          }
          createRenderRoot() {
            return (
              this.disableShadowDOM && (this.style.display = 'block'),
              this.disableShadowDOM ? this : super.createRenderRoot()
            );
          }
          firstUpdated() {
            'IntersectionObserver' in window &&
              ((this._io = new IntersectionObserver((t) => {
                t[0].isIntersecting
                  ? this.currentState === PlayerState.Frozen && this.play()
                  : this.currentState === PlayerState.Playing && this.freeze();
              })),
              this._io.observe(this.container)),
              void 0 !== document.hidden &&
                document.addEventListener('visibilitychange', () => this._onVisibilityChange()),
              this.src && this.load(this.src),
              this.dispatchEvent(new CustomEvent(PlayerEvents.Rendered));
          }
          renderControls() {
            var t = this.currentState === PlayerState.Playing,
              e = this.currentState === PlayerState.Paused,
              r = this.currentState === PlayerState.Stopped;
            return $(
              _templateObject3 ||
                (_templateObject3 = _taggedTemplateLiteral([
                  '\n      <div\n        id="lottie-controls"\n        aria-label="lottie-animation-controls"\n        class="toolbar"\n      >\n        <button\n          id="lottie-play-button"\n          @click=',
                  '\n          class=',
                  '\n          style="align-items:center;"\n          tabindex="0"\n          aria-label="play-pause"\n        >\n          ',
                  '\n        </button>\n        <button\n          id="lottie-stop-button"\n          @click=',
                  '\n          class=',
                  '\n          style="align-items:center;"\n          tabindex="0"\n          aria-label="stop"\n        >\n          <svg width="24" height="24" aria-hidden="true" focusable="false">\n            <path d="M6 6h12v12H6V6z" />\n          </svg>\n        </button>\n        <input\n          id="lottie-seeker-input"\n          class="seeker"\n          type="range"\n          min="0"\n          step="1"\n          max="100"\n          .value=',
                  '\n          @input=',
                  '\n          @mousedown=',
                  '\n          @mouseup=',
                  '\n          aria-valuemin="1"\n          aria-valuemax="100"\n          role="slider"\n          aria-valuenow=',
                  '\n          tabindex="0"\n          aria-label="lottie-seek-input"\n        />\n        <button\n          id="lottie-loop-toggle"\n          @click=',
                  '\n          class=',
                  '\n          style="align-items:center;"\n          tabindex="0"\n          aria-label="loop-toggle"\n        >\n          <svg width="24" height="24" aria-hidden="true" focusable="false">\n            <path\n              d="M17.016 17.016v-4.031h1.969v6h-12v3l-3.984-3.984 3.984-3.984v3h10.031zM6.984 6.984v4.031H5.015v-6h12v-3l3.984 3.984-3.984 3.984v-3H6.984z"\n            />\n          </svg>\n        </button>\n      </div>\n    ',
                ])),
              this.togglePlay,
              t || e ? 'active' : '',
              $(
                t
                  ? _templateObject4 ||
                      (_templateObject4 = _taggedTemplateLiteral([
                        '<svg\n                width="24"\n                height="24"\n                aria-hidden="true"\n                focusable="false"\n              >\n                <path\n                  d="M14.016 5.016H18v13.969h-3.984V5.016zM6 18.984V5.015h3.984v13.969H6z"\n                />\n              </svg>',
                      ]))
                  : _templateObject5 ||
                      (_templateObject5 = _taggedTemplateLiteral([
                        '<svg\n                width="24"\n                height="24"\n                aria-hidden="true"\n                focusable="false"\n              >\n                <path d="M8.016 5.016L18.985 12 8.016 18.984V5.015z" />\n              </svg>',
                      ])),
              ),
              this.stop,
              r ? 'active' : '',
              this.seeker,
              this._handleSeekChange,
              () => {
                (this._prevState = this.currentState), this.freeze();
              },
              () => {
                this._prevState === PlayerState.Playing && this.play();
              },
              this.seeker,
              this.toggleLooping,
              this.loop ? 'active' : '',
            );
          }
          _onVisibilityChange() {
            !0 === document.hidden && this.currentState === PlayerState.Playing
              ? this.freeze()
              : this.currentState === PlayerState.Frozen && this.play();
          }
          _handleSeekChange(t) {
            if (this._lottie && !isNaN(t.target.value)) {
              var e = (t.target.value / 100) * this._lottie.totalFrames;
              this.seek(e);
            }
          }
          _attachEventListeners() {
            this._lottie.addEventListener('enterFrame', () => {
              (this.seeker = (this._lottie.currentFrame / this._lottie.totalFrames) * 100),
                this.dispatchEvent(
                  new CustomEvent(PlayerEvents.Frame, {
                    detail: { frame: this._lottie.currentFrame, seeker: this.seeker },
                  }),
                );
            }),
              this._lottie.addEventListener('complete', () => {
                if (this.currentState === PlayerState.Playing) {
                  if (!this.loop || (this.count && this._counter >= this.count)) {
                    if ((this.dispatchEvent(new CustomEvent(PlayerEvents.Complete)), this.mode !== PlayMode.Bounce))
                      return;
                    if (0 === this._lottie.currentFrame) return;
                  }
                  this.mode === PlayMode.Bounce
                    ? (this.count && (this._counter += 0.5),
                      setTimeout(() => {
                        this.dispatchEvent(new CustomEvent(PlayerEvents.Loop)),
                          this.currentState === PlayerState.Playing &&
                            (this._lottie.setDirection(-1 * this._lottie.playDirection), this._lottie.play());
                      }, this.intermission))
                    : (this.count && (this._counter += 1),
                      window.setTimeout(() => {
                        this.dispatchEvent(new CustomEvent(PlayerEvents.Loop)),
                          this.currentState === PlayerState.Playing &&
                            (-1 === this.direction
                              ? (this.seek('99%'), this.play())
                              : (this._lottie.stop(), this._lottie.play()));
                      }, this.intermission));
                } else this.dispatchEvent(new CustomEvent(PlayerEvents.Complete));
              }),
              this._lottie.addEventListener('DOMLoaded', () => {
                this.setSpeed(this.speed),
                  this.setDirection(this.direction),
                  this.autoplay && (-1 === this.direction && this.seek('100%'), this.play()),
                  this.dispatchEvent(new CustomEvent(PlayerEvents.Ready));
              }),
              this._lottie.addEventListener('data_ready', () => {
                this.dispatchEvent(new CustomEvent(PlayerEvents.Load));
              }),
              this._lottie.addEventListener('data_failed', () => {
                (this.currentState = PlayerState.Error), this.dispatchEvent(new CustomEvent(PlayerEvents.Error));
              }),
              this.container.addEventListener('mouseenter', () => {
                this.hover && this.currentState !== PlayerState.Playing && this.play();
              }),
              this.container.addEventListener('mouseleave', () => {
                this.hover && this.currentState === PlayerState.Playing && this.stop();
              });
          }
          freeze() {
            this._lottie &&
              (this._lottie.pause(),
              (this.currentState = PlayerState.Frozen),
              this.dispatchEvent(new CustomEvent(PlayerEvents.Freeze)));
          }
        };
        __decorate([e$5({ type: Boolean })], LottiePlayer.prototype, 'autoplay', void 0),
          __decorate([e$5({ type: String, reflect: !0 })], LottiePlayer.prototype, 'background', void 0),
          __decorate([e$5({ type: Boolean })], LottiePlayer.prototype, 'controls', void 0),
          __decorate([e$5({ type: Number })], LottiePlayer.prototype, 'count', void 0),
          __decorate([e$5({ type: String })], LottiePlayer.prototype, 'currentState', void 0),
          __decorate([e$5({ type: String })], LottiePlayer.prototype, 'description', void 0),
          __decorate([e$5({ type: Number })], LottiePlayer.prototype, 'direction', void 0),
          __decorate([e$5({ type: Boolean })], LottiePlayer.prototype, 'disableCheck', void 0),
          __decorate([e$5({ type: Boolean })], LottiePlayer.prototype, 'disableShadowDOM', void 0),
          __decorate([e$5({ type: Boolean })], LottiePlayer.prototype, 'hover', void 0),
          __decorate([e$5()], LottiePlayer.prototype, 'intermission', void 0),
          __decorate([e$5({ type: Boolean, reflect: !0 })], LottiePlayer.prototype, 'loop', void 0),
          __decorate([e$5()], LottiePlayer.prototype, 'mode', void 0),
          __decorate([e$5({ type: String })], LottiePlayer.prototype, 'preserveAspectRatio', void 0),
          __decorate([e$5({ type: String })], LottiePlayer.prototype, 'renderer', void 0),
          __decorate([e$5({ type: String })], LottiePlayer.prototype, 'viewBoxSize', void 0),
          __decorate([e$5()], LottiePlayer.prototype, 'seeker', void 0),
          __decorate([e$5({ type: Number })], LottiePlayer.prototype, 'speed', void 0),
          __decorate([e$5({ type: String })], LottiePlayer.prototype, 'src', void 0),
          __decorate([e$5({ type: Boolean })], LottiePlayer.prototype, 'webworkers', void 0),
          __decorate([i('.animation')], LottiePlayer.prototype, 'container', void 0),
          (LottiePlayer = __decorate([n$1('lottie-player')], LottiePlayer));
      },
      755: function (t, e) {
        var r;
        !(function (e, r) {
          'use strict';
          'object' == typeof t.exports
            ? (t.exports = e.document
                ? r(e, !0)
                : function (t) {
                    if (!t.document) throw new Error('jQuery requires a window with a document');
                    return r(t);
                  })
            : r(e);
        })('undefined' != typeof window ? window : this, function (n, i) {
          'use strict';
          var o = [],
            a = Object.getPrototypeOf,
            s = o.slice,
            l = o.flat
              ? function (t) {
                  return o.flat.call(t);
                }
              : function (t) {
                  return o.concat.apply([], t);
                },
            c = o.push,
            h = o.indexOf,
            u = {},
            p = u.toString,
            f = u.hasOwnProperty,
            d = f.toString,
            m = d.call(Object),
            y = {},
            g = function (t) {
              return 'function' == typeof t && 'number' != typeof t.nodeType && 'function' != typeof t.item;
            },
            v = function (t) {
              return null != t && t === t.window;
            },
            b = n.document,
            x = { type: !0, src: !0, nonce: !0, noModule: !0 };
          function E(t, e, r) {
            var n,
              i,
              o = (r = r || b).createElement('script');
            if (((o.text = t), e))
              for (n in x) (i = e[n] || (e.getAttribute && e.getAttribute(n))) && o.setAttribute(n, i);
            r.head.appendChild(o).parentNode.removeChild(o);
          }
          function w(t) {
            return null == t
              ? t + ''
              : 'object' == typeof t || 'function' == typeof t
              ? u[p.call(t)] || 'object'
              : typeof t;
          }
          var _ = '3.6.0',
            S = function (t, e) {
              return new S.fn.init(t, e);
            };
          function P(t) {
            var e = !!t && 'length' in t && t.length,
              r = w(t);
            return !g(t) && !v(t) && ('array' === r || 0 === e || ('number' == typeof e && e > 0 && e - 1 in t));
          }
          (S.fn = S.prototype =
            {
              jquery: _,
              constructor: S,
              length: 0,
              toArray: function () {
                return s.call(this);
              },
              get: function (t) {
                return null == t ? s.call(this) : t < 0 ? this[t + this.length] : this[t];
              },
              pushStack: function (t) {
                var e = S.merge(this.constructor(), t);
                return (e.prevObject = this), e;
              },
              each: function (t) {
                return S.each(this, t);
              },
              map: function (t) {
                return this.pushStack(
                  S.map(this, function (e, r) {
                    return t.call(e, r, e);
                  }),
                );
              },
              slice: function () {
                return this.pushStack(s.apply(this, arguments));
              },
              first: function () {
                return this.eq(0);
              },
              last: function () {
                return this.eq(-1);
              },
              even: function () {
                return this.pushStack(
                  S.grep(this, function (t, e) {
                    return (e + 1) % 2;
                  }),
                );
              },
              odd: function () {
                return this.pushStack(
                  S.grep(this, function (t, e) {
                    return e % 2;
                  }),
                );
              },
              eq: function (t) {
                var e = this.length,
                  r = +t + (t < 0 ? e : 0);
                return this.pushStack(r >= 0 && r < e ? [this[r]] : []);
              },
              end: function () {
                return this.prevObject || this.constructor();
              },
              push: c,
              sort: o.sort,
              splice: o.splice,
            }),
            (S.extend = S.fn.extend =
              function () {
                var t,
                  e,
                  r,
                  n,
                  i,
                  o,
                  a = arguments[0] || {},
                  s = 1,
                  l = arguments.length,
                  c = !1;
                for (
                  'boolean' == typeof a && ((c = a), (a = arguments[s] || {}), s++),
                    'object' == typeof a || g(a) || (a = {}),
                    s === l && ((a = this), s--);
                  s < l;
                  s++
                )
                  if (null != (t = arguments[s]))
                    for (e in t)
                      (n = t[e]),
                        '__proto__' !== e &&
                          a !== n &&
                          (c && n && (S.isPlainObject(n) || (i = Array.isArray(n)))
                            ? ((r = a[e]),
                              (o = i && !Array.isArray(r) ? [] : i || S.isPlainObject(r) ? r : {}),
                              (i = !1),
                              (a[e] = S.extend(c, o, n)))
                            : void 0 !== n && (a[e] = n));
                return a;
              }),
            S.extend({
              expando: 'jQuery' + (_ + Math.random()).replace(/\D/g, ''),
              isReady: !0,
              error: function (t) {
                throw new Error(t);
              },
              noop: function () {},
              isPlainObject: function (t) {
                var e, r;
                return !(
                  !t ||
                  '[object Object]' !== p.call(t) ||
                  ((e = a(t)) &&
                    ('function' != typeof (r = f.call(e, 'constructor') && e.constructor) || d.call(r) !== m))
                );
              },
              isEmptyObject: function (t) {
                var e;
                for (e in t) return !1;
                return !0;
              },
              globalEval: function (t, e, r) {
                E(t, { nonce: e && e.nonce }, r);
              },
              each: function (t, e) {
                var r,
                  n = 0;
                if (P(t)) for (r = t.length; n < r && !1 !== e.call(t[n], n, t[n]); n++);
                else for (n in t) if (!1 === e.call(t[n], n, t[n])) break;
                return t;
              },
              makeArray: function (t, e) {
                var r = e || [];
                return null != t && (P(Object(t)) ? S.merge(r, 'string' == typeof t ? [t] : t) : c.call(r, t)), r;
              },
              inArray: function (t, e, r) {
                return null == e ? -1 : h.call(e, t, r);
              },
              merge: function (t, e) {
                for (var r = +e.length, n = 0, i = t.length; n < r; n++) t[i++] = e[n];
                return (t.length = i), t;
              },
              grep: function (t, e, r) {
                for (var n = [], i = 0, o = t.length, a = !r; i < o; i++) !e(t[i], i) !== a && n.push(t[i]);
                return n;
              },
              map: function (t, e, r) {
                var n,
                  i,
                  o = 0,
                  a = [];
                if (P(t)) for (n = t.length; o < n; o++) null != (i = e(t[o], o, r)) && a.push(i);
                else for (o in t) null != (i = e(t[o], o, r)) && a.push(i);
                return l(a);
              },
              guid: 1,
              support: y,
            }),
            'function' == typeof Symbol && (S.fn[Symbol.iterator] = o[Symbol.iterator]),
            S.each('Boolean Number String Function Array Date RegExp Object Error Symbol'.split(' '), function (t, e) {
              u['[object ' + e + ']'] = e.toLowerCase();
            });
          var A = (function (t) {
            var e,
              r,
              n,
              i,
              o,
              a,
              s,
              l,
              c,
              h,
              u,
              p,
              f,
              d,
              m,
              y,
              g,
              v,
              b,
              x = 'sizzle' + 1 * new Date(),
              E = t.document,
              w = 0,
              _ = 0,
              S = lt(),
              P = lt(),
              A = lt(),
              C = lt(),
              T = function (t, e) {
                return t === e && (u = !0), 0;
              },
              k = {}.hasOwnProperty,
              D = [],
              M = D.pop,
              I = D.push,
              F = D.push,
              L = D.slice,
              R = function (t, e) {
                for (var r = 0, n = t.length; r < n; r++) if (t[r] === e) return r;
                return -1;
              },
              O =
                'checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped',
              B = '[\\x20\\t\\r\\n\\f]',
              j = '(?:\\\\[\\da-fA-F]{1,6}[\\x20\\t\\r\\n\\f]?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+',
              N =
                '\\[[\\x20\\t\\r\\n\\f]*(' +
                j +
                ')(?:' +
                B +
                '*([*^$|!~]?=)' +
                B +
                '*(?:\'((?:\\\\.|[^\\\\\'])*)\'|"((?:\\\\.|[^\\\\"])*)"|(' +
                j +
                '))|)' +
                B +
                '*\\]',
              V =
                ':(' +
                j +
                ')(?:\\(((\'((?:\\\\.|[^\\\\\'])*)\'|"((?:\\\\.|[^\\\\"])*)")|((?:\\\\.|[^\\\\()[\\]]|' +
                N +
                ')*)|.*)\\)|)',
              z = new RegExp(B + '+', 'g'),
              $ = new RegExp('^[\\x20\\t\\r\\n\\f]+|((?:^|[^\\\\])(?:\\\\.)*)[\\x20\\t\\r\\n\\f]+$', 'g'),
              q = new RegExp('^[\\x20\\t\\r\\n\\f]*,[\\x20\\t\\r\\n\\f]*'),
              H = new RegExp('^[\\x20\\t\\r\\n\\f]*([>+~]|[\\x20\\t\\r\\n\\f])[\\x20\\t\\r\\n\\f]*'),
              G = new RegExp(B + '|>'),
              W = new RegExp(V),
              U = new RegExp('^' + j + '$'),
              X = {
                ID: new RegExp('^#(' + j + ')'),
                CLASS: new RegExp('^\\.(' + j + ')'),
                TAG: new RegExp('^(' + j + '|[*])'),
                ATTR: new RegExp('^' + N),
                PSEUDO: new RegExp('^' + V),
                CHILD: new RegExp(
                  '^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\([\\x20\\t\\r\\n\\f]*(even|odd|(([+-]|)(\\d*)n|)[\\x20\\t\\r\\n\\f]*(?:([+-]|)[\\x20\\t\\r\\n\\f]*(\\d+)|))[\\x20\\t\\r\\n\\f]*\\)|)',
                  'i',
                ),
                bool: new RegExp('^(?:' + O + ')$', 'i'),
                needsContext: new RegExp(
                  '^[\\x20\\t\\r\\n\\f]*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\([\\x20\\t\\r\\n\\f]*((?:-\\d)?\\d*)[\\x20\\t\\r\\n\\f]*\\)|)(?=[^-]|$)',
                  'i',
                ),
              },
              Y = /HTML$/i,
              K = /^(?:input|select|textarea|button)$/i,
              Z = /^h\d$/i,
              J = /^[^{]+\{\s*\[native \w/,
              Q = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
              tt = /[+~]/,
              et = new RegExp('\\\\[\\da-fA-F]{1,6}[\\x20\\t\\r\\n\\f]?|\\\\([^\\r\\n\\f])', 'g'),
              rt = function (t, e) {
                var r = '0x' + t.slice(1) - 65536;
                return (
                  e ||
                  (r < 0 ? String.fromCharCode(r + 65536) : String.fromCharCode((r >> 10) | 55296, (1023 & r) | 56320))
                );
              },
              nt = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
              it = function (t, e) {
                return e
                  ? '\0' === t
                    ? '�'
                    : t.slice(0, -1) + '\\' + t.charCodeAt(t.length - 1).toString(16) + ' '
                  : '\\' + t;
              },
              ot = function () {
                p();
              },
              at = xt(
                function (t) {
                  return !0 === t.disabled && 'fieldset' === t.nodeName.toLowerCase();
                },
                { dir: 'parentNode', next: 'legend' },
              );
            try {
              F.apply((D = L.call(E.childNodes)), E.childNodes), D[E.childNodes.length].nodeType;
            } catch (t) {
              F = {
                apply: D.length
                  ? function (t, e) {
                      I.apply(t, L.call(e));
                    }
                  : function (t, e) {
                      for (var r = t.length, n = 0; (t[r++] = e[n++]); );
                      t.length = r - 1;
                    },
              };
            }
            function st(t, e, n, i) {
              var o,
                s,
                c,
                h,
                u,
                d,
                g,
                v = e && e.ownerDocument,
                E = e ? e.nodeType : 9;
              if (((n = n || []), 'string' != typeof t || !t || (1 !== E && 9 !== E && 11 !== E))) return n;
              if (!i && (p(e), (e = e || f), m)) {
                if (11 !== E && (u = Q.exec(t)))
                  if ((o = u[1])) {
                    if (9 === E) {
                      if (!(c = e.getElementById(o))) return n;
                      if (c.id === o) return n.push(c), n;
                    } else if (v && (c = v.getElementById(o)) && b(e, c) && c.id === o) return n.push(c), n;
                  } else {
                    if (u[2]) return F.apply(n, e.getElementsByTagName(t)), n;
                    if ((o = u[3]) && r.getElementsByClassName && e.getElementsByClassName)
                      return F.apply(n, e.getElementsByClassName(o)), n;
                  }
                if (r.qsa && !C[t + ' '] && (!y || !y.test(t)) && (1 !== E || 'object' !== e.nodeName.toLowerCase())) {
                  if (((g = t), (v = e), 1 === E && (G.test(t) || H.test(t)))) {
                    for (
                      ((v = (tt.test(t) && gt(e.parentNode)) || e) === e && r.scope) ||
                        ((h = e.getAttribute('id')) ? (h = h.replace(nt, it)) : e.setAttribute('id', (h = x))),
                        s = (d = a(t)).length;
                      s--;

                    )
                      d[s] = (h ? '#' + h : ':scope') + ' ' + bt(d[s]);
                    g = d.join(',');
                  }
                  try {
                    return F.apply(n, v.querySelectorAll(g)), n;
                  } catch (e) {
                    C(t, !0);
                  } finally {
                    h === x && e.removeAttribute('id');
                  }
                }
              }
              return l(t.replace($, '$1'), e, n, i);
            }
            function lt() {
              var t = [];
              return function e(r, i) {
                return t.push(r + ' ') > n.cacheLength && delete e[t.shift()], (e[r + ' '] = i);
              };
            }
            function ct(t) {
              return (t[x] = !0), t;
            }
            function ht(t) {
              var e = f.createElement('fieldset');
              try {
                return !!t(e);
              } catch (t) {
                return !1;
              } finally {
                e.parentNode && e.parentNode.removeChild(e), (e = null);
              }
            }
            function ut(t, e) {
              for (var r = t.split('|'), i = r.length; i--; ) n.attrHandle[r[i]] = e;
            }
            function pt(t, e) {
              var r = e && t,
                n = r && 1 === t.nodeType && 1 === e.nodeType && t.sourceIndex - e.sourceIndex;
              if (n) return n;
              if (r) for (; (r = r.nextSibling); ) if (r === e) return -1;
              return t ? 1 : -1;
            }
            function ft(t) {
              return function (e) {
                return 'input' === e.nodeName.toLowerCase() && e.type === t;
              };
            }
            function dt(t) {
              return function (e) {
                var r = e.nodeName.toLowerCase();
                return ('input' === r || 'button' === r) && e.type === t;
              };
            }
            function mt(t) {
              return function (e) {
                return 'form' in e
                  ? e.parentNode && !1 === e.disabled
                    ? 'label' in e
                      ? 'label' in e.parentNode
                        ? e.parentNode.disabled === t
                        : e.disabled === t
                      : e.isDisabled === t || (e.isDisabled !== !t && at(e) === t)
                    : e.disabled === t
                  : 'label' in e && e.disabled === t;
              };
            }
            function yt(t) {
              return ct(function (e) {
                return (
                  (e = +e),
                  ct(function (r, n) {
                    for (var i, o = t([], r.length, e), a = o.length; a--; ) r[(i = o[a])] && (r[i] = !(n[i] = r[i]));
                  })
                );
              });
            }
            function gt(t) {
              return t && void 0 !== t.getElementsByTagName && t;
            }
            for (e in ((r = st.support = {}),
            (o = st.isXML =
              function (t) {
                var e = t && t.namespaceURI,
                  r = t && (t.ownerDocument || t).documentElement;
                return !Y.test(e || (r && r.nodeName) || 'HTML');
              }),
            (p = st.setDocument =
              function (t) {
                var e,
                  i,
                  a = t ? t.ownerDocument || t : E;
                return a != f && 9 === a.nodeType && a.documentElement
                  ? ((d = (f = a).documentElement),
                    (m = !o(f)),
                    E != f &&
                      (i = f.defaultView) &&
                      i.top !== i &&
                      (i.addEventListener
                        ? i.addEventListener('unload', ot, !1)
                        : i.attachEvent && i.attachEvent('onunload', ot)),
                    (r.scope = ht(function (t) {
                      return (
                        d.appendChild(t).appendChild(f.createElement('div')),
                        void 0 !== t.querySelectorAll && !t.querySelectorAll(':scope fieldset div').length
                      );
                    })),
                    (r.attributes = ht(function (t) {
                      return (t.className = 'i'), !t.getAttribute('className');
                    })),
                    (r.getElementsByTagName = ht(function (t) {
                      return t.appendChild(f.createComment('')), !t.getElementsByTagName('*').length;
                    })),
                    (r.getElementsByClassName = J.test(f.getElementsByClassName)),
                    (r.getById = ht(function (t) {
                      return (d.appendChild(t).id = x), !f.getElementsByName || !f.getElementsByName(x).length;
                    })),
                    r.getById
                      ? ((n.filter.ID = function (t) {
                          var e = t.replace(et, rt);
                          return function (t) {
                            return t.getAttribute('id') === e;
                          };
                        }),
                        (n.find.ID = function (t, e) {
                          if (void 0 !== e.getElementById && m) {
                            var r = e.getElementById(t);
                            return r ? [r] : [];
                          }
                        }))
                      : ((n.filter.ID = function (t) {
                          var e = t.replace(et, rt);
                          return function (t) {
                            var r = void 0 !== t.getAttributeNode && t.getAttributeNode('id');
                            return r && r.value === e;
                          };
                        }),
                        (n.find.ID = function (t, e) {
                          if (void 0 !== e.getElementById && m) {
                            var r,
                              n,
                              i,
                              o = e.getElementById(t);
                            if (o) {
                              if ((r = o.getAttributeNode('id')) && r.value === t) return [o];
                              for (i = e.getElementsByName(t), n = 0; (o = i[n++]); )
                                if ((r = o.getAttributeNode('id')) && r.value === t) return [o];
                            }
                            return [];
                          }
                        })),
                    (n.find.TAG = r.getElementsByTagName
                      ? function (t, e) {
                          return void 0 !== e.getElementsByTagName
                            ? e.getElementsByTagName(t)
                            : r.qsa
                            ? e.querySelectorAll(t)
                            : void 0;
                        }
                      : function (t, e) {
                          var r,
                            n = [],
                            i = 0,
                            o = e.getElementsByTagName(t);
                          if ('*' === t) {
                            for (; (r = o[i++]); ) 1 === r.nodeType && n.push(r);
                            return n;
                          }
                          return o;
                        }),
                    (n.find.CLASS =
                      r.getElementsByClassName &&
                      function (t, e) {
                        if (void 0 !== e.getElementsByClassName && m) return e.getElementsByClassName(t);
                      }),
                    (g = []),
                    (y = []),
                    (r.qsa = J.test(f.querySelectorAll)) &&
                      (ht(function (t) {
                        var e;
                        (d.appendChild(t).innerHTML =
                          "<a id='" +
                          x +
                          "'></a><select id='" +
                          x +
                          "-\r\\' msallowcapture=''><option selected=''></option></select>"),
                          t.querySelectorAll("[msallowcapture^='']").length &&
                            y.push('[*^$]=[\\x20\\t\\r\\n\\f]*(?:\'\'|"")'),
                          t.querySelectorAll('[selected]').length ||
                            y.push('\\[[\\x20\\t\\r\\n\\f]*(?:value|' + O + ')'),
                          t.querySelectorAll('[id~=' + x + '-]').length || y.push('~='),
                          (e = f.createElement('input')).setAttribute('name', ''),
                          t.appendChild(e),
                          t.querySelectorAll("[name='']").length ||
                            y.push('\\[[\\x20\\t\\r\\n\\f]*name[\\x20\\t\\r\\n\\f]*=[\\x20\\t\\r\\n\\f]*(?:\'\'|"")'),
                          t.querySelectorAll(':checked').length || y.push(':checked'),
                          t.querySelectorAll('a#' + x + '+*').length || y.push('.#.+[+~]'),
                          t.querySelectorAll('\\\f'),
                          y.push('[\\r\\n\\f]');
                      }),
                      ht(function (t) {
                        t.innerHTML =
                          "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                        var e = f.createElement('input');
                        e.setAttribute('type', 'hidden'),
                          t.appendChild(e).setAttribute('name', 'D'),
                          t.querySelectorAll('[name=d]').length && y.push('name[\\x20\\t\\r\\n\\f]*[*^$|!~]?='),
                          2 !== t.querySelectorAll(':enabled').length && y.push(':enabled', ':disabled'),
                          (d.appendChild(t).disabled = !0),
                          2 !== t.querySelectorAll(':disabled').length && y.push(':enabled', ':disabled'),
                          t.querySelectorAll('*,:x'),
                          y.push(',.*:');
                      })),
                    (r.matchesSelector = J.test(
                      (v =
                        d.matches ||
                        d.webkitMatchesSelector ||
                        d.mozMatchesSelector ||
                        d.oMatchesSelector ||
                        d.msMatchesSelector),
                    )) &&
                      ht(function (t) {
                        (r.disconnectedMatch = v.call(t, '*')), v.call(t, "[s!='']:x"), g.push('!=', V);
                      }),
                    (y = y.length && new RegExp(y.join('|'))),
                    (g = g.length && new RegExp(g.join('|'))),
                    (e = J.test(d.compareDocumentPosition)),
                    (b =
                      e || J.test(d.contains)
                        ? function (t, e) {
                            var r = 9 === t.nodeType ? t.documentElement : t,
                              n = e && e.parentNode;
                            return (
                              t === n ||
                              !(
                                !n ||
                                1 !== n.nodeType ||
                                !(r.contains
                                  ? r.contains(n)
                                  : t.compareDocumentPosition && 16 & t.compareDocumentPosition(n))
                              )
                            );
                          }
                        : function (t, e) {
                            if (e) for (; (e = e.parentNode); ) if (e === t) return !0;
                            return !1;
                          }),
                    (T = e
                      ? function (t, e) {
                          if (t === e) return (u = !0), 0;
                          var n = !t.compareDocumentPosition - !e.compareDocumentPosition;
                          return (
                            n ||
                            (1 &
                              (n =
                                (t.ownerDocument || t) == (e.ownerDocument || e) ? t.compareDocumentPosition(e) : 1) ||
                            (!r.sortDetached && e.compareDocumentPosition(t) === n)
                              ? t == f || (t.ownerDocument == E && b(E, t))
                                ? -1
                                : e == f || (e.ownerDocument == E && b(E, e))
                                ? 1
                                : h
                                ? R(h, t) - R(h, e)
                                : 0
                              : 4 & n
                              ? -1
                              : 1)
                          );
                        }
                      : function (t, e) {
                          if (t === e) return (u = !0), 0;
                          var r,
                            n = 0,
                            i = t.parentNode,
                            o = e.parentNode,
                            a = [t],
                            s = [e];
                          if (!i || !o) return t == f ? -1 : e == f ? 1 : i ? -1 : o ? 1 : h ? R(h, t) - R(h, e) : 0;
                          if (i === o) return pt(t, e);
                          for (r = t; (r = r.parentNode); ) a.unshift(r);
                          for (r = e; (r = r.parentNode); ) s.unshift(r);
                          for (; a[n] === s[n]; ) n++;
                          return n ? pt(a[n], s[n]) : a[n] == E ? -1 : s[n] == E ? 1 : 0;
                        }),
                    f)
                  : f;
              }),
            (st.matches = function (t, e) {
              return st(t, null, null, e);
            }),
            (st.matchesSelector = function (t, e) {
              if ((p(t), r.matchesSelector && m && !C[e + ' '] && (!g || !g.test(e)) && (!y || !y.test(e))))
                try {
                  var n = v.call(t, e);
                  if (n || r.disconnectedMatch || (t.document && 11 !== t.document.nodeType)) return n;
                } catch (t) {
                  C(e, !0);
                }
              return st(e, f, null, [t]).length > 0;
            }),
            (st.contains = function (t, e) {
              return (t.ownerDocument || t) != f && p(t), b(t, e);
            }),
            (st.attr = function (t, e) {
              (t.ownerDocument || t) != f && p(t);
              var i = n.attrHandle[e.toLowerCase()],
                o = i && k.call(n.attrHandle, e.toLowerCase()) ? i(t, e, !m) : void 0;
              return void 0 !== o
                ? o
                : r.attributes || !m
                ? t.getAttribute(e)
                : (o = t.getAttributeNode(e)) && o.specified
                ? o.value
                : null;
            }),
            (st.escape = function (t) {
              return (t + '').replace(nt, it);
            }),
            (st.error = function (t) {
              throw new Error('Syntax error, unrecognized expression: ' + t);
            }),
            (st.uniqueSort = function (t) {
              var e,
                n = [],
                i = 0,
                o = 0;
              if (((u = !r.detectDuplicates), (h = !r.sortStable && t.slice(0)), t.sort(T), u)) {
                for (; (e = t[o++]); ) e === t[o] && (i = n.push(o));
                for (; i--; ) t.splice(n[i], 1);
              }
              return (h = null), t;
            }),
            (i = st.getText =
              function (t) {
                var e,
                  r = '',
                  n = 0,
                  o = t.nodeType;
                if (o) {
                  if (1 === o || 9 === o || 11 === o) {
                    if ('string' == typeof t.textContent) return t.textContent;
                    for (t = t.firstChild; t; t = t.nextSibling) r += i(t);
                  } else if (3 === o || 4 === o) return t.nodeValue;
                } else for (; (e = t[n++]); ) r += i(e);
                return r;
              }),
            (n = st.selectors =
              {
                cacheLength: 50,
                createPseudo: ct,
                match: X,
                attrHandle: {},
                find: {},
                relative: {
                  '>': { dir: 'parentNode', first: !0 },
                  ' ': { dir: 'parentNode' },
                  '+': { dir: 'previousSibling', first: !0 },
                  '~': { dir: 'previousSibling' },
                },
                preFilter: {
                  ATTR: function (t) {
                    return (
                      (t[1] = t[1].replace(et, rt)),
                      (t[3] = (t[3] || t[4] || t[5] || '').replace(et, rt)),
                      '~=' === t[2] && (t[3] = ' ' + t[3] + ' '),
                      t.slice(0, 4)
                    );
                  },
                  CHILD: function (t) {
                    return (
                      (t[1] = t[1].toLowerCase()),
                      'nth' === t[1].slice(0, 3)
                        ? (t[3] || st.error(t[0]),
                          (t[4] = +(t[4] ? t[5] + (t[6] || 1) : 2 * ('even' === t[3] || 'odd' === t[3]))),
                          (t[5] = +(t[7] + t[8] || 'odd' === t[3])))
                        : t[3] && st.error(t[0]),
                      t
                    );
                  },
                  PSEUDO: function (t) {
                    var e,
                      r = !t[6] && t[2];
                    return X.CHILD.test(t[0])
                      ? null
                      : (t[3]
                          ? (t[2] = t[4] || t[5] || '')
                          : r &&
                            W.test(r) &&
                            (e = a(r, !0)) &&
                            (e = r.indexOf(')', r.length - e) - r.length) &&
                            ((t[0] = t[0].slice(0, e)), (t[2] = r.slice(0, e))),
                        t.slice(0, 3));
                  },
                },
                filter: {
                  TAG: function (t) {
                    var e = t.replace(et, rt).toLowerCase();
                    return '*' === t
                      ? function () {
                          return !0;
                        }
                      : function (t) {
                          return t.nodeName && t.nodeName.toLowerCase() === e;
                        };
                  },
                  CLASS: function (t) {
                    var e = S[t + ' '];
                    return (
                      e ||
                      ((e = new RegExp('(^|[\\x20\\t\\r\\n\\f])' + t + '(' + B + '|$)')) &&
                        S(t, function (t) {
                          return e.test(
                            ('string' == typeof t.className && t.className) ||
                              (void 0 !== t.getAttribute && t.getAttribute('class')) ||
                              '',
                          );
                        }))
                    );
                  },
                  ATTR: function (t, e, r) {
                    return function (n) {
                      var i = st.attr(n, t);
                      return null == i
                        ? '!=' === e
                        : !e ||
                            ((i += ''),
                            '=' === e
                              ? i === r
                              : '!=' === e
                              ? i !== r
                              : '^=' === e
                              ? r && 0 === i.indexOf(r)
                              : '*=' === e
                              ? r && i.indexOf(r) > -1
                              : '$=' === e
                              ? r && i.slice(-r.length) === r
                              : '~=' === e
                              ? (' ' + i.replace(z, ' ') + ' ').indexOf(r) > -1
                              : '|=' === e && (i === r || i.slice(0, r.length + 1) === r + '-'));
                    };
                  },
                  CHILD: function (t, e, r, n, i) {
                    var o = 'nth' !== t.slice(0, 3),
                      a = 'last' !== t.slice(-4),
                      s = 'of-type' === e;
                    return 1 === n && 0 === i
                      ? function (t) {
                          return !!t.parentNode;
                        }
                      : function (e, r, l) {
                          var c,
                            h,
                            u,
                            p,
                            f,
                            d,
                            m = o !== a ? 'nextSibling' : 'previousSibling',
                            y = e.parentNode,
                            g = s && e.nodeName.toLowerCase(),
                            v = !l && !s,
                            b = !1;
                          if (y) {
                            if (o) {
                              for (; m; ) {
                                for (p = e; (p = p[m]); )
                                  if (s ? p.nodeName.toLowerCase() === g : 1 === p.nodeType) return !1;
                                d = m = 'only' === t && !d && 'nextSibling';
                              }
                              return !0;
                            }
                            if (((d = [a ? y.firstChild : y.lastChild]), a && v)) {
                              for (
                                b =
                                  (f =
                                    (c =
                                      (h = (u = (p = y)[x] || (p[x] = {}))[p.uniqueID] || (u[p.uniqueID] = {}))[t] ||
                                      [])[0] === w && c[1]) && c[2],
                                  p = f && y.childNodes[f];
                                (p = (++f && p && p[m]) || (b = f = 0) || d.pop());

                              )
                                if (1 === p.nodeType && ++b && p === e) {
                                  h[t] = [w, f, b];
                                  break;
                                }
                            } else if (
                              (v &&
                                (b = f =
                                  (c =
                                    (h = (u = (p = e)[x] || (p[x] = {}))[p.uniqueID] || (u[p.uniqueID] = {}))[t] ||
                                    [])[0] === w && c[1]),
                              !1 === b)
                            )
                              for (
                                ;
                                (p = (++f && p && p[m]) || (b = f = 0) || d.pop()) &&
                                ((s ? p.nodeName.toLowerCase() !== g : 1 !== p.nodeType) ||
                                  !++b ||
                                  (v &&
                                    ((h = (u = p[x] || (p[x] = {}))[p.uniqueID] || (u[p.uniqueID] = {}))[t] = [w, b]),
                                  p !== e));

                              );
                            return (b -= i) === n || (b % n == 0 && b / n >= 0);
                          }
                        };
                  },
                  PSEUDO: function (t, e) {
                    var r,
                      i = n.pseudos[t] || n.setFilters[t.toLowerCase()] || st.error('unsupported pseudo: ' + t);
                    return i[x]
                      ? i(e)
                      : i.length > 1
                      ? ((r = [t, t, '', e]),
                        n.setFilters.hasOwnProperty(t.toLowerCase())
                          ? ct(function (t, r) {
                              for (var n, o = i(t, e), a = o.length; a--; ) t[(n = R(t, o[a]))] = !(r[n] = o[a]);
                            })
                          : function (t) {
                              return i(t, 0, r);
                            })
                      : i;
                  },
                },
                pseudos: {
                  not: ct(function (t) {
                    var e = [],
                      r = [],
                      n = s(t.replace($, '$1'));
                    return n[x]
                      ? ct(function (t, e, r, i) {
                          for (var o, a = n(t, null, i, []), s = t.length; s--; ) (o = a[s]) && (t[s] = !(e[s] = o));
                        })
                      : function (t, i, o) {
                          return (e[0] = t), n(e, null, o, r), (e[0] = null), !r.pop();
                        };
                  }),
                  has: ct(function (t) {
                    return function (e) {
                      return st(t, e).length > 0;
                    };
                  }),
                  contains: ct(function (t) {
                    return (
                      (t = t.replace(et, rt)),
                      function (e) {
                        return (e.textContent || i(e)).indexOf(t) > -1;
                      }
                    );
                  }),
                  lang: ct(function (t) {
                    return (
                      U.test(t || '') || st.error('unsupported lang: ' + t),
                      (t = t.replace(et, rt).toLowerCase()),
                      function (e) {
                        var r;
                        do {
                          if ((r = m ? e.lang : e.getAttribute('xml:lang') || e.getAttribute('lang')))
                            return (r = r.toLowerCase()) === t || 0 === r.indexOf(t + '-');
                        } while ((e = e.parentNode) && 1 === e.nodeType);
                        return !1;
                      }
                    );
                  }),
                  target: function (e) {
                    var r = t.location && t.location.hash;
                    return r && r.slice(1) === e.id;
                  },
                  root: function (t) {
                    return t === d;
                  },
                  focus: function (t) {
                    return (
                      t === f.activeElement && (!f.hasFocus || f.hasFocus()) && !!(t.type || t.href || ~t.tabIndex)
                    );
                  },
                  enabled: mt(!1),
                  disabled: mt(!0),
                  checked: function (t) {
                    var e = t.nodeName.toLowerCase();
                    return ('input' === e && !!t.checked) || ('option' === e && !!t.selected);
                  },
                  selected: function (t) {
                    return t.parentNode && t.parentNode.selectedIndex, !0 === t.selected;
                  },
                  empty: function (t) {
                    for (t = t.firstChild; t; t = t.nextSibling) if (t.nodeType < 6) return !1;
                    return !0;
                  },
                  parent: function (t) {
                    return !n.pseudos.empty(t);
                  },
                  header: function (t) {
                    return Z.test(t.nodeName);
                  },
                  input: function (t) {
                    return K.test(t.nodeName);
                  },
                  button: function (t) {
                    var e = t.nodeName.toLowerCase();
                    return ('input' === e && 'button' === t.type) || 'button' === e;
                  },
                  text: function (t) {
                    var e;
                    return (
                      'input' === t.nodeName.toLowerCase() &&
                      'text' === t.type &&
                      (null == (e = t.getAttribute('type')) || 'text' === e.toLowerCase())
                    );
                  },
                  first: yt(function () {
                    return [0];
                  }),
                  last: yt(function (t, e) {
                    return [e - 1];
                  }),
                  eq: yt(function (t, e, r) {
                    return [r < 0 ? r + e : r];
                  }),
                  even: yt(function (t, e) {
                    for (var r = 0; r < e; r += 2) t.push(r);
                    return t;
                  }),
                  odd: yt(function (t, e) {
                    for (var r = 1; r < e; r += 2) t.push(r);
                    return t;
                  }),
                  lt: yt(function (t, e, r) {
                    for (var n = r < 0 ? r + e : r > e ? e : r; --n >= 0; ) t.push(n);
                    return t;
                  }),
                  gt: yt(function (t, e, r) {
                    for (var n = r < 0 ? r + e : r; ++n < e; ) t.push(n);
                    return t;
                  }),
                },
              }),
            (n.pseudos.nth = n.pseudos.eq),
            { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 }))
              n.pseudos[e] = ft(e);
            for (e in { submit: !0, reset: !0 }) n.pseudos[e] = dt(e);
            function vt() {}
            function bt(t) {
              for (var e = 0, r = t.length, n = ''; e < r; e++) n += t[e].value;
              return n;
            }
            function xt(t, e, r) {
              var n = e.dir,
                i = e.next,
                o = i || n,
                a = r && 'parentNode' === o,
                s = _++;
              return e.first
                ? function (e, r, i) {
                    for (; (e = e[n]); ) if (1 === e.nodeType || a) return t(e, r, i);
                    return !1;
                  }
                : function (e, r, l) {
                    var c,
                      h,
                      u,
                      p = [w, s];
                    if (l) {
                      for (; (e = e[n]); ) if ((1 === e.nodeType || a) && t(e, r, l)) return !0;
                    } else
                      for (; (e = e[n]); )
                        if (1 === e.nodeType || a)
                          if (
                            ((h = (u = e[x] || (e[x] = {}))[e.uniqueID] || (u[e.uniqueID] = {})),
                            i && i === e.nodeName.toLowerCase())
                          )
                            e = e[n] || e;
                          else {
                            if ((c = h[o]) && c[0] === w && c[1] === s) return (p[2] = c[2]);
                            if (((h[o] = p), (p[2] = t(e, r, l)))) return !0;
                          }
                    return !1;
                  };
            }
            function Et(t) {
              return t.length > 1
                ? function (e, r, n) {
                    for (var i = t.length; i--; ) if (!t[i](e, r, n)) return !1;
                    return !0;
                  }
                : t[0];
            }
            function wt(t, e, r, n, i) {
              for (var o, a = [], s = 0, l = t.length, c = null != e; s < l; s++)
                (o = t[s]) && ((r && !r(o, n, i)) || (a.push(o), c && e.push(s)));
              return a;
            }
            function _t(t, e, r, n, i, o) {
              return (
                n && !n[x] && (n = _t(n)),
                i && !i[x] && (i = _t(i, o)),
                ct(function (o, a, s, l) {
                  var c,
                    h,
                    u,
                    p = [],
                    f = [],
                    d = a.length,
                    m =
                      o ||
                      (function (t, e, r) {
                        for (var n = 0, i = e.length; n < i; n++) st(t, e[n], r);
                        return r;
                      })(e || '*', s.nodeType ? [s] : s, []),
                    y = !t || (!o && e) ? m : wt(m, p, t, s, l),
                    g = r ? (i || (o ? t : d || n) ? [] : a) : y;
                  if ((r && r(y, g, s, l), n))
                    for (c = wt(g, f), n(c, [], s, l), h = c.length; h--; ) (u = c[h]) && (g[f[h]] = !(y[f[h]] = u));
                  if (o) {
                    if (i || t) {
                      if (i) {
                        for (c = [], h = g.length; h--; ) (u = g[h]) && c.push((y[h] = u));
                        i(null, (g = []), c, l);
                      }
                      for (h = g.length; h--; ) (u = g[h]) && (c = i ? R(o, u) : p[h]) > -1 && (o[c] = !(a[c] = u));
                    }
                  } else (g = wt(g === a ? g.splice(d, g.length) : g)), i ? i(null, a, g, l) : F.apply(a, g);
                })
              );
            }
            function St(t) {
              for (
                var e,
                  r,
                  i,
                  o = t.length,
                  a = n.relative[t[0].type],
                  s = a || n.relative[' '],
                  l = a ? 1 : 0,
                  h = xt(
                    function (t) {
                      return t === e;
                    },
                    s,
                    !0,
                  ),
                  u = xt(
                    function (t) {
                      return R(e, t) > -1;
                    },
                    s,
                    !0,
                  ),
                  p = [
                    function (t, r, n) {
                      var i = (!a && (n || r !== c)) || ((e = r).nodeType ? h(t, r, n) : u(t, r, n));
                      return (e = null), i;
                    },
                  ];
                l < o;
                l++
              )
                if ((r = n.relative[t[l].type])) p = [xt(Et(p), r)];
                else {
                  if ((r = n.filter[t[l].type].apply(null, t[l].matches))[x]) {
                    for (i = ++l; i < o && !n.relative[t[i].type]; i++);
                    return _t(
                      l > 1 && Et(p),
                      l > 1 &&
                        bt(t.slice(0, l - 1).concat({ value: ' ' === t[l - 2].type ? '*' : '' })).replace($, '$1'),
                      r,
                      l < i && St(t.slice(l, i)),
                      i < o && St((t = t.slice(i))),
                      i < o && bt(t),
                    );
                  }
                  p.push(r);
                }
              return Et(p);
            }
            return (
              (vt.prototype = n.filters = n.pseudos),
              (n.setFilters = new vt()),
              (a = st.tokenize =
                function (t, e) {
                  var r,
                    i,
                    o,
                    a,
                    s,
                    l,
                    c,
                    h = P[t + ' '];
                  if (h) return e ? 0 : h.slice(0);
                  for (s = t, l = [], c = n.preFilter; s; ) {
                    for (a in ((r && !(i = q.exec(s))) || (i && (s = s.slice(i[0].length) || s), l.push((o = []))),
                    (r = !1),
                    (i = H.exec(s)) &&
                      ((r = i.shift()), o.push({ value: r, type: i[0].replace($, ' ') }), (s = s.slice(r.length))),
                    n.filter))
                      !(i = X[a].exec(s)) ||
                        (c[a] && !(i = c[a](i))) ||
                        ((r = i.shift()), o.push({ value: r, type: a, matches: i }), (s = s.slice(r.length)));
                    if (!r) break;
                  }
                  return e ? s.length : s ? st.error(t) : P(t, l).slice(0);
                }),
              (s = st.compile =
                function (t, e) {
                  var r,
                    i = [],
                    o = [],
                    s = A[t + ' '];
                  if (!s) {
                    for (e || (e = a(t)), r = e.length; r--; ) (s = St(e[r]))[x] ? i.push(s) : o.push(s);
                    (s = A(
                      t,
                      (function (t, e) {
                        var r = e.length > 0,
                          i = t.length > 0,
                          o = function (o, a, s, l, h) {
                            var u,
                              d,
                              y,
                              g = 0,
                              v = '0',
                              b = o && [],
                              x = [],
                              E = c,
                              _ = o || (i && n.find.TAG('*', h)),
                              S = (w += null == E ? 1 : Math.random() || 0.1),
                              P = _.length;
                            for (h && (c = a == f || a || h); v !== P && null != (u = _[v]); v++) {
                              if (i && u) {
                                for (d = 0, a || u.ownerDocument == f || (p(u), (s = !m)); (y = t[d++]); )
                                  if (y(u, a || f, s)) {
                                    l.push(u);
                                    break;
                                  }
                                h && (w = S);
                              }
                              r && ((u = !y && u) && g--, o && b.push(u));
                            }
                            if (((g += v), r && v !== g)) {
                              for (d = 0; (y = e[d++]); ) y(b, x, a, s);
                              if (o) {
                                if (g > 0) for (; v--; ) b[v] || x[v] || (x[v] = M.call(l));
                                x = wt(x);
                              }
                              F.apply(l, x), h && !o && x.length > 0 && g + e.length > 1 && st.uniqueSort(l);
                            }
                            return h && ((w = S), (c = E)), b;
                          };
                        return r ? ct(o) : o;
                      })(o, i),
                    )),
                      (s.selector = t);
                  }
                  return s;
                }),
              (l = st.select =
                function (t, e, r, i) {
                  var o,
                    l,
                    c,
                    h,
                    u,
                    p = 'function' == typeof t && t,
                    f = !i && a((t = p.selector || t));
                  if (((r = r || []), 1 === f.length)) {
                    if (
                      (l = f[0] = f[0].slice(0)).length > 2 &&
                      'ID' === (c = l[0]).type &&
                      9 === e.nodeType &&
                      m &&
                      n.relative[l[1].type]
                    ) {
                      if (!(e = (n.find.ID(c.matches[0].replace(et, rt), e) || [])[0])) return r;
                      p && (e = e.parentNode), (t = t.slice(l.shift().value.length));
                    }
                    for (o = X.needsContext.test(t) ? 0 : l.length; o-- && ((c = l[o]), !n.relative[(h = c.type)]); )
                      if (
                        (u = n.find[h]) &&
                        (i = u(c.matches[0].replace(et, rt), (tt.test(l[0].type) && gt(e.parentNode)) || e))
                      ) {
                        if ((l.splice(o, 1), !(t = i.length && bt(l)))) return F.apply(r, i), r;
                        break;
                      }
                  }
                  return (p || s(t, f))(i, e, !m, r, !e || (tt.test(t) && gt(e.parentNode)) || e), r;
                }),
              (r.sortStable = x.split('').sort(T).join('') === x),
              (r.detectDuplicates = !!u),
              p(),
              (r.sortDetached = ht(function (t) {
                return 1 & t.compareDocumentPosition(f.createElement('fieldset'));
              })),
              ht(function (t) {
                return (t.innerHTML = "<a href='#'></a>"), '#' === t.firstChild.getAttribute('href');
              }) ||
                ut('type|href|height|width', function (t, e, r) {
                  if (!r) return t.getAttribute(e, 'type' === e.toLowerCase() ? 1 : 2);
                }),
              (r.attributes &&
                ht(function (t) {
                  return (
                    (t.innerHTML = '<input/>'),
                    t.firstChild.setAttribute('value', ''),
                    '' === t.firstChild.getAttribute('value')
                  );
                })) ||
                ut('value', function (t, e, r) {
                  if (!r && 'input' === t.nodeName.toLowerCase()) return t.defaultValue;
                }),
              ht(function (t) {
                return null == t.getAttribute('disabled');
              }) ||
                ut(O, function (t, e, r) {
                  var n;
                  if (!r)
                    return !0 === t[e] ? e.toLowerCase() : (n = t.getAttributeNode(e)) && n.specified ? n.value : null;
                }),
              st
            );
          })(n);
          (S.find = A),
            (S.expr = A.selectors),
            (S.expr[':'] = S.expr.pseudos),
            (S.uniqueSort = S.unique = A.uniqueSort),
            (S.text = A.getText),
            (S.isXMLDoc = A.isXML),
            (S.contains = A.contains),
            (S.escapeSelector = A.escape);
          var C = function (t, e, r) {
              for (var n = [], i = void 0 !== r; (t = t[e]) && 9 !== t.nodeType; )
                if (1 === t.nodeType) {
                  if (i && S(t).is(r)) break;
                  n.push(t);
                }
              return n;
            },
            T = function (t, e) {
              for (var r = []; t; t = t.nextSibling) 1 === t.nodeType && t !== e && r.push(t);
              return r;
            },
            k = S.expr.match.needsContext;
          function D(t, e) {
            return t.nodeName && t.nodeName.toLowerCase() === e.toLowerCase();
          }
          var M = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
          function I(t, e, r) {
            return g(e)
              ? S.grep(t, function (t, n) {
                  return !!e.call(t, n, t) !== r;
                })
              : e.nodeType
              ? S.grep(t, function (t) {
                  return (t === e) !== r;
                })
              : 'string' != typeof e
              ? S.grep(t, function (t) {
                  return h.call(e, t) > -1 !== r;
                })
              : S.filter(e, t, r);
          }
          (S.filter = function (t, e, r) {
            var n = e[0];
            return (
              r && (t = ':not(' + t + ')'),
              1 === e.length && 1 === n.nodeType
                ? S.find.matchesSelector(n, t)
                  ? [n]
                  : []
                : S.find.matches(
                    t,
                    S.grep(e, function (t) {
                      return 1 === t.nodeType;
                    }),
                  )
            );
          }),
            S.fn.extend({
              find: function (t) {
                var e,
                  r,
                  n = this.length,
                  i = this;
                if ('string' != typeof t)
                  return this.pushStack(
                    S(t).filter(function () {
                      for (e = 0; e < n; e++) if (S.contains(i[e], this)) return !0;
                    }),
                  );
                for (r = this.pushStack([]), e = 0; e < n; e++) S.find(t, i[e], r);
                return n > 1 ? S.uniqueSort(r) : r;
              },
              filter: function (t) {
                return this.pushStack(I(this, t || [], !1));
              },
              not: function (t) {
                return this.pushStack(I(this, t || [], !0));
              },
              is: function (t) {
                return !!I(this, 'string' == typeof t && k.test(t) ? S(t) : t || [], !1).length;
              },
            });
          var F,
            L = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
          ((S.fn.init = function (t, e, r) {
            var n, i;
            if (!t) return this;
            if (((r = r || F), 'string' == typeof t)) {
              if (
                !(n = '<' === t[0] && '>' === t[t.length - 1] && t.length >= 3 ? [null, t, null] : L.exec(t)) ||
                (!n[1] && e)
              )
                return !e || e.jquery ? (e || r).find(t) : this.constructor(e).find(t);
              if (n[1]) {
                if (
                  ((e = e instanceof S ? e[0] : e),
                  S.merge(this, S.parseHTML(n[1], e && e.nodeType ? e.ownerDocument || e : b, !0)),
                  M.test(n[1]) && S.isPlainObject(e))
                )
                  for (n in e) g(this[n]) ? this[n](e[n]) : this.attr(n, e[n]);
                return this;
              }
              return (i = b.getElementById(n[2])) && ((this[0] = i), (this.length = 1)), this;
            }
            return t.nodeType
              ? ((this[0] = t), (this.length = 1), this)
              : g(t)
              ? void 0 !== r.ready
                ? r.ready(t)
                : t(S)
              : S.makeArray(t, this);
          }).prototype = S.fn),
            (F = S(b));
          var R = /^(?:parents|prev(?:Until|All))/,
            O = { children: !0, contents: !0, next: !0, prev: !0 };
          function B(t, e) {
            for (; (t = t[e]) && 1 !== t.nodeType; );
            return t;
          }
          S.fn.extend({
            has: function (t) {
              var e = S(t, this),
                r = e.length;
              return this.filter(function () {
                for (var t = 0; t < r; t++) if (S.contains(this, e[t])) return !0;
              });
            },
            closest: function (t, e) {
              var r,
                n = 0,
                i = this.length,
                o = [],
                a = 'string' != typeof t && S(t);
              if (!k.test(t))
                for (; n < i; n++)
                  for (r = this[n]; r && r !== e; r = r.parentNode)
                    if (r.nodeType < 11 && (a ? a.index(r) > -1 : 1 === r.nodeType && S.find.matchesSelector(r, t))) {
                      o.push(r);
                      break;
                    }
              return this.pushStack(o.length > 1 ? S.uniqueSort(o) : o);
            },
            index: function (t) {
              return t
                ? 'string' == typeof t
                  ? h.call(S(t), this[0])
                  : h.call(this, t.jquery ? t[0] : t)
                : this[0] && this[0].parentNode
                ? this.first().prevAll().length
                : -1;
            },
            add: function (t, e) {
              return this.pushStack(S.uniqueSort(S.merge(this.get(), S(t, e))));
            },
            addBack: function (t) {
              return this.add(null == t ? this.prevObject : this.prevObject.filter(t));
            },
          }),
            S.each(
              {
                parent: function (t) {
                  var e = t.parentNode;
                  return e && 11 !== e.nodeType ? e : null;
                },
                parents: function (t) {
                  return C(t, 'parentNode');
                },
                parentsUntil: function (t, e, r) {
                  return C(t, 'parentNode', r);
                },
                next: function (t) {
                  return B(t, 'nextSibling');
                },
                prev: function (t) {
                  return B(t, 'previousSibling');
                },
                nextAll: function (t) {
                  return C(t, 'nextSibling');
                },
                prevAll: function (t) {
                  return C(t, 'previousSibling');
                },
                nextUntil: function (t, e, r) {
                  return C(t, 'nextSibling', r);
                },
                prevUntil: function (t, e, r) {
                  return C(t, 'previousSibling', r);
                },
                siblings: function (t) {
                  return T((t.parentNode || {}).firstChild, t);
                },
                children: function (t) {
                  return T(t.firstChild);
                },
                contents: function (t) {
                  return null != t.contentDocument && a(t.contentDocument)
                    ? t.contentDocument
                    : (D(t, 'template') && (t = t.content || t), S.merge([], t.childNodes));
                },
              },
              function (t, e) {
                S.fn[t] = function (r, n) {
                  var i = S.map(this, e, r);
                  return (
                    'Until' !== t.slice(-5) && (n = r),
                    n && 'string' == typeof n && (i = S.filter(n, i)),
                    this.length > 1 && (O[t] || S.uniqueSort(i), R.test(t) && i.reverse()),
                    this.pushStack(i)
                  );
                };
              },
            );
          var j = /[^\x20\t\r\n\f]+/g;
          function N(t) {
            return t;
          }
          function V(t) {
            throw t;
          }
          function z(t, e, r, n) {
            var i;
            try {
              t && g((i = t.promise))
                ? i.call(t).done(e).fail(r)
                : t && g((i = t.then))
                ? i.call(t, e, r)
                : e.apply(void 0, [t].slice(n));
            } catch (t) {
              r.apply(void 0, [t]);
            }
          }
          (S.Callbacks = function (t) {
            t =
              'string' == typeof t
                ? (function (t) {
                    var e = {};
                    return (
                      S.each(t.match(j) || [], function (t, r) {
                        e[r] = !0;
                      }),
                      e
                    );
                  })(t)
                : S.extend({}, t);
            var e,
              r,
              n,
              i,
              o = [],
              a = [],
              s = -1,
              l = function () {
                for (i = i || t.once, n = e = !0; a.length; s = -1)
                  for (r = a.shift(); ++s < o.length; )
                    !1 === o[s].apply(r[0], r[1]) && t.stopOnFalse && ((s = o.length), (r = !1));
                t.memory || (r = !1), (e = !1), i && (o = r ? [] : '');
              },
              c = {
                add: function () {
                  return (
                    o &&
                      (r && !e && ((s = o.length - 1), a.push(r)),
                      (function e(r) {
                        S.each(r, function (r, n) {
                          g(n) ? (t.unique && c.has(n)) || o.push(n) : n && n.length && 'string' !== w(n) && e(n);
                        });
                      })(arguments),
                      r && !e && l()),
                    this
                  );
                },
                remove: function () {
                  return (
                    S.each(arguments, function (t, e) {
                      for (var r; (r = S.inArray(e, o, r)) > -1; ) o.splice(r, 1), r <= s && s--;
                    }),
                    this
                  );
                },
                has: function (t) {
                  return t ? S.inArray(t, o) > -1 : o.length > 0;
                },
                empty: function () {
                  return o && (o = []), this;
                },
                disable: function () {
                  return (i = a = []), (o = r = ''), this;
                },
                disabled: function () {
                  return !o;
                },
                lock: function () {
                  return (i = a = []), r || e || (o = r = ''), this;
                },
                locked: function () {
                  return !!i;
                },
                fireWith: function (t, r) {
                  return i || ((r = [t, (r = r || []).slice ? r.slice() : r]), a.push(r), e || l()), this;
                },
                fire: function () {
                  return c.fireWith(this, arguments), this;
                },
                fired: function () {
                  return !!n;
                },
              };
            return c;
          }),
            S.extend({
              Deferred: function (t) {
                var e = [
                    ['notify', 'progress', S.Callbacks('memory'), S.Callbacks('memory'), 2],
                    ['resolve', 'done', S.Callbacks('once memory'), S.Callbacks('once memory'), 0, 'resolved'],
                    ['reject', 'fail', S.Callbacks('once memory'), S.Callbacks('once memory'), 1, 'rejected'],
                  ],
                  r = 'pending',
                  i = {
                    state: function () {
                      return r;
                    },
                    always: function () {
                      return o.done(arguments).fail(arguments), this;
                    },
                    catch: function (t) {
                      return i.then(null, t);
                    },
                    pipe: function () {
                      var t = arguments;
                      return S.Deferred(function (r) {
                        S.each(e, function (e, n) {
                          var i = g(t[n[4]]) && t[n[4]];
                          o[n[1]](function () {
                            var t = i && i.apply(this, arguments);
                            t && g(t.promise)
                              ? t.promise().progress(r.notify).done(r.resolve).fail(r.reject)
                              : r[n[0] + 'With'](this, i ? [t] : arguments);
                          });
                        }),
                          (t = null);
                      }).promise();
                    },
                    then: function (t, r, i) {
                      var o = 0;
                      function a(t, e, r, i) {
                        return function () {
                          var s = this,
                            l = arguments,
                            c = function () {
                              var n, c;
                              if (!(t < o)) {
                                if ((n = r.apply(s, l)) === e.promise())
                                  throw new TypeError('Thenable self-resolution');
                                (c = n && ('object' == typeof n || 'function' == typeof n) && n.then),
                                  g(c)
                                    ? i
                                      ? c.call(n, a(o, e, N, i), a(o, e, V, i))
                                      : (o++, c.call(n, a(o, e, N, i), a(o, e, V, i), a(o, e, N, e.notifyWith)))
                                    : (r !== N && ((s = void 0), (l = [n])), (i || e.resolveWith)(s, l));
                              }
                            },
                            h = i
                              ? c
                              : function () {
                                  try {
                                    c();
                                  } catch (n) {
                                    S.Deferred.exceptionHook && S.Deferred.exceptionHook(n, h.stackTrace),
                                      t + 1 >= o && (r !== V && ((s = void 0), (l = [n])), e.rejectWith(s, l));
                                  }
                                };
                          t
                            ? h()
                            : (S.Deferred.getStackHook && (h.stackTrace = S.Deferred.getStackHook()), n.setTimeout(h));
                        };
                      }
                      return S.Deferred(function (n) {
                        e[0][3].add(a(0, n, g(i) ? i : N, n.notifyWith)),
                          e[1][3].add(a(0, n, g(t) ? t : N)),
                          e[2][3].add(a(0, n, g(r) ? r : V));
                      }).promise();
                    },
                    promise: function (t) {
                      return null != t ? S.extend(t, i) : i;
                    },
                  },
                  o = {};
                return (
                  S.each(e, function (t, n) {
                    var a = n[2],
                      s = n[5];
                    (i[n[1]] = a.add),
                      s &&
                        a.add(
                          function () {
                            r = s;
                          },
                          e[3 - t][2].disable,
                          e[3 - t][3].disable,
                          e[0][2].lock,
                          e[0][3].lock,
                        ),
                      a.add(n[3].fire),
                      (o[n[0]] = function () {
                        return o[n[0] + 'With'](this === o ? void 0 : this, arguments), this;
                      }),
                      (o[n[0] + 'With'] = a.fireWith);
                  }),
                  i.promise(o),
                  t && t.call(o, o),
                  o
                );
              },
              when: function (t) {
                var e = arguments.length,
                  r = e,
                  n = Array(r),
                  i = s.call(arguments),
                  o = S.Deferred(),
                  a = function (t) {
                    return function (r) {
                      (n[t] = this), (i[t] = arguments.length > 1 ? s.call(arguments) : r), --e || o.resolveWith(n, i);
                    };
                  };
                if (
                  e <= 1 &&
                  (z(t, o.done(a(r)).resolve, o.reject, !e), 'pending' === o.state() || g(i[r] && i[r].then))
                )
                  return o.then();
                for (; r--; ) z(i[r], a(r), o.reject);
                return o.promise();
              },
            });
          var $ = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
          (S.Deferred.exceptionHook = function (t, e) {
            n.console &&
              n.console.warn &&
              t &&
              $.test(t.name) &&
              n.console.warn('jQuery.Deferred exception: ' + t.message, t.stack, e);
          }),
            (S.readyException = function (t) {
              n.setTimeout(function () {
                throw t;
              });
            });
          var q = S.Deferred();
          function H() {
            b.removeEventListener('DOMContentLoaded', H), n.removeEventListener('load', H), S.ready();
          }
          (S.fn.ready = function (t) {
            return (
              q.then(t).catch(function (t) {
                S.readyException(t);
              }),
              this
            );
          }),
            S.extend({
              isReady: !1,
              readyWait: 1,
              ready: function (t) {
                (!0 === t ? --S.readyWait : S.isReady) ||
                  ((S.isReady = !0), (!0 !== t && --S.readyWait > 0) || q.resolveWith(b, [S]));
              },
            }),
            (S.ready.then = q.then),
            'complete' === b.readyState || ('loading' !== b.readyState && !b.documentElement.doScroll)
              ? n.setTimeout(S.ready)
              : (b.addEventListener('DOMContentLoaded', H), n.addEventListener('load', H));
          var G = function (t, e, r, n, i, o, a) {
              var s = 0,
                l = t.length,
                c = null == r;
              if ('object' === w(r)) for (s in ((i = !0), r)) G(t, e, s, r[s], !0, o, a);
              else if (
                void 0 !== n &&
                ((i = !0),
                g(n) || (a = !0),
                c &&
                  (a
                    ? (e.call(t, n), (e = null))
                    : ((c = e),
                      (e = function (t, e, r) {
                        return c.call(S(t), r);
                      }))),
                e)
              )
                for (; s < l; s++) e(t[s], r, a ? n : n.call(t[s], s, e(t[s], r)));
              return i ? t : c ? e.call(t) : l ? e(t[0], r) : o;
            },
            W = /^-ms-/,
            U = /-([a-z])/g;
          function X(t, e) {
            return e.toUpperCase();
          }
          function Y(t) {
            return t.replace(W, 'ms-').replace(U, X);
          }
          var K = function (t) {
            return 1 === t.nodeType || 9 === t.nodeType || !+t.nodeType;
          };
          function Z() {
            this.expando = S.expando + Z.uid++;
          }
          (Z.uid = 1),
            (Z.prototype = {
              cache: function (t) {
                var e = t[this.expando];
                return (
                  e ||
                    ((e = {}),
                    K(t) &&
                      (t.nodeType
                        ? (t[this.expando] = e)
                        : Object.defineProperty(t, this.expando, { value: e, configurable: !0 }))),
                  e
                );
              },
              set: function (t, e, r) {
                var n,
                  i = this.cache(t);
                if ('string' == typeof e) i[Y(e)] = r;
                else for (n in e) i[Y(n)] = e[n];
                return i;
              },
              get: function (t, e) {
                return void 0 === e ? this.cache(t) : t[this.expando] && t[this.expando][Y(e)];
              },
              access: function (t, e, r) {
                return void 0 === e || (e && 'string' == typeof e && void 0 === r)
                  ? this.get(t, e)
                  : (this.set(t, e, r), void 0 !== r ? r : e);
              },
              remove: function (t, e) {
                var r,
                  n = t[this.expando];
                if (void 0 !== n) {
                  if (void 0 !== e) {
                    r = (e = Array.isArray(e) ? e.map(Y) : (e = Y(e)) in n ? [e] : e.match(j) || []).length;
                    for (; r--; ) delete n[e[r]];
                  }
                  (void 0 === e || S.isEmptyObject(n)) &&
                    (t.nodeType ? (t[this.expando] = void 0) : delete t[this.expando]);
                }
              },
              hasData: function (t) {
                var e = t[this.expando];
                return void 0 !== e && !S.isEmptyObject(e);
              },
            });
          var J = new Z(),
            Q = new Z(),
            tt = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
            et = /[A-Z]/g;
          function rt(t, e, r) {
            var n;
            if (void 0 === r && 1 === t.nodeType)
              if (((n = 'data-' + e.replace(et, '-$&').toLowerCase()), 'string' == typeof (r = t.getAttribute(n)))) {
                try {
                  r = (function (t) {
                    return (
                      'true' === t ||
                      ('false' !== t && ('null' === t ? null : t === +t + '' ? +t : tt.test(t) ? JSON.parse(t) : t))
                    );
                  })(r);
                } catch (t) {}
                Q.set(t, e, r);
              } else r = void 0;
            return r;
          }
          S.extend({
            hasData: function (t) {
              return Q.hasData(t) || J.hasData(t);
            },
            data: function (t, e, r) {
              return Q.access(t, e, r);
            },
            removeData: function (t, e) {
              Q.remove(t, e);
            },
            _data: function (t, e, r) {
              return J.access(t, e, r);
            },
            _removeData: function (t, e) {
              J.remove(t, e);
            },
          }),
            S.fn.extend({
              data: function (t, e) {
                var r,
                  n,
                  i,
                  o = this[0],
                  a = o && o.attributes;
                if (void 0 === t) {
                  if (this.length && ((i = Q.get(o)), 1 === o.nodeType && !J.get(o, 'hasDataAttrs'))) {
                    for (r = a.length; r--; )
                      a[r] && 0 === (n = a[r].name).indexOf('data-') && ((n = Y(n.slice(5))), rt(o, n, i[n]));
                    J.set(o, 'hasDataAttrs', !0);
                  }
                  return i;
                }
                return 'object' == typeof t
                  ? this.each(function () {
                      Q.set(this, t);
                    })
                  : G(
                      this,
                      function (e) {
                        var r;
                        if (o && void 0 === e)
                          return void 0 !== (r = Q.get(o, t)) || void 0 !== (r = rt(o, t)) ? r : void 0;
                        this.each(function () {
                          Q.set(this, t, e);
                        });
                      },
                      null,
                      e,
                      arguments.length > 1,
                      null,
                      !0,
                    );
              },
              removeData: function (t) {
                return this.each(function () {
                  Q.remove(this, t);
                });
              },
            }),
            S.extend({
              queue: function (t, e, r) {
                var n;
                if (t)
                  return (
                    (e = (e || 'fx') + 'queue'),
                    (n = J.get(t, e)),
                    r && (!n || Array.isArray(r) ? (n = J.access(t, e, S.makeArray(r))) : n.push(r)),
                    n || []
                  );
              },
              dequeue: function (t, e) {
                e = e || 'fx';
                var r = S.queue(t, e),
                  n = r.length,
                  i = r.shift(),
                  o = S._queueHooks(t, e);
                'inprogress' === i && ((i = r.shift()), n--),
                  i &&
                    ('fx' === e && r.unshift('inprogress'),
                    delete o.stop,
                    i.call(
                      t,
                      function () {
                        S.dequeue(t, e);
                      },
                      o,
                    )),
                  !n && o && o.empty.fire();
              },
              _queueHooks: function (t, e) {
                var r = e + 'queueHooks';
                return (
                  J.get(t, r) ||
                  J.access(t, r, {
                    empty: S.Callbacks('once memory').add(function () {
                      J.remove(t, [e + 'queue', r]);
                    }),
                  })
                );
              },
            }),
            S.fn.extend({
              queue: function (t, e) {
                var r = 2;
                return (
                  'string' != typeof t && ((e = t), (t = 'fx'), r--),
                  arguments.length < r
                    ? S.queue(this[0], t)
                    : void 0 === e
                    ? this
                    : this.each(function () {
                        var r = S.queue(this, t, e);
                        S._queueHooks(this, t), 'fx' === t && 'inprogress' !== r[0] && S.dequeue(this, t);
                      })
                );
              },
              dequeue: function (t) {
                return this.each(function () {
                  S.dequeue(this, t);
                });
              },
              clearQueue: function (t) {
                return this.queue(t || 'fx', []);
              },
              promise: function (t, e) {
                var r,
                  n = 1,
                  i = S.Deferred(),
                  o = this,
                  a = this.length,
                  s = function () {
                    --n || i.resolveWith(o, [o]);
                  };
                for ('string' != typeof t && ((e = t), (t = void 0)), t = t || 'fx'; a--; )
                  (r = J.get(o[a], t + 'queueHooks')) && r.empty && (n++, r.empty.add(s));
                return s(), i.promise(e);
              },
            });
          var nt = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
            it = new RegExp('^(?:([+-])=|)(' + nt + ')([a-z%]*)$', 'i'),
            ot = ['Top', 'Right', 'Bottom', 'Left'],
            at = b.documentElement,
            st = function (t) {
              return S.contains(t.ownerDocument, t);
            },
            lt = { composed: !0 };
          at.getRootNode &&
            (st = function (t) {
              return S.contains(t.ownerDocument, t) || t.getRootNode(lt) === t.ownerDocument;
            });
          var ct = function (t, e) {
            return (
              'none' === (t = e || t).style.display ||
              ('' === t.style.display && st(t) && 'none' === S.css(t, 'display'))
            );
          };
          function ht(t, e, r, n) {
            var i,
              o,
              a = 20,
              s = n
                ? function () {
                    return n.cur();
                  }
                : function () {
                    return S.css(t, e, '');
                  },
              l = s(),
              c = (r && r[3]) || (S.cssNumber[e] ? '' : 'px'),
              h = t.nodeType && (S.cssNumber[e] || ('px' !== c && +l)) && it.exec(S.css(t, e));
            if (h && h[3] !== c) {
              for (l /= 2, c = c || h[3], h = +l || 1; a--; )
                S.style(t, e, h + c), (1 - o) * (1 - (o = s() / l || 0.5)) <= 0 && (a = 0), (h /= o);
              (h *= 2), S.style(t, e, h + c), (r = r || []);
            }
            return (
              r &&
                ((h = +h || +l || 0),
                (i = r[1] ? h + (r[1] + 1) * r[2] : +r[2]),
                n && ((n.unit = c), (n.start = h), (n.end = i))),
              i
            );
          }
          var ut = {};
          function pt(t) {
            var e,
              r = t.ownerDocument,
              n = t.nodeName,
              i = ut[n];
            return (
              i ||
              ((e = r.body.appendChild(r.createElement(n))),
              (i = S.css(e, 'display')),
              e.parentNode.removeChild(e),
              'none' === i && (i = 'block'),
              (ut[n] = i),
              i)
            );
          }
          function ft(t, e) {
            for (var r, n, i = [], o = 0, a = t.length; o < a; o++)
              (n = t[o]).style &&
                ((r = n.style.display),
                e
                  ? ('none' === r && ((i[o] = J.get(n, 'display') || null), i[o] || (n.style.display = '')),
                    '' === n.style.display && ct(n) && (i[o] = pt(n)))
                  : 'none' !== r && ((i[o] = 'none'), J.set(n, 'display', r)));
            for (o = 0; o < a; o++) null != i[o] && (t[o].style.display = i[o]);
            return t;
          }
          S.fn.extend({
            show: function () {
              return ft(this, !0);
            },
            hide: function () {
              return ft(this);
            },
            toggle: function (t) {
              return 'boolean' == typeof t
                ? t
                  ? this.show()
                  : this.hide()
                : this.each(function () {
                    ct(this) ? S(this).show() : S(this).hide();
                  });
            },
          });
          var dt,
            mt,
            yt = /^(?:checkbox|radio)$/i,
            gt = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i,
            vt = /^$|^module$|\/(?:java|ecma)script/i;
          (dt = b.createDocumentFragment().appendChild(b.createElement('div'))),
            (mt = b.createElement('input')).setAttribute('type', 'radio'),
            mt.setAttribute('checked', 'checked'),
            mt.setAttribute('name', 't'),
            dt.appendChild(mt),
            (y.checkClone = dt.cloneNode(!0).cloneNode(!0).lastChild.checked),
            (dt.innerHTML = '<textarea>x</textarea>'),
            (y.noCloneChecked = !!dt.cloneNode(!0).lastChild.defaultValue),
            (dt.innerHTML = '<option></option>'),
            (y.option = !!dt.lastChild);
          var bt = {
            thead: [1, '<table>', '</table>'],
            col: [2, '<table><colgroup>', '</colgroup></table>'],
            tr: [2, '<table><tbody>', '</tbody></table>'],
            td: [3, '<table><tbody><tr>', '</tr></tbody></table>'],
            _default: [0, '', ''],
          };
          function xt(t, e) {
            var r;
            return (
              (r =
                void 0 !== t.getElementsByTagName
                  ? t.getElementsByTagName(e || '*')
                  : void 0 !== t.querySelectorAll
                  ? t.querySelectorAll(e || '*')
                  : []),
              void 0 === e || (e && D(t, e)) ? S.merge([t], r) : r
            );
          }
          function Et(t, e) {
            for (var r = 0, n = t.length; r < n; r++) J.set(t[r], 'globalEval', !e || J.get(e[r], 'globalEval'));
          }
          (bt.tbody = bt.tfoot = bt.colgroup = bt.caption = bt.thead),
            (bt.th = bt.td),
            y.option || (bt.optgroup = bt.option = [1, "<select multiple='multiple'>", '</select>']);
          var wt = /<|&#?\w+;/;
          function _t(t, e, r, n, i) {
            for (var o, a, s, l, c, h, u = e.createDocumentFragment(), p = [], f = 0, d = t.length; f < d; f++)
              if ((o = t[f]) || 0 === o)
                if ('object' === w(o)) S.merge(p, o.nodeType ? [o] : o);
                else if (wt.test(o)) {
                  for (
                    a = a || u.appendChild(e.createElement('div')),
                      s = (gt.exec(o) || ['', ''])[1].toLowerCase(),
                      l = bt[s] || bt._default,
                      a.innerHTML = l[1] + S.htmlPrefilter(o) + l[2],
                      h = l[0];
                    h--;

                  )
                    a = a.lastChild;
                  S.merge(p, a.childNodes), ((a = u.firstChild).textContent = '');
                } else p.push(e.createTextNode(o));
            for (u.textContent = '', f = 0; (o = p[f++]); )
              if (n && S.inArray(o, n) > -1) i && i.push(o);
              else if (((c = st(o)), (a = xt(u.appendChild(o), 'script')), c && Et(a), r))
                for (h = 0; (o = a[h++]); ) vt.test(o.type || '') && r.push(o);
            return u;
          }
          var St = /^([^.]*)(?:\.(.+)|)/;
          function Pt() {
            return !0;
          }
          function At() {
            return !1;
          }
          function Ct(t, e) {
            return (
              (t ===
                (function () {
                  try {
                    return b.activeElement;
                  } catch (t) {}
                })()) ==
              ('focus' === e)
            );
          }
          function Tt(t, e, r, n, i, o) {
            var a, s;
            if ('object' == typeof e) {
              for (s in ('string' != typeof r && ((n = n || r), (r = void 0)), e)) Tt(t, s, r, n, e[s], o);
              return t;
            }
            if (
              (null == n && null == i
                ? ((i = r), (n = r = void 0))
                : null == i && ('string' == typeof r ? ((i = n), (n = void 0)) : ((i = n), (n = r), (r = void 0))),
              !1 === i)
            )
              i = At;
            else if (!i) return t;
            return (
              1 === o &&
                ((a = i),
                (i = function (t) {
                  return S().off(t), a.apply(this, arguments);
                }),
                (i.guid = a.guid || (a.guid = S.guid++))),
              t.each(function () {
                S.event.add(this, e, i, n, r);
              })
            );
          }
          function kt(t, e, r) {
            r
              ? (J.set(t, e, !1),
                S.event.add(t, e, {
                  namespace: !1,
                  handler: function (t) {
                    var n,
                      i,
                      o = J.get(this, e);
                    if (1 & t.isTrigger && this[e]) {
                      if (o.length) (S.event.special[e] || {}).delegateType && t.stopPropagation();
                      else if (
                        ((o = s.call(arguments)),
                        J.set(this, e, o),
                        (n = r(this, e)),
                        this[e](),
                        o !== (i = J.get(this, e)) || n ? J.set(this, e, !1) : (i = {}),
                        o !== i)
                      )
                        return t.stopImmediatePropagation(), t.preventDefault(), i && i.value;
                    } else
                      o.length &&
                        (J.set(this, e, {
                          value: S.event.trigger(S.extend(o[0], S.Event.prototype), o.slice(1), this),
                        }),
                        t.stopImmediatePropagation());
                  },
                }))
              : void 0 === J.get(t, e) && S.event.add(t, e, Pt);
          }
          (S.event = {
            global: {},
            add: function (t, e, r, n, i) {
              var o,
                a,
                s,
                l,
                c,
                h,
                u,
                p,
                f,
                d,
                m,
                y = J.get(t);
              if (K(t))
                for (
                  r.handler && ((r = (o = r).handler), (i = o.selector)),
                    i && S.find.matchesSelector(at, i),
                    r.guid || (r.guid = S.guid++),
                    (l = y.events) || (l = y.events = Object.create(null)),
                    (a = y.handle) ||
                      (a = y.handle =
                        function (e) {
                          return void 0 !== S && S.event.triggered !== e.type
                            ? S.event.dispatch.apply(t, arguments)
                            : void 0;
                        }),
                    c = (e = (e || '').match(j) || ['']).length;
                  c--;

                )
                  (f = m = (s = St.exec(e[c]) || [])[1]),
                    (d = (s[2] || '').split('.').sort()),
                    f &&
                      ((u = S.event.special[f] || {}),
                      (f = (i ? u.delegateType : u.bindType) || f),
                      (u = S.event.special[f] || {}),
                      (h = S.extend(
                        {
                          type: f,
                          origType: m,
                          data: n,
                          handler: r,
                          guid: r.guid,
                          selector: i,
                          needsContext: i && S.expr.match.needsContext.test(i),
                          namespace: d.join('.'),
                        },
                        o,
                      )),
                      (p = l[f]) ||
                        (((p = l[f] = []).delegateCount = 0),
                        (u.setup && !1 !== u.setup.call(t, n, d, a)) ||
                          (t.addEventListener && t.addEventListener(f, a))),
                      u.add && (u.add.call(t, h), h.handler.guid || (h.handler.guid = r.guid)),
                      i ? p.splice(p.delegateCount++, 0, h) : p.push(h),
                      (S.event.global[f] = !0));
            },
            remove: function (t, e, r, n, i) {
              var o,
                a,
                s,
                l,
                c,
                h,
                u,
                p,
                f,
                d,
                m,
                y = J.hasData(t) && J.get(t);
              if (y && (l = y.events)) {
                for (c = (e = (e || '').match(j) || ['']).length; c--; )
                  if (((f = m = (s = St.exec(e[c]) || [])[1]), (d = (s[2] || '').split('.').sort()), f)) {
                    for (
                      u = S.event.special[f] || {},
                        p = l[(f = (n ? u.delegateType : u.bindType) || f)] || [],
                        s = s[2] && new RegExp('(^|\\.)' + d.join('\\.(?:.*\\.|)') + '(\\.|$)'),
                        a = o = p.length;
                      o--;

                    )
                      (h = p[o]),
                        (!i && m !== h.origType) ||
                          (r && r.guid !== h.guid) ||
                          (s && !s.test(h.namespace)) ||
                          (n && n !== h.selector && ('**' !== n || !h.selector)) ||
                          (p.splice(o, 1), h.selector && p.delegateCount--, u.remove && u.remove.call(t, h));
                    a &&
                      !p.length &&
                      ((u.teardown && !1 !== u.teardown.call(t, d, y.handle)) || S.removeEvent(t, f, y.handle),
                      delete l[f]);
                  } else for (f in l) S.event.remove(t, f + e[c], r, n, !0);
                S.isEmptyObject(l) && J.remove(t, 'handle events');
              }
            },
            dispatch: function (t) {
              var e,
                r,
                n,
                i,
                o,
                a,
                s = new Array(arguments.length),
                l = S.event.fix(t),
                c = (J.get(this, 'events') || Object.create(null))[l.type] || [],
                h = S.event.special[l.type] || {};
              for (s[0] = l, e = 1; e < arguments.length; e++) s[e] = arguments[e];
              if (((l.delegateTarget = this), !h.preDispatch || !1 !== h.preDispatch.call(this, l))) {
                for (a = S.event.handlers.call(this, l, c), e = 0; (i = a[e++]) && !l.isPropagationStopped(); )
                  for (l.currentTarget = i.elem, r = 0; (o = i.handlers[r++]) && !l.isImmediatePropagationStopped(); )
                    (l.rnamespace && !1 !== o.namespace && !l.rnamespace.test(o.namespace)) ||
                      ((l.handleObj = o),
                      (l.data = o.data),
                      void 0 !== (n = ((S.event.special[o.origType] || {}).handle || o.handler).apply(i.elem, s)) &&
                        !1 === (l.result = n) &&
                        (l.preventDefault(), l.stopPropagation()));
                return h.postDispatch && h.postDispatch.call(this, l), l.result;
              }
            },
            handlers: function (t, e) {
              var r,
                n,
                i,
                o,
                a,
                s = [],
                l = e.delegateCount,
                c = t.target;
              if (l && c.nodeType && !('click' === t.type && t.button >= 1))
                for (; c !== this; c = c.parentNode || this)
                  if (1 === c.nodeType && ('click' !== t.type || !0 !== c.disabled)) {
                    for (o = [], a = {}, r = 0; r < l; r++)
                      void 0 === a[(i = (n = e[r]).selector + ' ')] &&
                        (a[i] = n.needsContext ? S(i, this).index(c) > -1 : S.find(i, this, null, [c]).length),
                        a[i] && o.push(n);
                    o.length && s.push({ elem: c, handlers: o });
                  }
              return (c = this), l < e.length && s.push({ elem: c, handlers: e.slice(l) }), s;
            },
            addProp: function (t, e) {
              Object.defineProperty(S.Event.prototype, t, {
                enumerable: !0,
                configurable: !0,
                get: g(e)
                  ? function () {
                      if (this.originalEvent) return e(this.originalEvent);
                    }
                  : function () {
                      if (this.originalEvent) return this.originalEvent[t];
                    },
                set: function (e) {
                  Object.defineProperty(this, t, { enumerable: !0, configurable: !0, writable: !0, value: e });
                },
              });
            },
            fix: function (t) {
              return t[S.expando] ? t : new S.Event(t);
            },
            special: {
              load: { noBubble: !0 },
              click: {
                setup: function (t) {
                  var e = this || t;
                  return yt.test(e.type) && e.click && D(e, 'input') && kt(e, 'click', Pt), !1;
                },
                trigger: function (t) {
                  var e = this || t;
                  return yt.test(e.type) && e.click && D(e, 'input') && kt(e, 'click'), !0;
                },
                _default: function (t) {
                  var e = t.target;
                  return (yt.test(e.type) && e.click && D(e, 'input') && J.get(e, 'click')) || D(e, 'a');
                },
              },
              beforeunload: {
                postDispatch: function (t) {
                  void 0 !== t.result && t.originalEvent && (t.originalEvent.returnValue = t.result);
                },
              },
            },
          }),
            (S.removeEvent = function (t, e, r) {
              t.removeEventListener && t.removeEventListener(e, r);
            }),
            (S.Event = function (t, e) {
              if (!(this instanceof S.Event)) return new S.Event(t, e);
              t && t.type
                ? ((this.originalEvent = t),
                  (this.type = t.type),
                  (this.isDefaultPrevented =
                    t.defaultPrevented || (void 0 === t.defaultPrevented && !1 === t.returnValue) ? Pt : At),
                  (this.target = t.target && 3 === t.target.nodeType ? t.target.parentNode : t.target),
                  (this.currentTarget = t.currentTarget),
                  (this.relatedTarget = t.relatedTarget))
                : (this.type = t),
                e && S.extend(this, e),
                (this.timeStamp = (t && t.timeStamp) || Date.now()),
                (this[S.expando] = !0);
            }),
            (S.Event.prototype = {
              constructor: S.Event,
              isDefaultPrevented: At,
              isPropagationStopped: At,
              isImmediatePropagationStopped: At,
              isSimulated: !1,
              preventDefault: function () {
                var t = this.originalEvent;
                (this.isDefaultPrevented = Pt), t && !this.isSimulated && t.preventDefault();
              },
              stopPropagation: function () {
                var t = this.originalEvent;
                (this.isPropagationStopped = Pt), t && !this.isSimulated && t.stopPropagation();
              },
              stopImmediatePropagation: function () {
                var t = this.originalEvent;
                (this.isImmediatePropagationStopped = Pt),
                  t && !this.isSimulated && t.stopImmediatePropagation(),
                  this.stopPropagation();
              },
            }),
            S.each(
              {
                altKey: !0,
                bubbles: !0,
                cancelable: !0,
                changedTouches: !0,
                ctrlKey: !0,
                detail: !0,
                eventPhase: !0,
                metaKey: !0,
                pageX: !0,
                pageY: !0,
                shiftKey: !0,
                view: !0,
                char: !0,
                code: !0,
                charCode: !0,
                key: !0,
                keyCode: !0,
                button: !0,
                buttons: !0,
                clientX: !0,
                clientY: !0,
                offsetX: !0,
                offsetY: !0,
                pointerId: !0,
                pointerType: !0,
                screenX: !0,
                screenY: !0,
                targetTouches: !0,
                toElement: !0,
                touches: !0,
                which: !0,
              },
              S.event.addProp,
            ),
            S.each({ focus: 'focusin', blur: 'focusout' }, function (t, e) {
              S.event.special[t] = {
                setup: function () {
                  return kt(this, t, Ct), !1;
                },
                trigger: function () {
                  return kt(this, t), !0;
                },
                _default: function () {
                  return !0;
                },
                delegateType: e,
              };
            }),
            S.each(
              {
                mouseenter: 'mouseover',
                mouseleave: 'mouseout',
                pointerenter: 'pointerover',
                pointerleave: 'pointerout',
              },
              function (t, e) {
                S.event.special[t] = {
                  delegateType: e,
                  bindType: e,
                  handle: function (t) {
                    var r,
                      n = this,
                      i = t.relatedTarget,
                      o = t.handleObj;
                    return (
                      (i && (i === n || S.contains(n, i))) ||
                        ((t.type = o.origType), (r = o.handler.apply(this, arguments)), (t.type = e)),
                      r
                    );
                  },
                };
              },
            ),
            S.fn.extend({
              on: function (t, e, r, n) {
                return Tt(this, t, e, r, n);
              },
              one: function (t, e, r, n) {
                return Tt(this, t, e, r, n, 1);
              },
              off: function (t, e, r) {
                var n, i;
                if (t && t.preventDefault && t.handleObj)
                  return (
                    (n = t.handleObj),
                    S(t.delegateTarget).off(
                      n.namespace ? n.origType + '.' + n.namespace : n.origType,
                      n.selector,
                      n.handler,
                    ),
                    this
                  );
                if ('object' == typeof t) {
                  for (i in t) this.off(i, e, t[i]);
                  return this;
                }
                return (
                  (!1 !== e && 'function' != typeof e) || ((r = e), (e = void 0)),
                  !1 === r && (r = At),
                  this.each(function () {
                    S.event.remove(this, t, r, e);
                  })
                );
              },
            });
          var Dt = /<script|<style|<link/i,
            Mt = /checked\s*(?:[^=]|=\s*.checked.)/i,
            It = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
          function Ft(t, e) {
            return (D(t, 'table') && D(11 !== e.nodeType ? e : e.firstChild, 'tr') && S(t).children('tbody')[0]) || t;
          }
          function Lt(t) {
            return (t.type = (null !== t.getAttribute('type')) + '/' + t.type), t;
          }
          function Rt(t) {
            return 'true/' === (t.type || '').slice(0, 5) ? (t.type = t.type.slice(5)) : t.removeAttribute('type'), t;
          }
          function Ot(t, e) {
            var r, n, i, o, a, s;
            if (1 === e.nodeType) {
              if (J.hasData(t) && (s = J.get(t).events))
                for (i in (J.remove(e, 'handle events'), s))
                  for (r = 0, n = s[i].length; r < n; r++) S.event.add(e, i, s[i][r]);
              Q.hasData(t) && ((o = Q.access(t)), (a = S.extend({}, o)), Q.set(e, a));
            }
          }
          function Bt(t, e) {
            var r = e.nodeName.toLowerCase();
            'input' === r && yt.test(t.type)
              ? (e.checked = t.checked)
              : ('input' !== r && 'textarea' !== r) || (e.defaultValue = t.defaultValue);
          }
          function jt(t, e, r, n) {
            e = l(e);
            var i,
              o,
              a,
              s,
              c,
              h,
              u = 0,
              p = t.length,
              f = p - 1,
              d = e[0],
              m = g(d);
            if (m || (p > 1 && 'string' == typeof d && !y.checkClone && Mt.test(d)))
              return t.each(function (i) {
                var o = t.eq(i);
                m && (e[0] = d.call(this, i, o.html())), jt(o, e, r, n);
              });
            if (
              p &&
              ((o = (i = _t(e, t[0].ownerDocument, !1, t, n)).firstChild), 1 === i.childNodes.length && (i = o), o || n)
            ) {
              for (s = (a = S.map(xt(i, 'script'), Lt)).length; u < p; u++)
                (c = i), u !== f && ((c = S.clone(c, !0, !0)), s && S.merge(a, xt(c, 'script'))), r.call(t[u], c, u);
              if (s)
                for (h = a[a.length - 1].ownerDocument, S.map(a, Rt), u = 0; u < s; u++)
                  (c = a[u]),
                    vt.test(c.type || '') &&
                      !J.access(c, 'globalEval') &&
                      S.contains(h, c) &&
                      (c.src && 'module' !== (c.type || '').toLowerCase()
                        ? S._evalUrl &&
                          !c.noModule &&
                          S._evalUrl(c.src, { nonce: c.nonce || c.getAttribute('nonce') }, h)
                        : E(c.textContent.replace(It, ''), c, h));
            }
            return t;
          }
          function Nt(t, e, r) {
            for (var n, i = e ? S.filter(e, t) : t, o = 0; null != (n = i[o]); o++)
              r || 1 !== n.nodeType || S.cleanData(xt(n)),
                n.parentNode && (r && st(n) && Et(xt(n, 'script')), n.parentNode.removeChild(n));
            return t;
          }
          S.extend({
            htmlPrefilter: function (t) {
              return t;
            },
            clone: function (t, e, r) {
              var n,
                i,
                o,
                a,
                s = t.cloneNode(!0),
                l = st(t);
              if (!(y.noCloneChecked || (1 !== t.nodeType && 11 !== t.nodeType) || S.isXMLDoc(t)))
                for (a = xt(s), n = 0, i = (o = xt(t)).length; n < i; n++) Bt(o[n], a[n]);
              if (e)
                if (r) for (o = o || xt(t), a = a || xt(s), n = 0, i = o.length; n < i; n++) Ot(o[n], a[n]);
                else Ot(t, s);
              return (a = xt(s, 'script')).length > 0 && Et(a, !l && xt(t, 'script')), s;
            },
            cleanData: function (t) {
              for (var e, r, n, i = S.event.special, o = 0; void 0 !== (r = t[o]); o++)
                if (K(r)) {
                  if ((e = r[J.expando])) {
                    if (e.events) for (n in e.events) i[n] ? S.event.remove(r, n) : S.removeEvent(r, n, e.handle);
                    r[J.expando] = void 0;
                  }
                  r[Q.expando] && (r[Q.expando] = void 0);
                }
            },
          }),
            S.fn.extend({
              detach: function (t) {
                return Nt(this, t, !0);
              },
              remove: function (t) {
                return Nt(this, t);
              },
              text: function (t) {
                return G(
                  this,
                  function (t) {
                    return void 0 === t
                      ? S.text(this)
                      : this.empty().each(function () {
                          (1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType) ||
                            (this.textContent = t);
                        });
                  },
                  null,
                  t,
                  arguments.length,
                );
              },
              append: function () {
                return jt(this, arguments, function (t) {
                  (1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType) || Ft(this, t).appendChild(t);
                });
              },
              prepend: function () {
                return jt(this, arguments, function (t) {
                  if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                    var e = Ft(this, t);
                    e.insertBefore(t, e.firstChild);
                  }
                });
              },
              before: function () {
                return jt(this, arguments, function (t) {
                  this.parentNode && this.parentNode.insertBefore(t, this);
                });
              },
              after: function () {
                return jt(this, arguments, function (t) {
                  this.parentNode && this.parentNode.insertBefore(t, this.nextSibling);
                });
              },
              empty: function () {
                for (var t, e = 0; null != (t = this[e]); e++)
                  1 === t.nodeType && (S.cleanData(xt(t, !1)), (t.textContent = ''));
                return this;
              },
              clone: function (t, e) {
                return (
                  (t = null != t && t),
                  (e = null == e ? t : e),
                  this.map(function () {
                    return S.clone(this, t, e);
                  })
                );
              },
              html: function (t) {
                return G(
                  this,
                  function (t) {
                    var e = this[0] || {},
                      r = 0,
                      n = this.length;
                    if (void 0 === t && 1 === e.nodeType) return e.innerHTML;
                    if ('string' == typeof t && !Dt.test(t) && !bt[(gt.exec(t) || ['', ''])[1].toLowerCase()]) {
                      t = S.htmlPrefilter(t);
                      try {
                        for (; r < n; r++)
                          1 === (e = this[r] || {}).nodeType && (S.cleanData(xt(e, !1)), (e.innerHTML = t));
                        e = 0;
                      } catch (t) {}
                    }
                    e && this.empty().append(t);
                  },
                  null,
                  t,
                  arguments.length,
                );
              },
              replaceWith: function () {
                var t = [];
                return jt(
                  this,
                  arguments,
                  function (e) {
                    var r = this.parentNode;
                    S.inArray(this, t) < 0 && (S.cleanData(xt(this)), r && r.replaceChild(e, this));
                  },
                  t,
                );
              },
            }),
            S.each(
              {
                appendTo: 'append',
                prependTo: 'prepend',
                insertBefore: 'before',
                insertAfter: 'after',
                replaceAll: 'replaceWith',
              },
              function (t, e) {
                S.fn[t] = function (t) {
                  for (var r, n = [], i = S(t), o = i.length - 1, a = 0; a <= o; a++)
                    (r = a === o ? this : this.clone(!0)), S(i[a])[e](r), c.apply(n, r.get());
                  return this.pushStack(n);
                };
              },
            );
          var Vt = new RegExp('^(' + nt + ')(?!px)[a-z%]+$', 'i'),
            zt = function (t) {
              var e = t.ownerDocument.defaultView;
              return (e && e.opener) || (e = n), e.getComputedStyle(t);
            },
            $t = function (t, e, r) {
              var n,
                i,
                o = {};
              for (i in e) (o[i] = t.style[i]), (t.style[i] = e[i]);
              for (i in ((n = r.call(t)), e)) t.style[i] = o[i];
              return n;
            },
            qt = new RegExp(ot.join('|'), 'i');
          function Ht(t, e, r) {
            var n,
              i,
              o,
              a,
              s = t.style;
            return (
              (r = r || zt(t)) &&
                ('' !== (a = r.getPropertyValue(e) || r[e]) || st(t) || (a = S.style(t, e)),
                !y.pixelBoxStyles() &&
                  Vt.test(a) &&
                  qt.test(e) &&
                  ((n = s.width),
                  (i = s.minWidth),
                  (o = s.maxWidth),
                  (s.minWidth = s.maxWidth = s.width = a),
                  (a = r.width),
                  (s.width = n),
                  (s.minWidth = i),
                  (s.maxWidth = o))),
              void 0 !== a ? a + '' : a
            );
          }
          function Gt(t, e) {
            return {
              get: function () {
                if (!t()) return (this.get = e).apply(this, arguments);
                delete this.get;
              },
            };
          }
          !(function () {
            function t() {
              if (h) {
                (c.style.cssText = 'position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0'),
                  (h.style.cssText =
                    'position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%'),
                  at.appendChild(c).appendChild(h);
                var t = n.getComputedStyle(h);
                (r = '1%' !== t.top),
                  (l = 12 === e(t.marginLeft)),
                  (h.style.right = '60%'),
                  (a = 36 === e(t.right)),
                  (i = 36 === e(t.width)),
                  (h.style.position = 'absolute'),
                  (o = 12 === e(h.offsetWidth / 3)),
                  at.removeChild(c),
                  (h = null);
              }
            }
            function e(t) {
              return Math.round(parseFloat(t));
            }
            var r,
              i,
              o,
              a,
              s,
              l,
              c = b.createElement('div'),
              h = b.createElement('div');
            h.style &&
              ((h.style.backgroundClip = 'content-box'),
              (h.cloneNode(!0).style.backgroundClip = ''),
              (y.clearCloneStyle = 'content-box' === h.style.backgroundClip),
              S.extend(y, {
                boxSizingReliable: function () {
                  return t(), i;
                },
                pixelBoxStyles: function () {
                  return t(), a;
                },
                pixelPosition: function () {
                  return t(), r;
                },
                reliableMarginLeft: function () {
                  return t(), l;
                },
                scrollboxSize: function () {
                  return t(), o;
                },
                reliableTrDimensions: function () {
                  var t, e, r, i;
                  return (
                    null == s &&
                      ((t = b.createElement('table')),
                      (e = b.createElement('tr')),
                      (r = b.createElement('div')),
                      (t.style.cssText = 'position:absolute;left:-11111px;border-collapse:separate'),
                      (e.style.cssText = 'border:1px solid'),
                      (e.style.height = '1px'),
                      (r.style.height = '9px'),
                      (r.style.display = 'block'),
                      at.appendChild(t).appendChild(e).appendChild(r),
                      (i = n.getComputedStyle(e)),
                      (s =
                        parseInt(i.height, 10) + parseInt(i.borderTopWidth, 10) + parseInt(i.borderBottomWidth, 10) ===
                        e.offsetHeight),
                      at.removeChild(t)),
                    s
                  );
                },
              }));
          })();
          var Wt = ['Webkit', 'Moz', 'ms'],
            Ut = b.createElement('div').style,
            Xt = {};
          function Yt(t) {
            return (
              S.cssProps[t] ||
              Xt[t] ||
              (t in Ut
                ? t
                : (Xt[t] =
                    (function (t) {
                      for (var e = t[0].toUpperCase() + t.slice(1), r = Wt.length; r--; )
                        if ((t = Wt[r] + e) in Ut) return t;
                    })(t) || t))
            );
          }
          var Kt = /^(none|table(?!-c[ea]).+)/,
            Zt = /^--/,
            Jt = { position: 'absolute', visibility: 'hidden', display: 'block' },
            Qt = { letterSpacing: '0', fontWeight: '400' };
          function te(t, e, r) {
            var n = it.exec(e);
            return n ? Math.max(0, n[2] - (r || 0)) + (n[3] || 'px') : e;
          }
          function ee(t, e, r, n, i, o) {
            var a = 'width' === e ? 1 : 0,
              s = 0,
              l = 0;
            if (r === (n ? 'border' : 'content')) return 0;
            for (; a < 4; a += 2)
              'margin' === r && (l += S.css(t, r + ot[a], !0, i)),
                n
                  ? ('content' === r && (l -= S.css(t, 'padding' + ot[a], !0, i)),
                    'margin' !== r && (l -= S.css(t, 'border' + ot[a] + 'Width', !0, i)))
                  : ((l += S.css(t, 'padding' + ot[a], !0, i)),
                    'padding' !== r
                      ? (l += S.css(t, 'border' + ot[a] + 'Width', !0, i))
                      : (s += S.css(t, 'border' + ot[a] + 'Width', !0, i)));
            return (
              !n &&
                o >= 0 &&
                (l += Math.max(0, Math.ceil(t['offset' + e[0].toUpperCase() + e.slice(1)] - o - l - s - 0.5)) || 0),
              l
            );
          }
          function re(t, e, r) {
            var n = zt(t),
              i = (!y.boxSizingReliable() || r) && 'border-box' === S.css(t, 'boxSizing', !1, n),
              o = i,
              a = Ht(t, e, n),
              s = 'offset' + e[0].toUpperCase() + e.slice(1);
            if (Vt.test(a)) {
              if (!r) return a;
              a = 'auto';
            }
            return (
              ((!y.boxSizingReliable() && i) ||
                (!y.reliableTrDimensions() && D(t, 'tr')) ||
                'auto' === a ||
                (!parseFloat(a) && 'inline' === S.css(t, 'display', !1, n))) &&
                t.getClientRects().length &&
                ((i = 'border-box' === S.css(t, 'boxSizing', !1, n)), (o = s in t) && (a = t[s])),
              (a = parseFloat(a) || 0) + ee(t, e, r || (i ? 'border' : 'content'), o, n, a) + 'px'
            );
          }
          function ne(t, e, r, n, i) {
            return new ne.prototype.init(t, e, r, n, i);
          }
          S.extend({
            cssHooks: {
              opacity: {
                get: function (t, e) {
                  if (e) {
                    var r = Ht(t, 'opacity');
                    return '' === r ? '1' : r;
                  }
                },
              },
            },
            cssNumber: {
              animationIterationCount: !0,
              columnCount: !0,
              fillOpacity: !0,
              flexGrow: !0,
              flexShrink: !0,
              fontWeight: !0,
              gridArea: !0,
              gridColumn: !0,
              gridColumnEnd: !0,
              gridColumnStart: !0,
              gridRow: !0,
              gridRowEnd: !0,
              gridRowStart: !0,
              lineHeight: !0,
              opacity: !0,
              order: !0,
              orphans: !0,
              widows: !0,
              zIndex: !0,
              zoom: !0,
            },
            cssProps: {},
            style: function (t, e, r, n) {
              if (t && 3 !== t.nodeType && 8 !== t.nodeType && t.style) {
                var i,
                  o,
                  a,
                  s = Y(e),
                  l = Zt.test(e),
                  c = t.style;
                if ((l || (e = Yt(s)), (a = S.cssHooks[e] || S.cssHooks[s]), void 0 === r))
                  return a && 'get' in a && void 0 !== (i = a.get(t, !1, n)) ? i : c[e];
                'string' == (o = typeof r) && (i = it.exec(r)) && i[1] && ((r = ht(t, e, i)), (o = 'number')),
                  null != r &&
                    r == r &&
                    ('number' !== o || l || (r += (i && i[3]) || (S.cssNumber[s] ? '' : 'px')),
                    y.clearCloneStyle || '' !== r || 0 !== e.indexOf('background') || (c[e] = 'inherit'),
                    (a && 'set' in a && void 0 === (r = a.set(t, r, n))) || (l ? c.setProperty(e, r) : (c[e] = r)));
              }
            },
            css: function (t, e, r, n) {
              var i,
                o,
                a,
                s = Y(e);
              return (
                Zt.test(e) || (e = Yt(s)),
                (a = S.cssHooks[e] || S.cssHooks[s]) && 'get' in a && (i = a.get(t, !0, r)),
                void 0 === i && (i = Ht(t, e, n)),
                'normal' === i && e in Qt && (i = Qt[e]),
                '' === r || r ? ((o = parseFloat(i)), !0 === r || isFinite(o) ? o || 0 : i) : i
              );
            },
          }),
            S.each(['height', 'width'], function (t, e) {
              S.cssHooks[e] = {
                get: function (t, r, n) {
                  if (r)
                    return !Kt.test(S.css(t, 'display')) ||
                      (t.getClientRects().length && t.getBoundingClientRect().width)
                      ? re(t, e, n)
                      : $t(t, Jt, function () {
                          return re(t, e, n);
                        });
                },
                set: function (t, r, n) {
                  var i,
                    o = zt(t),
                    a = !y.scrollboxSize() && 'absolute' === o.position,
                    s = (a || n) && 'border-box' === S.css(t, 'boxSizing', !1, o),
                    l = n ? ee(t, e, n, s, o) : 0;
                  return (
                    s &&
                      a &&
                      (l -= Math.ceil(
                        t['offset' + e[0].toUpperCase() + e.slice(1)] -
                          parseFloat(o[e]) -
                          ee(t, e, 'border', !1, o) -
                          0.5,
                      )),
                    l && (i = it.exec(r)) && 'px' !== (i[3] || 'px') && ((t.style[e] = r), (r = S.css(t, e))),
                    te(0, r, l)
                  );
                },
              };
            }),
            (S.cssHooks.marginLeft = Gt(y.reliableMarginLeft, function (t, e) {
              if (e)
                return (
                  (parseFloat(Ht(t, 'marginLeft')) ||
                    t.getBoundingClientRect().left -
                      $t(t, { marginLeft: 0 }, function () {
                        return t.getBoundingClientRect().left;
                      })) + 'px'
                );
            })),
            S.each({ margin: '', padding: '', border: 'Width' }, function (t, e) {
              (S.cssHooks[t + e] = {
                expand: function (r) {
                  for (var n = 0, i = {}, o = 'string' == typeof r ? r.split(' ') : [r]; n < 4; n++)
                    i[t + ot[n] + e] = o[n] || o[n - 2] || o[0];
                  return i;
                },
              }),
                'margin' !== t && (S.cssHooks[t + e].set = te);
            }),
            S.fn.extend({
              css: function (t, e) {
                return G(
                  this,
                  function (t, e, r) {
                    var n,
                      i,
                      o = {},
                      a = 0;
                    if (Array.isArray(e)) {
                      for (n = zt(t), i = e.length; a < i; a++) o[e[a]] = S.css(t, e[a], !1, n);
                      return o;
                    }
                    return void 0 !== r ? S.style(t, e, r) : S.css(t, e);
                  },
                  t,
                  e,
                  arguments.length > 1,
                );
              },
            }),
            (S.Tween = ne),
            (ne.prototype = {
              constructor: ne,
              init: function (t, e, r, n, i, o) {
                (this.elem = t),
                  (this.prop = r),
                  (this.easing = i || S.easing._default),
                  (this.options = e),
                  (this.start = this.now = this.cur()),
                  (this.end = n),
                  (this.unit = o || (S.cssNumber[r] ? '' : 'px'));
              },
              cur: function () {
                var t = ne.propHooks[this.prop];
                return t && t.get ? t.get(this) : ne.propHooks._default.get(this);
              },
              run: function (t) {
                var e,
                  r = ne.propHooks[this.prop];
                return (
                  this.options.duration
                    ? (this.pos = e = S.easing[this.easing](t, this.options.duration * t, 0, 1, this.options.duration))
                    : (this.pos = e = t),
                  (this.now = (this.end - this.start) * e + this.start),
                  this.options.step && this.options.step.call(this.elem, this.now, this),
                  r && r.set ? r.set(this) : ne.propHooks._default.set(this),
                  this
                );
              },
            }),
            (ne.prototype.init.prototype = ne.prototype),
            (ne.propHooks = {
              _default: {
                get: function (t) {
                  var e;
                  return 1 !== t.elem.nodeType || (null != t.elem[t.prop] && null == t.elem.style[t.prop])
                    ? t.elem[t.prop]
                    : (e = S.css(t.elem, t.prop, '')) && 'auto' !== e
                    ? e
                    : 0;
                },
                set: function (t) {
                  S.fx.step[t.prop]
                    ? S.fx.step[t.prop](t)
                    : 1 !== t.elem.nodeType || (!S.cssHooks[t.prop] && null == t.elem.style[Yt(t.prop)])
                    ? (t.elem[t.prop] = t.now)
                    : S.style(t.elem, t.prop, t.now + t.unit);
                },
              },
            }),
            (ne.propHooks.scrollTop = ne.propHooks.scrollLeft =
              {
                set: function (t) {
                  t.elem.nodeType && t.elem.parentNode && (t.elem[t.prop] = t.now);
                },
              }),
            (S.easing = {
              linear: function (t) {
                return t;
              },
              swing: function (t) {
                return 0.5 - Math.cos(t * Math.PI) / 2;
              },
              _default: 'swing',
            }),
            (S.fx = ne.prototype.init),
            (S.fx.step = {});
          var ie,
            oe,
            ae = /^(?:toggle|show|hide)$/,
            se = /queueHooks$/;
          function le() {
            oe &&
              (!1 === b.hidden && n.requestAnimationFrame
                ? n.requestAnimationFrame(le)
                : n.setTimeout(le, S.fx.interval),
              S.fx.tick());
          }
          function ce() {
            return (
              n.setTimeout(function () {
                ie = void 0;
              }),
              (ie = Date.now())
            );
          }
          function he(t, e) {
            var r,
              n = 0,
              i = { height: t };
            for (e = e ? 1 : 0; n < 4; n += 2 - e) i['margin' + (r = ot[n])] = i['padding' + r] = t;
            return e && (i.opacity = i.width = t), i;
          }
          function ue(t, e, r) {
            for (var n, i = (pe.tweeners[e] || []).concat(pe.tweeners['*']), o = 0, a = i.length; o < a; o++)
              if ((n = i[o].call(r, e, t))) return n;
          }
          function pe(t, e, r) {
            var n,
              i,
              o = 0,
              a = pe.prefilters.length,
              s = S.Deferred().always(function () {
                delete l.elem;
              }),
              l = function () {
                if (i) return !1;
                for (
                  var e = ie || ce(),
                    r = Math.max(0, c.startTime + c.duration - e),
                    n = 1 - (r / c.duration || 0),
                    o = 0,
                    a = c.tweens.length;
                  o < a;
                  o++
                )
                  c.tweens[o].run(n);
                return (
                  s.notifyWith(t, [c, n, r]),
                  n < 1 && a ? r : (a || s.notifyWith(t, [c, 1, 0]), s.resolveWith(t, [c]), !1)
                );
              },
              c = s.promise({
                elem: t,
                props: S.extend({}, e),
                opts: S.extend(!0, { specialEasing: {}, easing: S.easing._default }, r),
                originalProperties: e,
                originalOptions: r,
                startTime: ie || ce(),
                duration: r.duration,
                tweens: [],
                createTween: function (e, r) {
                  var n = S.Tween(t, c.opts, e, r, c.opts.specialEasing[e] || c.opts.easing);
                  return c.tweens.push(n), n;
                },
                stop: function (e) {
                  var r = 0,
                    n = e ? c.tweens.length : 0;
                  if (i) return this;
                  for (i = !0; r < n; r++) c.tweens[r].run(1);
                  return e ? (s.notifyWith(t, [c, 1, 0]), s.resolveWith(t, [c, e])) : s.rejectWith(t, [c, e]), this;
                },
              }),
              h = c.props;
            for (
              (function (t, e) {
                var r, n, i, o, a;
                for (r in t)
                  if (
                    ((i = e[(n = Y(r))]),
                    (o = t[r]),
                    Array.isArray(o) && ((i = o[1]), (o = t[r] = o[0])),
                    r !== n && ((t[n] = o), delete t[r]),
                    (a = S.cssHooks[n]) && ('expand' in a))
                  )
                    for (r in ((o = a.expand(o)), delete t[n], o)) (r in t) || ((t[r] = o[r]), (e[r] = i));
                  else e[n] = i;
              })(h, c.opts.specialEasing);
              o < a;
              o++
            )
              if ((n = pe.prefilters[o].call(c, t, h, c.opts)))
                return g(n.stop) && (S._queueHooks(c.elem, c.opts.queue).stop = n.stop.bind(n)), n;
            return (
              S.map(h, ue, c),
              g(c.opts.start) && c.opts.start.call(t, c),
              c.progress(c.opts.progress).done(c.opts.done, c.opts.complete).fail(c.opts.fail).always(c.opts.always),
              S.fx.timer(S.extend(l, { elem: t, anim: c, queue: c.opts.queue })),
              c
            );
          }
          (S.Animation = S.extend(pe, {
            tweeners: {
              '*': [
                function (t, e) {
                  var r = this.createTween(t, e);
                  return ht(r.elem, t, it.exec(e), r), r;
                },
              ],
            },
            tweener: function (t, e) {
              g(t) ? ((e = t), (t = ['*'])) : (t = t.match(j));
              for (var r, n = 0, i = t.length; n < i; n++)
                (r = t[n]), (pe.tweeners[r] = pe.tweeners[r] || []), pe.tweeners[r].unshift(e);
            },
            prefilters: [
              function (t, e, r) {
                var n,
                  i,
                  o,
                  a,
                  s,
                  l,
                  c,
                  h,
                  u = 'width' in e || 'height' in e,
                  p = this,
                  f = {},
                  d = t.style,
                  m = t.nodeType && ct(t),
                  y = J.get(t, 'fxshow');
                for (n in (r.queue ||
                  (null == (a = S._queueHooks(t, 'fx')).unqueued &&
                    ((a.unqueued = 0),
                    (s = a.empty.fire),
                    (a.empty.fire = function () {
                      a.unqueued || s();
                    })),
                  a.unqueued++,
                  p.always(function () {
                    p.always(function () {
                      a.unqueued--, S.queue(t, 'fx').length || a.empty.fire();
                    });
                  })),
                e))
                  if (((i = e[n]), ae.test(i))) {
                    if ((delete e[n], (o = o || 'toggle' === i), i === (m ? 'hide' : 'show'))) {
                      if ('show' !== i || !y || void 0 === y[n]) continue;
                      m = !0;
                    }
                    f[n] = (y && y[n]) || S.style(t, n);
                  }
                if ((l = !S.isEmptyObject(e)) || !S.isEmptyObject(f))
                  for (n in (u &&
                    1 === t.nodeType &&
                    ((r.overflow = [d.overflow, d.overflowX, d.overflowY]),
                    null == (c = y && y.display) && (c = J.get(t, 'display')),
                    'none' === (h = S.css(t, 'display')) &&
                      (c ? (h = c) : (ft([t], !0), (c = t.style.display || c), (h = S.css(t, 'display')), ft([t]))),
                    ('inline' === h || ('inline-block' === h && null != c)) &&
                      'none' === S.css(t, 'float') &&
                      (l ||
                        (p.done(function () {
                          d.display = c;
                        }),
                        null == c && ((h = d.display), (c = 'none' === h ? '' : h))),
                      (d.display = 'inline-block'))),
                  r.overflow &&
                    ((d.overflow = 'hidden'),
                    p.always(function () {
                      (d.overflow = r.overflow[0]), (d.overflowX = r.overflow[1]), (d.overflowY = r.overflow[2]);
                    })),
                  (l = !1),
                  f))
                    l ||
                      (y ? 'hidden' in y && (m = y.hidden) : (y = J.access(t, 'fxshow', { display: c })),
                      o && (y.hidden = !m),
                      m && ft([t], !0),
                      p.done(function () {
                        for (n in (m || ft([t]), J.remove(t, 'fxshow'), f)) S.style(t, n, f[n]);
                      })),
                      (l = ue(m ? y[n] : 0, n, p)),
                      n in y || ((y[n] = l.start), m && ((l.end = l.start), (l.start = 0)));
              },
            ],
            prefilter: function (t, e) {
              e ? pe.prefilters.unshift(t) : pe.prefilters.push(t);
            },
          })),
            (S.speed = function (t, e, r) {
              var n =
                t && 'object' == typeof t
                  ? S.extend({}, t)
                  : { complete: r || (!r && e) || (g(t) && t), duration: t, easing: (r && e) || (e && !g(e) && e) };
              return (
                S.fx.off
                  ? (n.duration = 0)
                  : 'number' != typeof n.duration &&
                    (n.duration in S.fx.speeds
                      ? (n.duration = S.fx.speeds[n.duration])
                      : (n.duration = S.fx.speeds._default)),
                (null != n.queue && !0 !== n.queue) || (n.queue = 'fx'),
                (n.old = n.complete),
                (n.complete = function () {
                  g(n.old) && n.old.call(this), n.queue && S.dequeue(this, n.queue);
                }),
                n
              );
            }),
            S.fn.extend({
              fadeTo: function (t, e, r, n) {
                return this.filter(ct).css('opacity', 0).show().end().animate({ opacity: e }, t, r, n);
              },
              animate: function (t, e, r, n) {
                var i = S.isEmptyObject(t),
                  o = S.speed(e, r, n),
                  a = function () {
                    var e = pe(this, S.extend({}, t), o);
                    (i || J.get(this, 'finish')) && e.stop(!0);
                  };
                return (a.finish = a), i || !1 === o.queue ? this.each(a) : this.queue(o.queue, a);
              },
              stop: function (t, e, r) {
                var n = function (t) {
                  var e = t.stop;
                  delete t.stop, e(r);
                };
                return (
                  'string' != typeof t && ((r = e), (e = t), (t = void 0)),
                  e && this.queue(t || 'fx', []),
                  this.each(function () {
                    var e = !0,
                      i = null != t && t + 'queueHooks',
                      o = S.timers,
                      a = J.get(this);
                    if (i) a[i] && a[i].stop && n(a[i]);
                    else for (i in a) a[i] && a[i].stop && se.test(i) && n(a[i]);
                    for (i = o.length; i--; )
                      o[i].elem !== this ||
                        (null != t && o[i].queue !== t) ||
                        (o[i].anim.stop(r), (e = !1), o.splice(i, 1));
                    (!e && r) || S.dequeue(this, t);
                  })
                );
              },
              finish: function (t) {
                return (
                  !1 !== t && (t = t || 'fx'),
                  this.each(function () {
                    var e,
                      r = J.get(this),
                      n = r[t + 'queue'],
                      i = r[t + 'queueHooks'],
                      o = S.timers,
                      a = n ? n.length : 0;
                    for (r.finish = !0, S.queue(this, t, []), i && i.stop && i.stop.call(this, !0), e = o.length; e--; )
                      o[e].elem === this && o[e].queue === t && (o[e].anim.stop(!0), o.splice(e, 1));
                    for (e = 0; e < a; e++) n[e] && n[e].finish && n[e].finish.call(this);
                    delete r.finish;
                  })
                );
              },
            }),
            S.each(['toggle', 'show', 'hide'], function (t, e) {
              var r = S.fn[e];
              S.fn[e] = function (t, n, i) {
                return null == t || 'boolean' == typeof t ? r.apply(this, arguments) : this.animate(he(e, !0), t, n, i);
              };
            }),
            S.each(
              {
                slideDown: he('show'),
                slideUp: he('hide'),
                slideToggle: he('toggle'),
                fadeIn: { opacity: 'show' },
                fadeOut: { opacity: 'hide' },
                fadeToggle: { opacity: 'toggle' },
              },
              function (t, e) {
                S.fn[t] = function (t, r, n) {
                  return this.animate(e, t, r, n);
                };
              },
            ),
            (S.timers = []),
            (S.fx.tick = function () {
              var t,
                e = 0,
                r = S.timers;
              for (ie = Date.now(); e < r.length; e++) (t = r[e])() || r[e] !== t || r.splice(e--, 1);
              r.length || S.fx.stop(), (ie = void 0);
            }),
            (S.fx.timer = function (t) {
              S.timers.push(t), S.fx.start();
            }),
            (S.fx.interval = 13),
            (S.fx.start = function () {
              oe || ((oe = !0), le());
            }),
            (S.fx.stop = function () {
              oe = null;
            }),
            (S.fx.speeds = { slow: 600, fast: 200, _default: 400 }),
            (S.fn.delay = function (t, e) {
              return (
                (t = (S.fx && S.fx.speeds[t]) || t),
                (e = e || 'fx'),
                this.queue(e, function (e, r) {
                  var i = n.setTimeout(e, t);
                  r.stop = function () {
                    n.clearTimeout(i);
                  };
                })
              );
            }),
            (function () {
              var t = b.createElement('input'),
                e = b.createElement('select').appendChild(b.createElement('option'));
              (t.type = 'checkbox'),
                (y.checkOn = '' !== t.value),
                (y.optSelected = e.selected),
                ((t = b.createElement('input')).value = 't'),
                (t.type = 'radio'),
                (y.radioValue = 't' === t.value);
            })();
          var fe,
            de = S.expr.attrHandle;
          S.fn.extend({
            attr: function (t, e) {
              return G(this, S.attr, t, e, arguments.length > 1);
            },
            removeAttr: function (t) {
              return this.each(function () {
                S.removeAttr(this, t);
              });
            },
          }),
            S.extend({
              attr: function (t, e, r) {
                var n,
                  i,
                  o = t.nodeType;
                if (3 !== o && 8 !== o && 2 !== o)
                  return void 0 === t.getAttribute
                    ? S.prop(t, e, r)
                    : ((1 === o && S.isXMLDoc(t)) ||
                        (i = S.attrHooks[e.toLowerCase()] || (S.expr.match.bool.test(e) ? fe : void 0)),
                      void 0 !== r
                        ? null === r
                          ? void S.removeAttr(t, e)
                          : i && 'set' in i && void 0 !== (n = i.set(t, r, e))
                          ? n
                          : (t.setAttribute(e, r + ''), r)
                        : i && 'get' in i && null !== (n = i.get(t, e))
                        ? n
                        : null == (n = S.find.attr(t, e))
                        ? void 0
                        : n);
              },
              attrHooks: {
                type: {
                  set: function (t, e) {
                    if (!y.radioValue && 'radio' === e && D(t, 'input')) {
                      var r = t.value;
                      return t.setAttribute('type', e), r && (t.value = r), e;
                    }
                  },
                },
              },
              removeAttr: function (t, e) {
                var r,
                  n = 0,
                  i = e && e.match(j);
                if (i && 1 === t.nodeType) for (; (r = i[n++]); ) t.removeAttribute(r);
              },
            }),
            (fe = {
              set: function (t, e, r) {
                return !1 === e ? S.removeAttr(t, r) : t.setAttribute(r, r), r;
              },
            }),
            S.each(S.expr.match.bool.source.match(/\w+/g), function (t, e) {
              var r = de[e] || S.find.attr;
              de[e] = function (t, e, n) {
                var i,
                  o,
                  a = e.toLowerCase();
                return n || ((o = de[a]), (de[a] = i), (i = null != r(t, e, n) ? a : null), (de[a] = o)), i;
              };
            });
          var me = /^(?:input|select|textarea|button)$/i,
            ye = /^(?:a|area)$/i;
          function ge(t) {
            return (t.match(j) || []).join(' ');
          }
          function ve(t) {
            return (t.getAttribute && t.getAttribute('class')) || '';
          }
          function be(t) {
            return Array.isArray(t) ? t : ('string' == typeof t && t.match(j)) || [];
          }
          S.fn.extend({
            prop: function (t, e) {
              return G(this, S.prop, t, e, arguments.length > 1);
            },
            removeProp: function (t) {
              return this.each(function () {
                delete this[S.propFix[t] || t];
              });
            },
          }),
            S.extend({
              prop: function (t, e, r) {
                var n,
                  i,
                  o = t.nodeType;
                if (3 !== o && 8 !== o && 2 !== o)
                  return (
                    (1 === o && S.isXMLDoc(t)) || ((e = S.propFix[e] || e), (i = S.propHooks[e])),
                    void 0 !== r
                      ? i && 'set' in i && void 0 !== (n = i.set(t, r, e))
                        ? n
                        : (t[e] = r)
                      : i && 'get' in i && null !== (n = i.get(t, e))
                      ? n
                      : t[e]
                  );
              },
              propHooks: {
                tabIndex: {
                  get: function (t) {
                    var e = S.find.attr(t, 'tabindex');
                    return e ? parseInt(e, 10) : me.test(t.nodeName) || (ye.test(t.nodeName) && t.href) ? 0 : -1;
                  },
                },
              },
              propFix: { for: 'htmlFor', class: 'className' },
            }),
            y.optSelected ||
              (S.propHooks.selected = {
                get: function (t) {
                  var e = t.parentNode;
                  return e && e.parentNode && e.parentNode.selectedIndex, null;
                },
                set: function (t) {
                  var e = t.parentNode;
                  e && (e.selectedIndex, e.parentNode && e.parentNode.selectedIndex);
                },
              }),
            S.each(
              [
                'tabIndex',
                'readOnly',
                'maxLength',
                'cellSpacing',
                'cellPadding',
                'rowSpan',
                'colSpan',
                'useMap',
                'frameBorder',
                'contentEditable',
              ],
              function () {
                S.propFix[this.toLowerCase()] = this;
              },
            ),
            S.fn.extend({
              addClass: function (t) {
                var e,
                  r,
                  n,
                  i,
                  o,
                  a,
                  s,
                  l = 0;
                if (g(t))
                  return this.each(function (e) {
                    S(this).addClass(t.call(this, e, ve(this)));
                  });
                if ((e = be(t)).length)
                  for (; (r = this[l++]); )
                    if (((i = ve(r)), (n = 1 === r.nodeType && ' ' + ge(i) + ' '))) {
                      for (a = 0; (o = e[a++]); ) n.indexOf(' ' + o + ' ') < 0 && (n += o + ' ');
                      i !== (s = ge(n)) && r.setAttribute('class', s);
                    }
                return this;
              },
              removeClass: function (t) {
                var e,
                  r,
                  n,
                  i,
                  o,
                  a,
                  s,
                  l = 0;
                if (g(t))
                  return this.each(function (e) {
                    S(this).removeClass(t.call(this, e, ve(this)));
                  });
                if (!arguments.length) return this.attr('class', '');
                if ((e = be(t)).length)
                  for (; (r = this[l++]); )
                    if (((i = ve(r)), (n = 1 === r.nodeType && ' ' + ge(i) + ' '))) {
                      for (a = 0; (o = e[a++]); )
                        for (; n.indexOf(' ' + o + ' ') > -1; ) n = n.replace(' ' + o + ' ', ' ');
                      i !== (s = ge(n)) && r.setAttribute('class', s);
                    }
                return this;
              },
              toggleClass: function (t, e) {
                var r = typeof t,
                  n = 'string' === r || Array.isArray(t);
                return 'boolean' == typeof e && n
                  ? e
                    ? this.addClass(t)
                    : this.removeClass(t)
                  : g(t)
                  ? this.each(function (r) {
                      S(this).toggleClass(t.call(this, r, ve(this), e), e);
                    })
                  : this.each(function () {
                      var e, i, o, a;
                      if (n)
                        for (i = 0, o = S(this), a = be(t); (e = a[i++]); )
                          o.hasClass(e) ? o.removeClass(e) : o.addClass(e);
                      else
                        (void 0 !== t && 'boolean' !== r) ||
                          ((e = ve(this)) && J.set(this, '__className__', e),
                          this.setAttribute &&
                            this.setAttribute('class', e || !1 === t ? '' : J.get(this, '__className__') || ''));
                    });
              },
              hasClass: function (t) {
                var e,
                  r,
                  n = 0;
                for (e = ' ' + t + ' '; (r = this[n++]); )
                  if (1 === r.nodeType && (' ' + ge(ve(r)) + ' ').indexOf(e) > -1) return !0;
                return !1;
              },
            });
          var xe = /\r/g;
          S.fn.extend({
            val: function (t) {
              var e,
                r,
                n,
                i = this[0];
              return arguments.length
                ? ((n = g(t)),
                  this.each(function (r) {
                    var i;
                    1 === this.nodeType &&
                      (null == (i = n ? t.call(this, r, S(this).val()) : t)
                        ? (i = '')
                        : 'number' == typeof i
                        ? (i += '')
                        : Array.isArray(i) &&
                          (i = S.map(i, function (t) {
                            return null == t ? '' : t + '';
                          })),
                      ((e = S.valHooks[this.type] || S.valHooks[this.nodeName.toLowerCase()]) &&
                        'set' in e &&
                        void 0 !== e.set(this, i, 'value')) ||
                        (this.value = i));
                  }))
                : i
                ? (e = S.valHooks[i.type] || S.valHooks[i.nodeName.toLowerCase()]) &&
                  'get' in e &&
                  void 0 !== (r = e.get(i, 'value'))
                  ? r
                  : 'string' == typeof (r = i.value)
                  ? r.replace(xe, '')
                  : null == r
                  ? ''
                  : r
                : void 0;
            },
          }),
            S.extend({
              valHooks: {
                option: {
                  get: function (t) {
                    var e = S.find.attr(t, 'value');
                    return null != e ? e : ge(S.text(t));
                  },
                },
                select: {
                  get: function (t) {
                    var e,
                      r,
                      n,
                      i = t.options,
                      o = t.selectedIndex,
                      a = 'select-one' === t.type,
                      s = a ? null : [],
                      l = a ? o + 1 : i.length;
                    for (n = o < 0 ? l : a ? o : 0; n < l; n++)
                      if (
                        ((r = i[n]).selected || n === o) &&
                        !r.disabled &&
                        (!r.parentNode.disabled || !D(r.parentNode, 'optgroup'))
                      ) {
                        if (((e = S(r).val()), a)) return e;
                        s.push(e);
                      }
                    return s;
                  },
                  set: function (t, e) {
                    for (var r, n, i = t.options, o = S.makeArray(e), a = i.length; a--; )
                      ((n = i[a]).selected = S.inArray(S.valHooks.option.get(n), o) > -1) && (r = !0);
                    return r || (t.selectedIndex = -1), o;
                  },
                },
              },
            }),
            S.each(['radio', 'checkbox'], function () {
              (S.valHooks[this] = {
                set: function (t, e) {
                  if (Array.isArray(e)) return (t.checked = S.inArray(S(t).val(), e) > -1);
                },
              }),
                y.checkOn ||
                  (S.valHooks[this].get = function (t) {
                    return null === t.getAttribute('value') ? 'on' : t.value;
                  });
            }),
            (y.focusin = 'onfocusin' in n);
          var Ee = /^(?:focusinfocus|focusoutblur)$/,
            we = function (t) {
              t.stopPropagation();
            };
          S.extend(S.event, {
            trigger: function (t, e, r, i) {
              var o,
                a,
                s,
                l,
                c,
                h,
                u,
                p,
                d = [r || b],
                m = f.call(t, 'type') ? t.type : t,
                y = f.call(t, 'namespace') ? t.namespace.split('.') : [];
              if (
                ((a = p = s = r = r || b),
                3 !== r.nodeType &&
                  8 !== r.nodeType &&
                  !Ee.test(m + S.event.triggered) &&
                  (m.indexOf('.') > -1 && ((y = m.split('.')), (m = y.shift()), y.sort()),
                  (c = m.indexOf(':') < 0 && 'on' + m),
                  ((t = t[S.expando] ? t : new S.Event(m, 'object' == typeof t && t)).isTrigger = i ? 2 : 3),
                  (t.namespace = y.join('.')),
                  (t.rnamespace = t.namespace ? new RegExp('(^|\\.)' + y.join('\\.(?:.*\\.|)') + '(\\.|$)') : null),
                  (t.result = void 0),
                  t.target || (t.target = r),
                  (e = null == e ? [t] : S.makeArray(e, [t])),
                  (u = S.event.special[m] || {}),
                  i || !u.trigger || !1 !== u.trigger.apply(r, e)))
              ) {
                if (!i && !u.noBubble && !v(r)) {
                  for (l = u.delegateType || m, Ee.test(l + m) || (a = a.parentNode); a; a = a.parentNode)
                    d.push(a), (s = a);
                  s === (r.ownerDocument || b) && d.push(s.defaultView || s.parentWindow || n);
                }
                for (o = 0; (a = d[o++]) && !t.isPropagationStopped(); )
                  (p = a),
                    (t.type = o > 1 ? l : u.bindType || m),
                    (h = (J.get(a, 'events') || Object.create(null))[t.type] && J.get(a, 'handle')) && h.apply(a, e),
                    (h = c && a[c]) &&
                      h.apply &&
                      K(a) &&
                      ((t.result = h.apply(a, e)), !1 === t.result && t.preventDefault());
                return (
                  (t.type = m),
                  i ||
                    t.isDefaultPrevented() ||
                    (u._default && !1 !== u._default.apply(d.pop(), e)) ||
                    !K(r) ||
                    (c &&
                      g(r[m]) &&
                      !v(r) &&
                      ((s = r[c]) && (r[c] = null),
                      (S.event.triggered = m),
                      t.isPropagationStopped() && p.addEventListener(m, we),
                      r[m](),
                      t.isPropagationStopped() && p.removeEventListener(m, we),
                      (S.event.triggered = void 0),
                      s && (r[c] = s))),
                  t.result
                );
              }
            },
            simulate: function (t, e, r) {
              var n = S.extend(new S.Event(), r, { type: t, isSimulated: !0 });
              S.event.trigger(n, null, e);
            },
          }),
            S.fn.extend({
              trigger: function (t, e) {
                return this.each(function () {
                  S.event.trigger(t, e, this);
                });
              },
              triggerHandler: function (t, e) {
                var r = this[0];
                if (r) return S.event.trigger(t, e, r, !0);
              },
            }),
            y.focusin ||
              S.each({ focus: 'focusin', blur: 'focusout' }, function (t, e) {
                var r = function (t) {
                  S.event.simulate(e, t.target, S.event.fix(t));
                };
                S.event.special[e] = {
                  setup: function () {
                    var n = this.ownerDocument || this.document || this,
                      i = J.access(n, e);
                    i || n.addEventListener(t, r, !0), J.access(n, e, (i || 0) + 1);
                  },
                  teardown: function () {
                    var n = this.ownerDocument || this.document || this,
                      i = J.access(n, e) - 1;
                    i ? J.access(n, e, i) : (n.removeEventListener(t, r, !0), J.remove(n, e));
                  },
                };
              });
          var _e = n.location,
            Se = { guid: Date.now() },
            Pe = /\?/;
          S.parseXML = function (t) {
            var e, r;
            if (!t || 'string' != typeof t) return null;
            try {
              e = new n.DOMParser().parseFromString(t, 'text/xml');
            } catch (t) {}
            return (
              (r = e && e.getElementsByTagName('parsererror')[0]),
              (e && !r) ||
                S.error(
                  'Invalid XML: ' +
                    (r
                      ? S.map(r.childNodes, function (t) {
                          return t.textContent;
                        }).join('\n')
                      : t),
                ),
              e
            );
          };
          var Ae = /\[\]$/,
            Ce = /\r?\n/g,
            Te = /^(?:submit|button|image|reset|file)$/i,
            ke = /^(?:input|select|textarea|keygen)/i;
          function De(t, e, r, n) {
            var i;
            if (Array.isArray(e))
              S.each(e, function (e, i) {
                r || Ae.test(t) ? n(t, i) : De(t + '[' + ('object' == typeof i && null != i ? e : '') + ']', i, r, n);
              });
            else if (r || 'object' !== w(e)) n(t, e);
            else for (i in e) De(t + '[' + i + ']', e[i], r, n);
          }
          (S.param = function (t, e) {
            var r,
              n = [],
              i = function (t, e) {
                var r = g(e) ? e() : e;
                n[n.length] = encodeURIComponent(t) + '=' + encodeURIComponent(null == r ? '' : r);
              };
            if (null == t) return '';
            if (Array.isArray(t) || (t.jquery && !S.isPlainObject(t)))
              S.each(t, function () {
                i(this.name, this.value);
              });
            else for (r in t) De(r, t[r], e, i);
            return n.join('&');
          }),
            S.fn.extend({
              serialize: function () {
                return S.param(this.serializeArray());
              },
              serializeArray: function () {
                return this.map(function () {
                  var t = S.prop(this, 'elements');
                  return t ? S.makeArray(t) : this;
                })
                  .filter(function () {
                    var t = this.type;
                    return (
                      this.name &&
                      !S(this).is(':disabled') &&
                      ke.test(this.nodeName) &&
                      !Te.test(t) &&
                      (this.checked || !yt.test(t))
                    );
                  })
                  .map(function (t, e) {
                    var r = S(this).val();
                    return null == r
                      ? null
                      : Array.isArray(r)
                      ? S.map(r, function (t) {
                          return { name: e.name, value: t.replace(Ce, '\r\n') };
                        })
                      : { name: e.name, value: r.replace(Ce, '\r\n') };
                  })
                  .get();
              },
            });
          var Me = /%20/g,
            Ie = /#.*$/,
            Fe = /([?&])_=[^&]*/,
            Le = /^(.*?):[ \t]*([^\r\n]*)$/gm,
            Re = /^(?:GET|HEAD)$/,
            Oe = /^\/\//,
            Be = {},
            je = {},
            Ne = '*/'.concat('*'),
            Ve = b.createElement('a');
          function ze(t) {
            return function (e, r) {
              'string' != typeof e && ((r = e), (e = '*'));
              var n,
                i = 0,
                o = e.toLowerCase().match(j) || [];
              if (g(r))
                for (; (n = o[i++]); )
                  '+' === n[0]
                    ? ((n = n.slice(1) || '*'), (t[n] = t[n] || []).unshift(r))
                    : (t[n] = t[n] || []).push(r);
            };
          }
          function $e(t, e, r, n) {
            var i = {},
              o = t === je;
            function a(s) {
              var l;
              return (
                (i[s] = !0),
                S.each(t[s] || [], function (t, s) {
                  var c = s(e, r, n);
                  return 'string' != typeof c || o || i[c]
                    ? o
                      ? !(l = c)
                      : void 0
                    : (e.dataTypes.unshift(c), a(c), !1);
                }),
                l
              );
            }
            return a(e.dataTypes[0]) || (!i['*'] && a('*'));
          }
          function qe(t, e) {
            var r,
              n,
              i = S.ajaxSettings.flatOptions || {};
            for (r in e) void 0 !== e[r] && ((i[r] ? t : n || (n = {}))[r] = e[r]);
            return n && S.extend(!0, t, n), t;
          }
          (Ve.href = _e.href),
            S.extend({
              active: 0,
              lastModified: {},
              etag: {},
              ajaxSettings: {
                url: _e.href,
                type: 'GET',
                isLocal: /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(_e.protocol),
                global: !0,
                processData: !0,
                async: !0,
                contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
                accepts: {
                  '*': Ne,
                  text: 'text/plain',
                  html: 'text/html',
                  xml: 'application/xml, text/xml',
                  json: 'application/json, text/javascript',
                },
                contents: { xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/ },
                responseFields: { xml: 'responseXML', text: 'responseText', json: 'responseJSON' },
                converters: { '* text': String, 'text html': !0, 'text json': JSON.parse, 'text xml': S.parseXML },
                flatOptions: { url: !0, context: !0 },
              },
              ajaxSetup: function (t, e) {
                return e ? qe(qe(t, S.ajaxSettings), e) : qe(S.ajaxSettings, t);
              },
              ajaxPrefilter: ze(Be),
              ajaxTransport: ze(je),
              ajax: function (t, e) {
                'object' == typeof t && ((e = t), (t = void 0)), (e = e || {});
                var r,
                  i,
                  o,
                  a,
                  s,
                  l,
                  c,
                  h,
                  u,
                  p,
                  f = S.ajaxSetup({}, e),
                  d = f.context || f,
                  m = f.context && (d.nodeType || d.jquery) ? S(d) : S.event,
                  y = S.Deferred(),
                  g = S.Callbacks('once memory'),
                  v = f.statusCode || {},
                  x = {},
                  E = {},
                  w = 'canceled',
                  _ = {
                    readyState: 0,
                    getResponseHeader: function (t) {
                      var e;
                      if (c) {
                        if (!a)
                          for (a = {}; (e = Le.exec(o)); )
                            a[e[1].toLowerCase() + ' '] = (a[e[1].toLowerCase() + ' '] || []).concat(e[2]);
                        e = a[t.toLowerCase() + ' '];
                      }
                      return null == e ? null : e.join(', ');
                    },
                    getAllResponseHeaders: function () {
                      return c ? o : null;
                    },
                    setRequestHeader: function (t, e) {
                      return null == c && ((t = E[t.toLowerCase()] = E[t.toLowerCase()] || t), (x[t] = e)), this;
                    },
                    overrideMimeType: function (t) {
                      return null == c && (f.mimeType = t), this;
                    },
                    statusCode: function (t) {
                      var e;
                      if (t)
                        if (c) _.always(t[_.status]);
                        else for (e in t) v[e] = [v[e], t[e]];
                      return this;
                    },
                    abort: function (t) {
                      var e = t || w;
                      return r && r.abort(e), P(0, e), this;
                    },
                  };
                if (
                  (y.promise(_),
                  (f.url = ((t || f.url || _e.href) + '').replace(Oe, _e.protocol + '//')),
                  (f.type = e.method || e.type || f.method || f.type),
                  (f.dataTypes = (f.dataType || '*').toLowerCase().match(j) || ['']),
                  null == f.crossDomain)
                ) {
                  l = b.createElement('a');
                  try {
                    (l.href = f.url),
                      (l.href = l.href),
                      (f.crossDomain = Ve.protocol + '//' + Ve.host != l.protocol + '//' + l.host);
                  } catch (t) {
                    f.crossDomain = !0;
                  }
                }
                if (
                  (f.data && f.processData && 'string' != typeof f.data && (f.data = S.param(f.data, f.traditional)),
                  $e(Be, f, e, _),
                  c)
                )
                  return _;
                for (u in ((h = S.event && f.global) && 0 == S.active++ && S.event.trigger('ajaxStart'),
                (f.type = f.type.toUpperCase()),
                (f.hasContent = !Re.test(f.type)),
                (i = f.url.replace(Ie, '')),
                f.hasContent
                  ? f.data &&
                    f.processData &&
                    0 === (f.contentType || '').indexOf('application/x-www-form-urlencoded') &&
                    (f.data = f.data.replace(Me, '+'))
                  : ((p = f.url.slice(i.length)),
                    f.data &&
                      (f.processData || 'string' == typeof f.data) &&
                      ((i += (Pe.test(i) ? '&' : '?') + f.data), delete f.data),
                    !1 === f.cache &&
                      ((i = i.replace(Fe, '$1')), (p = (Pe.test(i) ? '&' : '?') + '_=' + Se.guid++ + p)),
                    (f.url = i + p)),
                f.ifModified &&
                  (S.lastModified[i] && _.setRequestHeader('If-Modified-Since', S.lastModified[i]),
                  S.etag[i] && _.setRequestHeader('If-None-Match', S.etag[i])),
                ((f.data && f.hasContent && !1 !== f.contentType) || e.contentType) &&
                  _.setRequestHeader('Content-Type', f.contentType),
                _.setRequestHeader(
                  'Accept',
                  f.dataTypes[0] && f.accepts[f.dataTypes[0]]
                    ? f.accepts[f.dataTypes[0]] + ('*' !== f.dataTypes[0] ? ', ' + Ne + '; q=0.01' : '')
                    : f.accepts['*'],
                ),
                f.headers))
                  _.setRequestHeader(u, f.headers[u]);
                if (f.beforeSend && (!1 === f.beforeSend.call(d, _, f) || c)) return _.abort();
                if (((w = 'abort'), g.add(f.complete), _.done(f.success), _.fail(f.error), (r = $e(je, f, e, _)))) {
                  if (((_.readyState = 1), h && m.trigger('ajaxSend', [_, f]), c)) return _;
                  f.async &&
                    f.timeout > 0 &&
                    (s = n.setTimeout(function () {
                      _.abort('timeout');
                    }, f.timeout));
                  try {
                    (c = !1), r.send(x, P);
                  } catch (t) {
                    if (c) throw t;
                    P(-1, t);
                  }
                } else P(-1, 'No Transport');
                function P(t, e, a, l) {
                  var u,
                    p,
                    b,
                    x,
                    E,
                    w = e;
                  c ||
                    ((c = !0),
                    s && n.clearTimeout(s),
                    (r = void 0),
                    (o = l || ''),
                    (_.readyState = t > 0 ? 4 : 0),
                    (u = (t >= 200 && t < 300) || 304 === t),
                    a &&
                      (x = (function (t, e, r) {
                        for (var n, i, o, a, s = t.contents, l = t.dataTypes; '*' === l[0]; )
                          l.shift(), void 0 === n && (n = t.mimeType || e.getResponseHeader('Content-Type'));
                        if (n)
                          for (i in s)
                            if (s[i] && s[i].test(n)) {
                              l.unshift(i);
                              break;
                            }
                        if (l[0] in r) o = l[0];
                        else {
                          for (i in r) {
                            if (!l[0] || t.converters[i + ' ' + l[0]]) {
                              o = i;
                              break;
                            }
                            a || (a = i);
                          }
                          o = o || a;
                        }
                        if (o) return o !== l[0] && l.unshift(o), r[o];
                      })(f, _, a)),
                    !u &&
                      S.inArray('script', f.dataTypes) > -1 &&
                      S.inArray('json', f.dataTypes) < 0 &&
                      (f.converters['text script'] = function () {}),
                    (x = (function (t, e, r, n) {
                      var i,
                        o,
                        a,
                        s,
                        l,
                        c = {},
                        h = t.dataTypes.slice();
                      if (h[1]) for (a in t.converters) c[a.toLowerCase()] = t.converters[a];
                      for (o = h.shift(); o; )
                        if (
                          (t.responseFields[o] && (r[t.responseFields[o]] = e),
                          !l && n && t.dataFilter && (e = t.dataFilter(e, t.dataType)),
                          (l = o),
                          (o = h.shift()))
                        )
                          if ('*' === o) o = l;
                          else if ('*' !== l && l !== o) {
                            if (!(a = c[l + ' ' + o] || c['* ' + o]))
                              for (i in c)
                                if ((s = i.split(' '))[1] === o && (a = c[l + ' ' + s[0]] || c['* ' + s[0]])) {
                                  !0 === a ? (a = c[i]) : !0 !== c[i] && ((o = s[0]), h.unshift(s[1]));
                                  break;
                                }
                            if (!0 !== a)
                              if (a && t.throws) e = a(e);
                              else
                                try {
                                  e = a(e);
                                } catch (t) {
                                  return {
                                    state: 'parsererror',
                                    error: a ? t : 'No conversion from ' + l + ' to ' + o,
                                  };
                                }
                          }
                      return { state: 'success', data: e };
                    })(f, x, _, u)),
                    u
                      ? (f.ifModified &&
                          ((E = _.getResponseHeader('Last-Modified')) && (S.lastModified[i] = E),
                          (E = _.getResponseHeader('etag')) && (S.etag[i] = E)),
                        204 === t || 'HEAD' === f.type
                          ? (w = 'nocontent')
                          : 304 === t
                          ? (w = 'notmodified')
                          : ((w = x.state), (p = x.data), (u = !(b = x.error))))
                      : ((b = w), (!t && w) || ((w = 'error'), t < 0 && (t = 0))),
                    (_.status = t),
                    (_.statusText = (e || w) + ''),
                    u ? y.resolveWith(d, [p, w, _]) : y.rejectWith(d, [_, w, b]),
                    _.statusCode(v),
                    (v = void 0),
                    h && m.trigger(u ? 'ajaxSuccess' : 'ajaxError', [_, f, u ? p : b]),
                    g.fireWith(d, [_, w]),
                    h && (m.trigger('ajaxComplete', [_, f]), --S.active || S.event.trigger('ajaxStop')));
                }
                return _;
              },
              getJSON: function (t, e, r) {
                return S.get(t, e, r, 'json');
              },
              getScript: function (t, e) {
                return S.get(t, void 0, e, 'script');
              },
            }),
            S.each(['get', 'post'], function (t, e) {
              S[e] = function (t, r, n, i) {
                return (
                  g(r) && ((i = i || n), (n = r), (r = void 0)),
                  S.ajax(S.extend({ url: t, type: e, dataType: i, data: r, success: n }, S.isPlainObject(t) && t))
                );
              };
            }),
            S.ajaxPrefilter(function (t) {
              var e;
              for (e in t.headers) 'content-type' === e.toLowerCase() && (t.contentType = t.headers[e] || '');
            }),
            (S._evalUrl = function (t, e, r) {
              return S.ajax({
                url: t,
                type: 'GET',
                dataType: 'script',
                cache: !0,
                async: !1,
                global: !1,
                converters: { 'text script': function () {} },
                dataFilter: function (t) {
                  S.globalEval(t, e, r);
                },
              });
            }),
            S.fn.extend({
              wrapAll: function (t) {
                var e;
                return (
                  this[0] &&
                    (g(t) && (t = t.call(this[0])),
                    (e = S(t, this[0].ownerDocument).eq(0).clone(!0)),
                    this[0].parentNode && e.insertBefore(this[0]),
                    e
                      .map(function () {
                        for (var t = this; t.firstElementChild; ) t = t.firstElementChild;
                        return t;
                      })
                      .append(this)),
                  this
                );
              },
              wrapInner: function (t) {
                return g(t)
                  ? this.each(function (e) {
                      S(this).wrapInner(t.call(this, e));
                    })
                  : this.each(function () {
                      var e = S(this),
                        r = e.contents();
                      r.length ? r.wrapAll(t) : e.append(t);
                    });
              },
              wrap: function (t) {
                var e = g(t);
                return this.each(function (r) {
                  S(this).wrapAll(e ? t.call(this, r) : t);
                });
              },
              unwrap: function (t) {
                return (
                  this.parent(t)
                    .not('body')
                    .each(function () {
                      S(this).replaceWith(this.childNodes);
                    }),
                  this
                );
              },
            }),
            (S.expr.pseudos.hidden = function (t) {
              return !S.expr.pseudos.visible(t);
            }),
            (S.expr.pseudos.visible = function (t) {
              return !!(t.offsetWidth || t.offsetHeight || t.getClientRects().length);
            }),
            (S.ajaxSettings.xhr = function () {
              try {
                return new n.XMLHttpRequest();
              } catch (t) {}
            });
          var He = { 0: 200, 1223: 204 },
            Ge = S.ajaxSettings.xhr();
          (y.cors = !!Ge && 'withCredentials' in Ge),
            (y.ajax = Ge = !!Ge),
            S.ajaxTransport(function (t) {
              var e, r;
              if (y.cors || (Ge && !t.crossDomain))
                return {
                  send: function (i, o) {
                    var a,
                      s = t.xhr();
                    if ((s.open(t.type, t.url, t.async, t.username, t.password), t.xhrFields))
                      for (a in t.xhrFields) s[a] = t.xhrFields[a];
                    for (a in (t.mimeType && s.overrideMimeType && s.overrideMimeType(t.mimeType),
                    t.crossDomain || i['X-Requested-With'] || (i['X-Requested-With'] = 'XMLHttpRequest'),
                    i))
                      s.setRequestHeader(a, i[a]);
                    (e = function (t) {
                      return function () {
                        e &&
                          ((e = r = s.onload = s.onerror = s.onabort = s.ontimeout = s.onreadystatechange = null),
                          'abort' === t
                            ? s.abort()
                            : 'error' === t
                            ? 'number' != typeof s.status
                              ? o(0, 'error')
                              : o(s.status, s.statusText)
                            : o(
                                He[s.status] || s.status,
                                s.statusText,
                                'text' !== (s.responseType || 'text') || 'string' != typeof s.responseText
                                  ? { binary: s.response }
                                  : { text: s.responseText },
                                s.getAllResponseHeaders(),
                              ));
                      };
                    }),
                      (s.onload = e()),
                      (r = s.onerror = s.ontimeout = e('error')),
                      void 0 !== s.onabort
                        ? (s.onabort = r)
                        : (s.onreadystatechange = function () {
                            4 === s.readyState &&
                              n.setTimeout(function () {
                                e && r();
                              });
                          }),
                      (e = e('abort'));
                    try {
                      s.send((t.hasContent && t.data) || null);
                    } catch (t) {
                      if (e) throw t;
                    }
                  },
                  abort: function () {
                    e && e();
                  },
                };
            }),
            S.ajaxPrefilter(function (t) {
              t.crossDomain && (t.contents.script = !1);
            }),
            S.ajaxSetup({
              accepts: {
                script: 'text/javascript, application/javascript, application/ecmascript, application/x-ecmascript',
              },
              contents: { script: /\b(?:java|ecma)script\b/ },
              converters: {
                'text script': function (t) {
                  return S.globalEval(t), t;
                },
              },
            }),
            S.ajaxPrefilter('script', function (t) {
              void 0 === t.cache && (t.cache = !1), t.crossDomain && (t.type = 'GET');
            }),
            S.ajaxTransport('script', function (t) {
              var e, r;
              if (t.crossDomain || t.scriptAttrs)
                return {
                  send: function (n, i) {
                    (e = S('<script>')
                      .attr(t.scriptAttrs || {})
                      .prop({ charset: t.scriptCharset, src: t.url })
                      .on(
                        'load error',
                        (r = function (t) {
                          e.remove(), (r = null), t && i('error' === t.type ? 404 : 200, t.type);
                        }),
                      )),
                      b.head.appendChild(e[0]);
                  },
                  abort: function () {
                    r && r();
                  },
                };
            });
          var We,
            Ue = [],
            Xe = /(=)\?(?=&|$)|\?\?/;
          S.ajaxSetup({
            jsonp: 'callback',
            jsonpCallback: function () {
              var t = Ue.pop() || S.expando + '_' + Se.guid++;
              return (this[t] = !0), t;
            },
          }),
            S.ajaxPrefilter('json jsonp', function (t, e, r) {
              var i,
                o,
                a,
                s =
                  !1 !== t.jsonp &&
                  (Xe.test(t.url)
                    ? 'url'
                    : 'string' == typeof t.data &&
                      0 === (t.contentType || '').indexOf('application/x-www-form-urlencoded') &&
                      Xe.test(t.data) &&
                      'data');
              if (s || 'jsonp' === t.dataTypes[0])
                return (
                  (i = t.jsonpCallback = g(t.jsonpCallback) ? t.jsonpCallback() : t.jsonpCallback),
                  s
                    ? (t[s] = t[s].replace(Xe, '$1' + i))
                    : !1 !== t.jsonp && (t.url += (Pe.test(t.url) ? '&' : '?') + t.jsonp + '=' + i),
                  (t.converters['script json'] = function () {
                    return a || S.error(i + ' was not called'), a[0];
                  }),
                  (t.dataTypes[0] = 'json'),
                  (o = n[i]),
                  (n[i] = function () {
                    a = arguments;
                  }),
                  r.always(function () {
                    void 0 === o ? S(n).removeProp(i) : (n[i] = o),
                      t[i] && ((t.jsonpCallback = e.jsonpCallback), Ue.push(i)),
                      a && g(o) && o(a[0]),
                      (a = o = void 0);
                  }),
                  'script'
                );
            }),
            (y.createHTMLDocument =
              (((We = b.implementation.createHTMLDocument('').body).innerHTML = '<form></form><form></form>'),
              2 === We.childNodes.length)),
            (S.parseHTML = function (t, e, r) {
              return 'string' != typeof t
                ? []
                : ('boolean' == typeof e && ((r = e), (e = !1)),
                  e ||
                    (y.createHTMLDocument
                      ? (((n = (e = b.implementation.createHTMLDocument('')).createElement('base')).href =
                          b.location.href),
                        e.head.appendChild(n))
                      : (e = b)),
                  (o = !r && []),
                  (i = M.exec(t))
                    ? [e.createElement(i[1])]
                    : ((i = _t([t], e, o)), o && o.length && S(o).remove(), S.merge([], i.childNodes)));
              var n, i, o;
            }),
            (S.fn.load = function (t, e, r) {
              var n,
                i,
                o,
                a = this,
                s = t.indexOf(' ');
              return (
                s > -1 && ((n = ge(t.slice(s))), (t = t.slice(0, s))),
                g(e) ? ((r = e), (e = void 0)) : e && 'object' == typeof e && (i = 'POST'),
                a.length > 0 &&
                  S.ajax({ url: t, type: i || 'GET', dataType: 'html', data: e })
                    .done(function (t) {
                      (o = arguments), a.html(n ? S('<div>').append(S.parseHTML(t)).find(n) : t);
                    })
                    .always(
                      r &&
                        function (t, e) {
                          a.each(function () {
                            r.apply(this, o || [t.responseText, e, t]);
                          });
                        },
                    ),
                this
              );
            }),
            (S.expr.pseudos.animated = function (t) {
              return S.grep(S.timers, function (e) {
                return t === e.elem;
              }).length;
            }),
            (S.offset = {
              setOffset: function (t, e, r) {
                var n,
                  i,
                  o,
                  a,
                  s,
                  l,
                  c = S.css(t, 'position'),
                  h = S(t),
                  u = {};
                'static' === c && (t.style.position = 'relative'),
                  (s = h.offset()),
                  (o = S.css(t, 'top')),
                  (l = S.css(t, 'left')),
                  ('absolute' === c || 'fixed' === c) && (o + l).indexOf('auto') > -1
                    ? ((a = (n = h.position()).top), (i = n.left))
                    : ((a = parseFloat(o) || 0), (i = parseFloat(l) || 0)),
                  g(e) && (e = e.call(t, r, S.extend({}, s))),
                  null != e.top && (u.top = e.top - s.top + a),
                  null != e.left && (u.left = e.left - s.left + i),
                  'using' in e ? e.using.call(t, u) : h.css(u);
              },
            }),
            S.fn.extend({
              offset: function (t) {
                if (arguments.length)
                  return void 0 === t
                    ? this
                    : this.each(function (e) {
                        S.offset.setOffset(this, t, e);
                      });
                var e,
                  r,
                  n = this[0];
                return n
                  ? n.getClientRects().length
                    ? ((e = n.getBoundingClientRect()),
                      (r = n.ownerDocument.defaultView),
                      { top: e.top + r.pageYOffset, left: e.left + r.pageXOffset })
                    : { top: 0, left: 0 }
                  : void 0;
              },
              position: function () {
                if (this[0]) {
                  var t,
                    e,
                    r,
                    n = this[0],
                    i = { top: 0, left: 0 };
                  if ('fixed' === S.css(n, 'position')) e = n.getBoundingClientRect();
                  else {
                    for (
                      e = this.offset(), r = n.ownerDocument, t = n.offsetParent || r.documentElement;
                      t && (t === r.body || t === r.documentElement) && 'static' === S.css(t, 'position');

                    )
                      t = t.parentNode;
                    t &&
                      t !== n &&
                      1 === t.nodeType &&
                      (((i = S(t).offset()).top += S.css(t, 'borderTopWidth', !0)),
                      (i.left += S.css(t, 'borderLeftWidth', !0)));
                  }
                  return {
                    top: e.top - i.top - S.css(n, 'marginTop', !0),
                    left: e.left - i.left - S.css(n, 'marginLeft', !0),
                  };
                }
              },
              offsetParent: function () {
                return this.map(function () {
                  for (var t = this.offsetParent; t && 'static' === S.css(t, 'position'); ) t = t.offsetParent;
                  return t || at;
                });
              },
            }),
            S.each({ scrollLeft: 'pageXOffset', scrollTop: 'pageYOffset' }, function (t, e) {
              var r = 'pageYOffset' === e;
              S.fn[t] = function (n) {
                return G(
                  this,
                  function (t, n, i) {
                    var o;
                    if ((v(t) ? (o = t) : 9 === t.nodeType && (o = t.defaultView), void 0 === i))
                      return o ? o[e] : t[n];
                    o ? o.scrollTo(r ? o.pageXOffset : i, r ? i : o.pageYOffset) : (t[n] = i);
                  },
                  t,
                  n,
                  arguments.length,
                );
              };
            }),
            S.each(['top', 'left'], function (t, e) {
              S.cssHooks[e] = Gt(y.pixelPosition, function (t, r) {
                if (r) return (r = Ht(t, e)), Vt.test(r) ? S(t).position()[e] + 'px' : r;
              });
            }),
            S.each({ Height: 'height', Width: 'width' }, function (t, e) {
              S.each({ padding: 'inner' + t, content: e, '': 'outer' + t }, function (r, n) {
                S.fn[n] = function (i, o) {
                  var a = arguments.length && (r || 'boolean' != typeof i),
                    s = r || (!0 === i || !0 === o ? 'margin' : 'border');
                  return G(
                    this,
                    function (e, r, i) {
                      var o;
                      return v(e)
                        ? 0 === n.indexOf('outer')
                          ? e['inner' + t]
                          : e.document.documentElement['client' + t]
                        : 9 === e.nodeType
                        ? ((o = e.documentElement),
                          Math.max(
                            e.body['scroll' + t],
                            o['scroll' + t],
                            e.body['offset' + t],
                            o['offset' + t],
                            o['client' + t],
                          ))
                        : void 0 === i
                        ? S.css(e, r, s)
                        : S.style(e, r, i, s);
                    },
                    e,
                    a ? i : void 0,
                    a,
                  );
                };
              });
            }),
            S.each(['ajaxStart', 'ajaxStop', 'ajaxComplete', 'ajaxError', 'ajaxSuccess', 'ajaxSend'], function (t, e) {
              S.fn[e] = function (t) {
                return this.on(e, t);
              };
            }),
            S.fn.extend({
              bind: function (t, e, r) {
                return this.on(t, null, e, r);
              },
              unbind: function (t, e) {
                return this.off(t, null, e);
              },
              delegate: function (t, e, r, n) {
                return this.on(e, t, r, n);
              },
              undelegate: function (t, e, r) {
                return 1 === arguments.length ? this.off(t, '**') : this.off(e, t || '**', r);
              },
              hover: function (t, e) {
                return this.mouseenter(t).mouseleave(e || t);
              },
            }),
            S.each(
              'blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu'.split(
                ' ',
              ),
              function (t, e) {
                S.fn[e] = function (t, r) {
                  return arguments.length > 0 ? this.on(e, null, t, r) : this.trigger(e);
                };
              },
            );
          var Ye = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
          (S.proxy = function (t, e) {
            var r, n, i;
            if (('string' == typeof e && ((r = t[e]), (e = t), (t = r)), g(t)))
              return (
                (n = s.call(arguments, 2)),
                (i = function () {
                  return t.apply(e || this, n.concat(s.call(arguments)));
                }),
                (i.guid = t.guid = t.guid || S.guid++),
                i
              );
          }),
            (S.holdReady = function (t) {
              t ? S.readyWait++ : S.ready(!0);
            }),
            (S.isArray = Array.isArray),
            (S.parseJSON = JSON.parse),
            (S.nodeName = D),
            (S.isFunction = g),
            (S.isWindow = v),
            (S.camelCase = Y),
            (S.type = w),
            (S.now = Date.now),
            (S.isNumeric = function (t) {
              var e = S.type(t);
              return ('number' === e || 'string' === e) && !isNaN(t - parseFloat(t));
            }),
            (S.trim = function (t) {
              return null == t ? '' : (t + '').replace(Ye, '');
            }),
            void 0 ===
              (r = function () {
                return S;
              }.apply(e, [])) || (t.exports = r);
          var Ke = n.jQuery,
            Ze = n.$;
          return (
            (S.noConflict = function (t) {
              return n.$ === S && (n.$ = Ze), t && n.jQuery === S && (n.jQuery = Ke), S;
            }),
            void 0 === i && (n.jQuery = n.$ = S),
            S
          );
        });
      },
      205: function (t, e, r) {
        var n =
            (function () {
              return this;
            })() || Function('return this')(),
          i = n.regeneratorRuntime && Object.getOwnPropertyNames(n).indexOf('regeneratorRuntime') >= 0,
          o = i && n.regeneratorRuntime;
        if (((n.regeneratorRuntime = void 0), (t.exports = r(666)), i)) n.regeneratorRuntime = o;
        else
          try {
            delete n.regeneratorRuntime;
          } catch (t) {
            n.regeneratorRuntime = void 0;
          }
      },
      666: function (t) {
        !(function (e) {
          'use strict';
          var r,
            n = Object.prototype,
            i = n.hasOwnProperty,
            o = 'function' == typeof Symbol ? Symbol : {},
            a = o.iterator || '@@iterator',
            s = o.asyncIterator || '@@asyncIterator',
            l = o.toStringTag || '@@toStringTag',
            c = e.regeneratorRuntime;
          if (c) t.exports = c;
          else {
            (c = e.regeneratorRuntime = t.exports).wrap = b;
            var h = 'suspendedStart',
              u = 'suspendedYield',
              p = 'executing',
              f = 'completed',
              d = {},
              m = {};
            m[a] = function () {
              return this;
            };
            var y = Object.getPrototypeOf,
              g = y && y(y(D([])));
            g && g !== n && i.call(g, a) && (m = g);
            var v = (_.prototype = E.prototype = Object.create(m));
            (w.prototype = v.constructor = _),
              (_.constructor = w),
              (_[l] = w.displayName = 'GeneratorFunction'),
              (c.isGeneratorFunction = function (t) {
                var e = 'function' == typeof t && t.constructor;
                return !!e && (e === w || 'GeneratorFunction' === (e.displayName || e.name));
              }),
              (c.mark = function (t) {
                return (
                  Object.setPrototypeOf
                    ? Object.setPrototypeOf(t, _)
                    : ((t.__proto__ = _), l in t || (t[l] = 'GeneratorFunction')),
                  (t.prototype = Object.create(v)),
                  t
                );
              }),
              (c.awrap = function (t) {
                return { __await: t };
              }),
              S(P.prototype),
              (P.prototype[s] = function () {
                return this;
              }),
              (c.AsyncIterator = P),
              (c.async = function (t, e, r, n) {
                var i = new P(b(t, e, r, n));
                return c.isGeneratorFunction(e)
                  ? i
                  : i.next().then(function (t) {
                      return t.done ? t.value : i.next();
                    });
              }),
              S(v),
              (v[l] = 'Generator'),
              (v[a] = function () {
                return this;
              }),
              (v.toString = function () {
                return '[object Generator]';
              }),
              (c.keys = function (t) {
                var e = [];
                for (var r in t) e.push(r);
                return (
                  e.reverse(),
                  function r() {
                    for (; e.length; ) {
                      var n = e.pop();
                      if (n in t) return (r.value = n), (r.done = !1), r;
                    }
                    return (r.done = !0), r;
                  }
                );
              }),
              (c.values = D),
              (k.prototype = {
                constructor: k,
                reset: function (t) {
                  if (
                    ((this.prev = 0),
                    (this.next = 0),
                    (this.sent = this._sent = r),
                    (this.done = !1),
                    (this.delegate = null),
                    (this.method = 'next'),
                    (this.arg = r),
                    this.tryEntries.forEach(T),
                    !t)
                  )
                    for (var e in this) 't' === e.charAt(0) && i.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = r);
                },
                stop: function () {
                  this.done = !0;
                  var t = this.tryEntries[0].completion;
                  if ('throw' === t.type) throw t.arg;
                  return this.rval;
                },
                dispatchException: function (t) {
                  if (this.done) throw t;
                  var e = this;
                  function n(n, i) {
                    return (s.type = 'throw'), (s.arg = t), (e.next = n), i && ((e.method = 'next'), (e.arg = r)), !!i;
                  }
                  for (var o = this.tryEntries.length - 1; o >= 0; --o) {
                    var a = this.tryEntries[o],
                      s = a.completion;
                    if ('root' === a.tryLoc) return n('end');
                    if (a.tryLoc <= this.prev) {
                      var l = i.call(a, 'catchLoc'),
                        c = i.call(a, 'finallyLoc');
                      if (l && c) {
                        if (this.prev < a.catchLoc) return n(a.catchLoc, !0);
                        if (this.prev < a.finallyLoc) return n(a.finallyLoc);
                      } else if (l) {
                        if (this.prev < a.catchLoc) return n(a.catchLoc, !0);
                      } else {
                        if (!c) throw new Error('try statement without catch or finally');
                        if (this.prev < a.finallyLoc) return n(a.finallyLoc);
                      }
                    }
                  }
                },
                abrupt: function (t, e) {
                  for (var r = this.tryEntries.length - 1; r >= 0; --r) {
                    var n = this.tryEntries[r];
                    if (n.tryLoc <= this.prev && i.call(n, 'finallyLoc') && this.prev < n.finallyLoc) {
                      var o = n;
                      break;
                    }
                  }
                  o && ('break' === t || 'continue' === t) && o.tryLoc <= e && e <= o.finallyLoc && (o = null);
                  var a = o ? o.completion : {};
                  return (
                    (a.type = t),
                    (a.arg = e),
                    o ? ((this.method = 'next'), (this.next = o.finallyLoc), d) : this.complete(a)
                  );
                },
                complete: function (t, e) {
                  if ('throw' === t.type) throw t.arg;
                  return (
                    'break' === t.type || 'continue' === t.type
                      ? (this.next = t.arg)
                      : 'return' === t.type
                      ? ((this.rval = this.arg = t.arg), (this.method = 'return'), (this.next = 'end'))
                      : 'normal' === t.type && e && (this.next = e),
                    d
                  );
                },
                finish: function (t) {
                  for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                    var r = this.tryEntries[e];
                    if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), T(r), d;
                  }
                },
                catch: function (t) {
                  for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                    var r = this.tryEntries[e];
                    if (r.tryLoc === t) {
                      var n = r.completion;
                      if ('throw' === n.type) {
                        var i = n.arg;
                        T(r);
                      }
                      return i;
                    }
                  }
                  throw new Error('illegal catch attempt');
                },
                delegateYield: function (t, e, n) {
                  return (
                    (this.delegate = { iterator: D(t), resultName: e, nextLoc: n }),
                    'next' === this.method && (this.arg = r),
                    d
                  );
                },
              });
          }
          function b(t, e, r, n) {
            var i = e && e.prototype instanceof E ? e : E,
              o = Object.create(i.prototype),
              a = new k(n || []);
            return (
              (o._invoke = (function (t, e, r) {
                var n = h;
                return function (i, o) {
                  if (n === p) throw new Error('Generator is already running');
                  if (n === f) {
                    if ('throw' === i) throw o;
                    return M();
                  }
                  for (r.method = i, r.arg = o; ; ) {
                    var a = r.delegate;
                    if (a) {
                      var s = A(a, r);
                      if (s) {
                        if (s === d) continue;
                        return s;
                      }
                    }
                    if ('next' === r.method) r.sent = r._sent = r.arg;
                    else if ('throw' === r.method) {
                      if (n === h) throw ((n = f), r.arg);
                      r.dispatchException(r.arg);
                    } else 'return' === r.method && r.abrupt('return', r.arg);
                    n = p;
                    var l = x(t, e, r);
                    if ('normal' === l.type) {
                      if (((n = r.done ? f : u), l.arg === d)) continue;
                      return { value: l.arg, done: r.done };
                    }
                    'throw' === l.type && ((n = f), (r.method = 'throw'), (r.arg = l.arg));
                  }
                };
              })(t, r, a)),
              o
            );
          }
          function x(t, e, r) {
            try {
              return { type: 'normal', arg: t.call(e, r) };
            } catch (t) {
              return { type: 'throw', arg: t };
            }
          }
          function E() {}
          function w() {}
          function _() {}
          function S(t) {
            ['next', 'throw', 'return'].forEach(function (e) {
              t[e] = function (t) {
                return this._invoke(e, t);
              };
            });
          }
          function P(t) {
            function e(r, n, o, a) {
              var s = x(t[r], t, n);
              if ('throw' !== s.type) {
                var l = s.arg,
                  c = l.value;
                return c && 'object' == typeof c && i.call(c, '__await')
                  ? Promise.resolve(c.__await).then(
                      function (t) {
                        e('next', t, o, a);
                      },
                      function (t) {
                        e('throw', t, o, a);
                      },
                    )
                  : Promise.resolve(c).then(function (t) {
                      (l.value = t), o(l);
                    }, a);
              }
              a(s.arg);
            }
            var r;
            this._invoke = function (t, n) {
              function i() {
                return new Promise(function (r, i) {
                  e(t, n, r, i);
                });
              }
              return (r = r ? r.then(i, i) : i());
            };
          }
          function A(t, e) {
            var n = t.iterator[e.method];
            if (n === r) {
              if (((e.delegate = null), 'throw' === e.method)) {
                if (t.iterator.return && ((e.method = 'return'), (e.arg = r), A(t, e), 'throw' === e.method)) return d;
                (e.method = 'throw'), (e.arg = new TypeError("The iterator does not provide a 'throw' method"));
              }
              return d;
            }
            var i = x(n, t.iterator, e.arg);
            if ('throw' === i.type) return (e.method = 'throw'), (e.arg = i.arg), (e.delegate = null), d;
            var o = i.arg;
            return o
              ? o.done
                ? ((e[t.resultName] = o.value),
                  (e.next = t.nextLoc),
                  'return' !== e.method && ((e.method = 'next'), (e.arg = r)),
                  (e.delegate = null),
                  d)
                : o
              : ((e.method = 'throw'),
                (e.arg = new TypeError('iterator result is not an object')),
                (e.delegate = null),
                d);
          }
          function C(t) {
            var e = { tryLoc: t[0] };
            1 in t && (e.catchLoc = t[1]),
              2 in t && ((e.finallyLoc = t[2]), (e.afterLoc = t[3])),
              this.tryEntries.push(e);
          }
          function T(t) {
            var e = t.completion || {};
            (e.type = 'normal'), delete e.arg, (t.completion = e);
          }
          function k(t) {
            (this.tryEntries = [{ tryLoc: 'root' }]), t.forEach(C, this), this.reset(!0);
          }
          function D(t) {
            if (t) {
              var e = t[a];
              if (e) return e.call(t);
              if ('function' == typeof t.next) return t;
              if (!isNaN(t.length)) {
                var n = -1,
                  o = function e() {
                    for (; ++n < t.length; ) if (i.call(t, n)) return (e.value = t[n]), (e.done = !1), e;
                    return (e.value = r), (e.done = !0), e;
                  };
                return (o.next = o);
              }
            }
            return { next: M };
          }
          function M() {
            return { value: r, done: !0 };
          }
        })(
          (function () {
            return this;
          })() || Function('return this')(),
        );
      },
      739: function (t) {
        t.exports = (function () {
          'use strict';
          var t = !('modify' in window.getSelection());
          function e(t) {
            return [].slice.call(t);
          }
          function r(t) {
            var n = [];
            return (
              t.nodeType === Node.TEXT_NODE && n.push(t),
              e(t.childNodes).map(function (t) {
                n = n.concat(r(t));
              }),
              n
            );
          }
          function n(t, e, r, n) {
            return (
              void 0 === e && (e = ''),
              void 0 === r && (r = ''),
              void 0 === n && (n = ''),
              { isCuted: t, fullHTML: e, cutedHTML: r, cutedWithAfterHTML: n }
            );
          }
          return function (i, o, a) {
            if ((void 0 === o && (o = 2), void 0 === a && (a = null), !i.childNodes.length)) return n(!1);
            var s,
              l,
              c,
              h,
              u,
              p,
              f,
              d = window.getSelection(),
              m = i.innerHTML,
              y = i.getBoundingClientRect().height;
            if ((d.collapse(i, 0), t))
              (l = i),
                (c = o),
                (h = document.createRange()),
                (u = r(l)),
                (p = null),
                (f = 0),
                h.setStart(u[0], 0),
                (function () {
                  for (var t = 0; t < u.length; t++)
                    for (var e = 0; e < u[t].length; e++) {
                      h.setEnd(u[t], e);
                      var r = h.getBoundingClientRect().height;
                      if ((null === p && (p = r), r !== p && (f++, (p = r)), c < f))
                        return h.setStart(u[t], e), h.setEnd(u[t], e);
                    }
                })(),
                (s = h);
            else {
              for (var g = 0; g < o; g++)
                if (
                  (d.modify('extend', 'right', 'character'),
                  d.modify('extend', 'right', 'lineboundary'),
                  !i.contains(d.focusNode))
                ) {
                  d.selectAllChildren(i);
                  break;
                }
              d.collapseToEnd(), (s = d.getRangeAt(0).cloneRange());
            }
            d.selectAllChildren(i),
              s.setEnd(d.getRangeAt(0).endContainer, d.getRangeAt(0).endOffset),
              s.cloneRange().deleteContents();
            var v = i.innerHTML,
              b = m !== v,
              x = v,
              E = i.getBoundingClientRect().height;
            if (E < y && a) {
              var w = (function (t) {
                  var r = document.createElement('DIV');
                  r.innerHTML = t;
                  var n = document.createDocumentFragment();
                  return (
                    e(r.childNodes).forEach(function (t) {
                      return n.appendChild(t);
                    }),
                    n
                  );
                })(a),
                _ = r(i),
                S = _[_.length - 1],
                P = S.length,
                A = document.createRange();
              A.setStart(S, P),
                A.setEnd(S, P),
                i.appendChild(w),
                (function () {
                  for (var t = _.length - 1; 0 <= t; t--)
                    for (var e = _[t].length - 1; 0 <= e; e--) {
                      if (i.getBoundingClientRect().height <= E) return;
                      var r = document.createRange();
                      r.setStart(_[t], e), r.setEnd(_[t], e + 1), r.deleteContents();
                      var n = _[t].parentNode;
                      n && n !== i && !n.textContent && i.removeChild(n);
                    }
                })(),
                (x = i.innerHTML);
            }
            return d.removeAllRanges(), n(b, m, v, x);
          };
        })();
      },
    },
    __webpack_module_cache__ = {};
  function __webpack_require__(t) {
    var e = __webpack_module_cache__[t];
    if (void 0 !== e) return e.exports;
    var r = (__webpack_module_cache__[t] = { exports: {} });
    return __webpack_modules__[t].call(r.exports, r, r.exports, __webpack_require__), r.exports;
  }
  (__webpack_require__.d = function (t, e) {
    for (var r in e)
      __webpack_require__.o(e, r) &&
        !__webpack_require__.o(t, r) &&
        Object.defineProperty(t, r, { enumerable: !0, get: e[r] });
  }),
    (__webpack_require__.g = (function () {
      if ('object' == typeof globalThis) return globalThis;
      try {
        return this || new Function('return this')();
      } catch (t) {
        if ('object' == typeof window) return window;
      }
    })()),
    (__webpack_require__.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    });
  var __webpack_exports__ = {};
  !(function () {
    'use strict';
    function t() {
      this.entries = [];
    }
    function e(t) {
      if ('object' != typeof t) throw new TypeError(t + ' is not an object.');
      if (0 === Object.keys(t).length && t.constructor === Object) throw new Error(t + ' is empty.');
    }
    (t.prototype.add = function (t, e, r) {
      this.entries.push({ element: t, event: e, fn: r }), t.addEventListener(e, r);
    }),
      (t.prototype.removeAll = function () {
        this.entries = this.entries.filter(function (t) {
          return t.element.removeEventListener(t.event, t.fn), !1;
        });
      });
    function r(e, r, n) {
      (this.element = e),
        (this.product = (function (t) {
          if ('object' != typeof t) throw new TypeError(t + ' is not an object.');
          if (void 0 === t.variants[0].options)
            throw new TypeError(
              'Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route',
            );
          return t;
        })(r)),
        (n = n || {}),
        (this._listeners = new t()),
        this._listeners.add(this.element, 'submit', this._onSubmit.bind(this, n)),
        (this.optionInputs = this._initInputs('[name^="options"]', n.onOptionChange)),
        (this.quantityInputs = this._initInputs('[name="quantity"]', n.onQuantityChange)),
        (this.propertyInputs = this._initInputs('[name^="properties"]', n.onPropertyChange));
    }
    (r.prototype.destroy = function () {
      this._listeners.removeAll();
    }),
      (r.prototype.options = function () {
        return (
          (t = this.optionInputs),
          (e = function (t) {
            return (t.name = /(?:^(options\[))(.*?)(?:\])/.exec(t.name)[2]), t;
          }),
          t.reduce(function (t, r) {
            return (
              (r.checked || ('radio' !== r.type && 'checkbox' !== r.type)) &&
                t.push(e({ name: r.name, value: r.value })),
              t
            );
          }, [])
        );
        var t, e;
      }),
      (r.prototype.variant = function () {
        return (function (t, r) {
          e(t);
          var n = (function (t, r) {
            e(t),
              (function (t) {
                if (!Array.isArray(t)) throw new TypeError(t + ' is not an array.');
                if (0 === t.length) return [];
                if (!t[0].hasOwnProperty('name')) throw new Error(t[0] + 'does not contain name key.');
                if ('string' != typeof t[0].name)
                  throw new TypeError(
                    'Invalid value type passed for name of option ' + t[0].name + '. Value should be string.',
                  );
              })(r);
            var n = [];
            return (
              r.forEach(function (e) {
                for (var r = 0; r < t.options.length; r++)
                  if (t.options[r].name.toLowerCase() === e.name.toLowerCase()) {
                    n[r] = e.value;
                    break;
                  }
              }),
              n
            );
          })(t, r);
          return (function (t, r) {
            return (
              e(t),
              (function (t) {
                if (Array.isArray(t) && 'object' == typeof t[0])
                  throw new Error(t + 'is not a valid array of options.');
              })(r),
              t.variants.filter(function (t) {
                return r.every(function (e, r) {
                  return t.options[r] === e;
                });
              })[0] || null
            );
          })(t, n);
        })(this.product, this.options());
      }),
      (r.prototype.properties = function () {
        var t,
          e,
          r =
            ((t = this.propertyInputs),
            (e = function (t) {
              return /(?:^(properties\[))(.*?)(?:\])/.exec(t)[2];
            }),
            t.reduce(function (t, r) {
              return (r.checked || ('radio' !== r.type && 'checkbox' !== r.type)) && (t[e(r.name)] = r.value), t;
            }, {}));
        return 0 === Object.entries(r).length ? null : r;
      }),
      (r.prototype.quantity = function () {
        return this.quantityInputs[0] ? Number.parseInt(this.quantityInputs[0].value, 10) : 1;
      }),
      (r.prototype._setIdInputValue = function (t) {
        var e = this.element.querySelector('[name="id"]');
        e || (((e = document.createElement('input')).type = 'hidden'), (e.name = 'id'), this.element.appendChild(e)),
          (e.value = t.toString());
      }),
      (r.prototype._onSubmit = function (t, e) {
        (e.dataset = this._getProductFormEventData()),
          e.dataset.variant && this._setIdInputValue(e.dataset.variant.id),
          t.onFormSubmit && t.onFormSubmit(e);
      }),
      (r.prototype._onFormEvent = function (t) {
        return void 0 === t
          ? Function.prototype
          : function (e) {
              (e.dataset = this._getProductFormEventData()), t(e);
            }.bind(this);
      }),
      (r.prototype._initInputs = function (t, e) {
        return Array.prototype.slice.call(this.element.querySelectorAll(t)).map(
          function (t) {
            return this._listeners.add(t, 'change', this._onFormEvent(e)), t;
          }.bind(this),
        );
      }),
      (r.prototype._getProductFormEventData = function () {
        return {
          options: this.options(),
          variant: this.variant(),
          properties: this.properties(),
          quantity: this.quantity(),
        };
      }),
      __webpack_require__(755);
    var n = 'data-section-id';
    function i(t, e) {
      (this.container = (function (t) {
        if (!(t instanceof Element))
          throw new TypeError(
            'Theme Sections: Attempted to load section. The section container provided is not a DOM element.',
          );
        if (null === t.getAttribute(n))
          throw new Error(
            'Theme Sections: The section container provided does not have an id assigned to the data-section-id attribute.',
          );
        return t;
      })(t)),
        (this.id = t.getAttribute(n)),
        (this.extensions = []),
        Object.assign(
          this,
          (function (t) {
            if ((void 0 !== t && 'object' != typeof t) || null === t)
              throw new TypeError('Theme Sections: The properties object provided is not a valid');
            return t;
          })(e),
        ),
        this.onLoad();
    }
    (i.prototype = {
      onLoad: Function.prototype,
      onUnload: Function.prototype,
      onSelect: Function.prototype,
      onDeselect: Function.prototype,
      onBlockSelect: Function.prototype,
      onBlockDeselect: Function.prototype,
      extend: function (t) {
        this.extensions.push(t);
        var e = Object.assign({}, t);
        delete e.init, Object.assign(this, e), 'function' == typeof t.init && t.init.apply(this);
      },
    }),
      'function' != typeof Object.assign &&
        Object.defineProperty(Object, 'assign', {
          value: function (t) {
            if (null == t) throw new TypeError('Cannot convert undefined or null to object');
            for (var e = Object(t), r = 1; r < arguments.length; r++) {
              var n = arguments[r];
              if (null != n) for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
            }
            return e;
          },
          writable: !0,
          configurable: !0,
        });
    var o = 'data-section-type';
    (window.Shopify = window.Shopify || {}),
      (window.Shopify.theme = window.Shopify.theme || {}),
      (window.Shopify.theme.sections = window.Shopify.theme.sections || {});
    var a = (window.Shopify.theme.sections.registered = window.Shopify.theme.sections.registered || {}),
      s = (window.Shopify.theme.sections.instances = window.Shopify.theme.sections.instances || []);
    function l(t) {
      var e = [];
      if (NodeList.prototype.isPrototypeOf(t) || Array.isArray(t)) var r = t[0];
      return (
        t instanceof Element || r instanceof Element
          ? u(t).forEach(function (t) {
              e = e.concat(
                s.filter(function (e) {
                  return e.container === t;
                }),
              );
            })
          : ('string' != typeof t && 'string' != typeof r) ||
            h(t).forEach(function (t) {
              e = e.concat(
                s.filter(function (e) {
                  return e.type === t;
                }),
              );
            }),
        e
      );
    }
    function c(t) {
      for (var e, r = 0; r < s.length; r++)
        if (s[r].id === t) {
          e = s[r];
          break;
        }
      return e;
    }
    function h(t) {
      return (
        '*' === t
          ? (t = Object.keys(a))
          : 'string' == typeof t
          ? (t = [t])
          : t.constructor === i
          ? (t = [t.prototype.type])
          : Array.isArray(t) &&
            t[0].constructor === i &&
            (t = t.map(function (t) {
              return t.prototype.type;
            })),
        t.map(function (t) {
          return t.toLowerCase();
        })
      );
    }
    function u(t) {
      return (
        NodeList.prototype.isPrototypeOf(t) && t.length > 0
          ? (t = Array.prototype.slice.call(t))
          : (NodeList.prototype.isPrototypeOf(t) && 0 === t.length) || null === t
          ? (t = [])
          : !Array.isArray(t) && t instanceof Element && (t = [t]),
        t
      );
    }
    window.Shopify.designMode &&
      (document.addEventListener('shopify:section:load', function (t) {
        var e,
          r,
          n = t.detail.sectionId,
          i = t.target.querySelector('[data-section-id="' + n + '"]');
        null !== i &&
          ((e = i.getAttribute(o)),
          (r = i),
          (e = h(e)),
          void 0 === r && (r = document.querySelectorAll('[data-section-type]')),
          (r = u(r)),
          e.forEach(function (t) {
            var e = a[t];
            void 0 !== e &&
              (r = r.filter(function (r) {
                return !(
                  l(r).length > 0 ||
                  null === r.getAttribute(o) ||
                  (r.getAttribute(o) === t && (s.push(new e(r)), 1))
                );
              }));
          }));
      }),
      document.addEventListener('shopify:section:unload', function (t) {
        var e = t.detail.sectionId,
          r = t.target.querySelector('[data-section-id="' + e + '"]');
        'object' == typeof l(r)[0] &&
          l(r).forEach(function (t) {
            var e = s
              .map(function (t) {
                return t.id;
              })
              .indexOf(t.id);
            s.splice(e, 1), t.onUnload();
          });
      }),
      document.addEventListener('shopify:section:select', function (t) {
        var e = c(t.detail.sectionId);
        'object' == typeof e && e.onSelect(t);
      }),
      document.addEventListener('shopify:section:deselect', function (t) {
        var e = c(t.detail.sectionId);
        'object' == typeof e && e.onDeselect(t);
      }),
      document.addEventListener('shopify:block:select', function (t) {
        var e = c(t.detail.sectionId);
        'object' == typeof e && e.onBlockSelect(t);
      }),
      document.addEventListener('shopify:block:deselect', function (t) {
        var e = c(t.detail.sectionId);
        'object' == typeof e && e.onBlockDeselect(t);
      }));
    var p = __webpack_require__(739);
    function f() {
      if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ('function' == typeof Proxy) return !0;
      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }
    function d(t, e, r) {
      return (
        (d = f()
          ? Reflect.construct
          : function (t, e, r) {
              var n = [null];
              n.push.apply(n, e);
              var i = new (Function.bind.apply(t, n))();
              return r && v(i, r.prototype), i;
            }),
        d.apply(null, arguments)
      );
    }
    function m(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        (n.enumerable = n.enumerable || !1),
          (n.configurable = !0),
          'value' in n && (n.writable = !0),
          Object.defineProperty(t, n.key, n);
      }
    }
    function y(t) {
      return (
        (y = Object.setPrototypeOf
          ? Object.getPrototypeOf
          : function (t) {
              return t.__proto__ || Object.getPrototypeOf(t);
            }),
        y(t)
      );
    }
    function g(t, e) {
      return !e || ('object' !== b(e) && 'function' != typeof e)
        ? (function (t) {
            if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return t;
          })(t)
        : e;
    }
    function v(t, e) {
      return (
        (v =
          Object.setPrototypeOf ||
          function (t, e) {
            return (t.__proto__ = e), t;
          }),
        v(t, e)
      );
    }
    var b = function (t) {
      return t && 'undefined' != typeof Symbol && t.constructor === Symbol ? 'symbol' : typeof t;
    };
    function x(t) {
      var e = 'function' == typeof Map ? new Map() : void 0;
      return (
        (x = function (t) {
          if (null === t || ((r = t), -1 === Function.toString.call(r).indexOf('[native code]'))) return t;
          var r;
          if ('function' != typeof t) throw new TypeError('Super expression must either be null or a function');
          if (void 0 !== e) {
            if (e.has(t)) return e.get(t);
            e.set(t, n);
          }
          function n() {
            return d(t, arguments, y(this).constructor);
          }
          return (
            (n.prototype = Object.create(t.prototype, {
              constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 },
            })),
            v(n, t)
          );
        }),
        x(t)
      );
    }
    var E = (function (t) {
      !(function (t, e) {
        if ('function' != typeof e && null !== e)
          throw new TypeError('Super expression must either be null or a function');
        (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })),
          e && v(t, e);
      })(a, t);
      var e,
        r,
        n,
        i,
        o =
          ((n = a),
          (i = (function () {
            if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ('function' == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (t) {
              return !1;
            }
          })()),
          function () {
            var t,
              e = y(n);
            if (i) {
              var r = y(this).constructor;
              t = Reflect.construct(e, arguments, r);
            } else t = e.apply(this, arguments);
            return g(this, t);
          });
      function a() {
        var t;
        return (
          (function (t, e) {
            if (!(t instanceof e)) throw new TypeError('Cannot call a class as a function');
          })(this, a),
          ((t = o.call(this)).isClamped = !1),
          (t.clampedLines = t.getAttribute('lines')),
          t.clampedLines
            ? ((t.elements = { content: t.querySelector('[data-content]'), button: t.querySelector('[data-button]') }),
              (t.originalContentNodes = document.createDocumentFragment()),
              t.elements.content.childNodes.forEach(function (e) {
                t.originalContentNodes.appendChild(e.cloneNode(!0));
              }),
              t.elements.button.classList.add(t.toggleClamp(!0) ? 'inline-block' : 'hidden'),
              t.elements.button.addEventListener('click', function (e) {
                e.preventDefault(), t.toggleClamp();
              }),
              t)
            : g(t)
        );
      }
      return (
        (e = a),
        (r = [
          {
            key: 'toggleClamp',
            value: function () {
              var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : void 0,
                e = void 0 === t ? !this.isClamped : Boolean(t);
              if (e && !this.isClamped) {
                var r = p(this.elements.content, this.clampedLines),
                  n = r.isCuted;
                n && (this.elements.content.lastElementChild.innerHTML += '&hellip;'), (this.isClamped = n);
              } else
                e ||
                  ((this.isClamped = !1),
                  this.elements.content.replaceChildren(this.originalContentNodes.cloneNode(!0)));
              return (this.elements.button.textContent = this.isClamped ? 'Read more' : 'Read less'), this.isClamped;
            },
          },
        ]),
        r && m(e.prototype, r),
        a
      );
    })(x(HTMLElement));
    customElements.get('line-clamp') || customElements.define('line-clamp', E);
    var w = function () {
      return (
        (w =
          Object.assign ||
          function (t) {
            for (var e, r = 1, n = arguments.length; r < n; r++)
              for (var i in (e = arguments[r])) Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
            return t;
          }),
        w.apply(this, arguments)
      );
    };
    function _(t, e, r) {
      if (r || 2 === arguments.length)
        for (var n, i = 0, o = e.length; i < o; i++)
          (!n && i in e) || (n || (n = Array.prototype.slice.call(e, 0, i)), (n[i] = e[i]));
      return t.concat(n || Array.prototype.slice.call(e));
    }
    function S(t) {
      return Array.prototype.slice.call(t);
    }
    function P(t, e) {
      var r = Math.floor(t);
      return r === e || r + 1 === e ? t : e;
    }
    function A() {
      return Date.now();
    }
    function C(t, e, r) {
      if (((e = 'data-keen-slider-' + e), null === r)) return t.removeAttribute(e);
      t.setAttribute(e, r || '');
    }
    function T(t, e) {
      return (
        (e = e || document),
        'function' == typeof t && (t = t(e)),
        Array.isArray(t)
          ? t
          : 'string' == typeof t
          ? S(e.querySelectorAll(t))
          : t instanceof HTMLElement
          ? [t]
          : t instanceof NodeList
          ? S(t)
          : []
      );
    }
    function k(t) {
      t.raw && (t = t.raw), t.cancelable && !t.defaultPrevented && t.preventDefault();
    }
    function D(t) {
      t.raw && (t = t.raw), t.stopPropagation && t.stopPropagation();
    }
    function M() {
      var t = [];
      return {
        add: function (e, r, n, i) {
          e.addListener ? e.addListener(n) : e.addEventListener(r, n, i), t.push([e, r, n, i]);
        },
        input: function (t, e, r, n) {
          this.add(
            t,
            e,
            (function (t) {
              return function (e) {
                e.nativeEvent && (e = e.nativeEvent);
                var r = e.changedTouches || [],
                  n = e.targetTouches || [],
                  i = e.detail && e.detail.x ? e.detail : null;
                return t({
                  id: i ? (i.identifier ? i.identifier : 'i') : n[0] ? (n[0] ? n[0].identifier : 'e') : 'd',
                  idChanged: i ? (i.identifier ? i.identifier : 'i') : r[0] ? (r[0] ? r[0].identifier : 'e') : 'd',
                  raw: e,
                  x: i && i.x ? i.x : n[0] ? n[0].screenX : i ? i.x : e.pageX,
                  y: i && i.y ? i.y : n[0] ? n[0].screenY : i ? i.y : e.pageY,
                });
              };
            })(r),
            n,
          );
        },
        purge: function () {
          t.forEach(function (t) {
            t[0].removeListener ? t[0].removeListener(t[2]) : t[0].removeEventListener(t[1], t[2], t[3]);
          }),
            (t = []);
        },
      };
    }
    function I(t, e, r) {
      return Math.min(Math.max(t, e), r);
    }
    function F(t) {
      return (t > 0 ? 1 : 0) - (t < 0 ? 1 : 0) || +t;
    }
    function L(t) {
      var e = t.getBoundingClientRect();
      return { height: P(e.height, t.offsetHeight), width: P(e.width, t.offsetWidth) };
    }
    function R(t, e, r, n) {
      var i = t && t[e];
      return null == i ? r : n && 'function' == typeof i ? i() : i;
    }
    function O(t) {
      return Math.round(1e6 * t) / 1e6;
    }
    function B(t) {
      var e,
        r,
        n,
        i,
        o,
        a,
        s,
        l,
        c,
        h,
        u,
        p,
        f,
        d,
        m = 1 / 0,
        y = [],
        g = null,
        v = 0;
      function b(t) {
        D(v + t);
      }
      function x(t) {
        var e = E(v + t).abs;
        return P(e) ? e : null;
      }
      function E(t) {
        var e = Math.floor(Math.abs(O(t / r))),
          n = O(((t % r) + r) % r);
        n === r && (n = 0);
        var i = F(t),
          o = s.indexOf(
            _([], s, !0).reduce(function (t, e) {
              return Math.abs(e - n) < Math.abs(t - n) ? e : t;
            }),
          ),
          l = o;
        return i < 0 && e++, o === a && ((l = 0), (e += i > 0 ? 1 : -1)), { abs: l + e * a * i, origin: o, rel: l };
      }
      function w(t, e, r) {
        var n;
        if (e || !T()) return S(t, r);
        if (!P(t)) return null;
        var i = E(null != r ? r : v),
          o = i.abs,
          s = t - i.rel,
          l = o + s;
        n = S(l);
        var c = S(l - a * F(s));
        return ((null !== c && Math.abs(c) < Math.abs(n)) || null === n) && (n = c), O(n);
      }
      function S(t, e) {
        if ((null == e && (e = O(v)), !P(t) || null === t)) return null;
        t = Math.round(t);
        var n = E(e),
          i = n.abs,
          o = n.rel,
          l = n.origin,
          c = k(t),
          h = ((e % r) + r) % r,
          u = s[l],
          p = Math.floor((t - (i - o)) / a) * r;
        return O(u - h - u + s[c] + p + (l === a ? r : 0));
      }
      function P(t) {
        return C(t) === t;
      }
      function C(t) {
        return I(t, c, h);
      }
      function T() {
        return i.loop;
      }
      function k(t) {
        return ((t % a) + a) % a;
      }
      function D(e) {
        var r;
        (r = e - v), y.push({ distance: r, timestamp: A() }), y.length > 6 && (y = y.slice(-6)), (v = O(e));
        var n = M().abs;
        if (n !== g) {
          var i = null !== g;
          (g = n), i && t.emit('slideChanged');
        }
      }
      function M(s) {
        var l = s
          ? null
          : (function () {
              if (a) {
                var t = T(),
                  e = t ? ((v % r) + r) % r : v,
                  s = (t ? v % r : v) - o[0][2],
                  l = 0 - (s < 0 && t ? r - Math.abs(s) : s),
                  m = 0,
                  y = E(v),
                  g = y.abs,
                  b = y.rel,
                  x = o[b][2],
                  w = o.map(function (e, n) {
                    var o = l + m;
                    (o < 0 - e[0] || o > 1) && (o += (Math.abs(o) > r - 1 && t ? r : 0) * F(-o));
                    var s = n - b,
                      c = F(s),
                      h = s + g;
                    t &&
                      (-1 === c && o > x && (h += a),
                      1 === c && o < x && (h -= a),
                      null !== u && h < u && (o += r),
                      null !== p && h > p && (o -= r));
                    var f = o + e[0] + e[1],
                      d = Math.max(
                        o >= 0 && f <= 1
                          ? 1
                          : f < 0 || o > 1
                          ? 0
                          : o < 0
                          ? Math.min(1, (e[0] + o) / e[0])
                          : (1 - o) / e[0],
                        0,
                      );
                    return (
                      (m += e[0] + e[1]), { abs: h, distance: i.rtl ? -1 * o + 1 - e[0] : o, portion: d, size: e[0] }
                    );
                  });
                return (
                  (g = C(g)),
                  (b = k(g)),
                  {
                    abs: C(g),
                    length: n,
                    max: d,
                    maxIdx: h,
                    min: f,
                    minIdx: c,
                    position: v,
                    progress: t ? e / r : v / n,
                    rel: b,
                    slides: w,
                    slidesLength: r,
                  }
                );
              }
            })();
        return (e.details = l), t.emit('detailsChanged'), l;
      }
      return (e = {
        absToRel: k,
        add: b,
        details: null,
        distToIdx: x,
        idxToDist: w,
        init: function (e) {
          if (
            ((function () {
              if (
                ((i = t.options),
                (o = (i.trackConfig || []).map(function (t) {
                  return [R(t, 'size', 1), R(t, 'spacing', 0), R(t, 'origin', 0)];
                })),
                (a = o.length))
              ) {
                r = O(
                  o.reduce(function (t, e) {
                    return t + e[0] + e[1];
                  }, 0),
                );
                var e,
                  c = a - 1;
                (n = O(r + o[0][2] - o[c][0] - o[c][2] - o[c][1])),
                  (s = o.reduce(function (t, r) {
                    if (!t) return [0];
                    var n = o[t.length - 1],
                      i = t[t.length - 1] + (n[0] + n[2]) + n[1];
                    return (
                      (i -= r[2]),
                      t[t.length - 1] > i && (i = t[t.length - 1]),
                      (i = O(i)),
                      t.push(i),
                      (!e || e < i) && (l = t.length - 1),
                      (e = i),
                      t
                    );
                  }, null)),
                  0 === n && (l = 0),
                  s.push(O(r));
              }
            })(),
            !a)
          )
            return M(!0);
          var y;
          !(function () {
            var e = t.options.range,
              r = t.options.loop;
            (u = c = r ? R(r, 'min', -1 / 0) : 0), (p = h = r ? R(r, 'max', m) : l);
            var n = R(e, 'min', null),
              i = R(e, 'max', null);
            n && (c = n),
              i && (h = i),
              (f = c === -1 / 0 ? c : t.track.idxToDist(c || 0, !0, 0)),
              (d = h === m ? h : w(h, !0, 0)),
              null === i && (p = h),
              R(e, 'align', !1) && h !== m && 0 === o[k(h)][2] && ((d -= 1 - o[k(h)][0]), (h = x(d - v))),
              (f = O(f)),
              (d = O(d));
          })(),
            (y = e),
            Number(y) === y ? b(S(C(e))) : M();
        },
        to: D,
        velocity: function () {
          var t = A(),
            e = y.reduce(
              function (e, r) {
                var n = r.distance,
                  i = r.timestamp;
                return (
                  t - i > 200 ||
                    (F(n) !== F(e.distance) && e.distance && (e = { distance: 0, lastTimestamp: 0, time: 0 }),
                    e.time && (e.distance += n),
                    e.lastTimestamp && (e.time += i - e.lastTimestamp),
                    (e.lastTimestamp = i)),
                  e
                );
              },
              { distance: 0, lastTimestamp: 0, time: 0 },
            );
          return e.distance / e.time || 0;
        },
      });
    }
    function j(t) {
      var e, r, n, i, o, a, s;
      function l(t) {
        return 2 * t;
      }
      function c(t) {
        return I(t, a, s);
      }
      function h(t) {
        return 1 - Math.pow(1 - t, 3);
      }
      function u() {
        d();
        var e = 'free-snap' === t.options.mode,
          r = t.track,
          a = r.velocity();
        n = F(a);
        var s = t.track.details,
          u = [];
        if (a || !e) {
          var f = p(a),
            m = f.dist,
            y = f.dur;
          if (((y = l(y)), (m *= n), e)) {
            var g = r.idxToDist(r.distToIdx(m), !0);
            g && (m = g);
          }
          u.push({ distance: m, duration: y, easing: h });
          var v = s.position,
            b = v + m;
          if (b < i || b > o) {
            var x = b < i ? i - v : o - v,
              E = 0,
              w = a;
            if (F(x) === n) {
              var _ = Math.min(Math.abs(x) / Math.abs(m), 1),
                S =
                  (function (t) {
                    return 1 - Math.pow(1 - t, 1 / 3);
                  })(_) * y;
              (u[0].earlyExit = S), (w = a * (1 - _));
            } else (u[0].earlyExit = 0), (E += x);
            var P = p(w, 100),
              A = P.dist * n;
            t.options.rubberband &&
              (u.push({ distance: A, duration: l(P.dur), easing: h }),
              u.push({ distance: -A + E, duration: 500, easing: h }));
          }
          t.animator.start(u);
        } else
          t.moveToIdx(c(s.abs), !0, {
            duration: 500,
            easing: function (t) {
              return 1 + --t * t * t * t * t;
            },
          });
      }
      function p(t, e) {
        void 0 === e && (e = 1e3);
        var r = 147e-9 + (t = Math.abs(t)) / e;
        return { dist: Math.pow(t, 2) / r, dur: t / r };
      }
      function f() {
        var e = t.track.details;
        e && ((i = e.min), (o = e.max), (a = e.minIdx), (s = e.maxIdx));
      }
      function d() {
        t.animator.stop();
      }
      t.on('updated', f),
        t.on('optionsChanged', f),
        t.on('created', f),
        t.on('dragStarted', function () {
          d(), (e = r = t.track.details.abs);
        }),
        t.on('dragEnded', function () {
          var n = t.options.mode;
          'snap' === n &&
            (function () {
              var n = t.track,
                a = t.track.details,
                s = a.position,
                l = F(n.velocity());
              (s > o || s < i) && (l = 0);
              var h = e + l;
              0 === a.slides[n.absToRel(h)].portion && (h -= l),
                e !== r && (h = r),
                F(n.idxToDist(h, !0)) !== l && (h += l),
                (h = c(h));
              var u = n.idxToDist(h, !0);
              t.animator.start([
                {
                  distance: u,
                  duration: 500,
                  easing: function (t) {
                    return 1 + --t * t * t * t * t;
                  },
                },
              ]);
            })(),
            ('free' !== n && 'free-snap' !== n) || u();
        }),
        t.on('dragged', function () {
          r = t.track.details.abs;
        });
    }
    function N(t) {
      var e,
        r,
        n,
        i,
        o,
        a,
        s,
        l,
        c,
        h,
        u,
        p,
        f,
        d,
        m,
        y,
        g,
        v,
        b = M();
      function x(f) {
        if (a && l === f.id) {
          var d = S(f);
          if (c) {
            if (!_(f)) return w(f);
            (h = d), (c = !1), t.emit('dragChecked');
          }
          if (y) return (h = d);
          k(f);
          var m = (function (e) {
            if (g === -1 / 0 && v === 1 / 0) return e;
            var n = t.track.details,
              a = n.length,
              s = n.position,
              l = I(e, g - s, v - s);
            if (0 === a) return 0;
            if (!t.options.rubberband) return l;
            if (s <= v && s >= g) return e;
            if ((s < g && r > 0) || (s > v && r < 0)) return e;
            var c = (s < g ? s - g : s - v) / a,
              h = i * a,
              u = Math.abs(c * h),
              p = Math.max(0, 1 - (u / o) * 2);
            return p * p * e;
          })((s(h - d) / i) * n);
          r = F(m);
          var b = t.track.details.position;
          ((b > g && b < v) || (b === g && r > 0) || (b === v && r < 0)) && D(f),
            (u += m),
            !p && Math.abs(u * i) > 5 && ((p = !0), C(e, 'moves', '')),
            t.track.add(m),
            (h = d),
            t.emit('dragged');
        }
      }
      function E(e) {
        !a &&
          t.track.details &&
          t.track.details.length &&
          ((p = !1), (u = 0), (a = !0), (c = !0), (l = e.id), _(e), (h = S(e)), t.emit('dragStarted'));
      }
      function w(r) {
        a && l === r.idChanged && (C(e, 'moves', null), (a = !1), t.emit('dragEnded'));
      }
      function _(t) {
        var e = P(),
          r = e ? t.y : t.x,
          n = e ? t.x : t.y,
          i = void 0 !== f && void 0 !== d && Math.abs(d - n) <= Math.abs(f - r);
        return (f = r), (d = n), i;
      }
      function S(t) {
        return P() ? t.y : t.x;
      }
      function P() {
        return t.options.vertical;
      }
      function A() {
        (i = t.size), (o = P() ? window.innerHeight : window.innerWidth);
        var e = t.track.details;
        e && ((g = e.min), (v = e.max));
      }
      function L() {
        if ((b.purge(), t.options.drag && !t.options.disabled)) {
          var r;
          (r = t.options.dragSpeed || 1),
            (s =
              'function' == typeof r
                ? r
                : function (t) {
                    return t * r;
                  }),
            (n = t.options.rtl ? -1 : 1),
            A(),
            (e = t.container),
            (function () {
              var t = 'data-keen-slider-clickable';
              T('['.concat(t, ']:not([').concat(t, '=false])'), e).map(function (t) {
                b.add(t, 'mousedown', D), b.add(t, 'touchstart', D);
              });
            })(),
            b.add(e, 'dragstart', function (t) {
              k(t);
            }),
            b.input(e, 'ksDragStart', E),
            b.input(e, 'ksDrag', x),
            b.input(e, 'ksDragEnd', w),
            b.input(e, 'mousedown', E),
            b.input(e, 'mousemove', x),
            b.input(e, 'mouseleave', w),
            b.input(e, 'mouseup', w),
            b.input(e, 'touchstart', E, { passive: !0 }),
            b.input(e, 'touchmove', x, { passive: !1 }),
            b.input(e, 'touchend', w),
            b.input(e, 'touchcancel', w),
            b.add(window, 'wheel', function (t) {
              a && k(t);
            });
          var i = 'data-keen-slider-scrollable';
          T('['.concat(i, ']:not([').concat(i, '=false])'), t.container).map(function (t) {
            return (function (t) {
              var e;
              b.input(
                t,
                'touchstart',
                function (t) {
                  (e = S(t)), (y = !0), (m = !0);
                },
                { passive: !0 },
              ),
                b.input(t, 'touchmove', function (r) {
                  var n = P(),
                    i = n ? t.scrollHeight - t.clientHeight : t.scrollWidth - t.clientWidth,
                    o = e - S(r),
                    a = n ? t.scrollTop : t.scrollLeft,
                    s = (n && 'scroll' === t.style.overflowY) || (!n && 'scroll' === t.style.overflowX);
                  if (((e = S(r)), ((o < 0 && a > 0) || (o > 0 && a < i)) && m && s)) return (y = !0);
                  (m = !1), k(r), (y = !1);
                }),
                b.input(t, 'touchend', function () {
                  y = !1;
                });
            })(t);
          });
        }
      }
      t.on('updated', A), t.on('optionsChanged', L), t.on('created', L), t.on('destroyed', b.purge);
    }
    function V(t) {
      var e,
        r,
        n = null;
      function i(e, r, n) {
        t.animator.active
          ? a(e, r, n)
          : requestAnimationFrame(function () {
              return a(e, r, n);
            });
      }
      function o() {
        i(!1, !1, r);
      }
      function a(r, i, o) {
        var a = 0,
          s = t.size,
          h = t.track.details;
        if (h && e) {
          var u = h.slides;
          e.forEach(function (t, e) {
            if (r) !n && i && l(t, null, o), c(t, null, o);
            else {
              if (!u[e]) return;
              var h = u[e].size * s;
              !n && i && l(t, h, o), c(t, u[e].distance * s - a, o), (a += h);
            }
          });
        }
      }
      function s(e) {
        return 'performance' === t.options.renderMode ? Math.round(e) : e;
      }
      function l(t, e, r) {
        var n = r ? 'height' : 'width';
        null !== e && (e = s(e) + 'px'), (t.style['min-' + n] = e), (t.style['max-' + n] = e);
      }
      function c(t, e, r) {
        if (null !== e) {
          e = s(e);
          var n = r ? e : 0;
          e = 'translate3d('.concat(r ? 0 : e, 'px, ').concat(n, 'px, 0)');
        }
        (t.style.transform = e), (t.style['-webkit-transform'] = e);
      }
      function h() {
        e && (a(!0, !0, r), (e = null)), t.on('detailsChanged', o, !0);
      }
      function u() {
        i(!1, !0, r);
      }
      function p() {
        h(),
          (r = t.options.vertical),
          t.options.disabled ||
            'custom' === t.options.renderMode ||
            ((n = 'auto' === R(t.options.slides, 'perView', null)),
            t.on('detailsChanged', o),
            (e = t.slides).length && u());
      }
      t.on('created', p),
        t.on('optionsChanged', p),
        t.on('beforeOptionsChanged', function () {
          h();
        }),
        t.on('updated', u),
        t.on('destroyed', h);
    }
    function z(t, e) {
      return function (r) {
        var n,
          i,
          o,
          a,
          s,
          l = M();
        function c(t) {
          var e;
          C(
            r.container,
            'reverse',
            'rtl' !== ((e = r.container), window.getComputedStyle(e, null).getPropertyValue('direction')) || t
              ? null
              : '',
          ),
            C(r.container, 'v', r.options.vertical && !t ? '' : null),
            C(r.container, 'disabled', r.options.disabled && !t ? '' : null);
        }
        function h() {
          u() && y();
        }
        function u() {
          var t = null;
          if (
            (a.forEach(function (e) {
              e.matches && (t = e.__media);
            }),
            t === n)
          )
            return !1;
          n || r.emit('beforeOptionsChanged'), (n = t);
          var e = t ? o.breakpoints[t] : o;
          return (r.options = w(w({}, o), e)), c(), E(), _(), v(), !0;
        }
        function p(t) {
          var e = L(t);
          return (r.options.vertical ? e.height : e.width) / r.size || 1;
        }
        function f() {
          return r.options.trackConfig.length;
        }
        function d(t) {
          for (var s in ((n = !1), (o = w(w({}, e), t)), l.purge(), (i = r.size), (a = []), o.breakpoints || [])) {
            var c = window.matchMedia(s);
            (c.__media = s), a.push(c), l.add(c, 'change', h);
          }
          l.add(window, 'orientationchange', x), l.add(window, 'resize', b), u();
        }
        function m(t) {
          r.animator.stop();
          var e = r.track.details;
          r.track.init(null != t ? t : e ? e.abs : 0);
        }
        function y(t) {
          m(t), r.emit('optionsChanged');
        }
        function g(t, e) {
          if (t) return d(t), void y(e);
          E(), _();
          var n = f();
          v(), f() !== n ? y(e) : m(e), r.emit('updated');
        }
        function v() {
          var t = r.options.slides;
          if ('function' == typeof t) return (r.options.trackConfig = t(r.size, r.slides));
          for (
            var e = r.slides,
              n = e.length,
              i = 'number' == typeof t ? t : R(t, 'number', n, !0),
              o = [],
              a = R(t, 'perView', 1, !0),
              s = R(t, 'spacing', 0, !0) / r.size || 0,
              l = 'auto' === a ? s : s / a,
              c = R(t, 'origin', 'auto'),
              h = 0,
              u = 0;
            u < i;
            u++
          ) {
            var f = 'auto' === a ? p(e[u]) : 1 / a - s + l,
              d = 'center' === c ? 0.5 - f / 2 : 'auto' === c ? 0 : c;
            o.push({ origin: d, size: f, spacing: s }), (h += f);
          }
          if (((h += s * (i - 1)), 'auto' === c && !r.options.loop && 1 !== a)) {
            var m = 0;
            o.map(function (t) {
              var e = h - m;
              return (m += t.size + s), e >= 1 || (t.origin = 1 - e - (h > 1 ? 0 : 1 - h)), t;
            });
          }
          r.options.trackConfig = o;
        }
        function b() {
          E();
          var t = r.size;
          r.options.disabled || t === i || ((i = t), g());
        }
        function x() {
          b(), setTimeout(b, 500), setTimeout(b, 2e3);
        }
        function E() {
          var t = L(r.container);
          r.size = (r.options.vertical ? t.height : t.width) || 1;
        }
        function _() {
          r.slides = T(r.options.selector, r.container);
        }
        (r.container = (s = T(t, document)).length ? s[0] : null),
          (r.destroy = function () {
            l.purge(), r.emit('destroyed'), c(!0);
          }),
          (r.prev = function () {
            r.moveToIdx(r.track.details.abs - 1, !0);
          }),
          (r.next = function () {
            r.moveToIdx(r.track.details.abs + 1, !0);
          }),
          (r.update = g),
          d(r.options);
      };
    }
    var $ = function (t, e, r) {
      try {
        return (function (t, e) {
          var r,
            n = {};
          return (
            (r = {
              emit: function (t) {
                n[t] &&
                  n[t].forEach(function (t) {
                    t(r);
                  });
                var e = r.options && r.options[t];
                e && e(r);
              },
              moveToIdx: function (t, e, n) {
                var i = r.track.idxToDist(t, e);
                if (i) {
                  var o = r.options.defaultAnimation;
                  r.animator.start([
                    {
                      distance: i,
                      duration: R(n || o, 'duration', 500),
                      easing: R(n || o, 'easing', function (t) {
                        return 1 + --t * t * t * t * t;
                      }),
                    },
                  ]);
                }
              },
              on: function (t, e, r) {
                void 0 === r && (r = !1), n[t] || (n[t] = []);
                var i = n[t].indexOf(e);
                i > -1 ? r && delete n[t][i] : r || n[t].push(e);
              },
              options: t,
            }),
            (function () {
              if (
                ((r.track = B(r)),
                (r.animator = (function (t) {
                  var e, r, n, i, o, a;
                  function s(e) {
                    a || (a = e), l(!0);
                    var o = e - a;
                    o > n && (o = n);
                    var u = i[r];
                    if (u[3] < o) return r++, s(e);
                    var p = u[2],
                      f = u[4],
                      d = u[0],
                      m = u[1] * (0, u[5])(0 === f ? 1 : (o - p) / f);
                    if ((m && t.track.to(d + m), o < n)) return h();
                    (a = null), l(!1), c(null), t.emit('animationEnded');
                  }
                  function l(t) {
                    e.active = t;
                  }
                  function c(t) {
                    e.targetIdx = t;
                  }
                  function h() {
                    var t;
                    (t = s), (o = window.requestAnimationFrame(t));
                  }
                  function u() {
                    var e;
                    (e = o),
                      window.cancelAnimationFrame(e),
                      l(!1),
                      c(null),
                      a && t.emit('animationStopped'),
                      (a = null);
                  }
                  return (e = {
                    active: !1,
                    start: function (e) {
                      if ((u(), t.track.details)) {
                        var o = 0,
                          a = t.track.details.position;
                        (r = 0),
                          (n = 0),
                          (i = e.map(function (t) {
                            var e,
                              r = a,
                              i = null !== (e = t.earlyExit) && void 0 !== e ? e : t.duration,
                              s = t.easing,
                              l = t.distance * s(i / t.duration) || 0;
                            a += l;
                            var c = n;
                            return (n += i), (o += l), [r, t.distance, c, n, t.duration, s];
                          })),
                          c(t.track.distToIdx(o)),
                          h(),
                          t.emit('animationStarted');
                      }
                    },
                    stop: u,
                    targetIdx: null,
                  });
                })(r)),
                e)
              )
                for (var t = 0, n = e; t < n.length; t++) (0, n[t])(r);
              r.track.init(r.options.initial || 0), r.emit('created');
            })(),
            r
          );
        })(
          e,
          _(
            [
              z(t, {
                drag: !0,
                mode: 'snap',
                renderMode: 'precision',
                rubberband: !0,
                selector: '.keen-slider__slide',
              }),
              V,
              N,
              j,
            ],
            r || [],
            !0,
          ),
        );
      } catch (t) {
        console.error(t);
      }
    };
    function q(t) {
      var e,
        r,
        n,
        i,
        o = function (t) {
          c(t), h(t), l(t);
        },
        a = function (t) {
          void 0 !== t && null != t && t.parentNode.removeChild(t);
        },
        s = function (t) {
          var e = document.createElement('div');
          return (
            t.split(' ').forEach(function (t) {
              return e.classList.add(t);
            }),
            e
          );
        },
        l = function (r) {
          if (r) return a(n), void a(i);
          0 != t.options.arrows &&
            ((n = s('arrow arrow--left')).addEventListener('click', function () {
              return t.prev();
            }),
            (i = s('arrow arrow--right')).addEventListener('click', function () {
              return t.next();
            }),
            e.appendChild(n),
            e.appendChild(i));
        },
        c = function (r) {
          if (r && e) {
            for (var n = e.parentNode; e.firstChild; ) n.insertBefore(e.firstChild, e);
            a(e);
          } else
            (0 == t.options.arrows && 0 == t.options.dots) ||
              ((e = s('keen-slider-navigation-wrapper')),
              t.container.parentNode.insertBefore(e, t.container),
              e.appendChild(t.container));
        },
        h = function (n) {
          n
            ? a(r)
            : 0 != t.options.dots &&
              ((r = s('dots')),
              t.track.details.slides.forEach(function (e, n) {
                var i = s('dot');
                i.addEventListener('click', function () {
                  return t.moveToIdx(n);
                }),
                  r.appendChild(i);
              }),
              e.appendChild(r));
        },
        u = function () {
          var e,
            o,
            a,
            s =
              null !==
                (a =
                  null == t || null === (e = t.track) || void 0 === e || null === (o = e.details) || void 0 === o
                    ? void 0
                    : o.rel) && void 0 !== a
                ? a
                : void 0;
          if (void 0 !== s) {
            if (t.options.arrows) {
              s <= 0 ? n.classList.add('arrow--disabled') : n.classList.remove('arrow--disabled');
              var l = t.options.slides.perView,
                c = t.track.details.slides.length;
              s + l >= c ? i.classList.add('arrow--disabled') : i.classList.remove('arrow--disabled');
            }
            t.options.dots &&
              Array.from(r.children).forEach(function (t, e) {
                e === s ? t.classList.add('dot--active') : t.classList.remove('dot--active');
              });
          }
        };
      t.on('created', function () {
        o(), u(), t.update();
      }),
        t.on('optionsChanged', function () {
          o(!0), o(), u();
        }),
        t.on('slideChanged', function () {
          u();
        }),
        t.on('updated', function () {
          u();
        }),
        t.on('destroyed', function () {
          o(!0);
        });
    }
    function H() {
      if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ('function' == typeof Proxy) return !0;
      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }
    function G(t, e, r) {
      return (
        (G = H()
          ? Reflect.construct
          : function (t, e, r) {
              var n = [null];
              n.push.apply(n, e);
              var i = new (Function.bind.apply(t, n))();
              return r && X(i, r.prototype), i;
            }),
        G.apply(null, arguments)
      );
    }
    function W(t) {
      return (
        (W = Object.setPrototypeOf
          ? Object.getPrototypeOf
          : function (t) {
              return t.__proto__ || Object.getPrototypeOf(t);
            }),
        W(t)
      );
    }
    function U(t, e) {
      return !e || ('object' !== Y(e) && 'function' != typeof e)
        ? (function (t) {
            if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return t;
          })(t)
        : e;
    }
    function X(t, e) {
      return (
        (X =
          Object.setPrototypeOf ||
          function (t, e) {
            return (t.__proto__ = e), t;
          }),
        X(t, e)
      );
    }
    var Y = function (t) {
      return t && 'undefined' != typeof Symbol && t.constructor === Symbol ? 'symbol' : typeof t;
    };
    function K(t) {
      var e = 'function' == typeof Map ? new Map() : void 0;
      return (
        (K = function (t) {
          if (null === t || ((r = t), -1 === Function.toString.call(r).indexOf('[native code]'))) return t;
          var r;
          if ('function' != typeof t) throw new TypeError('Super expression must either be null or a function');
          if (void 0 !== e) {
            if (e.has(t)) return e.get(t);
            e.set(t, n);
          }
          function n() {
            return G(t, arguments, W(this).constructor);
          }
          return (
            (n.prototype = Object.create(t.prototype, {
              constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 },
            })),
            X(n, t)
          );
        }),
        K(t)
      );
    }
    (window.KeenSlider = $), (window.KeenSlider.sliders = []);
    var Z = (function (t) {
      !(function (t, e) {
        if ('function' != typeof e && null !== e)
          throw new TypeError('Super expression must either be null or a function');
        (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })),
          e && X(t, e);
      })(i, t);
      var e,
        r,
        n =
          ((e = i),
          (r = (function () {
            if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ('function' == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (t) {
              return !1;
            }
          })()),
          function () {
            var t,
              n = W(e);
            if (r) {
              var i = W(this).constructor;
              t = Reflect.construct(n, arguments, i);
            } else t = n.apply(this, arguments);
            return U(this, t);
          });
      function i() {
        var t;
        return (
          (function (t, e) {
            if (!(t instanceof e)) throw new TypeError('Cannot call a class as a function');
          })(this, i),
          (t = n.call(this)).slider,
          t.thumbnailSlider,
          t.currentSlider,
          (t.elements = {
            mainSlider: t.querySelector('[id^="Slider-"]') || t.querySelector('[data-keen-id^="Slider-"]'),
            thumbnailSlider:
              t.querySelector('[id^="Slider-Thumbnail-"]') || t.querySelector('[data-keen-id^="Slider-Thumbnail-"]'),
          }),
          t.elements && 0 === Object.keys(t.elements).length && Object.getPrototypeOf(t.elements) === Object.prototype
            ? U(t)
            : (Object.keys(t.elements).forEach(function (e) {
                var r,
                  n = {};
                t.elements[e] &&
                  ((t.currentSlider = t.elements[e]),
                  t.currentSlider.hasAttribute('data-keen') &&
                    (n = JSON.parse(t.currentSlider.getAttribute('data-keen'))),
                  'mainSlider' == e &&
                    ((n.arrows = void 0 === n.arrows || n.arrows),
                    (t.slider = new $(t.currentSlider, n, [q])),
                    t.currentSlider.id && (window.KeenSlider.sliders[t.currentSlider.id] = t.slider)),
                  'thumbnailSlider' == e &&
                    (t.thumbnailSlider = new $(t.currentSlider, n, [
                      q,
                      ((r = t.slider),
                      function (t) {
                        var e = function (e) {
                          t.slides[e].classList.add('active');
                        };
                        t.on('created', function () {
                          e(t.track.details.rel),
                            t.slides.forEach(function (t, e) {
                              t.addEventListener('click', function () {
                                r.moveToIdx(e);
                              });
                            }),
                            r.on('animationStarted', function (r) {
                              t.slides.forEach(function (t) {
                                t.classList.remove('active');
                              });
                              var n = r.animator.targetIdx || 0;
                              e(r.track.absToRel(n)), t.moveToIdx(n);
                            });
                        });
                      }),
                    ])));
              }),
              t)
        );
      }
      return i;
    })(K(HTMLElement));
    function J(t) {
      return t.split('-')[1];
    }
    function Q(t) {
      return 'y' === t ? 'height' : 'width';
    }
    function tt(t) {
      return t.split('-')[0];
    }
    function et(t) {
      return ['top', 'bottom'].includes(tt(t)) ? 'x' : 'y';
    }
    function rt(t, e, r) {
      let { reference: n, floating: i } = t;
      const o = n.x + n.width / 2 - i.width / 2,
        a = n.y + n.height / 2 - i.height / 2,
        s = et(e),
        l = Q(s),
        c = n[l] / 2 - i[l] / 2,
        h = 'x' === s;
      let u;
      switch (tt(e)) {
        case 'top':
          u = { x: o, y: n.y - i.height };
          break;
        case 'bottom':
          u = { x: o, y: n.y + n.height };
          break;
        case 'right':
          u = { x: n.x + n.width, y: a };
          break;
        case 'left':
          u = { x: n.x - i.width, y: a };
          break;
        default:
          u = { x: n.x, y: n.y };
      }
      switch (J(e)) {
        case 'start':
          u[s] -= c * (r && h ? -1 : 1);
          break;
        case 'end':
          u[s] += c * (r && h ? -1 : 1);
      }
      return u;
    }
    function nt(t) {
      return { ...t, top: t.y, left: t.x, right: t.x + t.width, bottom: t.y + t.height };
    }
    async function it(t, e) {
      var r;
      void 0 === e && (e = {});
      const { x: n, y: i, platform: o, rects: a, elements: s, strategy: l } = t,
        {
          boundary: c = 'clippingAncestors',
          rootBoundary: h = 'viewport',
          elementContext: u = 'floating',
          altBoundary: p = !1,
          padding: f = 0,
        } = e,
        d = (function (t) {
          return 'number' != typeof t
            ? (function (t) {
                return { top: 0, right: 0, bottom: 0, left: 0, ...t };
              })(t)
            : { top: t, right: t, bottom: t, left: t };
        })(f),
        m = s[p ? ('floating' === u ? 'reference' : 'floating') : u],
        y = nt(
          await o.getClippingRect({
            element:
              null == (r = await (null == o.isElement ? void 0 : o.isElement(m))) || r
                ? m
                : m.contextElement ||
                  (await (null == o.getDocumentElement ? void 0 : o.getDocumentElement(s.floating))),
            boundary: c,
            rootBoundary: h,
            strategy: l,
          }),
        ),
        g = 'floating' === u ? { ...a.floating, x: n, y: i } : a.reference,
        v = await (null == o.getOffsetParent ? void 0 : o.getOffsetParent(s.floating)),
        b = ((await (null == o.isElement ? void 0 : o.isElement(v))) &&
          (await (null == o.getScale ? void 0 : o.getScale(v)))) || { x: 1, y: 1 },
        x = nt(
          o.convertOffsetParentRelativeRectToViewportRelativeRect
            ? await o.convertOffsetParentRelativeRectToViewportRelativeRect({ rect: g, offsetParent: v, strategy: l })
            : g,
        );
      return {
        top: (y.top - x.top + d.top) / b.y,
        bottom: (x.bottom - y.bottom + d.bottom) / b.y,
        left: (y.left - x.left + d.left) / b.x,
        right: (x.right - y.right + d.right) / b.x,
      };
    }
    customElements.define('slider-component', Z);
    const ot = Math.min,
      at = Math.max;
    function st(t, e, r) {
      return at(t, ot(e, r));
    }
    const lt = ['top', 'right', 'bottom', 'left'].reduce((t, e) => t.concat(e, e + '-start', e + '-end'), []),
      ct = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
    function ht(t) {
      return t.replace(/left|right|bottom|top/g, (t) => ct[t]);
    }
    const ut = { start: 'end', end: 'start' };
    const pt = function (t) {
        return (
          void 0 === t && (t = {}),
          {
            name: 'autoPlacement',
            options: t,
            async fn(e) {
              var r, n, i;
              const { rects: o, middlewareData: a, placement: s, platform: l, elements: c } = e,
                { crossAxis: h = !1, alignment: u, allowedPlacements: p = lt, autoAlignment: f = !0, ...d } = t,
                m =
                  void 0 !== u || p === lt
                    ? (function (t, e, r) {
                        return (
                          t
                            ? [...r.filter((e) => J(e) === t), ...r.filter((e) => J(e) !== t)]
                            : r.filter((t) => tt(t) === t)
                        ).filter(
                          (r) =>
                            !t ||
                            J(r) === t ||
                            (!!e &&
                              (function (t) {
                                return t.replace(/start|end/g, (t) => ut[t]);
                              })(r) !== r),
                        );
                      })(u || null, f, p)
                    : p,
                y = await it(e, d),
                g = (null == (r = a.autoPlacement) ? void 0 : r.index) || 0,
                v = m[g];
              if (null == v) return {};
              const { main: b, cross: x } = (function (t, e, r) {
                void 0 === r && (r = !1);
                const n = J(t),
                  i = et(t),
                  o = Q(i);
                let a = 'x' === i ? (n === (r ? 'end' : 'start') ? 'right' : 'left') : 'start' === n ? 'bottom' : 'top';
                return e.reference[o] > e.floating[o] && (a = ht(a)), { main: a, cross: ht(a) };
              })(v, o, await (null == l.isRTL ? void 0 : l.isRTL(c.floating)));
              if (s !== v) return { reset: { placement: m[0] } };
              const E = [y[tt(v)], y[b], y[x]],
                w = [...((null == (n = a.autoPlacement) ? void 0 : n.overflows) || []), { placement: v, overflows: E }],
                _ = m[g + 1];
              if (_) return { data: { index: g + 1, overflows: w }, reset: { placement: _ } };
              const S = w
                  .map((t) => {
                    const e = J(t.placement);
                    return [
                      t.placement,
                      e && h ? t.overflows.slice(0, 2).reduce((t, e) => t + e, 0) : t.overflows[0],
                      t.overflows,
                    ];
                  })
                  .sort((t, e) => t[1] - e[1]),
                P =
                  (null == (i = S.filter((t) => t[2].slice(0, J(t[0]) ? 2 : 3).every((t) => t <= 0))[0])
                    ? void 0
                    : i[0]) || S[0][0];
              return P !== s ? { data: { index: g + 1, overflows: w }, reset: { placement: P } } : {};
            },
          }
        );
      },
      ft = function (t) {
        return (
          void 0 === t && (t = 0),
          {
            name: 'offset',
            options: t,
            async fn(e) {
              const { x: r, y: n } = e,
                i = await (async function (t, e) {
                  const { placement: r, platform: n, elements: i } = t,
                    o = await (null == n.isRTL ? void 0 : n.isRTL(i.floating)),
                    a = tt(r),
                    s = J(r),
                    l = 'x' === et(r),
                    c = ['left', 'top'].includes(a) ? -1 : 1,
                    h = o && l ? -1 : 1,
                    u = 'function' == typeof e ? e(t) : e;
                  let {
                    mainAxis: p,
                    crossAxis: f,
                    alignmentAxis: d,
                  } = 'number' == typeof u
                    ? { mainAxis: u, crossAxis: 0, alignmentAxis: null }
                    : { mainAxis: 0, crossAxis: 0, alignmentAxis: null, ...u };
                  return (
                    s && 'number' == typeof d && (f = 'end' === s ? -1 * d : d),
                    l ? { x: f * h, y: p * c } : { x: p * c, y: f * h }
                  );
                })(e, t);
              return { x: r + i.x, y: n + i.y, data: i };
            },
          }
        );
      };
    const dt = function (t) {
      return (
        void 0 === t && (t = {}),
        {
          name: 'shift',
          options: t,
          async fn(e) {
            const { x: r, y: n, placement: i } = e,
              {
                mainAxis: o = !0,
                crossAxis: a = !1,
                limiter: s = {
                  fn: (t) => {
                    let { x: e, y: r } = t;
                    return { x: e, y: r };
                  },
                },
                ...l
              } = t,
              c = { x: r, y: n },
              h = await it(e, l),
              u = et(tt(i)),
              p = (function (t) {
                return 'x' === t ? 'y' : 'x';
              })(u);
            let f = c[u],
              d = c[p];
            if (o) {
              const t = 'y' === u ? 'bottom' : 'right';
              f = st(f + h['y' === u ? 'top' : 'left'], f, f - h[t]);
            }
            if (a) {
              const t = 'y' === p ? 'bottom' : 'right';
              d = st(d + h['y' === p ? 'top' : 'left'], d, d - h[t]);
            }
            const m = s.fn({ ...e, [u]: f, [p]: d });
            return { ...m, data: { x: m.x - r, y: m.y - n } };
          },
        }
      );
    };
    function mt(t) {
      var e;
      return (null == (e = t.ownerDocument) ? void 0 : e.defaultView) || window;
    }
    function yt(t) {
      return mt(t).getComputedStyle(t);
    }
    function gt(t) {
      return t instanceof mt(t).Node;
    }
    function vt(t) {
      return gt(t) ? (t.nodeName || '').toLowerCase() : '';
    }
    let bt;
    function xt() {
      if (bt) return bt;
      const t = navigator.userAgentData;
      return t && Array.isArray(t.brands)
        ? ((bt = t.brands.map((t) => t.brand + '/' + t.version).join(' ')), bt)
        : navigator.userAgent;
    }
    function Et(t) {
      return t instanceof mt(t).HTMLElement;
    }
    function wt(t) {
      return t instanceof mt(t).Element;
    }
    function _t(t) {
      return 'undefined' != typeof ShadowRoot && (t instanceof mt(t).ShadowRoot || t instanceof ShadowRoot);
    }
    function St(t) {
      const { overflow: e, overflowX: r, overflowY: n, display: i } = yt(t);
      return /auto|scroll|overlay|hidden|clip/.test(e + n + r) && !['inline', 'contents'].includes(i);
    }
    function Pt(t) {
      return ['table', 'td', 'th'].includes(vt(t));
    }
    function At(t) {
      const e = /firefox/i.test(xt()),
        r = yt(t),
        n = r.backdropFilter || r.WebkitBackdropFilter;
      return (
        'none' !== r.transform ||
        'none' !== r.perspective ||
        (!!n && 'none' !== n) ||
        (e && 'filter' === r.willChange) ||
        (e && !!r.filter && 'none' !== r.filter) ||
        ['transform', 'perspective'].some((t) => r.willChange.includes(t)) ||
        ['paint', 'layout', 'strict', 'content'].some((t) => {
          const e = r.contain;
          return null != e && e.includes(t);
        })
      );
    }
    function Ct() {
      return /^((?!chrome|android).)*safari/i.test(xt());
    }
    function Tt(t) {
      return ['html', 'body', '#document'].includes(vt(t));
    }
    const kt = Math.min,
      Dt = Math.max,
      Mt = Math.round;
    function It(t) {
      const e = yt(t);
      let r = parseFloat(e.width),
        n = parseFloat(e.height);
      const i = Et(t),
        o = i ? t.offsetWidth : r,
        a = i ? t.offsetHeight : n,
        s = Mt(r) !== o || Mt(n) !== a;
      return s && ((r = o), (n = a)), { width: r, height: n, fallback: s };
    }
    function Ft(t) {
      return wt(t) ? t : t.contextElement;
    }
    const Lt = { x: 1, y: 1 };
    function Rt(t) {
      const e = Ft(t);
      if (!Et(e)) return Lt;
      const r = e.getBoundingClientRect(),
        { width: n, height: i, fallback: o } = It(e);
      let a = (o ? Mt(r.width) : r.width) / n,
        s = (o ? Mt(r.height) : r.height) / i;
      return (a && Number.isFinite(a)) || (a = 1), (s && Number.isFinite(s)) || (s = 1), { x: a, y: s };
    }
    function Ot(t, e, r, n) {
      var i, o;
      void 0 === e && (e = !1), void 0 === r && (r = !1);
      const a = t.getBoundingClientRect(),
        s = Ft(t);
      let l = Lt;
      e && (n ? wt(n) && (l = Rt(n)) : (l = Rt(t)));
      const c = s ? mt(s) : window,
        h = Ct() && r;
      let u = (a.left + ((h && (null == (i = c.visualViewport) ? void 0 : i.offsetLeft)) || 0)) / l.x,
        p = (a.top + ((h && (null == (o = c.visualViewport) ? void 0 : o.offsetTop)) || 0)) / l.y,
        f = a.width / l.x,
        d = a.height / l.y;
      if (s) {
        const t = mt(s),
          e = n && wt(n) ? mt(n) : n;
        let r = t.frameElement;
        for (; r && n && e !== t; ) {
          const t = Rt(r),
            e = r.getBoundingClientRect(),
            n = getComputedStyle(r);
          (e.x += (r.clientLeft + parseFloat(n.paddingLeft)) * t.x),
            (e.y += (r.clientTop + parseFloat(n.paddingTop)) * t.y),
            (u *= t.x),
            (p *= t.y),
            (f *= t.x),
            (d *= t.y),
            (u += e.x),
            (p += e.y),
            (r = mt(r).frameElement);
        }
      }
      return nt({ width: f, height: d, x: u, y: p });
    }
    function Bt(t) {
      return ((gt(t) ? t.ownerDocument : t.document) || window.document).documentElement;
    }
    function jt(t) {
      return wt(t)
        ? { scrollLeft: t.scrollLeft, scrollTop: t.scrollTop }
        : { scrollLeft: t.pageXOffset, scrollTop: t.pageYOffset };
    }
    function Nt(t) {
      return Ot(Bt(t)).left + jt(t).scrollLeft;
    }
    function Vt(t) {
      if ('html' === vt(t)) return t;
      const e = t.assignedSlot || t.parentNode || (_t(t) && t.host) || Bt(t);
      return _t(e) ? e.host : e;
    }
    function zt(t) {
      const e = Vt(t);
      return Tt(e) ? e.ownerDocument.body : Et(e) && St(e) ? e : zt(e);
    }
    function $t(t, e) {
      var r;
      void 0 === e && (e = []);
      const n = zt(t),
        i = n === (null == (r = t.ownerDocument) ? void 0 : r.body),
        o = mt(n);
      return i ? e.concat(o, o.visualViewport || [], St(n) ? n : []) : e.concat(n, $t(n));
    }
    function qt(t, e, r) {
      let n;
      if ('viewport' === e)
        n = (function (t, e) {
          const r = mt(t),
            n = Bt(t),
            i = r.visualViewport;
          let o = n.clientWidth,
            a = n.clientHeight,
            s = 0,
            l = 0;
          if (i) {
            (o = i.width), (a = i.height);
            const t = Ct();
            (!t || (t && 'fixed' === e)) && ((s = i.offsetLeft), (l = i.offsetTop));
          }
          return { width: o, height: a, x: s, y: l };
        })(t, r);
      else if ('document' === e)
        n = (function (t) {
          const e = Bt(t),
            r = jt(t),
            n = t.ownerDocument.body,
            i = Dt(e.scrollWidth, e.clientWidth, n.scrollWidth, n.clientWidth),
            o = Dt(e.scrollHeight, e.clientHeight, n.scrollHeight, n.clientHeight);
          let a = -r.scrollLeft + Nt(t);
          const s = -r.scrollTop;
          return (
            'rtl' === yt(n).direction && (a += Dt(e.clientWidth, n.clientWidth) - i),
            { width: i, height: o, x: a, y: s }
          );
        })(Bt(t));
      else if (wt(e))
        n = (function (t, e) {
          const r = Ot(t, !0, 'fixed' === e),
            n = r.top + t.clientTop,
            i = r.left + t.clientLeft,
            o = Et(t) ? Rt(t) : { x: 1, y: 1 };
          return { width: t.clientWidth * o.x, height: t.clientHeight * o.y, x: i * o.x, y: n * o.y };
        })(e, r);
      else {
        const r = { ...e };
        if (Ct()) {
          var i, o;
          const e = mt(t);
          (r.x -= (null == (i = e.visualViewport) ? void 0 : i.offsetLeft) || 0),
            (r.y -= (null == (o = e.visualViewport) ? void 0 : o.offsetTop) || 0);
        }
        n = r;
      }
      return nt(n);
    }
    function Ht(t, e) {
      return Et(t) && 'fixed' !== yt(t).position ? (e ? e(t) : t.offsetParent) : null;
    }
    function Gt(t, e) {
      const r = mt(t);
      if (!Et(t)) return r;
      let n = Ht(t, e);
      for (; n && Pt(n) && 'static' === yt(n).position; ) n = Ht(n, e);
      return n && ('html' === vt(n) || ('body' === vt(n) && 'static' === yt(n).position && !At(n)))
        ? r
        : n ||
            (function (t) {
              let e = Vt(t);
              for (; Et(e) && !Tt(e); ) {
                if (At(e)) return e;
                e = Vt(e);
              }
              return null;
            })(t) ||
            r;
    }
    function Wt(t, e, r) {
      const n = Et(e),
        i = Bt(e),
        o = Ot(t, !0, 'fixed' === r, e);
      let a = { scrollLeft: 0, scrollTop: 0 };
      const s = { x: 0, y: 0 };
      if (n || (!n && 'fixed' !== r))
        if ((('body' !== vt(e) || St(i)) && (a = jt(e)), Et(e))) {
          const t = Ot(e, !0);
          (s.x = t.x + e.clientLeft), (s.y = t.y + e.clientTop);
        } else i && (s.x = Nt(i));
      return { x: o.left + a.scrollLeft - s.x, y: o.top + a.scrollTop - s.y, width: o.width, height: o.height };
    }
    const Ut = {
        getClippingRect: function (t) {
          let { element: e, boundary: r, rootBoundary: n, strategy: i } = t;
          const o =
              'clippingAncestors' === r
                ? (function (t, e) {
                    const r = e.get(t);
                    if (r) return r;
                    let n = $t(t).filter((t) => wt(t) && 'body' !== vt(t)),
                      i = null;
                    const o = 'fixed' === yt(t).position;
                    let a = o ? Vt(t) : t;
                    for (; wt(a) && !Tt(a); ) {
                      const t = yt(a),
                        e = At(a);
                      'fixed' === t.position
                        ? (i = null)
                        : (
                            o
                              ? e || i
                              : e || 'static' !== t.position || !i || !['absolute', 'fixed'].includes(i.position)
                          )
                        ? (i = t)
                        : (n = n.filter((t) => t !== a)),
                        (a = Vt(a));
                    }
                    return e.set(t, n), n;
                  })(e, this._c)
                : [].concat(r),
            a = [...o, n],
            s = a[0],
            l = a.reduce((t, r) => {
              const n = qt(e, r, i);
              return (
                (t.top = Dt(n.top, t.top)),
                (t.right = kt(n.right, t.right)),
                (t.bottom = kt(n.bottom, t.bottom)),
                (t.left = Dt(n.left, t.left)),
                t
              );
            }, qt(e, s, i));
          return { width: l.right - l.left, height: l.bottom - l.top, x: l.left, y: l.top };
        },
        convertOffsetParentRelativeRectToViewportRelativeRect: function (t) {
          let { rect: e, offsetParent: r, strategy: n } = t;
          const i = Et(r),
            o = Bt(r);
          if (r === o) return e;
          let a = { scrollLeft: 0, scrollTop: 0 },
            s = { x: 1, y: 1 };
          const l = { x: 0, y: 0 };
          if ((i || (!i && 'fixed' !== n)) && (('body' !== vt(r) || St(o)) && (a = jt(r)), Et(r))) {
            const t = Ot(r);
            (s = Rt(r)), (l.x = t.x + r.clientLeft), (l.y = t.y + r.clientTop);
          }
          return {
            width: e.width * s.x,
            height: e.height * s.y,
            x: e.x * s.x - a.scrollLeft * s.x + l.x,
            y: e.y * s.y - a.scrollTop * s.y + l.y,
          };
        },
        isElement: wt,
        getDimensions: function (t) {
          return It(t);
        },
        getOffsetParent: Gt,
        getDocumentElement: Bt,
        getScale: Rt,
        async getElementRects(t) {
          let { reference: e, floating: r, strategy: n } = t;
          const i = this.getOffsetParent || Gt,
            o = this.getDimensions;
          return { reference: Wt(e, await i(r), n), floating: { x: 0, y: 0, ...(await o(r)) } };
        },
        getClientRects: (t) => Array.from(t.getClientRects()),
        isRTL: (t) => 'rtl' === yt(t).direction,
      },
      Xt = (t, e, r) => {
        const n = new Map(),
          i = { platform: Ut, ...r },
          o = { ...i.platform, _c: n };
        return (async (t, e, r) => {
          const { placement: n = 'bottom', strategy: i = 'absolute', middleware: o = [], platform: a } = r,
            s = o.filter(Boolean),
            l = await (null == a.isRTL ? void 0 : a.isRTL(e));
          let c = await a.getElementRects({ reference: t, floating: e, strategy: i }),
            { x: h, y: u } = rt(c, n, l),
            p = n,
            f = {},
            d = 0;
          for (let r = 0; r < s.length; r++) {
            const { name: o, fn: m } = s[r],
              {
                x: y,
                y: g,
                data: v,
                reset: b,
              } = await m({
                x: h,
                y: u,
                initialPlacement: n,
                placement: p,
                strategy: i,
                middlewareData: f,
                rects: c,
                platform: a,
                elements: { reference: t, floating: e },
              });
            (h = null != y ? y : h),
              (u = null != g ? g : u),
              (f = { ...f, [o]: { ...f[o], ...v } }),
              b &&
                d <= 50 &&
                (d++,
                'object' == typeof b &&
                  (b.placement && (p = b.placement),
                  b.rects &&
                    (c =
                      !0 === b.rects ? await a.getElementRects({ reference: t, floating: e, strategy: i }) : b.rects),
                  ({ x: h, y: u } = rt(c, p, l))),
                (r = -1));
          }
          return { x: h, y: u, placement: p, strategy: i, middlewareData: f };
        })(t, e, { ...i, platform: o });
      };
    function Yt(t, e) {
      (null == e || e > t.length) && (e = t.length);
      for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
      return n;
    }
    function Kt(t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    }
    function Zt() {
      if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ('function' == typeof Proxy) return !0;
      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }
    function Jt(t, e, r) {
      return (
        (Jt = Zt()
          ? Reflect.construct
          : function (t, e, r) {
              var n = [null];
              n.push.apply(n, e);
              var i = new (Function.bind.apply(t, n))();
              return r && re(i, r.prototype), i;
            }),
        Jt.apply(null, arguments)
      );
    }
    function Qt(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        (n.enumerable = n.enumerable || !1),
          (n.configurable = !0),
          'value' in n && (n.writable = !0),
          Object.defineProperty(t, n.key, n);
      }
    }
    function te(t) {
      return (
        (te = Object.setPrototypeOf
          ? Object.getPrototypeOf
          : function (t) {
              return t.__proto__ || Object.getPrototypeOf(t);
            }),
        te(t)
      );
    }
    function ee(t, e) {
      return !e || ('object' !== ne(e) && 'function' != typeof e) ? Kt(t) : e;
    }
    function re(t, e) {
      return (
        (re =
          Object.setPrototypeOf ||
          function (t, e) {
            return (t.__proto__ = e), t;
          }),
        re(t, e)
      );
    }
    var ne = function (t) {
      return t && 'undefined' != typeof Symbol && t.constructor === Symbol ? 'symbol' : typeof t;
    };
    function ie(t) {
      var e = 'function' == typeof Map ? new Map() : void 0;
      return (
        (ie = function (t) {
          if (null === t || ((r = t), -1 === Function.toString.call(r).indexOf('[native code]'))) return t;
          var r;
          if ('function' != typeof t) throw new TypeError('Super expression must either be null or a function');
          if (void 0 !== e) {
            if (e.has(t)) return e.get(t);
            e.set(t, n);
          }
          function n() {
            return Jt(t, arguments, te(this).constructor);
          }
          return (
            (n.prototype = Object.create(t.prototype, {
              constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 },
            })),
            re(n, t)
          );
        }),
        ie(t)
      );
    }
    var oe = (function (t) {
      !(function (t, e) {
        if ('function' != typeof e && null !== e)
          throw new TypeError('Super expression must either be null or a function');
        (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })),
          e && re(t, e);
      })(a, t);
      var e,
        r,
        n,
        i,
        o =
          ((n = a),
          (i = (function () {
            if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ('function' == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (t) {
              return !1;
            }
          })()),
          function () {
            var t,
              e = te(n);
            if (i) {
              var r = te(this).constructor;
              t = Reflect.construct(e, arguments, r);
            } else t = e.apply(this, arguments);
            return ee(this, t);
          });
      function a() {
        var t, e;
        return (
          (function (t, e) {
            if (!(t instanceof e)) throw new TypeError('Cannot call a class as a function');
          })(this, a),
          ((t = o.call(this)).tooltipButton = t.querySelector('[data-tooltip-button]')),
          (t.tooltip = t.querySelector('[data-tooltip]')),
          t.tooltipButton && t.tooltip
            ? (Xt(t.tooltipButton, t.tooltip, {
                placement: 'right-start',
                middleware: [ft(6), dt(), pt({ crossAxis: !0, autoAlignment: !0 })],
              }).then(function (e) {
                var r = e.x,
                  n = e.y;
                Object.assign(t.tooltip.style, { left: ''.concat(r, 'px'), top: ''.concat(n, 'px') });
              }),
              [
                ['mouseenter', t.showTooltip],
                ['focus', t.showTooltip],
                ['blur', t.hideTooltip],
              ].forEach(function (e) {
                var r = (function (t, e) {
                    return (
                      (function (t) {
                        if (Array.isArray(t)) return t;
                      })(t) ||
                      (function (t, e) {
                        var r =
                          null == t ? null : ('undefined' != typeof Symbol && t[Symbol.iterator]) || t['@@iterator'];
                        if (null != r) {
                          var n,
                            i,
                            o = [],
                            a = !0,
                            s = !1;
                          try {
                            for (
                              r = r.call(t);
                              !(a = (n = r.next()).done) && (o.push(n.value), !e || o.length !== e);
                              a = !0
                            );
                          } catch (t) {
                            (s = !0), (i = t);
                          } finally {
                            try {
                              a || null == r.return || r.return();
                            } finally {
                              if (s) throw i;
                            }
                          }
                          return o;
                        }
                      })(t, e) ||
                      (function (t, e) {
                        if (t) {
                          if ('string' == typeof t) return Yt(t, e);
                          var r = Object.prototype.toString.call(t).slice(8, -1);
                          return (
                            'Object' === r && t.constructor && (r = t.constructor.name),
                            'Map' === r || 'Set' === r
                              ? Array.from(r)
                              : 'Arguments' === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)
                              ? Yt(t, e)
                              : void 0
                          );
                        }
                      })(t, e) ||
                      (function () {
                        throw new TypeError(
                          'Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
                        );
                      })()
                    );
                  })(e, 2),
                  n = r[0],
                  i = r[1];
                t.tooltipButton.addEventListener(n, i.bind(Kt(t)));
              }),
              t.tooltipButton.addEventListener('mouseleave', function () {
                e && (clearTimeout(e), (e = void 0)),
                  (e = setTimeout(function () {
                    t.hideTooltip();
                  }, 500));
              }),
              t.tooltip.addEventListener('mouseenter', function () {
                e && (clearTimeout(e), (e = void 0)), t.showTooltip();
              }),
              t.tooltip.addEventListener('mouseleave', function () {
                e && (clearTimeout(e), (e = void 0)), t.hideTooltip();
              }),
              t)
            : ee(t)
        );
      }
      return (
        (e = a),
        (r = [
          {
            key: 'update',
            value: function () {
              var t = this;
              Xt(this.tooltipButton, this.tooltip, {
                placement: 'right-start',
                middleware: [ft(6), dt(), pt({ crossAxis: !0, autoAlignment: !0 })],
              }).then(function (e) {
                var r = e.x,
                  n = e.y;
                Object.assign(t.tooltip.style, { left: ''.concat(r, 'px'), top: ''.concat(n, 'px') });
              });
            },
          },
          {
            key: 'showTooltip',
            value: function () {
              (this.tooltip.style.display = 'block'), this.update();
            },
          },
          {
            key: 'hideTooltip',
            value: function () {
              this.tooltip.style.display = '';
            },
          },
        ]),
        r && Qt(e.prototype, r),
        a
      );
    })(ie(HTMLElement));
    customElements.define('tooltip-component', oe);
    var ae = __webpack_require__(205);
    function se(t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    }
    function le(t, e, r, n, i, o, a) {
      try {
        var s = t[o](a),
          l = s.value;
      } catch (t) {
        return void r(t);
      }
      s.done ? e(l) : Promise.resolve(l).then(n, i);
    }
    function ce(t) {
      return function () {
        var e = this,
          r = arguments;
        return new Promise(function (n, i) {
          var o = t.apply(e, r);
          function a(t) {
            le(o, n, i, a, s, 'next', t);
          }
          function s(t) {
            le(o, n, i, a, s, 'throw', t);
          }
          a(void 0);
        });
      };
    }
    function he() {
      if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ('function' == typeof Proxy) return !0;
      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }
    function ue(t, e, r) {
      return (
        (ue = he()
          ? Reflect.construct
          : function (t, e, r) {
              var n = [null];
              n.push.apply(n, e);
              var i = new (Function.bind.apply(t, n))();
              return r && me(i, r.prototype), i;
            }),
        ue.apply(null, arguments)
      );
    }
    function pe(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        (n.enumerable = n.enumerable || !1),
          (n.configurable = !0),
          'value' in n && (n.writable = !0),
          Object.defineProperty(t, n.key, n);
      }
    }
    function fe(t) {
      return (
        (fe = Object.setPrototypeOf
          ? Object.getPrototypeOf
          : function (t) {
              return t.__proto__ || Object.getPrototypeOf(t);
            }),
        fe(t)
      );
    }
    function de(t, e) {
      return !e || ('object' !== ye(e) && 'function' != typeof e) ? se(t) : e;
    }
    function me(t, e) {
      return (
        (me =
          Object.setPrototypeOf ||
          function (t, e) {
            return (t.__proto__ = e), t;
          }),
        me(t, e)
      );
    }
    var ye = function (t) {
      return t && 'undefined' != typeof Symbol && t.constructor === Symbol ? 'symbol' : typeof t;
    };
    function ge(t) {
      var e = 'function' == typeof Map ? new Map() : void 0;
      return (
        (ge = function (t) {
          if (null === t || ((r = t), -1 === Function.toString.call(r).indexOf('[native code]'))) return t;
          var r;
          if ('function' != typeof t) throw new TypeError('Super expression must either be null or a function');
          if (void 0 !== e) {
            if (e.has(t)) return e.get(t);
            e.set(t, n);
          }
          function n() {
            return ue(t, arguments, fe(this).constructor);
          }
          return (
            (n.prototype = Object.create(t.prototype, {
              constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 },
            })),
            me(n, t)
          );
        }),
        ge(t)
      );
    }
    var ve = (function (t) {
      !(function (t, e) {
        if ('function' != typeof e && null !== e)
          throw new TypeError('Super expression must either be null or a function');
        (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })),
          e && me(t, e);
      })(a, t);
      var e,
        r,
        n,
        i,
        o =
          ((n = a),
          (i = (function () {
            if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ('function' == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (t) {
              return !1;
            }
          })()),
          function () {
            var t,
              e = fe(n);
            if (i) {
              var r = fe(this).constructor;
              t = Reflect.construct(e, arguments, r);
            } else t = e.apply(this, arguments);
            return de(this, t);
          });
      function a() {
        var t;
        if (
          ((function (t, e) {
            if (!(t instanceof e)) throw new TypeError('Cannot call a class as a function');
          })(this, a),
          ((t = o.call(this)).button = t.querySelector('button')),
          (t.next_page = ''),
          (t.next_url = ''),
          (t.product_grid = ''),
          !t.button)
        )
          return de(t);
        (t.product_grid = document.getElementById('product-grid')), (t.next_url = t.product_grid.dataset.nextUrl);
        var e = se(t);
        return (
          t.button.addEventListener(
            'click',
            ce(
              ae.mark(function t() {
                return ae.wrap(function (t) {
                  for (;;)
                    switch ((t.prev = t.next)) {
                      case 0:
                        return (t.next = 2), e.loadMoreProducts();
                      case 2:
                      case 'end':
                        return t.stop();
                    }
                }, t);
              }),
            ),
          ),
          t
        );
      }
      return (
        (e = a),
        (r = [
          {
            key: 'loadMoreProducts',
            value: function () {
              var t = this;
              return ce(
                ae.mark(function e() {
                  var r, n, i, o, a, s;
                  return ae.wrap(function (e) {
                    for (;;)
                      switch ((e.prev = e.next)) {
                        case 0:
                          return (t.button.style.display = 'none'), (e.next = 3), t.getNextPage();
                        case 3:
                          if (((t.next_page = e.sent), t.next_url)) {
                            e.next = 6;
                            break;
                          }
                          return e.abrupt('return');
                        case 6:
                          for (
                            r = new DOMParser(),
                              n = r.parseFromString(t.next_page, 'text/html'),
                              i = n.getElementById('product-grid'),
                              o = i.getElementsByClassName('js-product'),
                              (a = i.dataset.nextUrl) && (t.button.style.display = 'inline-block'),
                              t.next_url = a,
                              s = 0;
                            s < o.length;
                            s++
                          )
                            t.product_grid.appendChild(o[s]);
                        case 14:
                        case 'end':
                          return e.stop();
                      }
                  }, e);
                }),
              )();
            },
          },
          {
            key: 'getNextPage',
            value: function () {
              var t = this;
              return ce(
                ae.mark(function e() {
                  var r;
                  return ae.wrap(
                    function (e) {
                      for (;;)
                        switch ((e.prev = e.next)) {
                          case 0:
                            return (e.prev = 0), (e.next = 3), fetch(t.next_url);
                          case 3:
                            return (r = e.sent), (e.next = 6), r.text();
                          case 6:
                            return e.abrupt('return', e.sent);
                          case 9:
                            (e.prev = 9), (e.t0 = e.catch(0)), console.error(e.t0);
                          case 12:
                          case 'end':
                            return e.stop();
                        }
                    },
                    e,
                    null,
                    [[0, 9]],
                  );
                }),
              )();
            },
          },
        ]),
        r && pe(e.prototype, r),
        a
      );
    })(ge(HTMLElement));
    function be(t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    }
    function xe(t, e, r, n, i, o, a) {
      try {
        var s = t[o](a),
          l = s.value;
      } catch (t) {
        return void r(t);
      }
      s.done ? e(l) : Promise.resolve(l).then(n, i);
    }
    function Ee() {
      if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ('function' == typeof Proxy) return !0;
      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }
    function we(t, e, r) {
      return (
        (we = Ee()
          ? Reflect.construct
          : function (t, e, r) {
              var n = [null];
              n.push.apply(n, e);
              var i = new (Function.bind.apply(t, n))();
              return r && Pe(i, r.prototype), i;
            }),
        we.apply(null, arguments)
      );
    }
    function _e(t) {
      return (
        (_e = Object.setPrototypeOf
          ? Object.getPrototypeOf
          : function (t) {
              return t.__proto__ || Object.getPrototypeOf(t);
            }),
        _e(t)
      );
    }
    function Se(t, e) {
      return !e || ('object' !== Ae(e) && 'function' != typeof e) ? be(t) : e;
    }
    function Pe(t, e) {
      return (
        (Pe =
          Object.setPrototypeOf ||
          function (t, e) {
            return (t.__proto__ = e), t;
          }),
        Pe(t, e)
      );
    }
    customElements.define('paginate-button', ve);
    var Ae = function (t) {
      return t && 'undefined' != typeof Symbol && t.constructor === Symbol ? 'symbol' : typeof t;
    };
    function Ce(t) {
      var e = 'function' == typeof Map ? new Map() : void 0;
      return (
        (Ce = function (t) {
          if (null === t || ((r = t), -1 === Function.toString.call(r).indexOf('[native code]'))) return t;
          var r;
          if ('function' != typeof t) throw new TypeError('Super expression must either be null or a function');
          if (void 0 !== e) {
            if (e.has(t)) return e.get(t);
            e.set(t, n);
          }
          function n() {
            return we(t, arguments, _e(this).constructor);
          }
          return (
            (n.prototype = Object.create(t.prototype, {
              constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 },
            })),
            Pe(n, t)
          );
        }),
        Ce(t)
      );
    }
    var Te = (function (t) {
      !(function (t, e) {
        if ('function' != typeof e && null !== e)
          throw new TypeError('Super expression must either be null or a function');
        (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })),
          e && Pe(t, e);
      })(i, t);
      var e,
        r,
        n =
          ((e = i),
          (r = (function () {
            if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ('function' == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (t) {
              return !1;
            }
          })()),
          function () {
            var t,
              n = _e(e);
            if (r) {
              var i = _e(this).constructor;
              t = Reflect.construct(n, arguments, i);
            } else t = n.apply(this, arguments);
            return Se(this, t);
          });
      function i() {
        var t;
        if (
          ((function (t, e) {
            if (!(t instanceof e)) throw new TypeError('Cannot call a class as a function');
          })(this, i),
          (t = n.call(this)).customerAccessToken,
          (t.form = t.querySelector('form')),
          (t.formToggle = t.querySelector('button[aria-expanded]')),
          (t.formResetButtons = t.querySelectorAll('button[type="reset"]')),
          !t.form)
        )
          return Se(t);
        t.formToggle.addEventListener('click', function (e) {
          t.querySelector('button[aria-expanded]').setAttribute(
            'aria-expanded',
            ('false' === e.target.getAttribute('aria-expanded')).toString(),
          );
        }),
          t.formResetButtons.forEach(function (e) {
            e.addEventListener('click', function (e) {
              t.querySelector('button[aria-expanded]').setAttribute(
                'aria-expanded',
                ('false' === e.target.getAttribute('aria-expanded')).toString(),
              );
            });
          });
        var e,
          r,
          o = be(t);
        return (
          t.form.addEventListener(
            'submit',
            ((e = ae.mark(function t(e) {
              var r, n, i, a, s, l, c, h;
              return ae.wrap(function (t) {
                for (;;)
                  switch ((t.prev = t.next)) {
                    case 0:
                      if (
                        (e.preventDefault(),
                        (r = o.form.querySelector("[name='first_name']")),
                        (n = o.form.querySelector("[name='last_name']")),
                        (i = o.form.querySelector("[name='email']")),
                        (a = o.form.querySelector("[name='password']")),
                        (s = o.form.querySelector("[name='new_email']")),
                        (l = o.form.querySelector("[name='new_password']")),
                        (c = o.form.querySelector("[name='new_password_confirmation']")),
                        l.value !== c.value ? c.setCustomValidity('Passwords do not match') : c.setCustomValidity(''),
                        !o.form.checkValidity())
                      ) {
                        t.next = 16;
                        break;
                      }
                      return (
                        (h = { input: { email: i.value, password: a.value } }),
                        (t.next = 14),
                        fetch('https://chagrinvalleysoapandsalve.myshopify.com/api/2023-01/graphql.json', {
                          method: 'POST',
                          headers: {
                            'X-Shopify-Storefront-Access-Token': '97d37c79df6b77749ff1792faab3cd75',
                            'Content-Type': 'application/json',
                          },
                          body: JSON.stringify({
                            query:
                              '\n          mutation customerAccessTokenCreate($input: CustomerAccessTokenCreateInput!) {\n            customerAccessTokenCreate(input: $input) {\n              customerAccessToken {\n                accessToken\n              }\n              customerUserErrors {\n                message\n              }\n            }\n          }\n        ',
                            variables: h,
                          }),
                        })
                          .then(function (t) {
                            return t.json();
                          })
                          .then(function (t) {
                            var e,
                              o,
                              c,
                              h =
                                null == t ||
                                null === (e = t.data) ||
                                void 0 === e ||
                                null === (o = e.customerAccessTokenCreate) ||
                                void 0 === o ||
                                null === (c = o.customerAccessToken) ||
                                void 0 === c
                                  ? void 0
                                  : c.accessToken,
                              u = {
                                customerAccessToken: h,
                                customer: {
                                  firstName: r.value,
                                  lastName: n.value,
                                  email: s.value ? s.value : i.value,
                                  password: l.value ? l.value : a.value,
                                },
                              };
                            if (h)
                              return fetch('https://chagrinvalleysoapandsalve.myshopify.com/api/2023-01/graphql.json', {
                                method: 'POST',
                                headers: {
                                  'X-Shopify-Storefront-Access-Token': '97d37c79df6b77749ff1792faab3cd75',
                                  'Content-Type': 'application/json',
                                },
                                body: JSON.stringify({
                                  query:
                                    '\n            mutation customerUpdate($customerAccessToken: String!, $customer: CustomerUpdateInput!) {\n              customerUpdate(customerAccessToken: $customerAccessToken, customer: $customer) {\n                customer {\n                  id\n                }\n                customerAccessToken {\n                  accessToken\n                }\n                customerUserErrors {\n                  message\n                }\n              }\n            }\n          ',
                                  variables: u,
                                }),
                              });
                          })
                          .then(function (t) {
                            return t.json();
                          })
                          .then(function (t) {
                            t.data.id, location.reload();
                          })
                          .catch(function (t) {
                            return console.error(t);
                          })
                      );
                    case 14:
                      t.next = 17;
                      break;
                    case 16:
                      o.form.querySelectorAll(':invalid').forEach(function (t) {
                        o.form.querySelectorAll('.error-message').forEach(function (e) {
                          (e.textContent = t.validationMessage), (e.style.display = 'block');
                        });
                      });
                    case 17:
                    case 'end':
                      return t.stop();
                  }
              }, t);
            })),
            (r = function () {
              var t = this,
                r = arguments;
              return new Promise(function (n, i) {
                var o = e.apply(t, r);
                function a(t) {
                  xe(o, n, i, a, s, 'next', t);
                }
                function s(t) {
                  xe(o, n, i, a, s, 'throw', t);
                }
                a(void 0);
              });
            }),
            function (t) {
              return r.apply(this, arguments);
            }),
          ),
          t
        );
      }
      return i;
    })(Ce(HTMLElement));
    function ke() {
      if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ('function' == typeof Proxy) return !0;
      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }
    function De(t, e, r) {
      return (
        (De = ke()
          ? Reflect.construct
          : function (t, e, r) {
              var n = [null];
              n.push.apply(n, e);
              var i = new (Function.bind.apply(t, n))();
              return r && Fe(i, r.prototype), i;
            }),
        De.apply(null, arguments)
      );
    }
    function Me(t) {
      return (
        (Me = Object.setPrototypeOf
          ? Object.getPrototypeOf
          : function (t) {
              return t.__proto__ || Object.getPrototypeOf(t);
            }),
        Me(t)
      );
    }
    function Ie(t, e) {
      return !e || ('object' !== Le(e) && 'function' != typeof e)
        ? (function (t) {
            if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return t;
          })(t)
        : e;
    }
    function Fe(t, e) {
      return (
        (Fe =
          Object.setPrototypeOf ||
          function (t, e) {
            return (t.__proto__ = e), t;
          }),
        Fe(t, e)
      );
    }
    customElements.get('edit-customer-form') || customElements.define('edit-customer-form', Te);
    var Le = function (t) {
      return t && 'undefined' != typeof Symbol && t.constructor === Symbol ? 'symbol' : typeof t;
    };
    function Re(t) {
      var e = 'function' == typeof Map ? new Map() : void 0;
      return (
        (Re = function (t) {
          if (null === t || ((r = t), -1 === Function.toString.call(r).indexOf('[native code]'))) return t;
          var r;
          if ('function' != typeof t) throw new TypeError('Super expression must either be null or a function');
          if (void 0 !== e) {
            if (e.has(t)) return e.get(t);
            e.set(t, n);
          }
          function n() {
            return De(t, arguments, Me(this).constructor);
          }
          return (
            (n.prototype = Object.create(t.prototype, {
              constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 },
            })),
            Fe(n, t)
          );
        }),
        Re(t)
      );
    }
    var Oe,
      Be,
      je,
      Ne,
      Ve = (function (t) {
        !(function (t, e) {
          if ('function' != typeof e && null !== e)
            throw new TypeError('Super expression must either be null or a function');
          (t.prototype = Object.create(e && e.prototype, {
            constructor: { value: t, writable: !0, configurable: !0 },
          })),
            e && Fe(t, e);
        })(i, t);
        var e,
          r,
          n =
            ((e = i),
            (r = (function () {
              if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
              if (Reflect.construct.sham) return !1;
              if ('function' == typeof Proxy) return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
              } catch (t) {
                return !1;
              }
            })()),
            function () {
              var t,
                n = Me(e);
              if (r) {
                var i = Me(this).constructor;
                t = Reflect.construct(n, arguments, i);
              } else t = n.apply(this, arguments);
              return Ie(this, t);
            });
        function i() {
          var t;
          if (
            ((function (t, e) {
              if (!(t instanceof e)) throw new TypeError('Cannot call a class as a function');
            })(this, i),
            ((t = n.call(this)).headingText = t.querySelector('[data-newsletter-heading]')),
            (t.subscribedText = t.querySelector('[data-newsletter-subscribed]')),
            (t.form = t.querySelector('#NewsletterForm--' + t.dataset.id)),
            !t.headingText || !t.subscribedText)
          )
            return Ie(t);
          var e = window.location.href.includes('form_type=customer'),
            r = t.form.value.length;
          return e && 0 != r && (t.headingText.classList.add('hidden'), t.subscribedText.classList.remove('hidden')), t;
        }
        return i;
      })(Re(HTMLElement));
    function ze(t, e, r, n, i, o, a) {
      try {
        var s = t[o](a),
          l = s.value;
      } catch (t) {
        return void r(t);
      }
      s.done ? e(l) : Promise.resolve(l).then(n, i);
    }
    function $e(t) {
      return function () {
        var e = this,
          r = arguments;
        return new Promise(function (n, i) {
          var o = t.apply(e, r);
          function a(t) {
            ze(o, n, i, a, s, 'next', t);
          }
          function s(t) {
            ze(o, n, i, a, s, 'throw', t);
          }
          a(void 0);
        });
      };
    }
    customElements.define('newsletter-component', Ve),
      __webpack_require__(886),
      /Chrome/i.test(navigator.userAgent) &&
        document.addEventListener('DOMContentLoaded', function () {
          for (var t = document.getElementsByTagName('lottie-player'), e = 0; e < t.length; e++)
            t[e].addEventListener('play', function (t) {
              t.target.shadowRoot.querySelector('svg') &&
                (t.target.shadowRoot.querySelector('svg').style.transform = '');
            }),
              t[e].play();
        }),
      (function (t) {
        if (!t) return function () {};
        new ResizeObserver(function (e) {
          var r = !0,
            n = !1,
            i = void 0;
          try {
            for (var o, a = e[Symbol.iterator](); !(r = (o = a.next()).done); r = !0) {
              var s,
                l,
                c = o.value;
              if (c.target === t) {
                var h,
                  u = c.contentBoxSize
                    ? null !==
                        (h =
                          null === (s = c.contentBoxSize) || void 0 === s || null === (l = s[0]) || void 0 === l
                            ? void 0
                            : l.blockSize) && void 0 !== h
                      ? h
                      : c.contentBoxSize.blockSize
                    : c.contentRect.height;
                document.documentElement.style.setProperty('--header-height', ''.concat(u, 'px'));
              }
            }
          } catch (t) {
            (n = !0), (i = t);
          } finally {
            try {
              r || null == a.return || a.return();
            } finally {
              if (n) throw i;
            }
          }
        }).observe(t);
      })(document.getElementById('MainHeader')),
      (je = function (t) {
        var e, r, n, i, o, a, s, l, c, h, u, p, f, d, m, y, g, v, b, x, E;
        t.matches
          ? (Be && (Be(), (Be = null)),
            (e = document.querySelector('[data-vf-js="nav-list"]')),
            (n = function () {
              E && (d(E, !1), (E = null)),
                f(),
                window.removeEventListener('resize', i),
                v.forEach(function (t) {
                  t.removeEventListener('mouseenter', c),
                    t.removeEventListener('mouseleave', h),
                    t.removeEventListener('focusout', h),
                    t.removeEventListener('click', l);
                }),
                b.forEach(function (t) {
                  t.removeEventListener('toggle', s),
                    t.removeEventListener('mouseenter', o),
                    t.removeEventListener('focusin', o);
                });
            }),
            (i = function () {
              b.forEach(u);
            }),
            (o = function (t) {
              t.currentTarget.open && f();
            }),
            (a = function (t) {
              var e = t.currentTarget;
              e.classList.contains('active') && e.classList.remove('active');
            }),
            (s = function (t) {
              var e = t.currentTarget;
              e.open ? m(e) : f();
            }),
            (l = function (t) {
              var e = t.currentTarget.querySelector(':scope > a[href]');
              e && (t.stopPropagation(), e.click());
            }),
            (c = function (t) {
              var e = t.currentTarget.querySelector('[data-vf-js="nav-list-dropdown"]');
              e && (x.length && x[0].classList.add('active'), e.open && e === E && f(), d(e, !0));
            }),
            (h = function (t) {
              t.currentTarget.querySelector('[data-vf-js="nav-list-dropdown"]') && p();
            }),
            (u = function (t) {
              if (t.open) {
                var e = t.querySelector('[data-vf-js="nav-list-dropdown-panel"]');
                if (e) {
                  var r = e.offsetTop - t.offsetTop;
                  t.style.setProperty('--dropdown-gap-top', r), t.style.setProperty('--item-width', t.clientWidth);
                }
              }
            }),
            (p = function () {
              f(),
                (r = setTimeout(function () {
                  d(E, !1);
                }, g));
            }),
            (f = function () {
              r && (clearTimeout(r), (r = null));
            }),
            (d = function (t) {
              var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0;
              if (t) {
                var r = t.open,
                  n = void 0 === e ? !r : Boolean(e);
                if (r !== n) return (t.open = n), n && (m(t), u(t)), n;
              }
            }),
            (m = function (t) {
              t && t.open && t !== E && (y(), (E = t));
            }),
            (y = function () {
              if (E) {
                var t = E;
                (E = null), d(t, !1);
              }
            }),
            (g = 50),
            (v = e.querySelectorAll('[data-vf-js="nav-list-item"]')),
            (b = e.querySelectorAll('[data-vf-js="nav-list-dropdown"]')),
            (x = Array.from(e.querySelectorAll('[data-vf-menu-child]'))),
            (E = e.querySelector('[data-vf-js="nav-list-dropdown"][open]')),
            window.addEventListener('resize', i),
            v.forEach(function (t) {
              t.addEventListener('mouseenter', c),
                t.addEventListener('mouseleave', h),
                t.addEventListener('focusout', h),
                t.addEventListener('click', l);
            }),
            b.forEach(function (t) {
              t.addEventListener('toggle', s), t.addEventListener('mouseenter', o), t.addEventListener('focusin', o);
            }),
            x.forEach(function (t) {
              t.addEventListener('mouseenter', a);
            }),
            (Oe = n))
          : (Oe && (Oe(), (Oe = null)),
            (Be = (function (t) {
              var e = function () {
                  h.style.setProperty('--drawer-top', h.getBoundingClientRect().top);
                },
                r = function (e) {
                  var r = e.currentTarget.getAttribute('aria-controls');
                  if (r) {
                    var n = t.querySelector('#'.concat(r));
                    n && o(n, !1);
                  }
                },
                n = function (t) {
                  var e = t.currentTarget;
                  e.open ? a(e) : l(e);
                },
                i = function () {
                  s(),
                    window.requestAnimationFrame(function () {
                      t.style.setProperty('--drawer-vh', ''.concat(0.01 * window.innerHeight, 'px')),
                        h.style.setProperty('--drawer-top', h.getBoundingClientRect().top);
                    }),
                    document.body.classList.toggle('overflow-hidden', t.open);
                },
                o = function (t) {
                  var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0;
                  if (t) {
                    var r = t.open,
                      n = void 0 === e ? !r : Boolean(e);
                    if (r !== n) return (t.open = n), n ? a(t) : l(t), n;
                  }
                },
                a = function (t) {
                  c(t) >= 0 || f.push(t);
                },
                s = function () {
                  if (f.length) return l(f[0]);
                },
                l = function (t) {
                  var e = c(t);
                  e < 0 ||
                    f.splice(e, 1 / 0).forEach(function (t) {
                      return o(t, !1);
                    });
                },
                c = function (t) {
                  return f.indexOf(t);
                };
              if (!t) return function () {};
              var h = t.querySelector('[data-vf-js="drawer-nav"]'),
                u = t.querySelectorAll('[data-vf-js="drawer-panel"]'),
                p = t.querySelectorAll('[data-vf-js="drawer-panel-close"]'),
                f = Array.from(t.querySelectorAll('[data-vf-js="drawer-panel"][open]'));
              return (
                e(),
                window.addEventListener('resize', e),
                t.addEventListener('toggle', i),
                u.forEach(function (t) {
                  t.addEventListener('toggle', n);
                }),
                p.forEach(function (t) {
                  t.addEventListener('click', r);
                }),
                function () {
                  s(),
                    window.removeEventListener('resize', e),
                    t.removeEventListener('toggle', i),
                    u.forEach(function (t) {
                      t.removeEventListener('toggle', n);
                    }),
                    p.forEach(function (t) {
                      t.removeEventListener('click', r);
                    });
                }
              );
            })(document.querySelector('[data-vf-js="drawer"]'))));
      }),
      je((Ne = window.matchMedia('(min-width: 768px)'))),
      Ne.addEventListener('change', je);
    var qe = document.querySelectorAll('[data-js="product-card"]');
    function He(t) {
      var e = function () {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 'idle';
        if (t in n) {
          var e = n[t],
            r = e.content.cloneNode(!0);
          i.replaceChildren(r);
        }
      };
      if (!t) return function () {};
      var r = t.querySelector('[data-js="product-card/add-to-cart"]'),
        n = {
          idle: null == r ? void 0 : r.querySelector('template[data-id="idle"]'),
          loading: null == r ? void 0 : r.querySelector('template[data-id="loading"]'),
          added: null == r ? void 0 : r.querySelector('template[data-id="added"]'),
        },
        i = null == r ? void 0 : r.querySelector('[data-js="product-card/add-to-cart/slot"]');
      return (
        null == r || r.addEventListener('click', o),
        function () {
          null == r || r.removeEventListener('click', o);
        }
      );
      function o(t) {
        return a.apply(this, arguments);
      }
      function a() {
        return (a = $e(
          ae.mark(function t(n) {
            var i, o, a, s, l, c, h, u, p, f, d, m;
            return ae.wrap(
              function (t) {
                for (;;)
                  switch ((t.prev = t.next)) {
                    case 0:
                      if (((i = n.currentTarget), (o = i.dataset.productId))) {
                        t.next = 4;
                        break;
                      }
                      return t.abrupt('return');
                    case 4:
                      return (
                        (a = Number(o)),
                        (s = null),
                        (r.disabled = !0),
                        e('loading'),
                        (t.prev = 8),
                        (l = { items: [{ id: a, quantity: 1 }] }),
                        i.dataset.sections &&
                          ((l.sections = i.dataset.sections),
                          (c = l.sections.split(',')).includes('main-cart-items') &&
                            (u =
                              null === (h = document.getElementById('main-cart-items')) || void 0 === h
                                ? void 0
                                : h.dataset.id) &&
                            (c.splice(c.indexOf('main-cart-items'), 1, u), (l.sections = c.join(','))),
                          i.dataset.sectionsUrl && (l.sections_url = i.dataset.sectionsUrl)),
                        (t.next = 13),
                        fetch('/cart/add.js', {
                          credentials: 'same-origin',
                          headers: { 'X-Requested-With': 'XMLHttpRequest', 'Content-Type': 'application/json' },
                          method: 'POST',
                          body: JSON.stringify(l),
                        })
                      );
                    case 13:
                      return (p = t.sent), (t.next = 16), p.json();
                    case 16:
                      if (
                        ((f = t.sent),
                        !(s = ((null == f ? void 0 : f.items) || []).find(function (t) {
                          return t.id === a;
                        })))
                      ) {
                        t.next = 29;
                        break;
                      }
                      if ((e('added'), !(null == f ? void 0 : f.sections))) {
                        t.next = 29;
                        break;
                      }
                      return (
                        (t.next = 24),
                        fetch('/cart.js', {
                          credentials: 'same-origin',
                          headers: { 'X-Requested-With': 'XMLHttpRequest', 'Content-Type': 'application/json' },
                        })
                          .then(function (t) {
                            return t.text();
                          })
                          .then(function (t) {
                            return JSON.parse(t);
                          })
                      );
                    case 24:
                      ((m = t.sent).sections = f.sections),
                        null === (d = document.querySelector('cart-items')) ||
                          void 0 === d ||
                          d.dispatchEvent(new CustomEvent('refresh', { detail: { cart: m } })),
                        document.body.dispatchEvent(
                          new CustomEvent('productCard:addToCart', { detail: { lineItem: s, cart: m } }),
                        ),
                        document.body.dispatchEvent(
                          new CustomEvent('productCard:addToCart:sections', { detail: { sections: f.sections } }),
                        );
                    case 29:
                      t.next = 34;
                      break;
                    case 31:
                      (t.prev = 31), (t.t0 = t.catch(8)), console.error('Product Card Error:', t.t0);
                    case 34:
                      return (
                        (t.prev = 34),
                        s
                          ? setTimeout(function () {
                              (r.disabled = !1), e('idle');
                            }, 3e3)
                          : ((r.disabled = !1), e('idle')),
                        t.finish(34)
                      );
                    case 37:
                      return t.abrupt('return', s);
                    case 38:
                    case 'end':
                      return t.stop();
                  }
              },
              t,
              null,
              [[8, 31, 34, 37]],
            );
          }),
        )).apply(this, arguments);
      }
    }
    function Ge(t, e, r, n, i, o, a) {
      try {
        var s = t[o](a),
          l = s.value;
      } catch (t) {
        return void r(t);
      }
      s.done ? e(l) : Promise.resolve(l).then(n, i);
    }
    function We(t) {
      return function () {
        var e = this,
          r = arguments;
        return new Promise(function (n, i) {
          var o = t.apply(e, r);
          function a(t) {
            Ge(o, n, i, a, s, 'next', t);
          }
          function s(t) {
            Ge(o, n, i, a, s, 'throw', t);
          }
          a(void 0);
        });
      };
    }
    function Ue(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        (n.enumerable = n.enumerable || !1),
          (n.configurable = !0),
          'value' in n && (n.writable = !0),
          Object.defineProperty(t, n.key, n);
      }
    }
    qe.length > 0 && qe.forEach(He),
      (window.mountProductCard = He),
      (function (t) {
        var e,
          r = function (r) {
            r.matches
              ? (null == e || e(), (e = null))
              : e ||
                (e = (function (t) {
                  var e = function (t) {
                      var e,
                        r,
                        i =
                          null !== (r = null === (e = t.detail) || void 0 === e ? void 0 : e.state) && void 0 !== r
                            ? r
                            : void 0;
                      n(i);
                    },
                    r = function (t) {
                      t.preventDefault(), t.stopImmediatePropagation(), n(void 0, t.currentTarget);
                    },
                    n = function () {
                      var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : void 0,
                        e = (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0) || i;
                      if (!e) return !1;
                      var r = 'true' === e.getAttribute('aria-expanded'),
                        n = void 0 === t ? !r : Boolean(t);
                      if (n === r) return r;
                      e.setAttribute('aria-expanded', n), o && (o.inert = !n);
                    };
                  if (!t) return function () {};
                  var i = t.querySelector('[data-js="product-navigation-toggle"]'),
                    o = t.querySelector('[data-js="product-navigation-list"]'),
                    a = 'true' === (null == i ? void 0 : i.getAttribute('aria-expanded'));
                  return (
                    n(!1),
                    t.addEventListener('toggle', e),
                    null == i || i.addEventListener('click', r),
                    function () {
                      t.removeEventListener('toggle', e), null == i || i.removeEventListener('click', r), n(a);
                    }
                  );
                })(t));
          };
        if (!t) return function () {};
        var n = window.matchMedia('(min-width: 82.5rem)'),
          i = t.querySelectorAll('[data-js="product-navigation-anchor"]'),
          o = t.querySelector('[data-js="product-navigation-add-to-cart"]');
        r(n), n.addEventListener('change', r);
        Array.from(i).map(function (t) {
          return (function (t) {
            var e = function (t) {
                var e;
                t.preventDefault(), t.stopImmediatePropagation();
                var n = t.currentTarget.getAttribute('href'),
                  i = document.querySelector(n);
                r(i),
                  null === (e = document.getElementById('ProductNavigation')) ||
                    void 0 === e ||
                    e.dispatchEvent(new CustomEvent('toggle', { detail: { state: !1 } }));
              },
              r = function (t) {
                var e, r;
                if (t) {
                  var n,
                    i,
                    o = t.getBoundingClientRect().top,
                    a = Number(document.documentElement.style.getPropertyValue('--header-height').replace('px', '')),
                    s =
                      null !==
                        (n =
                          null === (e = document.getElementById('ProductNavigation')) || void 0 === e
                            ? void 0
                            : e.offsetHeight) && void 0 !== n
                        ? n
                        : 0,
                    l =
                      null !==
                        (i =
                          null === (r = document.getElementById('ProductNavigation-List')) || void 0 === r
                            ? void 0
                            : r.offsetHeight) && void 0 !== i
                        ? i
                        : 0;
                  window.scrollTo({ top: o - a - s + l + window.scrollY, behavior: 'smooth' });
                }
              };
            return t
              ? (t.addEventListener('click', e),
                function () {
                  t.removeEventListener('click', e);
                })
              : function () {};
          })(t);
        }),
          (function (t) {
            var e = function (t) {
              t.preventDefault();
              var e = t.currentTarget,
                r = null == e ? void 0 : e.getAttribute('data-variant-id');
              if (r) {
                (e.disabled = !0), window.scrollTo({ top: 0, behavior: 'smooth' });
                var n = { items: [{ id: r, quantity: 1 }] };
                fetch(window.Shopify.routes.root + 'cart/add.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify(n),
                })
                  .then(function (t) {
                    return t.json();
                  })
                  .then(function (t) {
                    return (
                      window.SLIDECART_UPDATE(function () {
                        window.SLIDECART_OPEN();
                      }),
                      (e.disabled = !1),
                      t
                    );
                  })
                  .finally(function () {
                    e.disabled = !1;
                  });
              }
            };
            if (!t) return function () {};
            var r = document.querySelector('variant-inputs');
            t.addEventListener('click', e),
              null == r ||
                r.addEventListener('variantChanged', function (e) {
                  var r,
                    n,
                    i = null === (r = e.detail) || void 0 === r ? void 0 : r.variant,
                    o = null !== (n = null == i ? void 0 : i.available) && void 0 !== n && n,
                    a = t.getAttribute('data-variant-id');
                  (t.disabled = !o),
                    (null == i ? void 0 : i.id) && i.id !== a && t.setAttribute('data-variant-id', i.id);
                });
          })(o);
      })(document.getElementById('ProductNavigation')),
      (function (t) {
        var e = function (t) {
            var e = document.querySelectorAll('#cart-icon-bubble'),
              r = new DOMParser().parseFromString(t, 'text/html').querySelector('.shopify-section').innerHTML;
            e.forEach(function (t) {
              t.innerHTML = r;
            });
          },
          r = function () {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 'idle';
            if (t in o) {
              var e = o[t],
                r = e.content.cloneNode(!0);
              a.replaceChildren(r);
            }
          };
        if (!t) return function () {};
        var n = t.dataset.variantId,
          i = t.querySelector('[data-js="product-bundle/add-to-cart"]'),
          o = {
            idle: null == i ? void 0 : i.querySelector('template[data-id="idle"]'),
            loading: null == i ? void 0 : i.querySelector('template[data-id="loading"]'),
            added: null == i ? void 0 : i.querySelector('template[data-id="added"]'),
          },
          a = null == i ? void 0 : i.querySelector('[data-js="product-bundle/add-to-cart/slot"]'),
          s = t.querySelector('[data-js="product-bundle/add-to-cart/error"]');
        return (
          i.addEventListener('click', l),
          document.body.addEventListener('productCard:addToCart:sections', function (t) {
            if (null == t ? void 0 : t.detail) {
              var r = t.detail.sections;
              (null == r ? void 0 : r['cart-icon-bubble']) && e(r['cart-icon-bubble']),
                window.SLIDECART_UPDATE(function () {
                  window.SLIDECART_OPEN();
                });
            }
          }),
          function () {
            i.removeEventListener('click', l);
          }
        );
        function l(t) {
          return c.apply(this, arguments);
        }
        function c() {
          return (c = We(
            ae.mark(function t(i) {
              var o, a, l, c, h, u, p, f;
              return ae.wrap(
                function (t) {
                  for (;;)
                    switch ((t.prev = t.next)) {
                      case 0:
                        if (
                          ((o = i.currentTarget),
                          (a = o.dataset.bundleVariants),
                          !((null == (l = null == a ? void 0 : a.split(',')) ? void 0 : l.length) < 1))
                        ) {
                          t.next = 5;
                          break;
                        }
                        return t.abrupt('return');
                      case 5:
                        return (
                          null == s || s.setAttribute('hidden', !0),
                          (c = null),
                          (h = {
                            items: [{ id: n, quantity: 1 }].concat(
                              l.map(function (t) {
                                return { id: t, quantity: 1 };
                              }),
                            ),
                            sections: 'cart-icon-bubble',
                          }),
                          (o.disabled = !0),
                          r('loading'),
                          (t.prev = 10),
                          (t.next = 14),
                          fetch(window.Shopify.routes.root + 'cart/add.js', {
                            credentials: 'same-origin',
                            headers: { 'X-Requested-With': 'XMLHttpRequest', 'Content-Type': 'application/json' },
                            method: 'POST',
                            body: JSON.stringify(h),
                          })
                        );
                      case 14:
                        return (p = t.sent), (t.next = 17), p.json();
                      case 17:
                        (f = t.sent),
                          (c = ((null == f ? void 0 : f.items) || []).find(function (t) {
                            return String(t.variant_id) === n;
                          }))
                            ? (r('added'),
                              window.SLIDECART_UPDATE(function () {
                                window.SLIDECART_OPEN();
                              }))
                            : 422 === (null == f ? void 0 : f.status) &&
                              (null == s || s.setAttribute('hidden', !1),
                              s &&
                                (s.textContnet =
                                  f.description || 'An error occurred while adding the product bundle to the cart.')),
                          (null == f || null === (u = f.sections) || void 0 === u ? void 0 : u['cart-icon-bubble']) &&
                            e(f.sections['cart-icon-bubble']),
                          (t.next = 26);
                        break;
                      case 23:
                        (t.prev = 23), (t.t0 = t.catch(10)), console.error('Error adding product bundle to cart', t.t0);
                      case 26:
                        return (
                          (t.prev = 26),
                          c
                            ? setTimeout(function () {
                                (o.disabled = !1), r('idle');
                              }, 3e3)
                            : ((o.disabled = !1), r('idle')),
                          t.finish(26)
                        );
                      case 29:
                      case 'end':
                        return t.stop();
                    }
                },
                t,
                null,
                [[10, 23, 26, 29]],
              );
            }),
          )).apply(this, arguments);
        }
      })(document.querySelector('[data-js="product-bundle"]'));
    var Xe = '(prefers-reduced-motion: reduce)';
    function Ye(t) {
      t.length = 0;
    }
    function Ke(t, e, r) {
      return Array.prototype.slice.call(t, e, r);
    }
    function Ze(t) {
      return t.bind.apply(t, [null].concat(Ke(arguments, 1)));
    }
    var Je = setTimeout,
      Qe = function () {};
    function tr(t) {
      return requestAnimationFrame(t);
    }
    function er(t, e) {
      return typeof e === t;
    }
    function rr(t) {
      return !sr(t) && er('object', t);
    }
    var nr = Array.isArray,
      ir = Ze(er, 'function'),
      or = Ze(er, 'string'),
      ar = Ze(er, 'undefined');
    function sr(t) {
      return null === t;
    }
    function lr(t) {
      try {
        return t instanceof (t.ownerDocument.defaultView || window).HTMLElement;
      } catch (t) {
        return !1;
      }
    }
    function cr(t) {
      return nr(t) ? t : [t];
    }
    function hr(t, e) {
      cr(t).forEach(e);
    }
    function ur(t, e) {
      return t.indexOf(e) > -1;
    }
    function pr(t, e) {
      return t.push.apply(t, cr(e)), t;
    }
    function fr(t, e, r) {
      t &&
        hr(e, function (e) {
          e && t.classList[r ? 'add' : 'remove'](e);
        });
    }
    function dr(t, e) {
      fr(t, or(e) ? e.split(' ') : e, !0);
    }
    function mr(t, e) {
      hr(e, t.appendChild.bind(t));
    }
    function yr(t, e) {
      hr(t, function (t) {
        var r = (e || t).parentNode;
        r && r.insertBefore(t, e);
      });
    }
    function gr(t, e) {
      return lr(t) && (t.msMatchesSelector || t.matches).call(t, e);
    }
    function vr(t, e) {
      var r = t ? Ke(t.children) : [];
      return e
        ? r.filter(function (t) {
            return gr(t, e);
          })
        : r;
    }
    function br(t, e) {
      return e ? vr(t, e)[0] : t.firstElementChild;
    }
    var xr = Object.keys;
    function Er(t, e, r) {
      return (
        t &&
          (r ? xr(t).reverse() : xr(t)).forEach(function (r) {
            '__proto__' !== r && e(t[r], r);
          }),
        t
      );
    }
    function wr(t) {
      return (
        Ke(arguments, 1).forEach(function (e) {
          Er(e, function (r, n) {
            t[n] = e[n];
          });
        }),
        t
      );
    }
    function _r(t) {
      return (
        Ke(arguments, 1).forEach(function (e) {
          Er(e, function (e, r) {
            nr(e) ? (t[r] = e.slice()) : rr(e) ? (t[r] = _r({}, rr(t[r]) ? t[r] : {}, e)) : (t[r] = e);
          });
        }),
        t
      );
    }
    function Sr(t, e) {
      hr(e || xr(t), function (e) {
        delete t[e];
      });
    }
    function Pr(t, e) {
      hr(t, function (t) {
        hr(e, function (e) {
          t && t.removeAttribute(e);
        });
      });
    }
    function Ar(t, e, r) {
      rr(e)
        ? Er(e, function (e, r) {
            Ar(t, r, e);
          })
        : hr(t, function (t) {
            sr(r) || '' === r ? Pr(t, e) : t.setAttribute(e, String(r));
          });
    }
    function Cr(t, e, r) {
      var n = document.createElement(t);
      return e && (or(e) ? dr(n, e) : Ar(n, e)), r && mr(r, n), n;
    }
    function Tr(t, e, r) {
      if (ar(r)) return getComputedStyle(t)[e];
      sr(r) || (t.style[e] = '' + r);
    }
    function kr(t, e) {
      Tr(t, 'display', e);
    }
    function Dr(t) {
      (t.setActive && t.setActive()) || t.focus({ preventScroll: !0 });
    }
    function Mr(t, e) {
      return t.getAttribute(e);
    }
    function Ir(t, e) {
      return t && t.classList.contains(e);
    }
    function Fr(t) {
      return t.getBoundingClientRect();
    }
    function Lr(t) {
      hr(t, function (t) {
        t && t.parentNode && t.parentNode.removeChild(t);
      });
    }
    function Rr(t) {
      return br(new DOMParser().parseFromString(t, 'text/html').body);
    }
    function Or(t, e) {
      t.preventDefault(), e && (t.stopPropagation(), t.stopImmediatePropagation());
    }
    function Br(t, e) {
      return t && t.querySelector(e);
    }
    function jr(t, e) {
      return e ? Ke(t.querySelectorAll(e)) : [];
    }
    function Nr(t, e) {
      fr(t, e, !1);
    }
    function Vr(t) {
      return t.timeStamp;
    }
    function zr(t) {
      return or(t) ? t : t ? t + 'px' : '';
    }
    var $r = 'splide';
    function qr(t, e) {
      if (!t) throw new Error('[splide] ' + (e || ''));
    }
    var Hr = Math.min,
      Gr = Math.max,
      Wr = Math.floor,
      Ur = Math.ceil,
      Xr = Math.abs;
    function Yr(t, e, r) {
      return Xr(t - e) < r;
    }
    function Kr(t, e, r, n) {
      var i = Hr(e, r),
        o = Gr(e, r);
      return n ? i < t && t < o : i <= t && t <= o;
    }
    function Zr(t, e, r) {
      var n = Hr(e, r),
        i = Gr(e, r);
      return Hr(Gr(n, t), i);
    }
    function Jr(t) {
      return +(t > 0) - +(t < 0);
    }
    function Qr(t, e) {
      return (
        hr(e, function (e) {
          t = t.replace('%s', '' + e);
        }),
        t
      );
    }
    function tn(t) {
      return t < 10 ? '0' + t : '' + t;
    }
    var en = {};
    function rn() {
      var t = [];
      function e(t, e, r) {
        hr(t, function (t) {
          t &&
            hr(e, function (e) {
              e.split(' ').forEach(function (e) {
                var n = e.split('.');
                r(t, n[0], n[1]);
              });
            });
        });
      }
      return {
        bind: function (r, n, i, o) {
          e(r, n, function (e, r, n) {
            var a = 'addEventListener' in e,
              s = a ? e.removeEventListener.bind(e, r, i, o) : e.removeListener.bind(e, i);
            a ? e.addEventListener(r, i, o) : e.addListener(i), t.push([e, r, n, i, s]);
          });
        },
        unbind: function (r, n, i) {
          e(r, n, function (e, r, n) {
            t = t.filter(function (t) {
              return !!(t[0] !== e || t[1] !== r || t[2] !== n || (i && t[3] !== i)) || (t[4](), !1);
            });
          });
        },
        dispatch: function (t, e, r) {
          var n;
          return (
            'function' == typeof CustomEvent
              ? (n = new CustomEvent(e, { bubbles: !0, detail: r }))
              : (n = document.createEvent('CustomEvent')).initCustomEvent(e, !0, !1, r),
            t.dispatchEvent(n),
            n
          );
        },
        destroy: function () {
          t.forEach(function (t) {
            t[4]();
          }),
            Ye(t);
        },
      };
    }
    var nn = 'mounted',
      on = 'ready',
      an = 'move',
      sn = 'moved',
      ln = 'click',
      cn = 'refresh',
      hn = 'updated',
      un = 'resize',
      pn = 'resized',
      fn = 'scroll',
      dn = 'scrolled',
      mn = 'destroy',
      yn = 'navigation:mounted',
      gn = 'autoplay:play',
      vn = 'autoplay:pause',
      bn = 'lazyload:loaded',
      xn = 'ei';
    function En(t) {
      var e = t ? t.event.bus : document.createDocumentFragment(),
        r = rn();
      return (
        t && t.event.on(mn, r.destroy),
        wr(r, {
          bus: e,
          on: function (t, n) {
            r.bind(e, cr(t).join(' '), function (t) {
              n.apply(n, nr(t.detail) ? t.detail : []);
            });
          },
          off: Ze(r.unbind, e),
          emit: function (t) {
            r.dispatch(e, t, Ke(arguments, 1));
          },
        })
      );
    }
    function wn(t, e, r, n) {
      var i,
        o,
        a = Date.now,
        s = 0,
        l = !0,
        c = 0;
      function h() {
        if (!l) {
          if (((s = t ? Hr((a() - i) / t, 1) : 1), r && r(s), s >= 1 && (e(), (i = a()), n && ++c >= n))) return u();
          o = tr(h);
        }
      }
      function u() {
        l = !0;
      }
      function p() {
        o && cancelAnimationFrame(o), (s = 0), (o = 0), (l = !0);
      }
      return {
        start: function (e) {
          e || p(), (i = a() - (e ? s * t : 0)), (l = !1), (o = tr(h));
        },
        rewind: function () {
          (i = a()), (s = 0), r && r(s);
        },
        pause: u,
        cancel: p,
        set: function (e) {
          t = e;
        },
        isPaused: function () {
          return l;
        },
      };
    }
    var _n = 'ArrowLeft',
      Sn = 'ArrowRight',
      Pn = 'ArrowUp',
      An = 'ArrowDown',
      Cn = 'ttb',
      Tn = {
        width: ['height'],
        left: ['top', 'right'],
        right: ['bottom', 'left'],
        x: ['y'],
        X: ['Y'],
        Y: ['X'],
        ArrowLeft: [Pn, Sn],
        ArrowRight: [An, _n],
      };
    var kn = 'role',
      Dn = 'tabindex',
      Mn = 'aria-controls',
      In = 'aria-current',
      Fn = 'aria-selected',
      Ln = 'aria-label',
      Rn = 'aria-labelledby',
      On = 'aria-hidden',
      Bn = 'aria-orientation',
      jn = 'aria-roledescription',
      Nn = 'aria-live',
      Vn = 'aria-busy',
      zn = 'aria-atomic',
      $n = [kn, Dn, 'disabled', Mn, In, Ln, Rn, On, Bn, jn],
      qn = $r,
      Hn = 'splide__track',
      Gn = 'splide__slide',
      Wn = Gn + '--clone',
      Un = 'splide__arrows',
      Xn = 'splide__arrow',
      Yn = Xn + '--prev',
      Kn = Xn + '--next',
      Zn = 'splide__pagination',
      Jn = 'is-active',
      Qn = 'is-prev',
      ti = 'is-next',
      ei = 'is-visible',
      ri = 'is-loading',
      ni = 'is-focus-in',
      ii = 'is-overflow',
      oi = [Jn, ei, Qn, ti, ri, ni, ii],
      ai = {
        slide: Gn,
        clone: Wn,
        arrows: Un,
        arrow: Xn,
        prev: Yn,
        next: Kn,
        pagination: Zn,
        page: 'splide__pagination__page',
        spinner: 'splide__spinner',
      },
      si = 'touchmove mousemove',
      li = 'touchend touchcancel mouseup click',
      ci = 'slide',
      hi = 'loop',
      ui = 'fade';
    var pi = { passive: !1, capture: !0 },
      fi = { Spacebar: ' ', Right: Sn, Left: _n, Up: Pn, Down: An };
    function di(t) {
      return (t = or(t) ? t : t.key), fi[t] || t;
    }
    var mi = 'keydown',
      yi = 'data-splide-lazy',
      gi = 'data-splide-lazy-srcset',
      vi = [' ', 'Enter'],
      bi = Object.freeze({
        __proto__: null,
        Media: function (t, e, r) {
          var n = t.state,
            i = r.breakpoints || {},
            o = r.reducedMotion || {},
            a = rn(),
            s = [];
          function l(t) {
            t && a.destroy();
          }
          function c(t, e) {
            var r = matchMedia(e);
            a.bind(r, 'change', h), s.push([t, r]);
          }
          function h() {
            var e = n.is(7),
              i = r.direction,
              o = s.reduce(function (t, e) {
                return _r(t, e[1].matches ? e[0] : {});
              }, {});
            Sr(r),
              u(o),
              r.destroy
                ? t.destroy('completely' === r.destroy)
                : e
                ? (l(!0), t.mount())
                : i !== r.direction && t.refresh();
          }
          function u(e, i, o) {
            _r(r, e), i && _r(Object.getPrototypeOf(r), e), (!o && n.is(1)) || t.emit(hn, r);
          }
          return {
            setup: function () {
              var t = 'min' === r.mediaQuery;
              xr(i)
                .sort(function (e, r) {
                  return t ? +e - +r : +r - +e;
                })
                .forEach(function (e) {
                  c(i[e], '(' + (t ? 'min' : 'max') + '-width:' + e + 'px)');
                }),
                c(o, Xe),
                h();
            },
            destroy: l,
            reduce: function (t) {
              matchMedia(Xe).matches && (t ? _r(r, o) : Sr(r, xr(o)));
            },
            set: u,
          };
        },
        Direction: function (t, e, r) {
          return {
            resolve: function (t, e, n) {
              var i = 'rtl' !== (n = n || r.direction) || e ? (n === Cn ? 0 : -1) : 1;
              return (
                (Tn[t] && Tn[t][i]) ||
                t.replace(/width|left|right/i, function (t, e) {
                  var r = Tn[t.toLowerCase()][i] || t;
                  return e > 0 ? r.charAt(0).toUpperCase() + r.slice(1) : r;
                })
              );
            },
            orient: function (t) {
              return t * ('rtl' === r.direction ? 1 : -1);
            },
          };
        },
        Elements: function (t, e, r) {
          var n,
            i,
            o,
            a = En(t),
            s = a.on,
            l = a.bind,
            c = t.root,
            h = r.i18n,
            u = {},
            p = [],
            f = [],
            d = [];
          function m() {
            var t, e, o;
            (n = v('.' + Hn)),
              (i = br(n, '.splide__list')),
              qr(n && i, 'A track/list element is missing.'),
              pr(p, vr(i, '.splide__slide:not(.' + Wn + ')')),
              Er(
                {
                  arrows: Un,
                  pagination: Zn,
                  prev: Yn,
                  next: Kn,
                  bar: 'splide__progress__bar',
                  toggle: 'splide__toggle',
                },
                function (t, e) {
                  u[e] = v('.' + t);
                },
              ),
              wr(u, { root: c, track: n, list: i, slides: p }),
              (e = c.id || '' + (t = $r) + tn((en[t] = (en[t] || 0) + 1))),
              (o = r.role),
              (c.id = e),
              (n.id = n.id || e + '-track'),
              (i.id = i.id || e + '-list'),
              !Mr(c, kn) && 'SECTION' !== c.tagName && o && Ar(c, kn, o),
              Ar(c, jn, h.carousel),
              Ar(i, kn, 'presentation'),
              g();
          }
          function y(t) {
            var e = $n.concat('style');
            Ye(p), Nr(c, f), Nr(n, d), Pr([n, i], e), Pr(c, t ? e : ['style', jn]);
          }
          function g() {
            Nr(c, f),
              Nr(n, d),
              (f = b(qn)),
              (d = b(Hn)),
              dr(c, f),
              dr(n, d),
              Ar(c, Ln, r.label),
              Ar(c, Rn, r.labelledby);
          }
          function v(t) {
            var e = Br(c, t);
            return e &&
              (function (t, e) {
                if (ir(t.closest)) return t.closest(e);
                for (var r = t; r && 1 === r.nodeType && !gr(r, e); ) r = r.parentElement;
                return r;
              })(e, '.splide') === c
              ? e
              : void 0;
          }
          function b(t) {
            return [
              t + '--' + r.type,
              t + '--' + r.direction,
              r.drag && t + '--draggable',
              r.isNavigation && t + '--nav',
              t === qn && Jn,
            ];
          }
          return wr(u, {
            setup: m,
            mount: function () {
              s(cn, y),
                s(cn, m),
                s(hn, g),
                l(
                  document,
                  'touchstart mousedown keydown',
                  function (t) {
                    o = 'keydown' === t.type;
                  },
                  { capture: !0 },
                ),
                l(c, 'focusin', function () {
                  fr(c, ni, !!o);
                });
            },
            destroy: y,
          });
        },
        Slides: function (t, e, r) {
          var n = En(t),
            i = n.on,
            o = n.emit,
            a = n.bind,
            s = e.Elements,
            l = s.slides,
            c = s.list,
            h = [];
          function u() {
            l.forEach(function (t, e) {
              f(t, e, -1);
            });
          }
          function p() {
            m(function (t) {
              t.destroy();
            }),
              Ye(h);
          }
          function f(e, r, n) {
            var i = (function (t, e, r, n) {
              var i,
                o = En(t),
                a = o.on,
                s = o.emit,
                l = o.bind,
                c = t.Components,
                h = t.root,
                u = t.options,
                p = u.isNavigation,
                f = u.updateOnMove,
                d = u.i18n,
                m = u.pagination,
                y = u.slideFocus,
                g = c.Direction.resolve,
                v = Mr(n, 'style'),
                b = Mr(n, Ln),
                x = r > -1,
                E = br(n, '.splide__slide__container');
              function w() {
                var i = t.splides
                  .map(function (t) {
                    var r = t.splide.Components.Slides.getAt(e);
                    return r ? r.slide.id : '';
                  })
                  .join(' ');
                Ar(n, Ln, Qr(d.slideX, (x ? r : e) + 1)), Ar(n, Mn, i), Ar(n, kn, y ? 'button' : ''), y && Pr(n, jn);
              }
              function _() {
                i || S();
              }
              function S() {
                if (!i) {
                  var r = t.index;
                  (o = P()) !== Ir(n, Jn) && (fr(n, Jn, o), Ar(n, In, (p && o) || ''), s(o ? 'active' : 'inactive', A)),
                    (function () {
                      var e = (function () {
                          if (t.is(ui)) return P();
                          var e = Fr(c.Elements.track),
                            r = Fr(n),
                            i = g('left', !0),
                            o = g('right', !0);
                          return Wr(e[i]) <= Ur(r[i]) && Wr(r[o]) <= Ur(e[o]);
                        })(),
                        r = !e && (!P() || x);
                      if (
                        (t.state.is([4, 5]) || Ar(n, On, r || ''),
                        Ar(jr(n, u.focusableNodes || ''), Dn, r ? -1 : ''),
                        y && Ar(n, Dn, r ? -1 : 0),
                        e !== Ir(n, ei) && (fr(n, ei, e), s(e ? 'visible' : 'hidden', A)),
                        !e && document.activeElement === n)
                      ) {
                        var i = c.Slides.getAt(t.index);
                        i && Dr(i.slide);
                      }
                    })(),
                    fr(n, Qn, e === r - 1),
                    fr(n, ti, e === r + 1);
                }
                var o;
              }
              function P() {
                var n = t.index;
                return n === e || (u.cloneStatus && n === r);
              }
              var A = {
                index: e,
                slideIndex: r,
                slide: n,
                container: E,
                isClone: x,
                mount: function () {
                  x ||
                    ((n.id = h.id + '-slide' + tn(e + 1)),
                    Ar(n, kn, m ? 'tabpanel' : 'group'),
                    Ar(n, jn, d.slide),
                    Ar(n, Ln, b || Qr(d.slideLabel, [e + 1, t.length]))),
                    l(n, 'click', Ze(s, ln, A)),
                    l(n, 'keydown', Ze(s, 'sk', A)),
                    a([sn, 'sh', dn], S),
                    a(yn, w),
                    f && a(an, _);
                },
                destroy: function () {
                  (i = !0), o.destroy(), Nr(n, oi), Pr(n, $n), Ar(n, 'style', v), Ar(n, Ln, b || '');
                },
                update: S,
                style: function (t, e, r) {
                  Tr((r && E) || n, t, e);
                },
                isWithin: function (r, n) {
                  var i = Xr(r - e);
                  return x || (!u.rewind && !t.is(hi)) || (i = Hr(i, t.length - i)), i <= n;
                },
              };
              return A;
            })(t, r, n, e);
            i.mount(),
              h.push(i),
              h.sort(function (t, e) {
                return t.index - e.index;
              });
          }
          function d(t) {
            return t
              ? y(function (t) {
                  return !t.isClone;
                })
              : h;
          }
          function m(t, e) {
            d(e).forEach(t);
          }
          function y(t) {
            return h.filter(
              ir(t)
                ? t
                : function (e) {
                    return or(t) ? gr(e.slide, t) : ur(cr(t), e.index);
                  },
            );
          }
          return {
            mount: function () {
              u(), i(cn, p), i(cn, u);
            },
            destroy: p,
            update: function () {
              m(function (t) {
                t.update();
              });
            },
            register: f,
            get: d,
            getIn: function (t) {
              var n = e.Controller,
                i = n.toIndex(t),
                o = n.hasFocus() ? 1 : r.perPage;
              return y(function (t) {
                return Kr(t.index, i, i + o - 1);
              });
            },
            getAt: function (t) {
              return y(t)[0];
            },
            add: function (t, e) {
              hr(t, function (t) {
                if ((or(t) && (t = Rr(t)), lr(t))) {
                  var n = l[e];
                  n ? yr(t, n) : mr(c, t),
                    dr(t, r.classes.slide),
                    (i = t),
                    (s = Ze(o, un)),
                    (h = jr(i, 'img')),
                    (u = h.length)
                      ? h.forEach(function (t) {
                          a(t, 'load error', function () {
                            --u || s();
                          });
                        })
                      : s();
                }
                var i, s, h, u;
              }),
                o(cn);
            },
            remove: function (t) {
              Lr(
                y(t).map(function (t) {
                  return t.slide;
                }),
              ),
                o(cn);
            },
            forEach: m,
            filter: y,
            style: function (t, e, r) {
              m(function (n) {
                n.style(t, e, r);
              });
            },
            getLength: function (t) {
              return t ? l.length : h.length;
            },
            isEnough: function () {
              return h.length > r.perPage;
            },
          };
        },
        Layout: function (t, e, r) {
          var n,
            i,
            o,
            a = En(t),
            s = a.on,
            l = a.bind,
            c = a.emit,
            h = e.Slides,
            u = e.Direction.resolve,
            p = e.Elements,
            f = p.root,
            d = p.track,
            m = p.list,
            y = h.getAt,
            g = h.style;
          function v() {
            (n = r.direction === Cn),
              Tr(f, 'maxWidth', zr(r.width)),
              Tr(d, u('paddingLeft'), x(!1)),
              Tr(d, u('paddingRight'), x(!0)),
              b(!0);
          }
          function b(t) {
            var e,
              a = Fr(f);
            (t || i.width !== a.width || i.height !== a.height) &&
              (Tr(
                d,
                'height',
                ((e = ''),
                n &&
                  (qr((e = E()), 'height or heightRatio is missing.'),
                  (e = 'calc(' + e + ' - ' + x(!1) + ' - ' + x(!0) + ')')),
                e),
              ),
              g(u('marginRight'), zr(r.gap)),
              g('width', r.autoWidth ? null : zr(r.fixedWidth) || (n ? '' : w())),
              g('height', zr(r.fixedHeight) || (n ? (r.autoHeight ? null : w()) : E()), !0),
              (i = a),
              c(pn),
              o !== (o = T()) && (fr(f, ii, o), c('overflow', o)));
          }
          function x(t) {
            var e = r.padding,
              n = u(t ? 'right' : 'left');
            return (e && zr(e[n] || (rr(e) ? 0 : e))) || '0px';
          }
          function E() {
            return zr(r.height || Fr(m).width * r.heightRatio);
          }
          function w() {
            var t = zr(r.gap);
            return 'calc((100%' + (t && ' + ' + t) + ')/' + (r.perPage || 1) + (t && ' - ' + t) + ')';
          }
          function _() {
            return Fr(m)[u('width')];
          }
          function S(t, e) {
            var r = y(t || 0);
            return r ? Fr(r.slide)[u('width')] + (e ? 0 : C()) : 0;
          }
          function P(t, e) {
            var r = y(t);
            if (r) {
              var n = Fr(r.slide)[u('right')],
                i = Fr(m)[u('left')];
              return Xr(n - i) + (e ? 0 : C());
            }
            return 0;
          }
          function A(e) {
            return P(t.length - 1) - P(0) + S(0, e);
          }
          function C() {
            var t = y(0);
            return (t && parseFloat(Tr(t.slide, u('marginRight')))) || 0;
          }
          function T() {
            return t.is(ui) || A(!0) > _();
          }
          return {
            mount: function () {
              var t, e;
              v(),
                l(
                  window,
                  'resize load',
                  ((t = Ze(c, un)),
                  (e = wn(0, t, null, 1)),
                  function () {
                    e.isPaused() && e.start();
                  }),
                ),
                s([hn, cn], v),
                s(un, b);
            },
            resize: b,
            listSize: _,
            slideSize: S,
            sliderSize: A,
            totalSize: P,
            getPadding: function (t) {
              return parseFloat(Tr(d, u('padding' + (t ? 'Right' : 'Left')))) || 0;
            },
            isOverflow: T,
          };
        },
        Clones: function (t, e, r) {
          var n,
            i = En(t),
            o = i.on,
            a = e.Elements,
            s = e.Slides,
            l = e.Direction.resolve,
            c = [];
          function h() {
            o(cn, u),
              o([hn, un], f),
              (n = d()) &&
                ((function (e) {
                  var n = s.get().slice(),
                    i = n.length;
                  if (i) {
                    for (; n.length < e; ) pr(n, n);
                    pr(n.slice(-e), n.slice(0, e)).forEach(function (o, l) {
                      var h = l < e,
                        u = (function (e, n) {
                          var i = e.cloneNode(!0);
                          return dr(i, r.classes.clone), (i.id = t.root.id + '-clone' + tn(n + 1)), i;
                        })(o.slide, l);
                      h ? yr(u, n[0].slide) : mr(a.list, u), pr(c, u), s.register(u, l - e + (h ? 0 : i), o.index);
                    });
                  }
                })(n),
                e.Layout.resize(!0));
          }
          function u() {
            p(), h();
          }
          function p() {
            Lr(c), Ye(c), i.destroy();
          }
          function f() {
            var t = d();
            n !== t && (n < t || !t) && i.emit(cn);
          }
          function d() {
            var n = r.clones;
            if (t.is(hi)) {
              if (ar(n)) {
                var i = r[l('fixedWidth')] && e.Layout.slideSize(0);
                n = (i && Ur(Fr(a.track)[l('width')] / i)) || (r[l('autoWidth')] && t.length) || 2 * r.perPage;
              }
            } else n = 0;
            return n;
          }
          return { mount: h, destroy: p };
        },
        Move: function (t, e, r) {
          var n,
            i = En(t),
            o = i.on,
            a = i.emit,
            s = t.state.set,
            l = e.Layout,
            c = l.slideSize,
            h = l.getPadding,
            u = l.totalSize,
            p = l.listSize,
            f = l.sliderSize,
            d = e.Direction,
            m = d.resolve,
            y = d.orient,
            g = e.Elements,
            v = g.list,
            b = g.track;
          function x() {
            e.Controller.isBusy() || (e.Scroll.cancel(), E(t.index), e.Slides.update());
          }
          function E(t) {
            w(A(t, !0));
          }
          function w(r, n) {
            if (!t.is(ui)) {
              var i = n
                ? r
                : (function (r) {
                    if (t.is(hi)) {
                      var n = P(r),
                        i = n > e.Controller.getEnd();
                      (n < 0 || i) && (r = _(r, i));
                    }
                    return r;
                  })(r);
              Tr(v, 'transform', 'translate' + m('X') + '(' + i + 'px)'), r !== i && a('sh');
            }
          }
          function _(t, e) {
            var r = t - T(e),
              n = f();
            return t - y(n * (Ur(Xr(r) / n) || 1)) * (e ? 1 : -1);
          }
          function S() {
            w(C(), !0), n.cancel();
          }
          function P(t) {
            for (var r = e.Slides.get(), n = 0, i = 1 / 0, o = 0; o < r.length; o++) {
              var a = r[o].index,
                s = Xr(A(a, !0) - t);
              if (!(s <= i)) break;
              (i = s), (n = a);
            }
            return n;
          }
          function A(e, n) {
            var i = y(
              u(e - 1) -
                (function (t) {
                  var e = r.focus;
                  return 'center' === e ? (p() - c(t, !0)) / 2 : +e * c(t) || 0;
                })(e),
            );
            return n
              ? (function (e) {
                  return r.trimSpace && t.is(ci) && (e = Zr(e, 0, y(f(!0) - p()))), e;
                })(i)
              : i;
          }
          function C() {
            var t = m('left');
            return Fr(v)[t] - Fr(b)[t] + y(h(!1));
          }
          function T(t) {
            return A(t ? e.Controller.getEnd() : 0, !!r.trimSpace);
          }
          return {
            mount: function () {
              (n = e.Transition), o([nn, pn, hn, cn], x);
            },
            move: function (t, e, r, i) {
              var o, l;
              t !== e &&
                ((o = t > r), (l = y(_(C(), o))), o ? l >= 0 : l <= v[m('scrollWidth')] - Fr(b)[m('width')]) &&
                (S(), w(_(C(), t > r), !0)),
                s(4),
                a(an, e, r, t),
                n.start(e, function () {
                  s(3), a(sn, e, r, t), i && i();
                });
            },
            jump: E,
            translate: w,
            shift: _,
            cancel: S,
            toIndex: P,
            toPosition: A,
            getPosition: C,
            getLimit: T,
            exceededLimit: function (t, e) {
              e = ar(e) ? C() : e;
              var r = !0 !== t && y(e) < y(T(!1)),
                n = !1 !== t && y(e) > y(T(!0));
              return r || n;
            },
            reposition: x,
          };
        },
        Controller: function (t, e, r) {
          var n,
            i,
            o,
            a,
            s = En(t),
            l = s.on,
            c = s.emit,
            h = e.Move,
            u = h.getPosition,
            p = h.getLimit,
            f = h.toPosition,
            d = e.Slides,
            m = d.isEnough,
            y = d.getLength,
            g = r.omitEnd,
            v = t.is(hi),
            b = t.is(ci),
            x = Ze(A, !1),
            E = Ze(A, !0),
            w = r.start || 0,
            _ = w;
          function S() {
            (i = y(!0)), (o = r.perMove), (a = r.perPage), (n = k());
            var t = Zr(w, 0, g ? n : i - 1);
            t !== w && ((w = t), h.reposition());
          }
          function P() {
            n !== k() && c(xn);
          }
          function A(t, e) {
            var r = o || (F() ? 1 : a),
              i = C(w + r * (t ? -1 : 1), w, !(o || F()));
            return -1 === i && b && !Yr(u(), p(!t), 1) ? (t ? 0 : n) : e ? i : T(i);
          }
          function C(e, s, l) {
            if (m() || F()) {
              var c = (function (e) {
                if (b && 'move' === r.trimSpace && e !== w)
                  for (var n = u(); n === f(e, !0) && Kr(e, 0, t.length - 1, !r.rewind); ) e < w ? --e : ++e;
                return e;
              })(e);
              c !== e && ((s = e), (e = c), (l = !1)),
                e < 0 || e > n
                  ? (e =
                      o || (!Kr(0, e, s, !0) && !Kr(n, s, e, !0))
                        ? v
                          ? l
                            ? e < 0
                              ? -(i % a || a)
                              : i
                            : e
                          : r.rewind
                          ? e < 0
                            ? n
                            : 0
                          : -1
                        : D(M(e)))
                  : l && e !== s && (e = D(M(s) + (e < s ? -1 : 1)));
            } else e = -1;
            return e;
          }
          function T(t) {
            return v ? (t + i) % i || 0 : t;
          }
          function k() {
            for (var t = i - (F() || (v && o) ? 1 : a); g && t-- > 0; )
              if (f(i - 1, !0) !== f(t, !0)) {
                t++;
                break;
              }
            return Zr(t, 0, i - 1);
          }
          function D(t) {
            return Zr(F() ? t : a * t, 0, n);
          }
          function M(t) {
            return F() ? Hr(t, n) : Wr((t >= n ? i - 1 : t) / a);
          }
          function I(t) {
            t !== w && ((_ = w), (w = t));
          }
          function F() {
            return !ar(r.focus) || r.isNavigation;
          }
          function L() {
            return t.state.is([4, 5]) && !!r.waitForTransition;
          }
          return {
            mount: function () {
              S(), l([hn, cn, xn], S), l(pn, P);
            },
            go: function (t, e, r) {
              if (!L()) {
                var i = (function (t) {
                    var e = w;
                    if (or(t)) {
                      var r = t.match(/([+\-<>])(\d+)?/) || [],
                        i = r[1],
                        o = r[2];
                      '+' === i || '-' === i
                        ? (e = C(w + +('' + i + (+o || 1)), w))
                        : '>' === i
                        ? (e = o ? D(+o) : x(!0))
                        : '<' === i && (e = E(!0));
                    } else e = v ? t : Zr(t, 0, n);
                    return e;
                  })(t),
                  o = T(i);
                o > -1 && (e || o !== w) && (I(o), h.move(i, o, _, r));
              }
            },
            scroll: function (t, r, i, o) {
              e.Scroll.scroll(t, r, i, function () {
                var t = T(h.toIndex(u()));
                I(g ? Hr(t, n) : t), o && o();
              });
            },
            getNext: x,
            getPrev: E,
            getAdjacent: A,
            getEnd: k,
            setIndex: I,
            getIndex: function (t) {
              return t ? _ : w;
            },
            toIndex: D,
            toPage: M,
            toDest: function (t) {
              var e = h.toIndex(t);
              return b ? Zr(e, 0, n) : e;
            },
            hasFocus: F,
            isBusy: L,
          };
        },
        Arrows: function (t, e, r) {
          var n,
            i,
            o = En(t),
            a = o.on,
            s = o.bind,
            l = o.emit,
            c = r.classes,
            h = r.i18n,
            u = e.Elements,
            p = e.Controller,
            f = u.arrows,
            d = u.track,
            m = f,
            y = u.prev,
            g = u.next,
            v = {};
          function b() {
            var t;
            !(t = r.arrows) ||
              (y && g) ||
              ((m = f || Cr('div', c.arrows)), (y = _(!0)), (g = _(!1)), (n = !0), mr(m, [y, g]), !f && yr(m, d)),
              y &&
                g &&
                (wr(v, { prev: y, next: g }),
                kr(m, t ? '' : 'none'),
                dr(m, (i = Un + '--' + r.direction)),
                t &&
                  (a([nn, sn, cn, dn, xn], S),
                  s(g, 'click', Ze(w, '>')),
                  s(y, 'click', Ze(w, '<')),
                  S(),
                  Ar([y, g], Mn, d.id),
                  l('arrows:mounted', y, g))),
              a(hn, x);
          }
          function x() {
            E(), b();
          }
          function E() {
            o.destroy(), Nr(m, i), n ? (Lr(f ? [y, g] : m), (y = g = null)) : Pr([y, g], $n);
          }
          function w(t) {
            p.go(t, !0);
          }
          function _(t) {
            return Rr(
              '<button class="' +
                c.arrow +
                ' ' +
                (t ? c.prev : c.next) +
                '" type="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="40" height="40" focusable="false"><path d="' +
                (r.arrowPath ||
                  'm15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z') +
                '" />',
            );
          }
          function S() {
            if (y && g) {
              var e = t.index,
                r = p.getPrev(),
                n = p.getNext(),
                i = r > -1 && e < r ? h.last : h.prev,
                o = n > -1 && e > n ? h.first : h.next;
              (y.disabled = r < 0), (g.disabled = n < 0), Ar(y, Ln, i), Ar(g, Ln, o), l('arrows:updated', y, g, r, n);
            }
          }
          return { arrows: v, mount: b, destroy: E, update: S };
        },
        Autoplay: function (t, e, r) {
          var n,
            i,
            o = En(t),
            a = o.on,
            s = o.bind,
            l = o.emit,
            c = wn(r.interval, t.go.bind(t, '>'), function (t) {
              var e = u.bar;
              e && Tr(e, 'width', 100 * t + '%'), l('autoplay:playing', t);
            }),
            h = c.isPaused,
            u = e.Elements,
            p = e.Elements,
            f = p.root,
            d = p.toggle,
            m = r.autoplay,
            y = 'pause' === m;
          function g() {
            h() && e.Slides.isEnough() && (c.start(!r.resetProgress), (i = n = y = !1), x(), l(gn));
          }
          function v(t) {
            void 0 === t && (t = !0), (y = !!t), x(), h() || (c.pause(), l(vn));
          }
          function b() {
            y || (n || i ? v(!1) : g());
          }
          function x() {
            d && (fr(d, Jn, !y), Ar(d, Ln, r.i18n[y ? 'play' : 'pause']));
          }
          function E(t) {
            var n = e.Slides.getAt(t);
            c.set((n && +Mr(n.slide, 'data-splide-interval')) || r.interval);
          }
          return {
            mount: function () {
              m &&
                (r.pauseOnHover &&
                  s(f, 'mouseenter mouseleave', function (t) {
                    (n = 'mouseenter' === t.type), b();
                  }),
                r.pauseOnFocus &&
                  s(f, 'focusin focusout', function (t) {
                    (i = 'focusin' === t.type), b();
                  }),
                d &&
                  s(d, 'click', function () {
                    y ? g() : v(!0);
                  }),
                a([an, fn, cn], c.rewind),
                a(an, E),
                d && Ar(d, Mn, u.track.id),
                y || g(),
                x());
            },
            destroy: c.cancel,
            play: g,
            pause: v,
            isPaused: h,
          };
        },
        Cover: function (t, e, r) {
          var n = En(t).on;
          function i(t) {
            e.Slides.forEach(function (e) {
              var r = br(e.container || e.slide, 'img');
              r && r.src && o(t, r, e);
            });
          }
          function o(t, e, r) {
            r.style('background', t ? 'center/cover no-repeat url("' + e.src + '")' : '', !0), kr(e, t ? 'none' : '');
          }
          return {
            mount: function () {
              r.cover && (n(bn, Ze(o, !0)), n([nn, hn, cn], Ze(i, !0)));
            },
            destroy: Ze(i, !1),
          };
        },
        Scroll: function (t, e, r) {
          var n,
            i,
            o = En(t),
            a = o.on,
            s = o.emit,
            l = t.state.set,
            c = e.Move,
            h = c.getPosition,
            u = c.getLimit,
            p = c.exceededLimit,
            f = c.translate,
            d = t.is(ci),
            m = 1;
          function y(t, r, o, a, u) {
            var f = h();
            if ((b(), o && (!d || !p()))) {
              var y = e.Layout.sliderSize(),
                x = Jr(t) * y * Wr(Xr(t) / y) || 0;
              t = c.toPosition(e.Controller.toDest(t % y)) + x;
            }
            var E = Yr(f, t, 1);
            (m = 1),
              (r = E ? 0 : r || Gr(Xr(t - f) / 1.5, 800)),
              (i = a),
              (n = wn(r, g, Ze(v, f, t, u), 1)),
              l(5),
              s(fn),
              n.start();
          }
          function g() {
            l(3), i && i(), s(dn);
          }
          function v(t, e, n, o) {
            var a = h(),
              s =
                t +
                (e - t) *
                  (function (t) {
                    var e = r.easingFunc;
                    return e ? e(t) : 1 - Math.pow(1 - t, 4);
                  })(o),
              l = (s - a) * m;
            f(a + l), d && !n && p() && ((m *= 0.6), Xr(l) < 10 && y(u(p(!0)), 600, !1, i, !0));
          }
          function b() {
            n && n.cancel();
          }
          function x() {
            n && !n.isPaused() && (b(), g());
          }
          return {
            mount: function () {
              a(an, b), a([hn, cn], x);
            },
            destroy: b,
            scroll: y,
            cancel: x,
          };
        },
        Drag: function (t, e, r) {
          var n,
            i,
            o,
            a,
            s,
            l,
            c,
            h,
            u = En(t),
            p = u.on,
            f = u.emit,
            d = u.bind,
            m = u.unbind,
            y = t.state,
            g = e.Move,
            v = e.Scroll,
            b = e.Controller,
            x = e.Elements.track,
            E = e.Media.reduce,
            w = e.Direction,
            _ = w.resolve,
            S = w.orient,
            P = g.getPosition,
            A = g.exceededLimit,
            C = !1;
          function T() {
            var t = r.drag;
            N(!t), (a = 'free' === t);
          }
          function k(t) {
            if (((l = !1), !c)) {
              var e = j(t);
              (n = t.target),
                (i = r.noDrag),
                gr(n, '.splide__pagination__page, .' + Xn) ||
                  (i && gr(n, i)) ||
                  (!e && t.button) ||
                  (b.isBusy()
                    ? Or(t, !0)
                    : ((h = e ? x : window),
                      (s = y.is([4, 5])),
                      (o = null),
                      d(h, si, D, pi),
                      d(h, li, M, pi),
                      g.cancel(),
                      v.cancel(),
                      F(t)));
            }
            var n, i;
          }
          function D(e) {
            if ((y.is(6) || (y.set(6), f('drag')), e.cancelable))
              if (s) {
                g.translate(n + L(e) / (C && t.is(ci) ? 5 : 1));
                var i = R(e) > 200,
                  o = C !== (C = A());
                (i || o) && F(e), (l = !0), f('dragging'), Or(e);
              } else
                (function (t) {
                  return Xr(L(t)) > Xr(L(t, !0));
                })(e) &&
                  ((s = (function (t) {
                    var e = r.dragMinThreshold,
                      n = rr(e),
                      i = (n && e.mouse) || 0,
                      o = (n ? e.touch : +e) || 10;
                    return Xr(L(t)) > (j(t) ? o : i);
                  })(e)),
                  Or(e));
          }
          function M(n) {
            y.is(6) && (y.set(3), f('dragged')),
              s &&
                ((function (n) {
                  var i = (function (e) {
                      if (t.is(hi) || !C) {
                        var r = R(e);
                        if (r && r < 200) return L(e) / r;
                      }
                      return 0;
                    })(n),
                    o = (function (t) {
                      return (
                        P() +
                        Jr(t) *
                          Hr(Xr(t) * (r.flickPower || 600), a ? 1 / 0 : e.Layout.listSize() * (r.flickMaxPages || 1))
                      );
                    })(i),
                    s = r.rewind && r.rewindByDrag;
                  E(!1),
                    a
                      ? b.scroll(o, 0, r.snap)
                      : t.is(ui)
                      ? b.go(S(Jr(i)) < 0 ? (s ? '<' : '-') : s ? '>' : '+')
                      : t.is(ci) && C && s
                      ? b.go(A(!0) ? '>' : '<')
                      : b.go(b.toDest(o), !0),
                    E(!0);
                })(n),
                Or(n)),
              m(h, si, D),
              m(h, li, M),
              (s = !1);
          }
          function I(t) {
            !c && l && Or(t, !0);
          }
          function F(t) {
            (o = i), (i = t), (n = P());
          }
          function L(t, e) {
            return B(t, e) - B(O(t), e);
          }
          function R(t) {
            return Vr(t) - Vr(O(t));
          }
          function O(t) {
            return (i === t && o) || i;
          }
          function B(t, e) {
            return (j(t) ? t.changedTouches[0] : t)['page' + _(e ? 'Y' : 'X')];
          }
          function j(t) {
            return 'undefined' != typeof TouchEvent && t instanceof TouchEvent;
          }
          function N(t) {
            c = t;
          }
          return {
            mount: function () {
              d(x, si, Qe, pi),
                d(x, li, Qe, pi),
                d(x, 'touchstart mousedown', k, pi),
                d(x, 'click', I, { capture: !0 }),
                d(x, 'dragstart', Or),
                p([nn, hn], T);
            },
            disable: N,
            isDragging: function () {
              return s;
            },
          };
        },
        Keyboard: function (t, e, r) {
          var n,
            i,
            o = En(t),
            a = o.on,
            s = o.bind,
            l = o.unbind,
            c = t.root,
            h = e.Direction.resolve;
          function u() {
            var t = r.keyboard;
            t && ((n = 'global' === t ? window : c), s(n, mi, d));
          }
          function p() {
            l(n, mi);
          }
          function f() {
            var t = i;
            (i = !0),
              Je(function () {
                i = t;
              });
          }
          function d(e) {
            if (!i) {
              var r = di(e);
              r === h(_n) ? t.go('<') : r === h(Sn) && t.go('>');
            }
          }
          return {
            mount: function () {
              u(), a(hn, p), a(hn, u), a(an, f);
            },
            destroy: p,
            disable: function (t) {
              i = t;
            },
          };
        },
        LazyLoad: function (t, e, r) {
          var n = En(t),
            i = n.on,
            o = n.off,
            a = n.bind,
            s = n.emit,
            l = 'sequential' === r.lazyLoad,
            c = [sn, dn],
            h = [];
          function u() {
            Ye(h),
              e.Slides.forEach(function (t) {
                jr(t.slide, '[data-splide-lazy], [data-splide-lazy-srcset]').forEach(function (e) {
                  var n = Mr(e, yi),
                    i = Mr(e, gi);
                  if (n !== e.src || i !== e.srcset) {
                    var o = r.classes.spinner,
                      a = e.parentElement,
                      s = br(a, '.' + o) || Cr('span', o, a);
                    h.push([e, t, s]), e.src || kr(e, 'none');
                  }
                });
              }),
              l ? m() : (o(c), i(c, p), p());
          }
          function p() {
            (h = h.filter(function (e) {
              var n = r.perPage * ((r.preloadPages || 1) + 1) - 1;
              return !e[1].isWithin(t.index, n) || f(e);
            })).length || o(c);
          }
          function f(t) {
            var e = t[0];
            dr(t[1].slide, ri),
              a(e, 'load error', Ze(d, t)),
              Ar(e, 'src', Mr(e, yi)),
              Ar(e, 'srcset', Mr(e, gi)),
              Pr(e, yi),
              Pr(e, gi);
          }
          function d(t, e) {
            var r = t[0],
              n = t[1];
            Nr(n.slide, ri), 'error' !== e.type && (Lr(t[2]), kr(r, ''), s(bn, r, n), s(un)), l && m();
          }
          function m() {
            h.length && f(h.shift());
          }
          return {
            mount: function () {
              r.lazyLoad && (u(), i(cn, u));
            },
            destroy: Ze(Ye, h),
            check: p,
          };
        },
        Pagination: function (t, e, r) {
          var n,
            i,
            o = En(t),
            a = o.on,
            s = o.emit,
            l = o.bind,
            c = e.Slides,
            h = e.Elements,
            u = e.Controller,
            p = u.hasFocus,
            f = u.getIndex,
            d = u.go,
            m = e.Direction.resolve,
            y = h.pagination,
            g = [];
          function v() {
            n && (Lr(y ? Ke(n.children) : n), Nr(n, i), Ye(g), (n = null)), o.destroy();
          }
          function b(t) {
            d('>' + t, !0);
          }
          function x(t, e) {
            var r = g.length,
              n = di(e),
              i = E(),
              o = -1;
            n === m(Sn, !1, i)
              ? (o = ++t % r)
              : n === m(_n, !1, i)
              ? (o = (--t + r) % r)
              : 'Home' === n
              ? (o = 0)
              : 'End' === n && (o = r - 1);
            var a = g[o];
            a && (Dr(a.button), d('>' + o), Or(e, !0));
          }
          function E() {
            return r.paginationDirection || r.direction;
          }
          function w(t) {
            return g[u.toPage(t)];
          }
          function _() {
            var t = w(f(!0)),
              e = w(f());
            if (t) {
              var r = t.button;
              Nr(r, Jn), Pr(r, Fn), Ar(r, Dn, -1);
            }
            if (e) {
              var i = e.button;
              dr(i, Jn), Ar(i, Fn, !0), Ar(i, Dn, '');
            }
            s('pagination:updated', { list: n, items: g }, t, e);
          }
          return {
            items: g,
            mount: function e() {
              v(), a([hn, cn, xn], e);
              var o = r.pagination;
              y && kr(y, o ? '' : 'none'),
                o &&
                  (a([an, fn, dn], _),
                  (function () {
                    var e = t.length,
                      o = r.classes,
                      a = r.i18n,
                      s = r.perPage,
                      f = p() ? u.getEnd() + 1 : Ur(e / s);
                    dr((n = y || Cr('ul', o.pagination, h.track.parentElement)), (i = Zn + '--' + E())),
                      Ar(n, kn, 'tablist'),
                      Ar(n, Ln, a.select),
                      Ar(n, Bn, E() === Cn ? 'vertical' : '');
                    for (var d = 0; d < f; d++) {
                      var m = Cr('li', null, n),
                        v = Cr('button', { class: o.page, type: 'button' }, m),
                        w = c.getIn(d).map(function (t) {
                          return t.slide.id;
                        }),
                        _ = !p() && s > 1 ? a.pageX : a.slideX;
                      l(v, 'click', Ze(b, d)),
                        r.paginationKeyboard && l(v, 'keydown', Ze(x, d)),
                        Ar(m, kn, 'presentation'),
                        Ar(v, kn, 'tab'),
                        Ar(v, Mn, w.join(' ')),
                        Ar(v, Ln, Qr(_, d + 1)),
                        Ar(v, Dn, -1),
                        g.push({ li: m, button: v, page: d });
                    }
                  })(),
                  _(),
                  s('pagination:mounted', { list: n, items: g }, w(t.index)));
            },
            destroy: v,
            getAt: w,
            update: _,
          };
        },
        Sync: function (t, e, r) {
          var n = r.isNavigation,
            i = r.slideFocus,
            o = [];
          function a() {
            var e, r;
            t.splides.forEach(function (e) {
              e.isParent || (l(t, e.splide), l(e.splide, t));
            }),
              n && ((r = (e = En(t)).on)(ln, h), r('sk', u), r([nn, hn], c), o.push(e), e.emit(yn, t.splides));
          }
          function s() {
            o.forEach(function (t) {
              t.destroy();
            }),
              Ye(o);
          }
          function l(t, e) {
            var r = En(t);
            r.on(an, function (t, r, n) {
              e.go(e.is(hi) ? n : t);
            }),
              o.push(r);
          }
          function c() {
            Ar(e.Elements.list, Bn, r.direction === Cn ? 'vertical' : '');
          }
          function h(e) {
            t.go(e.index);
          }
          function u(t, e) {
            ur(vi, di(e)) && (h(t), Or(e));
          }
          return {
            setup: Ze(e.Media.set, { slideFocus: ar(i) ? n : i }, !0),
            mount: a,
            destroy: s,
            remount: function () {
              s(), a();
            },
          };
        },
        Wheel: function (t, e, r) {
          var n = En(t).bind,
            i = 0;
          function o(n) {
            if (n.cancelable) {
              var o = n.deltaY,
                a = o < 0,
                s = Vr(n),
                l = r.wheelMinThreshold || 0,
                c = r.wheelSleep || 0;
              Xr(o) > l && s - i > c && (t.go(a ? '<' : '>'), (i = s)),
                (function (n) {
                  return !r.releaseWheel || t.state.is(4) || -1 !== e.Controller.getAdjacent(n);
                })(a) && Or(n);
            }
          }
          return {
            mount: function () {
              r.wheel && n(e.Elements.track, 'wheel', o, pi);
            },
          };
        },
        Live: function (t, e, r) {
          var n = En(t).on,
            i = e.Elements.track,
            o = r.live && !r.isNavigation,
            a = Cr('span', 'splide__sr'),
            s = wn(90, Ze(l, !1));
          function l(t) {
            Ar(i, Vn, t), t ? (mr(i, a), s.start()) : (Lr(a), s.cancel());
          }
          function c(t) {
            o && Ar(i, Nn, t ? 'off' : 'polite');
          }
          return {
            mount: function () {
              o &&
                (c(!e.Autoplay.isPaused()),
                Ar(i, zn, !0),
                (a.textContent = '…'),
                n(gn, Ze(c, !0)),
                n(vn, Ze(c, !1)),
                n([sn, dn], Ze(l, !0)));
            },
            disable: c,
            destroy: function () {
              Pr(i, [Nn, zn, Vn]), Lr(a);
            },
          };
        },
      }),
      xi = {
        type: 'slide',
        role: 'region',
        speed: 400,
        perPage: 1,
        cloneStatus: !0,
        arrows: !0,
        pagination: !0,
        paginationKeyboard: !0,
        interval: 5e3,
        pauseOnHover: !0,
        pauseOnFocus: !0,
        resetProgress: !0,
        easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
        drag: !0,
        direction: 'ltr',
        trimSpace: !0,
        focusableNodes: 'a, button, textarea, input, select, iframe',
        live: !0,
        classes: ai,
        i18n: {
          prev: 'Previous slide',
          next: 'Next slide',
          first: 'Go to first slide',
          last: 'Go to last slide',
          slideX: 'Go to slide %s',
          pageX: 'Go to page %s',
          play: 'Start autoplay',
          pause: 'Pause autoplay',
          carousel: 'carousel',
          slide: 'slide',
          select: 'Select a slide to show',
          slideLabel: '%s of %s',
        },
        reducedMotion: { speed: 0, rewindSpeed: 0, autoplay: 'pause' },
      };
    function Ei(t, e, r) {
      var n = e.Slides;
      function i() {
        n.forEach(function (t) {
          t.style('transform', 'translateX(-' + 100 * t.index + '%)');
        });
      }
      return {
        mount: function () {
          En(t).on([nn, cn], i);
        },
        start: function (t, e) {
          n.style('transition', 'opacity ' + r.speed + 'ms ' + r.easing), Je(e);
        },
        cancel: Qe,
      };
    }
    function wi(t, e, r) {
      var n,
        i = e.Move,
        o = e.Controller,
        a = e.Scroll,
        s = e.Elements.list,
        l = Ze(Tr, s, 'transition');
      function c() {
        l(''), a.cancel();
      }
      return {
        mount: function () {
          En(t).bind(s, 'transitionend', function (t) {
            t.target === s && n && (c(), n());
          });
        },
        start: function (e, s) {
          var c = i.toPosition(e, !0),
            h = i.getPosition(),
            u = (function (e) {
              var n = r.rewindSpeed;
              if (t.is(ci) && n) {
                var i = o.getIndex(!0),
                  a = o.getEnd();
                if ((0 === i && e >= a) || (i >= a && 0 === e)) return n;
              }
              return r.speed;
            })(e);
          Xr(c - h) >= 1 && u >= 1
            ? r.useScroll
              ? a.scroll(c, u, !1, s)
              : (l('transform ' + u + 'ms ' + r.easing), i.translate(c, !0), (n = s))
            : (i.jump(e), s());
        },
        cancel: c,
      };
    }
    var _i = (function () {
        function t(e, r) {
          var n;
          (this.event = En()),
            (this.Components = {}),
            (this.state =
              ((n = 1),
              {
                set: function (t) {
                  n = t;
                },
                is: function (t) {
                  return ur(cr(t), n);
                },
              })),
            (this.splides = []),
            (this._o = {}),
            (this._E = {});
          var i = or(e) ? Br(document, e) : e;
          qr(i, i + ' is invalid.'),
            (this.root = i),
            (r = _r({ label: Mr(i, Ln) || '', labelledby: Mr(i, Rn) || '' }, xi, t.defaults, r || {}));
          try {
            _r(r, JSON.parse(Mr(i, 'data-splide')));
          } catch (t) {
            qr(!1, 'Invalid JSON');
          }
          this._o = Object.create(_r({}, r));
        }
        var e,
          r,
          n = t.prototype;
        return (
          (n.mount = function (t, e) {
            var r = this,
              n = this.state,
              i = this.Components;
            return (
              qr(n.is([1, 7]), 'Already mounted!'),
              n.set(1),
              (this._C = i),
              (this._T = e || this._T || (this.is(ui) ? Ei : wi)),
              (this._E = t || this._E),
              Er(wr({}, bi, this._E, { Transition: this._T }), function (t, e) {
                var n = t(r, i, r._o);
                (i[e] = n), n.setup && n.setup();
              }),
              Er(i, function (t) {
                t.mount && t.mount();
              }),
              this.emit(nn),
              dr(this.root, 'is-initialized'),
              n.set(3),
              this.emit(on),
              this
            );
          }),
          (n.sync = function (t) {
            return (
              this.splides.push({ splide: t }),
              t.splides.push({ splide: this, isParent: !0 }),
              this.state.is(3) && (this._C.Sync.remount(), t.Components.Sync.remount()),
              this
            );
          }),
          (n.go = function (t) {
            return this._C.Controller.go(t), this;
          }),
          (n.on = function (t, e) {
            return this.event.on(t, e), this;
          }),
          (n.off = function (t) {
            return this.event.off(t), this;
          }),
          (n.emit = function (t) {
            var e;
            return (e = this.event).emit.apply(e, [t].concat(Ke(arguments, 1))), this;
          }),
          (n.add = function (t, e) {
            return this._C.Slides.add(t, e), this;
          }),
          (n.remove = function (t) {
            return this._C.Slides.remove(t), this;
          }),
          (n.is = function (t) {
            return this._o.type === t;
          }),
          (n.refresh = function () {
            return this.emit(cn), this;
          }),
          (n.destroy = function (t) {
            void 0 === t && (t = !0);
            var e = this.event,
              r = this.state;
            return (
              r.is(1)
                ? En(this).on(on, this.destroy.bind(this, t))
                : (Er(
                    this._C,
                    function (e) {
                      e.destroy && e.destroy(t);
                    },
                    !0,
                  ),
                  e.emit(mn),
                  e.destroy(),
                  t && Ye(this.splides),
                  r.set(7)),
              this
            );
          }),
          (e = t),
          (r = [
            {
              key: 'options',
              get: function () {
                return this._o;
              },
              set: function (t) {
                this._C.Media.set(t, !0, !0);
              },
            },
            {
              key: 'length',
              get: function () {
                return this._C.Slides.getLength(!0);
              },
            },
            {
              key: 'index',
              get: function () {
                return this._C.Controller.getIndex();
              },
            },
          ]) && Ue(e.prototype, r),
          Object.defineProperty(e, 'prototype', { writable: !1 }),
          t
        );
      })(),
      Si = _i;
    (Si.defaults = {}),
      (Si.STATES = { CREATED: 1, MOUNTED: 2, IDLE: 3, MOVING: 4, SCROLLING: 5, DRAGGING: 6, DESTROYED: 7 });
    var Pi = document.querySelectorAll('[data-bundle-slider]');
    function Ai(t, e, r, n, i, o, a) {
      try {
        var s = t[o](a),
          l = s.value;
      } catch (t) {
        return void r(t);
      }
      s.done ? e(l) : Promise.resolve(l).then(n, i);
    }
    function Ci(t) {
      return function () {
        var e = this,
          r = arguments;
        return new Promise(function (n, i) {
          var o = t.apply(e, r);
          function a(t) {
            Ai(o, n, i, a, s, 'next', t);
          }
          function s(t) {
            Ai(o, n, i, a, s, 'throw', t);
          }
          a(void 0);
        });
      };
    }
    function Ti() {
      if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ('function' == typeof Proxy) return !0;
      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }
    function ki(t, e, r) {
      return (
        (ki = Ti()
          ? Reflect.construct
          : function (t, e, r) {
              var n = [null];
              n.push.apply(n, e);
              var i = new (Function.bind.apply(t, n))();
              return r && Fi(i, r.prototype), i;
            }),
        ki.apply(null, arguments)
      );
    }
    function Di(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        (n.enumerable = n.enumerable || !1),
          (n.configurable = !0),
          'value' in n && (n.writable = !0),
          Object.defineProperty(t, n.key, n);
      }
    }
    function Mi(t) {
      return (
        (Mi = Object.setPrototypeOf
          ? Object.getPrototypeOf
          : function (t) {
              return t.__proto__ || Object.getPrototypeOf(t);
            }),
        Mi(t)
      );
    }
    function Ii(t, e) {
      return !e || ('object' !== Li(e) && 'function' != typeof e)
        ? (function (t) {
            if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return t;
          })(t)
        : e;
    }
    function Fi(t, e) {
      return (
        (Fi =
          Object.setPrototypeOf ||
          function (t, e) {
            return (t.__proto__ = e), t;
          }),
        Fi(t, e)
      );
    }
    document.querySelectorAll('[data-influencer-slider]').forEach(function (t) {
      var e = new Si(t, { type: 'fade', focus: 'center', pagination: !1 });
      t.querySelectorAll('[data-video-trigger]').forEach(function (t) {
        t.addEventListener('click', function () {
          var e = t.closest('.group'),
            r = e.querySelector('video');
          e.classList.add('is-playing'), r.play();
        });
      }),
        e.on('move', function () {
          var e = t.querySelectorAll('video'),
            r = t.querySelectorAll('.group');
          e.forEach(function (t) {
            t.pause();
          }),
            r.forEach(function (t) {
              t.classList.remove('is-playing');
            });
        }),
        e.mount();
    }),
      Pi.forEach(function (t) {
        var e = new Si(t, {
          type: 'slide',
          perPage: 4,
          perMove: 1,
          gap: 16,
          autoWidth: !0,
          focus: 'center',
          pagination: !1,
        });
        e.mount();
        var r = e.Components.Controller,
          n = t.querySelectorAll('[data-bundle-slide]'),
          i = 'active',
          o = '[data-bundle-slide-content]',
          a = '[data-bundle-slide-inner-content]',
          s = '[data-bundle-cta]',
          l = function (t) {
            var e = t.dataset.bundleLink;
            e &&
              (document.querySelector(s).setAttribute('href', e),
              document.querySelector(s).classList.remove('disabled')),
              n.forEach(function (t) {
                var e = t.querySelector(o),
                  r = e.querySelector(a);
                t.classList.remove(i),
                  e.classList.remove('open'),
                  r.classList.add('hidden'),
                  r.classList.add('!opacity-0');
              });
            var r = t.querySelector(o),
              l = r.querySelector(a);
            t.classList.add(i),
              r.classList.add('open'),
              setTimeout(function () {
                l.classList.remove('hidden');
              }, 200),
              setTimeout(function () {
                l.classList.remove('!opacity-0');
              }, 250);
          },
          c = !1;
        e.on('moved', function () {
          if (c) c = !1;
          else {
            var t = e.index,
              r = n[t];
            l(r);
          }
        }),
          n.forEach(function (t, n) {
            t.querySelector('[data-bundle-slide-link]').addEventListener('click', function (h) {
              if ((h.preventDefault(), (e.options.focus = 'center'), (c = !0), t.classList.contains(i))) {
                var u = t.querySelector(o),
                  p = u.querySelector(a);
                t.classList.remove(i),
                  u.classList.remove('open'),
                  p.classList.add('hidden'),
                  p.classList.add('!opacity-0');
                var f = document.querySelector(s);
                f.classList.add('disabled'), f.setAttribute('disabled', '');
              } else l(t), r.go(n);
            });
          });
      }),
      (window.SLIDECART_UPDATED = function (t) {
        var e = [101813059595, 106255122443],
          r = [7351952769097];
        t.items
          .filter(function (t) {
            if (e.includes(t.product_id) || r.includes(t.product_id)) return t;
          })
          .forEach(function (t) {
            document.querySelectorAll('[data-line-item-id="'.concat(t.variant_id, '"]')).forEach(function (t) {
              t.querySelectorAll('input[type="text"], input[type="number"]').forEach(function (t) {
                t.disabled = !0;
              });
              var e = t.querySelector('.quantity-selector');
              e.classList.add('!opacity-50', 'cursor-not-allowed', 'pointer-events-none'),
                e.querySelectorAll('button').forEach(function (t) {
                  t.disabled = !0;
                });
            });
          });
      });
    var Li = function (t) {
      return t && 'undefined' != typeof Symbol && t.constructor === Symbol ? 'symbol' : typeof t;
    };
    function Ri(t) {
      var e = 'function' == typeof Map ? new Map() : void 0;
      return (
        (Ri = function (t) {
          if (null === t || ((r = t), -1 === Function.toString.call(r).indexOf('[native code]'))) return t;
          var r;
          if ('function' != typeof t) throw new TypeError('Super expression must either be null or a function');
          if (void 0 !== e) {
            if (e.has(t)) return e.get(t);
            e.set(t, n);
          }
          function n() {
            return ki(t, arguments, Mi(this).constructor);
          }
          return (
            (n.prototype = Object.create(t.prototype, {
              constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 },
            })),
            Fi(n, t)
          );
        }),
        Ri(t)
      );
    }
    var Oi = (function (t) {
      !(function (t, e) {
        if ('function' != typeof e && null !== e)
          throw new TypeError('Super expression must either be null or a function');
        (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })),
          e && Fi(t, e);
      })(a, t);
      var e,
        r,
        n,
        i,
        o =
          ((n = a),
          (i = (function () {
            if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ('function' == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (t) {
              return !1;
            }
          })()),
          function () {
            var t,
              e = Mi(n);
            if (i) {
              var r = Mi(this).constructor;
              t = Reflect.construct(e, arguments, r);
            } else t = e.apply(this, arguments);
            return Ii(this, t);
          });
      function a() {
        var t;
        return (
          (function (t, e) {
            if (!(t instanceof e)) throw new TypeError('Cannot call a class as a function');
          })(this, a),
          (t = o.call(this)),
          console.log('QuickAddDrawer initialized'),
          (t.drawer = document.getElementById('quick-add-drawer')),
          (t.drawerContent = t.drawer.querySelector('.drawer__content')),
          t.bindEvents(),
          t
        );
      }
      return (
        (e = a),
        (r = [
          {
            key: 'bindEvents',
            value: function () {
              var t = this;
              console.log('Binding events...');
              var e,
                r = this;
              document.addEventListener(
                'click',
                ((e = Ci(
                  ae.mark(function t(e) {
                    var n, i, o, a, s, l, c, h, u, p;
                    return ae.wrap(
                      function (t) {
                        for (;;)
                          switch ((t.prev = t.next)) {
                            case 0:
                              if ((n = e.target.closest('[data-quick-add-button]'))) {
                                t.next = 3;
                                break;
                              }
                              return t.abrupt('return');
                            case 3:
                              if (!n.hasAttribute('disabled')) {
                                t.next = 5;
                                break;
                              }
                              return t.abrupt('return');
                            case 5:
                              return (
                                n.setAttribute('disabled', ''),
                                e.preventDefault(),
                                (i = n.dataset.productHandle),
                                (o = n.dataset.productId),
                                (a = n.dataset.productTitle),
                                console.log('Quick add clicked:', { productHandle: i, productId: o, productTitle: a }),
                                (t.prev = 11),
                                (s = ''
                                  .concat(window.Shopify.routes.root, 'products/')
                                  .concat(i, '?section_id=quick-add-drawer')),
                                console.log('Fetching drawer content from:', s),
                                (t.next = 16),
                                fetch(s)
                              );
                            case 16:
                              return (l = t.sent), (t.next = 19), l.text();
                            case 19:
                              (c = t.sent),
                                ((h = document.createElement('div')).innerHTML = c),
                                (u = h.querySelector('.drawer__body')),
                                (p = r.drawer.querySelector('.drawer__body')),
                                console.log('Found drawer content:', !!u),
                                u && ((p.innerHTML = u.innerHTML), r.addVariantButtonHandlers(p), r.open()),
                                (t.next = 31);
                              break;
                            case 28:
                              (t.prev = 28), (t.t0 = t.catch(11)), console.error('Error in quick add process:', t.t0);
                            case 31:
                              return (t.prev = 31), n.removeAttribute('disabled'), t.finish(31);
                            case 34:
                            case 'end':
                              return t.stop();
                          }
                      },
                      t,
                      null,
                      [[11, 28, 31, 34]],
                    );
                  }),
                )),
                function (t) {
                  return e.apply(this, arguments);
                }),
              ),
                this.drawer.addEventListener('click', function (e) {
                  (e.target.hasAttribute('data-drawer-close') || e.target.closest('[data-drawer-close]')) && t.close();
                }),
                this.drawer.addEventListener('keyup', function (e) {
                  'Escape' === e.code && t.close();
                });
            },
          },
          {
            key: 'addVariantButtonHandlers',
            value: function (t) {
              var e = this,
                r = t.querySelector('.quick-add__variants');
              r &&
                r.querySelectorAll('button[data-variant-id]').forEach(function (t) {
                  var r = e;
                  t.addEventListener('click', function (e) {
                    e.preventDefault();
                    var n = t.dataset.variantId,
                      i = t.closest('form');
                    (i.querySelector('input[name="id"]').value = n), r.handleSubmit(i);
                  });
                });
            },
          },
          {
            key: 'open',
            value: function () {
              var t = this;
              console.log('Opening drawer...'),
                this.drawer.setAttribute('open', ''),
                document.body.classList.add('overflow-hidden'),
                requestAnimationFrame(function () {
                  t.drawerContent.classList.add('animate');
                });
            },
          },
          {
            key: 'close',
            value: function () {
              var t = this;
              this.drawerContent.classList.remove('animate'),
                this.drawerContent.addEventListener(
                  'transitionend',
                  function () {
                    t.drawer.removeAttribute('open'), document.body.classList.remove('overflow-hidden');
                  },
                  { once: !0 },
                );
            },
          },
          {
            key: 'handleSubmit',
            value: function (t) {
              var e = this;
              return Ci(
                ae.mark(function r() {
                  var n;
                  return ae.wrap(
                    function (r) {
                      for (;;)
                        switch ((r.prev = r.next)) {
                          case 0:
                            return (
                              (n = t.querySelector('input[name="id"]').value),
                              (r.prev = 1),
                              (r.next = 4),
                              fetch(window.Shopify.routes.root + 'cart/add.js', {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json' },
                                body: JSON.stringify({ items: [{ id: n, quantity: 1 }] }),
                              })
                            );
                          case 4:
                            r.sent.ok && e.close(), (r.next = 11);
                            break;
                          case 8:
                            (r.prev = 8), (r.t0 = r.catch(1)), console.error('Error adding to cart:', r.t0);
                          case 11:
                          case 'end':
                            return r.stop();
                        }
                    },
                    r,
                    null,
                    [[1, 8]],
                  );
                }),
              )();
            },
          },
        ]),
        r && Di(e.prototype, r),
        a
      );
    })(Ri(HTMLElement));
    console.log('Defining QuickAddDrawer custom element...'), customElements.define('quick-add-drawer', Oi);
  })();
})();
